export const communityAnalysis = {
  overview: {
    summary: {
      serverName: "unayung's dc",
      groupName: "unayung's tg",
      dataInfo: [
        {
          dataTitle: "New Participants",
          number: 8799,
          totalNumber: 10831,
          rate: 30,
          id: "newParticipants",
        },
        {
          dataTitle: "Engagements",
          number: 4320,
          rate: 11,
          id: "engagements",
        },
        {
          dataTitle: "Unified Retention Rate",
          number: 0.16,
          rate: 4.8,
          id: "unifiedRetentionRate",
        },
      ],
    },
    newParticipants: {
      data: {
        totalParticipants: 8799,
        discord: {
          newParticipants: 4355,
          growthRate: 16,
        },
        telegram: {
          newParticipants: 4444,
          growthRate: 13,
        },
        trend: [
          {
            date: "2024-06-17",
            tgNewParticipants: 19,
            dcNewParticipants: "N/A",
          },
          {
            date: "2024-06-18",
            tgNewParticipants: 16,
            dcNewParticipants: "N/A",
          },
          {
            date: "2024-06-19",
            tgNewParticipants: 49,
            dcNewParticipants: "N/A",
          },
          {
            date: "2024-06-20",
            tgNewParticipants: 49,
            dcNewParticipants: "N/A",
          },
          {
            date: "2024-06-21",
            tgNewParticipants: 20,
            dcNewParticipants: "N/A",
          },
          {
            date: "2024-06-22",
            tgNewParticipants: 37,
            dcNewParticipants: "N/A",
          },
          {
            date: "2024-06-23",
            tgNewParticipants: 50,
            dcNewParticipants: "N/A",
          },
          {
            date: "2024-06-24",
            tgNewParticipants: 24,
            dcNewParticipants: "N/A",
          },
          {
            date: "2024-06-25",
            tgNewParticipants: 36,
            dcNewParticipants: "N/A",
          },
          {
            date: "2024-06-26",
            tgNewParticipants: 42,
            dcNewParticipants: 18,
          },
          {
            date: "2024-06-27",
            tgNewParticipants: 13,
            dcNewParticipants: 30,
          },
          {
            date: "2024-06-28",
            tgNewParticipants: 25,
            dcNewParticipants: 48,
          },
          {
            date: "2024-06-29",
            tgNewParticipants: 20,
            dcNewParticipants: 36,
          },
          {
            date: "2024-06-30",
            tgNewParticipants: 13,
            dcNewParticipants: 23,
          },
          {
            date: "2024-07-01",
            tgNewParticipants: 17,
            dcNewParticipants: 27,
          },
          {
            date: "2024-07-02",
            tgNewParticipants: 35,
            dcNewParticipants: 19,
          },
          {
            date: "2024-07-03",
            tgNewParticipants: 17,
            dcNewParticipants: 19,
          },
          {
            date: "2024-07-04",
            tgNewParticipants: 47,
            dcNewParticipants: 23,
          },
          {
            date: "2024-07-05",
            tgNewParticipants: 18,
            dcNewParticipants: 44,
          },
          {
            date: "2024-07-06",
            tgNewParticipants: 28,
            dcNewParticipants: 19,
          },
          {
            date: "2024-07-07",
            tgNewParticipants: 22,
            dcNewParticipants: 11,
          },
          {
            date: "2024-07-08",
            tgNewParticipants: 23,
            dcNewParticipants: 23,
          },
          {
            date: "2024-07-09",
            tgNewParticipants: 39,
            dcNewParticipants: 30,
          },
          {
            date: "2024-07-10",
            tgNewParticipants: 14,
            dcNewParticipants: 47,
          },
          {
            date: "2024-07-11",
            tgNewParticipants: 38,
            dcNewParticipants: 38,
          },
          {
            date: "2024-07-12",
            tgNewParticipants: 30,
            dcNewParticipants: 43,
          },
          {
            date: "2024-07-13",
            tgNewParticipants: 30,
            dcNewParticipants: 35,
          },
          {
            date: "2024-07-14",
            tgNewParticipants: 20,
            dcNewParticipants: 24,
          },
          {
            date: "2024-07-15",
            tgNewParticipants: 44,
            dcNewParticipants: 16,
          },
          {
            date: "2024-07-16",
            tgNewParticipants: 14,
            dcNewParticipants: 47,
          },
          {
            date: "2024-07-17",
            tgNewParticipants: 39,
            dcNewParticipants: 41,
          },
          {
            date: "2024-07-18",
            tgNewParticipants: 33,
            dcNewParticipants: 44,
          },
          {
            date: "2024-07-19",
            tgNewParticipants: 42,
            dcNewParticipants: 11,
          },
          {
            date: "2024-07-20",
            tgNewParticipants: 40,
            dcNewParticipants: 26,
          },
          {
            date: "2024-07-21",
            tgNewParticipants: 20,
            dcNewParticipants: 16,
          },
          {
            date: "2024-07-22",
            tgNewParticipants: 18,
            dcNewParticipants: 36,
          },
          {
            date: "2024-07-23",
            tgNewParticipants: 38,
            dcNewParticipants: 48,
          },
          {
            date: "2024-07-24",
            tgNewParticipants: 14,
            dcNewParticipants: 32,
          },
          {
            date: "2024-07-25",
            tgNewParticipants: 42,
            dcNewParticipants: 44,
          },
          {
            date: "2024-07-26",
            tgNewParticipants: 34,
            dcNewParticipants: 19,
          },
          {
            date: "2024-07-27",
            tgNewParticipants: 41,
            dcNewParticipants: 36,
          },
          {
            date: "2024-07-28",
            tgNewParticipants: 15,
            dcNewParticipants: 26,
          },
          {
            date: "2024-07-29",
            tgNewParticipants: 25,
            dcNewParticipants: 22,
          },
          {
            date: "2024-07-30",
            tgNewParticipants: 28,
            dcNewParticipants: 44,
          },
          {
            date: "2024-07-31",
            tgNewParticipants: 28,
            dcNewParticipants: 36,
          },
          {
            date: "2024-08-01",
            tgNewParticipants: 33,
            dcNewParticipants: 42,
          },
          {
            date: "2024-08-02",
            tgNewParticipants: 47,
            dcNewParticipants: 15,
          },
          {
            date: "2024-08-03",
            tgNewParticipants: 12,
            dcNewParticipants: 24,
          },
          {
            date: "2024-08-04",
            tgNewParticipants: 41,
            dcNewParticipants: 13,
          },
          {
            date: "2024-08-05",
            tgNewParticipants: 29,
            dcNewParticipants: 31,
          },
          {
            date: "2024-08-06",
            tgNewParticipants: 12,
            dcNewParticipants: 39,
          },
          {
            date: "2024-08-07",
            tgNewParticipants: 33,
            dcNewParticipants: 37,
          },
          {
            date: "2024-08-08",
            tgNewParticipants: 43,
            dcNewParticipants: 40,
          },
          {
            date: "2024-08-09",
            tgNewParticipants: 36,
            dcNewParticipants: 36,
          },
          {
            date: "2024-08-10",
            tgNewParticipants: 40,
            dcNewParticipants: 15,
          },
          {
            date: "2024-08-11",
            tgNewParticipants: 16,
            dcNewParticipants: 35,
          },
          {
            date: "2024-08-12",
            tgNewParticipants: 11,
            dcNewParticipants: 38,
          },
          {
            date: "2024-08-13",
            tgNewParticipants: 29,
            dcNewParticipants: 12,
          },
          {
            date: "2024-08-14",
            tgNewParticipants: 43,
            dcNewParticipants: 20,
          },
          {
            date: "2024-08-15",
            tgNewParticipants: 45,
            dcNewParticipants: 11,
          },
          {
            date: "2024-08-16",
            tgNewParticipants: 49,
            dcNewParticipants: 23,
          },
          {
            date: "2024-08-17",
            tgNewParticipants: 29,
            dcNewParticipants: 34,
          },
          {
            date: "2024-08-18",
            tgNewParticipants: 33,
            dcNewParticipants: 30,
          },
          {
            date: "2024-08-19",
            tgNewParticipants: 48,
            dcNewParticipants: 41,
          },
          {
            date: "2024-08-20",
            tgNewParticipants: 14,
            dcNewParticipants: 25,
          },
          {
            date: "2024-08-21",
            tgNewParticipants: 26,
            dcNewParticipants: 25,
          },
          {
            date: "2024-08-22",
            tgNewParticipants: 25,
            dcNewParticipants: 45,
          },
          {
            date: "2024-08-23",
            tgNewParticipants: 47,
            dcNewParticipants: 23,
          },
          {
            date: "2024-08-24",
            tgNewParticipants: 44,
            dcNewParticipants: 50,
          },
          {
            date: "2024-08-25",
            tgNewParticipants: 40,
            dcNewParticipants: 27,
          },
          {
            date: "2024-08-26",
            tgNewParticipants: 22,
            dcNewParticipants: 32,
          },
          {
            date: "2024-08-27",
            tgNewParticipants: 16,
            dcNewParticipants: 26,
          },
          {
            date: "2024-08-28",
            tgNewParticipants: 37,
            dcNewParticipants: 12,
          },
          {
            date: "2024-08-29",
            tgNewParticipants: 17,
            dcNewParticipants: 11,
          },
          {
            date: "2024-08-30",
            tgNewParticipants: 27,
            dcNewParticipants: 45,
          },
          {
            date: "2024-08-31",
            tgNewParticipants: 18,
            dcNewParticipants: 19,
          },
          {
            date: "2024-09-01",
            tgNewParticipants: 16,
            dcNewParticipants: 38,
          },
          {
            date: "2024-09-02",
            tgNewParticipants: 21,
            dcNewParticipants: 44,
          },
          {
            date: "2024-09-03",
            tgNewParticipants: 16,
            dcNewParticipants: 21,
          },
          {
            date: "2024-09-04",
            tgNewParticipants: 10,
            dcNewParticipants: 12,
          },
          {
            date: "2024-09-05",
            tgNewParticipants: 46,
            dcNewParticipants: 29,
          },
          {
            date: "2024-09-06",
            tgNewParticipants: 13,
            dcNewParticipants: 13,
          },
          {
            date: "2024-09-07",
            tgNewParticipants: 14,
            dcNewParticipants: 23,
          },
          {
            date: "2024-09-08",
            tgNewParticipants: 36,
            dcNewParticipants: 42,
          },
          {
            date: "2024-09-09",
            tgNewParticipants: 50,
            dcNewParticipants: 11,
          },
          {
            date: "2024-09-10",
            tgNewParticipants: 21,
            dcNewParticipants: 28,
          },
          {
            date: "2024-09-11",
            tgNewParticipants: 21,
            dcNewParticipants: 44,
          },
          {
            date: "2024-09-12",
            tgNewParticipants: 14,
            dcNewParticipants: 45,
          },
          {
            date: "2024-09-13",
            tgNewParticipants: 39,
            dcNewParticipants: 18,
          },
          {
            date: "2024-09-14",
            tgNewParticipants: 26,
            dcNewParticipants: 18,
          },
          {
            date: "2024-09-15",
            tgNewParticipants: 23,
            dcNewParticipants: 14,
          },
          {
            date: "2024-09-16",
            tgNewParticipants: 21,
            dcNewParticipants: 48,
          },
          {
            date: "2024-09-17",
            tgNewParticipants: 11,
            dcNewParticipants: 48,
          },
          {
            date: "2024-09-18",
            tgNewParticipants: 49,
            dcNewParticipants: 22,
          },
          {
            date: "2024-09-19",
            tgNewParticipants: 28,
            dcNewParticipants: 14,
          },
          {
            date: "2024-09-20",
            tgNewParticipants: 26,
            dcNewParticipants: 35,
          },
          {
            date: "2024-09-21",
            tgNewParticipants: 31,
            dcNewParticipants: 29,
          },
          {
            date: "2024-09-22",
            tgNewParticipants: 20,
            dcNewParticipants: 47,
          },
          {
            date: "2024-09-23",
            tgNewParticipants: 37,
            dcNewParticipants: 42,
          },
          {
            date: "2024-09-24",
            tgNewParticipants: 30,
            dcNewParticipants: 34,
          },
          {
            date: "2024-09-25",
            tgNewParticipants: 42,
            dcNewParticipants: 14,
          },
          {
            date: "2024-09-26",
            tgNewParticipants: 23,
            dcNewParticipants: 19,
          },
          {
            date: "2024-09-27",
            tgNewParticipants: 22,
            dcNewParticipants: 34,
          },
          {
            date: "2024-09-28",
            tgNewParticipants: 28,
            dcNewParticipants: 40,
          },
          {
            date: "2024-09-29",
            tgNewParticipants: 46,
            dcNewParticipants: 23,
          },
          {
            date: "2024-09-30",
            tgNewParticipants: 27,
            dcNewParticipants: 12,
          },
          {
            date: "2024-10-01",
            tgNewParticipants: 46,
            dcNewParticipants: 38,
          },
          {
            date: "2024-10-02",
            tgNewParticipants: 28,
            dcNewParticipants: 45,
          },
          {
            date: "2024-10-03",
            tgNewParticipants: 41,
            dcNewParticipants: 41,
          },
          {
            date: "2024-10-04",
            tgNewParticipants: 13,
            dcNewParticipants: 14,
          },
          {
            date: "2024-10-05",
            tgNewParticipants: 39,
            dcNewParticipants: 17,
          },
          {
            date: "2024-10-06",
            tgNewParticipants: 18,
            dcNewParticipants: 28,
          },
          {
            date: "2024-10-07",
            tgNewParticipants: 50,
            dcNewParticipants: 46,
          },
          {
            date: "2024-10-08",
            tgNewParticipants: 27,
            dcNewParticipants: 41,
          },
          {
            date: "2024-10-09",
            tgNewParticipants: 25,
            dcNewParticipants: 41,
          },
          {
            date: "2024-10-10",
            tgNewParticipants: 12,
            dcNewParticipants: 19,
          },
          {
            date: "2024-10-11",
            tgNewParticipants: 33,
            dcNewParticipants: 27,
          },
          {
            date: "2024-10-12",
            tgNewParticipants: 28,
            dcNewParticipants: 10,
          },
          {
            date: "2024-10-13",
            tgNewParticipants: 35,
            dcNewParticipants: 31,
          },
          {
            date: "2024-10-14",
            tgNewParticipants: 44,
            dcNewParticipants: 22,
          },
          {
            date: "2024-10-15",
            tgNewParticipants: 25,
            dcNewParticipants: 22,
          },
          {
            date: "2024-10-16",
            tgNewParticipants: 11,
            dcNewParticipants: 17,
          },
          {
            date: "2024-10-17",
            tgNewParticipants: 17,
            dcNewParticipants: 28,
          },
          {
            date: "2024-10-18",
            tgNewParticipants: 25,
            dcNewParticipants: 24,
          },
          {
            date: "2024-10-19",
            tgNewParticipants: 32,
            dcNewParticipants: 30,
          },
          {
            date: "2024-10-20",
            tgNewParticipants: 27,
            dcNewParticipants: 28,
          },
          {
            date: "2024-10-21",
            tgNewParticipants: 24,
            dcNewParticipants: 37,
          },
          {
            date: "2024-10-22",
            tgNewParticipants: 47,
            dcNewParticipants: 45,
          },
          {
            date: "2024-10-23",
            tgNewParticipants: 39,
            dcNewParticipants: 31,
          },
          {
            date: "2024-10-24",
            tgNewParticipants: 28,
            dcNewParticipants: 41,
          },
          {
            date: "2024-10-25",
            tgNewParticipants: 38,
            dcNewParticipants: 25,
          },
          {
            date: "2024-10-26",
            tgNewParticipants: 34,
            dcNewParticipants: 11,
          },
          {
            date: "2024-10-27",
            tgNewParticipants: 47,
            dcNewParticipants: 27,
          },
          {
            date: "2024-10-28",
            tgNewParticipants: 19,
            dcNewParticipants: 20,
          },
          {
            date: "2024-10-29",
            tgNewParticipants: 19,
            dcNewParticipants: 12,
          },
          {
            date: "2024-10-30",
            tgNewParticipants: 22,
            dcNewParticipants: 44,
          },
          {
            date: "2024-10-31",
            tgNewParticipants: 29,
            dcNewParticipants: 26,
          },
          {
            date: "2024-11-01",
            tgNewParticipants: 41,
            dcNewParticipants: 11,
          },
          {
            date: "2024-11-02",
            tgNewParticipants: 32,
            dcNewParticipants: 26,
          },
          {
            date: "2024-11-03",
            tgNewParticipants: 25,
            dcNewParticipants: 18,
          },
          {
            date: "2024-11-04",
            tgNewParticipants: 11,
            dcNewParticipants: 46,
          },
          {
            date: "2024-11-05",
            tgNewParticipants: 41,
            dcNewParticipants: 17,
          },
          {
            date: "2024-11-06",
            tgNewParticipants: 48,
            dcNewParticipants: 48,
          },
          {
            date: "2024-11-07",
            tgNewParticipants: 20,
            dcNewParticipants: 31,
          },
          {
            date: "2024-11-08",
            tgNewParticipants: 36,
            dcNewParticipants: 25,
          },
          {
            date: "2024-11-09",
            tgNewParticipants: 49,
            dcNewParticipants: 33,
          },
          {
            date: "2024-11-10",
            tgNewParticipants: 50,
            dcNewParticipants: 11,
          },
          {
            date: "2024-11-11",
            tgNewParticipants: 14,
            dcNewParticipants: 45,
          },
          {
            date: "2024-11-12",
            tgNewParticipants: 46,
            dcNewParticipants: 17,
          },
          {
            date: "2024-11-13",
            tgNewParticipants: 34,
            dcNewParticipants: 50,
          },
          {
            date: "2024-11-14",
            tgNewParticipants: "N/A",
            dcNewParticipants: 29,
          },
          {
            date: "2024-11-15",
            tgNewParticipants: "N/A",
            dcNewParticipants: 24,
          },
          {
            date: "2024-11-16",
            tgNewParticipants: "N/A",
            dcNewParticipants: 18,
          },
          {
            date: "2024-11-17",
            tgNewParticipants: "N/A",
            dcNewParticipants: 17,
          },
          {
            date: "2024-11-18",
            tgNewParticipants: "N/A",
            dcNewParticipants: 42,
          },
          {
            date: "2024-11-19",
            tgNewParticipants: "N/A",
            dcNewParticipants: 15,
          },
          {
            date: "2024-11-20",
            tgNewParticipants: "N/A",
            dcNewParticipants: 36,
          },
          {
            date: "2024-11-21",
            tgNewParticipants: "N/A",
            dcNewParticipants: 35,
          },
          {
            date: "2024-11-22",
            tgNewParticipants: "N/A",
            dcNewParticipants: 35,
          },
        ],
      },
    },
    engagements: {
      data: {
        tgEngagementCount: 2160,
        dcEngagementCount: 2160,
        dailyTrend: [
          {
            date: "2024-07-16",
            tg: {
              messages: 5,
              reactions: 5,
            },
            dc: {
              messages: "N/A",
              reactions: "N/A",
            },
          },
          {
            date: "2024-07-17",
            tg: {
              messages: 14,
              reactions: 8,
            },
            dc: {
              messages: "N/A",
              reactions: "N/A",
            },
          },
          {
            date: "2024-07-18",
            tg: {
              messages: 11,
              reactions: 5,
            },
            dc: {
              messages: "N/A",
              reactions: "N/A",
            },
          },
          {
            date: "2024-07-19",
            tg: {
              messages: 12,
              reactions: 13,
            },
            dc: {
              messages: "N/A",
              reactions: "N/A",
            },
          },
          {
            date: "2024-07-20",
            tg: {
              messages: 11,
              reactions: 11,
            },
            dc: {
              messages: "N/A",
              reactions: "N/A",
            },
          },
          {
            date: "2024-07-21",
            tg: {
              messages: 9,
              reactions: 8,
            },
            dc: {
              messages: "N/A",
              reactions: "N/A",
            },
          },
          {
            date: "2024-07-22",
            tg: {
              messages: 10,
              reactions: 7,
            },
            dc: {
              messages: "N/A",
              reactions: "N/A",
            },
          },
          {
            date: "2024-07-23",
            tg: {
              messages: 14,
              reactions: 7,
            },
            dc: {
              messages: "N/A",
              reactions: "N/A",
            },
          },
          {
            date: "2024-07-24",
            tg: {
              messages: 13,
              reactions: 5,
            },
            dc: {
              messages: "N/A",
              reactions: "N/A",
            },
          },
          {
            date: "2024-07-25",
            tg: {
              messages: 11,
              reactions: 11,
            },
            dc: {
              messages: 5,
              reactions: 7,
            },
          },
          {
            date: "2024-07-26",
            tg: {
              messages: 8,
              reactions: 5,
            },
            dc: {
              messages: 13,
              reactions: 7,
            },
          },
          {
            date: "2024-07-27",
            tg: {
              messages: 7,
              reactions: 5,
            },
            dc: {
              messages: 5,
              reactions: 8,
            },
          },
          {
            date: "2024-07-28",
            tg: {
              messages: 11,
              reactions: 9,
            },
            dc: {
              messages: 12,
              reactions: 11,
            },
          },
          {
            date: "2024-07-29",
            tg: {
              messages: 8,
              reactions: 5,
            },
            dc: {
              messages: 8,
              reactions: 7,
            },
          },
          {
            date: "2024-07-30",
            tg: {
              messages: 13,
              reactions: 7,
            },
            dc: {
              messages: 7,
              reactions: 8,
            },
          },
          {
            date: "2024-07-31",
            tg: {
              messages: 10,
              reactions: 9,
            },
            dc: {
              messages: 16,
              reactions: 14,
            },
          },
          {
            date: "2024-08-01",
            tg: {
              messages: 6,
              reactions: 3,
            },
            dc: {
              messages: 8,
              reactions: 5,
            },
          },
          {
            date: "2024-08-02",
            tg: {
              messages: 6,
              reactions: 9,
            },
            dc: {
              messages: 6,
              reactions: 8,
            },
          },
          {
            date: "2024-08-03",
            tg: {
              messages: 12,
              reactions: 10,
            },
            dc: {
              messages: 7,
              reactions: 8,
            },
          },
          {
            date: "2024-08-04",
            tg: {
              messages: 3,
              reactions: 7,
            },
            dc: {
              messages: 10,
              reactions: 12,
            },
          },
          {
            date: "2024-08-05",
            tg: {
              messages: 7,
              reactions: 9,
            },
            dc: {
              messages: 13,
              reactions: 6,
            },
          },
          {
            date: "2024-08-06",
            tg: {
              messages: 10,
              reactions: 8,
            },
            dc: {
              messages: 11,
              reactions: 8,
            },
          },
          {
            date: "2024-08-07",
            tg: {
              messages: 14,
              reactions: 9,
            },
            dc: {
              messages: 9,
              reactions: 8,
            },
          },
          {
            date: "2024-08-08",
            tg: {
              messages: 14,
              reactions: 9,
            },
            dc: {
              messages: 10,
              reactions: 8,
            },
          },
          {
            date: "2024-08-09",
            tg: {
              messages: 9,
              reactions: 12,
            },
            dc: {
              messages: 9,
              reactions: 14,
            },
          },
          {
            date: "2024-08-10",
            tg: {
              messages: 11,
              reactions: 6,
            },
            dc: {
              messages: 7,
              reactions: 6,
            },
          },
          {
            date: "2024-08-11",
            tg: {
              messages: 15,
              reactions: 5,
            },
            dc: {
              messages: 8,
              reactions: 11,
            },
          },
          {
            date: "2024-08-12",
            tg: {
              messages: 17,
              reactions: 9,
            },
            dc: {
              messages: 11,
              reactions: 4,
            },
          },
          {
            date: "2024-08-13",
            tg: {
              messages: 2,
              reactions: 6,
            },
            dc: {
              messages: 11,
              reactions: 8,
            },
          },
          {
            date: "2024-08-14",
            tg: {
              messages: 10,
              reactions: 8,
            },
            dc: {
              messages: 13,
              reactions: 9,
            },
          },
          {
            date: "2024-08-15",
            tg: {
              messages: 11,
              reactions: 16,
            },
            dc: {
              messages: 14,
              reactions: 5,
            },
          },
          {
            date: "2024-08-16",
            tg: {
              messages: 11,
              reactions: 6,
            },
            dc: {
              messages: 10,
              reactions: 6,
            },
          },
          {
            date: "2024-08-17",
            tg: {
              messages: 9,
              reactions: 9,
            },
            dc: {
              messages: 15,
              reactions: 10,
            },
          },
          {
            date: "2024-08-18",
            tg: {
              messages: 13,
              reactions: 9,
            },
            dc: {
              messages: 12,
              reactions: 7,
            },
          },
          {
            date: "2024-08-19",
            tg: {
              messages: 10,
              reactions: 4,
            },
            dc: {
              messages: 6,
              reactions: 8,
            },
          },
          {
            date: "2024-08-20",
            tg: {
              messages: 11,
              reactions: 3,
            },
            dc: {
              messages: 13,
              reactions: 3,
            },
          },
          {
            date: "2024-08-21",
            tg: {
              messages: 7,
              reactions: 12,
            },
            dc: {
              messages: 15,
              reactions: 5,
            },
          },
          {
            date: "2024-08-22",
            tg: {
              messages: 8,
              reactions: 8,
            },
            dc: {
              messages: 13,
              reactions: 8,
            },
          },
          {
            date: "2024-08-23",
            tg: {
              messages: 8,
              reactions: 8,
            },
            dc: {
              messages: 8,
              reactions: 6,
            },
          },
          {
            date: "2024-08-24",
            tg: {
              messages: 7,
              reactions: 10,
            },
            dc: {
              messages: 9,
              reactions: 7,
            },
          },
          {
            date: "2024-08-25",
            tg: {
              messages: 3,
              reactions: 8,
            },
            dc: {
              messages: 13,
              reactions: 10,
            },
          },
          {
            date: "2024-08-26",
            tg: {
              messages: 12,
              reactions: 5,
            },
            dc: {
              messages: 13,
              reactions: 9,
            },
          },
          {
            date: "2024-08-27",
            tg: {
              messages: 8,
              reactions: 5,
            },
            dc: {
              messages: 11,
              reactions: 8,
            },
          },
          {
            date: "2024-08-28",
            tg: {
              messages: 12,
              reactions: 6,
            },
            dc: {
              messages: 12,
              reactions: 7,
            },
          },
          {
            date: "2024-08-29",
            tg: {
              messages: 8,
              reactions: 10,
            },
            dc: {
              messages: 13,
              reactions: 7,
            },
          },
          {
            date: "2024-08-30",
            tg: {
              messages: 13,
              reactions: 6,
            },
            dc: {
              messages: 10,
              reactions: 7,
            },
          },
          {
            date: "2024-08-31",
            tg: {
              messages: 10,
              reactions: 4,
            },
            dc: {
              messages: 12,
              reactions: 6,
            },
          },
          {
            date: "2024-09-01",
            tg: {
              messages: 12,
              reactions: 11,
            },
            dc: {
              messages: 12,
              reactions: 5,
            },
          },
          {
            date: "2024-09-02",
            tg: {
              messages: 9,
              reactions: 7,
            },
            dc: {
              messages: 19,
              reactions: 9,
            },
          },
          {
            date: "2024-09-03",
            tg: {
              messages: 9,
              reactions: 8,
            },
            dc: {
              messages: 11,
              reactions: 12,
            },
          },
          {
            date: "2024-09-04",
            tg: {
              messages: 12,
              reactions: 6,
            },
            dc: {
              messages: 6,
              reactions: 4,
            },
          },
          {
            date: "2024-09-05",
            tg: {
              messages: 8,
              reactions: 7,
            },
            dc: {
              messages: 6,
              reactions: 10,
            },
          },
          {
            date: "2024-09-06",
            tg: {
              messages: 8,
              reactions: 8,
            },
            dc: {
              messages: 10,
              reactions: 9,
            },
          },
          {
            date: "2024-09-07",
            tg: {
              messages: 13,
              reactions: 9,
            },
            dc: {
              messages: 9,
              reactions: 9,
            },
          },
          {
            date: "2024-09-08",
            tg: {
              messages: 9,
              reactions: 13,
            },
            dc: {
              messages: 7,
              reactions: 5,
            },
          },
          {
            date: "2024-09-09",
            tg: {
              messages: 12,
              reactions: 6,
            },
            dc: {
              messages: 9,
              reactions: 4,
            },
          },
          {
            date: "2024-09-10",
            tg: {
              messages: 11,
              reactions: 9,
            },
            dc: {
              messages: 7,
              reactions: 6,
            },
          },
          {
            date: "2024-09-11",
            tg: {
              messages: 9,
              reactions: 6,
            },
            dc: {
              messages: 10,
              reactions: 9,
            },
          },
          {
            date: "2024-09-12",
            tg: {
              messages: 7,
              reactions: 12,
            },
            dc: {
              messages: 7,
              reactions: 8,
            },
          },
          {
            date: "2024-09-13",
            tg: {
              messages: 8,
              reactions: 7,
            },
            dc: {
              messages: 10,
              reactions: 2,
            },
          },
          {
            date: "2024-09-14",
            tg: {
              messages: 11,
              reactions: 11,
            },
            dc: {
              messages: 9,
              reactions: 7,
            },
          },
          {
            date: "2024-09-15",
            tg: {
              messages: 15,
              reactions: 7,
            },
            dc: {
              messages: 11,
              reactions: 2,
            },
          },
          {
            date: "2024-09-16",
            tg: {
              messages: 8,
              reactions: 7,
            },
            dc: {
              messages: 19,
              reactions: 10,
            },
          },
          {
            date: "2024-09-17",
            tg: {
              messages: 7,
              reactions: 7,
            },
            dc: {
              messages: 14,
              reactions: 8,
            },
          },
          {
            date: "2024-09-18",
            tg: {
              messages: 4,
              reactions: 4,
            },
            dc: {
              messages: 11,
              reactions: 6,
            },
          },
          {
            date: "2024-09-19",
            tg: {
              messages: 8,
              reactions: 9,
            },
            dc: {
              messages: 2,
              reactions: 13,
            },
          },
          {
            date: "2024-09-20",
            tg: {
              messages: 8,
              reactions: 6,
            },
            dc: {
              messages: 6,
              reactions: 11,
            },
          },
          {
            date: "2024-09-21",
            tg: {
              messages: 17,
              reactions: 11,
            },
            dc: {
              messages: 11,
              reactions: 11,
            },
          },
          {
            date: "2024-09-22",
            tg: {
              messages: 13,
              reactions: 9,
            },
            dc: {
              messages: 12,
              reactions: 3,
            },
          },
          {
            date: "2024-09-23",
            tg: {
              messages: 3,
              reactions: 5,
            },
            dc: {
              messages: 6,
              reactions: 10,
            },
          },
          {
            date: "2024-09-24",
            tg: {
              messages: 12,
              reactions: 8,
            },
            dc: {
              messages: 5,
              reactions: 10,
            },
          },
          {
            date: "2024-09-25",
            tg: {
              messages: 2,
              reactions: 7,
            },
            dc: {
              messages: 14,
              reactions: 9,
            },
          },
          {
            date: "2024-09-26",
            tg: {
              messages: 8,
              reactions: 9,
            },
            dc: {
              messages: 9,
              reactions: 7,
            },
          },
          {
            date: "2024-09-27",
            tg: {
              messages: 8,
              reactions: 9,
            },
            dc: {
              messages: 10,
              reactions: 10,
            },
          },
          {
            date: "2024-09-28",
            tg: {
              messages: 10,
              reactions: 8,
            },
            dc: {
              messages: 7,
              reactions: 9,
            },
          },
          {
            date: "2024-09-29",
            tg: {
              messages: 13,
              reactions: 6,
            },
            dc: {
              messages: 4,
              reactions: 10,
            },
          },
          {
            date: "2024-09-30",
            tg: {
              messages: 11,
              reactions: 8,
            },
            dc: {
              messages: 12,
              reactions: 7,
            },
          },
          {
            date: "2024-10-01",
            tg: {
              messages: 12,
              reactions: 5,
            },
            dc: {
              messages: 8,
              reactions: 5,
            },
          },
          {
            date: "2024-10-02",
            tg: {
              messages: 12,
              reactions: 9,
            },
            dc: {
              messages: 6,
              reactions: 11,
            },
          },
          {
            date: "2024-10-03",
            tg: {
              messages: 10,
              reactions: 14,
            },
            dc: {
              messages: 9,
              reactions: 7,
            },
          },
          {
            date: "2024-10-04",
            tg: {
              messages: 6,
              reactions: 10,
            },
            dc: {
              messages: 11,
              reactions: 10,
            },
          },
          {
            date: "2024-10-05",
            tg: {
              messages: 12,
              reactions: 7,
            },
            dc: {
              messages: 3,
              reactions: 5,
            },
          },
          {
            date: "2024-10-06",
            tg: {
              messages: 14,
              reactions: 5,
            },
            dc: {
              messages: 8,
              reactions: 13,
            },
          },
          {
            date: "2024-10-07",
            tg: {
              messages: 14,
              reactions: 3,
            },
            dc: {
              messages: 7,
              reactions: 9,
            },
          },
          {
            date: "2024-10-08",
            tg: {
              messages: 6,
              reactions: 11,
            },
            dc: {
              messages: 6,
              reactions: 5,
            },
          },
          {
            date: "2024-10-09",
            tg: {
              messages: 16,
              reactions: 7,
            },
            dc: {
              messages: 6,
              reactions: 5,
            },
          },
          {
            date: "2024-10-10",
            tg: {
              messages: 8,
              reactions: 7,
            },
            dc: {
              messages: 12,
              reactions: 9,
            },
          },
          {
            date: "2024-10-11",
            tg: {
              messages: 12,
              reactions: 8,
            },
            dc: {
              messages: 8,
              reactions: 7,
            },
          },
          {
            date: "2024-10-12",
            tg: {
              messages: 8,
              reactions: 13,
            },
            dc: {
              messages: 13,
              reactions: 16,
            },
          },
          {
            date: "2024-10-13",
            tg: {
              messages: 4,
              reactions: 16,
            },
            dc: {
              messages: 9,
              reactions: 11,
            },
          },
          {
            date: "2024-10-14",
            tg: {
              messages: 15,
              reactions: 8,
            },
            dc: {
              messages: 8,
              reactions: 10,
            },
          },
          {
            date: "2024-10-15",
            tg: {
              messages: 14,
              reactions: 13,
            },
            dc: {
              messages: 14,
              reactions: 9,
            },
          },
          {
            date: "2024-10-16",
            tg: {
              messages: 1,
              reactions: 3,
            },
            dc: {
              messages: 9,
              reactions: 9,
            },
          },
          {
            date: "2024-10-17",
            tg: {
              messages: 12,
              reactions: 6,
            },
            dc: {
              messages: 8,
              reactions: 9,
            },
          },
          {
            date: "2024-10-18",
            tg: {
              messages: 9,
              reactions: 7,
            },
            dc: {
              messages: 8,
              reactions: 9,
            },
          },
          {
            date: "2024-10-19",
            tg: {
              messages: 13,
              reactions: 4,
            },
            dc: {
              messages: 10,
              reactions: 5,
            },
          },
          {
            date: "2024-10-20",
            tg: {
              messages: 8,
              reactions: 8,
            },
            dc: {
              messages: 10,
              reactions: 12,
            },
          },
          {
            date: "2024-10-21",
            tg: {
              messages: 10,
              reactions: 12,
            },
            dc: {
              messages: 9,
              reactions: 7,
            },
          },
          {
            date: "2024-10-22",
            tg: {
              messages: 10,
              reactions: 9,
            },
            dc: {
              messages: 8,
              reactions: 14,
            },
          },
          {
            date: "2024-10-23",
            tg: {
              messages: 12,
              reactions: 10,
            },
            dc: {
              messages: 7,
              reactions: 4,
            },
          },
          {
            date: "2024-10-24",
            tg: {
              messages: 14,
              reactions: 10,
            },
            dc: {
              messages: 9,
              reactions: 7,
            },
          },
          {
            date: "2024-10-25",
            tg: {
              messages: 21,
              reactions: 9,
            },
            dc: {
              messages: 10,
              reactions: 9,
            },
          },
          {
            date: "2024-10-26",
            tg: {
              messages: 13,
              reactions: 7,
            },
            dc: {
              messages: 9,
              reactions: 9,
            },
          },
          {
            date: "2024-10-27",
            tg: {
              messages: 15,
              reactions: 10,
            },
            dc: {
              messages: 11,
              reactions: 5,
            },
          },
          {
            date: "2024-10-28",
            tg: {
              messages: 10,
              reactions: 8,
            },
            dc: {
              messages: 8,
              reactions: 12,
            },
          },
          {
            date: "2024-10-29",
            tg: {
              messages: 9,
              reactions: 9,
            },
            dc: {
              messages: 12,
              reactions: 6,
            },
          },
          {
            date: "2024-10-30",
            tg: {
              messages: 5,
              reactions: 9,
            },
            dc: {
              messages: 19,
              reactions: 6,
            },
          },
          {
            date: "2024-10-31",
            tg: {
              messages: 13,
              reactions: 6,
            },
            dc: {
              messages: 11,
              reactions: 13,
            },
          },
          {
            date: "2024-11-01",
            tg: {
              messages: 8,
              reactions: 5,
            },
            dc: {
              messages: 9,
              reactions: 4,
            },
          },
          {
            date: "2024-11-02",
            tg: {
              messages: 11,
              reactions: 5,
            },
            dc: {
              messages: 9,
              reactions: 3,
            },
          },
          {
            date: "2024-11-03",
            tg: {
              messages: 13,
              reactions: 13,
            },
            dc: {
              messages: 12,
              reactions: 8,
            },
          },
          {
            date: "2024-11-04",
            tg: {
              messages: 14,
              reactions: 6,
            },
            dc: {
              messages: 11,
              reactions: 9,
            },
          },
          {
            date: "2024-11-05",
            tg: {
              messages: 6,
              reactions: 9,
            },
            dc: {
              messages: 10,
              reactions: 9,
            },
          },
          {
            date: "2024-11-06",
            tg: {
              messages: 11,
              reactions: 8,
            },
            dc: {
              messages: 9,
              reactions: 6,
            },
          },
          {
            date: "2024-11-07",
            tg: {
              messages: 9,
              reactions: 4,
            },
            dc: {
              messages: 19,
              reactions: 8,
            },
          },
          {
            date: "2024-11-08",
            tg: {
              messages: 9,
              reactions: 7,
            },
            dc: {
              messages: 12,
              reactions: 16,
            },
          },
          {
            date: "2024-11-09",
            tg: {
              messages: 10,
              reactions: 6,
            },
            dc: {
              messages: 17,
              reactions: 3,
            },
          },
          {
            date: "2024-11-10",
            tg: {
              messages: 4,
              reactions: 13,
            },
            dc: {
              messages: 14,
              reactions: 8,
            },
          },
          {
            date: "2024-11-11",
            tg: {
              messages: 7,
              reactions: 10,
            },
            dc: {
              messages: 5,
              reactions: 7,
            },
          },
          {
            date: "2024-11-12",
            tg: {
              messages: 10,
              reactions: 12,
            },
            dc: {
              messages: 6,
              reactions: 6,
            },
          },
          {
            date: "2024-11-13",
            tg: {
              messages: 1,
              reactions: "N/A",
            },
            dc: {
              messages: 10,
              reactions: 9,
            },
          },
          {
            date: "2024-11-14",
            tg: {
              messages: "N/A",
              reactions: "N/A",
            },
            dc: {
              messages: 18,
              reactions: 9,
            },
          },
          {
            date: "2024-11-15",
            tg: {
              messages: "N/A",
              reactions: "N/A",
            },
            dc: {
              messages: 6,
              reactions: 8,
            },
          },
          {
            date: "2024-11-16",
            tg: {
              messages: "N/A",
              reactions: "N/A",
            },
            dc: {
              messages: 7,
              reactions: 9,
            },
          },
          {
            date: "2024-11-17",
            tg: {
              messages: "N/A",
              reactions: "N/A",
            },
            dc: {
              messages: 8,
              reactions: 11,
            },
          },
          {
            date: "2024-11-18",
            tg: {
              messages: "N/A",
              reactions: "N/A",
            },
            dc: {
              messages: 12,
              reactions: 3,
            },
          },
          {
            date: "2024-11-19",
            tg: {
              messages: "N/A",
              reactions: "N/A",
            },
            dc: {
              messages: 11,
              reactions: 8,
            },
          },
          {
            date: "2024-11-20",
            tg: {
              messages: "N/A",
              reactions: "N/A",
            },
            dc: {
              messages: 10,
              reactions: 8,
            },
          },
          {
            date: "2024-11-21",
            tg: {
              messages: "N/A",
              reactions: "N/A",
            },
            dc: {
              messages: 13,
              reactions: 8,
            },
          },
          {
            date: "2024-11-22",
            tg: {
              messages: "N/A",
              reactions: "N/A",
            },
            dc: {
              messages: 3,
              reactions: 1,
            },
          },
        ],
      },
    },
    keywordCloud: {
      data: [
        {
          value: "program",
          count: 180,
          keywordIds:
            "674e9072ec54f17a87b9a25f;674e8e12ec54f17a87b67ec0;674e9153ec54f17a87ba9cde;674e8fb9ec54f17a87b8a321;674e8d4fec54f17a87b5c1ef;674e8ef0ec54f17a87b7983d;674e8f7eec54f17a87b856e2;674e910bec54f17a87ba5d9d;674e8dd7ec54f17a87b64196;674e8fb4ec54f17a87b89ce0;674e8df1ec54f17a87b658ac;674e90f5ec54f17a87ba47e8;674e8f49ec54f17a87b81355;674e907bec54f17a87b9b0ad;674e90e0ec54f17a87ba3440;674e8e77ec54f17a87b6fd82;674e90dbec54f17a87ba2f5e;674e8d46ec54f17a87b5b9c9;674e8e5fec54f17a87b6ddc3;674e8fbcec54f17a87b8a61b;674e8fa4ec54f17a87b8886c;674e9013ec54f17a87b911c5;674e91b8ec54f17a87baf959;674e9071ec54f17a87b9a0ff;674e8fa8ec54f17a87b88d66;674e8e36ec54f17a87b6a0be;674e91c2ec54f17a87bb0126;674e8f2bec54f17a87b7eb7b;674e9044ec54f17a87b94e98;674e8e67ec54f17a87b6e87d;674e8d77ec54f17a87b5e8a1;674e8ff1ec54f17a87b8e862;674e8e07ec54f17a87b672fb;674e8f8fec54f17a87b86c60;674e8ef3ec54f17a87b79ac9;674e8cffec54f17a87b571af;674e90e8ec54f17a87ba3bd5;674e8d11ec54f17a87b583ab;674e8f37ec54f17a87b7fbfd;674e8ff0ec54f17a87b8e78b;674e915aec54f17a87baa43d;674e9053ec54f17a87b96934;674e8d9eec54f17a87b60d87;674e8f5eec54f17a87b82d8d;674e904fec54f17a87b9624b;674e8daaec54f17a87b618fc;674e8f5bec54f17a87b8299d;674e8dfdec54f17a87b6683b;674e8da8ec54f17a87b61652;674e8ffdec54f17a87b8f79a;674e8f85ec54f17a87b85f84;674e908bec54f17a87b9c916;674e8ff9ec54f17a87b8f19a;674e8f78ec54f17a87b84dc5;674e9149ec54f17a87ba9322;674e9085ec54f17a87b9c03c;674e8ea1ec54f17a87b732b6;674e915eec54f17a87baa771;674e8efbec54f17a87b7a51c;674e8e7dec54f17a87b70444;674e900bec54f17a87b9084c;674e8f38ec54f17a87b7fd1b;674e90baec54f17a87ba0bae;674e8d8cec54f17a87b5fc5b;674e8fa5ec54f17a87b88a04;674e8d54ec54f17a87b5c6b5;674e8fc9ec54f17a87b8b7a3;674e8d7dec54f17a87b5ef7b;674e8eccec54f17a87b76894;674e8f0bec54f17a87b7bb39;674e905cec54f17a87b97b5a;674e9083ec54f17a87b9bd73;674e8efbec54f17a87b7a5a5;674e8d84ec54f17a87b5f4fd;674e909bec54f17a87b9e0a8;674e8d99ec54f17a87b608af;674e8cf8ec54f17a87b56ac3;674e8f49ec54f17a87b812bd;674e8ec1ec54f17a87b75adb;674e8dc1ec54f17a87b62e4d;674e8f31ec54f17a87b7f3be;674e8f8dec54f17a87b86a04;674e8d86ec54f17a87b5f71a;674e91fbec54f17a87bb2e85;674e8fd0ec54f17a87b8c084;674e8cf7ec54f17a87b56a0a;674e8f52ec54f17a87b81e29;674e8d81ec54f17a87b5f30e;674e8f79ec54f17a87b84faa;674e8e93ec54f17a87b72111;674e9058ec54f17a87b973e2;674e8e7eec54f17a87b70651;674e8f56ec54f17a87b823fa;674e909eec54f17a87b9e406;674e8f43ec54f17a87b80a85;674e906bec54f17a87b995f3;674e8f01ec54f17a87b7ad4f;674e902dec54f17a87b931ed;674e8ea9ec54f17a87b73cc8;674e9006ec54f17a87b901c1;674e902fec54f17a87b93412;674e8fa9ec54f17a87b88f4d;674e90b1ec54f17a87b9ffc9;674e8e6aec54f17a87b6ecde;674e9024ec54f17a87b92705;674e919bec54f17a87badff8;674e8df6ec54f17a87b65cfb;674e90f2ec54f17a87ba459d;674e8f13ec54f17a87b7c536;674e9193ec54f17a87bad9a5;674e916cec54f17a87bab30d;674e8d39ec54f17a87b5ac6e;674e8e9aec54f17a87b72940;674e8fd4ec54f17a87b8c60d;674e8da7ec54f17a87b615bb;674e905fec54f17a87b981b5;674e8f34ec54f17a87b7f7b0;674e8ddcec54f17a87b645ed;674e8ff0ec54f17a87b8e6d2;674e8e52ec54f17a87b6bb87;674e8e60ec54f17a87b6df9b;674e8dc6ec54f17a87b632d6;674e8d3cec54f17a87b5af84;674e9009ec54f17a87b9052b;674e8e49ec54f17a87b6b323;674e8d35ec54f17a87b5a8bd;674e8eafec54f17a87b7440b;674e9078ec54f17a87b9acba;674e90bdec54f17a87ba0ff7;674e90c5ec54f17a87ba19a0;674e8d89ec54f17a87b5f9b9",
        },
        {
          value: "application",
          count: 132,
          keywordIds:
            "674e9173ec54f17a87bab9a3;674e917bec54f17a87bac5ed;674e8f4bec54f17a87b81503;674e8dd7ec54f17a87b64213;674e90c6ec54f17a87ba1ac4;674e9002ec54f17a87b8fe27;674e8f41ec54f17a87b807d5;674e8fecec54f17a87b8e2b5;674e8ef5ec54f17a87b79e8e;674e8ff4ec54f17a87b8ebda;674e8f01ec54f17a87b7acac;674e8f9dec54f17a87b88001;674e8fa5ec54f17a87b88949;674e8f3dec54f17a87b8031f;674e9098ec54f17a87b9dc47;674e8e3fec54f17a87b6a94a;674e8e20ec54f17a87b68c70;674e90adec54f17a87b9f920;674e8e11ec54f17a87b67cff;674e8f8fec54f17a87b86c2c;674e9004ec54f17a87b8ff73;674e8eb9ec54f17a87b750e4;674e9039ec54f17a87b94015;674e8fc6ec54f17a87b8b2fd;674e8ed3ec54f17a87b77107;674e9065ec54f17a87b98bee;674e8f04ec54f17a87b7b15f;674e8d90ec54f17a87b600bb;674e9032ec54f17a87b93896;674e8eddec54f17a87b77eca;674e8ebfec54f17a87b758a5;674e9097ec54f17a87b9d9a2;674e8de3ec54f17a87b64c0b;674e91a3ec54f17a87bae657;674e8f84ec54f17a87b85e11;674e8d55ec54f17a87b5c778;674e9075ec54f17a87b9a7d1;674e8f87ec54f17a87b862a5;674e9019ec54f17a87b919e1;674e91a5ec54f17a87bae7c7;674e8e17ec54f17a87b683b4;674e9077ec54f17a87b9aa77;674e8d33ec54f17a87b5a717;674e8e73ec54f17a87b6f8c5;674e8ea5ec54f17a87b73724;674e8f12ec54f17a87b7c3ac;674e8e86ec54f17a87b71148;674e91e2ec54f17a87bb1ba5;674e9036ec54f17a87b93c96;674e8d8dec54f17a87b5fdd4;674e905eec54f17a87b97eae;674e909cec54f17a87b9e0d3;674e8d9aec54f17a87b60a28;674e8f49ec54f17a87b81383;674e9017ec54f17a87b91618;674e8ea4ec54f17a87b7357e;674e8d96ec54f17a87b605a9;674e8f6eec54f17a87b840f8;674e8d75ec54f17a87b5e67c;674e8efdec54f17a87b7a88f;674e8fabec54f17a87b8915d;674e8e86ec54f17a87b7109e;674e8d65ec54f17a87b5d5d1;674e8d06ec54f17a87b57907;674e8ee9ec54f17a87b78e64;674e8ff6ec54f17a87b8eefb;674e910fec54f17a87ba6100;674e8da1ec54f17a87b6113d;674e913bec54f17a87ba867d;674e8d26ec54f17a87b59a14;674e9114ec54f17a87ba64b8;674e902dec54f17a87b9319b;674e90adec54f17a87b9fa0c;674e8dbeec54f17a87b62b4f;674e8ebfec54f17a87b75845;674e8ecfec54f17a87b76d01;674e9006ec54f17a87b90276;674e8eb0ec54f17a87b745ae;674e8d9dec54f17a87b60c84;674e9192ec54f17a87bad883;674e8e3eec54f17a87b6a7e1;674e90f0ec54f17a87ba437d;674e8d0dec54f17a87b57fdd;674e908bec54f17a87b9c99b;674e8fb9ec54f17a87b8a2e1;674e8eceec54f17a87b76b35;674e9054ec54f17a87b96bce;674e8f54ec54f17a87b820a1;674e8e78ec54f17a87b6fedd;674e8e15ec54f17a87b68139;674e8d58ec54f17a87b5cabb;674e8f02ec54f17a87b7ae3f;674e8f99ec54f17a87b87a06;674e8de1ec54f17a87b64a86;674e90aaec54f17a87b9f5cf;674e8ddaec54f17a87b643cf;674e8d57ec54f17a87b5c986;674e8f26ec54f17a87b7e44c;674e8f1fec54f17a87b7d57b;674e8f67ec54f17a87b8391f;674e8d36ec54f17a87b5a915;674e8dcfec54f17a87b63ac7;674e8d18ec54f17a87b58c61;674e90d0ec54f17a87ba24f9;674e913cec54f17a87ba87ff;674e8ed6ec54f17a87b77500",
        },
        {
          value: "driver",
          count: 128,
          keywordIds:
            "674e8d6bec54f17a87b5dbee;674e8eebec54f17a87b7919d;674e8ef1ec54f17a87b798dc;674e8e37ec54f17a87b6a1d1;674e8ef0ec54f17a87b7972b;674e9020ec54f17a87b92174;674e8e6cec54f17a87b6f043;674e8e51ec54f17a87b6baee;674e90f6ec54f17a87ba4994;674e91a0ec54f17a87bae409;674e917fec54f17a87bac8d3;674e8d29ec54f17a87b59d74;674e90a6ec54f17a87b9f09f;674e9044ec54f17a87b94ee2;674e8f05ec54f17a87b7b2b5;674e8e21ec54f17a87b68d28;674e8fd5ec54f17a87b8c6e1;674e9022ec54f17a87b92388;674e91c9ec54f17a87bb0770;674e8e7cec54f17a87b7040b;674e8ef0ec54f17a87b79849;674e918dec54f17a87bad4f6;674e8f5eec54f17a87b82dc4;674e8f05ec54f17a87b7b200;674e90e1ec54f17a87ba3588;674e9098ec54f17a87b9dbc5;674e8d6aec54f17a87b5db05;674e9096ec54f17a87b9d92f;674e9079ec54f17a87b9ae05;674e8f33ec54f17a87b7f69a;674e8d94ec54f17a87b603b6;674e8f9fec54f17a87b88266;674e8e94ec54f17a87b72269;674e906aec54f17a87b99493;674e8e7cec54f17a87b70306;674e9076ec54f17a87b9a9d1;674e8e8cec54f17a87b718f7;674e90f3ec54f17a87ba46d2;674e904dec54f17a87b95a55;674e9019ec54f17a87b91927;674e8f24ec54f17a87b7e27f;674e8efbec54f17a87b7a575;674e91d9ec54f17a87bb13b3;674e8ee1ec54f17a87b7845f;674e90fdec54f17a87ba4fb0;674e8e10ec54f17a87b67c10;674e9136ec54f17a87ba8239;674e8ef8ec54f17a87b7a273;674e902bec54f17a87b92ef5;674e8e8bec54f17a87b716e3;674e8e93ec54f17a87b72025;674e8d5bec54f17a87b5cd33;674e9133ec54f17a87ba7fd6;674e8db9ec54f17a87b627a0;674e90ecec54f17a87ba4030;674e9148ec54f17a87ba9245;674e90b0ec54f17a87b9fe00;674e8e9bec54f17a87b72ad9;674e8e87ec54f17a87b7119a;674e8f53ec54f17a87b81fc2;674e8da2ec54f17a87b611bd;674e9093ec54f17a87b9d4e4;674e910aec54f17a87ba5ce3;674e8f90ec54f17a87b86e46;674e8efdec54f17a87b7a7a2;674e8ebbec54f17a87b752e3;674e9021ec54f17a87b922c1;674e9200ec54f17a87bb32ce;674e8f53ec54f17a87b8204e;674e9022ec54f17a87b9249e;674e8edcec54f17a87b77e20;674e8fb1ec54f17a87b8987a;674e91eeec54f17a87bb24b0;674e906dec54f17a87b998d3;674e916cec54f17a87bab329;674e916aec54f17a87bab185;674e8deeec54f17a87b65574;674e8db6ec54f17a87b62453;674e8f9aec54f17a87b87bdf;674e8df0ec54f17a87b65704;674e91ecec54f17a87bb2347;674e8decec54f17a87b6542f;674e8ee6ec54f17a87b78a39;674e8f4fec54f17a87b81b6c;674e9160ec54f17a87baa91d;674e8e28ec54f17a87b69427;674e8fa7ec54f17a87b88ccb;674e91ceec54f17a87bb0b43;674e8f36ec54f17a87b7fa3a;674e8f1fec54f17a87b7d67f;674e8de4ec54f17a87b64ce0;674e905cec54f17a87b97af1;674e9079ec54f17a87b9aead;674e90d0ec54f17a87ba2494;674e906fec54f17a87b99c87;674e90a5ec54f17a87b9ee81;674e8ed6ec54f17a87b775e8",
        },
        {
          value: "pixel",
          count: 128,
          keywordIds:
            "674e903cec54f17a87b944ca;674e8ec2ec54f17a87b75d51;674e8e0eec54f17a87b679ab;674e8e83ec54f17a87b70dac;674e8e38ec54f17a87b6a25a;674e8fa4ec54f17a87b888db;674e8e96ec54f17a87b72547;674e90c3ec54f17a87ba1727;674e903fec54f17a87b9488b;674e8f21ec54f17a87b7d84f;674e9069ec54f17a87b991a3;674e8d06ec54f17a87b5798c;674e8e51ec54f17a87b6ba74;674e91cbec54f17a87bb08a5;674e8fb1ec54f17a87b898b0;674e8f87ec54f17a87b861ce;674e8f3bec54f17a87b80156;674e8e2bec54f17a87b695f3;674e91f6ec54f17a87bb2b14;674e8d21ec54f17a87b594e4;674e8e67ec54f17a87b6e825;674e8e73ec54f17a87b6f82e;674e903aec54f17a87b94264;674e8fcbec54f17a87b8bac0;674e8ed2ec54f17a87b7703c;674e91abec54f17a87baeda5;674e90a7ec54f17a87b9f18d;674e8d92ec54f17a87b6025d;674e8d08ec54f17a87b57ace;674e908cec54f17a87b9cae4;674e8f77ec54f17a87b84d27;674e9170ec54f17a87bab66e;674e8d20ec54f17a87b59386;674e8f9dec54f17a87b87f76;674e8e7cec54f17a87b70370;674e8e6fec54f17a87b6f2a1;674e8e74ec54f17a87b6f9cd;674e8f91ec54f17a87b86fba;674e8d8cec54f17a87b5fccd;674e8d17ec54f17a87b58a4c;674e9057ec54f17a87b9715d;674e8efaec54f17a87b7a404;674e8e48ec54f17a87b6b199;674e8d8dec54f17a87b5fd7c;674e8d83ec54f17a87b5f492;674e8e81ec54f17a87b70ac8;674e8d52ec54f17a87b5c437;674e8dbaec54f17a87b627d7;674e903aec54f17a87b94257;674e8dc2ec54f17a87b62f28;674e8ec2ec54f17a87b75d40;674e8dcdec54f17a87b6397c;674e917dec54f17a87bac7c9;674e8dd2ec54f17a87b63d68;674e8e82ec54f17a87b70c52;674e904eec54f17a87b95bce;674e8d05ec54f17a87b577eb;674e9004ec54f17a87b90072;674e8ea3ec54f17a87b7340e;674e8f85ec54f17a87b85f5a;674e908fec54f17a87b9cf04;674e8f72ec54f17a87b845e7;674e8e9cec54f17a87b72cdd;674e8d48ec54f17a87b5bb1d;674e8f5aec54f17a87b82868;674e8d91ec54f17a87b60170;674e8fc5ec54f17a87b8b1eb;674e8d41ec54f17a87b5b4d2;674e9166ec54f17a87baae5c;674e9039ec54f17a87b940b4;674e9052ec54f17a87b967dd;674e8e6bec54f17a87b6ee72;674e8edcec54f17a87b77d2f;674e9049ec54f17a87b95476;674e9155ec54f17a87ba9e9b;674e8f4bec54f17a87b815eb;674e8d2cec54f17a87b5a054;674e8fb8ec54f17a87b8a233;674e8f75ec54f17a87b849b4;674e902eec54f17a87b933a8;674e8fc3ec54f17a87b8af33;674e8d58ec54f17a87b5ca6e;674e8decec54f17a87b65488;674e8e69ec54f17a87b6eb3a;674e8efaec54f17a87b7a40b;674e903cec54f17a87b94493;674e8d46ec54f17a87b5b941;674e8e4eec54f17a87b6b88d;674e901dec54f17a87b91ed5;674e8fbdec54f17a87b8a7d4;674e8d3cec54f17a87b5afda;674e8ecdec54f17a87b769f4;674e8eb2ec54f17a87b7486b;674e8fa5ec54f17a87b88a12;674e8f03ec54f17a87b7afa9",
        },
        {
          value: "feed",
          count: 124,
          keywordIds:
            "674e903aec54f17a87b9416d;674e8d1cec54f17a87b58fc4;674e8e90ec54f17a87b71d19;674e9100ec54f17a87ba536b;674e8fe2ec54f17a87b8d684;674e905aec54f17a87b97881;674e8ff9ec54f17a87b8f224;674e8f60ec54f17a87b82f8d;674e90dfec54f17a87ba336d;674e8d47ec54f17a87b5ba88;674e9080ec54f17a87b9b856;674e8fddec54f17a87b8d07e;674e8f93ec54f17a87b87265;674e8d3eec54f17a87b5b129;674e8cfcec54f17a87b56f92;674e8e1eec54f17a87b68a04;674e9015ec54f17a87b914ae;674e9043ec54f17a87b94cbd;674e8f21ec54f17a87b7d93d;674e9139ec54f17a87ba84fe;674e8e20ec54f17a87b68c1f;674e90adec54f17a87b9fa1c;674e91bfec54f17a87bafeaa;674e91aeec54f17a87baf01b;674e8ef1ec54f17a87b798e7;674e91c5ec54f17a87bb0381;674e9038ec54f17a87b93f79;674e9063ec54f17a87b987da;674e9065ec54f17a87b98b43;674e8db8ec54f17a87b6268e;674e8fffec54f17a87b8f991;674e8e95ec54f17a87b7235b;674e8de2ec54f17a87b64ba1;674e8e6eec54f17a87b6f1f2;674e8f4aec54f17a87b81499;674e8e69ec54f17a87b6eb7d;674e91baec54f17a87bafaba;674e9164ec54f17a87baacf1;674e8de6ec54f17a87b64fa8;674e90d5ec54f17a87ba2968;674e8d31ec54f17a87b5a472;674e915cec54f17a87baa5c8;674e8e72ec54f17a87b6f726;674e8f76ec54f17a87b84bcb;674e8f29ec54f17a87b7e8b3;674e8fe1ec54f17a87b8d443;674e8d8cec54f17a87b5fc3c;674e8f73ec54f17a87b847ad;674e9137ec54f17a87ba8334;674e911eec54f17a87ba6df2;674e8df8ec54f17a87b66212;674e907dec54f17a87b9b4aa;674e9187ec54f17a87bacfca;674e8f89ec54f17a87b86421;674e8e42ec54f17a87b6ac8f;674e90a8ec54f17a87b9f3c3;674e8f81ec54f17a87b85a5c;674e9176ec54f17a87babbe8;674e8f46ec54f17a87b80efd;674e9017ec54f17a87b916c3;674e8f6eec54f17a87b840c8;674e8dcdec54f17a87b638f2;674e8ea0ec54f17a87b73111;674e917bec54f17a87bac018;674e8cf7ec54f17a87b56a57;674e8da1ec54f17a87b610d6;674e912dec54f17a87ba7ad2;674e8f90ec54f17a87b86dbd;674e8d6eec54f17a87b5df93;674e8f04ec54f17a87b7b12d;674e8e5dec54f17a87b6db8d;674e8d40ec54f17a87b5b3df;674e9040ec54f17a87b948fc;674e8fe5ec54f17a87b8d9b2;674e8fffec54f17a87b8fa1e;674e8ed3ec54f17a87b7717c;674e8eb1ec54f17a87b7473a;674e9024ec54f17a87b92653;674e8d38ec54f17a87b5abc9;674e9123ec54f17a87ba7234;674e9049ec54f17a87b954d8;674e8fdbec54f17a87b8cd81;674e90beec54f17a87ba1125;674e8ee7ec54f17a87b78bc8;674e8e64ec54f17a87b6e4b9;674e8f75ec54f17a87b84a71;674e8effec54f17a87b7aaf6;674e8f8bec54f17a87b866ff;674e8fe7ec54f17a87b8db72;674e8decec54f17a87b653db;674e8e29ec54f17a87b6949c;674e8dfaec54f17a87b664a5;674e8debec54f17a87b65303;674e8f35ec54f17a87b7f947;674e8fa0ec54f17a87b88340;674e8f67ec54f17a87b83833;674e8e70ec54f17a87b6f496;674e9107ec54f17a87ba594f;674e8fdfec54f17a87b8d201",
        },
        {
          value: "microchip",
          count: 121,
          keywordIds:
            "674e8fe3ec54f17a87b8d71a;674e8f68ec54f17a87b83a8f;674e8f0eec54f17a87b7bf4e;674e8de8ec54f17a87b65088;674e910cec54f17a87ba5e88;674e904bec54f17a87b95707;674e8f9eec54f17a87b8818c;674e90c3ec54f17a87ba1788;674e8f21ec54f17a87b7d930;674e8f8eec54f17a87b86be7;674e9074ec54f17a87b9a6cc;674e8dbcec54f17a87b629de;674e9172ec54f17a87bab841;674e90bbec54f17a87ba0dc5;674e91eaec54f17a87bb2172;674e8cfcec54f17a87b56ef8;674e8d5aec54f17a87b5cc84;674e8eacec54f17a87b74065;674e8e36ec54f17a87b6a132;674e8e98ec54f17a87b726e5;674e907fec54f17a87b9b81b;674e8f06ec54f17a87b7b36e;674e91beec54f17a87bafe88;674e8f3bec54f17a87b80135;674e9070ec54f17a87b99e4b;674e8e43ec54f17a87b6ad2d;674e905fec54f17a87b98210;674e9073ec54f17a87b9a471;674e8f1eec54f17a87b7d410;674e8feeec54f17a87b8e46b;674e9050ec54f17a87b96387;674e8f9cec54f17a87b87ea8;674e910dec54f17a87ba5f27;674e8dc5ec54f17a87b631fa;674e9180ec54f17a87bac97e;674e90b3ec54f17a87ba017d;674e9152ec54f17a87ba9b82;674e8fadec54f17a87b8939f;674e908dec54f17a87b9cc1f;674e8fb3ec54f17a87b89b88;674e8e71ec54f17a87b6f693;674e9030ec54f17a87b935aa;674e9189ec54f17a87bad12b;674e8f92ec54f17a87b870c9;674e8fa6ec54f17a87b88a49;674e8f54ec54f17a87b8217a;674e9136ec54f17a87ba8286;674e911eec54f17a87ba6d8f;674e8efaec54f17a87b7a4b9;674e905dec54f17a87b97ce9;674e8e47ec54f17a87b6b0ee;674e8f8aec54f17a87b8658a;674e8e65ec54f17a87b6e553;674e8e8cec54f17a87b71854;674e8ec9ec54f17a87b764f9;674e8ed5ec54f17a87b7738b;674e8dbaec54f17a87b62830;674e911fec54f17a87ba6ed7;674e9147ec54f17a87ba915a;674e8f8eec54f17a87b86ae0;674e9007ec54f17a87b9036f;674e8fd0ec54f17a87b8c052;674e917aec54f17a87babfb0;674e8d4bec54f17a87b5be38;674e903eec54f17a87b9470a;674e8f07ec54f17a87b7b4f6;674e8ff7ec54f17a87b8ef66;674e90eeec54f17a87ba41d3;674e8da1ec54f17a87b61087;674e909dec54f17a87b9e390;674e8e8fec54f17a87b71c78;674e8e66ec54f17a87b6e69e;674e8f00ec54f17a87b7ac7d;674e8f2eec54f17a87b7f02c;674e903fec54f17a87b94854;674e9016ec54f17a87b9156e;674e8f19ec54f17a87b7cd65;674e8d6dec54f17a87b5de23;674e91d5ec54f17a87bb104c;674e8f35ec54f17a87b7f8d7;674e9124ec54f17a87ba7292;674e8e3eec54f17a87b6a869;674e8f12ec54f17a87b7c3a1;674e8fbdec54f17a87b8a797;674e8fafec54f17a87b896ce;674e8f65ec54f17a87b83600;674e90d7ec54f17a87ba2b99;674e8fe8ec54f17a87b8dccb;674e8e6aec54f17a87b6ec11;674e8f41ec54f17a87b807ca;674e8fdeec54f17a87b8d0ec;674e8fbeec54f17a87b8a8ea;674e8eceec54f17a87b76ab0;674e906dec54f17a87b99901;674e91dcec54f17a87bb159a;674e8d35ec54f17a87b5a884;674e9000ec54f17a87b8fb0d;674e91e5ec54f17a87bb1db4",
        },
        {
          value: "system",
          count: 119,
          keywordIds:
            "674e9071ec54f17a87b9a191;674e8d6bec54f17a87b5dbbb;674e903dec54f17a87b94563;674e904aec54f17a87b9559a;674e8d4fec54f17a87b5c26f;674e8fbeec54f17a87b8a98a;674e91b4ec54f17a87baf54d;674e8fb5ec54f17a87b89dee;674e90c1ec54f17a87ba14ee;674e8e2fec54f17a87b6997b;674e8f63ec54f17a87b832f8;674e8f78ec54f17a87b84d92;674e8f58ec54f17a87b82554;674e8e5fec54f17a87b6de90;674e91eaec54f17a87bb21a1;674e8e00ec54f17a87b66c24;674e91f6ec54f17a87bb2aa1;674e8d5aec54f17a87b5cc38;674e8e6bec54f17a87b6ee44;674e8d0eec54f17a87b581d6;674e9045ec54f17a87b94f48;674e9195ec54f17a87badb49;674e9204ec54f17a87bb35a0;674e91bfec54f17a87bafee3;674e8f3bec54f17a87b800b0;674e8ff2ec54f17a87b8e9c2;674e8ff1ec54f17a87b8e7d1;674e8db8ec54f17a87b62572;674e9012ec54f17a87b9114f;674e8e4bec54f17a87b6b53a;674e9051ec54f17a87b9651d;674e8f19ec54f17a87b7ccf8;674e8f7bec54f17a87b852af;674e8d55ec54f17a87b5c804;674e8f48ec54f17a87b811f3;674e90f4ec54f17a87ba474d;674e8d0aec54f17a87b57d1b;674e8ffbec54f17a87b8f430;674e8e19ec54f17a87b68537;674e8e74ec54f17a87b6f92e;674e8f38ec54f17a87b7fdaf;674e8d72ec54f17a87b5e2a3;674e8e71ec54f17a87b6f645;674e8fa6ec54f17a87b88b5b;674e8d7eec54f17a87b5f009;674e8f0dec54f17a87b7bcfe;674e8efbec54f17a87b7a60d;674e8d9bec54f17a87b60acf;674e8f8cec54f17a87b868ba;674e9125ec54f17a87ba7362;674e8f6cec54f17a87b83f0f;674e8d63ec54f17a87b5d3c6;674e8d85ec54f17a87b5f670;674e9001ec54f17a87b8fc2e;674e8fcfec54f17a87b8bfc1;674e8ed0ec54f17a87b76df4;674e908bec54f17a87b9c8b4;674e8ef7ec54f17a87b7a0ba;674e8fe5ec54f17a87b8da01;674e8f4dec54f17a87b818d4;674e91d0ec54f17a87bb0c5e;674e90a1ec54f17a87b9e881;674e8d40ec54f17a87b5b2cc;674e8f7dec54f17a87b8552c;674e8f70ec54f17a87b84406;674e9092ec54f17a87b9d2eb;674e8dbeec54f17a87b62be1;674e8f3dec54f17a87b803f1;674e8faeec54f17a87b89483;674e90b1ec54f17a87b9fecb;674e9006ec54f17a87b9021a;674e8f42ec54f17a87b80903;674e8f20ec54f17a87b7d7e8;674e9192ec54f17a87bad8d2;674e8f1aec54f17a87b7ce69;674e9029ec54f17a87b92c5a;674e90f1ec54f17a87ba4411;674e8e5cec54f17a87b6d952;674e8da0ec54f17a87b60fdb;674e90beec54f17a87ba10d4;674e8e63ec54f17a87b6e3e9;674e8f44ec54f17a87b80bd5;674e8e5cec54f17a87b6da6c;674e8f93ec54f17a87b8733b;674e91e8ec54f17a87bb2018;674e8e8eec54f17a87b71b0d;674e8fdeec54f17a87b8d1c6;674e8dd1ec54f17a87b63c8d;674e8ee2ec54f17a87b785bf;674e8e61ec54f17a87b6e03e;674e8f7dec54f17a87b855ab;674e9134ec54f17a87ba8088;674e905bec54f17a87b97a0d;674e8eafec54f17a87b74520;674e9106ec54f17a87ba58bf;674e8ff0ec54f17a87b8e700;674e908dec54f17a87b9cc14",
        },
        {
          value: "firewall",
          count: 117,
          keywordIds:
            "674e9081ec54f17a87b9b9a7;674e9173ec54f17a87bab8d1;674e90b5ec54f17a87ba04ce;674e9011ec54f17a87b90f67;674e8f7fec54f17a87b85783;674e91b4ec54f17a87baf5ec;674e90b7ec54f17a87ba0703;674e8f23ec54f17a87b7db03;674e907cec54f17a87b9b338;674e904dec54f17a87b959d7;674e8f62ec54f17a87b8326b;674e8dc9ec54f17a87b6351c;674e8f58ec54f17a87b825e1;674e8f0eec54f17a87b7be9b;674e9202ec54f17a87bb33dc;674e902eec54f17a87b932c3;674e8e1dec54f17a87b6892d;674e8f6dec54f17a87b83fab;674e917eec54f17a87bac84e;674e9043ec54f17a87b94d50;674e8d1eec54f17a87b59208;674e8fcdec54f17a87b8bcf9;674e8f06ec54f17a87b7b2e8;674e8e12ec54f17a87b67e0f;674e8ef4ec54f17a87b79c13;674e8f83ec54f17a87b85cf1;674e916dec54f17a87bab42b;674e914eec54f17a87ba988d;674e8d87ec54f17a87b5f879;674e8f72ec54f17a87b84686;674e8f34ec54f17a87b7f72b;674e9012ec54f17a87b91073;674e8e4cec54f17a87b6b578;674e8fcbec54f17a87b8b9eb;674e8e2dec54f17a87b69827;674e8daeec54f17a87b61cac;674e902bec54f17a87b92ed0;674e90e2ec54f17a87ba36bd;674e8f0aec54f17a87b7b973;674e8d56ec54f17a87b5c89b;674e8e35ec54f17a87b69f7f;674e8de6ec54f17a87b64efd;674e8f2aec54f17a87b7ea5d;674e9146ec54f17a87ba90b5;674e8f5bec54f17a87b8298e;674e9025ec54f17a87b9281a;674e8f2fec54f17a87b7f064;674e9029ec54f17a87b92d48;674e91deec54f17a87bb177f;674e8cfbec54f17a87b56df7;674e8ec1ec54f17a87b75aef;674e8dd8ec54f17a87b6430f;674e8f47ec54f17a87b80fb8;674e8f31ec54f17a87b7f325;674e8dbfec54f17a87b62c76;674e8f6cec54f17a87b83e5d;674e8f61ec54f17a87b83133;674e912eec54f17a87ba7c26;674e917dec54f17a87bac732;674e90a2ec54f17a87b9e9fa;674e909aec54f17a87b9de15;674e8f48ec54f17a87b811a3;674e910bec54f17a87ba5d22;674e8e61ec54f17a87b6e182;674e8e89ec54f17a87b7152f;674e8eb2ec54f17a87b74966;674e8f47ec54f17a87b80fad;674e8f59ec54f17a87b82781;674e9035ec54f17a87b93baa;674e90c1ec54f17a87ba157a;674e8f17ec54f17a87b7ca13;674e8e1aec54f17a87b685ca;674e8d37ec54f17a87b5aafe;674e8fb0ec54f17a87b89818;674e91efec54f17a87bb2509;674e8eeeec54f17a87b79562;674e8e62ec54f17a87b6e2b6;674e8d13ec54f17a87b58691;674e90beec54f17a87ba11c9;674e91ffec54f17a87bb320d;674e8d3aec54f17a87b5ad14;674e8ec5ec54f17a87b760a6;674e8d79ec54f17a87b5ea8d;674e8f3aec54f17a87b7ff8e;674e8f25ec54f17a87b7e316;674e905aec54f17a87b97758;674e90eaec54f17a87ba3d89;674e8f7dec54f17a87b854cc;674e900aec54f17a87b90706;674e90b8ec54f17a87ba0928",
        },
        {
          value: "bandwidth",
          count: 116,
          keywordIds:
            "674e903eec54f17a87b946ff;674e9065ec54f17a87b98c3d;674e8f94ec54f17a87b87473;674e8d27ec54f17a87b59bae;674e90dfec54f17a87ba33c5;674e9095ec54f17a87b9d722;674e8eb0ec54f17a87b745e9;674e8ecdec54f17a87b769d5;674e91c6ec54f17a87bb0477;674e8ef4ec54f17a87b79d1b;674e8dbcec54f17a87b62980;674e9179ec54f17a87babea2;674e8db5ec54f17a87b622d3;674e8eaeec54f17a87b74377;674e8fb2ec54f17a87b899f8;674e90a7ec54f17a87b9f132;674e8f30ec54f17a87b7f1e7;674e8f90ec54f17a87b86d75;674e8ff3ec54f17a87b8eab4;674e9002ec54f17a87b8fe21;674e9093ec54f17a87b9d589;674e8f96ec54f17a87b87665;674e8d9eec54f17a87b60d65;674e8fa9ec54f17a87b88e1c;674e8dfcec54f17a87b66792;674e8e96ec54f17a87b724c4;674e8ebfec54f17a87b75816;674e8d15ec54f17a87b58879;674e8db2ec54f17a87b62026;674e8f9fec54f17a87b882f4;674e91c1ec54f17a87bb0040;674e8f47ec54f17a87b810cd;674e8fcfec54f17a87b8beb1;674e8d31ec54f17a87b5a521;674e9085ec54f17a87b9bff3;674e8f9dec54f17a87b88065;674e8dd4ec54f17a87b63ef5;674e8f2aec54f17a87b7e9c7;674e8d53ec54f17a87b5c5ca;674e8dacec54f17a87b61b2e;674e8fe8ec54f17a87b8dcff;674e8fcfec54f17a87b8be92;674e8efcec54f17a87b7a6bb;674e9090ec54f17a87b9d0ea;674e90cdec54f17a87ba21f4;674e8dd8ec54f17a87b642b7;674e8f8dec54f17a87b8697f;674e8fcfec54f17a87b8bf7d;674e9206ec54f17a87bb372b;674e8f32ec54f17a87b7f46e;674e8f8eec54f17a87b86b7d;674e906eec54f17a87b99b20;674e8f70ec54f17a87b84305;674e8dafec54f17a87b61dff;674e8f7cec54f17a87b8533c;674e8fadec54f17a87b89476;674e8ee4ec54f17a87b78790;674e8fefec54f17a87b8e5d9;674e8ea3ec54f17a87b73489;674e8d03ec54f17a87b5761e;674e8f16ec54f17a87b7c868;674e8f57ec54f17a87b824e5;674e8ddfec54f17a87b64935;674e914bec54f17a87ba9533;674e8e9dec54f17a87b72d8c;674e8d48ec54f17a87b5bb5e;674e8ea9ec54f17a87b73d5e;674e8fa2ec54f17a87b885e4;674e8f16ec54f17a87b7c98e;674e9017ec54f17a87b91694;674e90b1ec54f17a87b9ff5b;674e904aec54f17a87b955a9;674e901eec54f17a87b91f0b;674e9156ec54f17a87ba9f3e;674e8e81ec54f17a87b709ab;674e8e3dec54f17a87b6a77d;674e9175ec54f17a87baba8a;674e8d73ec54f17a87b5e402;674e9194ec54f17a87bada30;674e8fbdec54f17a87b8a6ea;674e8f9aec54f17a87b87bed;674e90ddec54f17a87ba3140;674e8d39ec54f17a87b5ac1a;674e8f14ec54f17a87b7c6ca;674e8f8bec54f17a87b8678e;674e8efbec54f17a87b7a50b;674e901eec54f17a87b91fcb;674e90a4ec54f17a87b9eda5;674e8dd9ec54f17a87b64370;674e9116ec54f17a87ba6723;674e8eadec54f17a87b7423e;674e8dceec54f17a87b63a62;674e8f1fec54f17a87b7d56f;674e90c4ec54f17a87ba1901",
        },
        {
          value: "monitor",
          count: 114,
          keywordIds:
            "674e9089ec54f17a87b9c598;674e903cec54f17a87b94429;674e8f0bec54f17a87b7b9f4;674e8e9eec54f17a87b72ec6;674e8f86ec54f17a87b86110;674e8f5fec54f17a87b82ea2;674e8f63ec54f17a87b83391;674e90feec54f17a87ba51c8;674e8d07ec54f17a87b57a59;674e8eafec54f17a87b7449d;674e8f86ec54f17a87b8615e;674e8fbfec54f17a87b8aac7;674e9067ec54f17a87b98f29;674e8f3cec54f17a87b8023b;674e9031ec54f17a87b9374c;674e8eedec54f17a87b79380;674e8db4ec54f17a87b6226d;674e8f22ec54f17a87b7da02;674e9084ec54f17a87b9be36;674e8dacec54f17a87b61a8c;674e9045ec54f17a87b94f53;674e8ef2ec54f17a87b79969;674e8e75ec54f17a87b6fae8;674e8eb8ec54f17a87b74fc7;674e8fe5ec54f17a87b8d914;674e8ef9ec54f17a87b7a2e5;674e8d2bec54f17a87b59eb0;674e8e7bec54f17a87b701f3;674e9108ec54f17a87ba5a4c;674e8f33ec54f17a87b7f623;674e8fddec54f17a87b8cfe8;674e8fe0ec54f17a87b8d353;674e8f42ec54f17a87b809d0;674e9096ec54f17a87b9d90f;674e8dcaec54f17a87b63626;674e8f91ec54f17a87b86fe4;674e8f7bec54f17a87b851ea;674e8e1bec54f17a87b68789;674e9164ec54f17a87baac94;674e915eec54f17a87baa789;674e91d6ec54f17a87bb1103;674e8e6fec54f17a87b6f3b5;674e8dd3ec54f17a87b63e3c;674e8f74ec54f17a87b84852;674e8e31ec54f17a87b69c04;674e8ee0ec54f17a87b78253;674e8eeeec54f17a87b79476;674e901cec54f17a87b91cc1;674e8e88ec54f17a87b712b4;674e8d02ec54f17a87b5756d;674e8d52ec54f17a87b5c4f8;674e8d95ec54f17a87b60553;674e8f6eec54f17a87b84167;674e8f7cec54f17a87b85402;674e8feeec54f17a87b8e53d;674e9005ec54f17a87b90125;674e90a3ec54f17a87b9ecb8;674e8e83ec54f17a87b70cf6;674e90d8ec54f17a87ba2d22;674e8ddfec54f17a87b648b6;674e8e06ec54f17a87b6715a;674e902dec54f17a87b93159;674e8d92ec54f17a87b60205;674e905dec54f17a87b97d92;674e8e1bec54f17a87b6870c;674e8ed4ec54f17a87b77274;674e8ff2ec54f17a87b8e9b1;674e8ea2ec54f17a87b73337;674e8d73ec54f17a87b5e49f;674e8d98ec54f17a87b607d8;674e8d14ec54f17a87b5870d;674e8ecdec54f17a87b76a75;674e8fafec54f17a87b89700;674e8f44ec54f17a87b80c81;674e8ee1ec54f17a87b78486;674e8e15ec54f17a87b6819b;674e9034ec54f17a87b93a6b;674e8e08ec54f17a87b6741b;674e8f4fec54f17a87b81a76;674e8e7eec54f17a87b7065c;674e8e80ec54f17a87b70899;674e8ebaec54f17a87b751d2;674e90e9ec54f17a87ba3cf2;674e8dfaec54f17a87b6656e;674e90aaec54f17a87b9f66b;674e8d56ec54f17a87b5c8f8;674e8f26ec54f17a87b7e491;674e8efeec54f17a87b7a907;674e8eb2ec54f17a87b74971;674e90d1ec54f17a87ba2575;674e8fc8ec54f17a87b8b667",
        },
        {
          value: "port",
          count: 114,
          keywordIds:
            "674e9081ec54f17a87b9ba35;674e8ff7ec54f17a87b8ef67;674e9088ec54f17a87b9c503;674e8fb6ec54f17a87b89f0f;674e8ee9ec54f17a87b78f3b;674e8ddbec54f17a87b645be;674e8f6bec54f17a87b83dab;674e8edbec54f17a87b77cc0;674e913dec54f17a87ba88cf;674e9040ec54f17a87b9493b;674e8d13ec54f17a87b5856c;674e8f1cec54f17a87b7d1ed;674e8f3cec54f17a87b80266;674e8e2bec54f17a87b696bc;674e906bec54f17a87b995eb;674e9013ec54f17a87b91216;674e8d22ec54f17a87b595ff;674e8f10ec54f17a87b7c1aa;674e8e35ec54f17a87b6a04a;674e8f21ec54f17a87b7d966;674e8ef3ec54f17a87b79b60;674e8d00ec54f17a87b572b9;674e8f37ec54f17a87b7fbcb;674e90f9ec54f17a87ba4c89;674e8d2bec54f17a87b59f22;674e9053ec54f17a87b96a23;674e90b0ec54f17a87b9fe0e;674e91d8ec54f17a87bb12e0;674e8fbdec54f17a87b8a724;674e8f5bec54f17a87b829d7;674e8f42ec54f17a87b80982;674e8dc3ec54f17a87b62fe7;674e8ee3ec54f17a87b78692;674e8fc1ec54f17a87b8ad5e;674e8e88ec54f17a87b71331;674e90f3ec54f17a87ba4667;674e8f77ec54f17a87b84c3b;674e915bec54f17a87baa512;674e8cfeec54f17a87b5709f;674e8e0bec54f17a87b6772f;674e8fccec54f17a87b8bb9f;674e8e6fec54f17a87b6f30d;674e8e26ec54f17a87b69209;674e91f3ec54f17a87bb28c0;674e9027ec54f17a87b92afc;674e8f64ec54f17a87b834a1;674e9058ec54f17a87b972ce;674e8ffcec54f17a87b8f5e6;674e9117ec54f17a87ba67c1;674e9132ec54f17a87ba7f6f;674e903bec54f17a87b94346;674e8e5bec54f17a87b6d890;674e8d95ec54f17a87b6051b;674e8e95ec54f17a87b723ca;674e8f2eec54f17a87b7ef33;674e8facec54f17a87b89241;674e8d4bec54f17a87b5bdf9;674e8e0aec54f17a87b67655;674e8e89ec54f17a87b7149c;674e8ddfec54f17a87b648e6;674e9112ec54f17a87ba62f1;674e8e5eec54f17a87b6dc83;674e8f7dec54f17a87b855fa;674e900fec54f17a87b90cd2;674e8d42ec54f17a87b5b5ac;674e90b2ec54f17a87ba0033;674e90aeec54f17a87b9facc;674e8e80ec54f17a87b7096e;674e8f22ec54f17a87b7daf6;674e90f0ec54f17a87ba4313;674e90b3ec54f17a87ba0271;674e8f2dec54f17a87b7eec0;674e90caec54f17a87ba1e3d;674e8d25ec54f17a87b59922;674e8dccec54f17a87b63819;674e8fb8ec54f17a87b8a16f;674e8dddec54f17a87b64728;674e8e5dec54f17a87b6db5f;674e8ed5ec54f17a87b773ef;674e8e02ec54f17a87b66dc8;674e8e0fec54f17a87b67ae8;674e8e66ec54f17a87b6e79b;674e8f17ec54f17a87b7cad1;674e91ceec54f17a87bb0a9a;674e8ed8ec54f17a87b7782f;674e8f74ec54f17a87b848d4;674e8eb1ec54f17a87b747cf;674e8f20ec54f17a87b7d6ea;674e8fcaec54f17a87b8b862;674e8fefec54f17a87b8e5d4;674e8d8aec54f17a87b5fa1d",
        },
        {
          value: "alarm",
          count: 113,
          keywordIds:
            "674e901cec54f17a87b91cb2;674e8e92ec54f17a87b71f6a;674e8fbaec54f17a87b8a450;674e9066ec54f17a87b98d74;674e905bec54f17a87b979d6;674e9184ec54f17a87bacd5a;674e8f8eec54f17a87b86b82;674e90feec54f17a87ba5127;674e912aec54f17a87ba78a1;674e8fc2ec54f17a87b8adb2;674e9009ec54f17a87b905b7;674e8eabec54f17a87b73ecc;674e9052ec54f17a87b96789;674e8d62ec54f17a87b5d309;674e9016ec54f17a87b914f9;674e8eecec54f17a87b792af;674e8e5eec54f17a87b6dd26;674e8e40ec54f17a87b6a9ea;674e91aeec54f17a87baefd2;674e8d7cec54f17a87b5eddf;674e907bec54f17a87b9b082;674e9002ec54f17a87b8fd4a;674e8ed9ec54f17a87b77946;674e91acec54f17a87baee0e;674e8f91ec54f17a87b87081;674e8f0aec54f17a87b7b8bf;674e8ffeec54f17a87b8f803;674e8f85ec54f17a87b8601c;674e8fceec54f17a87b8bdcc;674e8d0aec54f17a87b57d8b;674e914aec54f17a87ba939b;674e9086ec54f17a87b9c0fa;674e8d43ec54f17a87b5b650;674e8e0cec54f17a87b677c3;674e9073ec54f17a87b9a502;674e9087ec54f17a87b9c33d;674e90cbec54f17a87ba1fcf;674e90faec54f17a87ba4dd1;674e8f82ec54f17a87b85afb;674e90fdec54f17a87ba503c;674e918fec54f17a87bad670;674e8fb6ec54f17a87b89f31;674e8e66ec54f17a87b6e6a9;674e8ec2ec54f17a87b75c44;674e8ed6ec54f17a87b77529;674e8e53ec54f17a87b6bd17;674e8e96ec54f17a87b72477;674e8e9aec54f17a87b72a84;674e8f2dec54f17a87b7ee87;674e8f0aec54f17a87b7b8f0;674e8f5aec54f17a87b82817;674e90e6ec54f17a87ba3a04;674e8d65ec54f17a87b5d642;674e8e09ec54f17a87b67585;674e9011ec54f17a87b90fb3;674e8e14ec54f17a87b68014;674e90bcec54f17a87ba0e33;674e913bec54f17a87ba86d7;674e8e61ec54f17a87b6e123;674e90d8ec54f17a87ba2c6f;674e8e90ec54f17a87b71d14;674e8f00ec54f17a87b7abab;674e8d1aec54f17a87b58d9a;674e9142ec54f17a87ba8cfe;674e8f03ec54f17a87b7af9e;674e9167ec54f17a87baaef9;674e8f4dec54f17a87b81794;674e8eb0ec54f17a87b74662;674e9063ec54f17a87b9885c;674e8f1aec54f17a87b7cef7;674e8e80ec54f17a87b70914;674e8d74ec54f17a87b5e527;674e906eec54f17a87b99ab4;674e8e5cec54f17a87b6da1e;674e8d9fec54f17a87b60f04;674e916cec54f17a87bab386;674e9185ec54f17a87bacea5;674e8f1cec54f17a87b7d0ee;674e8dcbec54f17a87b636d0;674e8e9aec54f17a87b72a6c;674e8e77ec54f17a87b6fdbf;674e9047ec54f17a87b9526a;674e8d5eec54f17a87b5cfc7;674e8da6ec54f17a87b61585;674e8d79ec54f17a87b5eb0f;674e8f50ec54f17a87b81c45;674e8ee0ec54f17a87b782dc;674e8ff0ec54f17a87b8e792;674e901fec54f17a87b92047;674e8ddaec54f17a87b6444c;674e8e49ec54f17a87b6b255;674e8d30ec54f17a87b5a3c1;674e90a5ec54f17a87b9ef2c",
        },
        {
          value: "card",
          count: 112,
          keywordIds:
            "674e9062ec54f17a87b98683;674e8e13ec54f17a87b67f08;674e8df5ec54f17a87b65bf8;674e8d4fec54f17a87b5c1a0;674e8f45ec54f17a87b80dd8;674e8f94ec54f17a87b87397;674e8f0dec54f17a87b7bdcb;674e907bec54f17a87b9b256;674e8eb0ec54f17a87b7469c;674e9129ec54f17a87ba77a4;674e8e51ec54f17a87b6baa7;674e8febec54f17a87b8e1b0;674e8e6cec54f17a87b6ef5e;674e8e4dec54f17a87b6b67f;674e8eaeec54f17a87b7439e;674e8eb6ec54f17a87b74d4a;674e8f69ec54f17a87b83b09;674e9031ec54f17a87b9365e;674e9042ec54f17a87b94c58;674e8fa7ec54f17a87b88c9f;674e8e36ec54f17a87b6a099;674e9059ec54f17a87b97679;674e8d11ec54f17a87b5841c;674e8f37ec54f17a87b7fca5;674e918aec54f17a87bad2b4;674e8d6fec54f17a87b5e086;674e918eec54f17a87bad570;674e8d9eec54f17a87b60dda;674e91a8ec54f17a87baeb09;674e8da8ec54f17a87b616e1;674e900eec54f17a87b90be3;674e91c8ec54f17a87bb05f0;674e8fc1ec54f17a87b8acb8;674e8eedec54f17a87b79344;674e8f09ec54f17a87b7b6e0;674e915bec54f17a87baa546;674e8f3aec54f17a87b7fff1;674e8d4aec54f17a87b5bd0b;674e91f3ec54f17a87bb28da;674e91a7ec54f17a87baea1a;674e8e87ec54f17a87b711d6;674e9026ec54f17a87b928f8;674e8f2fec54f17a87b7f195;674e8dadec54f17a87b61bc9;674e8eccec54f17a87b76924;674e8ef9ec54f17a87b7a356;674e8f89ec54f17a87b864d0;674e8cfbec54f17a87b56e51;674e909cec54f17a87b9e22c;674e91e3ec54f17a87bb1c0f;674e904eec54f17a87b95c35;674e8ec9ec54f17a87b76553;674e8ec0ec54f17a87b75a74;674e8fd7ec54f17a87b8c8e1;674e9096ec54f17a87b9d8e5;674e8ec7ec54f17a87b7636f;674e8e7fec54f17a87b706bb;674e913aec54f17a87ba8654;674e909dec54f17a87b9e361;674e8d4eec54f17a87b5c04d;674e8d1aec54f17a87b58e3f;674e9091ec54f17a87b9d20e;674e8e8bec54f17a87b716d7;674e9023ec54f17a87b92576;674e9143ec54f17a87ba8df2;674e8f42ec54f17a87b80a00;674e91b2ec54f17a87baf39b;674e8df6ec54f17a87b65d1e;674e8d0eec54f17a87b580aa;674e90b3ec54f17a87ba01a3;674e8fdaec54f17a87b8cc42;674e8e76ec54f17a87b6fce1;674e8d4cec54f17a87b5bf1a;674e8f82ec54f17a87b85c0d;674e8f4fec54f17a87b81b78;674e9060ec54f17a87b983ac;674e909eec54f17a87b9e49e;674e8eb7ec54f17a87b74f16;674e8dd1ec54f17a87b63c1f;674e8f28ec54f17a87b7e70e;674e91fcec54f17a87bb2f73;674e8dfbec54f17a87b665f4;674e90d1ec54f17a87ba2652;674e8e23ec54f17a87b68f26;674e91dbec54f17a87bb14fe;674e8e58ec54f17a87b6c97f;674e8eadec54f17a87b741f1;674e9105ec54f17a87ba5847;674e8fa6ec54f17a87b88ad7",
        },
        {
          value: "array",
          count: 110,
          keywordIds:
            "674e8f68ec54f17a87b839e9;674e9154ec54f17a87ba9d48;674e8fb9ec54f17a87b8a38b;674e8fb5ec54f17a87b89ec9;674e8f7fec54f17a87b85896;674e8f26ec54f17a87b7e457;674e90f5ec54f17a87ba4857;674e902aec54f17a87b92d8e;674e8d12ec54f17a87b58496;674e8f0eec54f17a87b7bf43;674e8f00ec54f17a87b7ab83;674e9179ec54f17a87babe71;674e8f2bec54f17a87b7ec5e;674e8f3fec54f17a87b805a5;674e905aec54f17a87b97731;674e8fecec54f17a87b8e2c1;674e8e85ec54f17a87b71005;674e9070ec54f17a87b99eca;674e8d7bec54f17a87b5ed14;674e8fc5ec54f17a87b8b23b;674e91d2ec54f17a87bb0d79;674e8eb5ec54f17a87b74be2;674e8fbfec54f17a87b8aa4f;674e9089ec54f17a87b9c6e7;674e9056ec54f17a87b96eab;674e8feeec54f17a87b8e49c;674e8f1eec54f17a87b7d490;674e8d15ec54f17a87b587d8;674e8f91ec54f17a87b86fab;674e9075ec54f17a87b9a884;674e8de9ec54f17a87b651dd;674e915fec54f17a87baa83b;674e9073ec54f17a87b9a459;674e8fcdec54f17a87b8bc79;674e9198ec54f17a87badde6;674e8dfeec54f17a87b66a4c;674e8ecbec54f17a87b767f7;674e8f0cec54f17a87b7bc4b;674e8fb6ec54f17a87b8a03e;674e90cdec54f17a87ba213f;674e8f4cec54f17a87b816a7;674e8ebbec54f17a87b7539d;674e8f61ec54f17a87b83189;674e8fa9ec54f17a87b88e27;674e8ebeec54f17a87b7575b;674e8efeec54f17a87b7a8b6;674e909aec54f17a87b9de80;674e8d05ec54f17a87b5787b;674e8f14ec54f17a87b7c6a1;674e8f7bec54f17a87b85172;674e8fe6ec54f17a87b8dad4;674e9110ec54f17a87ba615e;674e90efec54f17a87ba4276;674e8f48ec54f17a87b8124a;674e912eec54f17a87ba7b91;674e908eec54f17a87b9ce46;674e8eaaec54f17a87b73e2d;674e8ed8ec54f17a87b777bf;674e91a1ec54f17a87bae50c;674e8e9eec54f17a87b72f38;674e9087ec54f17a87b9c29d;674e9144ec54f17a87ba8e61;674e8ff3ec54f17a87b8eae2;674e8f5eec54f17a87b82d51;674e8faeec54f17a87b895e4;674e8d76ec54f17a87b5e74a;674e8f9bec54f17a87b87c93;674e906fec54f17a87b99d75;674e8d4dec54f17a87b5bf97;674e9034ec54f17a87b939eb;674e8fc4ec54f17a87b8b05e;674e903cec54f17a87b94465;674e901fec54f17a87b92142;674e9051ec54f17a87b96633;674e8e24ec54f17a87b68fbe;674e8e48ec54f17a87b6b208;674e8f18ec54f17a87b7cc7c;674e901aec54f17a87b91ae1;674e8fa1ec54f17a87b8857e;674e912cec54f17a87ba79b0;674e906fec54f17a87b99d9b",
        },
        {
          value: "circuit",
          count: 109,
          keywordIds:
            "674e9080ec54f17a87b9b8f9;674e90b6ec54f17a87ba0559;674e8e9fec54f17a87b72f70;674e8f0cec54f17a87b7bc83;674e907cec54f17a87b9b27a;674e8f4aec54f17a87b813cf;674e8feaec54f17a87b8dfae;674e8d06ec54f17a87b579c5;674e8f58ec54f17a87b82582;674e8f1bec54f17a87b7d09f;674e8f6fec54f17a87b8424c;674e8f59ec54f17a87b8267f;674e919fec54f17a87bae373;674e8dffec54f17a87b66b58;674e8fd3ec54f17a87b8c4bf;674e8f2bec54f17a87b7ec8d;674e8d37ec54f17a87b5aa7a;674e9099ec54f17a87b9dd4b;674e8f2aec54f17a87b7eabc;674e91c8ec54f17a87bb06a3;674e903bec54f17a87b9430b;674e8d11ec54f17a87b5838c;674e8e44ec54f17a87b6add2;674e8f60ec54f17a87b8301a;674e8fc4ec54f17a87b8b016;674e8ffeec54f17a87b8f8ec;674e8f06ec54f17a87b7b2f3;674e8fe0ec54f17a87b8d3eb;674e8fd8ec54f17a87b8caa8;674e8d6aec54f17a87b5da99;674e8ecbec54f17a87b7672e;674e8facec54f17a87b892e8;674e8f85ec54f17a87b85f4d;674e8e46ec54f17a87b6afec;674e8d09ec54f17a87b57cc9;674e8fc8ec54f17a87b8b629;674e9074ec54f17a87b9a5af;674e8d1dec54f17a87b59158;674e8ea5ec54f17a87b736d7;674e90baec54f17a87ba0b7b;674e8f0bec54f17a87b7ba96;674e91deec54f17a87bb1813;674e901cec54f17a87b91d4b;674e8d99ec54f17a87b608e5;674e9047ec54f17a87b95291;674e8fd7ec54f17a87b8c97c;674e9018ec54f17a87b917ad;674e8e78ec54f17a87b6ff17;674e8d82ec54f17a87b5f385;674e8f14ec54f17a87b7c5d8;674e8f7aec54f17a87b84fd4;674e9095ec54f17a87b9d7b0;674e9111ec54f17a87ba6206;674e8ec4ec54f17a87b75f73;674e8d4eec54f17a87b5c0d1;674e9159ec54f17a87baa374;674e8ebbec54f17a87b75404;674e91adec54f17a87baeebc;674e8ebfec54f17a87b758d2;674e8e1aec54f17a87b6865b;674e9017ec54f17a87b915d6;674e91b2ec54f17a87baf3cb;674e8f1bec54f17a87b7cf9e;674e90d4ec54f17a87ba28bd;674e9022ec54f17a87b9248b;674e906dec54f17a87b99973;674e8d25ec54f17a87b5997c;674e8fafec54f17a87b89623;674e8f8dec54f17a87b869da;674e91f2ec54f17a87bb27f5;674e8f43ec54f17a87b80b62;674e8ec6ec54f17a87b761c0;674e8fb5ec54f17a87b89d88;674e913fec54f17a87ba8a55;674e8f35ec54f17a87b7f85b;674e8e80ec54f17a87b7080f;674e8f36ec54f17a87b7faea;674e8edaec54f17a87b77a9e;674e8f18ec54f17a87b7cb7a;674e8dc7ec54f17a87b633d7;674e90b4ec54f17a87ba03f0;674e8edaec54f17a87b77a1c;674e8e57ec54f17a87b6c0b3;674e905bec54f17a87b97926;674e8f27ec54f17a87b7e580;674e8d19ec54f17a87b58cc5;674e90a4ec54f17a87b9edd3;674e908eec54f17a87b9cd2d",
        },
        {
          value: "protocol",
          count: 109,
          keywordIds:
            "674e8df5ec54f17a87b65c21;674e90ffec54f17a87ba52cc;674e8ddbec54f17a87b64513;674e8f25ec54f17a87b7e3e2;674e904fec54f17a87b95d0b;674e90c0ec54f17a87ba13ba;674e90c7ec54f17a87ba1b66;674e902aec54f17a87b92e07;674e90dcec54f17a87ba3062;674e8e6cec54f17a87b6f01d;674e9064ec54f17a87b98991;674e8eaaec54f17a87b73e5e;674e91ebec54f17a87bb2207;674e902eec54f17a87b93370;674e8fc0ec54f17a87b8ab49;674e8d5dec54f17a87b5cee5;674e9046ec54f17a87b951d4;674e917eec54f17a87bac81a;674e9013ec54f17a87b912b2;674e8d8fec54f17a87b5fec4;674e8d0fec54f17a87b58264;674e90a6ec54f17a87b9f05c;674e8fcdec54f17a87b8bc01;674e8e67ec54f17a87b6e93c;674e8e40ec54f17a87b6aa7f;674e919dec54f17a87bae1aa;674e9177ec54f17a87babc79;674e8e76ec54f17a87b6fcb9;674e918aec54f17a87bad229;674e8e85ec54f17a87b70ff9;674e9119ec54f17a87ba68fb;674e8f5fec54f17a87b82e0a;674e8f33ec54f17a87b7f6a3;674e8dc3ec54f17a87b6308d;674e8e93ec54f17a87b7213b;674e908bec54f17a87b9c86f;674e9078ec54f17a87b9ac6a;674e8f9cec54f17a87b87f44;674e8eebec54f17a87b7910b;674e90ceec54f17a87ba22c0;674e91deec54f17a87bb17e0;674e8e82ec54f17a87b70be0;674e8d5cec54f17a87b5cd8f;674e8f4cec54f17a87b8173e;674e9008ec54f17a87b90445;674e8f31ec54f17a87b7f382;674e8d63ec54f17a87b5d498;674e8fa9ec54f17a87b88f0f;674e8d4bec54f17a87b5be86;674e908aec54f17a87b9c7d0;674e8ff5ec54f17a87b8ed16;674e8e5fec54f17a87b6de47;674e8ff7ec54f17a87b8f01d;674e8ea2ec54f17a87b733d7;674e8e84ec54f17a87b70dd9;674e8edfec54f17a87b780c3;674e8f27ec54f17a87b7e61a;674e8e9dec54f17a87b72d05;674e8f62ec54f17a87b831fa;674e8f2fec54f17a87b7f15d;674e8e96ec54f17a87b7251c;674e8f4eec54f17a87b81910;674e8edbec54f17a87b77c71;674e8f34ec54f17a87b7f82d;674e8f97ec54f17a87b877f3;674e8dcbec54f17a87b63747;674e8db6ec54f17a87b623d4;674e8f9aec54f17a87b87b4e;674e8f54ec54f17a87b8216f;674e8ddeec54f17a87b647b5;674e8e79ec54f17a87b6ffb2;674e8fd5ec54f17a87b8c640;674e90abec54f17a87b9f78e;674e8efaec54f17a87b7a484;674e8f41ec54f17a87b80865;674e90b4ec54f17a87ba0330;674e8ed7ec54f17a87b7779a;674e8f74ec54f17a87b84831;674e8e3aec54f17a87b6a441;674e8eaeec54f17a87b7429d;674e8f26ec54f17a87b7e564;674e912bec54f17a87ba7935;674e9138ec54f17a87ba83eb;674e8e4aec54f17a87b6b3eb",
        },
        {
          value: "matrix",
          count: 108,
          keywordIds:
            "674e8fe2ec54f17a87b8d68f;674e8e91ec54f17a87b71e5e;674e8f0eec54f17a87b7bed5;674e8f7fec54f17a87b85888;674e8edcec54f17a87b77dc9;674e8e2eec54f17a87b698c6;674e913dec54f17a87ba8883;674e907bec54f17a87b9b116;674e9197ec54f17a87badccd;674e91c3ec54f17a87bb0261;674e9075ec54f17a87b9a77d;674e8f1cec54f17a87b7d12b;674e8f58ec54f17a87b825a5;674e8f9eec54f17a87b88118;674e8d0cec54f17a87b57ee9;674e8d36ec54f17a87b5a9f4;674e9067ec54f17a87b98ec5;674e9084ec54f17a87b9bf75;674e9044ec54f17a87b94ea3;674e8e11ec54f17a87b67d64;674e8d88ec54f17a87b5f910;674e8d7bec54f17a87b5ec9b;674e8e7aec54f17a87b70167;674e8dd6ec54f17a87b6411e;674e90ebec54f17a87ba3e9e;674e8e6fec54f17a87b6f371;674e90e0ec54f17a87ba3509;674e8fe8ec54f17a87b8dda3;674e8cfaec54f17a87b56cfb;674e8db2ec54f17a87b6209c;674e909fec54f17a87b9e613;674e8e7bec54f17a87b70231;674e908cec54f17a87b9cb83;674e90d5ec54f17a87ba2a28;674e9170ec54f17a87bab6e1;674e8ffbec54f17a87b8f4bf;674e8f24ec54f17a87b7e1d4;674e9199ec54f17a87bade64;674e8f13ec54f17a87b7c4f6;674e8e70ec54f17a87b6f4a1;674e8dffec54f17a87b66a94;674e8ebeec54f17a87b7574d;674e8d8bec54f17a87b5fb01;674e8eefec54f17a87b796bf;674e90cdec54f17a87ba2122;674e8e92ec54f17a87b71f32;674e9205ec54f17a87bb368c;674e8ec1ec54f17a87b75bb7;674e8ec3ec54f17a87b75de3;674e90a1ec54f17a87b9e933;674e909bec54f17a87b9df69;674e8ee8ec54f17a87b78c5f;674e8e5bec54f17a87b6d8ae;674e8ff6ec54f17a87b8ee61;674e8e68ec54f17a87b6e986;674e8ec7ec54f17a87b762aa;674e90bbec54f17a87ba0dd2;674e8f85ec54f17a87b86029;674e8d6eec54f17a87b5df57;674e9042ec54f17a87b94c4c;674e8d91ec54f17a87b6013b;674e8fc6ec54f17a87b8b33a;674e8f3eec54f17a87b804e1;674e8d42ec54f17a87b5b55c;674e8e97ec54f17a87b725de;674e901dec54f17a87b91e7a;674e8e74ec54f17a87b6f920;674e8f23ec54f17a87b7e0f9;674e8f89ec54f17a87b86444;674e8e50ec54f17a87b6b9e2;674e8f66ec54f17a87b836fe;674e9055ec54f17a87b96ce8;674e906eec54f17a87b99bd5;674e902eec54f17a87b9337b;674e8df0ec54f17a87b65792;674e8fe7ec54f17a87b8dc15;674e8f24ec54f17a87b7e229;674e903dec54f17a87b9450f;674e8edaec54f17a87b77af9;674e8ebaec54f17a87b75265;674e8ee3ec54f17a87b786b6;674e8e61ec54f17a87b6e135;674e8efeec54f17a87b7a9c7;674e8f09ec54f17a87b7b813;674e9079ec54f17a87b9adcb;674e8d2fec54f17a87b5a310",
        },
        {
          value: "interface",
          count: 105,
          keywordIds:
            "674e8eebec54f17a87b79130;674e9088ec54f17a87b9c431;674e8f4aec54f17a87b81455;674e8fb5ec54f17a87b89e67;674e8f87ec54f17a87b861f1;674e8d2eec54f17a87b5a1f8;674e8f8fec54f17a87b86c85;674e8dc8ec54f17a87b6349f;674e90f7ec54f17a87ba49e4;674e8fa3ec54f17a87b88785;674e8f6fec54f17a87b841a9;674e8f92ec54f17a87b87124;674e8d21ec54f17a87b59536;674e9121ec54f17a87ba6fcf;674e8d77ec54f17a87b5e920;674e8eb6ec54f17a87b74cfe;674e8ebcec54f17a87b75526;674e8f8fec54f17a87b86cb8;674e8d24ec54f17a87b597ee;674e8d87ec54f17a87b5f80e;674e91faec54f17a87bb2da7;674e8e86ec54f17a87b71078;674e9032ec54f17a87b937b3;674e8eb9ec54f17a87b7512f;674e9000ec54f17a87b8fad5;674e8ef5ec54f17a87b79e34;674e9152ec54f17a87ba9bf7;674e8fc0ec54f17a87b8ac19;674e8f88ec54f17a87b86385;674e8d00ec54f17a87b57353;674e8ea1ec54f17a87b731df;674e9077ec54f17a87b9abc0;674e8ffeec54f17a87b8f828;674e91a9ec54f17a87baebdb;674e8fa6ec54f17a87b88acb;674e8d16ec54f17a87b5896c;674e8fcaec54f17a87b8b89d;674e8d7dec54f17a87b5ef20;674e8df8ec54f17a87b662d4;674e8fceec54f17a87b8bd46;674e8ef0ec54f17a87b7976f;674e8d9aec54f17a87b6093b;674e8e8dec54f17a87b7191a;674e8ecaec54f17a87b7661c;674e8ed5ec54f17a87b77466;674e8fd0ec54f17a87b8c0d1;674e8ecfec54f17a87b76d0d;674e8f7bec54f17a87b85219;674e8e79ec54f17a87b6ffd2;674e8ea7ec54f17a87b7390a;674e8fefec54f17a87b8e678;674e9084ec54f17a87b9be92;674e9122ec54f17a87ba712f;674e8e7eec54f17a87b7060a;674e910aec54f17a87ba5cc2;674e8d3bec54f17a87b5ae7a;674e906cec54f17a87b997a3;674e8e59ec54f17a87b6d689;674e8feaec54f17a87b8df76;674e8e8fec54f17a87b71b7c;674e8f03ec54f17a87b7b041;674e8f17ec54f17a87b7cadc;674e903aec54f17a87b941a5;674e9052ec54f17a87b966f5;674e8d6dec54f17a87b5ddb9;674e9025ec54f17a87b92789;674e8e3cec54f17a87b6a644;674e8f3eec54f17a87b803fc;674e90b2ec54f17a87ba013a;674e90cbec54f17a87ba1f19;674e90beec54f17a87ba1237;674e90ddec54f17a87ba3162;674e9041ec54f17a87b94b15;674e8edeec54f17a87b78027;674e8fc8ec54f17a87b8b5a6;674e8e02ec54f17a87b66da0;674e8ee6ec54f17a87b78ad7;674e8f38ec54f17a87b7fd51;674e8ddcec54f17a87b64679;674e8d45ec54f17a87b5b7fa;674e8f99ec54f17a87b879da;674e90aaec54f17a87b9f5f7;674e8f73ec54f17a87b847bb;674e8e56ec54f17a87b6c00e;674e8e57ec54f17a87b6c18d;674e8df3ec54f17a87b65a50;674e8f1fec54f17a87b7d638",
        },
        {
          value: "transmitter",
          count: 104,
          keywordIds:
            "674e901cec54f17a87b91d92;674e9089ec54f17a87b9c631;674e90b5ec54f17a87ba0419;674e9011ec54f17a87b90f31;674e8eeaec54f17a87b78fb4;674e8f7fec54f17a87b857a4;674e8f6cec54f17a87b83df9;674e8edbec54f17a87b77c08;674e8e75ec54f17a87b6fb1a;674e8ff4ec54f17a87b8eccc;674e912aec54f17a87ba782a;674e8e32ec54f17a87b69d84;674e9074ec54f17a87b9a706;674e90a1ec54f17a87b9e976;674e8e4dec54f17a87b6b768;674e90bbec54f17a87ba0e01;674e9179ec54f17a87babf09;674e8d8fec54f17a87b5ff36;674e8d2aec54f17a87b59dd5;674e8fb2ec54f17a87b899cd;674e90afec54f17a87b9fbf5;674e8ef7ec54f17a87b7a054;674e919eec54f17a87bae25f;674e8e85ec54f17a87b70f05;674e8e75ec54f17a87b6fb91;674e8ff5ec54f17a87b8eddb;674e914dec54f17a87ba96fd;674e8ff1ec54f17a87b8e906;674e9038ec54f17a87b93ec7;674e9027ec54f17a87b929bc;674e9119ec54f17a87ba699d;674e9107ec54f17a87ba59c5;674e8f7aec54f17a87b8514c;674e8daaec54f17a87b619b7;674e8fdcec54f17a87b8cedd;674e9097ec54f17a87b9db1c;674e9033ec54f17a87b93949;674e9182ec54f17a87bacbca;674e8f33ec54f17a87b7f5f3;674e8e6eec54f17a87b6f25e;674e91c0ec54f17a87baffbe;674e8d08ec54f17a87b57b6e;674e906bec54f17a87b9955a;674e9053ec54f17a87b969b5;674e8d66ec54f17a87b5d717;674e8e18ec54f17a87b683f1;674e8f3bec54f17a87b80096;674e8d7aec54f17a87b5ebf2;674e91d9ec54f17a87bb1384;674e8ec6ec54f17a87b761a5;674e91e4ec54f17a87bb1c9e;674e8f75ec54f17a87b84989;674e8ebeec54f17a87b757ad;674e915dec54f17a87baa6ab;674e8da3ec54f17a87b61279;674e8ee5ec54f17a87b788dd;674e8f15ec54f17a87b7c744;674e9056ec54f17a87b96fb5;674e8e94ec54f17a87b72277;674e8f1bec54f17a87b7cfd3;674e8f4eec54f17a87b81996;674e90bbec54f17a87ba0d75;674e8ec4ec54f17a87b75ea2;674e8f05ec54f17a87b7b1c2;674e8f28ec54f17a87b7e79e;674e8e05ec54f17a87b670f4;674e8ea9ec54f17a87b73d34;674e8ea9ec54f17a87b73c88;674e8fa1ec54f17a87b88579;674e8eb4ec54f17a87b74ba7;674e8f4dec54f17a87b81878;674e8f94ec54f17a87b87495;674e8f15ec54f17a87b7c7a3;674e8f2eec54f17a87b7efb2;674e8fd5ec54f17a87b8c6b5;674e8f8cec54f17a87b86828;674e8ea5ec54f17a87b737ca;674e8f1dec54f17a87b7d2cb;674e8fc7ec54f17a87b8b53c;674e91f8ec54f17a87bb2be2;674e8e2fec54f17a87b69a24;674e8f32ec54f17a87b7f54a;674e90acec54f17a87b9f7f8;674e8d3cec54f17a87b5af3c;674e9039ec54f17a87b93fe7;674e8e56ec54f17a87b6bf84;674e8f18ec54f17a87b7cbfd;674e901bec54f17a87b91bce;674e8f27ec54f17a87b7e61f;674e9079ec54f17a87b9ad6b;674e8fcaec54f17a87b8b959;674e9138ec54f17a87ba843a",
        },
        {
          value: "capacitor",
          count: 100,
          keywordIds:
            "674e8d6cec54f17a87b5dc5a;674e8fb6ec54f17a87b89fc1;674e8eeaec54f17a87b7905a;674e8f7eec54f17a87b8570c;674e90b7ec54f17a87ba078c;674e8dc8ec54f17a87b634bd;674e900aec54f17a87b90654;674e8f80ec54f17a87b85992;674e8ec8ec54f17a87b76447;674e8d0bec54f17a87b57e5b;674e8e7aec54f17a87b700b2;674e9071ec54f17a87b9a0ad;674e8f11ec54f17a87b7c278;674e8d60ec54f17a87b5d1a8;674e91c2ec54f17a87bb0175;674e8e8dec54f17a87b719ad;674e8cffec54f17a87b57200;674e8ef8ec54f17a87b7a1e1;674e8fc6ec54f17a87b8b3da;674e8ee9ec54f17a87b78e2c;674e8ed8ec54f17a87b7786a;674e8fa9ec54f17a87b88ed2;674e9057ec54f17a87b970ae;674e8d69ec54f17a87b5da19;674e8eb8ec54f17a87b74ff9;674e8dc5ec54f17a87b63193;674e8ed1ec54f17a87b76f13;674e8db1ec54f17a87b61f8c;674e8ff8ec54f17a87b8f0cc;674e8f08ec54f17a87b7b619;674e9054ec54f17a87b96aaf;674e8d20ec54f17a87b593ac;674e8d34ec54f17a87b5a7a7;674e9199ec54f17a87bade1d;674e8f73ec54f17a87b846ed;674e911eec54f17a87ba6d4e;674e8ffcec54f17a87b8f63c;674e9019ec54f17a87b91a47;674e8eeeec54f17a87b795b3;674e905eec54f17a87b97fee;674e9046ec54f17a87b9515f;674e8f75ec54f17a87b84ac5;674e9018ec54f17a87b91767;674e8e9fec54f17a87b73032;674e904dec54f17a87b95af2;674e8e69ec54f17a87b6ea81;674e9010ec54f17a87b90f0e;674e8f4dec54f17a87b81813;674e8e66ec54f17a87b6e764;674e8eb2ec54f17a87b74999;674e90a0ec54f17a87b9e78f;674e8f62ec54f17a87b8328c;674e90acec54f17a87b9f8d2;674e9043ec54f17a87b94d42;674e8f52ec54f17a87b81f35;674e8e6bec54f17a87b6edd7;674e8d6dec54f17a87b5dd14;674e8d9cec54f17a87b60c14;674e9126ec54f17a87ba74ae;674e908cec54f17a87b9ca77;674e9186ec54f17a87bacf09;674e8f1bec54f17a87b7d090;674e8fafec54f17a87b89668;674e8db6ec54f17a87b623fc;674e8e39ec54f17a87b6a394;674e9035ec54f17a87b93b22;674e91ecec54f17a87bb22f0;674e8ee5ec54f17a87b789a0;674e8ed0ec54f17a87b76e84;674e8ee0ec54f17a87b7821a;674e8edaec54f17a87b77b7d;674e8eb9ec54f17a87b75180;674e8f07ec54f17a87b7b50e;674e8f17ec54f17a87b7cb00;674e8deaec54f17a87b65299;674e8f18ec54f17a87b7cba0;674e8f09ec54f17a87b7b6ec;674e8dcfec54f17a87b63b30;674e8fefec54f17a87b8e677",
        },
        {
          value: "drive",
          count: 100,
          keywordIds:
            "674e9061ec54f17a87b98600;674e8ec9ec54f17a87b76550;674e9183ec54f17a87baccda;674e8e97ec54f17a87b72669;674e9069ec54f17a87b992dc;674e8f78ec54f17a87b84e5c;674e91cbec54f17a87bb0846;674e8d5aec54f17a87b5cc01;674e8d29ec54f17a87b59d2d;674e9067ec54f17a87b98f9b;674e8e99ec54f17a87b7283b;674e8d23ec54f17a87b5970f;674e9178ec54f17a87babd6b;674e91f9ec54f17a87bb2cd6;674e907aec54f17a87b9afbe;674e918cec54f17a87bad3fa;674e8dd5ec54f17a87b6404d;674e8f95ec54f17a87b875c4;674e8ed1ec54f17a87b76f8d;674e9102ec54f17a87ba556e;674e8f9bec54f17a87b87dc7;674e910eec54f17a87ba6002;674e8f5cec54f17a87b82ab5;674e8da9ec54f17a87b617b9;674e8d93ec54f17a87b60326;674e8fc1ec54f17a87b8ad24;674e8e89ec54f17a87b7141b;674e8d01ec54f17a87b5743f;674e8f5bec54f17a87b82a5d;674e91d7ec54f17a87bb11f5;674e91daec54f17a87bb1422;674e8ffdec54f17a87b8f779;674e8ef4ec54f17a87b79c08;674e91e2ec54f17a87bb1a9d;674e8ec5ec54f17a87b760ab;674e8fceec54f17a87b8bdee;674e8ee1ec54f17a87b7839f;674e8f0cec54f17a87b7bbcc;674e8d83ec54f17a87b5f44b;674e90d3ec54f17a87ba27d7;674e8f52ec54f17a87b81e60;674e91ccec54f17a87bb0953;674e8d74ec54f17a87b5e5d6;674e8db0ec54f17a87b61edf;674e8ee8ec54f17a87b78d6a;674e8f52ec54f17a87b81f2a;674e8ea7ec54f17a87b73a61;674e8f7aec54f17a87b850d3;674e8e60ec54f17a87b6df00;674e912dec54f17a87ba7b2f;674e8d50ec54f17a87b5c318;674e907dec54f17a87b9b514;674e8f28ec54f17a87b7e6de;674e9027ec54f17a87b92acb;674e9091ec54f17a87b9d2dd;674e8ed7ec54f17a87b776f2;674e8dbdec54f17a87b62b11;674e8fa1ec54f17a87b88532;674e8ffaec54f17a87b8f2de;674e8ecfec54f17a87b76c3a;674e9006ec54f17a87b902ea;674e91b3ec54f17a87baf45c;674e8f10ec54f17a87b7c164;674e8ea2ec54f17a87b733d8;674e8f22ec54f17a87b7da42;674e8eb7ec54f17a87b74e18;674e8e55ec54f17a87b6bf24;674e8f99ec54f17a87b87b19;674e8e1fec54f17a87b68b90;674e8f37ec54f17a87b7fc1b;674e8fc7ec54f17a87b8b44b;674e911bec54f17a87ba6b02;674e8fa7ec54f17a87b88bd6;674e9009ec54f17a87b90649;674e8f67ec54f17a87b83898;674e8e71ec54f17a87b6f59c",
        },
        {
          value: "hard",
          count: 100,
          keywordIds:
            "674e9061ec54f17a87b985ae;674e8ec9ec54f17a87b7652d;674e9183ec54f17a87bacc9a;674e8e97ec54f17a87b72637;674e9069ec54f17a87b99293;674e8f78ec54f17a87b84e3a;674e91caec54f17a87bb0812;674e8d5aec54f17a87b5cbe2;674e8d29ec54f17a87b59d05;674e9067ec54f17a87b98f59;674e8e99ec54f17a87b727eb;674e8d23ec54f17a87b596e4;674e9178ec54f17a87babd47;674e91f9ec54f17a87bb2cad;674e907aec54f17a87b9af93;674e918cec54f17a87bad3de;674e8dd5ec54f17a87b6402f;674e8f95ec54f17a87b87590;674e8ed1ec54f17a87b76f2a;674e9102ec54f17a87ba553d;674e8f9bec54f17a87b87d7b;674e910eec54f17a87ba5fd2;674e8f5cec54f17a87b82a6a;674e8da9ec54f17a87b61775;674e8d93ec54f17a87b602f0;674e8fc1ec54f17a87b8acd5;674e8e89ec54f17a87b713e0;674e8d01ec54f17a87b5741c;674e8f5bec54f17a87b82a24;674e91d7ec54f17a87bb11c9;674e91daec54f17a87bb13f4;674e8ffdec54f17a87b8f733;674e8ef3ec54f17a87b79bd4;674e91e1ec54f17a87bb1a79;674e8ec5ec54f17a87b76067;674e8fceec54f17a87b8bdc0;674e8ee1ec54f17a87b78355;674e8f0cec54f17a87b7bb7b;674e8d83ec54f17a87b5f41a;674e90d3ec54f17a87ba27a2;674e8f52ec54f17a87b81e1e;674e91ccec54f17a87bb093c;674e8d74ec54f17a87b5e5b2;674e8db0ec54f17a87b61eb5;674e8ee8ec54f17a87b78d1b;674e8f52ec54f17a87b81ef9;674e8ea7ec54f17a87b73a14;674e8f7aec54f17a87b85066;674e8e5fec54f17a87b6ded7;674e912dec54f17a87ba7b13;674e8d50ec54f17a87b5c2fa;674e907dec54f17a87b9b4c2;674e8f28ec54f17a87b7e6ab;674e9027ec54f17a87b92a88;674e9091ec54f17a87b9d297;674e8ed7ec54f17a87b776b1;674e8dbdec54f17a87b62af8;674e8fa1ec54f17a87b88509;674e8ff9ec54f17a87b8f2ae;674e8ecfec54f17a87b76bf6;674e9006ec54f17a87b902bb;674e91b3ec54f17a87baf42a;674e8f10ec54f17a87b7c118;674e8ea2ec54f17a87b733aa;674e8f22ec54f17a87b7da0e;674e8eb6ec54f17a87b74de5;674e8e55ec54f17a87b6befa;674e8f99ec54f17a87b87aee;674e8e1fec54f17a87b68b5d;674e8f37ec54f17a87b7fbd6;674e8fc6ec54f17a87b8b41c;674e911bec54f17a87ba6ad2;674e8fa7ec54f17a87b88bae;674e9009ec54f17a87b905ff;674e8f67ec54f17a87b83865;674e8e71ec54f17a87b6f56d",
        },
        {
          value: "panel",
          count: 99,
          keywordIds:
            "674e8fe3ec54f17a87b8d7d6;674e9089ec54f17a87b9c5cc;674e8f0bec54f17a87b7babc;674e903eec54f17a87b9465f;674e8fbeec54f17a87b8a855;674e90b6ec54f17a87ba06d4;674e8ff8ec54f17a87b8f180;674e91d4ec54f17a87bb0f59;674e8ea9ec54f17a87b73c46;674e8f78ec54f17a87b84dea;674e9031ec54f17a87b93682;674e8d5cec54f17a87b5cdfc;674e8f6dec54f17a87b83fe0;674e8eadec54f17a87b74266;674e8f3fec54f17a87b80631;674e8d0fec54f17a87b581f7;674e909bec54f17a87b9dfb0;674e8d7fec54f17a87b5f095;674e9102ec54f17a87ba55e0;674e8f04ec54f17a87b7b0d3;674e9164ec54f17a87baac0a;674e8fe9ec54f17a87b8de48;674e8dafec54f17a87b61d78;674e90b3ec54f17a87ba0241;674e9109ec54f17a87ba5bb2;674e8de6ec54f17a87b64e85;674e8e9bec54f17a87b72b8b;674e8f29ec54f17a87b7e92c;674e8cfeec54f17a87b57129;674e8f39ec54f17a87b7fe02;674e900bec54f17a87b9086e;674e8ea5ec54f17a87b7375a;674e91aaec54f17a87baece2;674e8d8bec54f17a87b5fbc0;674e8e0fec54f17a87b67b50;674e8eecec54f17a87b791df;674e8eccec54f17a87b76863;674e9018ec54f17a87b91896;674e9082ec54f17a87b9bc41;674e8eefec54f17a87b796e8;674e8e42ec54f17a87b6ac0f;674e8e8bec54f17a87b71787;674e9076ec54f17a87b9a9df;674e8d9bec54f17a87b60b8d;674e9007ec54f17a87b90382;674e8dc0ec54f17a87b62d36;674e8e5bec54f17a87b6d816;674e8e54ec54f17a87b6bd68;674e8e95ec54f17a87b722f6;674e904cec54f17a87b9594d;674e8efeec54f17a87b7a912;674e8e93ec54f17a87b72147;674e9093ec54f17a87b9d598;674e9041ec54f17a87b94aee;674e90d9ec54f17a87ba2d8f;674e8d4dec54f17a87b5c003;674e8e8fec54f17a87b71c3c;674e905dec54f17a87b97cac;674e8f6aec54f17a87b83c19;674e8f94ec54f17a87b87405;674e8fd2ec54f17a87b8c325;674e8f16ec54f17a87b7c887;674e8fdcec54f17a87b8ceb7;674e8eb7ec54f17a87b74f3d;674e8fdaec54f17a87b8ccf0;674e8ee7ec54f17a87b78b44;674e8f82ec54f17a87b85b06;674e8d5fec54f17a87b5d064;674e8defec54f17a87b656c9;674e8d78ec54f17a87b5ea1d;674e8ea5ec54f17a87b73733;674e8e7eec54f17a87b70558;674e8d45ec54f17a87b5b875;674e8f31ec54f17a87b7f3df;674e8f26ec54f17a87b7e545;674e8e3aec54f17a87b6a535;674e9001ec54f17a87b8fbb7;674e90edec54f17a87ba4099",
        },
        {
          value: "reboot",
          count: 98,
          keywordIds:
            "674e9081ec54f17a87b9b9c5;674e904aec54f17a87b955d0;674e8fe2ec54f17a87b8d6b1;674e8f23ec54f17a87b7db42;674e9002ec54f17a87b8fd44;674e8f8eec54f17a87b86b07;674e8eb0ec54f17a87b74619;674e8d06ec54f17a87b5796f;674e907fec54f17a87b9b7a6;674e8eaaec54f17a87b73e8c;674e8f00ec54f17a87b7abd0;674e8dffec54f17a87b66b37;674e8e6bec54f17a87b6ee82;674e8f10ec54f17a87b7c143;674e8fb1ec54f17a87b89958;674e8f2aec54f17a87b7ea81;674e8dabec54f17a87b61a2e;674e8ff1ec54f17a87b8e832;674e8e75ec54f17a87b6fb39;674e8d87ec54f17a87b5f7e3;674e91f8ec54f17a87bb2c7c;674e8fcbec54f17a87b8ba44;674e8ed2ec54f17a87b770a2;674e9031ec54f17a87b93707;674e8f2cec54f17a87b7ed47;674e8ffeec54f17a87b8f894;674e9181ec54f17a87bacad7;674e8f33ec54f17a87b7f621;674e9109ec54f17a87ba5ad6;674e8e1bec54f17a87b68768;674e9164ec54f17a87baac4e;674e8d43ec54f17a87b5b614;674e9078ec54f17a87b9abfb;674e8efbec54f17a87b7a5aa;674e8e7cec54f17a87b70328;674e8dd3ec54f17a87b63e5a;674e91e1ec54f17a87bb1a62;674e8d8aec54f17a87b5fa84;674e8eefec54f17a87b79612;674e8dd8ec54f17a87b642da;674e8d9bec54f17a87b60af7;674e8f48ec54f17a87b8125f;674e8db9ec54f17a87b626ed;674e8d85ec54f17a87b5f692;674e8e86ec54f17a87b710bd;674e90a1ec54f17a87b9e89f;674e902fec54f17a87b933db;674e9095ec54f17a87b9d820;674e8ec7ec54f17a87b7630d;674e9122ec54f17a87ba7091;674e91d0ec54f17a87bb0c17;674e8e89ec54f17a87b7140d;674e8d50ec54f17a87b5c2b3;674e8f27ec54f17a87b7e654;674e9200ec54f17a87bb3250;674e900eec54f17a87b90b8c;674e90aeec54f17a87b9fa8a;674e8f94ec54f17a87b873d3;674e8d9cec54f17a87b60c2f;674e9123ec54f17a87ba7193;674e91eeec54f17a87bb2482;674e8d73ec54f17a87b5e434;674e9193ec54f17a87bad9c5;674e8e5cec54f17a87b6d9b4;674e8f4cec54f17a87b8162d;674e8d38ec54f17a87b5abff;674e916eec54f17a87bab53e;674e8e78ec54f17a87b6fea7;674e8fc3ec54f17a87b8aeaf;674e8f3aec54f17a87b7ff0b;674e8fddec54f17a87b8d072;674e901dec54f17a87b91e88;674e8f7cec54f17a87b85434;674e8f25ec54f17a87b7e41a;674e8effec54f17a87b7aa0f;674e8e3aec54f17a87b6a48a;674e8ebcec54f17a87b75575;674e9000ec54f17a87b8faba;674e90eeec54f17a87ba413c;674e90a4ec54f17a87b9ed99",
        },
        {
          value: "sensor",
          count: 98,
          keywordIds:
            "674e8d1bec54f17a87b58ef7;674e8eecec54f17a87b7923a;674e8e93ec54f17a87b72051;674e8fe3ec54f17a87b8d70e;674e8e83ec54f17a87b70caa;674e8f25ec54f17a87b7e3bd;674e8d28ec54f17a87b59c6a;674e8eacec54f17a87b73fc8;674e8d2dec54f17a87b5a189;674e9094ec54f17a87b9d65f;674e8e77ec54f17a87b6fd52;674e90dbec54f17a87ba2fca;674e8dbcec54f17a87b62964;674e90bfec54f17a87ba1316;674e8fb8ec54f17a87b8a1fc;674e8f86ec54f17a87b8611b;674e9052ec54f17a87b96890;674e8ea0ec54f17a87b73126;674e8f79ec54f17a87b84ea6;674e8fd4ec54f17a87b8c5dd;674e8e3cec54f17a87b6a70f;674e8e8eec54f17a87b71a94;674e8e06ec54f17a87b67253;674e8e7dec54f17a87b704ea;674e8d70ec54f17a87b5e10c;674e8f61ec54f17a87b8309b;674e8d7fec54f17a87b5f102;674e8f2dec54f17a87b7edd3;674e91d8ec54f17a87bb1253;674e8f06ec54f17a87b7b3a0;674e9056ec54f17a87b96fc3;674e8ebfec54f17a87b7596f;674e8da8ec54f17a87b61716;674e8ed2ec54f17a87b77029;674e9109ec54f17a87ba5b1f;674e8fd3ec54f17a87b8c38d;674e8e34ec54f17a87b69ef3;674e904dec54f17a87b959fe;674e914aec54f17a87ba93ec;674e8fc8ec54f17a87b8b6ee;674e8d20ec54f17a87b5943a;674e8efcec54f17a87b7a641;674e911cec54f17a87ba6b73;674e8f82ec54f17a87b85bff;674e907eec54f17a87b9b5bf;674e8e47ec54f17a87b6b139;674e8e65ec54f17a87b6e5f0;674e909cec54f17a87b9e138;674e9076ec54f17a87b9a916;674e8f46ec54f17a87b80e43;674e9125ec54f17a87ba73ae;674e8f51ec54f17a87b81d64;674e912fec54f17a87ba7cdb;674e8f52ec54f17a87b81de6;674e906aec54f17a87b99512;674e8ff5ec54f17a87b8edb8;674e9094ec54f17a87b9d648;674e8e14ec54f17a87b68063;674e8e88ec54f17a87b713d5;674e8eb3ec54f17a87b749de;674e8e59ec54f17a87b6d617;674e8f70ec54f17a87b84360;674e8ff2ec54f17a87b8ea32;674e91d6ec54f17a87bb10c7;674e8ea3ec54f17a87b73485;674e8fabec54f17a87b890ad;674e8f13ec54f17a87b7c48d;674e8f56ec54f17a87b82362;674e8f4cec54f17a87b816e3;674e916aec54f17a87bab139;674e916fec54f17a87bab5dc;674e8edfec54f17a87b780cf;674e90deec54f17a87ba32bf;674e8e08ec54f17a87b674b4;674e8e02ec54f17a87b66e29;674e8e99ec54f17a87b728ce;674e90a4ec54f17a87b9ee36;674e9038ec54f17a87b93ed3;674e8effec54f17a87b7aa96;674e8fc9ec54f17a87b8b728",
        },
        {
          value: "back-end",
          count: 96,
          keywordIds:
            "674e8d6bec54f17a87b5db7a;674e903cec54f17a87b94486;674e8fbaec54f17a87b8a3fe;674e8ddbec54f17a87b645a6;674e9066ec54f17a87b98cf3;674e904fec54f17a87b96284;674e8df1ec54f17a87b6587a;674e8f70ec54f17a87b84415;674e8eb0ec54f17a87b7456c;674e8e6dec54f17a87b6f0b6;674e912aec54f17a87ba7812;674e8fb8ec54f17a87b8a279;674e8f00ec54f17a87b7ac1b;674e8cfcec54f17a87b56f52;674e8f79ec54f17a87b84f26;674e8db4ec54f17a87b621dd;674e8f21ec54f17a87b7d89d;674e90a6ec54f17a87b9efd1;674e90aeec54f17a87b9fb63;674e8ef9ec54f17a87b7a29a;674e90b0ec54f17a87b9fd6a;674e9102ec54f17a87ba55a7;674e8f33ec54f17a87b7f6c5;674e8fe8ec54f17a87b8ddf0;674e8fdfec54f17a87b8d2dd;674e8fd9ec54f17a87b8caee;674e8ecbec54f17a87b767bd;674e8ee3ec54f17a87b78615;674e8e6dec54f17a87b6f16b;674e8f7bec54f17a87b852fb;674e8ffdec54f17a87b8f6d4;674e8e34ec54f17a87b69eab;674e8d30ec54f17a87b5a415;674e8e63ec54f17a87b6e3f7;674e9032ec54f17a87b93873;674e9073ec54f17a87b9a54c;674e8fcdec54f17a87b8bc07;674e8d34ec54f17a87b5a74d;674e8f29ec54f17a87b7e94b;674e8d8bec54f17a87b5fc23;674e8eebec54f17a87b79176;674e8dfeec54f17a87b6699e;674e8d8aec54f17a87b5fab5;674e9076ec54f17a87b9a9a8;674e8d5bec54f17a87b5ccef;674e9157ec54f17a87baa12a;674e9205ec54f17a87bb36d1;674e8e9aec54f17a87b72a07;674e8efdec54f17a87b7a82b;674e8e82ec54f17a87b70c0c;674e8e5fec54f17a87b6ddb8;674e908eec54f17a87b9cd89;674e9004ec54f17a87b8fff6;674e8f57ec54f17a87b8243c;674e8efcec54f17a87b7a73e;674e8f27ec54f17a87b7e67f;674e90adec54f17a87b9f9a3;674e9043ec54f17a87b94ce5;674e903aec54f17a87b94130;674e8ecfec54f17a87b76ccb;674e9191ec54f17a87bad847;674e8d38ec54f17a87b5ab76;674e90d4ec54f17a87ba2873;674e8d13ec54f17a87b5860e;674e8d76ec54f17a87b5e794;674e90beec54f17a87ba1139;674e9054ec54f17a87b96b2c;674e9041ec54f17a87b94aae;674e8e78ec54f17a87b6ff3d;674e8e16ec54f17a87b681c1;674e8ea5ec54f17a87b7379d;674e9190ec54f17a87bad769;674e8f1dec54f17a87b7d242;674e8de1ec54f17a87b64a69;674e9038ec54f17a87b93f85;674e906dec54f17a87b998c0;674e8eadec54f17a87b7414b;674e90d0ec54f17a87ba251c",
        },
        {
          value: "bus",
          count: 95,
          keywordIds:
            "674e8e91ec54f17a87b71dce;674e8ec2ec54f17a87b75c66;674e9065ec54f17a87b98cb1;674e8fe1ec54f17a87b8d568;674e8d2dec54f17a87b5a160;674e9094ec54f17a87b9d639;674e8ef5ec54f17a87b79deb;674e8fd6ec54f17a87b8c88e;674e8db4ec54f17a87b6224b;674e8eaeec54f17a87b742c0;674e8e98ec54f17a87b7274b;674e8fcdec54f17a87b8bc33;674e8e07ec54f17a87b6735e;674e9203ec54f17a87bb34ca;674e8ff5ec54f17a87b8ee26;674e90f9ec54f17a87ba4bc1;674e9060ec54f17a87b98327;674e8ef8ec54f17a87b7a267;674e9027ec54f17a87b92a29;674e8f1eec54f17a87b7d45e;674e90afec54f17a87b9fc9d;674e9129ec54f17a87ba773b;674e910eec54f17a87ba5f84;674e8dfbec54f17a87b666ce;674e8f19ec54f17a87b7ccbb;674e8dc9ec54f17a87b6359d;674e8f4bec54f17a87b8157f;674e8e6aec54f17a87b6ec1c;674e8e1cec54f17a87b688ce;674e8e34ec54f17a87b69f24;674e8e9cec54f17a87b72c0d;674e9149ec54f17a87ba934e;674e900bec54f17a87b907e3;674e8e64ec54f17a87b6e47d;674e9082ec54f17a87b9bbd6;674e8ec4ec54f17a87b75f0f;674e911cec54f17a87ba6c22;674e8e27ec54f17a87b69328;674e9135ec54f17a87ba819a;674e8fe7ec54f17a87b8dc22;674e90a8ec54f17a87b9f303;674e8cf8ec54f17a87b56b88;674e9149ec54f17a87ba92ce;674e8e9bec54f17a87b72b5b;674e8cf6ec54f17a87b569d8;674e908eec54f17a87b9ce8f;674e9111ec54f17a87ba626b;674e8d27ec54f17a87b59aa7;674e8e66ec54f17a87b6e6f6;674e8e5aec54f17a87b6d75b;674e9026ec54f17a87b929aa;674e8f47ec54f17a87b8104f;674e91b8ec54f17a87baf919;674e9006ec54f17a87b902b6;674e8e5aec54f17a87b6d71e;674e8e8aec54f17a87b71603;674e8eb4ec54f17a87b74b53;674e8e3bec54f17a87b6a590;674e907eec54f17a87b9b68a;674e8f5dec54f17a87b82c6e;674e9081ec54f17a87b9ba9d;674e8eefec54f17a87b79600;674e8d76ec54f17a87b5e7ca;674e9054ec54f17a87b96c36;674e8e16ec54f17a87b68231;674e91e9ec54f17a87bb2096;674e8e67ec54f17a87b6e88a;674e8e99ec54f17a87b727d4;674e8fdeec54f17a87b8d14f;674e8fbcec54f17a87b8a619;674e8d2fec54f17a87b5a2a2;674e8f99ec54f17a87b87a81;674e8de0ec54f17a87b64a30;674e8ed7ec54f17a87b77700;674e9115ec54f17a87ba6638;674e8fa0ec54f17a87b883cf;674e8de4ec54f17a87b64d6e;674e909cec54f17a87b9e21d;674e91b5ec54f17a87baf6d2;674e91e4ec54f17a87bb1d3e;674e8e4bec54f17a87b6b4c7",
        },
        {
          value: "index",
          count: 93,
          keywordIds:
            "674e8eebec54f17a87b79100;674e8f0eec54f17a87b7bf12;674e9087ec54f17a87b9c406;674e8eeaec54f17a87b78fd4;674e8f44ec54f17a87b80cf4;674e8f94ec54f17a87b873b1;674e8e96ec54f17a87b72517;674e8f21ec54f17a87b7d88e;674e9069ec54f17a87b991ec;674e91c5ec54f17a87bb0404;674e8f57ec54f17a87b824da;674e90bfec54f17a87ba1260;674e90bbec54f17a87ba0ccf;674e8ea0ec54f17a87b73104;674e9178ec54f17a87babe0a;674e8fd6ec54f17a87b8c804;674e8d21ec54f17a87b594bb;674e91c2ec54f17a87bb00e4;674e9144ec54f17a87ba8f24;674e8e20ec54f17a87b68bfb;674e8e07ec54f17a87b6727f;674e903bec54f17a87b94296;674e8d70ec54f17a87b5e0ac;674e8d2aec54f17a87b59e58;674e8f60ec54f17a87b82f82;674e9064ec54f17a87b989ea;674e8f71ec54f17a87b84501;674e8fa9ec54f17a87b88e5f;674e91d8ec54f17a87bb1237;674e91a8ec54f17a87baeaa9;674e8dfcec54f17a87b667c9;674e8e95ec54f17a87b72326;674e8daeec54f17a87b61cf7;674e8f32ec54f17a87b7f580;674e8dc9ec54f17a87b63566;674e8d07ec54f17a87b57aa1;674e9074ec54f17a87b9a711;674e9053ec54f17a87b96a06;674e8f5aec54f17a87b8289a;674e8ec4ec54f17a87b75e96;674e8e73ec54f17a87b6f890;674e8f12ec54f17a87b7c40d;674e8d8bec54f17a87b5fc02;674e8f73ec54f17a87b84716;674e8dadec54f17a87b61b56;674e9018ec54f17a87b918cf;674e8ec0ec54f17a87b75aae;674e8e8bec54f17a87b7170f;674e9076ec54f17a87b9a95f;674e8f8cec54f17a87b868f4;674e8dbfec54f17a87b62cda;674e8dcdec54f17a87b6388b;674e8fd0ec54f17a87b8bff4;674e8ecfec54f17a87b76c90;674e8d05ec54f17a87b578a1;674e8f14ec54f17a87b7c6d6;674e8fefec54f17a87b8e55c;674e91cfec54f17a87bb0ba6;674e8e89ec54f17a87b714d1;674e8f67ec54f17a87b83827;674e8d3fec54f17a87b5b2a3;674e8fc5ec54f17a87b8b230;674e8d42ec54f17a87b5b57a;674e8f4dec54f17a87b817c4;674e8f97ec54f17a87b87847;674e8f9aec54f17a87b87c5c;674e91f1ec54f17a87bb271c;674e9041ec54f17a87b94a58;674e8e38ec54f17a87b6a2a9;674e8da6ec54f17a87b61526;674e91ebec54f17a87bb2282;674e8f38ec54f17a87b7fcf9;674e915fec54f17a87baa8c6;674e909eec54f17a87b9e44d;674e8f01ec54f17a87b7ade0;674e8dfaec54f17a87b6643f;674e8e24ec54f17a87b68f42;674e8f1fec54f17a87b7d672;674e8d18ec54f17a87b58c82",
        },
        {
          value: "calculate",
          count: 90,
          keywordIds:
            "674e8e0dec54f17a87b6796c;674e8e9eec54f17a87b72f04;674e905aec54f17a87b978ba;674e904aec54f17a87b95629;674e8eccec54f17a87b7688f;674e8ef5ec54f17a87b79e1c;674e9009ec54f17a87b9056c;674e917eec54f17a87bac7fd;674e8e35ec54f17a87b6a065;674e9067ec54f17a87b98e77;674e8d1eec54f17a87b591a5;674e9194ec54f17a87bada86;674e8e85ec54f17a87b70f89;674e8ff5ec54f17a87b8ed3f;674e8ed8ec54f17a87b7783b;674e9163ec54f17a87baab4d;674e9033ec54f17a87b938c7;674e8e03ec54f17a87b66ef3;674e902bec54f17a87b92f8f;674e90b2ec54f17a87ba00c2;674e8f4aec54f17a87b814db;674e8d55ec54f17a87b5c79c;674e8fc0ec54f17a87b8abed;674e8e88ec54f17a87b712d7;674e8f24ec54f17a87b7e207;674e8fc8ec54f17a87b8b65c;674e9030ec54f17a87b934fe;674e8d49ec54f17a87b5bc7c;674e8fe0ec54f17a87b8d426;674e8f2eec54f17a87b7f020;674e8fc9ec54f17a87b8b779;674e8f0cec54f17a87b7bb44;674e905dec54f17a87b97e2d;674e902aec54f17a87b92e92;674e8ed5ec54f17a87b774ab;674e9017ec54f17a87b91659;674e9147ec54f17a87ba917c;674e8f60ec54f17a87b8300d;674e90b1ec54f17a87b9ffbd;674e8d74ec54f17a87b5e5f7;674e8f6fec54f17a87b842a4;674e8f59ec54f17a87b827a4;674e8ee8ec54f17a87b78cc2;674e8e5bec54f17a87b6d8da;674e8e0aec54f17a87b675c8;674e908eec54f17a87b9cd52;674e8d6eec54f17a87b5de97;674e9115ec54f17a87ba6579;674e9020ec54f17a87b921ba;674e8d42ec54f17a87b5b508;674e90f7ec54f17a87ba4a23;674e9016ec54f17a87b9153a;674e91b2ec54f17a87baf330;674e8ff2ec54f17a87b8e957;674e8f34ec54f17a87b7f7e9;674e9169ec54f17a87bab082;674e8fb8ec54f17a87b8a1b3;674e8dddec54f17a87b64746;674e8efeec54f17a87b7a9a1;674e8d78ec54f17a87b5e9e5;674e8ee6ec54f17a87b78a8d;674e8e69ec54f17a87b6eb70;674e8efaec54f17a87b7a3c6;674e903cec54f17a87b943b0;674e8e4eec54f17a87b6b7bf;674e8d2eec54f17a87b5a247;674e8dc6ec54f17a87b632bb;674e8deaec54f17a87b652cb;674e8ecdec54f17a87b769c3;674e8e56ec54f17a87b6c04e;674e905bec54f17a87b978e0;674e8ed6ec54f17a87b77564",
        },
        {
          value: "compress",
          count: 88,
          keywordIds:
            "674e9072ec54f17a87b9a1cf;674e90b5ec54f17a87ba0503;674e8ef0ec54f17a87b797de;674e8f7fec54f17a87b85813;674e90b6ec54f17a87ba0600;674e8df1ec54f17a87b6585a;674e90feec54f17a87ba5163;674e8e5eec54f17a87b6dd53;674e8f92ec54f17a87b8719c;674e9052ec54f17a87b966ed;674e8f6dec54f17a87b83f1b;674e9015ec54f17a87b914d1;674e9031ec54f17a87b93696;674e8e72ec54f17a87b6f781;674e8e75ec54f17a87b6fa3e;674e8ef0ec54f17a87b797b0;674e8ff2ec54f17a87b8ea07;674e8fc6ec54f17a87b8b345;674e911aec54f17a87ba69c2;674e8d9dec54f17a87b60cd0;674e904fec54f17a87b95e24;674e8e6fec54f17a87b6f2c6;674e8d15ec54f17a87b5881b;674e8ff8ec54f17a87b8f0f1;674e90d5ec54f17a87ba2949;674e8f78ec54f17a87b84d51;674e9170ec54f17a87bab69b;674e8e63ec54f17a87b6e3c8;674e8d1dec54f17a87b5905d;674e8dfeec54f17a87b66951;674e8ef9ec54f17a87b7a37d;674e8d8dec54f17a87b5fd98;674e8e8aec54f17a87b7167c;674e8d52ec54f17a87b5c41c;674e9132ec54f17a87ba7f9d;674e9017ec54f17a87b91707;674e9125ec54f17a87ba732c;674e8e95ec54f17a87b72333;674e8f6fec54f17a87b84202;674e90e5ec54f17a87ba38cb;674e8d4aec54f17a87b5bda5;674e8f53ec54f17a87b81f5d;674e9011ec54f17a87b90f3f;674e8e14ec54f17a87b67fdf;674e8ec4ec54f17a87b75ed4;674e8d26ec54f17a87b599b9;674e90a0ec54f17a87b9e6fa;674e90acec54f17a87b9f880;674e91b8ec54f17a87baf8e8;674e8feaec54f17a87b8dfb9;674e8f6aec54f17a87b83b9b;674e8e1aec54f17a87b68601;674e8eb0ec54f17a87b745f7;674e8e81ec54f17a87b70a61;674e907eec54f17a87b9b6be;674e9081ec54f17a87b9ba57;674e8d14ec54f17a87b586c2;674e8ee7ec54f17a87b78bfb;674e8f8cec54f17a87b86908;674e9054ec54f17a87b96aed;674e8f8bec54f17a87b867b5;674e8fe7ec54f17a87b8dba9;674e8fc7ec54f17a87b8b48f;674e8e28ec54f17a87b693df;674e8fa7ec54f17a87b88c4e;674e8ddaec54f17a87b64410;674e90abec54f17a87b9f762;674e8d3bec54f17a87b5aed6;674e8df3ec54f17a87b659f9;674e912bec54f17a87ba78ee;674e9161ec54f17a87baaa2e;674e906eec54f17a87b99beb;674e913cec54f17a87ba8778",
        },
        {
          value: "connect",
          count: 88,
          keywordIds:
            "674e8fe3ec54f17a87b8d779;674e8f0bec54f17a87b7ba4e;674e8ddbec54f17a87b6455c;674e9183ec54f17a87baccf7;674e8fe1ec54f17a87b8d466;674e8e2eec54f17a87b698ef;674e8f86ec54f17a87b860db;674e8f70ec54f17a87b843e4;674e9094ec54f17a87b9d5ec;674e8dc8ec54f17a87b63413;674e9074ec54f17a87b9a5bf;674e8f1cec54f17a87b7d160;674e8eb5ec54f17a87b74cbb;674e8d8eec54f17a87b5fe70;674e8e3fec54f17a87b6a903;674e9044ec54f17a87b94e42;674e91b0ec54f17a87baf1a3;674e8f83ec54f17a87b85d22;674e91c4ec54f17a87bb0301;674e8fc5ec54f17a87b8b276;674e8ee8ec54f17a87b78cf7;674e8dd5ec54f17a87b63fb8;674e8eb4ec54f17a87b74b5f;674e8fffec54f17a87b8f928;674e8f05ec54f17a87b7b27a;674e8eddec54f17a87b77ef2;674e8eb8ec54f17a87b75041;674e9066ec54f17a87b98de3;674e8ed1ec54f17a87b76ee1;674e9152ec54f17a87ba9baf;674e900eec54f17a87b90b61;674e906aec54f17a87b994d3;674e8e7bec54f17a87b701dd;674e9075ec54f17a87b9a8c2;674e8eedec54f17a87b792fe;674e90f3ec54f17a87ba4684;674e8d00ec54f17a87b57336;674e8e0bec54f17a87b6775a;674e9086ec54f17a87b9c179;674e911cec54f17a87ba6b8e;674e8ee1ec54f17a87b78494;674e8dacec54f17a87b61ae6;674e8ee0ec54f17a87b78226;674e914cec54f17a87ba95ae;674e9090ec54f17a87b9d131;674e90ccec54f17a87ba208a;674e8f46ec54f17a87b80e68;674e8facec54f17a87b89304;674e903aec54f17a87b9420b;674e8ebbec54f17a87b753f6;674e8ec2ec54f17a87b75d77;674e906dec54f17a87b999b3;674e8f2dec54f17a87b7eeb5;674e8e82ec54f17a87b70bd2;674e910fec54f17a87ba60a2;674e8e65ec54f17a87b6e5d7;674e8eb2ec54f17a87b7485c;674e90a0ec54f17a87b9e7d5;674e8f00ec54f17a87b7abea;674e8d1aec54f17a87b58dd7;674e8dbdec54f17a87b62ab1;674e8f52ec54f17a87b81f07;674e8f4dec54f17a87b818b0;674e9143ec54f17a87ba8d90;674e8d6cec54f17a87b5dce4;674e9192ec54f17a87bad89c;674e8fd1ec54f17a87b8c18b;674e906dec54f17a87b99893;674e8eb7ec54f17a87b74e4c;674e8eceec54f17a87b76aa7;674e8d5eec54f17a87b5cf3e;674e8e08ec54f17a87b67456;674e9060ec54f17a87b982e5;674e901fec54f17a87b9206a;674e90e9ec54f17a87ba3cc0;674e90b8ec54f17a87ba091b;674e8e56ec54f17a87b6bfba;674e8f09ec54f17a87b7b740;674e8fa1ec54f17a87b884df;674e8e4aec54f17a87b6b3b6",
        },
        {
          value: "parse",
          count: 88,
          keywordIds:
            "674e8d1bec54f17a87b58e9b;674e8f68ec54f17a87b83a11;674e8d4eec54f17a87b5c12f;674e8f6bec54f17a87b83d6e;674e8f49ec54f17a87b812c3;674e8e75ec54f17a87b6fa2e;674e901fec54f17a87b920d4;674e8f0eec54f17a87b7beca;674e8f9dec54f17a87b87fbd;674e8e91ec54f17a87b71e0e;674e8f68ec54f17a87b83a00;674e91c2ec54f17a87bb013d;674e90aeec54f17a87b9fb21;674e9139ec54f17a87ba852e;674e8ef7ec54f17a87b79fbd;674e8f3bec54f17a87b800d7;674e9070ec54f17a87b99e09;674e8f37ec54f17a87b7fb4c;674e90f9ec54f17a87ba4b9b;674e8e85ec54f17a87b7102a;674e8d2bec54f17a87b59eda;674e8fedec54f17a87b8e351;674e8f33ec54f17a87b7f5f8;674e8f9bec54f17a87b87ca1;674e9050ec54f17a87b9643c;674e8f1dec54f17a87b7d33d;674e91a3ec54f17a87bae683;674e91baec54f17a87bafad6;674e8d33ec54f17a87b5a6f4;674e9198ec54f17a87badd84;674e8e27ec54f17a87b69226;674e8ea4ec54f17a87b73622;674e90fbec54f17a87ba4e20;674e8e86ec54f17a87b71112;674e8f73ec54f17a87b847e4;674e8f0bec54f17a87b7ba00;674e8eeeec54f17a87b794b6;674e8f81ec54f17a87b859ba;674e8ec9ec54f17a87b764b4;674e8d5bec54f17a87b5cd53;674e9148ec54f17a87ba9262;674e8f51ec54f17a87b81d15;674e8e9aec54f17a87b72994;674e8f09ec54f17a87b7b876;674e8e79ec54f17a87b6ff48;674e8ff5ec54f17a87b8ed3a;674e9083ec54f17a87b9bdf1;674e8f1aec54f17a87b7cea1;674e9058ec54f17a87b972b1;674e90eeec54f17a87ba41b5;674e90d8ec54f17a87ba2d41;674e8d3aec54f17a87b5adb7;674e8e05ec54f17a87b67114;674e8f3dec54f17a87b8036e;674e8fffec54f17a87b8f959;674e8faeec54f17a87b894b4;674e8eb0ec54f17a87b746a9;674e8e3bec54f17a87b6a56f;674e8d38ec54f17a87b5ab46;674e8f23ec54f17a87b7db25;674e90f0ec54f17a87ba433b;674e8f12ec54f17a87b7c402;674e8e62ec54f17a87b6e276;674e8f2eec54f17a87b7ef00;674e8ee7ec54f17a87b78b74;674e8e1fec54f17a87b68b01;674e8fe7ec54f17a87b8dc46;674e90b4ec54f17a87ba02dc;674e9133ec54f17a87ba8006;674e900aec54f17a87b9067c;674e8d18ec54f17a87b58b78",
        },
        {
          value: "1080p",
          count: 88,
          keywordIds:
            "674e8e13ec54f17a87b67f27;674e9010ec54f17a87b90ecb;674e8f22ec54f17a87b7da88;674e90c3ec54f17a87ba1745;674e8fdaec54f17a87b8cc1f;674e8ea8ec54f17a87b73be1;674e907fec54f17a87b9b7f6;674e8eaeec54f17a87b74306;674e907fec54f17a87b9b783;674e9139ec54f17a87ba84a2;674e919eec54f17a87bae1fc;674e8fecec54f17a87b8e27d;674e8e85ec54f17a87b70fc0;674e91afec54f17a87baf069;674e8ff2ec54f17a87b8ea44;674e8d87ec54f17a87b5f8ac;674e908fec54f17a87b9cf29;674e8fa9ec54f17a87b88ea4;674e9182ec54f17a87bacb21;674e8dc3ec54f17a87b63050;674e8ee3ec54f17a87b7870e;674e8f9fec54f17a87b882c7;674e8e94ec54f17a87b721b0;674e8f84ec54f17a87b85eda;674e9165ec54f17a87baad11;674e8eedec54f17a87b793b7;674e914aec54f17a87ba93bc;674e8f77ec54f17a87b84c46;674e8ec4ec54f17a87b75ec3;674e91d9ec54f17a87bb134b;674e8ea4ec54f17a87b73648;674e8ef4ec54f17a87b79c53;674e905cec54f17a87b97bc6;674e8e82ec54f17a87b70bb1;674e8e92ec54f17a87b71fa9;674e8d5bec54f17a87b5cd73;674e8f55ec54f17a87b822e0;674e8e54ec54f17a87b6bd4e;674e8ec3ec54f17a87b75daf;674e8f7bec54f17a87b852e7;674e8ee8ec54f17a87b78cea;674e8d81ec54f17a87b5f2ab;674e8ef7ec54f17a87b7a049;674e8e94ec54f17a87b721bf;674e9093ec54f17a87b9d563;674e905eec54f17a87b97f80;674e8f85ec54f17a87b85f91;674e90d8ec54f17a87ba2ceb;674e9033ec54f17a87b93993;674e8eb2ec54f17a87b748cf;674e8f7dec54f17a87b855bf;674e8e8eec54f17a87b71b0a;674e8f17ec54f17a87b7c9e0;674e8e1aec54f17a87b6862c;674e8f19ec54f17a87b7cde4;674e8f20ec54f17a87b7d77a;674e907fec54f17a87b9b6fc;674e9028ec54f17a87b92b46;674e90b3ec54f17a87ba01ec;674e9185ec54f17a87bace77;674e8f54ec54f17a87b8210f;674e9024ec54f17a87b9265f;674e8f82ec54f17a87b85b92;674e8e69ec54f17a87b6eba9;674e8f8aec54f17a87b8664e;674e8f02ec54f17a87b7ae18;674e8e4eec54f17a87b6b808;674e8ff0ec54f17a87b8e726;674e90abec54f17a87b9f799;674e8e70ec54f17a87b6f51f;674e8eafec54f17a87b7448d;674e91b5ec54f17a87baf681;674e8fc9ec54f17a87b8b7ff",
        },
        {
          value: "hack",
          count: 87,
          keywordIds:
            "674e8fe2ec54f17a87b8d6bd;674e903cec54f17a87b94459;674e8ec1ec54f17a87b75c39;674e9100ec54f17a87ba5322;674e8eeaec54f17a87b78f6a;674e8f7fec54f17a87b85719;674e907bec54f17a87b9b245;674e8ff4ec54f17a87b8ec68;674e8e6dec54f17a87b6f079;674e90dbec54f17a87ba2f3f;674e8ef5ec54f17a87b79d5e;674e906bec54f17a87b9966a;674e8db4ec54f17a87b621ba;674e8f05ec54f17a87b7b242;674e91c9ec54f17a87bb06c5;674e8f3aec54f17a87b80025;674e9159ec54f17a87baa3a1;674e907aec54f17a87b9aff7;674e918bec54f17a87bad341;674e8d7fec54f17a87b5f0ba;674e8ed1ec54f17a87b76fba;674e8db7ec54f17a87b6252e;674e9055ec54f17a87b96ce7;674e8cf9ec54f17a87b56c35;674e8f0aec54f17a87b7b8fd;674e908bec54f17a87b9c8a6;674e8e34ec54f17a87b69e5a;674e8fb2ec54f17a87b899da;674e900aec54f17a87b9074e;674e8ea1ec54f17a87b7321e;674e8f9dec54f17a87b87fb2;674e900cec54f17a87b9096d;674e9188ec54f17a87bad05e;674e8e71ec54f17a87b6f59e;674e8ef4ec54f17a87b79c3a;674e8eebec54f17a87b7913e;674e8d82ec54f17a87b5f3ed;674e8cf7ec54f17a87b56a90;674e8f49ec54f17a87b812f5;674e9007ec54f17a87b9032f;674e8dbfec54f17a87b62c9b;674e9007ec54f17a87b903cd;674e917cec54f17a87bac690;674e8dafec54f17a87b61db5;674e904dec54f17a87b95b25;674e8faeec54f17a87b894a8;674e8ff5ec54f17a87b8eddd;674e8f48ec54f17a87b811ec;674e8e05ec54f17a87b67094;674e8d47ec54f17a87b5bac6;674e9167ec54f17a87baae81;674e8f20ec54f17a87b7d738;674e9155ec54f17a87ba9ecd;674e8d73ec54f17a87b5e4c1;674e8fbaec54f17a87b8a3d5;674e8f99ec54f17a87b87b25;674e8e4fec54f17a87b6b950;674e90beec54f17a87ba10eb;674e8db5ec54f17a87b62350;674e8e63ec54f17a87b6e42e;674e8ec5ec54f17a87b760e0;674e8fc7ec54f17a87b8b457;674e9059ec54f17a87b97614;674e8ee3ec54f17a87b785ed;674e8fa6ec54f17a87b88b50;674e90a9ec54f17a87b9f523;674e9051ec54f17a87b9653e;674e8ed9ec54f17a87b779a8;674e8e48ec54f17a87b6b1e7;674e8eb1ec54f17a87b74800;674e91b5ec54f17a87baf65e;674e9000ec54f17a87b8fb58",
        },
        {
          value: "bypass",
          count: 85,
          keywordIds:
            "674e9199ec54f17a87badea7;674e8e83ec54f17a87b70c7a;674e8e37ec54f17a87b6a1f9;674e8f0dec54f17a87b7bd4b;674e904cec54f17a87b9593d;674e8d2cec54f17a87b5a0b4;674e8ecdec54f17a87b76961;674e9129ec54f17a87ba77f0;674e8d47ec54f17a87b5ba10;674e8fbbec54f17a87b8a5a6;674e8f58ec54f17a87b825d6;674e8cfcec54f17a87b56ebc;674e8f3cec54f17a87b8017d;674e8ec8ec54f17a87b763fe;674e9012ec54f17a87b9119b;674e8eacec54f17a87b73f83;674e9042ec54f17a87b94c13;674e8d5fec54f17a87b5d0bb;674e8e98ec54f17a87b7268e;674e8f8fec54f17a87b86d12;674e8d23ec54f17a87b59749;674e9001ec54f17a87b8fcc3;674e9072ec54f17a87b9a31a;674e90e1ec54f17a87ba3546;674e8d90ec54f17a87b60019;674e9089ec54f17a87b9c649;674e8fb3ec54f17a87b89add;674e8fffec54f17a87b8fa29;674e902bec54f17a87b92f15;674e8f9fec54f17a87b882ab;674e8f3aec54f17a87b8001a;674e8ffdec54f17a87b8f7c6;674e8f64ec54f17a87b83469;674e9057ec54f17a87b971a6;674e8ec5ec54f17a87b760db;674e8e82ec54f17a87b70b43;674e9075ec54f17a87b9a895;674e8fcfec54f17a87b8bfb5;674e8f09ec54f17a87b7b79a;674e8ea7ec54f17a87b7395a;674e8fefec54f17a87b8e607;674e8e68ec54f17a87b6e962;674e8ef7ec54f17a87b7a011;674e8da0ec54f17a87b6103d;674e909dec54f17a87b9e2b8;674e9158ec54f17a87baa315;674e8f71ec54f17a87b84527;674e8f62ec54f17a87b831b2;674e8f3eec54f17a87b80432;674e8e8aec54f17a87b71644;674e90f8ec54f17a87ba4ad8;674e8ecfec54f17a87b76c7b;674e8f19ec54f17a87b7cd0c;674e8fb0ec54f17a87b89746;674e8f3dec54f17a87b80385;674e8d25ec54f17a87b59945;674e8dccec54f17a87b63780;674e8fb7ec54f17a87b8a0ff;674e8edeec54f17a87b78058;674e8fc4ec54f17a87b8b008;674e8f50ec54f17a87b81bf2;674e8f37ec54f17a87b7fc67;674e9190ec54f17a87bad738;674e8f40ec54f17a87b8074f;674e8ea4ec54f17a87b73557;674e8e60ec54f17a87b6dfc8;674e8f7dec54f17a87b85508;674e8f73ec54f17a87b8477b;674e8fa0ec54f17a87b88362",
        },
        {
          value: "open-source",
          count: 84,
          keywordIds:
            "674e9039ec54f17a87b9410b;674e8e90ec54f17a87b71d95;674e8e92ec54f17a87b71fe9;674e8e83ec54f17a87b70d22;674e8fa4ec54f17a87b8885e;674e8feaec54f17a87b8df22;674e8e33ec54f17a87b69dbd;674e9031ec54f17a87b9364e;674e8f6fec54f17a87b84221;674e8eaaec54f17a87b73ea8;674e8d59ec54f17a87b5cbad;674e8e5eec54f17a87b6dc75;674e8d1eec54f17a87b59283;674e9044ec54f17a87b94e34;674e91b0ec54f17a87baf208;674e8ee9ec54f17a87b78def;674e8d7eec54f17a87b5f043;674e8fedec54f17a87b8e43b;674e8f5cec54f17a87b82af1;674e90a8ec54f17a87b9f40d;674e91c7ec54f17a87bb0555;674e8fd2ec54f17a87b8c285;674e8e9bec54f17a87b72bdd;674e8f08ec54f17a87b7b5ad;674e8d44ec54f17a87b5b6ba;674e8e0bec54f17a87b6779b;674e9069ec54f17a87b99215;674e8f82ec54f17a87b85b86;674e8e10ec54f17a87b67ba3;674e8f0cec54f17a87b7bc93;674e8fb6ec54f17a87b89ff8;674e8d9aec54f17a87b60992;674e91e3ec54f17a87bb1c4a;674e904eec54f17a87b95bd9;674e9176ec54f17a87babb98;674e8ed5ec54f17a87b7743b;674e8facec54f17a87b8933a;674e9007ec54f17a87b90413;674e8f30ec54f17a87b7f2af;674e8e95ec54f17a87b7236d;674e8d75ec54f17a87b5e61a;674e8f16ec54f17a87b7c91d;674e8ec4ec54f17a87b75f1b;674e8f43ec54f17a87b80b09;674e8e5dec54f17a87b6dbee;674e8d1aec54f17a87b58e02;674e91b8ec54f17a87baf900;674e9035ec54f17a87b93b35;674e8fe9ec54f17a87b8deff;674e8ff9ec54f17a87b8f262;674e8eceec54f17a87b76b5f;674e9006ec54f17a87b901bb;674e8f42ec54f17a87b80976;674e8ff2ec54f17a87b8ea6a;674e91efec54f17a87bb2536;674e8d0dec54f17a87b5803e;674e8e4fec54f17a87b6b96e;674e8faeec54f17a87b895c2;674e8e77ec54f17a87b6fd34;674e8fe7ec54f17a87b8dbe4;674e8ee5ec54f17a87b78a01;674e8f34ec54f17a87b7f709;674e8e67ec54f17a87b6e802;674e903cec54f17a87b943df;674e8e28ec54f17a87b69406;674e8f28ec54f17a87b7e799;674e8fa7ec54f17a87b88c94;674e90aaec54f17a87b9f560;674e8d57ec54f17a87b5c938;674e8f36ec54f17a87b7f9be;674e8e58ec54f17a87b6c77f;674e901aec54f17a87b91b64;674e8fc8ec54f17a87b8b634",
        },
        {
          value: "back",
          count: 84,
          keywordIds:
            "674e8f49ec54f17a87b81382;674e90c2ec54f17a87ba1685;674e8f63ec54f17a87b83335;674e8fdcec54f17a87b8cf3b;674e9030ec54f17a87b93584;674e8d0bec54f17a87b57e35;674e8eadec54f17a87b7421f;674e90a6ec54f17a87b9efa2;674e9195ec54f17a87badb0e;674e8eb5ec54f17a87b74c57;674e8fe0ec54f17a87b8d319;674e8e7cec54f17a87b703d4;674e9097ec54f17a87b9d9da;674e9003ec54f17a87b8fedb;674e918aec54f17a87bad1f1;674e8fe4ec54f17a87b8d898;674e8f96ec54f17a87b875f1;674e8daaec54f17a87b61860;674e9096ec54f17a87b9d843;674e91edec54f17a87bb23ed;674e8f90ec54f17a87b86e82;674e8e69ec54f17a87b6ebb4;674e908cec54f17a87b9cab1;674e90f4ec54f17a87ba46eb;674e9019ec54f17a87b9197c;674e8e18ec54f17a87b6848c;674e9032ec54f17a87b9381f;674e8d71ec54f17a87b5e214;674e9136ec54f17a87ba82b5;674e9135ec54f17a87ba81d0;674e8df8ec54f17a87b6623c;674e918fec54f17a87bad627;674e8fb6ec54f17a87b89f04;674e8e92ec54f17a87b71f01;674e90ecec54f17a87ba3fbb;674e9070ec54f17a87b99e9b;674e8d05ec54f17a87b5780e;674e8ea6ec54f17a87b73892;674e8d03ec54f17a87b575bd;674e910aec54f17a87ba5c1f;674e8d4dec54f17a87b5bfe7;674e9158ec54f17a87baa29f;674e9112ec54f17a87ba6322;674e9092ec54f17a87b9d314;674e9141ec54f17a87ba8bf4;674e8ea9ec54f17a87b73cba;674e8e59ec54f17a87b6d67c;674e8fe4ec54f17a87b8d8b9;674e8ebfec54f17a87b7580a;674e8e96ec54f17a87b7254d;674e8e9eec54f17a87b72ef2;674e90b1ec54f17a87b9feed;674e8e6bec54f17a87b6ed1a;674e8f15ec54f17a87b7c7d2;674e8e3eec54f17a87b6a827;674e90f0ec54f17a87ba4399;674e908bec54f17a87b9c9e9;674e8d76ec54f17a87b5e771;674e8dcbec54f17a87b636f3;674e8f99ec54f17a87b87a14;674e902cec54f17a87b930b8;674e8f93ec54f17a87b872b2;674e8ea5ec54f17a87b73769;674e911aec54f17a87ba6a56;674e8e29ec54f17a87b69448;674e8f28ec54f17a87b7e764;674e9106ec54f17a87ba586b;674e90d0ec54f17a87ba2476;674e908dec54f17a87b9cbcd",
        },
        {
          value: "input",
          count: 83,
          keywordIds:
            "674e9088ec54f17a87b9c4dc;674e8ef1ec54f17a87b7986b;674e8f97ec54f17a87b87817;674e8fa5ec54f17a87b8890b;674e8f20ec54f17a87b7d7f4;674e912aec54f17a87ba7857;674e8e32ec54f17a87b69d64;674e8e4dec54f17a87b6b6d1;674e8fb0ec54f17a87b89841;674e8d3eec54f17a87b5b150;674e8fa5ec54f17a87b88916;674e91f6ec54f17a87bb2a70;674e8d61ec54f17a87b5d1e9;674e8d36ec54f17a87b5a9b0;674e8e5eec54f17a87b6dc16;674e8f3fec54f17a87b80583;674e8e3cec54f17a87b6a6a3;674e8fd5ec54f17a87b8c635;674e8fdfec54f17a87b8d27f;674e8ef3ec54f17a87b79aa1;674e8f04ec54f17a87b7b100;674e8fcbec54f17a87b8ba1b;674e90a6ec54f17a87b9f0e8;674e8db1ec54f17a87b61fc3;674e90e2ec54f17a87ba364b;674e8e69ec54f17a87b6eb09;674e90a3ec54f17a87b9eb4a;674e8de5ec54f17a87b64e6c;674e8de9ec54f17a87b65168;674e8d66ec54f17a87b5d6aa;674e8e17ec54f17a87b682c0;674e8ee2ec54f17a87b7851f;674e8efbec54f17a87b7a572;674e8e42ec54f17a87b6ac3d;674e8e87ec54f17a87b7122c;674e8f46ec54f17a87b80f3e;674e8f30ec54f17a87b7f281;674e8d95ec54f17a87b60457;674e90b0ec54f17a87b9fd5f;674e8ed0ec54f17a87b76d47;674e8f7cec54f17a87b85394;674e915cec54f17a87baa63c;674e8f4eec54f17a87b81905;674e8e83ec54f17a87b70cb5;674e90d8ec54f17a87ba2c90;674e8e5dec54f17a87b6db54;674e8f2fec54f17a87b7f071;674e8f71ec54f17a87b8443c;674e8ff9ec54f17a87b8f217;674e9039ec54f17a87b94100;674e8ed3ec54f17a87b77143;674e8f42ec54f17a87b808c3;674e9049ec54f17a87b954cb;674e8f10ec54f17a87b7c07c;674e90f1ec54f17a87ba44b5;674e8d98ec54f17a87b6077b;674e8e15ec54f17a87b68110;674e8defec54f17a87b65697;674e8f1cec54f17a87b7d1fb;674e8f41ec54f17a87b807f8;674e8dd9ec54f17a87b64387;674e90d1ec54f17a87ba25c0;674e8f66ec54f17a87b837af;674e8eacec54f17a87b740f9;674e8df3ec54f17a87b65a7b;674e8f1fec54f17a87b7d5aa;674e90d9ec54f17a87ba2dcd;674e8fefec54f17a87b8e5ff;674e8fdeec54f17a87b8d0dd",
        },
        {
          value: "multi-byte",
          count: 82,
          keywordIds:
            "674e9071ec54f17a87b9a0f7;674e919aec54f17a87badf38;674e8eeaec54f17a87b78f90;674e8f4aec54f17a87b814d0;674e905bec54f17a87b978fe;674e8f23ec54f17a87b7df8c;674e90f5ec54f17a87ba4820;674e9002ec54f17a87b8fd87;674e90dfec54f17a87ba33e3;674e8f8fec54f17a87b86c1e;674e90feec54f17a87ba5195;674e8e77ec54f17a87b6fdea;674e8e00ec54f17a87b66bc6;674e8f68ec54f17a87b83a39;674e8e7aec54f17a87b7012c;674e8e67ec54f17a87b6e8d5;674e9177ec54f17a87babcb9;674e8fc6ec54f17a87b8b2a9;674e8f95ec54f17a87b87534;674e9090ec54f17a87b9d006;674e8fa8ec54f17a87b88dbf;674e90e1ec54f17a87ba356a;674e8fcaec54f17a87b8b989;674e91a3ec54f17a87bae6b3;674e8db2ec54f17a87b61fe0;674e8f9eec54f17a87b881f1;674e8d55ec54f17a87b5c7e6;674e8ff8ec54f17a87b8f129;674e9075ec54f17a87b9a742;674e9086ec54f17a87b9c1b4;674e8fa6ec54f17a87b88af8;674e8f6bec54f17a87b83d1b;674e8eefec54f17a87b7963a;674e902aec54f17a87b92de4;674e8f8cec54f17a87b8687e;674e8ec1ec54f17a87b75b02;674e8f6eec54f17a87b84055;674e8dd2ec54f17a87b63d31;674e90e5ec54f17a87ba38eb;674e8e5bec54f17a87b6d91e;674e903eec54f17a87b94675;674e8fe6ec54f17a87b8da61;674e9093ec54f17a87b9d47a;674e8e7eec54f17a87b70698;674e8d4eec54f17a87b5c093;674e9101ec54f17a87ba5433;674e8ea9ec54f17a87b73d25;674e8dbeec54f17a87b62b70;674e8f03ec54f17a87b7b01a;674e8eb4ec54f17a87b74ac5;674e9086ec54f17a87b9c1df;674e8f1aec54f17a87b7ceb1;674e8e80ec54f17a87b70884;674e916bec54f17a87bab2bc;674e8d75ec54f17a87b5e6d8;674e8e9aec54f17a87b729c8;674e8f99ec54f17a87b87a54;674e8efeec54f17a87b7a9db;674e8fc4ec54f17a87b8b0fb;674e8e0eec54f17a87b67a65;674e8e80ec54f17a87b70838;674e8f36ec54f17a87b7fa17;674e8eb7ec54f17a87b74e75;674e8f98ec54f17a87b879ac;674e8ecdec54f17a87b76a52;674e8f66ec54f17a87b837e4;674e8fa1ec54f17a87b88510;674e9078ec54f17a87b9ad04;674e9138ec54f17a87ba8421;674e8d89ec54f17a87b5f9d4",
        },
        {
          value: "transmit",
          count: 82,
          keywordIds:
            "674e8d96ec54f17a87b60620;674e8e90ec54f17a87b71d72;674e8ff6ec54f17a87b8eefa;674e8fb5ec54f17a87b89e1e;674e8f45ec54f17a87b80d8a;674e8e9eec54f17a87b72e2b;674e904fec54f17a87b96157;674e8ff8ec54f17a87b8f0da;674e90dfec54f17a87ba3335;674e8fc2ec54f17a87b8ad82;674e9171ec54f17a87bab757;674e9052ec54f17a87b967d3;674e8e2bec54f17a87b6963a;674e8f11ec54f17a87b7c1e5;674e9121ec54f17a87ba6fff;674e8ef6ec54f17a87b79f31;674e91b0ec54f17a87baf1ee;674e909aec54f17a87b9dec9;674e8e76ec54f17a87b6fb9c;674e9038ec54f17a87b93e9b;674e8fc3ec54f17a87b8aef7;674e8e4bec54f17a87b6b51b;674e8fdcec54f17a87b8cf15;674e9097ec54f17a87b9da4f;674e8d69ec54f17a87b5d9e1;674e8dc3ec54f17a87b63004;674e9180ec54f17a87bac999;674e8dcaec54f17a87b635c1;674e8e6eec54f17a87b6f215;674e8e88ec54f17a87b71377;674e91a4ec54f17a87bae74a;674e8d1fec54f17a87b5931f;674e9073ec54f17a87b9a3d9;674e8d7aec54f17a87b5eb5c;674e8f29ec54f17a87b7e886;674e90faec54f17a87ba4d13;674e8e10ec54f17a87b67b76;674e9029ec54f17a87b92caf;674e9135ec54f17a87ba8155;674e8e65ec54f17a87b6e62b;674e9048ec54f17a87b95365;674e9176ec54f17a87babb69;674e8ed5ec54f17a87b773b9;674e8fd0ec54f17a87b8c047;674e9007ec54f17a87b903e2;674e8fa9ec54f17a87b88e6a;674e8f7bec54f17a87b8529b;674e8da2ec54f17a87b61193;674e8ee4ec54f17a87b787e4;674e8f14ec54f17a87b7c617;674e9093ec54f17a87b9d510;674e913aec54f17a87ba85c2;674e907dec54f17a87b9b3d6;674e914bec54f17a87ba945b;674e8d91ec54f17a87b600e8;674e8e5aec54f17a87b6d74e;674e8fa0ec54f17a87b88448;674e9143ec54f17a87ba8e0e;674e91d5ec54f17a87bb0fd8;674e8f1aec54f17a87b7cf28;674e8da0ec54f17a87b60f5b;674e8e54ec54f17a87b6be5f;674e90dcec54f17a87ba3098;674e8deeec54f17a87b65594;674e8d5eec54f17a87b5cfe5;674e8e0eec54f17a87b67a41;674e8f24ec54f17a87b7e1fc;674e8f36ec54f17a87b7f9d0;674e8e44ec54f17a87b6ae96;674e90b4ec54f17a87ba0381;674e8f08ec54f17a87b7b66f;674e8dcfec54f17a87b63a7e;674e90daec54f17a87ba2e5c;674e90bcec54f17a87ba0f38",
        },
        {
          value: "online",
          count: 82,
          keywordIds:
            "674e8f45ec54f17a87b80da8;674e91b3ec54f17a87baf4bc;674e8f9eec54f17a87b881f7;674e8e2eec54f17a87b69916;674e913dec54f17a87ba88f1;674e9029ec54f17a87b92d3d;674e8d47ec54f17a87b5ba40;674e8fc2ec54f17a87b8ae19;674e8ef5ec54f17a87b79da5;674e8fddec54f17a87b8d02e;674e9064ec54f17a87b98a2a;674e91eaec54f17a87bb2145;674e8f80ec54f17a87b858f8;674e8fc0ec54f17a87b8ab2c;674e906bec54f17a87b996b7;674e8d0eec54f17a87b58193;674e9145ec54f17a87ba8f5c;674e8fcdec54f17a87b8bc81;674e8f30ec54f17a87b7f22a;674e90c0ec54f17a87ba1426;674e8ef2ec54f17a87b799ce;674e916dec54f17a87bab461;674e8d11ec54f17a87b583d4;674e914eec54f17a87ba984b;674e9073ec54f17a87b9a387;674e8f96ec54f17a87b8761b;674e90eaec54f17a87ba3dfd;674e8d90ec54f17a87b6005c;674e91a8ec54f17a87baeb50;674e8e25ec54f17a87b69012;674e91eeec54f17a87bb241b;674e8f83ec54f17a87b85d9e;674e8f88ec54f17a87b86315;674e8d0aec54f17a87b57d40;674e9053ec54f17a87b96a5f;674e8fc8ec54f17a87b8b6a8;674e8f3bec54f17a87b80049;674e8da3ec54f17a87b612f4;674e8f2fec54f17a87b7f11b;674e90ceec54f17a87ba2357;674e8df7ec54f17a87b66176;674e8ee0ec54f17a87b782ed;674e8d8dec54f17a87b5fd2d;674e91ddec54f17a87bb1727;674e8e42ec54f17a87b6ac5e;674e8e87ec54f17a87b71263;674e8cf8ec54f17a87b56b32;674e8d9bec54f17a87b60b3f;674e8f49ec54f17a87b81356;674e8f51ec54f17a87b81ddb;674e904eec54f17a87b95b4e;674e8f7aec54f17a87b85107;674e8ec7ec54f17a87b76266;674e9005ec54f17a87b900f3;674e8d03ec54f17a87b5767d;674e909dec54f17a87b9e2ef;674e8d6eec54f17a87b5dede;674e907dec54f17a87b9b414;674e8e05ec54f17a87b67138;674e8feaec54f17a87b8dfeb;674e905cec54f17a87b97bc1;674e9017ec54f17a87b9160c;674e9052ec54f17a87b96793;674e8f96ec54f17a87b876c4;674e8e3bec54f17a87b6a5f7;674e8dddec54f17a87b646e7;674e902eec54f17a87b9329b;674e8decec54f17a87b6544c;674e905fec54f17a87b9823a;674e8ddcec54f17a87b64613;674e8d2eec54f17a87b5a266;674e90e9ec54f17a87ba3d38;674e8fbeec54f17a87b8a833;674e8deaec54f17a87b652e5;674e91dbec54f17a87bb154a;674e8f1fec54f17a87b7d5e2;674e8d2fec54f17a87b5a38a",
        },
        {
          value: "solid",
          count: 80,
          keywordIds:
            "674e9061ec54f17a87b984b4;674e8d4fec54f17a87b5c22e;674e8ec9ec54f17a87b7648f;674e9099ec54f17a87b9dd3d;674e8fb5ec54f17a87b89d7c;674e90c6ec54f17a87ba1b29;674e8e97ec54f17a87b7259f;674e8d2dec54f17a87b5a0d0;674e8d12ec54f17a87b584e6;674e8f0dec54f17a87b7bdd7;674e8fb8ec54f17a87b8a135;674e8f3cec54f17a87b801a7;674e8f2bec54f17a87b7eb4d;674e91b9ec54f17a87baf9a6;674e9084ec54f17a87b9be9d;674e8e41ec54f17a87b6aaf4;674e90adec54f17a87b9f9b0;674e91beec54f17a87bafde5;674e8e76ec54f17a87b6fbd8;674e8ff1ec54f17a87b8e84d;674e91f9ec54f17a87bb2d0a;674e8f72ec54f17a87b845f4;674e904fec54f17a87b962d3;674e9098ec54f17a87b9db3d;674e8dfcec54f17a87b6672a;674e8fb3ec54f17a87b89b1c;674e8eb8ec54f17a87b75077;674e8daeec54f17a87b61d14;674e8d93ec54f17a87b602a8;674e91c0ec54f17a87bafffe;674e8e1cec54f17a87b687e7;674e8f77ec54f17a87b84cb3;674e9082ec54f17a87b9bc88;674e9077ec54f17a87b9ab0f;674e8efbec54f17a87b7a5d5;674e8f3aec54f17a87b7ff39;674e8d1dec54f17a87b590a2;674e8f91ec54f17a87b87043;674e90b9ec54f17a87ba0abb;674e8df8ec54f17a87b6627e;674e9035ec54f17a87b93c18;674e9125ec54f17a87ba73e3;674e8dc1ec54f17a87b62e70;674e906dec54f17a87b99a19;674e8f2dec54f17a87b7edde;674e8f52ec54f17a87b81e6b;674e8ee4ec54f17a87b78829;674e8f8fec54f17a87b86d1d;674e90a0ec54f17a87b9e824;674e8f46ec54f17a87b80ef2;674e9141ec54f17a87ba8ca9;674e8fc5ec54f17a87b8b269;674e8e5aec54f17a87b6d788;674e8e8aec54f17a87b7166e;674e9167ec54f17a87baae9f;674e90b9ec54f17a87ba0a45;674e9049ec54f17a87b95504;674e91dfec54f17a87bb18cc;674e9021ec54f17a87b9233b;674e906dec54f17a87b999a6;674e8f2eec54f17a87b7ef3e;674e8f9bec54f17a87b87d22;674e9169ec54f17a87bab0b0;674e8dddec54f17a87b64762;674e8d5eec54f17a87b5d027;674e8f4fec54f17a87b81ade;674e91ceec54f17a87bb0acd;674e91dbec54f17a87bb1492;674e8de4ec54f17a87b64d21;674e9106ec54f17a87ba5887",
        },
        {
          value: "state",
          count: 80,
          keywordIds:
            "674e9061ec54f17a87b984f7;674e8d4fec54f17a87b5c254;674e8ec9ec54f17a87b764b9;674e9099ec54f17a87b9dd70;674e8fb5ec54f17a87b89dbd;674e90c7ec54f17a87ba1b47;674e8e97ec54f17a87b725dd;674e8d2dec54f17a87b5a0f2;674e8d12ec54f17a87b58506;674e8f0eec54f17a87b7be14;674e8fb8ec54f17a87b8a17a;674e8f3cec54f17a87b801e9;674e8f2bec54f17a87b7eb86;674e91b9ec54f17a87baf9c3;674e9084ec54f17a87b9bedb;674e8e41ec54f17a87b6ab31;674e90adec54f17a87b9f9e8;674e91beec54f17a87bafe2a;674e8e76ec54f17a87b6fc29;674e8ff1ec54f17a87b8e881;674e91f9ec54f17a87bb2d27;674e8f72ec54f17a87b84624;674e904fec54f17a87b962ff;674e9098ec54f17a87b9db67;674e8dfcec54f17a87b66763;674e8fb3ec54f17a87b89b63;674e8eb9ec54f17a87b750b5;674e8daeec54f17a87b61d5a;674e8d93ec54f17a87b602d4;674e91c1ec54f17a87bb0023;674e8e1cec54f17a87b68873;674e8f77ec54f17a87b84cd5;674e9083ec54f17a87b9bcbf;674e9077ec54f17a87b9ab60;674e8efbec54f17a87b7a610;674e8f3aec54f17a87b7ff6a;674e8d1dec54f17a87b590f4;674e8f92ec54f17a87b8708f;674e90b9ec54f17a87ba0b0b;674e8df8ec54f17a87b662a7;674e9036ec54f17a87b93c32;674e9126ec54f17a87ba7406;674e8dc2ec54f17a87b62eaa;674e906eec54f17a87b99a6d;674e8f2dec54f17a87b7ee0d;674e8f52ec54f17a87b81ece;674e8ee4ec54f17a87b78876;674e8f8fec54f17a87b86d4f;674e90a1ec54f17a87b9e854;674e8f46ec54f17a87b80f2d;674e9142ec54f17a87ba8cc9;674e8fc6ec54f17a87b8b29d;674e8e5aec54f17a87b6d7a7;674e8e8bec54f17a87b716a5;674e9167ec54f17a87baaecb;674e90b9ec54f17a87ba0a67;674e9049ec54f17a87b95523;674e91dfec54f17a87bb18fa;674e9021ec54f17a87b92376;674e906dec54f17a87b99a0c;674e8f2eec54f17a87b7ef8c;674e8f9bec54f17a87b87d6e;674e9169ec54f17a87bab0dd;674e8ddeec54f17a87b64786;674e8d5eec54f17a87b5d048;674e8f4fec54f17a87b81b05;674e91ceec54f17a87bb0ae5;674e91dbec54f17a87bb14c8;674e8de4ec54f17a87b64d4e;674e9106ec54f17a87ba58a3",
        },
        {
          value: "copy",
          count: 79,
          keywordIds:
            "674e9080ec54f17a87b9b92f;674e903cec54f17a87b94503;674e91bcec54f17a87bafc96;674e8fbeec54f17a87b8a8f5;674e8edbec54f17a87b77c2f;674e8feaec54f17a87b8dfde;674e8f40ec54f17a87b80728;674e9030ec54f17a87b9361b;674e8f86ec54f17a87b86074;674e8f2bec54f17a87b7eb25;674e8d8fec54f17a87b5ff09;674e8d29ec54f17a87b59cd3;674e8fcdec54f17a87b8bbd0;674e8e8dec54f17a87b719d2;674e8e40ec54f17a87b6aa4a;674e914dec54f17a87ba96b2;674e8e85ec54f17a87b70f56;674e8e7aec54f17a87b70198;674e8f5eec54f17a87b82ce3;674e8f05ec54f17a87b7b19a;674e8fbfec54f17a87b8aa1c;674e8f06ec54f17a87b7b34b;674e8fd8ec54f17a87b8cac1;674e8dc5ec54f17a87b631b5;674e909eec54f17a87b9e4ec;674e8d55ec54f17a87b5c820;674e8f87ec54f17a87b86272;674e8f77ec54f17a87b84c84;674e915aec54f17a87baa4f7;674e8cfeec54f17a87b570c4;674e9104ec54f17a87ba5710;674e9025ec54f17a87b927e9;674e8f54ec54f17a87b82142;674e8f0bec54f17a87b7bad2;674e8e8cec54f17a87b71889;674e8f75ec54f17a87b84947;674e8ec0ec54f17a87b75a2b;674e8e53ec54f17a87b6bd34;674e8efdec54f17a87b7a7da;674e908aec54f17a87b9c725;674e908eec54f17a87b9cdf1;674e9005ec54f17a87b900bb;674e905eec54f17a87b97f1f;674e8f84ec54f17a87b85eb4;674e8f04ec54f17a87b7b161;674e8f7dec54f17a87b8549c;674e905dec54f17a87b97cf6;674e8f17ec54f17a87b7ca47;674e8e1aec54f17a87b68695;674e919bec54f17a87badfe0;674e8f22ec54f17a87b7da7b;674e8e3dec54f17a87b6a799;674e8fdaec54f17a87b8cc71;674e8deeec54f17a87b655e3;674e8d57ec54f17a87b5c9c3;674e8debec54f17a87b653a5;674e905fec54f17a87b981f8;674e8f8aec54f17a87b86624;674e8e8eec54f17a87b71a1b;674e8f01ec54f17a87b7ad43;674e8eb9ec54f17a87b7515f;674e9037ec54f17a87b93daa;674e8f28ec54f17a87b7e7ce;674e8e61ec54f17a87b6e09b;674e90a3ec54f17a87b9ecc3;674e8efeec54f17a87b7a93b;674e8de3ec54f17a87b64c7d;674e90edec54f17a87ba40bb;674e8fdeec54f17a87b8d1ae",
        },
        {
          value: "virtual",
          count: 79,
          keywordIds:
            "674e9088ec54f17a87b9c4a0;674e8fb5ec54f17a87b89e57;674e8e37ec54f17a87b6a218;674e9183ec54f17a87bacd37;674e9196ec54f17a87badc8c;674e9069ec54f17a87b99254;674e8e5fec54f17a87b6de55;674e8f92ec54f17a87b871f1;674e8f86ec54f17a87b860b8;674e9201ec54f17a87bb33a9;674e8ea0ec54f17a87b73180;674e8e1dec54f17a87b689a3;674e8f3cec54f17a87b801b2;674e8d8eec54f17a87b5fe9d;674e9195ec54f17a87badb2e;674e8ff1ec54f17a87b8e8e2;674e9021ec54f17a87b92356;674e8d23ec54f17a87b5977c;674e9097ec54f17a87b9da6f;674e918aec54f17a87bad20f;674e8fe4ec54f17a87b8d8e7;674e9053ec54f17a87b96993;674e9012ec54f17a87b910ef;674e8f06ec54f17a87b7b379;674e9056ec54f17a87b96f4a;674e8ed1ec54f17a87b76f9b;674e91baec54f17a87bafb19;674e8e88ec54f17a87b7139d;674e9018ec54f17a87b918a5;674e8cfdec54f17a87b57060;674e8fb3ec54f17a87b89c05;674e8d1fec54f17a87b59344;674e9146ec54f17a87ba9062;674e9030ec54f17a87b93527;674e8f76ec54f17a87b84b54;674e8e70ec54f17a87b6f524;674e900cec54f17a87b909f8;674e9091ec54f17a87b9d178;674e9017ec54f17a87b9169f;674e911fec54f17a87ba6e6c;674e8d63ec54f17a87b5d461;674e9130ec54f17a87ba7d50;674e8ebdec54f17a87b756ba;674e8ffcec54f17a87b8f606;674e90e5ec54f17a87ba39ac;674e8ff5ec54f17a87b8ed7d;674e8ee9ec54f17a87b78ee5;674e8f1bec54f17a87b7cf80;674e8da1ec54f17a87b610fa;674e8f90ec54f17a87b86e18;674e9112ec54f17a87ba6354;674e8d40ec54f17a87b5b375;674e9091ec54f17a87b9d2a6;674e8d6dec54f17a87b5ddf1;674e8e81ec54f17a87b7097b;674e8fbdec54f17a87b8a770;674e8fafec54f17a87b8964c;674e8e55ec54f17a87b6bea8;674e8e60ec54f17a87b6e00b;674e9133ec54f17a87ba8026;674e8eb2ec54f17a87b74834",
        },
        {
          value: "auxiliary",
          count: 78,
          keywordIds:
            "674e8d1cec54f17a87b58f63;674e9154ec54f17a87ba9cff;674e8ef1ec54f17a87b7989a;674e8f7fec54f17a87b8585c;674e8f94ec54f17a87b873de;674e8edbec54f17a87b77c8a;674e8eacec54f17a87b740e6;674e8f5fec54f17a87b82e5e;674e8f40ec54f17a87b80762;674e8f57ec54f17a87b82510;674e8e4dec54f17a87b6b6fc;674e8f9dec54f17a87b880b8;674e8f6dec54f17a87b83f53;674e9013ec54f17a87b91253;674e9121ec54f17a87ba702e;674e8fe0ec54f17a87b8d373;674e907aec54f17a87b9b04f;674e918bec54f17a87bad361;674e8f04ec54f17a87b7b133;674e8f9bec54f17a87b87e09;674e8fcbec54f17a87b8ba50;674e909fec54f17a87b9e5cd;674e8fceec54f17a87b8be40;674e8de9ec54f17a87b6519f;674e8f08ec54f17a87b7b698;674e91a5ec54f17a87bae7fa;674e8e17ec54f17a87b6830c;674e8e74ec54f17a87b6f96b;674e900cec54f17a87b909d2;674e91a6ec54f17a87bae92d;674e9028ec54f17a87b92b7f;674e8d54ec54f17a87b5c63e;674e9029ec54f17a87b92d06;674e9083ec54f17a87b9bcd0;674e914cec54f17a87ba95f6;674e90ecec54f17a87ba3ffd;674e8dbfec54f17a87b62cba;674e8f31ec54f17a87b7f3fb;674e8f8dec54f17a87b86a3e;674e8fd4ec54f17a87b8c52e;674e8fd0ec54f17a87b8c023;674e909aec54f17a87b9debe;674e8cf7ec54f17a87b56a39;674e8fadec54f17a87b893e5;674e8ea2ec54f17a87b73369;674e8e65ec54f17a87b6e61e;674e9087ec54f17a87b9c336;674e8ed3ec54f17a87b771df;674e8f22ec54f17a87b7dac1;674e8d98ec54f17a87b60822;674e8f65ec54f17a87b83687;674e916fec54f17a87bab5a8;674e9023ec54f17a87b925a0;674e8f14ec54f17a87b7c656;674e90deec54f17a87ba329c;674e8df0ec54f17a87b65724;674e915fec54f17a87baa8e1;674e8f40ec54f17a87b80797;674e8edfec54f17a87b781cf;674e8ebaec54f17a87b75201;674e8e30ec54f17a87b69aa8;674e9009ec54f17a87b905ab;674e8e49ec54f17a87b6b29c;674e8e70ec54f17a87b6f3db;674e8f03ec54f17a87b7af41",
        },
        {
          value: "haptic",
          count: 78,
          keywordIds:
            "674e8ff7ec54f17a87b8efbb;674e8fe3ec54f17a87b8d6e1;674e8e9eec54f17a87b72f39;674e904aec54f17a87b9566d;674e8ff3ec54f17a87b8ebb8;674e91c6ec54f17a87bb042d;674e8fa3ec54f17a87b88719;674e8f0eec54f17a87b7bf07;674e8eb6ec54f17a87b74cf1;674e8d5dec54f17a87b5ce91;674e9179ec54f17a87babe2a;674e8fd7ec54f17a87b8c8bd;674e8e36ec54f17a87b6a07f;674e8e3fec54f17a87b6a9af;674e8ef7ec54f17a87b7a01c;674e9059ec54f17a87b97521;674e91c9ec54f17a87bb06e0;674e8d10ec54f17a87b5834c;674e8f37ec54f17a87b7fc4d;674e9003ec54f17a87b8ff02;674e90f9ec54f17a87ba4c11;674e8d7fec54f17a87b5f0d5;674e9031ec54f17a87b9374d;674e91e6ec54f17a87bb1e3c;674e8e4cec54f17a87b6b5a8;674e8d6aec54f17a87b5dac3;674e8d08ec54f17a87b57b1d;674e908bec54f17a87b9c8de;674e908dec54f17a87b9cba2;674e8e46ec54f17a87b6b032;674e8ffbec54f17a87b8f499;674e915eec54f17a87baa7c2;674e9198ec54f17a87baddb2;674e8f12ec54f17a87b7c44c;674e8f9cec54f17a87b87ed7;674e8f73ec54f17a87b8476e;674e8e48ec54f17a87b6b153;674e8eeeec54f17a87b7952f;674e9118ec54f17a87ba6818;674e90ccec54f17a87ba20bb;674e8fd0ec54f17a87b8bfe8;674e9147ec54f17a87ba91b9;674e9070ec54f17a87b99edc;674e912fec54f17a87ba7c88;674e9018ec54f17a87b91741;674e8d05ec54f17a87b57844;674e8ea7ec54f17a87b7399a;674e9041ec54f17a87b94a78;674e913aec54f17a87ba85f3;674e8e89ec54f17a87b7146e;674e8d51ec54f17a87b5c3a8;674e8e5aec54f17a87b6d6e2;674e8f6aec54f17a87b83bb3;674e8e9fec54f17a87b72f98;674e9155ec54f17a87ba9eff;674e8fdcec54f17a87b8ce74;674e9193ec54f17a87bad9f3;674e8f9aec54f17a87b87b5a;674e91ffec54f17a87bb3199;674e906fec54f17a87b99cb9;674e9047ec54f17a87b95201;674e8da6ec54f17a87b615a0;674e8ed0ec54f17a87b76e00;674e909fec54f17a87b9e531;674e8e99ec54f17a87b7284e;674e8fddec54f17a87b8d0a9;674e8dc7ec54f17a87b63359;674e8df4ec54f17a87b65abd",
        },
        {
          value: "generate",
          count: 78,
          keywordIds:
            "674e8df4ec54f17a87b65b91;674e8fbaec54f17a87b8a3d0;674e8d27ec54f17a87b59b8e;674e903fec54f17a87b948cc;674e8e6cec54f17a87b6efaf;674e8dbbec54f17a87b628c2;674e90a1ec54f17a87b9e9b4;674e919fec54f17a87bae306;674e8e1dec54f17a87b68909;674e8d59ec54f17a87b5cb91;674e8eecec54f17a87b792ea;674e8d1eec54f17a87b5923e;674e8ebcec54f17a87b7556a;674e8ef2ec54f17a87b79993;674e8eb8ec54f17a87b75023;674e8f1dec54f17a87b7d34b;674e90afec54f17a87b9fc65;674e910dec54f17a87ba5ef6;674e908aec54f17a87b9c714;674e8e2cec54f17a87b69784;674e8e25ec54f17a87b690a3;674e8d94ec54f17a87b6034a;674e8fceec54f17a87b8bdfa;674e8d49ec54f17a87b5bc01;674e8f91ec54f17a87b87009;674e90baec54f17a87ba0ba0;674e8f9cec54f17a87b87eb3;674e8ecbec54f17a87b76827;674e8e47ec54f17a87b6b0c7;674e8f63ec54f17a87b83386;674e8e5aec54f17a87b6d7d3;674e8e95ec54f17a87b72405;674e8ffcec54f17a87b8f598;674e8dd1ec54f17a87b63d18;674e9168ec54f17a87baaf41;674e8e5fec54f17a87b6de7b;674e8ea2ec54f17a87b73334;674e8d03ec54f17a87b57651;674e90bbec54f17a87ba0cde;674e9111ec54f17a87ba6234;674e8f90ec54f17a87b86df9;674e8ddeec54f17a87b647f1;674e8f59ec54f17a87b8273d;674e8ed7ec54f17a87b77673;674e9150ec54f17a87ba9a30;674e8e81ec54f17a87b709a0;674e8f1aec54f17a87b7ce85;674e91ffec54f17a87bb317f;674e906eec54f17a87b99b77;674e9024ec54f17a87b92631;674e8f81ec54f17a87b85ad5;674e8e5cec54f17a87b6d9fb;674e9034ec54f17a87b93ab0;674e8f4fec54f17a87b81a4b;674e8e01ec54f17a87b66cf3;674e8f34ec54f17a87b7f7de;674e8e66ec54f17a87b6e7bd;674e8e99ec54f17a87b727f8;674e8eb7ec54f17a87b74e37;674e8f26ec54f17a87b7e4ab;674e8d2fec54f17a87b5a342",
        },
        {
          value: "override",
          count: 77,
          keywordIds:
            "674e8d6bec54f17a87b5db3d;674e9172ec54f17a87bab887;674e8f0aec54f17a87b7b983;674e90b5ec54f17a87ba043c;674e917cec54f17a87bac60f;674e8de7ec54f17a87b65033;674e9183ec54f17a87bacc66;674e8eacec54f17a87b73f8e;674e8e50ec54f17a87b6ba1b;674e8f6fec54f17a87b841db;674e8eb5ec54f17a87b74c1b;674e8fbfec54f17a87b8aa43;674e8f69ec54f17a87b83ab1;674e8e79ec54f17a87b7004c;674e8d60ec54f17a87b5d16d;674e8ebcec54f17a87b7548a;674e91c9ec54f17a87bb0715;674e907bec54f17a87b9b0bc;674e91d2ec54f17a87bb0db1;674e908fec54f17a87b9cfd4;674e90c8ec54f17a87ba1c87;674e91edec54f17a87bb2384;674e8db2ec54f17a87b6204c;674e8facec54f17a87b892b8;674e908bec54f17a87b9c95f;674e8fb3ec54f17a87b89bc2;674e8e0bec54f17a87b676ca;674e8e71ec54f17a87b6f6ba;674e8d16ec54f17a87b5899c;674e90ceec54f17a87ba2313;674e8ef8ec54f17a87b7a1af;674e9186ec54f17a87bacf39;674e91f0ec54f17a87bb2652;674e9090ec54f17a87b9d087;674e90a8ec54f17a87b9f353;674e8d02ec54f17a87b574be;674e8f51ec54f17a87b81da9;674e8d63ec54f17a87b5d40c;674e8e9fec54f17a87b7305c;674e90e5ec54f17a87ba396f;674e9041ec54f17a87b94b23;674e8e8fec54f17a87b71c30;674e8f01ec54f17a87b7acb8;674e8f46ec54f17a87b80ea5;674e9005ec54f17a87b9018c;674e9063ec54f17a87b987ca;674e8ea2ec54f17a87b732e5;674e9022ec54f17a87b9240f;674e8d98ec54f17a87b607f3;674e8e5cec54f17a87b6da53;674e8f56ec54f17a87b8230f;674e8f65ec54f17a87b83634;674e8e9aec54f17a87b72981;674e8e77ec54f17a87b6fd03;674e8ee1ec54f17a87b783e7;674e8e5dec54f17a87b6dab4;674e8ea5ec54f17a87b7369d;674e8e7eec54f17a87b7058b;674e8fbbec54f17a87b8a59b;674e8f17ec54f17a87b7ca08;674e90b7ec54f17a87ba0789;674e91ceec54f17a87bb0ab2;674e9038ec54f17a87b93f3d;674e8eb2ec54f17a87b748f1;674e8de4ec54f17a87b64cfd;674e8e70ec54f17a87b6f4e5;674e8dcfec54f17a87b63aeb;674e9137ec54f17a87ba83b2;674e8fc8ec54f17a87b8b6b3",
        },
        {
          value: "navigate",
          count: 77,
          keywordIds:
            "674e8e91ec54f17a87b71e19;674e8e92ec54f17a87b71fa4;674e9010ec54f17a87b90e85;674e91c3ec54f17a87bb027b;674e8febec54f17a87b8e09a;674e9064ec54f17a87b989ef;674e8fb0ec54f17a87b897b3;674e8d5dec54f17a87b5ce44;674e8fd4ec54f17a87b8c4f0;674e9044ec54f17a87b94ef0;674e9021ec54f17a87b92288;674e8e43ec54f17a87b6ad5e;674e8ee8ec54f17a87b78dab;674e90e0ec54f17a87ba3495;674e90c9ec54f17a87ba1d47;674e9056ec54f17a87b96eee;674e9054ec54f17a87b96bd9;674e8dadec54f17a87b61c1a;674e91a2ec54f17a87bae568;674e8d09ec54f17a87b57cad;674e8ffbec54f17a87b8f469;674e90bcec54f17a87ba0e77;674e8f39ec54f17a87b7fe40;674e91d9ec54f17a87bb131c;674e90ccec54f17a87ba1ff7;674e8e70ec54f17a87b6f4f0;674e8ebdec54f17a87b7567e;674e9117ec54f17a87ba67e9;674e9045ec54f17a87b95097;674e904eec54f17a87b95b96;674e8ea3ec54f17a87b73524;674e8fabec54f17a87b891c3;674e903dec54f17a87b94624;674e8fe6ec54f17a87b8da35;674e8f4dec54f17a87b8186b;674e912dec54f17a87ba7a5d;674e8d26ec54f17a87b59a36;674e8e9cec54f17a87b72c50;674e8fe5ec54f17a87b8d948;674e8f03ec54f17a87b7afda;674e8f65ec54f17a87b83624;674e9052ec54f17a87b96746;674e91e0ec54f17a87bb195d;674e8d0dec54f17a87b57fb7;674e8fbcec54f17a87b8a672;674e8faeec54f17a87b895a0;674e916bec54f17a87bab2a0;674e90caec54f17a87ba1e5b;674e8f1bec54f17a87b7d048;674e8d2bec54f17a87b59f82;674e8f43ec54f17a87b80b20;674e8ee5ec54f17a87b789d9;674e8ee0ec54f17a87b78247;674e8d45ec54f17a87b5b7bc;674e8f98ec54f17a87b8798b;674e8de1ec54f17a87b64a4c;674e8d57ec54f17a87b5c918;674e8f35ec54f17a87b7f92c;674e8f1fec54f17a87b7d5b8;674e8e58ec54f17a87b6c38c;674e8f02ec54f17a87b7af11;674e8ed5ec54f17a87b7749f",
        },
        {
          value: "wireless",
          count: 76,
          keywordIds:
            "674e90b5ec54f17a87ba0466;674e8f7fec54f17a87b85803;674e8dd7ec54f17a87b641b0;674e8fa5ec54f17a87b8893e;674e904cec54f17a87b95988;674e903fec54f17a87b94815;674e8d07ec54f17a87b579f4;674e8febec54f17a87b8e0ca;674e8e6cec54f17a87b6efe5;674e9067ec54f17a87b98faa;674e8f40ec54f17a87b8065b;674e8eb8ec54f17a87b75056;674e8d6fec54f17a87b5e03f;674e8fcbec54f17a87b8ba8a;674e8e7aec54f17a87b700ea;674e8dd5ec54f17a87b63fd6;674e8db8ec54f17a87b625fe;674e9032ec54f17a87b9381a;674e8f1eec54f17a87b7d401;674e8e6eec54f17a87b6f243;674e8fc1ec54f17a87b8ac53;674e906aec54f17a87b993bb;674e916fec54f17a87bab633;674e8ec3ec54f17a87b75e12;674e8f91ec54f17a87b86ed8;674e8d17ec54f17a87b589d2;674e8e31ec54f17a87b69c85;674e911eec54f17a87ba6d2d;674e907dec54f17a87b9b561;674e9019ec54f17a87b9191c;674e918fec54f17a87bad644;674e8d8dec54f17a87b5fdb4;674e8efcec54f17a87b7a63c;674e8e81ec54f17a87b70a56;674e8dd8ec54f17a87b642f6;674e8d52ec54f17a87b5c4a2;674e9132ec54f17a87ba7fb6;674e8f6cec54f17a87b83ee6;674e8d62ec54f17a87b5d357;674e8f5aec54f17a87b827ce;674e915cec54f17a87baa657;674e9096ec54f17a87b9d853;674e910aec54f17a87ba5c61;674e8f04ec54f17a87b7b0ce;674e8f67ec54f17a87b8385a;674e9092ec54f17a87b9d345;674e8f5aec54f17a87b827e8;674e8fffec54f17a87b8f9b4;674e913fec54f17a87ba8ac1;674e8e81ec54f17a87b709d6;674e8e73ec54f17a87b6f8b8;674e8f56ec54f17a87b823bd;674e8db5ec54f17a87b62375;674e90d7ec54f17a87ba2b51;674e8f8bec54f17a87b86769;674e8e01ec54f17a87b66d28;674e8f38ec54f17a87b7fcb0;674e8ee3ec54f17a87b7864d;674e8dd9ec54f17a87b643b4;674e8edaec54f17a87b77ac0;674e8efeec54f17a87b7a995;674e8e3aec54f17a87b6a4d6;674e90daec54f17a87ba2e7c;674e8fefec54f17a87b8e638",
        },
        {
          value: "quantify",
          count: 75,
          keywordIds:
            "674e9061ec54f17a87b98650;674e8e12ec54f17a87b67e99;674e903dec54f17a87b94619;674e90c0ec54f17a87ba138d;674e90c6ec54f17a87ba1aed;674e8f62ec54f17a87b83299;674e8fa2ec54f17a87b886b0;674e8e5fec54f17a87b6de0c;674e8f80ec54f17a87b858df;674e8fbfec54f17a87b8aaed;674e9044ec54f17a87b94dfb;674e8f30ec54f17a87b7f20b;674e90adec54f17a87b9f96b;674e9002ec54f17a87b8fd8a;674e9128ec54f17a87ba76f9;674e9011ec54f17a87b91042;674e8daaec54f17a87b61950;674e8dfcec54f17a87b666f4;674e8ebeec54f17a87b757e7;674e90a7ec54f17a87b9f1d8;674e8d93ec54f17a87b6027a;674e8f83ec54f17a87b85d68;674e8fc1ec54f17a87b8ace2;674e8e46ec54f17a87b6b00c;674e8d31ec54f17a87b5a4b6;674e91a5ec54f17a87bae7e0;674e9082ec54f17a87b9bc21;674e9069ec54f17a87b992a7;674e8f77ec54f17a87b84c02;674e8d7dec54f17a87b5eee3;674e8f6bec54f17a87b83ccb;674e8efaec54f17a87b7a449;674e8fcdec54f17a87b8bd07;674e9019ec54f17a87b919d6;674e9082ec54f17a87b9bc96;674e91ddec54f17a87bb16a6;674e8f4bec54f17a87b815e0;674e904bec54f17a87b9583c;674e909aec54f17a87b9dddb;674e8ee7ec54f17a87b78bd5;674e8ee9ec54f17a87b78e02;674e8ff6ec54f17a87b8eed6;674e8f1bec54f17a87b7cf3a;674e90a3ec54f17a87b9ec01;674e8f48ec54f17a87b8112d;674e8efcec54f17a87b7a70c;674e8e59ec54f17a87b6d5d5;674e9100ec54f17a87ba5411;674e9005ec54f17a87b90194;674e9166ec54f17a87baae15;674e8f5dec54f17a87b82c2e;674e8e80ec54f17a87b70947;674e8eeeec54f17a87b795a8;674e90b2ec54f17a87ba00ef;674e8d4cec54f17a87b5bef7;674e9034ec54f17a87b93a18;674e8fb4ec54f17a87b89c44;674e8ed0ec54f17a87b76da0;674e8e45ec54f17a87b6aef7;674e91f7ec54f17a87bb2b78;674e8de1ec54f17a87b64ad7;674e8f32ec54f17a87b7f4e5;674e8ed7ec54f17a87b77733;674e8fc9ec54f17a87b8b7ae;674e9161ec54f17a87baa9c9;674e8ff0ec54f17a87b8e69c;674e90c4ec54f17a87ba192c",
        },
        {
          value: "synthesize",
          count: 75,
          keywordIds:
            "674e8ff7ec54f17a87b8ef8f;674e8ec9ec54f17a87b7658d;674e8f25ec54f17a87b7e30f;674e8eefec54f17a87b7965e;674e8edcec54f17a87b77d0e;674e8f77ec54f17a87b84cfa;674e8e6dec54f17a87b6f050;674e8fddec54f17a87b8d00f;674e8f1cec54f17a87b7d0cc;674e8eaaec54f17a87b73df4;674e91eaec54f17a87bb212d;674e8ec7ec54f17a87b76335;674e91f6ec54f17a87bb2abb;674e8f3cec54f17a87b80271;674e8d0eec54f17a87b5814f;674e9083ec54f17a87b9be04;674e91beec54f17a87bafdcc;674e918aec54f17a87bad257;674e8ef8ec54f17a87b7a185;674e9102ec54f17a87ba550b;674e8fbcec54f17a87b8a67d;674e8feeec54f17a87b8e44a;674e8f48ec54f17a87b81102;674e8e9bec54f17a87b72bb7;674e8f29ec54f17a87b7e972;674e8f08ec54f17a87b7b664;674e8d66ec54f17a87b5d732;674e8e7cec54f17a87b703c6;674e8ffeec54f17a87b8f85a;674e91a9ec54f17a87baec0e;674e900cec54f17a87b909c6;674e8d53ec54f17a87b5c599;674e8e31ec54f17a87b69bce;674e91deec54f17a87bb17c6;674e8cfaec54f17a87b56db0;674e90d2ec54f17a87ba26b1;674e911fec54f17a87ba6e4a;674e912fec54f17a87ba7d17;674e8d85ec54f17a87b5f620;674e8cf6ec54f17a87b56961;674e8d82ec54f17a87b5f32b;674e9094ec54f17a87b9d67a;674e9110ec54f17a87ba6126;674e8e61ec54f17a87b6e0d3;674e8f28ec54f17a87b7e726;674e9042ec54f17a87b94c06;674e8e8fec54f17a87b71bc0;674e9022ec54f17a87b92455;674e9024ec54f17a87b92626;674e901dec54f17a87b91e3d;674e8fb9ec54f17a87b8a329;674e8fdbec54f17a87b8cd17;674e8faeec54f17a87b8957f;674e8f53ec54f17a87b82075;674e8f0fec54f17a87b7bf9a;674e90ddec54f17a87ba3211;674e8e1eec54f17a87b68a71;674e913eec54f17a87ba8a04;674e8dd1ec54f17a87b63c4c;674e8f07ec54f17a87b7b42a;674e8e2fec54f17a87b69a5b;674e8edaec54f17a87b77a4d;674e8e57ec54f17a87b6c129;674e901aec54f17a87b91b29;674e912bec54f17a87ba7961",
        },
        {
          value: "cross-platform",
          count: 74,
          keywordIds:
            "674e8f68ec54f17a87b83a52;674e8ec2ec54f17a87b75cb8;674e8fbdec54f17a87b8a810;674e90c0ec54f17a87ba147c;674e8ecdec54f17a87b76999;674e8f6eec54f17a87b84127;674e8fb1ec54f17a87b8986f;674e8fd4ec54f17a87b8c522;674e9031ec54f17a87b936de;674e8eecec54f17a87b7925e;674e9067ec54f17a87b98f18;674e9144ec54f17a87ba8ea4;674e9139ec54f17a87ba854d;674e8e21ec54f17a87b68c9f;674e8e07ec54f17a87b672d1;674e8ef3ec54f17a87b79bac;674e9026ec54f17a87b9291d;674e8e7bec54f17a87b701cd;674e8fc3ec54f17a87b8afb0;674e910eec54f17a87ba5f9d;674e9066ec54f17a87b98d60;674e8f91ec54f17a87b86ead;674e8e6aec54f17a87b6ebe9;674e8e9bec54f17a87b72b1f;674e9053ec54f17a87b968f9;674e9019ec54f17a87b919af;674e8f23ec54f17a87b7e164;674e8f9cec54f17a87b87f06;674e900bec54f17a87b907a3;674e8dd3ec54f17a87b63e7c;674e8f38ec54f17a87b7fd4c;674e8fe1ec54f17a87b8d4b4;674e8d7eec54f17a87b5efb6;674e8cfbec54f17a87b56e30;674e8e8bec54f17a87b71765;674e8dd8ec54f17a87b6426b;674e8e86ec54f17a87b7111e;674e8faeec54f17a87b894ec;674e8f07ec54f17a87b7b546;674e90efec54f17a87ba422b;674e8d3bec54f17a87b5ade6;674e8ea8ec54f17a87b73c1b;674e8ebfec54f17a87b75914;674e8f15ec54f17a87b7c811;674e8f12ec54f17a87b7c43b;674e9082ec54f17a87b9bb1c;674e8d25ec54f17a87b5989a;674e90dcec54f17a87ba30b7;674e8dcbec54f17a87b6372a;674e8f75ec54f17a87b84ab6;674e8e5dec54f17a87b6daf1;674e9034ec54f17a87b93a46;674e8e08ec54f17a87b6748e;674e91e9ec54f17a87bb2051;674e8e7eec54f17a87b705dd;674e8f07ec54f17a87b7b45a;674e8e52ec54f17a87b6bbd8;674e9116ec54f17a87ba666b;674e8fa0ec54f17a87b8839b;674e90b8ec54f17a87ba0888;674e90bdec54f17a87ba0f9a",
        },
        {
          value: "mobile",
          count: 74,
          keywordIds:
            "674e8ddbec54f17a87b644a3;674e8f25ec54f17a87b7e370;674e8eefec54f17a87b796bd;674e9094ec54f17a87b9d694;674e8dbbec54f17a87b628f0;674e8d3eec54f17a87b5b1b2;674e902dec54f17a87b9323f;674e91a0ec54f17a87bae3bb;674e91f6ec54f17a87bb2ad3;674e8e6bec54f17a87b6edf1;674e8f11ec54f17a87b7c220;674e8e3cec54f17a87b6a6cc;674e9120ec54f17a87ba6f96;674e8febec54f17a87b8e143;674e8f83ec54f17a87b85d76;674e9070ec54f17a87b99f09;674e8d70ec54f17a87b5e0e1;674e8d2bec54f17a87b59f02;674e9093ec54f17a87b9d4fb;674e9064ec54f17a87b98a1f;674e9050ec54f17a87b9647d;674e8ebfec54f17a87b758eb;674e9079ec54f17a87b9ae70;674e91a2ec54f17a87bae619;674e91a2ec54f17a87bae580;674e9076ec54f17a87b9a90b;674e8de6ec54f17a87b64f61;674e8d31ec54f17a87b5a4fb;674e8cfeec54f17a87b5710a;674e8e7cec54f17a87b703fc;674e8f39ec54f17a87b7fea3;674e91aaec54f17a87baec58;674e90fcec54f17a87ba4f40;674e8eccec54f17a87b76841;674e8f89ec54f17a87b86518;674e901cec54f17a87b91d77;674e8f81ec54f17a87b859fc;674e8ea3ec54f17a87b7354a;674e8fa9ec54f17a87b88eb0;674e8d85ec54f17a87b5f653;674e9000ec54f17a87b8fb7c;674e8d64ec54f17a87b5d55c;674e8e68ec54f17a87b6ea26;674e90bbec54f17a87ba0d11;674e901aec54f17a87b91b1d;674e91adec54f17a87baef52;674e9006ec54f17a87b9021c;674e902fec54f17a87b934cd;674e8e8fec54f17a87b71c05;674e8d42ec54f17a87b5b53a;674e8edcec54f17a87b77ce9;674e901eec54f17a87b91f4e;674e8e3dec54f17a87b6a7c6;674e8d73ec54f17a87b5e452;674e8eb7ec54f17a87b74ea1;674e8d14ec54f17a87b586e4;674e8d39ec54f17a87b5ac8d;674e8f44ec54f17a87b80c06;674e8e39ec54f17a87b6a34a;674e8fe9ec54f17a87b8de53;674e91ecec54f17a87bb22a4;674e9036ec54f17a87b93ce8;674e90b6ec54f17a87ba0683;674e90edec54f17a87ba40d6;674e90c5ec54f17a87ba194e",
        },
        {
          value: "primary",
          count: 73,
          keywordIds:
            "674e9080ec54f17a87b9b965;674e8f68ec54f17a87b8396a;674e8e0dec54f17a87b6789b;674e907cec54f17a87b9b2d6;674e8f49ec54f17a87b813a4;674e8dc8ec54f17a87b63432;674e9074ec54f17a87b9a614;674e8f1cec54f17a87b7d0fa;674e8ec7ec54f17a87b76369;674e917eec54f17a87bac893;674e8eedec54f17a87b79322;674e8fa8ec54f17a87b88d28;674e903bec54f17a87b942c8;674e8e85ec54f17a87b70fb4;674e9063ec54f17a87b9886b;674e8f61ec54f17a87b83062;674e8f1eec54f17a87b7d38d;674e8f2cec54f17a87b7ed6d;674e9163ec54f17a87baab9e;674e8fddec54f17a87b8cf5c;674e8e2dec54f17a87b697ca;674e8f42ec54f17a87b80922;674e9180ec54f17a87bac9ba;674e8dcaec54f17a87b635fa;674e8f0aec54f17a87b7b943;674e8fc1ec54f17a87b8ac69;674e91b6ec54f17a87baf795;674e9085ec54f17a87b9c082;674e8e18ec54f17a87b684c3;674e8fc8ec54f17a87b8b5b2;674e8e72ec54f17a87b6f6df;674e8e6fec54f17a87b6f33b;674e9026ec54f17a87b92883;674e9137ec54f17a87ba8302;674e8dadec54f17a87b61b9d;674e8f0bec54f17a87b7bb0e;674e8e42ec54f17a87b6abb3;674e8d02ec54f17a87b574eb;674e9047ec54f17a87b95309;674e903bec54f17a87b942bd;674e8d95ec54f17a87b604a9;674e8f6fec54f17a87b842ce;674e8fabec54f17a87b891ee;674e8db0ec54f17a87b61e4a;674e8d4aec54f17a87b5bdc0;674e9122ec54f17a87ba70e5;674e8f62ec54f17a87b8323b;674e8f70ec54f17a87b843d8;674e8fe5ec54f17a87b8d982;674e8e8aec54f17a87b7156a;674e8f4dec54f17a87b81843;674e919bec54f17a87bae07b;674e8eeeec54f17a87b7949e;674e8e5cec54f17a87b6d9e1;674e8fdaec54f17a87b8cccd;674e8d2cec54f17a87b59fc0;674e9047ec54f17a87b952fe;674e9014ec54f17a87b913be;674e8f50ec54f17a87b81bba;674e8efaec54f17a87b7a4be;674e911bec54f17a87ba6a7f;674e8e56ec54f17a87b6bfe1;674e8f08ec54f17a87b7b6a3;674e906fec54f17a87b99d45;674e8fc9ec54f17a87b8b6fa",
        },
        {
          value: "neural",
          count: 69,
          keywordIds:
            "674e8fe3ec54f17a87b8d6ed;674e8d97ec54f17a87b606c1;674e903eec54f17a87b9472e;674e8fe2ec54f17a87b8d603;674e90c6ec54f17a87ba1a6d;674e9040ec54f17a87b94908;674e8f58ec54f17a87b82638;674e8d21ec54f17a87b59570;674e8fb1ec54f17a87b8997d;674e8f2bec54f17a87b7eb1f;674e8e84ec54f17a87b70e9d;674e909aec54f17a87b9df1d;674e903aec54f17a87b941e8;674e905fec54f17a87b982be;674e8d9dec54f17a87b60d00;674e8f5eec54f17a87b82d2a;674e8daaec54f17a87b6197a;674e9089ec54f17a87b9c6a0;674e8fe0ec54f17a87b8d3c7;674e8eddec54f17a87b77f19;674e9000ec54f17a87b8fa63;674e91c0ec54f17a87baff61;674e8e7bec54f17a87b702a9;674e90d5ec54f17a87ba29d1;674e915bec54f17a87baa562;674e8ea1ec54f17a87b73251;674e8f5aec54f17a87b828d8;674e91d7ec54f17a87bb1180;674e90ccec54f17a87ba2022;674e8e87ec54f17a87b71205;674e8ec6ec54f17a87b7611b;674e905eec54f17a87b97f43;674e9085ec54f17a87b9c03b;674e8e5bec54f17a87b6d851;674e8dcdec54f17a87b63997;674e91fbec54f17a87bb2e9e;674e917aec54f17a87babf4b;674e906aec54f17a87b9948e;674e9058ec54f17a87b9732d;674e9041ec54f17a87b94b69;674e8f48ec54f17a87b81226;674e8f00ec54f17a87b7ac32;674e8ed7ec54f17a87b7775e;674e905dec54f17a87b97d45;674e9143ec54f17a87ba8dc5;674e8f95ec54f17a87b874b7;674e91b2ec54f17a87baf34d;674e9192ec54f17a87bad8b8;674e8ee7ec54f17a87b78b98;674e8e63ec54f17a87b6e364;674e8d4cec54f17a87b5bf5a;674e8f0fec54f17a87b7bfd8;674e8fc2ec54f17a87b8ae14;674e8ed4ec54f17a87b7727f;674e8f50ec54f17a87b81c38;674e8e8eec54f17a87b71a7c;674e8f24ec54f17a87b7e2a2;674e8dd0ec54f17a87b63bf1;674e90b4ec54f17a87ba039e;674e8d3cec54f17a87b5aef6;674e8d35ec54f17a87b5a8e2;674e8d19ec54f17a87b58ca5;674e8e4aec54f17a87b6b466",
        },
        {
          value: "optical",
          count: 68,
          keywordIds:
            "674e9072ec54f17a87b9a20f;674e91bdec54f17a87bafd1c;674e907bec54f17a87b9b1bc;674e8eb0ec54f17a87b74656;674e90f6ec54f17a87ba48ed;674e91caec54f17a87bb07dd;674e8d36ec54f17a87b5aa2b;674e8d60ec54f17a87b5d187;674e8d77ec54f17a87b5e8c7;674e9045ec54f17a87b94f20;674e8e7dec54f17a87b7048c;674e916dec54f17a87bab3d3;674e91c4ec54f17a87bb033f;674e905fec54f17a87b98177;674e9002ec54f17a87b8fce9;674e91d2ec54f17a87bb0dcc;674e90c9ec54f17a87ba1d96;674e8fedec54f17a87b8e39d;674e9096ec54f17a87b9d88f;674e8cf9ec54f17a87b56c5b;674e8f85ec54f17a87b85fbb;674e8d66ec54f17a87b5d763;674e8f9dec54f17a87b87ff6;674e900cec54f17a87b908ea;674e91f3ec54f17a87bb2868;674e90baec54f17a87ba0bd5;674e91e2ec54f17a87bb1b3f;674e8fceec54f17a87b8be39;674e9036ec54f17a87b93cf3;674e909cec54f17a87b9e1a6;674e8db9ec54f17a87b62745;674e8ea0ec54f17a87b7309a;674e9056ec54f17a87b96ee2;674e8ec7ec54f17a87b76341;674e8f4dec54f17a87b818a4;674e8d26ec54f17a87b59a6e;674e8e9cec54f17a87b72c77;674e9027ec54f17a87b92a13;674e8eaaec54f17a87b73dac;674e8d92ec54f17a87b601b9;674e903fec54f17a87b948bb;674e900eec54f17a87b90c50;674e8e97ec54f17a87b72576;674e9051ec54f17a87b96665;674e8fb0ec54f17a87b89785;674e8f8cec54f17a87b86950;674e8e64ec54f17a87b6e470;674e8fc7ec54f17a87b8b49a;674e8d79ec54f17a87b5eabc;674e8f34ec54f17a87b7f822;674e8ee0ec54f17a87b78279;674e8f17ec54f17a87b7ca3b;674e91fdec54f17a87bb2fd9;674e90a4ec54f17a87b9ecef;674e9051ec54f17a87b96576;674e8f26ec54f17a87b7e4bc;674e8f18ec54f17a87b7cc37;674e8d35ec54f17a87b5a841;674e8fa6ec54f17a87b88aa9;674e9161ec54f17a87baaa01",
        },
        {
          value: "bluetooth",
          count: 66,
          keywordIds:
            "674e9088ec54f17a87b9c527;674e8eecec54f17a87b791d2;674e8f0bec54f17a87b7ba89;674e9004ec54f17a87b8fff1;674e8de7ec54f17a87b6504f;674e8d28ec54f17a87b59bf7;674e8f63ec54f17a87b832c3;674e901fec54f17a87b92118;674e90bfec54f17a87ba1284;674e9052ec54f17a87b96824;674e8d0bec54f17a87b57ea6;674e9015ec54f17a87b91451;674e8eacec54f17a87b73fb8;674e8eaeec54f17a87b742e1;674e8f05ec54f17a87b7b272;674e8eb5ec54f17a87b74c85;674e8e11ec54f17a87b67d8b;674e8f83ec54f17a87b85c77;674e9159ec54f17a87baa3d6;674e9062ec54f17a87b98749;674e8ed2ec54f17a87b76ff6;674e9128ec54f17a87ba7715;674e91d8ec54f17a87bb1287;674e8d15ec54f17a87b5883a;674e8f33ec54f17a87b7f5a7;674e8f0aec54f17a87b7b889;674e8f48ec54f17a87b81138;674e8e8cec54f17a87b71898;674e8f55ec54f17a87b8221e;674e8ebdec54f17a87b756af;674e90a7ec54f17a87b9f29d;674e9132ec54f17a87ba7efd;674e9149ec54f17a87ba9297;674e90afec54f17a87b9fc91;674e8f2eec54f17a87b7eef5;674e8f0aec54f17a87b7b8b0;674e90a1ec54f17a87b9e9c1;674e8e5fec54f17a87b6deb6;674e9010ec54f17a87b90e94;674e8e83ec54f17a87b70d71;674e9110ec54f17a87ba61a5;674e8e62ec54f17a87b6e1c0;674e8edfec54f17a87b7815f;674e8f2fec54f17a87b7f0ba;674e8fa1ec54f17a87b88480;674e9023ec54f17a87b9250c;674e90b1ec54f17a87b9ff25;674e9024ec54f17a87b92728;674e8f10ec54f17a87b7c0a8;674e8f35ec54f17a87b7f890;674e9022ec54f17a87b92448;674e8eeeec54f17a87b795dd;674e8d9fec54f17a87b60ea3;674e8f1cec54f17a87b7d11c;674e902dec54f17a87b93101;674e90b7ec54f17a87ba07bc;674e8e24ec54f17a87b68f61;674e8f74ec54f17a87b8485d;674e912bec54f17a87ba798e;674e8ed6ec54f17a87b7759e",
        },
        {
          value: "redundant",
          count: 65,
          keywordIds:
            "674e901cec54f17a87b91d38;674e8df4ec54f17a87b65bae;674e8e0dec54f17a87b6798b;674e8fbeec54f17a87b8a949;674e8f4aec54f17a87b813ef;674e8f21ec54f17a87b7d8d7;674e91c4ec54f17a87bb029e;674e8f77ec54f17a87b84d41;674e8ff3ec54f17a87b8eb88;674e9071ec54f17a87b9a141;674e8d29ec54f17a87b59d91;674e8dabec54f17a87b61a4e;674e90acec54f17a87b9f8a4;674e9203ec54f17a87bb3518;674e8cffec54f17a87b57279;674e90e7ec54f17a87ba3b91;674e8e43ec54f17a87b6ad7c;674e8d7bec54f17a87b5ed54;674e8fcbec54f17a87b8b9ae;674e8ed8ec54f17a87b778c1;674e8eb4ec54f17a87b74b8f;674e8e6fec54f17a87b6f308;674e8e95ec54f17a87b7242f;674e8e25ec54f17a87b690d7;674e90e2ec54f17a87ba3668;674e8f4bec54f17a87b8150e;674e8ffdec54f17a87b8f7d2;674e906aec54f17a87b99517;674e8d01ec54f17a87b573bd;674e8ffaec54f17a87b8f3b0;674e9104ec54f17a87ba5748;674e911cec54f17a87ba6bc0;674e8d4aec54f17a87b5bcc7;674e8fe7ec54f17a87b8dca4;674e8d83ec54f17a87b5f4ba;674e8e8cec54f17a87b718bb;674e8f4cec54f17a87b816d7;674e8f61ec54f17a87b83046;674e9007ec54f17a87b90403;674e90a3ec54f17a87b9ec3a;674e8faaec54f17a87b88feb;674e8e6bec54f17a87b6ed7c;674e8d9cec54f17a87b60c4b;674e8df6ec54f17a87b65d5a;674e91e0ec54f17a87bb1974;674e90f0ec54f17a87ba4358;674e8f89ec54f17a87b86502;674e8f2dec54f17a87b7ee5e;674e8eceec54f17a87b76ad5;674e8deeec54f17a87b655c1;674e8fb8ec54f17a87b8a1f1;674e8ec6ec54f17a87b76121;674e8d45ec54f17a87b5b902;674e8fbbec54f17a87b8a5cd;674e8f7dec54f17a87b85576;674e909dec54f17a87b9e255;674e91e4ec54f17a87bb1d0f;674e908dec54f17a87b9ccbd",
        },
        {
          value: "digital",
          count: 64,
          keywordIds:
            "674e8f0eec54f17a87b7be5f;674e917cec54f17a87bac64a;674e8f0dec54f17a87b7bced;674e8f86ec54f17a87b8618c;674e8e75ec54f17a87b6fa8f;674e902aec54f17a87b92dd9;674e8ff4ec54f17a87b8ec96;674e90dbec54f17a87ba2ffe;674e8eafec54f17a87b74419;674e9201ec54f17a87bb3316;674e8e98ec54f17a87b72782;674e8e8eec54f17a87b71a03;674e8f8fec54f17a87b86c91;674e8e75ec54f17a87b6fb66;674e8ff5ec54f17a87b8ed7a;674e9038ec54f17a87b93fa7;674e8ed2ec54f17a87b770c6;674e9107ec54f17a87ba5a1a;674e91abec54f17a87baedd3;674e8fbcec54f17a87b8a6c3;674e902bec54f17a87b92f4f;674e8ef5ec54f17a87b79e65;674e900dec54f17a87b90b3a;674e8fc1ec54f17a87b8ad3d;674e91baec54f17a87bafa87;674e8d7aec54f17a87b5eb9d;674e8d71ec54f17a87b5e236;674e9057ec54f17a87b9721a;674e8f63ec54f17a87b83434;674e9046ec54f17a87b950dc;674e8f6cec54f17a87b83e05;674e90b0ec54f17a87b9fd8f;674e8ed0ec54f17a87b76d88;674e8e79ec54f17a87b6ff85;674e8da2ec54f17a87b6120a;674e8fefec54f17a87b8e59a;674e8e0aec54f17a87b67604;674e8e14ec54f17a87b68082;674e912dec54f17a87ba7a77;674e8e90ec54f17a87b71cbb;674e8f05ec54f17a87b7b18f;674e8f71ec54f17a87b84558;674e902cec54f17a87b930c5;674e8f3eec54f17a87b80460;674e90f8ec54f17a87ba4b1e;674e8fadec54f17a87b89406;674e8eb0ec54f17a87b7462d;674e8ea3ec54f17a87b7340f;674e8fb9ec54f17a87b8a350;674e8f4cec54f17a87b8165b;674e90beec54f17a87ba1192;674e8edeec54f17a87b7808e;674e8d58ec54f17a87b5c9dc;674e8fb4ec54f17a87b89d07;674e8fc7ec54f17a87b8b4d5;674e8ea4ec54f17a87b7358c;674e8dfaec54f17a87b66595;674e8dcfec54f17a87b63a9b;674e9000ec54f17a87b8fb87;674e90a5ec54f17a87b9eece",
        },
        {
          value: "xml",
          count: 52,
          keywordIds:
            "674e8df5ec54f17a87b65bd2;674e8f98ec54f17a87b878aa;674e90b7ec54f17a87ba074e;674e8d28ec54f17a87b59c34;674e8f87ec54f17a87b861be;674e8e75ec54f17a87b6fad6;674e9171ec54f17a87bab7a7;674e8f86ec54f17a87b860e9;674e8e00ec54f17a87b66bfc;674e8eacec54f17a87b74015;674e8d2aec54f17a87b59db1;674e9144ec54f17a87ba8ed2;674e8ef6ec54f17a87b79f62;674e91b0ec54f17a87baf1ba;674e8fcbec54f17a87b8b9df;674e8f7aec54f17a87b8502e;674e91acec54f17a87baedf5;674e8fddec54f17a87b8cf94;674e9032ec54f17a87b93864;674e8e95ec54f17a87b723b0;674e8d92ec54f17a87b60240;674e8d30ec54f17a87b5a430;674e8ea4ec54f17a87b73679;674e8ef4ec54f17a87b79c7c;674e8e47ec54f17a87b6b109;674e9075ec54f17a87b9a8cf;674e8d05ec54f17a87b578d4;674e908eec54f17a87b9ce51;674e8da1ec54f17a87b6111b;674e912dec54f17a87ba7a92;674e8e5aec54f17a87b6d72a;674e8e8eec54f17a87b71b3a;674e8d41ec54f17a87b5b49c;674e8f66ec54f17a87b8378c;674e8e6aec54f17a87b6ec9d;674e8df7ec54f17a87b65d75;674e8fb9ec54f17a87b8a2b2;674e8f1cec54f17a87b7d152;674e902dec54f17a87b9313a;674e8e1fec54f17a87b68a9f;674e8f38ec54f17a87b7fd26;674e8f34ec54f17a87b7f764;674e91f7ec54f17a87bb2bb1;674e8eadec54f17a87b74271;674e8f03ec54f17a87b7af76",
        },
        {
          value: "tls",
          count: 50,
          keywordIds:
            "674e9173ec54f17a87bab987;674e8e13ec54f17a87b67ee2;674e8f0aec54f17a87b7b9c1;674e8df5ec54f17a87b65c70;674e8cfcec54f17a87b56f71;674e91a0ec54f17a87bae3db;674e9013ec54f17a87b91297;674e8e3cec54f17a87b6a6f3;674e9044ec54f17a87b94e75;674e8e06ec54f17a87b67210;674e8d23ec54f17a87b597a1;674e8ff3ec54f17a87b8ea7c;674e918aec54f17a87bad285;674e8e6fec54f17a87b6f339;674e8f1eec54f17a87b7d452;674e8db1ec54f17a87b61f6c;674e8fd2ec54f17a87b8c2c9;674e8e34ec54f17a87b69eca;674e900bec54f17a87b907ae;674e9105ec54f17a87ba578b;674e900bec54f17a87b908ba;674e91a7ec54f17a87bae9e8;674e8da4ec54f17a87b61328;674e907eec54f17a87b9b58a;674e9187ec54f17a87bacfaf;674e8d83ec54f17a87b5f473;674e8d9aec54f17a87b609f2;674e8dc0ec54f17a87b62d01;674e8feeec54f17a87b8e519;674e9110ec54f17a87ba61e6;674e8f47ec54f17a87b81025;674e90f7ec54f17a87ba4a65;674e90b9ec54f17a87ba0ac9;674e8d9dec54f17a87b60c68;674e908cec54f17a87b9caf2;674e90cbec54f17a87ba1ef4;674e9055ec54f17a87b96c9e;674e8f75ec54f17a87b84aee;674e8decec54f17a87b65409;674e8f8aec54f17a87b866a6;674e8f1dec54f17a87b7d2a3;674e8fbcec54f17a87b8a5f6;674e90a4ec54f17a87b9edf6;674e8e56ec54f17a87b6bf62;674e8f08ec54f17a87b7b5df;674e908dec54f17a87b9ccfa",
        },
        {
          value: "thx",
          count: 48,
          keywordIds:
            "674e8fe3ec54f17a87b8d7b4;674e8d6cec54f17a87b5dc0e;674e8ee9ec54f17a87b78ef0;674e8f0cec54f17a87b7bc3c;674e8edcec54f17a87b77d50;674e8e77ec54f17a87b6fe08;674e8e5eec54f17a87b6dd81;674e8f58ec54f17a87b8265e;674e8e1dec54f17a87b689d4;674e8d5aec54f17a87b5cc6a;674e8e3fec54f17a87b6a9cd;674e8e67ec54f17a87b6e90f;674e8e21ec54f17a87b68ce6;674e8ef0ec54f17a87b79818;674e9152ec54f17a87ba9b6a;674e90a3ec54f17a87b9ebde;674e8d0aec54f17a87b57d71;674e91aaec54f17a87baeca3;674e8d8cec54f17a87b5fc97;674e8f54ec54f17a87b821b5;674e91dfec54f17a87bb1860;674e90cdec54f17a87ba2101;674e904eec54f17a87b95c03;674e8d63ec54f17a87b5d399;674e90a1ec54f17a87b9e8d4;674e8ea6ec54f17a87b738d5;674e8eb3ec54f17a87b749b9;674e8f01ec54f17a87b7ad0f;674e8d1aec54f17a87b58e1f;674e8e5aec54f17a87b6d6c1;674e8ebfec54f17a87b75894;674e8faaec54f17a87b89018;674e8ecfec54f17a87b76b9e;674e8d72ec54f17a87b5e36c;674e8eeeec54f17a87b79523;674e8d58ec54f17a87b5ca21;674e8e99ec54f17a87b72899;674e8debec54f17a87b65342;674e91dbec54f17a87bb14e8;674e9137ec54f17a87ba83d2",
        },
        {
          value: "sdd",
          count: 48,
          keywordIds:
            "674e8d97ec54f17a87b60701;674e9065ec54f17a87b98c6a;674e8f9fec54f17a87b8822c;674e907cec54f17a87b9b314;674e8f71ec54f17a87b8444b;674e8ef4ec54f17a87b79ce6;674e9072ec54f17a87b9a21a;674e91c2ec54f17a87bb0157;674e8e11ec54f17a87b67d2b;674e91c9ec54f17a87bb072f;674e9003ec54f17a87b8ff45;674e8ef8ec54f17a87b7a231;674e918dec54f17a87bad4db;674e9108ec54f17a87ba5a33;674e910eec54f17a87ba5f4f;674e8fe9ec54f17a87b8de19;674e8fd9ec54f17a87b8cb1a;674e9065ec54f17a87b98ca1;674e902bec54f17a87b92fd2;674e9077ec54f17a87b9aa4d;674e8e74ec54f17a87b6f999;674e9188ec54f17a87bad106;674e9134ec54f17a87ba8102;674e9125ec54f17a87ba7391;674e8ebcec54f17a87b75460;674e8f6eec54f17a87b84086;674e9008ec54f17a87b90436;674e8efdec54f17a87b7a86e;674e90e6ec54f17a87ba3a23;674e913aec54f17a87ba8622;674e9091ec54f17a87b9d24b;674e900fec54f17a87b90c94;674e8f19ec54f17a87b7cdad;674e8e3bec54f17a87b6a615;674e8e80ec54f17a87b708e5;674e8e5bec54f17a87b6d924;674e8fafec54f17a87b895f3;674e8fb8ec54f17a87b8a127;674e8f99ec54f17a87b87a8f;674e8e79ec54f17a87b6ff71;674e8f50ec54f17a87b81c12;674e8e7eec54f17a87b70615;674e8f18ec54f17a87b7cbc8",
        },
        {
          value: "json",
          count: 47,
          keywordIds:
            "674e9061ec54f17a87b98551;674e8fe1ec54f17a87b8d4ee;674e8f41ec54f17a87b807a3;674e90f6ec54f17a87ba492d;674e8fbfec54f17a87b8aa75;674e8fa8ec54f17a87b88d43;674e8d77ec54f17a87b5e8fd;674e8ff1ec54f17a87b8e894;674e8f8eec54f17a87b86bf3;674e8fe4ec54f17a87b8d837;674e9119ec54f17a87ba68de;674e8ed3ec54f17a87b770ed;674e8f5eec54f17a87b82d5c;674e8daaec54f17a87b618b6;674e8f42ec54f17a87b8094f;674e9096ec54f17a87b9d978;674e8dc6ec54f17a87b6322c;674e91a3ec54f17a87bae63e;674e9018ec54f17a87b918ef;674e8f5bec54f17a87b829c5;674e8fa6ec54f17a87b88a76;674e8f0bec54f17a87b7ba5b;674e914dec54f17a87ba9628;674e909cec54f17a87b9e1f2;674e8ecaec54f17a87b765cb;674e8f45ec54f17a87b80e16;674e8f55ec54f17a87b82277;674e8f61ec54f17a87b83161;674e8fa9ec54f17a87b88ede;674e9058ec54f17a87b97391;674e9158ec54f17a87baa2cd;674e8e05ec54f17a87b670c9;674e903aec54f17a87b94160;674e8edbec54f17a87b77c18;674e8d38ec54f17a87b5ab9b;674e90efec54f17a87ba42da;674e9023ec54f17a87b925e6;674e8d58ec54f17a87b5ca8e;674e8f07ec54f17a87b7b4da;674e90e9ec54f17a87ba3d5e;674e90b6ec54f17a87ba06c9;674e9133ec54f17a87ba8068;674e8eafec54f17a87b744f8;674e8fdeec54f17a87b8d0ff",
        },
        {
          value: "ocr",
          count: 47,
          keywordIds:
            "674e9049ec54f17a87b95551;674e8fb6ec54f17a87b89f3d;674e8d2dec54f17a87b5a119;674e8f8fec54f17a87b86c53;674e8f78ec54f17a87b84e09;674e8ff4ec54f17a87b8ec73;674e8d3fec54f17a87b5b1e1;674e91f6ec54f17a87bb2a87;674e8f2bec54f17a87b7ec14;674e8d22ec54f17a87b59599;674e8d29ec54f17a87b59d53;674e9194ec54f17a87badab5;674e919dec54f17a87bae18e;674e8fdfec54f17a87b8d2ba;674e905fec54f17a87b981d1;674e8f95ec54f17a87b87559;674e8f33ec54f17a87b7f651;674e8fcbec54f17a87b8b9bc;674e8ebfec54f17a87b75925;674e8db2ec54f17a87b6207d;674e8f85ec54f17a87b85f12;674e915bec54f17a87baa596;674e8d1fec54f17a87b59365;674e91f4ec54f17a87bb2909;674e905cec54f17a87b97c6e;674e9083ec54f17a87b9bd04;674e901cec54f17a87b91d09;674e8ec1ec54f17a87b75c17;674e8f28ec54f17a87b7e76f;674e8f00ec54f17a87b7ab5c;674e8f5aec54f17a87b8282a;674e8f4cec54f17a87b81762;674e9127ec54f17a87ba752e;674e8e5dec54f17a87b6daa5;674e8fe6ec54f17a87b8db37;674e8e67ec54f17a87b6e831;674e8eb7ec54f17a87b74eda;674e8eb9ec54f17a87b751a3;674e8ff0ec54f17a87b8e74a;674e8fbeec54f17a87b8a857;674e90d1ec54f17a87ba2626;674e8f26ec54f17a87b7e51b",
        },
        {
          value: "sms",
          count: 46,
          keywordIds:
            "674e919aec54f17a87badf52;674e8fbeec54f17a87b8a832;674e90c2ec54f17a87ba16e5;674e8dc9ec54f17a87b634ef;674e8d0cec54f17a87b57ecc;674e8f10ec54f17a87b7c188;674e8e75ec54f17a87b6fab0;674e8dd6ec54f17a87b640b2;674e9064ec54f17a87b98a73;674e9128ec54f17a87ba7675;674e8dfcec54f17a87b66806;674e91edec54f17a87bb23b3;674e8fc1ec54f17a87b8aca5;674e911cec54f17a87ba6bf1;674e8e10ec54f17a87b67be4;674e9117ec54f17a87ba6792;674e8cfbec54f17a87b56dd3;674e9017ec54f17a87b915e1;674e8dc2ec54f17a87b62ee2;674e8d75ec54f17a87b5e652;674e8f2dec54f17a87b7ee53;674e9168ec54f17a87baaf82;674e8d4bec54f17a87b5be6c;674e8ff4ec54f17a87b8eced;674e8f85ec54f17a87b85fc7;674e8e66ec54f17a87b6e722;674e8f27ec54f17a87b7e5ea;674e9021ec54f17a87b9227d;674e8f70ec54f17a87b84312;674e90f0ec54f17a87ba43d0;674e8f2dec54f17a87b7ee92;674e8fdbec54f17a87b8cd51;674e90beec54f17a87ba120a;674e9054ec54f17a87b96b7f;674e8e15ec54f17a87b68155;674e8f93ec54f17a87b87217;674e8ee5ec54f17a87b78944;674e8efaec54f17a87b7a44e;674e8f36ec54f17a87b7fa47;674e90a4ec54f17a87b9ed22;674e909cec54f17a87b9e1e6;674e8ed5ec54f17a87b774d2",
        },
        {
          value: "http",
          count: 46,
          keywordIds:
            "674e904bec54f17a87b9578e;674e91c4ec54f17a87bb02b6;674e8d06ec54f17a87b579a7;674e9080ec54f17a87b9b82c;674e8fb0ec54f17a87b897da;674e8fd4ec54f17a87b8c59a;674e917fec54f17a87bac8b6;674e90b0ec54f17a87b9fd9a;674e8e4cec54f17a87b6b5d8;674e8f84ec54f17a87b85ddd;674e8ff8ec54f17a87b8f16b;674e8f88ec54f17a87b86363;674e8d20ec54f17a87b593ec;674e915eec54f17a87baa7ef;674e8ee1ec54f17a87b78428;674e8fa6ec54f17a87b88b12;674e91ddec54f17a87bb16ef;674e8ec1ec54f17a87b75b38;674e8fd7ec54f17a87b8c8b1;674e8dcdec54f17a87b639c8;674e8facec54f17a87b8920e;674e9041ec54f17a87b94abb;674e8da1ec54f17a87b610b8;674e8f57ec54f17a87b82475;674e909dec54f17a87b9e30f;674e8f43ec54f17a87b80b4f;674e9101ec54f17a87ba5461;674e8eb4ec54f17a87b74b02;674e8edcec54f17a87b77d71;674e8f1bec54f17a87b7cf6c;674e916cec54f17a87bab344;674e8d76ec54f17a87b5e701;674e8f8dec54f17a87b86a32;674e8f75ec54f17a87b84a3a;674e8decec54f17a87b6546b;674e8edaec54f17a87b77b3d;674e9036ec54f17a87b93d37;674e8e52ec54f17a87b6bc0a;674e9051ec54f17a87b965bc;674e8f74ec54f17a87b848aa;674e8f67ec54f17a87b838c7;674e9106ec54f17a87ba5928;674e913cec54f17a87ba87bc",
        },
        {
          value: "ip",
          count: 44,
          keywordIds:
            "674e8ef0ec54f17a87b7980d;674e8eadec54f17a87b74132;674e8d12ec54f17a87b5852a;674e9129ec54f17a87ba7788;674e8f78ec54f17a87b84d61;674e8f0eec54f17a87b7be52;674e8fbcec54f17a87b8a5f5;674e8f87ec54f17a87b8619e;674e9068ec54f17a87b98ffd;674e9015ec54f17a87b91476;674e9042ec54f17a87b94c8e;674e9121ec54f17a87ba6fb4;674e8e73ec54f17a87b6f7dd;674e8f83ec54f17a87b85cbc;674e916dec54f17a87bab40c;674e91f9ec54f17a87bb2cf3;674e907aec54f17a87b9af4d;674e9026ec54f17a87b92938;674e911aec54f17a87ba69de;674e9054ec54f17a87b96c43;674e8ef5ec54f17a87b79e9c;674e8f9fec54f17a87b88225;674e8cfeec54f17a87b5707f;674e91f3ec54f17a87bb2893;674e8ecbec54f17a87b767b2;674e8eeeec54f17a87b7956d;674e8e64ec54f17a87b6e52a;674e8f8eec54f17a87b86b06;674e8e9aec54f17a87b72a49;674e8e86ec54f17a87b71157;674e917aec54f17a87babf7f;674e8e0aec54f17a87b6762d;674e9114ec54f17a87ba6497;674e8fffec54f17a87b8f9db;674e8f4dec54f17a87b818e0;674e8f1aec54f17a87b7ce0d;674e9124ec54f17a87ba7273;674e8fc2ec54f17a87b8ae49;674e8e4eec54f17a87b6b857;674e8fa6ec54f17a87b88b7f;674e8d30ec54f17a87b5a3a5",
        },
        {
          value: "ib",
          count: 43,
          keywordIds:
            "674e901cec54f17a87b91d64;674e903eec54f17a87b94787;674e9066ec54f17a87b98d33;674e8f5fec54f17a87b82e81;674e8f9dec54f17a87b880f1;674e8e6bec54f17a87b6eeb1;674e8ef2ec54f17a87b79a58;674e8eb9ec54f17a87b7509c;674e918eec54f17a87bad559;674e91abec54f17a87baed78;674e90b3ec54f17a87ba01f8;674e90e1ec54f17a87ba35dc;674e906aec54f17a87b99448;674e9164ec54f17a87baacd6;674e8d1dec54f17a87b59114;674e91a6ec54f17a87bae96f;674e8e31ec54f17a87b69ca9;674e9157ec54f17a87baa223;674e9147ec54f17a87ba913a;674e8e14ec54f17a87b6803b;674e9093ec54f17a87b9d4b0;674e910bec54f17a87ba5d01;674e8eb2ec54f17a87b74922;674e8ea9ec54f17a87b73c51;674e8fa1ec54f17a87b884d4;674e8e6bec54f17a87b6ee21;674e8f96ec54f17a87b876f0;674e8f4cec54f17a87b816b2;674e8f1cec54f17a87b7d0c0;674e8ee8ec54f17a87b78c40;674e8ee1ec54f17a87b7844f;674e8e02ec54f17a87b66d51;674e913eec54f17a87ba89cf;674e8e0fec54f17a87b67ab5;674e8f17ec54f17a87b7ca6e;674e8dd9ec54f17a87b6434e;674e8f09ec54f17a87b7b764;674e8e70ec54f17a87b6f44e",
        },
        {
          value: "hex",
          count: 43,
          keywordIds:
            "674e903cec54f17a87b943d3;674e90c3ec54f17a87ba1767;674e90dfec54f17a87ba339f;674e8f63ec54f17a87b83353;674e8fa3ec54f17a87b88740;674e8ff3ec54f17a87b8ebb6;674e9046ec54f17a87b950bb;674e8e20ec54f17a87b68c52;674e919eec54f17a87bae231;674e8ebcec54f17a87b754d1;674e9203ec54f17a87bb3555;674e91aeec54f17a87baefec;674e8e86ec54f17a87b71049;674e8f1eec54f17a87b7d3ca;674e9056ec54f17a87b9706c;674e8dc3ec54f17a87b6306e;674e8f19ec54f17a87b7cd4c;674e8fc1ec54f17a87b8ac86;674e8f6bec54f17a87b83d69;674e9086ec54f17a87b9c128;674e8ec0ec54f17a87b75a9f;674e8d84ec54f17a87b5f57c;674e914bec54f17a87ba9476;674e9043ec54f17a87b94d14;674e8fe4ec54f17a87b8d8f2;674e905cec54f17a87b97c70;674e9024ec54f17a87b926c1;674e8f23ec54f17a87b7ddfc;674e916fec54f17a87bab5c3;674e8effec54f17a87b7aa20;674e8d79ec54f17a87b5ea68;674e903cec54f17a87b944df;674e8d45ec54f17a87b5b831;674e8f9fec54f17a87b8831e;674e8fc9ec54f17a87b8b830;674e90edec54f17a87ba4074;674e90a5ec54f17a87b9eefc",
        },
        {
          value: "vga",
          count: 42,
          keywordIds:
            "674e903aec54f17a87b9413b;674e8f4aec54f17a87b8142e;674e8f94ec54f17a87b87410;674e8edbec54f17a87b77be3;674e8fcdec54f17a87b8bcb3;674e9021ec54f17a87b922c8;674e9070ec54f17a87b99e88;674e907bec54f17a87b9b124;674e9027ec54f17a87b929f0;674e8fa8ec54f17a87b88de8;674e8f5cec54f17a87b82b4a;674e8ed1ec54f17a87b76fd2;674e8e94ec54f17a87b721fa;674e908bec54f17a87b9c9a9;674e8e7bec54f17a87b702e7;674e908cec54f17a87b9cb30;674e9073ec54f17a87b9a4a7;674e8e74ec54f17a87b6f8fa;674e8ee2ec54f17a87b7854d;674e911eec54f17a87ba6dd2;674e8eefec54f17a87b79669;674e8ec9ec54f17a87b7652e;674e8d95ec54f17a87b6056f;674e8dd2ec54f17a87b63d4d;674e9168ec54f17a87baafe7;674e8f13ec54f17a87b7c59d;674e8ff6ec54f17a87b8ef40;674e909eec54f17a87b9e3c4;674e8f46ec54f17a87b80f61;674e8f17ec54f17a87b7ca7a;674e8e55ec54f17a87b6beda;674e8e09ec54f17a87b674d4;674e8d79ec54f17a87b5eae2;674e8ee6ec54f17a87b78ab0;674e8f37ec54f17a87b7fb93;674e903cec54f17a87b94435;674e901eec54f17a87b91f9b;674e8e30ec54f17a87b69af3;674e8dcfec54f17a87b63b03",
        },
        {
          value: "jbod",
          count: 42,
          keywordIds:
            "674e9089ec54f17a87b9c609;674e904aec54f17a87b9567a;674e8fe2ec54f17a87b8d639;674e9004ec54f17a87b9001d;674e90c0ec54f17a87ba13e4;674e90dbec54f17a87ba2f92;674e8e35ec54f17a87b6a012;674e8f06ec54f17a87b7b340;674e8e07ec54f17a87b67339;674e8d87ec54f17a87b5f858;674e8f1eec54f17a87b7d49c;674e8e4bec54f17a87b6b558;674e9075ec54f17a87b9a81a;674e8d0aec54f17a87b57cfb;674e8f2fec54f17a87b7f14a;674e8d7eec54f17a87b5efe7;674e8d52ec54f17a87b5c4c2;674e8e5bec54f17a87b6d7f0;674e9018ec54f17a87b91772;674e909aec54f17a87b9df08;674e8d64ec54f17a87b5d578;674e8ee9ec54f17a87b78f2c;674e9094ec54f17a87b9d60d;674e8e94ec54f17a87b7221d;674e8e65ec54f17a87b6e66a;674e9030ec54f17a87b934f3;674e8eb4ec54f17a87b74b7d;674e8f94ec54f17a87b87467;674e913fec54f17a87ba8aed;674e8fb0ec54f17a87b89846;674e908bec54f17a87b9c951;674e906fec54f17a87b99d0b;674e8e63ec54f17a87b6e3bd;674e9047ec54f17a87b95226;674e91ecec54f17a87bb2307;674e8ee5ec54f17a87b788d1;674e8efaec54f17a87b7a4e7;674e9115ec54f17a87ba6600;674e9000ec54f17a87b8faeb",
        },
        {
          value: "xss",
          count: 42,
          keywordIds:
            "674e9081ec54f17a87b9b9fe;674e8f0eec54f17a87b7bea7;674e8fb4ec54f17a87b89cae;674e8f22ec54f17a87b7dace;674e8eacec54f17a87b7401a;674e8eaeec54f17a87b74317;674e8f3bec54f17a87b80054;674e90e7ec54f17a87ba3bb7;674e8fc6ec54f17a87b8b384;674e8fc4ec54f17a87b8afe2;674e9182ec54f17a87bacbb1;674e8fedec54f17a87b8e3e1;674e90b2ec54f17a87ba014a;674e900dec54f17a87b90aa3;674e9030ec54f17a87b93576;674e90cbec54f17a87ba1f95;674e8ffeec54f17a87b8f8a2;674e8d8bec54f17a87b5fba1;674e8d17ec54f17a87b58a05;674e8d8dec54f17a87b5fd5b;674e8f81ec54f17a87b85a41;674e903bec54f17a87b94300;674e8f6fec54f17a87b84234;674e90e4ec54f17a87ba386b;674e909aec54f17a87b9de3d;674e8e89ec54f17a87b71511;674e91adec54f17a87baeeea;674e90adec54f17a87b9f9db;674e8d91ec54f17a87b60156;674e8e1bec54f17a87b686b7;674e8eb1ec54f17a87b746de;674e91b2ec54f17a87baf37e;674e91e0ec54f17a87bb1930;674e8fb0ec54f17a87b897b7;674e8d98ec54f17a87b607ae;674e8f9aec54f17a87b87ba5;674e8defec54f17a87b656e9;674e8fb4ec54f17a87b89d3b;674e8f31ec54f17a87b7f3b2",
        },
        {
          value: "sql",
          count: 42,
          keywordIds:
            "674e8f68ec54f17a87b839bb;674e904fec54f17a87b95c75;674e8ff4ec54f17a87b8ebdf;674e8dbcec54f17a87b6290d;674e8f6eec54f17a87b8415c;674e8d61ec54f17a87b5d23e;674e917eec54f17a87bac832;674e8e5eec54f17a87b6dccc;674e90f9ec54f17a87ba4c46;674e9062ec54f17a87b98783;674e914aec54f17a87ba9380;674e8fc8ec54f17a87b8b5e9;674e8e17ec54f17a87b68352;674e90b9ec54f17a87ba0b56;674e8e87ec54f17a87b7118f;674e8d7dec54f17a87b5ef49;674e90ceec54f17a87ba229c;674e8ee0ec54f17a87b78313;674e8e42ec54f17a87b6abd9;674e9157ec54f17a87baa15f;674e8f4cec54f17a87b8164f;674e8d95ec54f17a87b604f3;674e8f6eec54f17a87b84134;674e904bec54f17a87b957bc;674e8f07ec54f17a87b7b4a6;674e8e59ec54f17a87b6d653;674e9006ec54f17a87b90278;674e8dbeec54f17a87b62bbd;674e914fec54f17a87ba99e6;674e8d0dec54f17a87b58064;674e8fbaec54f17a87b8a403;674e8fc4ec54f17a87b8b08f;674e8f01ec54f17a87b7ad80;674e91ceec54f17a87bb0afc;674e9009ec54f17a87b90506;674e8dceec54f17a87b63a45;674e9105ec54f17a87ba5828;674e90bdec54f17a87ba0fbd",
        },
        {
          value: "hdd",
          count: 42,
          keywordIds:
            "674e8e37ec54f17a87b6a23d;674e90b6ec54f17a87ba0692;674e8e97ec54f17a87b7260c;674e9094ec54f17a87b9d6d6;674e8eb0ec54f17a87b7459d;674e8eaeec54f17a87b7436c;674e8f81ec54f17a87b859c7;674e9013ec54f17a87b911e9;674e8d5fec54f17a87b5d0e3;674e8f3fec54f17a87b80609;674e8e44ec54f17a87b6adaf;674e915aec54f17a87baa49b;674e90a9ec54f17a87b9f430;674e9096ec54f17a87b9d8d8;674e8e04ec54f17a87b67001;674e902aec54f17a87b92e9e;674e8d56ec54f17a87b5c868;674e9165ec54f17a87baad35;674e915bec54f17a87baa52d;674e900cec54f17a87b9091b;674e918fec54f17a87bad69e;674e8f89ec54f17a87b86555;674e9090ec54f17a87b9d0c5;674e9018ec54f17a87b91735;674e8e82ec54f17a87b70c28;674e8cf6ec54f17a87b5698d;674e8d03ec54f17a87b575e6;674e90d8ec54f17a87ba2c4b;674e8e1aec54f17a87b68598;674e8f42ec54f17a87b809c2;674e901dec54f17a87b91ec8;674e8fafec54f17a87b896b1;674e8e38ec54f17a87b6a2d3;674e91ecec54f17a87bb22bb;674e8e7fec54f17a87b707de;674e8f26ec54f17a87b7e477;674e8eb1ec54f17a87b7477f;674e8e3aec54f17a87b6a4fe;674e909dec54f17a87b9e284;674e90eeec54f17a87ba4159",
        },
        {
          value: "dram",
          count: 42,
          keywordIds:
            "674e9099ec54f17a87b9dd9f;674e904cec54f17a87b959aa;674e8f57ec54f17a87b82538;674e8d59ec54f17a87b5cbc4;674e8fb2ec54f17a87b89a22;674e8f21ec54f17a87b7d906;674e8e85ec54f17a87b70edb;674e90afec54f17a87b9fcf0;674e8f9bec54f17a87b87d33;674e909fec54f17a87b9e520;674e8d55ec54f17a87b5c75a;674e8e19ec54f17a87b68504;674e8d7aec54f17a87b5ebb9;674e8f13ec54f17a87b7c499;674e8ffcec54f17a87b8f671;674e8fceec54f17a87b8be62;674e8f0cec54f17a87b7bc0f;674e8ef0ec54f17a87b79730;674e90d2ec54f17a87ba26d3;674e8e78ec54f17a87b6fee8;674e8f51ec54f17a87b81db5;674e8ff5ec54f17a87b8ee25;674e8f72ec54f17a87b8458d;674e91b7ec54f17a87baf87a;674e8d92ec54f17a87b601e8;674e8f16ec54f17a87b7c940;674e8f12ec54f17a87b7c351;674e8f9aec54f17a87b87b97;674e8edeec54f17a87b77ff7;674e8fc7ec54f17a87b8b57e;674e8e02ec54f17a87b66e05;674e9060ec54f17a87b9834d;674e8f41ec54f17a87b8083e;674e8e45ec54f17a87b6aeb6;674e8dc7ec54f17a87b633a3;674e8ed8ec54f17a87b777f2;674e8f1fec54f17a87b7d646;674e901bec54f17a87b91b97;674e8ff0ec54f17a87b8e6be",
        },
        {
          value: "utf8",
          count: 41,
          keywordIds:
            "674e901cec54f17a87b91cfb;674e8e13ec54f17a87b67f79;674e8ddbec54f17a87b644d3;674e8fa4ec54f17a87b88899;674e902eec54f17a87b9332f;674e8d5dec54f17a87b5ceb6;674e8d8eec54f17a87b5fe36;674e90aeec54f17a87b9fb92;674e903aec54f17a87b9421e;674e8fc5ec54f17a87b8b1f7;674e8d9eec54f17a87b60d1b;674e8f78ec54f17a87b84d7b;674e8f24ec54f17a87b7e188;674e8d34ec54f17a87b5a77b;674e8e87ec54f17a87b71240;674e8d54ec54f17a87b5c66e;674e8d8aec54f17a87b5fad3;674e8db9ec54f17a87b62771;674e9149ec54f17a87ba92b5;674e8f56ec54f17a87b822fd;674e8dcdec54f17a87b6393b;674e8f4dec54f17a87b817b9;674e8e7eec54f17a87b705d2;674e91cfec54f17a87bb0bc4;674e8ebbec54f17a87b753b6;674e9040ec54f17a87b94972;674e8f03ec54f17a87b7af6a;674e8ea2ec54f17a87b73364;674e9175ec54f17a87baba68;674e90b3ec54f17a87ba0170;674e8f56ec54f17a87b823ec;674e8f65ec54f17a87b836bd;674e9191ec54f17a87bad7b2;674e8d46ec54f17a87b5b923;674e8ebaec54f17a87b75237;674e8ed7ec54f17a87b776be;674e9079ec54f17a87b9ad35",
        },
        {
          value: "cli",
          count: 41,
          keywordIds:
            "674e9080ec54f17a87b9b8b7;674e8fb9ec54f17a87b8a352;674e91b4ec54f17a87baf5af;674e8d07ec54f17a87b57a18;674e8fc2ec54f17a87b8ae4c;674e8fddec54f17a87b8cf89;674e90bfec54f17a87ba12c2;674e9097ec54f17a87b9dab9;674e915aec54f17a87baa41f;674e9038ec54f17a87b93fdc;674e8e7aec54f17a87b70120;674e8f2cec54f17a87b7edae;674e8ffeec54f17a87b8f8c4;674e914aec54f17a87ba93d3;674e8e17ec54f17a87b683d2;674e8e72ec54f17a87b6f6fd;674e8efbec54f17a87b7a53c;674e91e2ec54f17a87bb1ae1;674e9085ec54f17a87b9c083;674e8f4cec54f17a87b81709;674e8f61ec54f17a87b8308f;674e90b2ec54f17a87ba0025;674e8ea0ec54f17a87b730ca;674e8f7bec54f17a87b851d7;674e8d4bec54f17a87b5bddf;674e8e5cec54f17a87b6d951;674e9056ec54f17a87b9705d;674e9084ec54f17a87b9bf25;674e8ddfec54f17a87b6488c;674e906bec54f17a87b9966c;674e9042ec54f17a87b94c83;674e9166ec54f17a87baae2d;674e8fafec54f17a87b896a0;674e8dcbec54f17a87b636b3;674e8f99ec54f17a87b87a48;674e90aaec54f17a87b9f5a4;674e8e24ec54f17a87b68f93",
        },
        {
          value: "adp",
          count: 41,
          keywordIds:
            "674e90c6ec54f17a87ba1aa4;674e913dec54f17a87ba8927;674e8dc8ec54f17a87b63458;674e91caec54f17a87bb07f7;674e91eaec54f17a87bb215b;674e90a6ec54f17a87b9f0df;674e8d6fec54f17a87b5e067;674e8f34ec54f17a87b7f6fd;674e91a8ec54f17a87baead8;674e8ebfec54f17a87b75857;674e9000ec54f17a87b8fa86;674e9079ec54f17a87b9ad80;674e8f91ec54f17a87b87035;674e8e34ec54f17a87b69f4c;674e8de9ec54f17a87b651c0;674e8d66ec54f17a87b5d6e5;674e90bcec54f17a87ba0f04;674e8f5bec54f17a87b82901;674e8f9cec54f17a87b87efa;674e8efaec54f17a87b7a47e;674e9036ec54f17a87b93c5b;674e8f89ec54f17a87b86450;674e90a8ec54f17a87b9f2cb;674e8d02ec54f17a87b57537;674e8dbaec54f17a87b6280c;674e8f32ec54f17a87b7f432;674e9001ec54f17a87b8fc72;674e90bcec54f17a87ba0e0c;674e8e62ec54f17a87b6e216;674e8d4eec54f17a87b5c0b6;674e9051ec54f17a87b966af;674e8fd1ec54f17a87b8c1fd;674e90beec54f17a87ba116c;674e8d39ec54f17a87b5ace0;674e8f43ec54f17a87b80b9c;674e8fdeec54f17a87b8d191;674e8e57ec54f17a87b6c077",
        },
        {
          value: "ram",
          count: 40,
          keywordIds:
            "674e8eecec54f17a87b79204;674e8f7fec54f17a87b85751;674e8eefec54f17a87b796ed;674e90dbec54f17a87ba302d;674e8eb5ec54f17a87b74c44;674e8e91ec54f17a87b71e88;674e8f2cec54f17a87b7ecd0;674e8d0fec54f17a87b58232;674e8e85ec54f17a87b70ed6;674e8d7bec54f17a87b5ecf4;674e8ed1ec54f17a87b76ef5;674e8e6eec54f17a87b6f1a6;674e8e9bec54f17a87b72b50;674e8f39ec54f17a87b7fec6;674e90faec54f17a87ba4d35;674e900dec54f17a87b90a32;674e8dacec54f17a87b61b13;674e8e87ec54f17a87b71295;674e8e8cec54f17a87b718ec;674e8f49ec54f17a87b81295;674e91fcec54f17a87bb2f1a;674e8e68ec54f17a87b6e9a3;674e8ff7ec54f17a87b8efb6;674e90bbec54f17a87ba0d45;674e913bec54f17a87ba86bc;674e8e61ec54f17a87b6e161;674e8f6aec54f17a87b83c00;674e9086ec54f17a87b9c24a;674e906eec54f17a87b99a5f;674e8d13ec54f17a87b58658;674e9049ec54f17a87b95492;674e91ffec54f17a87bb31d9;674e8e77ec54f17a87b6fd63;674e8ddcec54f17a87b64658;674e8edaec54f17a87b77a3e;674e8de1ec54f17a87b64af5;674e90b4ec54f17a87ba0309;674e8e49ec54f17a87b6b239",
        },
        {
          value: "ftp",
          count: 40,
          keywordIds:
            "674e903eec54f17a87b946b6;674e8f58ec54f17a87b825b0;674e8f1cec54f17a87b7d1bc;674e90a6ec54f17a87b9effd;674e90c0ec54f17a87ba1488;674e91c8ec54f17a87bb0684;674e8f60ec54f17a87b82fe7;674e9012ec54f17a87b910ab;674e8daeec54f17a87b61c67;674e9109ec54f17a87ba5b79;674e8e88ec54f17a87b712f5;674e9053ec54f17a87b9695e;674e9083ec54f17a87b9bcf7;674e8ec3ec54f17a87b75e3e;674e8ffdec54f17a87b8f6fd;674e8eccec54f17a87b768f5;674e8fe8ec54f17a87b8dcd6;674e91deec54f17a87bb17f8;674e902aec54f17a87b92e12;674e9046ec54f17a87b95137;674e91cdec54f17a87bb09e5;674e9070ec54f17a87b99f46;674e8efeec54f17a87b7a8e6;674e8ecfec54f17a87b76cd8;674e8f85ec54f17a87b85f20;674e91aeec54f17a87baef78;674e9023ec54f17a87b9254d;674e9022ec54f17a87b923a5;674e8e63ec54f17a87b6e337;674e9186ec54f17a87bacef2;674e90dcec54f17a87ba30ed;674e8f44ec54f17a87b80c45;674e8f14ec54f17a87b7c68b;674e8fd5ec54f17a87b8c74f;674e9116ec54f17a87ba66eb;674e912bec54f17a87ba7907;674e91e5ec54f17a87bb1d94",
        },
        {
          value: "sas",
          count: 40,
          keywordIds:
            "674e8f49ec54f17a87b812fa;674e9009ec54f17a87b9060c;674e8eaaec54f17a87b73e38;674e8f00ec54f17a87b7ac51;674e8d37ec54f17a87b5aa51;674e8e36ec54f17a87b6a113;674e8ff1ec54f17a87b8e915;674e8e76ec54f17a87b6fc6e;674e9189ec54f17a87bad1a0;674e8ef9ec54f17a87b7a2c1;674e8dd5ec54f17a87b63ff9;674e8da8ec54f17a87b616bd;674e9153ec54f17a87ba9c48;674e8e69ec54f17a87b6eb45;674e9170ec54f17a87bab656;674e8f91ec54f17a87b86f6f;674e9058ec54f17a87b97273;674e9018ec54f17a87b9180e;674e91feec54f17a87bb30f1;674e8e65ec54f17a87b6e676;674e904cec54f17a87b958c3;674e8db0ec54f17a87b61e81;674e903eec54f17a87b946c2;674e9004ec54f17a87b90024;674e8f1aec54f17a87b7cece;674e8f4eec54f17a87b8195e;674e8d3bec54f17a87b5ae29;674e8dbeec54f17a87b62b2d;674e9049ec54f17a87b95574;674e8f3dec54f17a87b803cb;674e9034ec54f17a87b93af6;674e8e8eec54f17a87b71b45;674e8fc7ec54f17a87b8b501;674e8f18ec54f17a87b7cb36;674e8eb2ec54f17a87b7492d;674e8fcaec54f17a87b8b91b",
        },
        {
          value: "api",
          count: 39,
          keywordIds:
            "674e8ec2ec54f17a87b75d1c;674e8e9eec54f17a87b72e76;674e905bec54f17a87b9793e;674e9002ec54f17a87b8fdb8;674e9179ec54f17a87babe4a;674e8d21ec54f17a87b59517;674e9044ec54f17a87b94e69;674e9059ec54f17a87b976d7;674e9098ec54f17a87b9dba4;674e8e96ec54f17a87b72483;674e8e03ec54f17a87b66f49;674e8f91ec54f17a87b86f54;674e8d08ec54f17a87b57b49;674e91b6ec54f17a87baf7af;674e9068ec54f17a87b990c5;674e8e70ec54f17a87b6f459;674e8df8ec54f17a87b661ba;674e905eec54f17a87b97fab;674e8dd8ec54f17a87b6429a;674e8f8bec54f17a87b867d9;674e9007ec54f17a87b9035c;674e8dbfec54f17a87b62c54;674e8ec2ec54f17a87b75d0e;674e8ffcec54f17a87b8f64b;674e8e5fec54f17a87b6de01;674e905eec54f17a87b97fd6;674e9143ec54f17a87ba8e29;674e9191ec54f17a87bad864;674e90d4ec54f17a87ba28a0;674e9175ec54f17a87babac5;674e8fbcec54f17a87b8a6bd;674e8f9bec54f17a87b87da7;674e8f4fec54f17a87b81b33;674e8d3cec54f17a87b5afa2;674e905bec54f17a87b97967;674e8f26ec54f17a87b7e52f",
        },
        {
          value: "css",
          count: 39,
          keywordIds:
            "674e8fb5ec54f17a87b89ea9;674e913dec54f17a87ba88ab;674e903fec54f17a87b9485f;674e9052ec54f17a87b9673f;674e8f3cec54f17a87b801f6;674e8fb1ec54f17a87b899a4;674e907fec54f17a87b9b7e1;674e9177ec54f17a87babcf5;674e8d7fec54f17a87b5f05b;674e8f5fec54f17a87b82de3;674e9012ec54f17a87b91128;674e910eec54f17a87ba5fb8;674e8f05ec54f17a87b7b2c0;674e8d6aec54f17a87b5dae2;674e900eec54f17a87b90b98;674e908dec54f17a87b9cbd9;674e8d44ec54f17a87b5b6e1;674e900bec54f17a87b907d6;674e8ef9ec54f17a87b7a309;674e918eec54f17a87bad5d9;674e8e83ec54f17a87b70db7;674e8d6eec54f17a87b5df2d;674e8f04ec54f17a87b7b0fc;674e8e5eec54f17a87b6dc25;674e8e8aec54f17a87b715be;674e9024ec54f17a87b92756;674e8f10ec54f17a87b7c0f8;674e8f13ec54f17a87b7c519;674e9169ec54f17a87bab0fe;674e8dddec54f17a87b6470c;674e8df0ec54f17a87b65745;674e8e8eec54f17a87b71aab;674e901fec54f17a87b9210d;674e91fdec54f17a87bb2ff3;674e8de4ec54f17a87b64c9c;674e905bec54f17a87b97ab3;674e90d0ec54f17a87ba24c8;674e90a4ec54f17a87b9ee26",
        },
        {
          value: "usb",
          count: 38,
          keywordIds:
            "674e8f0dec54f17a87b7bda6;674e8f62ec54f17a87b83209;674e91c6ec54f17a87bb044a;674e90a1ec54f17a87b9e927;674e8e4dec54f17a87b6b73c;674e8e7aec54f17a87b7006e;674e8ff5ec54f17a87b8edb7;674e8d7cec54f17a87b5ed90;674e9032ec54f17a87b93782;674e8d90ec54f17a87b600a2;674e9089ec54f17a87b9c5e1;674e8e2dec54f17a87b69800;674e8f08ec54f17a87b7b5d4;674e8e6fec54f17a87b6f36f;674e8e27ec54f17a87b692a7;674e90fdec54f17a87ba5009;674e8fcaec54f17a87b8b857;674e90cdec54f17a87ba218a;674e90afec54f17a87b9fce0;674e8fd4ec54f17a87b8c5a6;674e8f59ec54f17a87b82725;674e8d04ec54f17a87b577c6;674e91bcec54f17a87bafc26;674e902dec54f17a87b931c4;674e9092ec54f17a87b9d41a;674e8fadec54f17a87b89451;674e90b2ec54f17a87b9ffff;674e8ed4ec54f17a87b77218;674e8e80ec54f17a87b70939;674e919bec54f17a87bae096;674e8f5eec54f17a87b82d1d;674e906dec54f17a87b99927;674e9015ec54f17a87b913e7;674e8d57ec54f17a87b5c964;674e8fefec54f17a87b8e593",
        },
        {
          value: "ssd",
          count: 37,
          keywordIds:
            "674e8fe2ec54f17a87b8d645;674e8d6bec54f17a87b5db9d;674e8f25ec54f17a87b7e426;674e8fe2ec54f17a87b8d597;674e907bec54f17a87b9b1f5;674e90dfec54f17a87ba3420;674e8e51ec54f17a87b6bac1;674e9074ec54f17a87b9a681;674e90bbec54f17a87ba0d38;674e8f68ec54f17a87b8398a;674e8f40ec54f17a87b806a7;674e8f7aec54f17a87b8511c;674e8f5bec54f17a87b82a32;674e8f7bec54f17a87b85228;674e8fb2ec54f17a87b89a3c;674e8f77ec54f17a87b84bf7;674e8e7cec54f17a87b70347;674e8dd4ec54f17a87b63ed5;674e9019ec54f17a87b91a25;674e8d99ec54f17a87b60905;674e9001ec54f17a87b8fbac;674e8f7aec54f17a87b8513f;674e8f95ec54f17a87b874f2;674e8f20ec54f17a87b7d7b1;674e8f35ec54f17a87b7f8b7;674e90f1ec54f17a87ba44d8;674e8dd0ec54f17a87b63b86;674e8ee3ec54f17a87b7867f;674e8efeec54f17a87b7a8da;674e8f66ec54f17a87b837fe;674e8eadec54f17a87b741a8;674e9079ec54f17a87b9ae3b;674e8d18ec54f17a87b58c08;674e9160ec54f17a87baa988",
        },
        {
          value: "exe",
          count: 37,
          keywordIds:
            "674e8d4fec54f17a87b5c15e;674e8f7fec54f17a87b85843;674e9068ec54f17a87b9914f;674e90f7ec54f17a87ba49b6;674e8ef5ec54f17a87b79e57;674e8dbcec54f17a87b629a8;674e9030ec54f17a87b935b5;674e900aec54f17a87b906df;674e8fb8ec54f17a87b8a1bf;674e902eec54f17a87b93265;674e8f6dec54f17a87b83f8e;674e8d1eec54f17a87b591cd;674e8eb5ec54f17a87b74cc7;674e9070ec54f17a87b99f7e;674e91c5ec54f17a87bb0363;674e8f72ec54f17a87b84660;674e8f05ec54f17a87b7b1cd;674e8d94ec54f17a87b60391;674e91baec54f17a87bafaa3;674e9199ec54f17a87bade38;674e8f55ec54f17a87b82266;674e8efbec54f17a87b7a5d0;674e91e3ec54f17a87bb1c79;674e8f46ec54f17a87b80f81;674e911fec54f17a87ba6e90;674e8f51ec54f17a87b81d38;674e8fcfec54f17a87b8bf90;674e9010ec54f17a87b90ed8;674e8e14ec54f17a87b680a7;674e8ec4ec54f17a87b75f49;674e9141ec54f17a87ba8c4b;674e9091ec54f17a87b9d1e8;674e9155ec54f17a87ba9f21;674e8d73ec54f17a87b5e4de;674e8db6ec54f17a87b6239e;674e905fec54f17a87b98107;674e90abec54f17a87b9f7cb",
        },
        {
          value: "tcp",
          count: 37,
          keywordIds:
            "674e9010ec54f17a87b90f03;674e8fb5ec54f17a87b89e35;674e8fd6ec54f17a87b8c848;674e8fd5ec54f17a87b8c6a9;674e8fb3ec54f17a87b89b94;674e9180ec54f17a87bac9e1;674e8f4bec54f17a87b81535;674e8fadec54f17a87b8936f;674e908aec54f17a87b9c803;674e90d5ec54f17a87ba2a01;674e8d01ec54f17a87b573f2;674e8f72ec54f17a87b846b9;674e8cf8ec54f17a87b56b53;674e8ed4ec54f17a87b7734a;674e8f8dec54f17a87b86a88;674e8d86ec54f17a87b5f6d8;674e908bec54f17a87b9c880;674e902dec54f17a87b93118;674e8d48ec54f17a87b5bae9;674e8f2fec54f17a87b7f127;674e8fc6ec54f17a87b8b2ef;674e8f3dec54f17a87b803be;674e8eb0ec54f17a87b74579;674e8ff2ec54f17a87b8e9f5;674e8e50ec54f17a87b6b9b2;674e8e9aec54f17a87b72a36;674e8f3aec54f17a87b7ff58;674e8ddaec54f17a87b6442a;674e90b9ec54f17a87ba09d3;674e90d0ec54f17a87ba253b;674e8d89ec54f17a87b5fa01",
        },
        {
          value: "udp",
          count: 35,
          keywordIds:
            "674e919aec54f17a87badf0a;674e90b5ec54f17a87ba0526;674e8f45ec54f17a87b80d15;674e8d47ec54f17a87b5ba65;674e8f80ec54f17a87b85920;674e9043ec54f17a87b94d20;674e8fe0ec54f17a87b8d30a;674e8f42ec54f17a87b80a0d;674e8ffdec54f17a87b8f709;674e8de6ec54f17a87b64f80;674e90f3ec54f17a87ba463a;674e904dec54f17a87b95b17;674e8fe1ec54f17a87b8d4fc;674e8f53ec54f17a87b81f8f;674e8f7aec54f17a87b85023;674e8e9dec54f17a87b72d5e;674e9027ec54f17a87b92a57;674e9006ec54f17a87b901e9;674e8d6dec54f17a87b5dd58;674e901eec54f17a87b91f8f;674e8fd2ec54f17a87b8c2d9;674e8f15ec54f17a87b7c844;674e8e3eec54f17a87b6a847;674e9194ec54f17a87bada16;674e8dccec54f17a87b637d5;674e8f54ec54f17a87b82136;674e8e16ec54f17a87b6820e;674e8f40ec54f17a87b806e7;674e8d35ec54f17a87b5a862;674e8ebdec54f17a87b755db;674e8f20ec54f17a87b7d6c6",
        },
        {
          value: "scsi",
          count: 35,
          keywordIds:
            "674e8eebec54f17a87b79168;674e9154ec54f17a87ba9d2b;674e90b4ec54f17a87ba03dd;674e8f7fec54f17a87b8575d;674e9197ec54f17a87badcae;674e8fdaec54f17a87b8cc4d;674e8e50ec54f17a87b6ba58;674e8f1bec54f17a87b7d06a;674e91ebec54f17a87bb21ee;674e90adec54f17a87b9f8ec;674e91beec54f17a87bafe69;674e8d9eec54f17a87b60dbb;674e8eb5ec54f17a87b74bc4;674e9163ec54f17a87baabbd;674e9086ec54f17a87b9c1eb;674e8f2aec54f17a87b7e97f;674e8f73ec54f17a87b84826;674e90cfec54f17a87ba23bf;674e8fb6ec54f17a87b8a019;674e9176ec54f17a87babbc9;674e8d5bec54f17a87b5cd14;674e9126ec54f17a87ba7422;674e917dec54f17a87bac70c;674e915dec54f17a87baa68f;674e8ee4ec54f17a87b788a9;674e8ef7ec54f17a87b7a07c;674e912eec54f17a87ba7b50;674e903fec54f17a87b9480d;674e8e97ec54f17a87b725a1;674e906eec54f17a87b99c37;674e9033ec54f17a87b939bd;674e8ee5ec54f17a87b789ff;674e8f7cec54f17a87b85481",
        },
        {
          value: "pci",
          count: 35,
          keywordIds:
            "674e9011ec54f17a87b90fa4;674e8e83ec54f17a87b70d66;674e91b3ec54f17a87baf4fa;674e904aec54f17a87b956bc;674e901fec54f17a87b9214e;674e8e33ec54f17a87b69df0;674e8fecec54f17a87b8e272;674e9064ec54f17a87b98a79;674e8e2bec54f17a87b695d8;674e9179ec54f17a87babec6;674e8e8eec54f17a87b71a2b;674e8dacec54f17a87b61a6d;674e8ef3ec54f17a87b79b17;674e918bec54f17a87bad393;674e908fec54f17a87b9cf68;674e8db8ec54f17a87b6264a;674e8f9cec54f17a87b87f50;674e8ec6ec54f17a87b76150;674e8ebeec54f17a87b756f4;674e8fcfec54f17a87b8bf42;674e8e94ec54f17a87b722d8;674e902fec54f17a87b93439;674e8f90ec54f17a87b86d81;674e90d9ec54f17a87ba2d69;674e90aeec54f17a87b9fb7e;674e8fabec54f17a87b89152;674e8deeec54f17a87b65558;674e90deec54f17a87ba3236;674e8e6aec54f17a87b6ebdc;674e8ea4ec54f17a87b735b9;674e8f27ec54f17a87b7e5f5;674e91b5ec54f17a87baf6a0;674e9161ec54f17a87baaa4a;674e906eec54f17a87b99c46",
        },
        {
          value: "ssl",
          count: 34,
          keywordIds:
            "674e8e93ec54f17a87b7202a;674e90ffec54f17a87ba528c;674e8ff8ec54f17a87b8f158;674e90f5ec54f17a87ba4839;674e9029ec54f17a87b92d72;674e90feec54f17a87ba50ef;674e8e6dec54f17a87b6f088;674e9172ec54f17a87bab82a;674e8e98ec54f17a87b727b0;674e8f30ec54f17a87b7f28d;674e909bec54f17a87b9df83;674e8fc0ec54f17a87b8ab02;674e8f33ec54f17a87b7f64c;674e91c0ec54f17a87baff8e;674e8eedec54f17a87b79402;674e8e0bec54f17a87b67708;674e9078ec54f17a87b9ac25;674e8d49ec54f17a87b5bc2a;674e8dffec54f17a87b66a6e;674e8f8cec54f17a87b86930;674e8d81ec54f17a87b5f2f0;674e908dec54f17a87b9cce4;674e8ea2ec54f17a87b733a5;674e8f71ec54f17a87b84470;674e9092ec54f17a87b9d351;674e9012ec54f17a87b91098;674e907fec54f17a87b9b721;674e8d4cec54f17a87b5bf77;674e8d2eec54f17a87b5a283;674e90aaec54f17a87b9f62b",
        },
        {
          value: "smtp",
          count: 33,
          keywordIds:
            "674e8e0dec54f17a87b678e3;674e917bec54f17a87bac5bf;674e8ec9ec54f17a87b764f3;674e8d2dec54f17a87b5a1c4;674e8eccec54f17a87b768f2;674e9201ec54f17a87bb3351;674e91c1ec54f17a87bb0092;674e90e7ec54f17a87ba3b24;674e8ff1ec54f17a87b8e8b4;674e8f9cec54f17a87b87e44;674e8dc9ec54f17a87b63580;674e9076ec54f17a87b9a99d;674e8ffaec54f17a87b8f3eb;674e8fcdec54f17a87b8bc32;674e8f38ec54f17a87b7fd92;674e8f75ec54f17a87b84a92;674e8e95ec54f17a87b7242c;674e8fadec54f17a87b89445;674e8f14ec54f17a87b7c713;674e9056ec54f17a87b96f2a;674e8e68ec54f17a87b6ea4b;674e8f16ec54f17a87b7c954;674e8f7dec54f17a87b854de;674e90b1ec54f17a87b9fe97;674e8d25ec54f17a87b598d5;674e8db6ec54f17a87b6241d;674e8f0fec54f17a87b7c008;674e8ed0ec54f17a87b76e38;674e909eec54f17a87b9e476;674e8e61ec54f17a87b6e0e0;674e8d3cec54f17a87b5af17",
        },
        {
          value: "rss",
          count: 33,
          keywordIds:
            "674e910cec54f17a87ba5e4e;674e8e2eec54f17a87b69948;674e8f21ec54f17a87b7d81f;674e8febec54f17a87b8e156;674e9031ec54f17a87b93702;674e8e41ec54f17a87b6ab57;674e8ef1ec54f17a87b7992d;674e8ef1ec54f17a87b798a5;674e8ef5ec54f17a87b79df7;674e8f7cec54f17a87b8534d;674e8f2aec54f17a87b7e9ed;674e9073ec54f17a87b9a582;674e8d72ec54f17a87b5e26f;674e91a9ec54f17a87baebba;674e8ffcec54f17a87b8f58c;674e8f0dec54f17a87b7bcc5;674e8efcec54f17a87b7a692;674e8ec1ec54f17a87b75b5d;674e8da3ec54f17a87b61234;674e8ec7ec54f17a87b7628e;674e8e88ec54f17a87b71383;674e90a0ec54f17a87b9e756;674e8f62ec54f17a87b831d6;674e8fa1ec54f17a87b885af;674e8ff3ec54f17a87b8eaa5;674e8e3dec54f17a87b6a758;674e8e5cec54f17a87b6da3b;674e8f25ec54f17a87b7e2cf;674e8ecdec54f17a87b76a7a",
        },
        {
          value: "ascii",
          count: 32,
          keywordIds:
            "674e8d1cec54f17a87b58f8a;674e9173ec54f17a87bab8ec;674e8de7ec54f17a87b6506b;674e8feaec54f17a87b8df6b;674e91d4ec54f17a87bb0f3f;674e8ea8ec54f17a87b73c10;674e919fec54f17a87bae341;674e8d0eec54f17a87b581b5;674e9139ec54f17a87ba84c5;674e8cffec54f17a87b57298;674e8d2aec54f17a87b59e8c;674e8eb9ec54f17a87b75109;674e8f48ec54f17a87b811bf;674e8e64ec54f17a87b6e439;674e9087ec54f17a87b9c2f6;674e8f82ec54f17a87b85bb7;674e917dec54f17a87bac79d;674e8f09ec54f17a87b7b81e;674e8f7cec54f17a87b853df;674e90a3ec54f17a87b9ec69;674e8d26ec54f17a87b599e0;674e8eaaec54f17a87b73de8;674e8d42ec54f17a87b5b594;674e91d6ec54f17a87bb109b;674e8ea3ec54f17a87b73435;674e91efec54f17a87bb2555;674e8f89ec54f17a87b86544;674e90b3ec54f17a87ba0232;674e916bec54f17a87bab2e0;674e8eceec54f17a87b76b0f;674e8de0ec54f17a87b64a06;674e8fa1ec54f17a87b88530",
        },
        {
          value: "ai",
          count: 31,
          keywordIds:
            "674e8eeaec54f17a87b7902f;674e8f6cec54f17a87b83e52;674e8ec8ec54f17a87b76419;674e9071ec54f17a87b9a04b;674e8e98ec54f17a87b7270e;674e8febec54f17a87b8e1a9;674e8f8fec54f17a87b86d42;674e8d10ec54f17a87b5836d;674e9001ec54f17a87b8fc51;674e8ee8ec54f17a87b78d2e;674e8fbdec54f17a87b8a6ef;674e9050ec54f17a87b964db;674e8fd3ec54f17a87b8c3c5;674e90f4ec54f17a87ba4708;674e9069ec54f17a87b992f1;674e8e6fec54f17a87b6f2d2;674e91d9ec54f17a87bb1368;674e8ef8ec54f17a87b7a23e;674e8ed5ec54f17a87b774de;674e8fe6ec54f17a87b8da99;674e8ea3ec54f17a87b73434;674e910aec54f17a87ba5c8f;674e90c2ec54f17a87ba15fd;674e8d5eec54f17a87b5cf7f;674e8f29ec54f17a87b7e809;674e90b8ec54f17a87ba08c9;674e8f1fec54f17a87b7d511",
        },
        {
          value: "dns",
          count: 31,
          keywordIds:
            "674e8e6cec54f17a87b6ef04;674e8db4ec54f17a87b621fe;674e8f37ec54f17a87b7fb70;674e8f72ec54f17a87b8456a;674e8eddec54f17a87b77f46;674e8f32ec54f17a87b7f507;674e8ee3ec54f17a87b78660;674e8e1cec54f17a87b6889d;674e8de6ec54f17a87b64ed2;674e9085ec54f17a87b9c0b0;674e9032ec54f17a87b9389d;674e8f76ec54f17a87b84bae;674e8f64ec54f17a87b8353b;674e8e81ec54f17a87b70a84;674e8e92ec54f17a87b71fe8;674e8fefec54f17a87b8e63b;674e9035ec54f17a87b93b6c;674e8feaec54f17a87b8df2f;674e9025ec54f17a87b927ab;674e91eeec54f17a87bb24df;674e8eb7ec54f17a87b74eee;674e8d39ec54f17a87b5ac4a;674e8ec6ec54f17a87b76151;674e8fd5ec54f17a87b8c67a;674e8e28ec54f17a87b6938a;674e8e60ec54f17a87b6df65;674e8f36ec54f17a87b7fa08;674e8e49ec54f17a87b6b2ef",
        },
        {
          value: "png",
          count: 30,
          keywordIds:
            "674e9071ec54f17a87b9a136;674e903dec54f17a87b94535;674e8dd7ec54f17a87b641d3;674e8ea0ec54f17a87b731aa;674e91b9ec54f17a87baf9ef;674e8e12ec54f17a87b67dc3;674e91bfec54f17a87bafec4;674e8ff6ec54f17a87b8ee5c;674e9053ec54f17a87b969dd;674e8ed9ec54f17a87b778ef;674e91d8ec54f17a87bb129e;674e8d6aec54f17a87b5da63;674e8f18ec54f17a87b7cc7e;674e8fceec54f17a87b8be67;674e91a4ec54f17a87bae778;674e91daec54f17a87bb13d8;674e9026ec54f17a87b928a0;674e8d83ec54f17a87b5f4db;674e9130ec54f17a87ba7ddc;674e8e9cec54f17a87b72c9e;674e8ebfec54f17a87b7595f;674e8f65ec54f17a87b836b1;674e8ee7ec54f17a87b78b20;674e902eec54f17a87b93306;674e8ed4ec54f17a87b772a7;674e8fe7ec54f17a87b8dc99;674e8edfec54f17a87b781f7;674e8deaec54f17a87b65278;674e906cec54f17a87b997f7;674e90d9ec54f17a87ba2e01",
        },
        {
          value: "agp",
          count: 30,
          keywordIds:
            "674e8e90ec54f17a87b71cee;674e912aec54f17a87ba7885;674e8f3cec54f17a87b8022e;674e8eecec54f17a87b79283;674e8fa7ec54f17a87b88cd8;674e91afec54f17a87baf0bd;674e91d2ec54f17a87bb0e10;674e9065ec54f17a87b98b71;674e90ebec54f17a87ba3eb7;674e8dfbec54f17a87b6669b;674e8fb3ec54f17a87b89b58;674e8f3aec54f17a87b7ffaf;674e9198ec54f17a87baddcb;674e8eebec54f17a87b791aa;674e8fceec54f17a87b8bd80;674e8d9bec54f17a87b60b5c;674e8e9bec54f17a87b72b2a;674e9095ec54f17a87b9d770;674e8e90ec54f17a87b71ce3;674e9112ec54f17a87ba6385;674e9016ec54f17a87b915b2;674e8e81ec54f17a87b70a8f;674e91d5ec54f17a87bb101c;674e916aec54f17a87bab1ab;674e8f82ec54f17a87b85bc2;674e8ea5ec54f17a87b736e9;674e911bec54f17a87ba6a9d;674e8ed9ec54f17a87b779dc",
        },
        {
          value: "transmitting",
          count: 29,
          keywordIds:
            "674e8e97ec54f17a87b72572;674e91c3ec54f17a87bb0222;674e8fc2ec54f17a87b8ade9;674e8d3eec54f17a87b5b106;674e8f00ec54f17a87b7ab4e;674e8d36ec54f17a87b5aa13;674e9099ec54f17a87b9dc78;674e8cffec54f17a87b57232;674e9177ec54f17a87babc94;674e9102ec54f17a87ba558b;674e8db8ec54f17a87b625b9;674e9163ec54f17a87baab86;674e91d8ec54f17a87bb126e;674e8e7bec54f17a87b7027c;674e8d16ec54f17a87b58931;674e9057ec54f17a87b970f6;674e91fdec54f17a87bb3074;674e8dc1ec54f17a87b62df0;674e8f31ec54f17a87b7f365;674e8fa8ec54f17a87b88df3;674e8dafec54f17a87b61e1c;674e8ebbec54f17a87b7532b;674e8f2eec54f17a87b7eff7;674e9081ec54f17a87b9bae9;674e8f82ec54f17a87b85b38;674e8fc6ec54f17a87b8b3ef;674e8e23ec54f17a87b68f09;674e9038ec54f17a87b93ea6;674e8e4aec54f17a87b6b445",
        },
        {
          value: "gb",
          count: 28,
          keywordIds:
            "674e8ff6ec54f17a87b8ef3c;674e91bdec54f17a87bafd34;674e8d62ec54f17a87b5d2e7;674e8ef3ec54f17a87b79be3;674e909bec54f17a87b9e029;674e8d88ec54f17a87b5f8df;674e9002ec54f17a87b8fdbb;674e9093ec54f17a87b9d53a;674e8e25ec54f17a87b6905a;674e8e46ec54f17a87b6b05a;674e8ea1ec54f17a87b73278;674e91f0ec54f17a87bb2697;674e8e8bec54f17a87b716b3;674e9206ec54f17a87bb3709;674e90efec54f17a87ba424e;674e8f44ec54f17a87b80bfa;674e8f67ec54f17a87b8388d;674e9082ec54f17a87b9bb66;674e8d9fec54f17a87b60ee9;674e8fdaec54f17a87b8cc14;674e8d2cec54f17a87b5a005;674e9041ec54f17a87b94ae2;674e8fdeec54f17a87b8d0c7;674e8dfaec54f17a87b66523;674e8e57ec54f17a87b6c161;674e90c5ec54f17a87ba1977",
        },
        {
          value: "navigating",
          count: 24,
          keywordIds:
            "674e8e83ec54f17a87b70ceb;674e910cec54f17a87ba5e17;674e8d28ec54f17a87b59bd3;674e8fa3ec54f17a87b886fa;674e9030ec54f17a87b93629;674e8e66ec54f17a87b6e7e0;674e8e7dec54f17a87b70450;674e91b6ec54f17a87baf77c;674e8fc9ec54f17a87b8b7df;674e8e8cec54f17a87b71811;674e8e92ec54f17a87b71f75;674e8e9fec54f17a87b72fdd;674e8ee4ec54f17a87b7873a;674e8e83ec54f17a87b70d39;674e8e8fec54f17a87b71c91;674e9020ec54f17a87b9222f;674e9039ec54f17a87b94072;674e9155ec54f17a87ba9e56;674e9126ec54f17a87ba747c;674e8e4fec54f17a87b6b8ea;674e8f4bec54f17a87b815bb;674e90beec54f17a87ba115b;674e8ee2ec54f17a87b78580;674e8fa0ec54f17a87b88453",
        },
        {
          value: "calculating",
          count: 23,
          keywordIds:
            "674e91bdec54f17a87bafcfa;674e8f9eec54f17a87b88159;674e8f86ec54f17a87b86147;674e8e77ec54f17a87b6fd19;674e8e33ec54f17a87b69d9f;674e8f58ec54f17a87b82577;674e9203ec54f17a87bb34e1;674e8fd8ec54f17a87b8ca6b;674e90b1ec54f17a87b9ff16;674e8ffbec54f17a87b8f53b;674e8f16ec54f17a87b7c8ac;674e9112ec54f17a87ba62d5;674e8ed3ec54f17a87b771a6;674e919bec54f17a87bae03a;674e8d0dec54f17a87b57ffb;674e8f65ec54f17a87b835df;674e8f54ec54f17a87b820e7;674e8e78ec54f17a87b6ff0b;674e8e69ec54f17a87b6eafd;674e90e9ec54f17a87ba3d1e;674e8fbdec54f17a87b8a7a3",
        },
        {
          value: "quantifying",
          count: 23,
          keywordIds:
            "674e9004ec54f17a87b8ffae;674e9099ec54f17a87b9dce8;674e9196ec54f17a87badc01;674e9084ec54f17a87b9be6a;674e8e43ec54f17a87b6ad02;674e90f9ec54f17a87ba4bda;674e91d1ec54f17a87bb0d2d;674e8dc3ec54f17a87b62fca;674e8d15ec54f17a87b587a0;674e8f4aec54f17a87b81460;674e9028ec54f17a87b92b28;674e9025ec54f17a87b9285c;674e8fb6ec54f17a87b89fb5;674e8d9bec54f17a87b60ab1;674e906aec54f17a87b99381;674e91bbec54f17a87bafb9a;674e8ea9ec54f17a87b73d6e;674e8df6ec54f17a87b65d3c;674e8f89ec54f17a87b86416;674e90beec54f17a87ba1105;674e8fb4ec54f17a87b89cbb",
        },
        {
          value: "connecting",
          count: 22,
          keywordIds:
            "674e9063ec54f17a87b98957;674e8ea0ec54f17a87b73158;674e9067ec54f17a87b98f67;674e8e3fec54f17a87b6a977;674e8ff2ec54f17a87b8e965;674e8f1eec54f17a87b7d3bc;674e9109ec54f17a87ba5b42;674e8e1cec54f17a87b687bb;674e8f12ec54f17a87b7c366;674e8ef3ec54f17a87b79b8d;674e8f64ec54f17a87b834e7;674e905eec54f17a87b97ef2;674e8d52ec54f17a87b5c466;674e9148ec54f17a87ba922a;674e9034ec54f17a87b93b0a;674e8f53ec54f17a87b81f69;674e8e96ec54f17a87b724ed;674e8fafec54f17a87b89616;674e8e9aec54f17a87b728f7;674e8f24ec54f17a87b7e274;674e8e2fec54f17a87b699f1",
        },
        {
          value: "programming",
          count: 21,
          keywordIds:
            "674e907cec54f17a87b9b299;674e8f9dec54f17a87b88075;674e8f2aec54f17a87b7eaf2;674e8ff1ec54f17a87b8e80e;674e8e93ec54f17a87b7216f;674e8ea1ec54f17a87b731b6;674e9082ec54f17a87b9bbaa;674e8ec5ec54f17a87b76021;674e914cec54f17a87ba9578;674e8f75ec54f17a87b849d6;674e912eec54f17a87ba7c68;674e905dec54f17a87b97e92;674e902fec54f17a87b9348b;674e8faaec54f17a87b88f9c;674e8e3bec54f17a87b6a5b2;674e8eb6ec54f17a87b74dba;674e91cdec54f17a87bb0a79;674e8d56ec54f17a87b5c8d9;674e8f1fec54f17a87b7d51c;674e908dec54f17a87b9cc85",
        },
        {
          value: "indexing",
          count: 20,
          keywordIds:
            "674e8ec2ec54f17a87b75c81;674e9088ec54f17a87b9c462;674e905aec54f17a87b97839;674e8f93ec54f17a87b8736b;674e8e4cec54f17a87b6b651;674e8d5cec54f17a87b5cde1;674e8e8dec54f17a87b7196b;674e8e40ec54f17a87b6aaa3;674e904fec54f17a87b9628f;674e8fdcec54f17a87b8ceac;674e8f29ec54f17a87b7e8fa;674e8fe1ec54f17a87b8d471;674e8cf8ec54f17a87b56ae0;674e903bec54f17a87b9428a;674e8e9fec54f17a87b72f64;674e8d4cec54f17a87b5bf3a;674e91e8ec54f17a87bb1fe9;674e90aaec54f17a87b9f65e;674e901eec54f17a87b91f17",
        },
        {
          value: "synthesizing",
          count: 20,
          keywordIds:
            "674e8e2eec54f17a87b69892;674e8f92ec54f17a87b87101;674e8fc3ec54f17a87b8af6e;674e90a8ec54f17a87b9f345;674e8facec54f17a87b89319;674e8e8bec54f17a87b717ac;674e8f88ec54f17a87b862e3;674e8fcdec54f17a87b8bbd7;674e8f38ec54f17a87b7fdd0;674e8ee0ec54f17a87b78286;674e9070ec54f17a87b99e1b;674e8f42ec54f17a87b80944;674e9049ec54f17a87b9543b;674e9040ec54f17a87b949ec;674e9014ec54f17a87b91344;674e8e98ec54f17a87b72792;674e8dc7ec54f17a87b63317;674e90b8ec54f17a87ba0874;674e901aec54f17a87b91a87",
        },
        {
          value: "compressing",
          count: 17,
          keywordIds:
            "674e8d1bec54f17a87b58f3b;674e8d12ec54f17a87b5847c;674e8d22ec54f17a87b596ba;674e8f47ec54f17a87b810a1;674e9104ec54f17a87ba56dc;674e8e26ec54f17a87b691e8;674e8e31ec54f17a87b69c32;674e9082ec54f17a87b9bbe4;674e8da2ec54f17a87b611d9;674e8e09ec54f17a87b67564;674e90c1ec54f17a87ba1598;674e8f15ec54f17a87b7c750;674e8ec5ec54f17a87b7605c;674e8e7dec54f17a87b70532;674e901fec54f17a87b92029",
        },
        {
          value: "hacking",
          count: 17,
          keywordIds:
            "674e8e92ec54f17a87b71f26;674e8d0bec54f17a87b57e87;674e8f30ec54f17a87b7f1c4;674e8de2ec54f17a87b64bbc;674e90d5ec54f17a87ba299c;674e8fe7ec54f17a87b8dc54;674e9205ec54f17a87bb36a5;674e8fe5ec54f17a87b8d9d5;674e9122ec54f17a87ba70cc;674e8e5dec54f17a87b6dbd3;674e9006ec54f17a87b901f5;674e8ed7ec54f17a87b77722;674e8d9cec54f17a87b60bee;674e8d37ec54f17a87b5aae1;674e8f14ec54f17a87b7c5fd;674e8ecdec54f17a87b76a20;674e8fa6ec54f17a87b88a54",
        },
        {
          value: "copying",
          count: 17,
          keywordIds:
            "674e907bec54f17a87b9b170;674e900fec54f17a87b90d60;674e909fec54f17a87b9e607;674e918bec54f17a87bad30f;674e8ed1ec54f17a87b76f76;674e9074ec54f17a87b9a68d;674e9146ec54f17a87ba9041;674e8f2fec54f17a87b7f09a;674e8ebbec54f17a87b7535b;674e8d74ec54f17a87b5e590;674e8ee9ec54f17a87b78eb8;674e8fc5ec54f17a87b8b175;674e907eec54f17a87b9b654;674e8e62ec54f17a87b6e2e1;674e8f4fec54f17a87b81ab8;674e8e66ec54f17a87b6e759;674e9059ec54f17a87b97534",
        },
        {
          value: "backing",
          count: 16,
          keywordIds:
            "674e9039ec54f17a87b9404a;674e8e1dec54f17a87b6897f;674e8eb8ec54f17a87b74fb5;674e8fc1ec54f17a87b8ac3c;674e8d43ec54f17a87b5b694;674e915eec54f17a87baa7aa;674e907dec54f17a87b9b45c;674e8e86ec54f17a87b7106b;674e8e5bec54f17a87b6d864;674e8e94ec54f17a87b7218f;674e9057ec54f17a87b97200;674e8f5aec54f17a87b827b7;674e8f9bec54f17a87b87cd0;674e8ecdec54f17a87b76a46;674e8e76ec54f17a87b6fcae;674e8e39ec54f17a87b6a40c",
        },
        {
          value: "overriding",
          count: 16,
          keywordIds:
            "674e90f4ec54f17a87ba47a9;674e8eb8ec54f17a87b74f8f;674e8ff8ec54f17a87b8f0a8;674e8e46ec54f17a87b6afb8;674e9032ec54f17a87b937d9;674e8e71ec54f17a87b6f652;674e91d6ec54f17a87bb10ec;674e8e0fec54f17a87b67b30;674e8f6aec54f17a87b83c77;674e91e3ec54f17a87bb1c2c;674e90eeec54f17a87ba420d;674e8ec3ec54f17a87b75e72;674e8d19ec54f17a87b58d43;674e900eec54f17a87b90c16;674e91f1ec54f17a87bb2788;674e8f36ec54f17a87b7f972",
        },
        {
          value: "parsing",
          count: 16,
          keywordIds:
            "674e904cec54f17a87b9588d;674e8cfcec54f17a87b56f30;674e8fd3ec54f17a87b8c490;674e8ed8ec54f17a87b77891;674e8d08ec54f17a87b57afc;674e8eedec54f17a87b7938f;674e8d00ec54f17a87b57386;674e911bec54f17a87ba6b56;674e8eebec54f17a87b790c8;674e8eedec54f17a87b79446;674e8fabec54f17a87b89129;674e90aeec54f17a87b9fb04;674e8d2fec54f17a87b5a2f4;674e90c4ec54f17a87ba18b5",
        },
        {
          value: "generating",
          count: 15,
          keywordIds:
            "674e8e37ec54f17a87b6a19a;674e8f3bec54f17a87b80113;674e9003ec54f17a87b8fe89;674e9107ec54f17a87ba59e1;674e8fbfec54f17a87b8aa82;674e8eddec54f17a87b77e90;674e917fec54f17a87bac946;674e8f29ec54f17a87b7e8de;674e9029ec54f17a87b92c65;674e9007ec54f17a87b9033e;674e8edeec54f17a87b78080;674e8d40ec54f17a87b5b329;674e8f69ec54f17a87b83b44;674e9022ec54f17a87b924de;674e8f5eec54f17a87b82c97",
        },
        {
          value: "bypassing",
          count: 12,
          keywordIds:
            "674e8e6cec54f17a87b6f00e;674e8d46ec54f17a87b5b9ac;674e8fe8ec54f17a87b8dd67;674e9085ec54f17a87b9bfae;674e8d33ec54f17a87b5a732;674e8f82ec54f17a87b85b2b;674e8d53ec54f17a87b5c60a;674e904dec54f17a87b95a91;674e9026ec54f17a87b92961;674e9193ec54f17a87bad976;674e8f56ec54f17a87b82384;674e916eec54f17a87bab58d",
        },
      ],
    },
    keywordTrend: {
      data: {
        cloudData: [
          {
            value: "program",
            count: 180,
            keywordIds:
              "674e9072ec54f17a87b9a25f;674e8e12ec54f17a87b67ec0;674e9153ec54f17a87ba9cde;674e8fb9ec54f17a87b8a321;674e8d4fec54f17a87b5c1ef;674e8ef0ec54f17a87b7983d;674e8f7eec54f17a87b856e2;674e910bec54f17a87ba5d9d;674e8dd7ec54f17a87b64196;674e8fb4ec54f17a87b89ce0;674e8df1ec54f17a87b658ac;674e90f5ec54f17a87ba47e8;674e8f49ec54f17a87b81355;674e907bec54f17a87b9b0ad;674e90e0ec54f17a87ba3440;674e8e77ec54f17a87b6fd82;674e90dbec54f17a87ba2f5e;674e8d46ec54f17a87b5b9c9;674e8e5fec54f17a87b6ddc3;674e8fbcec54f17a87b8a61b;674e8fa4ec54f17a87b8886c;674e9013ec54f17a87b911c5;674e91b8ec54f17a87baf959;674e9071ec54f17a87b9a0ff;674e8fa8ec54f17a87b88d66;674e8e36ec54f17a87b6a0be;674e91c2ec54f17a87bb0126;674e8f2bec54f17a87b7eb7b;674e9044ec54f17a87b94e98;674e8e67ec54f17a87b6e87d;674e8d77ec54f17a87b5e8a1;674e8ff1ec54f17a87b8e862;674e8e07ec54f17a87b672fb;674e8f8fec54f17a87b86c60;674e8ef3ec54f17a87b79ac9;674e8cffec54f17a87b571af;674e90e8ec54f17a87ba3bd5;674e8d11ec54f17a87b583ab;674e8f37ec54f17a87b7fbfd;674e8ff0ec54f17a87b8e78b;674e915aec54f17a87baa43d;674e9053ec54f17a87b96934;674e8d9eec54f17a87b60d87;674e8f5eec54f17a87b82d8d;674e904fec54f17a87b9624b;674e8daaec54f17a87b618fc;674e8f5bec54f17a87b8299d;674e8dfdec54f17a87b6683b;674e8da8ec54f17a87b61652;674e8ffdec54f17a87b8f79a;674e8f85ec54f17a87b85f84;674e908bec54f17a87b9c916;674e8ff9ec54f17a87b8f19a;674e8f78ec54f17a87b84dc5;674e9149ec54f17a87ba9322;674e9085ec54f17a87b9c03c;674e8ea1ec54f17a87b732b6;674e915eec54f17a87baa771;674e8efbec54f17a87b7a51c;674e8e7dec54f17a87b70444;674e900bec54f17a87b9084c;674e8f38ec54f17a87b7fd1b;674e90baec54f17a87ba0bae;674e8d8cec54f17a87b5fc5b;674e8fa5ec54f17a87b88a04;674e8d54ec54f17a87b5c6b5;674e8fc9ec54f17a87b8b7a3;674e8d7dec54f17a87b5ef7b;674e8eccec54f17a87b76894;674e8f0bec54f17a87b7bb39;674e905cec54f17a87b97b5a;674e9083ec54f17a87b9bd73;674e8efbec54f17a87b7a5a5;674e8d84ec54f17a87b5f4fd;674e909bec54f17a87b9e0a8;674e8d99ec54f17a87b608af;674e8cf8ec54f17a87b56ac3;674e8f49ec54f17a87b812bd;674e8ec1ec54f17a87b75adb;674e8dc1ec54f17a87b62e4d;674e8f31ec54f17a87b7f3be;674e8f8dec54f17a87b86a04;674e8d86ec54f17a87b5f71a;674e91fbec54f17a87bb2e85;674e8fd0ec54f17a87b8c084;674e8cf7ec54f17a87b56a0a;674e8f52ec54f17a87b81e29;674e8d81ec54f17a87b5f30e;674e8f79ec54f17a87b84faa;674e8e93ec54f17a87b72111;674e9058ec54f17a87b973e2;674e8e7eec54f17a87b70651;674e8f56ec54f17a87b823fa;674e909eec54f17a87b9e406;674e8f43ec54f17a87b80a85;674e906bec54f17a87b995f3;674e8f01ec54f17a87b7ad4f;674e902dec54f17a87b931ed;674e8ea9ec54f17a87b73cc8;674e9006ec54f17a87b901c1;674e902fec54f17a87b93412;674e8fa9ec54f17a87b88f4d;674e90b1ec54f17a87b9ffc9;674e8e6aec54f17a87b6ecde;674e9024ec54f17a87b92705;674e919bec54f17a87badff8;674e8df6ec54f17a87b65cfb;674e90f2ec54f17a87ba459d;674e8f13ec54f17a87b7c536;674e9193ec54f17a87bad9a5;674e916cec54f17a87bab30d;674e8d39ec54f17a87b5ac6e;674e8e9aec54f17a87b72940;674e8fd4ec54f17a87b8c60d;674e8da7ec54f17a87b615bb;674e905fec54f17a87b981b5;674e8f34ec54f17a87b7f7b0;674e8ddcec54f17a87b645ed;674e8ff0ec54f17a87b8e6d2;674e8e52ec54f17a87b6bb87;674e8e60ec54f17a87b6df9b;674e8dc6ec54f17a87b632d6;674e8d3cec54f17a87b5af84;674e9009ec54f17a87b9052b;674e8e49ec54f17a87b6b323;674e8d35ec54f17a87b5a8bd;674e8eafec54f17a87b7440b;674e9078ec54f17a87b9acba;674e90bdec54f17a87ba0ff7;674e90c5ec54f17a87ba19a0;674e8d89ec54f17a87b5f9b9",
          },
          {
            value: "application",
            count: 132,
            keywordIds:
              "674e9173ec54f17a87bab9a3;674e917bec54f17a87bac5ed;674e8f4bec54f17a87b81503;674e8dd7ec54f17a87b64213;674e90c6ec54f17a87ba1ac4;674e9002ec54f17a87b8fe27;674e8f41ec54f17a87b807d5;674e8fecec54f17a87b8e2b5;674e8ef5ec54f17a87b79e8e;674e8ff4ec54f17a87b8ebda;674e8f01ec54f17a87b7acac;674e8f9dec54f17a87b88001;674e8fa5ec54f17a87b88949;674e8f3dec54f17a87b8031f;674e9098ec54f17a87b9dc47;674e8e3fec54f17a87b6a94a;674e8e20ec54f17a87b68c70;674e90adec54f17a87b9f920;674e8e11ec54f17a87b67cff;674e8f8fec54f17a87b86c2c;674e9004ec54f17a87b8ff73;674e8eb9ec54f17a87b750e4;674e9039ec54f17a87b94015;674e8fc6ec54f17a87b8b2fd;674e8ed3ec54f17a87b77107;674e9065ec54f17a87b98bee;674e8f04ec54f17a87b7b15f;674e8d90ec54f17a87b600bb;674e9032ec54f17a87b93896;674e8eddec54f17a87b77eca;674e8ebfec54f17a87b758a5;674e9097ec54f17a87b9d9a2;674e8de3ec54f17a87b64c0b;674e91a3ec54f17a87bae657;674e8f84ec54f17a87b85e11;674e8d55ec54f17a87b5c778;674e9075ec54f17a87b9a7d1;674e8f87ec54f17a87b862a5;674e9019ec54f17a87b919e1;674e91a5ec54f17a87bae7c7;674e8e17ec54f17a87b683b4;674e9077ec54f17a87b9aa77;674e8d33ec54f17a87b5a717;674e8e73ec54f17a87b6f8c5;674e8ea5ec54f17a87b73724;674e8f12ec54f17a87b7c3ac;674e8e86ec54f17a87b71148;674e91e2ec54f17a87bb1ba5;674e9036ec54f17a87b93c96;674e8d8dec54f17a87b5fdd4;674e905eec54f17a87b97eae;674e909cec54f17a87b9e0d3;674e8d9aec54f17a87b60a28;674e8f49ec54f17a87b81383;674e9017ec54f17a87b91618;674e8ea4ec54f17a87b7357e;674e8d96ec54f17a87b605a9;674e8f6eec54f17a87b840f8;674e8d75ec54f17a87b5e67c;674e8efdec54f17a87b7a88f;674e8fabec54f17a87b8915d;674e8e86ec54f17a87b7109e;674e8d65ec54f17a87b5d5d1;674e8d06ec54f17a87b57907;674e8ee9ec54f17a87b78e64;674e8ff6ec54f17a87b8eefb;674e910fec54f17a87ba6100;674e8da1ec54f17a87b6113d;674e913bec54f17a87ba867d;674e8d26ec54f17a87b59a14;674e9114ec54f17a87ba64b8;674e902dec54f17a87b9319b;674e90adec54f17a87b9fa0c;674e8dbeec54f17a87b62b4f;674e8ebfec54f17a87b75845;674e8ecfec54f17a87b76d01;674e9006ec54f17a87b90276;674e8eb0ec54f17a87b745ae;674e8d9dec54f17a87b60c84;674e9192ec54f17a87bad883;674e8e3eec54f17a87b6a7e1;674e90f0ec54f17a87ba437d;674e8d0dec54f17a87b57fdd;674e908bec54f17a87b9c99b;674e8fb9ec54f17a87b8a2e1;674e8eceec54f17a87b76b35;674e9054ec54f17a87b96bce;674e8f54ec54f17a87b820a1;674e8e78ec54f17a87b6fedd;674e8e15ec54f17a87b68139;674e8d58ec54f17a87b5cabb;674e8f02ec54f17a87b7ae3f;674e8f99ec54f17a87b87a06;674e8de1ec54f17a87b64a86;674e90aaec54f17a87b9f5cf;674e8ddaec54f17a87b643cf;674e8d57ec54f17a87b5c986;674e8f26ec54f17a87b7e44c;674e8f1fec54f17a87b7d57b;674e8f67ec54f17a87b8391f;674e8d36ec54f17a87b5a915;674e8dcfec54f17a87b63ac7;674e8d18ec54f17a87b58c61;674e90d0ec54f17a87ba24f9;674e913cec54f17a87ba87ff;674e8ed6ec54f17a87b77500",
          },
          {
            value: "driver",
            count: 128,
            keywordIds:
              "674e8d6bec54f17a87b5dbee;674e8eebec54f17a87b7919d;674e8ef1ec54f17a87b798dc;674e8e37ec54f17a87b6a1d1;674e8ef0ec54f17a87b7972b;674e9020ec54f17a87b92174;674e8e6cec54f17a87b6f043;674e8e51ec54f17a87b6baee;674e90f6ec54f17a87ba4994;674e91a0ec54f17a87bae409;674e917fec54f17a87bac8d3;674e8d29ec54f17a87b59d74;674e90a6ec54f17a87b9f09f;674e9044ec54f17a87b94ee2;674e8f05ec54f17a87b7b2b5;674e8e21ec54f17a87b68d28;674e8fd5ec54f17a87b8c6e1;674e9022ec54f17a87b92388;674e91c9ec54f17a87bb0770;674e8e7cec54f17a87b7040b;674e8ef0ec54f17a87b79849;674e918dec54f17a87bad4f6;674e8f5eec54f17a87b82dc4;674e8f05ec54f17a87b7b200;674e90e1ec54f17a87ba3588;674e9098ec54f17a87b9dbc5;674e8d6aec54f17a87b5db05;674e9096ec54f17a87b9d92f;674e9079ec54f17a87b9ae05;674e8f33ec54f17a87b7f69a;674e8d94ec54f17a87b603b6;674e8f9fec54f17a87b88266;674e8e94ec54f17a87b72269;674e906aec54f17a87b99493;674e8e7cec54f17a87b70306;674e9076ec54f17a87b9a9d1;674e8e8cec54f17a87b718f7;674e90f3ec54f17a87ba46d2;674e904dec54f17a87b95a55;674e9019ec54f17a87b91927;674e8f24ec54f17a87b7e27f;674e8efbec54f17a87b7a575;674e91d9ec54f17a87bb13b3;674e8ee1ec54f17a87b7845f;674e90fdec54f17a87ba4fb0;674e8e10ec54f17a87b67c10;674e9136ec54f17a87ba8239;674e8ef8ec54f17a87b7a273;674e902bec54f17a87b92ef5;674e8e8bec54f17a87b716e3;674e8e93ec54f17a87b72025;674e8d5bec54f17a87b5cd33;674e9133ec54f17a87ba7fd6;674e8db9ec54f17a87b627a0;674e90ecec54f17a87ba4030;674e9148ec54f17a87ba9245;674e90b0ec54f17a87b9fe00;674e8e9bec54f17a87b72ad9;674e8e87ec54f17a87b7119a;674e8f53ec54f17a87b81fc2;674e8da2ec54f17a87b611bd;674e9093ec54f17a87b9d4e4;674e910aec54f17a87ba5ce3;674e8f90ec54f17a87b86e46;674e8efdec54f17a87b7a7a2;674e8ebbec54f17a87b752e3;674e9021ec54f17a87b922c1;674e9200ec54f17a87bb32ce;674e8f53ec54f17a87b8204e;674e9022ec54f17a87b9249e;674e8edcec54f17a87b77e20;674e8fb1ec54f17a87b8987a;674e91eeec54f17a87bb24b0;674e906dec54f17a87b998d3;674e916cec54f17a87bab329;674e916aec54f17a87bab185;674e8deeec54f17a87b65574;674e8db6ec54f17a87b62453;674e8f9aec54f17a87b87bdf;674e8df0ec54f17a87b65704;674e91ecec54f17a87bb2347;674e8decec54f17a87b6542f;674e8ee6ec54f17a87b78a39;674e8f4fec54f17a87b81b6c;674e9160ec54f17a87baa91d;674e8e28ec54f17a87b69427;674e8fa7ec54f17a87b88ccb;674e91ceec54f17a87bb0b43;674e8f36ec54f17a87b7fa3a;674e8f1fec54f17a87b7d67f;674e8de4ec54f17a87b64ce0;674e905cec54f17a87b97af1;674e9079ec54f17a87b9aead;674e90d0ec54f17a87ba2494;674e906fec54f17a87b99c87;674e90a5ec54f17a87b9ee81;674e8ed6ec54f17a87b775e8",
          },
          {
            value: "pixel",
            count: 128,
            keywordIds:
              "674e903cec54f17a87b944ca;674e8ec2ec54f17a87b75d51;674e8e0eec54f17a87b679ab;674e8e83ec54f17a87b70dac;674e8e38ec54f17a87b6a25a;674e8fa4ec54f17a87b888db;674e8e96ec54f17a87b72547;674e90c3ec54f17a87ba1727;674e903fec54f17a87b9488b;674e8f21ec54f17a87b7d84f;674e9069ec54f17a87b991a3;674e8d06ec54f17a87b5798c;674e8e51ec54f17a87b6ba74;674e91cbec54f17a87bb08a5;674e8fb1ec54f17a87b898b0;674e8f87ec54f17a87b861ce;674e8f3bec54f17a87b80156;674e8e2bec54f17a87b695f3;674e91f6ec54f17a87bb2b14;674e8d21ec54f17a87b594e4;674e8e67ec54f17a87b6e825;674e8e73ec54f17a87b6f82e;674e903aec54f17a87b94264;674e8fcbec54f17a87b8bac0;674e8ed2ec54f17a87b7703c;674e91abec54f17a87baeda5;674e90a7ec54f17a87b9f18d;674e8d92ec54f17a87b6025d;674e8d08ec54f17a87b57ace;674e908cec54f17a87b9cae4;674e8f77ec54f17a87b84d27;674e9170ec54f17a87bab66e;674e8d20ec54f17a87b59386;674e8f9dec54f17a87b87f76;674e8e7cec54f17a87b70370;674e8e6fec54f17a87b6f2a1;674e8e74ec54f17a87b6f9cd;674e8f91ec54f17a87b86fba;674e8d8cec54f17a87b5fccd;674e8d17ec54f17a87b58a4c;674e9057ec54f17a87b9715d;674e8efaec54f17a87b7a404;674e8e48ec54f17a87b6b199;674e8d8dec54f17a87b5fd7c;674e8d83ec54f17a87b5f492;674e8e81ec54f17a87b70ac8;674e8d52ec54f17a87b5c437;674e8dbaec54f17a87b627d7;674e903aec54f17a87b94257;674e8dc2ec54f17a87b62f28;674e8ec2ec54f17a87b75d40;674e8dcdec54f17a87b6397c;674e917dec54f17a87bac7c9;674e8dd2ec54f17a87b63d68;674e8e82ec54f17a87b70c52;674e904eec54f17a87b95bce;674e8d05ec54f17a87b577eb;674e9004ec54f17a87b90072;674e8ea3ec54f17a87b7340e;674e8f85ec54f17a87b85f5a;674e908fec54f17a87b9cf04;674e8f72ec54f17a87b845e7;674e8e9cec54f17a87b72cdd;674e8d48ec54f17a87b5bb1d;674e8f5aec54f17a87b82868;674e8d91ec54f17a87b60170;674e8fc5ec54f17a87b8b1eb;674e8d41ec54f17a87b5b4d2;674e9166ec54f17a87baae5c;674e9039ec54f17a87b940b4;674e9052ec54f17a87b967dd;674e8e6bec54f17a87b6ee72;674e8edcec54f17a87b77d2f;674e9049ec54f17a87b95476;674e9155ec54f17a87ba9e9b;674e8f4bec54f17a87b815eb;674e8d2cec54f17a87b5a054;674e8fb8ec54f17a87b8a233;674e8f75ec54f17a87b849b4;674e902eec54f17a87b933a8;674e8fc3ec54f17a87b8af33;674e8d58ec54f17a87b5ca6e;674e8decec54f17a87b65488;674e8e69ec54f17a87b6eb3a;674e8efaec54f17a87b7a40b;674e903cec54f17a87b94493;674e8d46ec54f17a87b5b941;674e8e4eec54f17a87b6b88d;674e901dec54f17a87b91ed5;674e8fbdec54f17a87b8a7d4;674e8d3cec54f17a87b5afda;674e8ecdec54f17a87b769f4;674e8eb2ec54f17a87b7486b;674e8fa5ec54f17a87b88a12;674e8f03ec54f17a87b7afa9",
          },
          {
            value: "feed",
            count: 124,
            keywordIds:
              "674e903aec54f17a87b9416d;674e8d1cec54f17a87b58fc4;674e8e90ec54f17a87b71d19;674e9100ec54f17a87ba536b;674e8fe2ec54f17a87b8d684;674e905aec54f17a87b97881;674e8ff9ec54f17a87b8f224;674e8f60ec54f17a87b82f8d;674e90dfec54f17a87ba336d;674e8d47ec54f17a87b5ba88;674e9080ec54f17a87b9b856;674e8fddec54f17a87b8d07e;674e8f93ec54f17a87b87265;674e8d3eec54f17a87b5b129;674e8cfcec54f17a87b56f92;674e8e1eec54f17a87b68a04;674e9015ec54f17a87b914ae;674e9043ec54f17a87b94cbd;674e8f21ec54f17a87b7d93d;674e9139ec54f17a87ba84fe;674e8e20ec54f17a87b68c1f;674e90adec54f17a87b9fa1c;674e91bfec54f17a87bafeaa;674e91aeec54f17a87baf01b;674e8ef1ec54f17a87b798e7;674e91c5ec54f17a87bb0381;674e9038ec54f17a87b93f79;674e9063ec54f17a87b987da;674e9065ec54f17a87b98b43;674e8db8ec54f17a87b6268e;674e8fffec54f17a87b8f991;674e8e95ec54f17a87b7235b;674e8de2ec54f17a87b64ba1;674e8e6eec54f17a87b6f1f2;674e8f4aec54f17a87b81499;674e8e69ec54f17a87b6eb7d;674e91baec54f17a87bafaba;674e9164ec54f17a87baacf1;674e8de6ec54f17a87b64fa8;674e90d5ec54f17a87ba2968;674e8d31ec54f17a87b5a472;674e915cec54f17a87baa5c8;674e8e72ec54f17a87b6f726;674e8f76ec54f17a87b84bcb;674e8f29ec54f17a87b7e8b3;674e8fe1ec54f17a87b8d443;674e8d8cec54f17a87b5fc3c;674e8f73ec54f17a87b847ad;674e9137ec54f17a87ba8334;674e911eec54f17a87ba6df2;674e8df8ec54f17a87b66212;674e907dec54f17a87b9b4aa;674e9187ec54f17a87bacfca;674e8f89ec54f17a87b86421;674e8e42ec54f17a87b6ac8f;674e90a8ec54f17a87b9f3c3;674e8f81ec54f17a87b85a5c;674e9176ec54f17a87babbe8;674e8f46ec54f17a87b80efd;674e9017ec54f17a87b916c3;674e8f6eec54f17a87b840c8;674e8dcdec54f17a87b638f2;674e8ea0ec54f17a87b73111;674e917bec54f17a87bac018;674e8cf7ec54f17a87b56a57;674e8da1ec54f17a87b610d6;674e912dec54f17a87ba7ad2;674e8f90ec54f17a87b86dbd;674e8d6eec54f17a87b5df93;674e8f04ec54f17a87b7b12d;674e8e5dec54f17a87b6db8d;674e8d40ec54f17a87b5b3df;674e9040ec54f17a87b948fc;674e8fe5ec54f17a87b8d9b2;674e8fffec54f17a87b8fa1e;674e8ed3ec54f17a87b7717c;674e8eb1ec54f17a87b7473a;674e9024ec54f17a87b92653;674e8d38ec54f17a87b5abc9;674e9123ec54f17a87ba7234;674e9049ec54f17a87b954d8;674e8fdbec54f17a87b8cd81;674e90beec54f17a87ba1125;674e8ee7ec54f17a87b78bc8;674e8e64ec54f17a87b6e4b9;674e8f75ec54f17a87b84a71;674e8effec54f17a87b7aaf6;674e8f8bec54f17a87b866ff;674e8fe7ec54f17a87b8db72;674e8decec54f17a87b653db;674e8e29ec54f17a87b6949c;674e8dfaec54f17a87b664a5;674e8debec54f17a87b65303;674e8f35ec54f17a87b7f947;674e8fa0ec54f17a87b88340;674e8f67ec54f17a87b83833;674e8e70ec54f17a87b6f496;674e9107ec54f17a87ba594f;674e8fdfec54f17a87b8d201",
          },
          {
            value: "microchip",
            count: 121,
            keywordIds:
              "674e8fe3ec54f17a87b8d71a;674e8f68ec54f17a87b83a8f;674e8f0eec54f17a87b7bf4e;674e8de8ec54f17a87b65088;674e910cec54f17a87ba5e88;674e904bec54f17a87b95707;674e8f9eec54f17a87b8818c;674e90c3ec54f17a87ba1788;674e8f21ec54f17a87b7d930;674e8f8eec54f17a87b86be7;674e9074ec54f17a87b9a6cc;674e8dbcec54f17a87b629de;674e9172ec54f17a87bab841;674e90bbec54f17a87ba0dc5;674e91eaec54f17a87bb2172;674e8cfcec54f17a87b56ef8;674e8d5aec54f17a87b5cc84;674e8eacec54f17a87b74065;674e8e36ec54f17a87b6a132;674e8e98ec54f17a87b726e5;674e907fec54f17a87b9b81b;674e8f06ec54f17a87b7b36e;674e91beec54f17a87bafe88;674e8f3bec54f17a87b80135;674e9070ec54f17a87b99e4b;674e8e43ec54f17a87b6ad2d;674e905fec54f17a87b98210;674e9073ec54f17a87b9a471;674e8f1eec54f17a87b7d410;674e8feeec54f17a87b8e46b;674e9050ec54f17a87b96387;674e8f9cec54f17a87b87ea8;674e910dec54f17a87ba5f27;674e8dc5ec54f17a87b631fa;674e9180ec54f17a87bac97e;674e90b3ec54f17a87ba017d;674e9152ec54f17a87ba9b82;674e8fadec54f17a87b8939f;674e908dec54f17a87b9cc1f;674e8fb3ec54f17a87b89b88;674e8e71ec54f17a87b6f693;674e9030ec54f17a87b935aa;674e9189ec54f17a87bad12b;674e8f92ec54f17a87b870c9;674e8fa6ec54f17a87b88a49;674e8f54ec54f17a87b8217a;674e9136ec54f17a87ba8286;674e911eec54f17a87ba6d8f;674e8efaec54f17a87b7a4b9;674e905dec54f17a87b97ce9;674e8e47ec54f17a87b6b0ee;674e8f8aec54f17a87b8658a;674e8e65ec54f17a87b6e553;674e8e8cec54f17a87b71854;674e8ec9ec54f17a87b764f9;674e8ed5ec54f17a87b7738b;674e8dbaec54f17a87b62830;674e911fec54f17a87ba6ed7;674e9147ec54f17a87ba915a;674e8f8eec54f17a87b86ae0;674e9007ec54f17a87b9036f;674e8fd0ec54f17a87b8c052;674e917aec54f17a87babfb0;674e8d4bec54f17a87b5be38;674e903eec54f17a87b9470a;674e8f07ec54f17a87b7b4f6;674e8ff7ec54f17a87b8ef66;674e90eeec54f17a87ba41d3;674e8da1ec54f17a87b61087;674e909dec54f17a87b9e390;674e8e8fec54f17a87b71c78;674e8e66ec54f17a87b6e69e;674e8f00ec54f17a87b7ac7d;674e8f2eec54f17a87b7f02c;674e903fec54f17a87b94854;674e9016ec54f17a87b9156e;674e8f19ec54f17a87b7cd65;674e8d6dec54f17a87b5de23;674e91d5ec54f17a87bb104c;674e8f35ec54f17a87b7f8d7;674e9124ec54f17a87ba7292;674e8e3eec54f17a87b6a869;674e8f12ec54f17a87b7c3a1;674e8fbdec54f17a87b8a797;674e8fafec54f17a87b896ce;674e8f65ec54f17a87b83600;674e90d7ec54f17a87ba2b99;674e8fe8ec54f17a87b8dccb;674e8e6aec54f17a87b6ec11;674e8f41ec54f17a87b807ca;674e8fdeec54f17a87b8d0ec;674e8fbeec54f17a87b8a8ea;674e8eceec54f17a87b76ab0;674e906dec54f17a87b99901;674e91dcec54f17a87bb159a;674e8d35ec54f17a87b5a884;674e9000ec54f17a87b8fb0d;674e91e5ec54f17a87bb1db4",
          },
          {
            value: "system",
            count: 119,
            keywordIds:
              "674e9071ec54f17a87b9a191;674e8d6bec54f17a87b5dbbb;674e903dec54f17a87b94563;674e904aec54f17a87b9559a;674e8d4fec54f17a87b5c26f;674e8fbeec54f17a87b8a98a;674e91b4ec54f17a87baf54d;674e8fb5ec54f17a87b89dee;674e90c1ec54f17a87ba14ee;674e8e2fec54f17a87b6997b;674e8f63ec54f17a87b832f8;674e8f78ec54f17a87b84d92;674e8f58ec54f17a87b82554;674e8e5fec54f17a87b6de90;674e91eaec54f17a87bb21a1;674e8e00ec54f17a87b66c24;674e91f6ec54f17a87bb2aa1;674e8d5aec54f17a87b5cc38;674e8e6bec54f17a87b6ee44;674e8d0eec54f17a87b581d6;674e9045ec54f17a87b94f48;674e9195ec54f17a87badb49;674e9204ec54f17a87bb35a0;674e91bfec54f17a87bafee3;674e8f3bec54f17a87b800b0;674e8ff2ec54f17a87b8e9c2;674e8ff1ec54f17a87b8e7d1;674e8db8ec54f17a87b62572;674e9012ec54f17a87b9114f;674e8e4bec54f17a87b6b53a;674e9051ec54f17a87b9651d;674e8f19ec54f17a87b7ccf8;674e8f7bec54f17a87b852af;674e8d55ec54f17a87b5c804;674e8f48ec54f17a87b811f3;674e90f4ec54f17a87ba474d;674e8d0aec54f17a87b57d1b;674e8ffbec54f17a87b8f430;674e8e19ec54f17a87b68537;674e8e74ec54f17a87b6f92e;674e8f38ec54f17a87b7fdaf;674e8d72ec54f17a87b5e2a3;674e8e71ec54f17a87b6f645;674e8fa6ec54f17a87b88b5b;674e8d7eec54f17a87b5f009;674e8f0dec54f17a87b7bcfe;674e8efbec54f17a87b7a60d;674e8d9bec54f17a87b60acf;674e8f8cec54f17a87b868ba;674e9125ec54f17a87ba7362;674e8f6cec54f17a87b83f0f;674e8d63ec54f17a87b5d3c6;674e8d85ec54f17a87b5f670;674e9001ec54f17a87b8fc2e;674e8fcfec54f17a87b8bfc1;674e8ed0ec54f17a87b76df4;674e908bec54f17a87b9c8b4;674e8ef7ec54f17a87b7a0ba;674e8fe5ec54f17a87b8da01;674e8f4dec54f17a87b818d4;674e91d0ec54f17a87bb0c5e;674e90a1ec54f17a87b9e881;674e8d40ec54f17a87b5b2cc;674e8f7dec54f17a87b8552c;674e8f70ec54f17a87b84406;674e9092ec54f17a87b9d2eb;674e8dbeec54f17a87b62be1;674e8f3dec54f17a87b803f1;674e8faeec54f17a87b89483;674e90b1ec54f17a87b9fecb;674e9006ec54f17a87b9021a;674e8f42ec54f17a87b80903;674e8f20ec54f17a87b7d7e8;674e9192ec54f17a87bad8d2;674e8f1aec54f17a87b7ce69;674e9029ec54f17a87b92c5a;674e90f1ec54f17a87ba4411;674e8e5cec54f17a87b6d952;674e8da0ec54f17a87b60fdb;674e90beec54f17a87ba10d4;674e8e63ec54f17a87b6e3e9;674e8f44ec54f17a87b80bd5;674e8e5cec54f17a87b6da6c;674e8f93ec54f17a87b8733b;674e91e8ec54f17a87bb2018;674e8e8eec54f17a87b71b0d;674e8fdeec54f17a87b8d1c6;674e8dd1ec54f17a87b63c8d;674e8ee2ec54f17a87b785bf;674e8e61ec54f17a87b6e03e;674e8f7dec54f17a87b855ab;674e9134ec54f17a87ba8088;674e905bec54f17a87b97a0d;674e8eafec54f17a87b74520;674e9106ec54f17a87ba58bf;674e8ff0ec54f17a87b8e700;674e908dec54f17a87b9cc14",
          },
          {
            value: "firewall",
            count: 117,
            keywordIds:
              "674e9081ec54f17a87b9b9a7;674e9173ec54f17a87bab8d1;674e90b5ec54f17a87ba04ce;674e9011ec54f17a87b90f67;674e8f7fec54f17a87b85783;674e91b4ec54f17a87baf5ec;674e90b7ec54f17a87ba0703;674e8f23ec54f17a87b7db03;674e907cec54f17a87b9b338;674e904dec54f17a87b959d7;674e8f62ec54f17a87b8326b;674e8dc9ec54f17a87b6351c;674e8f58ec54f17a87b825e1;674e8f0eec54f17a87b7be9b;674e9202ec54f17a87bb33dc;674e902eec54f17a87b932c3;674e8e1dec54f17a87b6892d;674e8f6dec54f17a87b83fab;674e917eec54f17a87bac84e;674e9043ec54f17a87b94d50;674e8d1eec54f17a87b59208;674e8fcdec54f17a87b8bcf9;674e8f06ec54f17a87b7b2e8;674e8e12ec54f17a87b67e0f;674e8ef4ec54f17a87b79c13;674e8f83ec54f17a87b85cf1;674e916dec54f17a87bab42b;674e914eec54f17a87ba988d;674e8d87ec54f17a87b5f879;674e8f72ec54f17a87b84686;674e8f34ec54f17a87b7f72b;674e9012ec54f17a87b91073;674e8e4cec54f17a87b6b578;674e8fcbec54f17a87b8b9eb;674e8e2dec54f17a87b69827;674e8daeec54f17a87b61cac;674e902bec54f17a87b92ed0;674e90e2ec54f17a87ba36bd;674e8f0aec54f17a87b7b973;674e8d56ec54f17a87b5c89b;674e8e35ec54f17a87b69f7f;674e8de6ec54f17a87b64efd;674e8f2aec54f17a87b7ea5d;674e9146ec54f17a87ba90b5;674e8f5bec54f17a87b8298e;674e9025ec54f17a87b9281a;674e8f2fec54f17a87b7f064;674e9029ec54f17a87b92d48;674e91deec54f17a87bb177f;674e8cfbec54f17a87b56df7;674e8ec1ec54f17a87b75aef;674e8dd8ec54f17a87b6430f;674e8f47ec54f17a87b80fb8;674e8f31ec54f17a87b7f325;674e8dbfec54f17a87b62c76;674e8f6cec54f17a87b83e5d;674e8f61ec54f17a87b83133;674e912eec54f17a87ba7c26;674e917dec54f17a87bac732;674e90a2ec54f17a87b9e9fa;674e909aec54f17a87b9de15;674e8f48ec54f17a87b811a3;674e910bec54f17a87ba5d22;674e8e61ec54f17a87b6e182;674e8e89ec54f17a87b7152f;674e8eb2ec54f17a87b74966;674e8f47ec54f17a87b80fad;674e8f59ec54f17a87b82781;674e9035ec54f17a87b93baa;674e90c1ec54f17a87ba157a;674e8f17ec54f17a87b7ca13;674e8e1aec54f17a87b685ca;674e8d37ec54f17a87b5aafe;674e8fb0ec54f17a87b89818;674e91efec54f17a87bb2509;674e8eeeec54f17a87b79562;674e8e62ec54f17a87b6e2b6;674e8d13ec54f17a87b58691;674e90beec54f17a87ba11c9;674e91ffec54f17a87bb320d;674e8d3aec54f17a87b5ad14;674e8ec5ec54f17a87b760a6;674e8d79ec54f17a87b5ea8d;674e8f3aec54f17a87b7ff8e;674e8f25ec54f17a87b7e316;674e905aec54f17a87b97758;674e90eaec54f17a87ba3d89;674e8f7dec54f17a87b854cc;674e900aec54f17a87b90706;674e90b8ec54f17a87ba0928",
          },
          {
            value: "bandwidth",
            count: 116,
            keywordIds:
              "674e903eec54f17a87b946ff;674e9065ec54f17a87b98c3d;674e8f94ec54f17a87b87473;674e8d27ec54f17a87b59bae;674e90dfec54f17a87ba33c5;674e9095ec54f17a87b9d722;674e8eb0ec54f17a87b745e9;674e8ecdec54f17a87b769d5;674e91c6ec54f17a87bb0477;674e8ef4ec54f17a87b79d1b;674e8dbcec54f17a87b62980;674e9179ec54f17a87babea2;674e8db5ec54f17a87b622d3;674e8eaeec54f17a87b74377;674e8fb2ec54f17a87b899f8;674e90a7ec54f17a87b9f132;674e8f30ec54f17a87b7f1e7;674e8f90ec54f17a87b86d75;674e8ff3ec54f17a87b8eab4;674e9002ec54f17a87b8fe21;674e9093ec54f17a87b9d589;674e8f96ec54f17a87b87665;674e8d9eec54f17a87b60d65;674e8fa9ec54f17a87b88e1c;674e8dfcec54f17a87b66792;674e8e96ec54f17a87b724c4;674e8ebfec54f17a87b75816;674e8d15ec54f17a87b58879;674e8db2ec54f17a87b62026;674e8f9fec54f17a87b882f4;674e91c1ec54f17a87bb0040;674e8f47ec54f17a87b810cd;674e8fcfec54f17a87b8beb1;674e8d31ec54f17a87b5a521;674e9085ec54f17a87b9bff3;674e8f9dec54f17a87b88065;674e8dd4ec54f17a87b63ef5;674e8f2aec54f17a87b7e9c7;674e8d53ec54f17a87b5c5ca;674e8dacec54f17a87b61b2e;674e8fe8ec54f17a87b8dcff;674e8fcfec54f17a87b8be92;674e8efcec54f17a87b7a6bb;674e9090ec54f17a87b9d0ea;674e90cdec54f17a87ba21f4;674e8dd8ec54f17a87b642b7;674e8f8dec54f17a87b8697f;674e8fcfec54f17a87b8bf7d;674e9206ec54f17a87bb372b;674e8f32ec54f17a87b7f46e;674e8f8eec54f17a87b86b7d;674e906eec54f17a87b99b20;674e8f70ec54f17a87b84305;674e8dafec54f17a87b61dff;674e8f7cec54f17a87b8533c;674e8fadec54f17a87b89476;674e8ee4ec54f17a87b78790;674e8fefec54f17a87b8e5d9;674e8ea3ec54f17a87b73489;674e8d03ec54f17a87b5761e;674e8f16ec54f17a87b7c868;674e8f57ec54f17a87b824e5;674e8ddfec54f17a87b64935;674e914bec54f17a87ba9533;674e8e9dec54f17a87b72d8c;674e8d48ec54f17a87b5bb5e;674e8ea9ec54f17a87b73d5e;674e8fa2ec54f17a87b885e4;674e8f16ec54f17a87b7c98e;674e9017ec54f17a87b91694;674e90b1ec54f17a87b9ff5b;674e904aec54f17a87b955a9;674e901eec54f17a87b91f0b;674e9156ec54f17a87ba9f3e;674e8e81ec54f17a87b709ab;674e8e3dec54f17a87b6a77d;674e9175ec54f17a87baba8a;674e8d73ec54f17a87b5e402;674e9194ec54f17a87bada30;674e8fbdec54f17a87b8a6ea;674e8f9aec54f17a87b87bed;674e90ddec54f17a87ba3140;674e8d39ec54f17a87b5ac1a;674e8f14ec54f17a87b7c6ca;674e8f8bec54f17a87b8678e;674e8efbec54f17a87b7a50b;674e901eec54f17a87b91fcb;674e90a4ec54f17a87b9eda5;674e8dd9ec54f17a87b64370;674e9116ec54f17a87ba6723;674e8eadec54f17a87b7423e;674e8dceec54f17a87b63a62;674e8f1fec54f17a87b7d56f;674e90c4ec54f17a87ba1901",
          },
          {
            value: "monitor",
            count: 114,
            keywordIds:
              "674e9089ec54f17a87b9c598;674e903cec54f17a87b94429;674e8f0bec54f17a87b7b9f4;674e8e9eec54f17a87b72ec6;674e8f86ec54f17a87b86110;674e8f5fec54f17a87b82ea2;674e8f63ec54f17a87b83391;674e90feec54f17a87ba51c8;674e8d07ec54f17a87b57a59;674e8eafec54f17a87b7449d;674e8f86ec54f17a87b8615e;674e8fbfec54f17a87b8aac7;674e9067ec54f17a87b98f29;674e8f3cec54f17a87b8023b;674e9031ec54f17a87b9374c;674e8eedec54f17a87b79380;674e8db4ec54f17a87b6226d;674e8f22ec54f17a87b7da02;674e9084ec54f17a87b9be36;674e8dacec54f17a87b61a8c;674e9045ec54f17a87b94f53;674e8ef2ec54f17a87b79969;674e8e75ec54f17a87b6fae8;674e8eb8ec54f17a87b74fc7;674e8fe5ec54f17a87b8d914;674e8ef9ec54f17a87b7a2e5;674e8d2bec54f17a87b59eb0;674e8e7bec54f17a87b701f3;674e9108ec54f17a87ba5a4c;674e8f33ec54f17a87b7f623;674e8fddec54f17a87b8cfe8;674e8fe0ec54f17a87b8d353;674e8f42ec54f17a87b809d0;674e9096ec54f17a87b9d90f;674e8dcaec54f17a87b63626;674e8f91ec54f17a87b86fe4;674e8f7bec54f17a87b851ea;674e8e1bec54f17a87b68789;674e9164ec54f17a87baac94;674e915eec54f17a87baa789;674e91d6ec54f17a87bb1103;674e8e6fec54f17a87b6f3b5;674e8dd3ec54f17a87b63e3c;674e8f74ec54f17a87b84852;674e8e31ec54f17a87b69c04;674e8ee0ec54f17a87b78253;674e8eeeec54f17a87b79476;674e901cec54f17a87b91cc1;674e8e88ec54f17a87b712b4;674e8d02ec54f17a87b5756d;674e8d52ec54f17a87b5c4f8;674e8d95ec54f17a87b60553;674e8f6eec54f17a87b84167;674e8f7cec54f17a87b85402;674e8feeec54f17a87b8e53d;674e9005ec54f17a87b90125;674e90a3ec54f17a87b9ecb8;674e8e83ec54f17a87b70cf6;674e90d8ec54f17a87ba2d22;674e8ddfec54f17a87b648b6;674e8e06ec54f17a87b6715a;674e902dec54f17a87b93159;674e8d92ec54f17a87b60205;674e905dec54f17a87b97d92;674e8e1bec54f17a87b6870c;674e8ed4ec54f17a87b77274;674e8ff2ec54f17a87b8e9b1;674e8ea2ec54f17a87b73337;674e8d73ec54f17a87b5e49f;674e8d98ec54f17a87b607d8;674e8d14ec54f17a87b5870d;674e8ecdec54f17a87b76a75;674e8fafec54f17a87b89700;674e8f44ec54f17a87b80c81;674e8ee1ec54f17a87b78486;674e8e15ec54f17a87b6819b;674e9034ec54f17a87b93a6b;674e8e08ec54f17a87b6741b;674e8f4fec54f17a87b81a76;674e8e7eec54f17a87b7065c;674e8e80ec54f17a87b70899;674e8ebaec54f17a87b751d2;674e90e9ec54f17a87ba3cf2;674e8dfaec54f17a87b6656e;674e90aaec54f17a87b9f66b;674e8d56ec54f17a87b5c8f8;674e8f26ec54f17a87b7e491;674e8efeec54f17a87b7a907;674e8eb2ec54f17a87b74971;674e90d1ec54f17a87ba2575;674e8fc8ec54f17a87b8b667",
          },
          {
            value: "port",
            count: 114,
            keywordIds:
              "674e9081ec54f17a87b9ba35;674e8ff7ec54f17a87b8ef67;674e9088ec54f17a87b9c503;674e8fb6ec54f17a87b89f0f;674e8ee9ec54f17a87b78f3b;674e8ddbec54f17a87b645be;674e8f6bec54f17a87b83dab;674e8edbec54f17a87b77cc0;674e913dec54f17a87ba88cf;674e9040ec54f17a87b9493b;674e8d13ec54f17a87b5856c;674e8f1cec54f17a87b7d1ed;674e8f3cec54f17a87b80266;674e8e2bec54f17a87b696bc;674e906bec54f17a87b995eb;674e9013ec54f17a87b91216;674e8d22ec54f17a87b595ff;674e8f10ec54f17a87b7c1aa;674e8e35ec54f17a87b6a04a;674e8f21ec54f17a87b7d966;674e8ef3ec54f17a87b79b60;674e8d00ec54f17a87b572b9;674e8f37ec54f17a87b7fbcb;674e90f9ec54f17a87ba4c89;674e8d2bec54f17a87b59f22;674e9053ec54f17a87b96a23;674e90b0ec54f17a87b9fe0e;674e91d8ec54f17a87bb12e0;674e8fbdec54f17a87b8a724;674e8f5bec54f17a87b829d7;674e8f42ec54f17a87b80982;674e8dc3ec54f17a87b62fe7;674e8ee3ec54f17a87b78692;674e8fc1ec54f17a87b8ad5e;674e8e88ec54f17a87b71331;674e90f3ec54f17a87ba4667;674e8f77ec54f17a87b84c3b;674e915bec54f17a87baa512;674e8cfeec54f17a87b5709f;674e8e0bec54f17a87b6772f;674e8fccec54f17a87b8bb9f;674e8e6fec54f17a87b6f30d;674e8e26ec54f17a87b69209;674e91f3ec54f17a87bb28c0;674e9027ec54f17a87b92afc;674e8f64ec54f17a87b834a1;674e9058ec54f17a87b972ce;674e8ffcec54f17a87b8f5e6;674e9117ec54f17a87ba67c1;674e9132ec54f17a87ba7f6f;674e903bec54f17a87b94346;674e8e5bec54f17a87b6d890;674e8d95ec54f17a87b6051b;674e8e95ec54f17a87b723ca;674e8f2eec54f17a87b7ef33;674e8facec54f17a87b89241;674e8d4bec54f17a87b5bdf9;674e8e0aec54f17a87b67655;674e8e89ec54f17a87b7149c;674e8ddfec54f17a87b648e6;674e9112ec54f17a87ba62f1;674e8e5eec54f17a87b6dc83;674e8f7dec54f17a87b855fa;674e900fec54f17a87b90cd2;674e8d42ec54f17a87b5b5ac;674e90b2ec54f17a87ba0033;674e90aeec54f17a87b9facc;674e8e80ec54f17a87b7096e;674e8f22ec54f17a87b7daf6;674e90f0ec54f17a87ba4313;674e90b3ec54f17a87ba0271;674e8f2dec54f17a87b7eec0;674e90caec54f17a87ba1e3d;674e8d25ec54f17a87b59922;674e8dccec54f17a87b63819;674e8fb8ec54f17a87b8a16f;674e8dddec54f17a87b64728;674e8e5dec54f17a87b6db5f;674e8ed5ec54f17a87b773ef;674e8e02ec54f17a87b66dc8;674e8e0fec54f17a87b67ae8;674e8e66ec54f17a87b6e79b;674e8f17ec54f17a87b7cad1;674e91ceec54f17a87bb0a9a;674e8ed8ec54f17a87b7782f;674e8f74ec54f17a87b848d4;674e8eb1ec54f17a87b747cf;674e8f20ec54f17a87b7d6ea;674e8fcaec54f17a87b8b862;674e8fefec54f17a87b8e5d4;674e8d8aec54f17a87b5fa1d",
          },
          {
            value: "alarm",
            count: 113,
            keywordIds:
              "674e901cec54f17a87b91cb2;674e8e92ec54f17a87b71f6a;674e8fbaec54f17a87b8a450;674e9066ec54f17a87b98d74;674e905bec54f17a87b979d6;674e9184ec54f17a87bacd5a;674e8f8eec54f17a87b86b82;674e90feec54f17a87ba5127;674e912aec54f17a87ba78a1;674e8fc2ec54f17a87b8adb2;674e9009ec54f17a87b905b7;674e8eabec54f17a87b73ecc;674e9052ec54f17a87b96789;674e8d62ec54f17a87b5d309;674e9016ec54f17a87b914f9;674e8eecec54f17a87b792af;674e8e5eec54f17a87b6dd26;674e8e40ec54f17a87b6a9ea;674e91aeec54f17a87baefd2;674e8d7cec54f17a87b5eddf;674e907bec54f17a87b9b082;674e9002ec54f17a87b8fd4a;674e8ed9ec54f17a87b77946;674e91acec54f17a87baee0e;674e8f91ec54f17a87b87081;674e8f0aec54f17a87b7b8bf;674e8ffeec54f17a87b8f803;674e8f85ec54f17a87b8601c;674e8fceec54f17a87b8bdcc;674e8d0aec54f17a87b57d8b;674e914aec54f17a87ba939b;674e9086ec54f17a87b9c0fa;674e8d43ec54f17a87b5b650;674e8e0cec54f17a87b677c3;674e9073ec54f17a87b9a502;674e9087ec54f17a87b9c33d;674e90cbec54f17a87ba1fcf;674e90faec54f17a87ba4dd1;674e8f82ec54f17a87b85afb;674e90fdec54f17a87ba503c;674e918fec54f17a87bad670;674e8fb6ec54f17a87b89f31;674e8e66ec54f17a87b6e6a9;674e8ec2ec54f17a87b75c44;674e8ed6ec54f17a87b77529;674e8e53ec54f17a87b6bd17;674e8e96ec54f17a87b72477;674e8e9aec54f17a87b72a84;674e8f2dec54f17a87b7ee87;674e8f0aec54f17a87b7b8f0;674e8f5aec54f17a87b82817;674e90e6ec54f17a87ba3a04;674e8d65ec54f17a87b5d642;674e8e09ec54f17a87b67585;674e9011ec54f17a87b90fb3;674e8e14ec54f17a87b68014;674e90bcec54f17a87ba0e33;674e913bec54f17a87ba86d7;674e8e61ec54f17a87b6e123;674e90d8ec54f17a87ba2c6f;674e8e90ec54f17a87b71d14;674e8f00ec54f17a87b7abab;674e8d1aec54f17a87b58d9a;674e9142ec54f17a87ba8cfe;674e8f03ec54f17a87b7af9e;674e9167ec54f17a87baaef9;674e8f4dec54f17a87b81794;674e8eb0ec54f17a87b74662;674e9063ec54f17a87b9885c;674e8f1aec54f17a87b7cef7;674e8e80ec54f17a87b70914;674e8d74ec54f17a87b5e527;674e906eec54f17a87b99ab4;674e8e5cec54f17a87b6da1e;674e8d9fec54f17a87b60f04;674e916cec54f17a87bab386;674e9185ec54f17a87bacea5;674e8f1cec54f17a87b7d0ee;674e8dcbec54f17a87b636d0;674e8e9aec54f17a87b72a6c;674e8e77ec54f17a87b6fdbf;674e9047ec54f17a87b9526a;674e8d5eec54f17a87b5cfc7;674e8da6ec54f17a87b61585;674e8d79ec54f17a87b5eb0f;674e8f50ec54f17a87b81c45;674e8ee0ec54f17a87b782dc;674e8ff0ec54f17a87b8e792;674e901fec54f17a87b92047;674e8ddaec54f17a87b6444c;674e8e49ec54f17a87b6b255;674e8d30ec54f17a87b5a3c1;674e90a5ec54f17a87b9ef2c",
          },
          {
            value: "card",
            count: 112,
            keywordIds:
              "674e9062ec54f17a87b98683;674e8e13ec54f17a87b67f08;674e8df5ec54f17a87b65bf8;674e8d4fec54f17a87b5c1a0;674e8f45ec54f17a87b80dd8;674e8f94ec54f17a87b87397;674e8f0dec54f17a87b7bdcb;674e907bec54f17a87b9b256;674e8eb0ec54f17a87b7469c;674e9129ec54f17a87ba77a4;674e8e51ec54f17a87b6baa7;674e8febec54f17a87b8e1b0;674e8e6cec54f17a87b6ef5e;674e8e4dec54f17a87b6b67f;674e8eaeec54f17a87b7439e;674e8eb6ec54f17a87b74d4a;674e8f69ec54f17a87b83b09;674e9031ec54f17a87b9365e;674e9042ec54f17a87b94c58;674e8fa7ec54f17a87b88c9f;674e8e36ec54f17a87b6a099;674e9059ec54f17a87b97679;674e8d11ec54f17a87b5841c;674e8f37ec54f17a87b7fca5;674e918aec54f17a87bad2b4;674e8d6fec54f17a87b5e086;674e918eec54f17a87bad570;674e8d9eec54f17a87b60dda;674e91a8ec54f17a87baeb09;674e8da8ec54f17a87b616e1;674e900eec54f17a87b90be3;674e91c8ec54f17a87bb05f0;674e8fc1ec54f17a87b8acb8;674e8eedec54f17a87b79344;674e8f09ec54f17a87b7b6e0;674e915bec54f17a87baa546;674e8f3aec54f17a87b7fff1;674e8d4aec54f17a87b5bd0b;674e91f3ec54f17a87bb28da;674e91a7ec54f17a87baea1a;674e8e87ec54f17a87b711d6;674e9026ec54f17a87b928f8;674e8f2fec54f17a87b7f195;674e8dadec54f17a87b61bc9;674e8eccec54f17a87b76924;674e8ef9ec54f17a87b7a356;674e8f89ec54f17a87b864d0;674e8cfbec54f17a87b56e51;674e909cec54f17a87b9e22c;674e91e3ec54f17a87bb1c0f;674e904eec54f17a87b95c35;674e8ec9ec54f17a87b76553;674e8ec0ec54f17a87b75a74;674e8fd7ec54f17a87b8c8e1;674e9096ec54f17a87b9d8e5;674e8ec7ec54f17a87b7636f;674e8e7fec54f17a87b706bb;674e913aec54f17a87ba8654;674e909dec54f17a87b9e361;674e8d4eec54f17a87b5c04d;674e8d1aec54f17a87b58e3f;674e9091ec54f17a87b9d20e;674e8e8bec54f17a87b716d7;674e9023ec54f17a87b92576;674e9143ec54f17a87ba8df2;674e8f42ec54f17a87b80a00;674e91b2ec54f17a87baf39b;674e8df6ec54f17a87b65d1e;674e8d0eec54f17a87b580aa;674e90b3ec54f17a87ba01a3;674e8fdaec54f17a87b8cc42;674e8e76ec54f17a87b6fce1;674e8d4cec54f17a87b5bf1a;674e8f82ec54f17a87b85c0d;674e8f4fec54f17a87b81b78;674e9060ec54f17a87b983ac;674e909eec54f17a87b9e49e;674e8eb7ec54f17a87b74f16;674e8dd1ec54f17a87b63c1f;674e8f28ec54f17a87b7e70e;674e91fcec54f17a87bb2f73;674e8dfbec54f17a87b665f4;674e90d1ec54f17a87ba2652;674e8e23ec54f17a87b68f26;674e91dbec54f17a87bb14fe;674e8e58ec54f17a87b6c97f;674e8eadec54f17a87b741f1;674e9105ec54f17a87ba5847;674e8fa6ec54f17a87b88ad7",
          },
          {
            value: "array",
            count: 110,
            keywordIds:
              "674e8f68ec54f17a87b839e9;674e9154ec54f17a87ba9d48;674e8fb9ec54f17a87b8a38b;674e8fb5ec54f17a87b89ec9;674e8f7fec54f17a87b85896;674e8f26ec54f17a87b7e457;674e90f5ec54f17a87ba4857;674e902aec54f17a87b92d8e;674e8d12ec54f17a87b58496;674e8f0eec54f17a87b7bf43;674e8f00ec54f17a87b7ab83;674e9179ec54f17a87babe71;674e8f2bec54f17a87b7ec5e;674e8f3fec54f17a87b805a5;674e905aec54f17a87b97731;674e8fecec54f17a87b8e2c1;674e8e85ec54f17a87b71005;674e9070ec54f17a87b99eca;674e8d7bec54f17a87b5ed14;674e8fc5ec54f17a87b8b23b;674e91d2ec54f17a87bb0d79;674e8eb5ec54f17a87b74be2;674e8fbfec54f17a87b8aa4f;674e9089ec54f17a87b9c6e7;674e9056ec54f17a87b96eab;674e8feeec54f17a87b8e49c;674e8f1eec54f17a87b7d490;674e8d15ec54f17a87b587d8;674e8f91ec54f17a87b86fab;674e9075ec54f17a87b9a884;674e8de9ec54f17a87b651dd;674e915fec54f17a87baa83b;674e9073ec54f17a87b9a459;674e8fcdec54f17a87b8bc79;674e9198ec54f17a87badde6;674e8dfeec54f17a87b66a4c;674e8ecbec54f17a87b767f7;674e8f0cec54f17a87b7bc4b;674e8fb6ec54f17a87b8a03e;674e90cdec54f17a87ba213f;674e8f4cec54f17a87b816a7;674e8ebbec54f17a87b7539d;674e8f61ec54f17a87b83189;674e8fa9ec54f17a87b88e27;674e8ebeec54f17a87b7575b;674e8efeec54f17a87b7a8b6;674e909aec54f17a87b9de80;674e8d05ec54f17a87b5787b;674e8f14ec54f17a87b7c6a1;674e8f7bec54f17a87b85172;674e8fe6ec54f17a87b8dad4;674e9110ec54f17a87ba615e;674e90efec54f17a87ba4276;674e8f48ec54f17a87b8124a;674e912eec54f17a87ba7b91;674e908eec54f17a87b9ce46;674e8eaaec54f17a87b73e2d;674e8ed8ec54f17a87b777bf;674e91a1ec54f17a87bae50c;674e8e9eec54f17a87b72f38;674e9087ec54f17a87b9c29d;674e9144ec54f17a87ba8e61;674e8ff3ec54f17a87b8eae2;674e8f5eec54f17a87b82d51;674e8faeec54f17a87b895e4;674e8d76ec54f17a87b5e74a;674e8f9bec54f17a87b87c93;674e906fec54f17a87b99d75;674e8d4dec54f17a87b5bf97;674e9034ec54f17a87b939eb;674e8fc4ec54f17a87b8b05e;674e903cec54f17a87b94465;674e901fec54f17a87b92142;674e9051ec54f17a87b96633;674e8e24ec54f17a87b68fbe;674e8e48ec54f17a87b6b208;674e8f18ec54f17a87b7cc7c;674e901aec54f17a87b91ae1;674e8fa1ec54f17a87b8857e;674e912cec54f17a87ba79b0;674e906fec54f17a87b99d9b",
          },
          {
            value: "circuit",
            count: 109,
            keywordIds:
              "674e9080ec54f17a87b9b8f9;674e90b6ec54f17a87ba0559;674e8e9fec54f17a87b72f70;674e8f0cec54f17a87b7bc83;674e907cec54f17a87b9b27a;674e8f4aec54f17a87b813cf;674e8feaec54f17a87b8dfae;674e8d06ec54f17a87b579c5;674e8f58ec54f17a87b82582;674e8f1bec54f17a87b7d09f;674e8f6fec54f17a87b8424c;674e8f59ec54f17a87b8267f;674e919fec54f17a87bae373;674e8dffec54f17a87b66b58;674e8fd3ec54f17a87b8c4bf;674e8f2bec54f17a87b7ec8d;674e8d37ec54f17a87b5aa7a;674e9099ec54f17a87b9dd4b;674e8f2aec54f17a87b7eabc;674e91c8ec54f17a87bb06a3;674e903bec54f17a87b9430b;674e8d11ec54f17a87b5838c;674e8e44ec54f17a87b6add2;674e8f60ec54f17a87b8301a;674e8fc4ec54f17a87b8b016;674e8ffeec54f17a87b8f8ec;674e8f06ec54f17a87b7b2f3;674e8fe0ec54f17a87b8d3eb;674e8fd8ec54f17a87b8caa8;674e8d6aec54f17a87b5da99;674e8ecbec54f17a87b7672e;674e8facec54f17a87b892e8;674e8f85ec54f17a87b85f4d;674e8e46ec54f17a87b6afec;674e8d09ec54f17a87b57cc9;674e8fc8ec54f17a87b8b629;674e9074ec54f17a87b9a5af;674e8d1dec54f17a87b59158;674e8ea5ec54f17a87b736d7;674e90baec54f17a87ba0b7b;674e8f0bec54f17a87b7ba96;674e91deec54f17a87bb1813;674e901cec54f17a87b91d4b;674e8d99ec54f17a87b608e5;674e9047ec54f17a87b95291;674e8fd7ec54f17a87b8c97c;674e9018ec54f17a87b917ad;674e8e78ec54f17a87b6ff17;674e8d82ec54f17a87b5f385;674e8f14ec54f17a87b7c5d8;674e8f7aec54f17a87b84fd4;674e9095ec54f17a87b9d7b0;674e9111ec54f17a87ba6206;674e8ec4ec54f17a87b75f73;674e8d4eec54f17a87b5c0d1;674e9159ec54f17a87baa374;674e8ebbec54f17a87b75404;674e91adec54f17a87baeebc;674e8ebfec54f17a87b758d2;674e8e1aec54f17a87b6865b;674e9017ec54f17a87b915d6;674e91b2ec54f17a87baf3cb;674e8f1bec54f17a87b7cf9e;674e90d4ec54f17a87ba28bd;674e9022ec54f17a87b9248b;674e906dec54f17a87b99973;674e8d25ec54f17a87b5997c;674e8fafec54f17a87b89623;674e8f8dec54f17a87b869da;674e91f2ec54f17a87bb27f5;674e8f43ec54f17a87b80b62;674e8ec6ec54f17a87b761c0;674e8fb5ec54f17a87b89d88;674e913fec54f17a87ba8a55;674e8f35ec54f17a87b7f85b;674e8e80ec54f17a87b7080f;674e8f36ec54f17a87b7faea;674e8edaec54f17a87b77a9e;674e8f18ec54f17a87b7cb7a;674e8dc7ec54f17a87b633d7;674e90b4ec54f17a87ba03f0;674e8edaec54f17a87b77a1c;674e8e57ec54f17a87b6c0b3;674e905bec54f17a87b97926;674e8f27ec54f17a87b7e580;674e8d19ec54f17a87b58cc5;674e90a4ec54f17a87b9edd3;674e908eec54f17a87b9cd2d",
          },
          {
            value: "protocol",
            count: 109,
            keywordIds:
              "674e8df5ec54f17a87b65c21;674e90ffec54f17a87ba52cc;674e8ddbec54f17a87b64513;674e8f25ec54f17a87b7e3e2;674e904fec54f17a87b95d0b;674e90c0ec54f17a87ba13ba;674e90c7ec54f17a87ba1b66;674e902aec54f17a87b92e07;674e90dcec54f17a87ba3062;674e8e6cec54f17a87b6f01d;674e9064ec54f17a87b98991;674e8eaaec54f17a87b73e5e;674e91ebec54f17a87bb2207;674e902eec54f17a87b93370;674e8fc0ec54f17a87b8ab49;674e8d5dec54f17a87b5cee5;674e9046ec54f17a87b951d4;674e917eec54f17a87bac81a;674e9013ec54f17a87b912b2;674e8d8fec54f17a87b5fec4;674e8d0fec54f17a87b58264;674e90a6ec54f17a87b9f05c;674e8fcdec54f17a87b8bc01;674e8e67ec54f17a87b6e93c;674e8e40ec54f17a87b6aa7f;674e919dec54f17a87bae1aa;674e9177ec54f17a87babc79;674e8e76ec54f17a87b6fcb9;674e918aec54f17a87bad229;674e8e85ec54f17a87b70ff9;674e9119ec54f17a87ba68fb;674e8f5fec54f17a87b82e0a;674e8f33ec54f17a87b7f6a3;674e8dc3ec54f17a87b6308d;674e8e93ec54f17a87b7213b;674e908bec54f17a87b9c86f;674e9078ec54f17a87b9ac6a;674e8f9cec54f17a87b87f44;674e8eebec54f17a87b7910b;674e90ceec54f17a87ba22c0;674e91deec54f17a87bb17e0;674e8e82ec54f17a87b70be0;674e8d5cec54f17a87b5cd8f;674e8f4cec54f17a87b8173e;674e9008ec54f17a87b90445;674e8f31ec54f17a87b7f382;674e8d63ec54f17a87b5d498;674e8fa9ec54f17a87b88f0f;674e8d4bec54f17a87b5be86;674e908aec54f17a87b9c7d0;674e8ff5ec54f17a87b8ed16;674e8e5fec54f17a87b6de47;674e8ff7ec54f17a87b8f01d;674e8ea2ec54f17a87b733d7;674e8e84ec54f17a87b70dd9;674e8edfec54f17a87b780c3;674e8f27ec54f17a87b7e61a;674e8e9dec54f17a87b72d05;674e8f62ec54f17a87b831fa;674e8f2fec54f17a87b7f15d;674e8e96ec54f17a87b7251c;674e8f4eec54f17a87b81910;674e8edbec54f17a87b77c71;674e8f34ec54f17a87b7f82d;674e8f97ec54f17a87b877f3;674e8dcbec54f17a87b63747;674e8db6ec54f17a87b623d4;674e8f9aec54f17a87b87b4e;674e8f54ec54f17a87b8216f;674e8ddeec54f17a87b647b5;674e8e79ec54f17a87b6ffb2;674e8fd5ec54f17a87b8c640;674e90abec54f17a87b9f78e;674e8efaec54f17a87b7a484;674e8f41ec54f17a87b80865;674e90b4ec54f17a87ba0330;674e8ed7ec54f17a87b7779a;674e8f74ec54f17a87b84831;674e8e3aec54f17a87b6a441;674e8eaeec54f17a87b7429d;674e8f26ec54f17a87b7e564;674e912bec54f17a87ba7935;674e9138ec54f17a87ba83eb;674e8e4aec54f17a87b6b3eb",
          },
          {
            value: "matrix",
            count: 108,
            keywordIds:
              "674e8fe2ec54f17a87b8d68f;674e8e91ec54f17a87b71e5e;674e8f0eec54f17a87b7bed5;674e8f7fec54f17a87b85888;674e8edcec54f17a87b77dc9;674e8e2eec54f17a87b698c6;674e913dec54f17a87ba8883;674e907bec54f17a87b9b116;674e9197ec54f17a87badccd;674e91c3ec54f17a87bb0261;674e9075ec54f17a87b9a77d;674e8f1cec54f17a87b7d12b;674e8f58ec54f17a87b825a5;674e8f9eec54f17a87b88118;674e8d0cec54f17a87b57ee9;674e8d36ec54f17a87b5a9f4;674e9067ec54f17a87b98ec5;674e9084ec54f17a87b9bf75;674e9044ec54f17a87b94ea3;674e8e11ec54f17a87b67d64;674e8d88ec54f17a87b5f910;674e8d7bec54f17a87b5ec9b;674e8e7aec54f17a87b70167;674e8dd6ec54f17a87b6411e;674e90ebec54f17a87ba3e9e;674e8e6fec54f17a87b6f371;674e90e0ec54f17a87ba3509;674e8fe8ec54f17a87b8dda3;674e8cfaec54f17a87b56cfb;674e8db2ec54f17a87b6209c;674e909fec54f17a87b9e613;674e8e7bec54f17a87b70231;674e908cec54f17a87b9cb83;674e90d5ec54f17a87ba2a28;674e9170ec54f17a87bab6e1;674e8ffbec54f17a87b8f4bf;674e8f24ec54f17a87b7e1d4;674e9199ec54f17a87bade64;674e8f13ec54f17a87b7c4f6;674e8e70ec54f17a87b6f4a1;674e8dffec54f17a87b66a94;674e8ebeec54f17a87b7574d;674e8d8bec54f17a87b5fb01;674e8eefec54f17a87b796bf;674e90cdec54f17a87ba2122;674e8e92ec54f17a87b71f32;674e9205ec54f17a87bb368c;674e8ec1ec54f17a87b75bb7;674e8ec3ec54f17a87b75de3;674e90a1ec54f17a87b9e933;674e909bec54f17a87b9df69;674e8ee8ec54f17a87b78c5f;674e8e5bec54f17a87b6d8ae;674e8ff6ec54f17a87b8ee61;674e8e68ec54f17a87b6e986;674e8ec7ec54f17a87b762aa;674e90bbec54f17a87ba0dd2;674e8f85ec54f17a87b86029;674e8d6eec54f17a87b5df57;674e9042ec54f17a87b94c4c;674e8d91ec54f17a87b6013b;674e8fc6ec54f17a87b8b33a;674e8f3eec54f17a87b804e1;674e8d42ec54f17a87b5b55c;674e8e97ec54f17a87b725de;674e901dec54f17a87b91e7a;674e8e74ec54f17a87b6f920;674e8f23ec54f17a87b7e0f9;674e8f89ec54f17a87b86444;674e8e50ec54f17a87b6b9e2;674e8f66ec54f17a87b836fe;674e9055ec54f17a87b96ce8;674e906eec54f17a87b99bd5;674e902eec54f17a87b9337b;674e8df0ec54f17a87b65792;674e8fe7ec54f17a87b8dc15;674e8f24ec54f17a87b7e229;674e903dec54f17a87b9450f;674e8edaec54f17a87b77af9;674e8ebaec54f17a87b75265;674e8ee3ec54f17a87b786b6;674e8e61ec54f17a87b6e135;674e8efeec54f17a87b7a9c7;674e8f09ec54f17a87b7b813;674e9079ec54f17a87b9adcb;674e8d2fec54f17a87b5a310",
          },
          {
            value: "interface",
            count: 105,
            keywordIds:
              "674e8eebec54f17a87b79130;674e9088ec54f17a87b9c431;674e8f4aec54f17a87b81455;674e8fb5ec54f17a87b89e67;674e8f87ec54f17a87b861f1;674e8d2eec54f17a87b5a1f8;674e8f8fec54f17a87b86c85;674e8dc8ec54f17a87b6349f;674e90f7ec54f17a87ba49e4;674e8fa3ec54f17a87b88785;674e8f6fec54f17a87b841a9;674e8f92ec54f17a87b87124;674e8d21ec54f17a87b59536;674e9121ec54f17a87ba6fcf;674e8d77ec54f17a87b5e920;674e8eb6ec54f17a87b74cfe;674e8ebcec54f17a87b75526;674e8f8fec54f17a87b86cb8;674e8d24ec54f17a87b597ee;674e8d87ec54f17a87b5f80e;674e91faec54f17a87bb2da7;674e8e86ec54f17a87b71078;674e9032ec54f17a87b937b3;674e8eb9ec54f17a87b7512f;674e9000ec54f17a87b8fad5;674e8ef5ec54f17a87b79e34;674e9152ec54f17a87ba9bf7;674e8fc0ec54f17a87b8ac19;674e8f88ec54f17a87b86385;674e8d00ec54f17a87b57353;674e8ea1ec54f17a87b731df;674e9077ec54f17a87b9abc0;674e8ffeec54f17a87b8f828;674e91a9ec54f17a87baebdb;674e8fa6ec54f17a87b88acb;674e8d16ec54f17a87b5896c;674e8fcaec54f17a87b8b89d;674e8d7dec54f17a87b5ef20;674e8df8ec54f17a87b662d4;674e8fceec54f17a87b8bd46;674e8ef0ec54f17a87b7976f;674e8d9aec54f17a87b6093b;674e8e8dec54f17a87b7191a;674e8ecaec54f17a87b7661c;674e8ed5ec54f17a87b77466;674e8fd0ec54f17a87b8c0d1;674e8ecfec54f17a87b76d0d;674e8f7bec54f17a87b85219;674e8e79ec54f17a87b6ffd2;674e8ea7ec54f17a87b7390a;674e8fefec54f17a87b8e678;674e9084ec54f17a87b9be92;674e9122ec54f17a87ba712f;674e8e7eec54f17a87b7060a;674e910aec54f17a87ba5cc2;674e8d3bec54f17a87b5ae7a;674e906cec54f17a87b997a3;674e8e59ec54f17a87b6d689;674e8feaec54f17a87b8df76;674e8e8fec54f17a87b71b7c;674e8f03ec54f17a87b7b041;674e8f17ec54f17a87b7cadc;674e903aec54f17a87b941a5;674e9052ec54f17a87b966f5;674e8d6dec54f17a87b5ddb9;674e9025ec54f17a87b92789;674e8e3cec54f17a87b6a644;674e8f3eec54f17a87b803fc;674e90b2ec54f17a87ba013a;674e90cbec54f17a87ba1f19;674e90beec54f17a87ba1237;674e90ddec54f17a87ba3162;674e9041ec54f17a87b94b15;674e8edeec54f17a87b78027;674e8fc8ec54f17a87b8b5a6;674e8e02ec54f17a87b66da0;674e8ee6ec54f17a87b78ad7;674e8f38ec54f17a87b7fd51;674e8ddcec54f17a87b64679;674e8d45ec54f17a87b5b7fa;674e8f99ec54f17a87b879da;674e90aaec54f17a87b9f5f7;674e8f73ec54f17a87b847bb;674e8e56ec54f17a87b6c00e;674e8e57ec54f17a87b6c18d;674e8df3ec54f17a87b65a50;674e8f1fec54f17a87b7d638",
          },
          {
            value: "transmitter",
            count: 104,
            keywordIds:
              "674e901cec54f17a87b91d92;674e9089ec54f17a87b9c631;674e90b5ec54f17a87ba0419;674e9011ec54f17a87b90f31;674e8eeaec54f17a87b78fb4;674e8f7fec54f17a87b857a4;674e8f6cec54f17a87b83df9;674e8edbec54f17a87b77c08;674e8e75ec54f17a87b6fb1a;674e8ff4ec54f17a87b8eccc;674e912aec54f17a87ba782a;674e8e32ec54f17a87b69d84;674e9074ec54f17a87b9a706;674e90a1ec54f17a87b9e976;674e8e4dec54f17a87b6b768;674e90bbec54f17a87ba0e01;674e9179ec54f17a87babf09;674e8d8fec54f17a87b5ff36;674e8d2aec54f17a87b59dd5;674e8fb2ec54f17a87b899cd;674e90afec54f17a87b9fbf5;674e8ef7ec54f17a87b7a054;674e919eec54f17a87bae25f;674e8e85ec54f17a87b70f05;674e8e75ec54f17a87b6fb91;674e8ff5ec54f17a87b8eddb;674e914dec54f17a87ba96fd;674e8ff1ec54f17a87b8e906;674e9038ec54f17a87b93ec7;674e9027ec54f17a87b929bc;674e9119ec54f17a87ba699d;674e9107ec54f17a87ba59c5;674e8f7aec54f17a87b8514c;674e8daaec54f17a87b619b7;674e8fdcec54f17a87b8cedd;674e9097ec54f17a87b9db1c;674e9033ec54f17a87b93949;674e9182ec54f17a87bacbca;674e8f33ec54f17a87b7f5f3;674e8e6eec54f17a87b6f25e;674e91c0ec54f17a87baffbe;674e8d08ec54f17a87b57b6e;674e906bec54f17a87b9955a;674e9053ec54f17a87b969b5;674e8d66ec54f17a87b5d717;674e8e18ec54f17a87b683f1;674e8f3bec54f17a87b80096;674e8d7aec54f17a87b5ebf2;674e91d9ec54f17a87bb1384;674e8ec6ec54f17a87b761a5;674e91e4ec54f17a87bb1c9e;674e8f75ec54f17a87b84989;674e8ebeec54f17a87b757ad;674e915dec54f17a87baa6ab;674e8da3ec54f17a87b61279;674e8ee5ec54f17a87b788dd;674e8f15ec54f17a87b7c744;674e9056ec54f17a87b96fb5;674e8e94ec54f17a87b72277;674e8f1bec54f17a87b7cfd3;674e8f4eec54f17a87b81996;674e90bbec54f17a87ba0d75;674e8ec4ec54f17a87b75ea2;674e8f05ec54f17a87b7b1c2;674e8f28ec54f17a87b7e79e;674e8e05ec54f17a87b670f4;674e8ea9ec54f17a87b73d34;674e8ea9ec54f17a87b73c88;674e8fa1ec54f17a87b88579;674e8eb4ec54f17a87b74ba7;674e8f4dec54f17a87b81878;674e8f94ec54f17a87b87495;674e8f15ec54f17a87b7c7a3;674e8f2eec54f17a87b7efb2;674e8fd5ec54f17a87b8c6b5;674e8f8cec54f17a87b86828;674e8ea5ec54f17a87b737ca;674e8f1dec54f17a87b7d2cb;674e8fc7ec54f17a87b8b53c;674e91f8ec54f17a87bb2be2;674e8e2fec54f17a87b69a24;674e8f32ec54f17a87b7f54a;674e90acec54f17a87b9f7f8;674e8d3cec54f17a87b5af3c;674e9039ec54f17a87b93fe7;674e8e56ec54f17a87b6bf84;674e8f18ec54f17a87b7cbfd;674e901bec54f17a87b91bce;674e8f27ec54f17a87b7e61f;674e9079ec54f17a87b9ad6b;674e8fcaec54f17a87b8b959;674e9138ec54f17a87ba843a",
          },
          {
            value: "capacitor",
            count: 100,
            keywordIds:
              "674e8d6cec54f17a87b5dc5a;674e8fb6ec54f17a87b89fc1;674e8eeaec54f17a87b7905a;674e8f7eec54f17a87b8570c;674e90b7ec54f17a87ba078c;674e8dc8ec54f17a87b634bd;674e900aec54f17a87b90654;674e8f80ec54f17a87b85992;674e8ec8ec54f17a87b76447;674e8d0bec54f17a87b57e5b;674e8e7aec54f17a87b700b2;674e9071ec54f17a87b9a0ad;674e8f11ec54f17a87b7c278;674e8d60ec54f17a87b5d1a8;674e91c2ec54f17a87bb0175;674e8e8dec54f17a87b719ad;674e8cffec54f17a87b57200;674e8ef8ec54f17a87b7a1e1;674e8fc6ec54f17a87b8b3da;674e8ee9ec54f17a87b78e2c;674e8ed8ec54f17a87b7786a;674e8fa9ec54f17a87b88ed2;674e9057ec54f17a87b970ae;674e8d69ec54f17a87b5da19;674e8eb8ec54f17a87b74ff9;674e8dc5ec54f17a87b63193;674e8ed1ec54f17a87b76f13;674e8db1ec54f17a87b61f8c;674e8ff8ec54f17a87b8f0cc;674e8f08ec54f17a87b7b619;674e9054ec54f17a87b96aaf;674e8d20ec54f17a87b593ac;674e8d34ec54f17a87b5a7a7;674e9199ec54f17a87bade1d;674e8f73ec54f17a87b846ed;674e911eec54f17a87ba6d4e;674e8ffcec54f17a87b8f63c;674e9019ec54f17a87b91a47;674e8eeeec54f17a87b795b3;674e905eec54f17a87b97fee;674e9046ec54f17a87b9515f;674e8f75ec54f17a87b84ac5;674e9018ec54f17a87b91767;674e8e9fec54f17a87b73032;674e904dec54f17a87b95af2;674e8e69ec54f17a87b6ea81;674e9010ec54f17a87b90f0e;674e8f4dec54f17a87b81813;674e8e66ec54f17a87b6e764;674e8eb2ec54f17a87b74999;674e90a0ec54f17a87b9e78f;674e8f62ec54f17a87b8328c;674e90acec54f17a87b9f8d2;674e9043ec54f17a87b94d42;674e8f52ec54f17a87b81f35;674e8e6bec54f17a87b6edd7;674e8d6dec54f17a87b5dd14;674e8d9cec54f17a87b60c14;674e9126ec54f17a87ba74ae;674e908cec54f17a87b9ca77;674e9186ec54f17a87bacf09;674e8f1bec54f17a87b7d090;674e8fafec54f17a87b89668;674e8db6ec54f17a87b623fc;674e8e39ec54f17a87b6a394;674e9035ec54f17a87b93b22;674e91ecec54f17a87bb22f0;674e8ee5ec54f17a87b789a0;674e8ed0ec54f17a87b76e84;674e8ee0ec54f17a87b7821a;674e8edaec54f17a87b77b7d;674e8eb9ec54f17a87b75180;674e8f07ec54f17a87b7b50e;674e8f17ec54f17a87b7cb00;674e8deaec54f17a87b65299;674e8f18ec54f17a87b7cba0;674e8f09ec54f17a87b7b6ec;674e8dcfec54f17a87b63b30;674e8fefec54f17a87b8e677",
          },
          {
            value: "drive",
            count: 100,
            keywordIds:
              "674e9061ec54f17a87b98600;674e8ec9ec54f17a87b76550;674e9183ec54f17a87baccda;674e8e97ec54f17a87b72669;674e9069ec54f17a87b992dc;674e8f78ec54f17a87b84e5c;674e91cbec54f17a87bb0846;674e8d5aec54f17a87b5cc01;674e8d29ec54f17a87b59d2d;674e9067ec54f17a87b98f9b;674e8e99ec54f17a87b7283b;674e8d23ec54f17a87b5970f;674e9178ec54f17a87babd6b;674e91f9ec54f17a87bb2cd6;674e907aec54f17a87b9afbe;674e918cec54f17a87bad3fa;674e8dd5ec54f17a87b6404d;674e8f95ec54f17a87b875c4;674e8ed1ec54f17a87b76f8d;674e9102ec54f17a87ba556e;674e8f9bec54f17a87b87dc7;674e910eec54f17a87ba6002;674e8f5cec54f17a87b82ab5;674e8da9ec54f17a87b617b9;674e8d93ec54f17a87b60326;674e8fc1ec54f17a87b8ad24;674e8e89ec54f17a87b7141b;674e8d01ec54f17a87b5743f;674e8f5bec54f17a87b82a5d;674e91d7ec54f17a87bb11f5;674e91daec54f17a87bb1422;674e8ffdec54f17a87b8f779;674e8ef4ec54f17a87b79c08;674e91e2ec54f17a87bb1a9d;674e8ec5ec54f17a87b760ab;674e8fceec54f17a87b8bdee;674e8ee1ec54f17a87b7839f;674e8f0cec54f17a87b7bbcc;674e8d83ec54f17a87b5f44b;674e90d3ec54f17a87ba27d7;674e8f52ec54f17a87b81e60;674e91ccec54f17a87bb0953;674e8d74ec54f17a87b5e5d6;674e8db0ec54f17a87b61edf;674e8ee8ec54f17a87b78d6a;674e8f52ec54f17a87b81f2a;674e8ea7ec54f17a87b73a61;674e8f7aec54f17a87b850d3;674e8e60ec54f17a87b6df00;674e912dec54f17a87ba7b2f;674e8d50ec54f17a87b5c318;674e907dec54f17a87b9b514;674e8f28ec54f17a87b7e6de;674e9027ec54f17a87b92acb;674e9091ec54f17a87b9d2dd;674e8ed7ec54f17a87b776f2;674e8dbdec54f17a87b62b11;674e8fa1ec54f17a87b88532;674e8ffaec54f17a87b8f2de;674e8ecfec54f17a87b76c3a;674e9006ec54f17a87b902ea;674e91b3ec54f17a87baf45c;674e8f10ec54f17a87b7c164;674e8ea2ec54f17a87b733d8;674e8f22ec54f17a87b7da42;674e8eb7ec54f17a87b74e18;674e8e55ec54f17a87b6bf24;674e8f99ec54f17a87b87b19;674e8e1fec54f17a87b68b90;674e8f37ec54f17a87b7fc1b;674e8fc7ec54f17a87b8b44b;674e911bec54f17a87ba6b02;674e8fa7ec54f17a87b88bd6;674e9009ec54f17a87b90649;674e8f67ec54f17a87b83898;674e8e71ec54f17a87b6f59c",
          },
          {
            value: "hard",
            count: 100,
            keywordIds:
              "674e9061ec54f17a87b985ae;674e8ec9ec54f17a87b7652d;674e9183ec54f17a87bacc9a;674e8e97ec54f17a87b72637;674e9069ec54f17a87b99293;674e8f78ec54f17a87b84e3a;674e91caec54f17a87bb0812;674e8d5aec54f17a87b5cbe2;674e8d29ec54f17a87b59d05;674e9067ec54f17a87b98f59;674e8e99ec54f17a87b727eb;674e8d23ec54f17a87b596e4;674e9178ec54f17a87babd47;674e91f9ec54f17a87bb2cad;674e907aec54f17a87b9af93;674e918cec54f17a87bad3de;674e8dd5ec54f17a87b6402f;674e8f95ec54f17a87b87590;674e8ed1ec54f17a87b76f2a;674e9102ec54f17a87ba553d;674e8f9bec54f17a87b87d7b;674e910eec54f17a87ba5fd2;674e8f5cec54f17a87b82a6a;674e8da9ec54f17a87b61775;674e8d93ec54f17a87b602f0;674e8fc1ec54f17a87b8acd5;674e8e89ec54f17a87b713e0;674e8d01ec54f17a87b5741c;674e8f5bec54f17a87b82a24;674e91d7ec54f17a87bb11c9;674e91daec54f17a87bb13f4;674e8ffdec54f17a87b8f733;674e8ef3ec54f17a87b79bd4;674e91e1ec54f17a87bb1a79;674e8ec5ec54f17a87b76067;674e8fceec54f17a87b8bdc0;674e8ee1ec54f17a87b78355;674e8f0cec54f17a87b7bb7b;674e8d83ec54f17a87b5f41a;674e90d3ec54f17a87ba27a2;674e8f52ec54f17a87b81e1e;674e91ccec54f17a87bb093c;674e8d74ec54f17a87b5e5b2;674e8db0ec54f17a87b61eb5;674e8ee8ec54f17a87b78d1b;674e8f52ec54f17a87b81ef9;674e8ea7ec54f17a87b73a14;674e8f7aec54f17a87b85066;674e8e5fec54f17a87b6ded7;674e912dec54f17a87ba7b13;674e8d50ec54f17a87b5c2fa;674e907dec54f17a87b9b4c2;674e8f28ec54f17a87b7e6ab;674e9027ec54f17a87b92a88;674e9091ec54f17a87b9d297;674e8ed7ec54f17a87b776b1;674e8dbdec54f17a87b62af8;674e8fa1ec54f17a87b88509;674e8ff9ec54f17a87b8f2ae;674e8ecfec54f17a87b76bf6;674e9006ec54f17a87b902bb;674e91b3ec54f17a87baf42a;674e8f10ec54f17a87b7c118;674e8ea2ec54f17a87b733aa;674e8f22ec54f17a87b7da0e;674e8eb6ec54f17a87b74de5;674e8e55ec54f17a87b6befa;674e8f99ec54f17a87b87aee;674e8e1fec54f17a87b68b5d;674e8f37ec54f17a87b7fbd6;674e8fc6ec54f17a87b8b41c;674e911bec54f17a87ba6ad2;674e8fa7ec54f17a87b88bae;674e9009ec54f17a87b905ff;674e8f67ec54f17a87b83865;674e8e71ec54f17a87b6f56d",
          },
          {
            value: "panel",
            count: 99,
            keywordIds:
              "674e8fe3ec54f17a87b8d7d6;674e9089ec54f17a87b9c5cc;674e8f0bec54f17a87b7babc;674e903eec54f17a87b9465f;674e8fbeec54f17a87b8a855;674e90b6ec54f17a87ba06d4;674e8ff8ec54f17a87b8f180;674e91d4ec54f17a87bb0f59;674e8ea9ec54f17a87b73c46;674e8f78ec54f17a87b84dea;674e9031ec54f17a87b93682;674e8d5cec54f17a87b5cdfc;674e8f6dec54f17a87b83fe0;674e8eadec54f17a87b74266;674e8f3fec54f17a87b80631;674e8d0fec54f17a87b581f7;674e909bec54f17a87b9dfb0;674e8d7fec54f17a87b5f095;674e9102ec54f17a87ba55e0;674e8f04ec54f17a87b7b0d3;674e9164ec54f17a87baac0a;674e8fe9ec54f17a87b8de48;674e8dafec54f17a87b61d78;674e90b3ec54f17a87ba0241;674e9109ec54f17a87ba5bb2;674e8de6ec54f17a87b64e85;674e8e9bec54f17a87b72b8b;674e8f29ec54f17a87b7e92c;674e8cfeec54f17a87b57129;674e8f39ec54f17a87b7fe02;674e900bec54f17a87b9086e;674e8ea5ec54f17a87b7375a;674e91aaec54f17a87baece2;674e8d8bec54f17a87b5fbc0;674e8e0fec54f17a87b67b50;674e8eecec54f17a87b791df;674e8eccec54f17a87b76863;674e9018ec54f17a87b91896;674e9082ec54f17a87b9bc41;674e8eefec54f17a87b796e8;674e8e42ec54f17a87b6ac0f;674e8e8bec54f17a87b71787;674e9076ec54f17a87b9a9df;674e8d9bec54f17a87b60b8d;674e9007ec54f17a87b90382;674e8dc0ec54f17a87b62d36;674e8e5bec54f17a87b6d816;674e8e54ec54f17a87b6bd68;674e8e95ec54f17a87b722f6;674e904cec54f17a87b9594d;674e8efeec54f17a87b7a912;674e8e93ec54f17a87b72147;674e9093ec54f17a87b9d598;674e9041ec54f17a87b94aee;674e90d9ec54f17a87ba2d8f;674e8d4dec54f17a87b5c003;674e8e8fec54f17a87b71c3c;674e905dec54f17a87b97cac;674e8f6aec54f17a87b83c19;674e8f94ec54f17a87b87405;674e8fd2ec54f17a87b8c325;674e8f16ec54f17a87b7c887;674e8fdcec54f17a87b8ceb7;674e8eb7ec54f17a87b74f3d;674e8fdaec54f17a87b8ccf0;674e8ee7ec54f17a87b78b44;674e8f82ec54f17a87b85b06;674e8d5fec54f17a87b5d064;674e8defec54f17a87b656c9;674e8d78ec54f17a87b5ea1d;674e8ea5ec54f17a87b73733;674e8e7eec54f17a87b70558;674e8d45ec54f17a87b5b875;674e8f31ec54f17a87b7f3df;674e8f26ec54f17a87b7e545;674e8e3aec54f17a87b6a535;674e9001ec54f17a87b8fbb7;674e90edec54f17a87ba4099",
          },
          {
            value: "reboot",
            count: 98,
            keywordIds:
              "674e9081ec54f17a87b9b9c5;674e904aec54f17a87b955d0;674e8fe2ec54f17a87b8d6b1;674e8f23ec54f17a87b7db42;674e9002ec54f17a87b8fd44;674e8f8eec54f17a87b86b07;674e8eb0ec54f17a87b74619;674e8d06ec54f17a87b5796f;674e907fec54f17a87b9b7a6;674e8eaaec54f17a87b73e8c;674e8f00ec54f17a87b7abd0;674e8dffec54f17a87b66b37;674e8e6bec54f17a87b6ee82;674e8f10ec54f17a87b7c143;674e8fb1ec54f17a87b89958;674e8f2aec54f17a87b7ea81;674e8dabec54f17a87b61a2e;674e8ff1ec54f17a87b8e832;674e8e75ec54f17a87b6fb39;674e8d87ec54f17a87b5f7e3;674e91f8ec54f17a87bb2c7c;674e8fcbec54f17a87b8ba44;674e8ed2ec54f17a87b770a2;674e9031ec54f17a87b93707;674e8f2cec54f17a87b7ed47;674e8ffeec54f17a87b8f894;674e9181ec54f17a87bacad7;674e8f33ec54f17a87b7f621;674e9109ec54f17a87ba5ad6;674e8e1bec54f17a87b68768;674e9164ec54f17a87baac4e;674e8d43ec54f17a87b5b614;674e9078ec54f17a87b9abfb;674e8efbec54f17a87b7a5aa;674e8e7cec54f17a87b70328;674e8dd3ec54f17a87b63e5a;674e91e1ec54f17a87bb1a62;674e8d8aec54f17a87b5fa84;674e8eefec54f17a87b79612;674e8dd8ec54f17a87b642da;674e8d9bec54f17a87b60af7;674e8f48ec54f17a87b8125f;674e8db9ec54f17a87b626ed;674e8d85ec54f17a87b5f692;674e8e86ec54f17a87b710bd;674e90a1ec54f17a87b9e89f;674e902fec54f17a87b933db;674e9095ec54f17a87b9d820;674e8ec7ec54f17a87b7630d;674e9122ec54f17a87ba7091;674e91d0ec54f17a87bb0c17;674e8e89ec54f17a87b7140d;674e8d50ec54f17a87b5c2b3;674e8f27ec54f17a87b7e654;674e9200ec54f17a87bb3250;674e900eec54f17a87b90b8c;674e90aeec54f17a87b9fa8a;674e8f94ec54f17a87b873d3;674e8d9cec54f17a87b60c2f;674e9123ec54f17a87ba7193;674e91eeec54f17a87bb2482;674e8d73ec54f17a87b5e434;674e9193ec54f17a87bad9c5;674e8e5cec54f17a87b6d9b4;674e8f4cec54f17a87b8162d;674e8d38ec54f17a87b5abff;674e916eec54f17a87bab53e;674e8e78ec54f17a87b6fea7;674e8fc3ec54f17a87b8aeaf;674e8f3aec54f17a87b7ff0b;674e8fddec54f17a87b8d072;674e901dec54f17a87b91e88;674e8f7cec54f17a87b85434;674e8f25ec54f17a87b7e41a;674e8effec54f17a87b7aa0f;674e8e3aec54f17a87b6a48a;674e8ebcec54f17a87b75575;674e9000ec54f17a87b8faba;674e90eeec54f17a87ba413c;674e90a4ec54f17a87b9ed99",
          },
          {
            value: "sensor",
            count: 98,
            keywordIds:
              "674e8d1bec54f17a87b58ef7;674e8eecec54f17a87b7923a;674e8e93ec54f17a87b72051;674e8fe3ec54f17a87b8d70e;674e8e83ec54f17a87b70caa;674e8f25ec54f17a87b7e3bd;674e8d28ec54f17a87b59c6a;674e8eacec54f17a87b73fc8;674e8d2dec54f17a87b5a189;674e9094ec54f17a87b9d65f;674e8e77ec54f17a87b6fd52;674e90dbec54f17a87ba2fca;674e8dbcec54f17a87b62964;674e90bfec54f17a87ba1316;674e8fb8ec54f17a87b8a1fc;674e8f86ec54f17a87b8611b;674e9052ec54f17a87b96890;674e8ea0ec54f17a87b73126;674e8f79ec54f17a87b84ea6;674e8fd4ec54f17a87b8c5dd;674e8e3cec54f17a87b6a70f;674e8e8eec54f17a87b71a94;674e8e06ec54f17a87b67253;674e8e7dec54f17a87b704ea;674e8d70ec54f17a87b5e10c;674e8f61ec54f17a87b8309b;674e8d7fec54f17a87b5f102;674e8f2dec54f17a87b7edd3;674e91d8ec54f17a87bb1253;674e8f06ec54f17a87b7b3a0;674e9056ec54f17a87b96fc3;674e8ebfec54f17a87b7596f;674e8da8ec54f17a87b61716;674e8ed2ec54f17a87b77029;674e9109ec54f17a87ba5b1f;674e8fd3ec54f17a87b8c38d;674e8e34ec54f17a87b69ef3;674e904dec54f17a87b959fe;674e914aec54f17a87ba93ec;674e8fc8ec54f17a87b8b6ee;674e8d20ec54f17a87b5943a;674e8efcec54f17a87b7a641;674e911cec54f17a87ba6b73;674e8f82ec54f17a87b85bff;674e907eec54f17a87b9b5bf;674e8e47ec54f17a87b6b139;674e8e65ec54f17a87b6e5f0;674e909cec54f17a87b9e138;674e9076ec54f17a87b9a916;674e8f46ec54f17a87b80e43;674e9125ec54f17a87ba73ae;674e8f51ec54f17a87b81d64;674e912fec54f17a87ba7cdb;674e8f52ec54f17a87b81de6;674e906aec54f17a87b99512;674e8ff5ec54f17a87b8edb8;674e9094ec54f17a87b9d648;674e8e14ec54f17a87b68063;674e8e88ec54f17a87b713d5;674e8eb3ec54f17a87b749de;674e8e59ec54f17a87b6d617;674e8f70ec54f17a87b84360;674e8ff2ec54f17a87b8ea32;674e91d6ec54f17a87bb10c7;674e8ea3ec54f17a87b73485;674e8fabec54f17a87b890ad;674e8f13ec54f17a87b7c48d;674e8f56ec54f17a87b82362;674e8f4cec54f17a87b816e3;674e916aec54f17a87bab139;674e916fec54f17a87bab5dc;674e8edfec54f17a87b780cf;674e90deec54f17a87ba32bf;674e8e08ec54f17a87b674b4;674e8e02ec54f17a87b66e29;674e8e99ec54f17a87b728ce;674e90a4ec54f17a87b9ee36;674e9038ec54f17a87b93ed3;674e8effec54f17a87b7aa96;674e8fc9ec54f17a87b8b728",
          },
          {
            value: "back-end",
            count: 96,
            keywordIds:
              "674e8d6bec54f17a87b5db7a;674e903cec54f17a87b94486;674e8fbaec54f17a87b8a3fe;674e8ddbec54f17a87b645a6;674e9066ec54f17a87b98cf3;674e904fec54f17a87b96284;674e8df1ec54f17a87b6587a;674e8f70ec54f17a87b84415;674e8eb0ec54f17a87b7456c;674e8e6dec54f17a87b6f0b6;674e912aec54f17a87ba7812;674e8fb8ec54f17a87b8a279;674e8f00ec54f17a87b7ac1b;674e8cfcec54f17a87b56f52;674e8f79ec54f17a87b84f26;674e8db4ec54f17a87b621dd;674e8f21ec54f17a87b7d89d;674e90a6ec54f17a87b9efd1;674e90aeec54f17a87b9fb63;674e8ef9ec54f17a87b7a29a;674e90b0ec54f17a87b9fd6a;674e9102ec54f17a87ba55a7;674e8f33ec54f17a87b7f6c5;674e8fe8ec54f17a87b8ddf0;674e8fdfec54f17a87b8d2dd;674e8fd9ec54f17a87b8caee;674e8ecbec54f17a87b767bd;674e8ee3ec54f17a87b78615;674e8e6dec54f17a87b6f16b;674e8f7bec54f17a87b852fb;674e8ffdec54f17a87b8f6d4;674e8e34ec54f17a87b69eab;674e8d30ec54f17a87b5a415;674e8e63ec54f17a87b6e3f7;674e9032ec54f17a87b93873;674e9073ec54f17a87b9a54c;674e8fcdec54f17a87b8bc07;674e8d34ec54f17a87b5a74d;674e8f29ec54f17a87b7e94b;674e8d8bec54f17a87b5fc23;674e8eebec54f17a87b79176;674e8dfeec54f17a87b6699e;674e8d8aec54f17a87b5fab5;674e9076ec54f17a87b9a9a8;674e8d5bec54f17a87b5ccef;674e9157ec54f17a87baa12a;674e9205ec54f17a87bb36d1;674e8e9aec54f17a87b72a07;674e8efdec54f17a87b7a82b;674e8e82ec54f17a87b70c0c;674e8e5fec54f17a87b6ddb8;674e908eec54f17a87b9cd89;674e9004ec54f17a87b8fff6;674e8f57ec54f17a87b8243c;674e8efcec54f17a87b7a73e;674e8f27ec54f17a87b7e67f;674e90adec54f17a87b9f9a3;674e9043ec54f17a87b94ce5;674e903aec54f17a87b94130;674e8ecfec54f17a87b76ccb;674e9191ec54f17a87bad847;674e8d38ec54f17a87b5ab76;674e90d4ec54f17a87ba2873;674e8d13ec54f17a87b5860e;674e8d76ec54f17a87b5e794;674e90beec54f17a87ba1139;674e9054ec54f17a87b96b2c;674e9041ec54f17a87b94aae;674e8e78ec54f17a87b6ff3d;674e8e16ec54f17a87b681c1;674e8ea5ec54f17a87b7379d;674e9190ec54f17a87bad769;674e8f1dec54f17a87b7d242;674e8de1ec54f17a87b64a69;674e9038ec54f17a87b93f85;674e906dec54f17a87b998c0;674e8eadec54f17a87b7414b;674e90d0ec54f17a87ba251c",
          },
          {
            value: "bus",
            count: 95,
            keywordIds:
              "674e8e91ec54f17a87b71dce;674e8ec2ec54f17a87b75c66;674e9065ec54f17a87b98cb1;674e8fe1ec54f17a87b8d568;674e8d2dec54f17a87b5a160;674e9094ec54f17a87b9d639;674e8ef5ec54f17a87b79deb;674e8fd6ec54f17a87b8c88e;674e8db4ec54f17a87b6224b;674e8eaeec54f17a87b742c0;674e8e98ec54f17a87b7274b;674e8fcdec54f17a87b8bc33;674e8e07ec54f17a87b6735e;674e9203ec54f17a87bb34ca;674e8ff5ec54f17a87b8ee26;674e90f9ec54f17a87ba4bc1;674e9060ec54f17a87b98327;674e8ef8ec54f17a87b7a267;674e9027ec54f17a87b92a29;674e8f1eec54f17a87b7d45e;674e90afec54f17a87b9fc9d;674e9129ec54f17a87ba773b;674e910eec54f17a87ba5f84;674e8dfbec54f17a87b666ce;674e8f19ec54f17a87b7ccbb;674e8dc9ec54f17a87b6359d;674e8f4bec54f17a87b8157f;674e8e6aec54f17a87b6ec1c;674e8e1cec54f17a87b688ce;674e8e34ec54f17a87b69f24;674e8e9cec54f17a87b72c0d;674e9149ec54f17a87ba934e;674e900bec54f17a87b907e3;674e8e64ec54f17a87b6e47d;674e9082ec54f17a87b9bbd6;674e8ec4ec54f17a87b75f0f;674e911cec54f17a87ba6c22;674e8e27ec54f17a87b69328;674e9135ec54f17a87ba819a;674e8fe7ec54f17a87b8dc22;674e90a8ec54f17a87b9f303;674e8cf8ec54f17a87b56b88;674e9149ec54f17a87ba92ce;674e8e9bec54f17a87b72b5b;674e8cf6ec54f17a87b569d8;674e908eec54f17a87b9ce8f;674e9111ec54f17a87ba626b;674e8d27ec54f17a87b59aa7;674e8e66ec54f17a87b6e6f6;674e8e5aec54f17a87b6d75b;674e9026ec54f17a87b929aa;674e8f47ec54f17a87b8104f;674e91b8ec54f17a87baf919;674e9006ec54f17a87b902b6;674e8e5aec54f17a87b6d71e;674e8e8aec54f17a87b71603;674e8eb4ec54f17a87b74b53;674e8e3bec54f17a87b6a590;674e907eec54f17a87b9b68a;674e8f5dec54f17a87b82c6e;674e9081ec54f17a87b9ba9d;674e8eefec54f17a87b79600;674e8d76ec54f17a87b5e7ca;674e9054ec54f17a87b96c36;674e8e16ec54f17a87b68231;674e91e9ec54f17a87bb2096;674e8e67ec54f17a87b6e88a;674e8e99ec54f17a87b727d4;674e8fdeec54f17a87b8d14f;674e8fbcec54f17a87b8a619;674e8d2fec54f17a87b5a2a2;674e8f99ec54f17a87b87a81;674e8de0ec54f17a87b64a30;674e8ed7ec54f17a87b77700;674e9115ec54f17a87ba6638;674e8fa0ec54f17a87b883cf;674e8de4ec54f17a87b64d6e;674e909cec54f17a87b9e21d;674e91b5ec54f17a87baf6d2;674e91e4ec54f17a87bb1d3e;674e8e4bec54f17a87b6b4c7",
          },
          {
            value: "index",
            count: 93,
            keywordIds:
              "674e8eebec54f17a87b79100;674e8f0eec54f17a87b7bf12;674e9087ec54f17a87b9c406;674e8eeaec54f17a87b78fd4;674e8f44ec54f17a87b80cf4;674e8f94ec54f17a87b873b1;674e8e96ec54f17a87b72517;674e8f21ec54f17a87b7d88e;674e9069ec54f17a87b991ec;674e91c5ec54f17a87bb0404;674e8f57ec54f17a87b824da;674e90bfec54f17a87ba1260;674e90bbec54f17a87ba0ccf;674e8ea0ec54f17a87b73104;674e9178ec54f17a87babe0a;674e8fd6ec54f17a87b8c804;674e8d21ec54f17a87b594bb;674e91c2ec54f17a87bb00e4;674e9144ec54f17a87ba8f24;674e8e20ec54f17a87b68bfb;674e8e07ec54f17a87b6727f;674e903bec54f17a87b94296;674e8d70ec54f17a87b5e0ac;674e8d2aec54f17a87b59e58;674e8f60ec54f17a87b82f82;674e9064ec54f17a87b989ea;674e8f71ec54f17a87b84501;674e8fa9ec54f17a87b88e5f;674e91d8ec54f17a87bb1237;674e91a8ec54f17a87baeaa9;674e8dfcec54f17a87b667c9;674e8e95ec54f17a87b72326;674e8daeec54f17a87b61cf7;674e8f32ec54f17a87b7f580;674e8dc9ec54f17a87b63566;674e8d07ec54f17a87b57aa1;674e9074ec54f17a87b9a711;674e9053ec54f17a87b96a06;674e8f5aec54f17a87b8289a;674e8ec4ec54f17a87b75e96;674e8e73ec54f17a87b6f890;674e8f12ec54f17a87b7c40d;674e8d8bec54f17a87b5fc02;674e8f73ec54f17a87b84716;674e8dadec54f17a87b61b56;674e9018ec54f17a87b918cf;674e8ec0ec54f17a87b75aae;674e8e8bec54f17a87b7170f;674e9076ec54f17a87b9a95f;674e8f8cec54f17a87b868f4;674e8dbfec54f17a87b62cda;674e8dcdec54f17a87b6388b;674e8fd0ec54f17a87b8bff4;674e8ecfec54f17a87b76c90;674e8d05ec54f17a87b578a1;674e8f14ec54f17a87b7c6d6;674e8fefec54f17a87b8e55c;674e91cfec54f17a87bb0ba6;674e8e89ec54f17a87b714d1;674e8f67ec54f17a87b83827;674e8d3fec54f17a87b5b2a3;674e8fc5ec54f17a87b8b230;674e8d42ec54f17a87b5b57a;674e8f4dec54f17a87b817c4;674e8f97ec54f17a87b87847;674e8f9aec54f17a87b87c5c;674e91f1ec54f17a87bb271c;674e9041ec54f17a87b94a58;674e8e38ec54f17a87b6a2a9;674e8da6ec54f17a87b61526;674e91ebec54f17a87bb2282;674e8f38ec54f17a87b7fcf9;674e915fec54f17a87baa8c6;674e909eec54f17a87b9e44d;674e8f01ec54f17a87b7ade0;674e8dfaec54f17a87b6643f;674e8e24ec54f17a87b68f42;674e8f1fec54f17a87b7d672;674e8d18ec54f17a87b58c82",
          },
          {
            value: "calculate",
            count: 90,
            keywordIds:
              "674e8e0dec54f17a87b6796c;674e8e9eec54f17a87b72f04;674e905aec54f17a87b978ba;674e904aec54f17a87b95629;674e8eccec54f17a87b7688f;674e8ef5ec54f17a87b79e1c;674e9009ec54f17a87b9056c;674e917eec54f17a87bac7fd;674e8e35ec54f17a87b6a065;674e9067ec54f17a87b98e77;674e8d1eec54f17a87b591a5;674e9194ec54f17a87bada86;674e8e85ec54f17a87b70f89;674e8ff5ec54f17a87b8ed3f;674e8ed8ec54f17a87b7783b;674e9163ec54f17a87baab4d;674e9033ec54f17a87b938c7;674e8e03ec54f17a87b66ef3;674e902bec54f17a87b92f8f;674e90b2ec54f17a87ba00c2;674e8f4aec54f17a87b814db;674e8d55ec54f17a87b5c79c;674e8fc0ec54f17a87b8abed;674e8e88ec54f17a87b712d7;674e8f24ec54f17a87b7e207;674e8fc8ec54f17a87b8b65c;674e9030ec54f17a87b934fe;674e8d49ec54f17a87b5bc7c;674e8fe0ec54f17a87b8d426;674e8f2eec54f17a87b7f020;674e8fc9ec54f17a87b8b779;674e8f0cec54f17a87b7bb44;674e905dec54f17a87b97e2d;674e902aec54f17a87b92e92;674e8ed5ec54f17a87b774ab;674e9017ec54f17a87b91659;674e9147ec54f17a87ba917c;674e8f60ec54f17a87b8300d;674e90b1ec54f17a87b9ffbd;674e8d74ec54f17a87b5e5f7;674e8f6fec54f17a87b842a4;674e8f59ec54f17a87b827a4;674e8ee8ec54f17a87b78cc2;674e8e5bec54f17a87b6d8da;674e8e0aec54f17a87b675c8;674e908eec54f17a87b9cd52;674e8d6eec54f17a87b5de97;674e9115ec54f17a87ba6579;674e9020ec54f17a87b921ba;674e8d42ec54f17a87b5b508;674e90f7ec54f17a87ba4a23;674e9016ec54f17a87b9153a;674e91b2ec54f17a87baf330;674e8ff2ec54f17a87b8e957;674e8f34ec54f17a87b7f7e9;674e9169ec54f17a87bab082;674e8fb8ec54f17a87b8a1b3;674e8dddec54f17a87b64746;674e8efeec54f17a87b7a9a1;674e8d78ec54f17a87b5e9e5;674e8ee6ec54f17a87b78a8d;674e8e69ec54f17a87b6eb70;674e8efaec54f17a87b7a3c6;674e903cec54f17a87b943b0;674e8e4eec54f17a87b6b7bf;674e8d2eec54f17a87b5a247;674e8dc6ec54f17a87b632bb;674e8deaec54f17a87b652cb;674e8ecdec54f17a87b769c3;674e8e56ec54f17a87b6c04e;674e905bec54f17a87b978e0;674e8ed6ec54f17a87b77564",
          },
          {
            value: "compress",
            count: 88,
            keywordIds:
              "674e9072ec54f17a87b9a1cf;674e90b5ec54f17a87ba0503;674e8ef0ec54f17a87b797de;674e8f7fec54f17a87b85813;674e90b6ec54f17a87ba0600;674e8df1ec54f17a87b6585a;674e90feec54f17a87ba5163;674e8e5eec54f17a87b6dd53;674e8f92ec54f17a87b8719c;674e9052ec54f17a87b966ed;674e8f6dec54f17a87b83f1b;674e9015ec54f17a87b914d1;674e9031ec54f17a87b93696;674e8e72ec54f17a87b6f781;674e8e75ec54f17a87b6fa3e;674e8ef0ec54f17a87b797b0;674e8ff2ec54f17a87b8ea07;674e8fc6ec54f17a87b8b345;674e911aec54f17a87ba69c2;674e8d9dec54f17a87b60cd0;674e904fec54f17a87b95e24;674e8e6fec54f17a87b6f2c6;674e8d15ec54f17a87b5881b;674e8ff8ec54f17a87b8f0f1;674e90d5ec54f17a87ba2949;674e8f78ec54f17a87b84d51;674e9170ec54f17a87bab69b;674e8e63ec54f17a87b6e3c8;674e8d1dec54f17a87b5905d;674e8dfeec54f17a87b66951;674e8ef9ec54f17a87b7a37d;674e8d8dec54f17a87b5fd98;674e8e8aec54f17a87b7167c;674e8d52ec54f17a87b5c41c;674e9132ec54f17a87ba7f9d;674e9017ec54f17a87b91707;674e9125ec54f17a87ba732c;674e8e95ec54f17a87b72333;674e8f6fec54f17a87b84202;674e90e5ec54f17a87ba38cb;674e8d4aec54f17a87b5bda5;674e8f53ec54f17a87b81f5d;674e9011ec54f17a87b90f3f;674e8e14ec54f17a87b67fdf;674e8ec4ec54f17a87b75ed4;674e8d26ec54f17a87b599b9;674e90a0ec54f17a87b9e6fa;674e90acec54f17a87b9f880;674e91b8ec54f17a87baf8e8;674e8feaec54f17a87b8dfb9;674e8f6aec54f17a87b83b9b;674e8e1aec54f17a87b68601;674e8eb0ec54f17a87b745f7;674e8e81ec54f17a87b70a61;674e907eec54f17a87b9b6be;674e9081ec54f17a87b9ba57;674e8d14ec54f17a87b586c2;674e8ee7ec54f17a87b78bfb;674e8f8cec54f17a87b86908;674e9054ec54f17a87b96aed;674e8f8bec54f17a87b867b5;674e8fe7ec54f17a87b8dba9;674e8fc7ec54f17a87b8b48f;674e8e28ec54f17a87b693df;674e8fa7ec54f17a87b88c4e;674e8ddaec54f17a87b64410;674e90abec54f17a87b9f762;674e8d3bec54f17a87b5aed6;674e8df3ec54f17a87b659f9;674e912bec54f17a87ba78ee;674e9161ec54f17a87baaa2e;674e906eec54f17a87b99beb;674e913cec54f17a87ba8778",
          },
          {
            value: "connect",
            count: 88,
            keywordIds:
              "674e8fe3ec54f17a87b8d779;674e8f0bec54f17a87b7ba4e;674e8ddbec54f17a87b6455c;674e9183ec54f17a87baccf7;674e8fe1ec54f17a87b8d466;674e8e2eec54f17a87b698ef;674e8f86ec54f17a87b860db;674e8f70ec54f17a87b843e4;674e9094ec54f17a87b9d5ec;674e8dc8ec54f17a87b63413;674e9074ec54f17a87b9a5bf;674e8f1cec54f17a87b7d160;674e8eb5ec54f17a87b74cbb;674e8d8eec54f17a87b5fe70;674e8e3fec54f17a87b6a903;674e9044ec54f17a87b94e42;674e91b0ec54f17a87baf1a3;674e8f83ec54f17a87b85d22;674e91c4ec54f17a87bb0301;674e8fc5ec54f17a87b8b276;674e8ee8ec54f17a87b78cf7;674e8dd5ec54f17a87b63fb8;674e8eb4ec54f17a87b74b5f;674e8fffec54f17a87b8f928;674e8f05ec54f17a87b7b27a;674e8eddec54f17a87b77ef2;674e8eb8ec54f17a87b75041;674e9066ec54f17a87b98de3;674e8ed1ec54f17a87b76ee1;674e9152ec54f17a87ba9baf;674e900eec54f17a87b90b61;674e906aec54f17a87b994d3;674e8e7bec54f17a87b701dd;674e9075ec54f17a87b9a8c2;674e8eedec54f17a87b792fe;674e90f3ec54f17a87ba4684;674e8d00ec54f17a87b57336;674e8e0bec54f17a87b6775a;674e9086ec54f17a87b9c179;674e911cec54f17a87ba6b8e;674e8ee1ec54f17a87b78494;674e8dacec54f17a87b61ae6;674e8ee0ec54f17a87b78226;674e914cec54f17a87ba95ae;674e9090ec54f17a87b9d131;674e90ccec54f17a87ba208a;674e8f46ec54f17a87b80e68;674e8facec54f17a87b89304;674e903aec54f17a87b9420b;674e8ebbec54f17a87b753f6;674e8ec2ec54f17a87b75d77;674e906dec54f17a87b999b3;674e8f2dec54f17a87b7eeb5;674e8e82ec54f17a87b70bd2;674e910fec54f17a87ba60a2;674e8e65ec54f17a87b6e5d7;674e8eb2ec54f17a87b7485c;674e90a0ec54f17a87b9e7d5;674e8f00ec54f17a87b7abea;674e8d1aec54f17a87b58dd7;674e8dbdec54f17a87b62ab1;674e8f52ec54f17a87b81f07;674e8f4dec54f17a87b818b0;674e9143ec54f17a87ba8d90;674e8d6cec54f17a87b5dce4;674e9192ec54f17a87bad89c;674e8fd1ec54f17a87b8c18b;674e906dec54f17a87b99893;674e8eb7ec54f17a87b74e4c;674e8eceec54f17a87b76aa7;674e8d5eec54f17a87b5cf3e;674e8e08ec54f17a87b67456;674e9060ec54f17a87b982e5;674e901fec54f17a87b9206a;674e90e9ec54f17a87ba3cc0;674e90b8ec54f17a87ba091b;674e8e56ec54f17a87b6bfba;674e8f09ec54f17a87b7b740;674e8fa1ec54f17a87b884df;674e8e4aec54f17a87b6b3b6",
          },
          {
            value: "parse",
            count: 88,
            keywordIds:
              "674e8d1bec54f17a87b58e9b;674e8f68ec54f17a87b83a11;674e8d4eec54f17a87b5c12f;674e8f6bec54f17a87b83d6e;674e8f49ec54f17a87b812c3;674e8e75ec54f17a87b6fa2e;674e901fec54f17a87b920d4;674e8f0eec54f17a87b7beca;674e8f9dec54f17a87b87fbd;674e8e91ec54f17a87b71e0e;674e8f68ec54f17a87b83a00;674e91c2ec54f17a87bb013d;674e90aeec54f17a87b9fb21;674e9139ec54f17a87ba852e;674e8ef7ec54f17a87b79fbd;674e8f3bec54f17a87b800d7;674e9070ec54f17a87b99e09;674e8f37ec54f17a87b7fb4c;674e90f9ec54f17a87ba4b9b;674e8e85ec54f17a87b7102a;674e8d2bec54f17a87b59eda;674e8fedec54f17a87b8e351;674e8f33ec54f17a87b7f5f8;674e8f9bec54f17a87b87ca1;674e9050ec54f17a87b9643c;674e8f1dec54f17a87b7d33d;674e91a3ec54f17a87bae683;674e91baec54f17a87bafad6;674e8d33ec54f17a87b5a6f4;674e9198ec54f17a87badd84;674e8e27ec54f17a87b69226;674e8ea4ec54f17a87b73622;674e90fbec54f17a87ba4e20;674e8e86ec54f17a87b71112;674e8f73ec54f17a87b847e4;674e8f0bec54f17a87b7ba00;674e8eeeec54f17a87b794b6;674e8f81ec54f17a87b859ba;674e8ec9ec54f17a87b764b4;674e8d5bec54f17a87b5cd53;674e9148ec54f17a87ba9262;674e8f51ec54f17a87b81d15;674e8e9aec54f17a87b72994;674e8f09ec54f17a87b7b876;674e8e79ec54f17a87b6ff48;674e8ff5ec54f17a87b8ed3a;674e9083ec54f17a87b9bdf1;674e8f1aec54f17a87b7cea1;674e9058ec54f17a87b972b1;674e90eeec54f17a87ba41b5;674e90d8ec54f17a87ba2d41;674e8d3aec54f17a87b5adb7;674e8e05ec54f17a87b67114;674e8f3dec54f17a87b8036e;674e8fffec54f17a87b8f959;674e8faeec54f17a87b894b4;674e8eb0ec54f17a87b746a9;674e8e3bec54f17a87b6a56f;674e8d38ec54f17a87b5ab46;674e8f23ec54f17a87b7db25;674e90f0ec54f17a87ba433b;674e8f12ec54f17a87b7c402;674e8e62ec54f17a87b6e276;674e8f2eec54f17a87b7ef00;674e8ee7ec54f17a87b78b74;674e8e1fec54f17a87b68b01;674e8fe7ec54f17a87b8dc46;674e90b4ec54f17a87ba02dc;674e9133ec54f17a87ba8006;674e900aec54f17a87b9067c;674e8d18ec54f17a87b58b78",
          },
          {
            value: "1080p",
            count: 88,
            keywordIds:
              "674e8e13ec54f17a87b67f27;674e9010ec54f17a87b90ecb;674e8f22ec54f17a87b7da88;674e90c3ec54f17a87ba1745;674e8fdaec54f17a87b8cc1f;674e8ea8ec54f17a87b73be1;674e907fec54f17a87b9b7f6;674e8eaeec54f17a87b74306;674e907fec54f17a87b9b783;674e9139ec54f17a87ba84a2;674e919eec54f17a87bae1fc;674e8fecec54f17a87b8e27d;674e8e85ec54f17a87b70fc0;674e91afec54f17a87baf069;674e8ff2ec54f17a87b8ea44;674e8d87ec54f17a87b5f8ac;674e908fec54f17a87b9cf29;674e8fa9ec54f17a87b88ea4;674e9182ec54f17a87bacb21;674e8dc3ec54f17a87b63050;674e8ee3ec54f17a87b7870e;674e8f9fec54f17a87b882c7;674e8e94ec54f17a87b721b0;674e8f84ec54f17a87b85eda;674e9165ec54f17a87baad11;674e8eedec54f17a87b793b7;674e914aec54f17a87ba93bc;674e8f77ec54f17a87b84c46;674e8ec4ec54f17a87b75ec3;674e91d9ec54f17a87bb134b;674e8ea4ec54f17a87b73648;674e8ef4ec54f17a87b79c53;674e905cec54f17a87b97bc6;674e8e82ec54f17a87b70bb1;674e8e92ec54f17a87b71fa9;674e8d5bec54f17a87b5cd73;674e8f55ec54f17a87b822e0;674e8e54ec54f17a87b6bd4e;674e8ec3ec54f17a87b75daf;674e8f7bec54f17a87b852e7;674e8ee8ec54f17a87b78cea;674e8d81ec54f17a87b5f2ab;674e8ef7ec54f17a87b7a049;674e8e94ec54f17a87b721bf;674e9093ec54f17a87b9d563;674e905eec54f17a87b97f80;674e8f85ec54f17a87b85f91;674e90d8ec54f17a87ba2ceb;674e9033ec54f17a87b93993;674e8eb2ec54f17a87b748cf;674e8f7dec54f17a87b855bf;674e8e8eec54f17a87b71b0a;674e8f17ec54f17a87b7c9e0;674e8e1aec54f17a87b6862c;674e8f19ec54f17a87b7cde4;674e8f20ec54f17a87b7d77a;674e907fec54f17a87b9b6fc;674e9028ec54f17a87b92b46;674e90b3ec54f17a87ba01ec;674e9185ec54f17a87bace77;674e8f54ec54f17a87b8210f;674e9024ec54f17a87b9265f;674e8f82ec54f17a87b85b92;674e8e69ec54f17a87b6eba9;674e8f8aec54f17a87b8664e;674e8f02ec54f17a87b7ae18;674e8e4eec54f17a87b6b808;674e8ff0ec54f17a87b8e726;674e90abec54f17a87b9f799;674e8e70ec54f17a87b6f51f;674e8eafec54f17a87b7448d;674e91b5ec54f17a87baf681;674e8fc9ec54f17a87b8b7ff",
          },
          {
            value: "hack",
            count: 87,
            keywordIds:
              "674e8fe2ec54f17a87b8d6bd;674e903cec54f17a87b94459;674e8ec1ec54f17a87b75c39;674e9100ec54f17a87ba5322;674e8eeaec54f17a87b78f6a;674e8f7fec54f17a87b85719;674e907bec54f17a87b9b245;674e8ff4ec54f17a87b8ec68;674e8e6dec54f17a87b6f079;674e90dbec54f17a87ba2f3f;674e8ef5ec54f17a87b79d5e;674e906bec54f17a87b9966a;674e8db4ec54f17a87b621ba;674e8f05ec54f17a87b7b242;674e91c9ec54f17a87bb06c5;674e8f3aec54f17a87b80025;674e9159ec54f17a87baa3a1;674e907aec54f17a87b9aff7;674e918bec54f17a87bad341;674e8d7fec54f17a87b5f0ba;674e8ed1ec54f17a87b76fba;674e8db7ec54f17a87b6252e;674e9055ec54f17a87b96ce7;674e8cf9ec54f17a87b56c35;674e8f0aec54f17a87b7b8fd;674e908bec54f17a87b9c8a6;674e8e34ec54f17a87b69e5a;674e8fb2ec54f17a87b899da;674e900aec54f17a87b9074e;674e8ea1ec54f17a87b7321e;674e8f9dec54f17a87b87fb2;674e900cec54f17a87b9096d;674e9188ec54f17a87bad05e;674e8e71ec54f17a87b6f59e;674e8ef4ec54f17a87b79c3a;674e8eebec54f17a87b7913e;674e8d82ec54f17a87b5f3ed;674e8cf7ec54f17a87b56a90;674e8f49ec54f17a87b812f5;674e9007ec54f17a87b9032f;674e8dbfec54f17a87b62c9b;674e9007ec54f17a87b903cd;674e917cec54f17a87bac690;674e8dafec54f17a87b61db5;674e904dec54f17a87b95b25;674e8faeec54f17a87b894a8;674e8ff5ec54f17a87b8eddd;674e8f48ec54f17a87b811ec;674e8e05ec54f17a87b67094;674e8d47ec54f17a87b5bac6;674e9167ec54f17a87baae81;674e8f20ec54f17a87b7d738;674e9155ec54f17a87ba9ecd;674e8d73ec54f17a87b5e4c1;674e8fbaec54f17a87b8a3d5;674e8f99ec54f17a87b87b25;674e8e4fec54f17a87b6b950;674e90beec54f17a87ba10eb;674e8db5ec54f17a87b62350;674e8e63ec54f17a87b6e42e;674e8ec5ec54f17a87b760e0;674e8fc7ec54f17a87b8b457;674e9059ec54f17a87b97614;674e8ee3ec54f17a87b785ed;674e8fa6ec54f17a87b88b50;674e90a9ec54f17a87b9f523;674e9051ec54f17a87b9653e;674e8ed9ec54f17a87b779a8;674e8e48ec54f17a87b6b1e7;674e8eb1ec54f17a87b74800;674e91b5ec54f17a87baf65e;674e9000ec54f17a87b8fb58",
          },
          {
            value: "bypass",
            count: 85,
            keywordIds:
              "674e9199ec54f17a87badea7;674e8e83ec54f17a87b70c7a;674e8e37ec54f17a87b6a1f9;674e8f0dec54f17a87b7bd4b;674e904cec54f17a87b9593d;674e8d2cec54f17a87b5a0b4;674e8ecdec54f17a87b76961;674e9129ec54f17a87ba77f0;674e8d47ec54f17a87b5ba10;674e8fbbec54f17a87b8a5a6;674e8f58ec54f17a87b825d6;674e8cfcec54f17a87b56ebc;674e8f3cec54f17a87b8017d;674e8ec8ec54f17a87b763fe;674e9012ec54f17a87b9119b;674e8eacec54f17a87b73f83;674e9042ec54f17a87b94c13;674e8d5fec54f17a87b5d0bb;674e8e98ec54f17a87b7268e;674e8f8fec54f17a87b86d12;674e8d23ec54f17a87b59749;674e9001ec54f17a87b8fcc3;674e9072ec54f17a87b9a31a;674e90e1ec54f17a87ba3546;674e8d90ec54f17a87b60019;674e9089ec54f17a87b9c649;674e8fb3ec54f17a87b89add;674e8fffec54f17a87b8fa29;674e902bec54f17a87b92f15;674e8f9fec54f17a87b882ab;674e8f3aec54f17a87b8001a;674e8ffdec54f17a87b8f7c6;674e8f64ec54f17a87b83469;674e9057ec54f17a87b971a6;674e8ec5ec54f17a87b760db;674e8e82ec54f17a87b70b43;674e9075ec54f17a87b9a895;674e8fcfec54f17a87b8bfb5;674e8f09ec54f17a87b7b79a;674e8ea7ec54f17a87b7395a;674e8fefec54f17a87b8e607;674e8e68ec54f17a87b6e962;674e8ef7ec54f17a87b7a011;674e8da0ec54f17a87b6103d;674e909dec54f17a87b9e2b8;674e9158ec54f17a87baa315;674e8f71ec54f17a87b84527;674e8f62ec54f17a87b831b2;674e8f3eec54f17a87b80432;674e8e8aec54f17a87b71644;674e90f8ec54f17a87ba4ad8;674e8ecfec54f17a87b76c7b;674e8f19ec54f17a87b7cd0c;674e8fb0ec54f17a87b89746;674e8f3dec54f17a87b80385;674e8d25ec54f17a87b59945;674e8dccec54f17a87b63780;674e8fb7ec54f17a87b8a0ff;674e8edeec54f17a87b78058;674e8fc4ec54f17a87b8b008;674e8f50ec54f17a87b81bf2;674e8f37ec54f17a87b7fc67;674e9190ec54f17a87bad738;674e8f40ec54f17a87b8074f;674e8ea4ec54f17a87b73557;674e8e60ec54f17a87b6dfc8;674e8f7dec54f17a87b85508;674e8f73ec54f17a87b8477b;674e8fa0ec54f17a87b88362",
          },
          {
            value: "open-source",
            count: 84,
            keywordIds:
              "674e9039ec54f17a87b9410b;674e8e90ec54f17a87b71d95;674e8e92ec54f17a87b71fe9;674e8e83ec54f17a87b70d22;674e8fa4ec54f17a87b8885e;674e8feaec54f17a87b8df22;674e8e33ec54f17a87b69dbd;674e9031ec54f17a87b9364e;674e8f6fec54f17a87b84221;674e8eaaec54f17a87b73ea8;674e8d59ec54f17a87b5cbad;674e8e5eec54f17a87b6dc75;674e8d1eec54f17a87b59283;674e9044ec54f17a87b94e34;674e91b0ec54f17a87baf208;674e8ee9ec54f17a87b78def;674e8d7eec54f17a87b5f043;674e8fedec54f17a87b8e43b;674e8f5cec54f17a87b82af1;674e90a8ec54f17a87b9f40d;674e91c7ec54f17a87bb0555;674e8fd2ec54f17a87b8c285;674e8e9bec54f17a87b72bdd;674e8f08ec54f17a87b7b5ad;674e8d44ec54f17a87b5b6ba;674e8e0bec54f17a87b6779b;674e9069ec54f17a87b99215;674e8f82ec54f17a87b85b86;674e8e10ec54f17a87b67ba3;674e8f0cec54f17a87b7bc93;674e8fb6ec54f17a87b89ff8;674e8d9aec54f17a87b60992;674e91e3ec54f17a87bb1c4a;674e904eec54f17a87b95bd9;674e9176ec54f17a87babb98;674e8ed5ec54f17a87b7743b;674e8facec54f17a87b8933a;674e9007ec54f17a87b90413;674e8f30ec54f17a87b7f2af;674e8e95ec54f17a87b7236d;674e8d75ec54f17a87b5e61a;674e8f16ec54f17a87b7c91d;674e8ec4ec54f17a87b75f1b;674e8f43ec54f17a87b80b09;674e8e5dec54f17a87b6dbee;674e8d1aec54f17a87b58e02;674e91b8ec54f17a87baf900;674e9035ec54f17a87b93b35;674e8fe9ec54f17a87b8deff;674e8ff9ec54f17a87b8f262;674e8eceec54f17a87b76b5f;674e9006ec54f17a87b901bb;674e8f42ec54f17a87b80976;674e8ff2ec54f17a87b8ea6a;674e91efec54f17a87bb2536;674e8d0dec54f17a87b5803e;674e8e4fec54f17a87b6b96e;674e8faeec54f17a87b895c2;674e8e77ec54f17a87b6fd34;674e8fe7ec54f17a87b8dbe4;674e8ee5ec54f17a87b78a01;674e8f34ec54f17a87b7f709;674e8e67ec54f17a87b6e802;674e903cec54f17a87b943df;674e8e28ec54f17a87b69406;674e8f28ec54f17a87b7e799;674e8fa7ec54f17a87b88c94;674e90aaec54f17a87b9f560;674e8d57ec54f17a87b5c938;674e8f36ec54f17a87b7f9be;674e8e58ec54f17a87b6c77f;674e901aec54f17a87b91b64;674e8fc8ec54f17a87b8b634",
          },
          {
            value: "back",
            count: 84,
            keywordIds:
              "674e8f49ec54f17a87b81382;674e90c2ec54f17a87ba1685;674e8f63ec54f17a87b83335;674e8fdcec54f17a87b8cf3b;674e9030ec54f17a87b93584;674e8d0bec54f17a87b57e35;674e8eadec54f17a87b7421f;674e90a6ec54f17a87b9efa2;674e9195ec54f17a87badb0e;674e8eb5ec54f17a87b74c57;674e8fe0ec54f17a87b8d319;674e8e7cec54f17a87b703d4;674e9097ec54f17a87b9d9da;674e9003ec54f17a87b8fedb;674e918aec54f17a87bad1f1;674e8fe4ec54f17a87b8d898;674e8f96ec54f17a87b875f1;674e8daaec54f17a87b61860;674e9096ec54f17a87b9d843;674e91edec54f17a87bb23ed;674e8f90ec54f17a87b86e82;674e8e69ec54f17a87b6ebb4;674e908cec54f17a87b9cab1;674e90f4ec54f17a87ba46eb;674e9019ec54f17a87b9197c;674e8e18ec54f17a87b6848c;674e9032ec54f17a87b9381f;674e8d71ec54f17a87b5e214;674e9136ec54f17a87ba82b5;674e9135ec54f17a87ba81d0;674e8df8ec54f17a87b6623c;674e918fec54f17a87bad627;674e8fb6ec54f17a87b89f04;674e8e92ec54f17a87b71f01;674e90ecec54f17a87ba3fbb;674e9070ec54f17a87b99e9b;674e8d05ec54f17a87b5780e;674e8ea6ec54f17a87b73892;674e8d03ec54f17a87b575bd;674e910aec54f17a87ba5c1f;674e8d4dec54f17a87b5bfe7;674e9158ec54f17a87baa29f;674e9112ec54f17a87ba6322;674e9092ec54f17a87b9d314;674e9141ec54f17a87ba8bf4;674e8ea9ec54f17a87b73cba;674e8e59ec54f17a87b6d67c;674e8fe4ec54f17a87b8d8b9;674e8ebfec54f17a87b7580a;674e8e96ec54f17a87b7254d;674e8e9eec54f17a87b72ef2;674e90b1ec54f17a87b9feed;674e8e6bec54f17a87b6ed1a;674e8f15ec54f17a87b7c7d2;674e8e3eec54f17a87b6a827;674e90f0ec54f17a87ba4399;674e908bec54f17a87b9c9e9;674e8d76ec54f17a87b5e771;674e8dcbec54f17a87b636f3;674e8f99ec54f17a87b87a14;674e902cec54f17a87b930b8;674e8f93ec54f17a87b872b2;674e8ea5ec54f17a87b73769;674e911aec54f17a87ba6a56;674e8e29ec54f17a87b69448;674e8f28ec54f17a87b7e764;674e9106ec54f17a87ba586b;674e90d0ec54f17a87ba2476;674e908dec54f17a87b9cbcd",
          },
          {
            value: "input",
            count: 83,
            keywordIds:
              "674e9088ec54f17a87b9c4dc;674e8ef1ec54f17a87b7986b;674e8f97ec54f17a87b87817;674e8fa5ec54f17a87b8890b;674e8f20ec54f17a87b7d7f4;674e912aec54f17a87ba7857;674e8e32ec54f17a87b69d64;674e8e4dec54f17a87b6b6d1;674e8fb0ec54f17a87b89841;674e8d3eec54f17a87b5b150;674e8fa5ec54f17a87b88916;674e91f6ec54f17a87bb2a70;674e8d61ec54f17a87b5d1e9;674e8d36ec54f17a87b5a9b0;674e8e5eec54f17a87b6dc16;674e8f3fec54f17a87b80583;674e8e3cec54f17a87b6a6a3;674e8fd5ec54f17a87b8c635;674e8fdfec54f17a87b8d27f;674e8ef3ec54f17a87b79aa1;674e8f04ec54f17a87b7b100;674e8fcbec54f17a87b8ba1b;674e90a6ec54f17a87b9f0e8;674e8db1ec54f17a87b61fc3;674e90e2ec54f17a87ba364b;674e8e69ec54f17a87b6eb09;674e90a3ec54f17a87b9eb4a;674e8de5ec54f17a87b64e6c;674e8de9ec54f17a87b65168;674e8d66ec54f17a87b5d6aa;674e8e17ec54f17a87b682c0;674e8ee2ec54f17a87b7851f;674e8efbec54f17a87b7a572;674e8e42ec54f17a87b6ac3d;674e8e87ec54f17a87b7122c;674e8f46ec54f17a87b80f3e;674e8f30ec54f17a87b7f281;674e8d95ec54f17a87b60457;674e90b0ec54f17a87b9fd5f;674e8ed0ec54f17a87b76d47;674e8f7cec54f17a87b85394;674e915cec54f17a87baa63c;674e8f4eec54f17a87b81905;674e8e83ec54f17a87b70cb5;674e90d8ec54f17a87ba2c90;674e8e5dec54f17a87b6db54;674e8f2fec54f17a87b7f071;674e8f71ec54f17a87b8443c;674e8ff9ec54f17a87b8f217;674e9039ec54f17a87b94100;674e8ed3ec54f17a87b77143;674e8f42ec54f17a87b808c3;674e9049ec54f17a87b954cb;674e8f10ec54f17a87b7c07c;674e90f1ec54f17a87ba44b5;674e8d98ec54f17a87b6077b;674e8e15ec54f17a87b68110;674e8defec54f17a87b65697;674e8f1cec54f17a87b7d1fb;674e8f41ec54f17a87b807f8;674e8dd9ec54f17a87b64387;674e90d1ec54f17a87ba25c0;674e8f66ec54f17a87b837af;674e8eacec54f17a87b740f9;674e8df3ec54f17a87b65a7b;674e8f1fec54f17a87b7d5aa;674e90d9ec54f17a87ba2dcd;674e8fefec54f17a87b8e5ff;674e8fdeec54f17a87b8d0dd",
          },
          {
            value: "multi-byte",
            count: 82,
            keywordIds:
              "674e9071ec54f17a87b9a0f7;674e919aec54f17a87badf38;674e8eeaec54f17a87b78f90;674e8f4aec54f17a87b814d0;674e905bec54f17a87b978fe;674e8f23ec54f17a87b7df8c;674e90f5ec54f17a87ba4820;674e9002ec54f17a87b8fd87;674e90dfec54f17a87ba33e3;674e8f8fec54f17a87b86c1e;674e90feec54f17a87ba5195;674e8e77ec54f17a87b6fdea;674e8e00ec54f17a87b66bc6;674e8f68ec54f17a87b83a39;674e8e7aec54f17a87b7012c;674e8e67ec54f17a87b6e8d5;674e9177ec54f17a87babcb9;674e8fc6ec54f17a87b8b2a9;674e8f95ec54f17a87b87534;674e9090ec54f17a87b9d006;674e8fa8ec54f17a87b88dbf;674e90e1ec54f17a87ba356a;674e8fcaec54f17a87b8b989;674e91a3ec54f17a87bae6b3;674e8db2ec54f17a87b61fe0;674e8f9eec54f17a87b881f1;674e8d55ec54f17a87b5c7e6;674e8ff8ec54f17a87b8f129;674e9075ec54f17a87b9a742;674e9086ec54f17a87b9c1b4;674e8fa6ec54f17a87b88af8;674e8f6bec54f17a87b83d1b;674e8eefec54f17a87b7963a;674e902aec54f17a87b92de4;674e8f8cec54f17a87b8687e;674e8ec1ec54f17a87b75b02;674e8f6eec54f17a87b84055;674e8dd2ec54f17a87b63d31;674e90e5ec54f17a87ba38eb;674e8e5bec54f17a87b6d91e;674e903eec54f17a87b94675;674e8fe6ec54f17a87b8da61;674e9093ec54f17a87b9d47a;674e8e7eec54f17a87b70698;674e8d4eec54f17a87b5c093;674e9101ec54f17a87ba5433;674e8ea9ec54f17a87b73d25;674e8dbeec54f17a87b62b70;674e8f03ec54f17a87b7b01a;674e8eb4ec54f17a87b74ac5;674e9086ec54f17a87b9c1df;674e8f1aec54f17a87b7ceb1;674e8e80ec54f17a87b70884;674e916bec54f17a87bab2bc;674e8d75ec54f17a87b5e6d8;674e8e9aec54f17a87b729c8;674e8f99ec54f17a87b87a54;674e8efeec54f17a87b7a9db;674e8fc4ec54f17a87b8b0fb;674e8e0eec54f17a87b67a65;674e8e80ec54f17a87b70838;674e8f36ec54f17a87b7fa17;674e8eb7ec54f17a87b74e75;674e8f98ec54f17a87b879ac;674e8ecdec54f17a87b76a52;674e8f66ec54f17a87b837e4;674e8fa1ec54f17a87b88510;674e9078ec54f17a87b9ad04;674e9138ec54f17a87ba8421;674e8d89ec54f17a87b5f9d4",
          },
          {
            value: "transmit",
            count: 82,
            keywordIds:
              "674e8d96ec54f17a87b60620;674e8e90ec54f17a87b71d72;674e8ff6ec54f17a87b8eefa;674e8fb5ec54f17a87b89e1e;674e8f45ec54f17a87b80d8a;674e8e9eec54f17a87b72e2b;674e904fec54f17a87b96157;674e8ff8ec54f17a87b8f0da;674e90dfec54f17a87ba3335;674e8fc2ec54f17a87b8ad82;674e9171ec54f17a87bab757;674e9052ec54f17a87b967d3;674e8e2bec54f17a87b6963a;674e8f11ec54f17a87b7c1e5;674e9121ec54f17a87ba6fff;674e8ef6ec54f17a87b79f31;674e91b0ec54f17a87baf1ee;674e909aec54f17a87b9dec9;674e8e76ec54f17a87b6fb9c;674e9038ec54f17a87b93e9b;674e8fc3ec54f17a87b8aef7;674e8e4bec54f17a87b6b51b;674e8fdcec54f17a87b8cf15;674e9097ec54f17a87b9da4f;674e8d69ec54f17a87b5d9e1;674e8dc3ec54f17a87b63004;674e9180ec54f17a87bac999;674e8dcaec54f17a87b635c1;674e8e6eec54f17a87b6f215;674e8e88ec54f17a87b71377;674e91a4ec54f17a87bae74a;674e8d1fec54f17a87b5931f;674e9073ec54f17a87b9a3d9;674e8d7aec54f17a87b5eb5c;674e8f29ec54f17a87b7e886;674e90faec54f17a87ba4d13;674e8e10ec54f17a87b67b76;674e9029ec54f17a87b92caf;674e9135ec54f17a87ba8155;674e8e65ec54f17a87b6e62b;674e9048ec54f17a87b95365;674e9176ec54f17a87babb69;674e8ed5ec54f17a87b773b9;674e8fd0ec54f17a87b8c047;674e9007ec54f17a87b903e2;674e8fa9ec54f17a87b88e6a;674e8f7bec54f17a87b8529b;674e8da2ec54f17a87b61193;674e8ee4ec54f17a87b787e4;674e8f14ec54f17a87b7c617;674e9093ec54f17a87b9d510;674e913aec54f17a87ba85c2;674e907dec54f17a87b9b3d6;674e914bec54f17a87ba945b;674e8d91ec54f17a87b600e8;674e8e5aec54f17a87b6d74e;674e8fa0ec54f17a87b88448;674e9143ec54f17a87ba8e0e;674e91d5ec54f17a87bb0fd8;674e8f1aec54f17a87b7cf28;674e8da0ec54f17a87b60f5b;674e8e54ec54f17a87b6be5f;674e90dcec54f17a87ba3098;674e8deeec54f17a87b65594;674e8d5eec54f17a87b5cfe5;674e8e0eec54f17a87b67a41;674e8f24ec54f17a87b7e1fc;674e8f36ec54f17a87b7f9d0;674e8e44ec54f17a87b6ae96;674e90b4ec54f17a87ba0381;674e8f08ec54f17a87b7b66f;674e8dcfec54f17a87b63a7e;674e90daec54f17a87ba2e5c;674e90bcec54f17a87ba0f38",
          },
          {
            value: "online",
            count: 82,
            keywordIds:
              "674e8f45ec54f17a87b80da8;674e91b3ec54f17a87baf4bc;674e8f9eec54f17a87b881f7;674e8e2eec54f17a87b69916;674e913dec54f17a87ba88f1;674e9029ec54f17a87b92d3d;674e8d47ec54f17a87b5ba40;674e8fc2ec54f17a87b8ae19;674e8ef5ec54f17a87b79da5;674e8fddec54f17a87b8d02e;674e9064ec54f17a87b98a2a;674e91eaec54f17a87bb2145;674e8f80ec54f17a87b858f8;674e8fc0ec54f17a87b8ab2c;674e906bec54f17a87b996b7;674e8d0eec54f17a87b58193;674e9145ec54f17a87ba8f5c;674e8fcdec54f17a87b8bc81;674e8f30ec54f17a87b7f22a;674e90c0ec54f17a87ba1426;674e8ef2ec54f17a87b799ce;674e916dec54f17a87bab461;674e8d11ec54f17a87b583d4;674e914eec54f17a87ba984b;674e9073ec54f17a87b9a387;674e8f96ec54f17a87b8761b;674e90eaec54f17a87ba3dfd;674e8d90ec54f17a87b6005c;674e91a8ec54f17a87baeb50;674e8e25ec54f17a87b69012;674e91eeec54f17a87bb241b;674e8f83ec54f17a87b85d9e;674e8f88ec54f17a87b86315;674e8d0aec54f17a87b57d40;674e9053ec54f17a87b96a5f;674e8fc8ec54f17a87b8b6a8;674e8f3bec54f17a87b80049;674e8da3ec54f17a87b612f4;674e8f2fec54f17a87b7f11b;674e90ceec54f17a87ba2357;674e8df7ec54f17a87b66176;674e8ee0ec54f17a87b782ed;674e8d8dec54f17a87b5fd2d;674e91ddec54f17a87bb1727;674e8e42ec54f17a87b6ac5e;674e8e87ec54f17a87b71263;674e8cf8ec54f17a87b56b32;674e8d9bec54f17a87b60b3f;674e8f49ec54f17a87b81356;674e8f51ec54f17a87b81ddb;674e904eec54f17a87b95b4e;674e8f7aec54f17a87b85107;674e8ec7ec54f17a87b76266;674e9005ec54f17a87b900f3;674e8d03ec54f17a87b5767d;674e909dec54f17a87b9e2ef;674e8d6eec54f17a87b5dede;674e907dec54f17a87b9b414;674e8e05ec54f17a87b67138;674e8feaec54f17a87b8dfeb;674e905cec54f17a87b97bc1;674e9017ec54f17a87b9160c;674e9052ec54f17a87b96793;674e8f96ec54f17a87b876c4;674e8e3bec54f17a87b6a5f7;674e8dddec54f17a87b646e7;674e902eec54f17a87b9329b;674e8decec54f17a87b6544c;674e905fec54f17a87b9823a;674e8ddcec54f17a87b64613;674e8d2eec54f17a87b5a266;674e90e9ec54f17a87ba3d38;674e8fbeec54f17a87b8a833;674e8deaec54f17a87b652e5;674e91dbec54f17a87bb154a;674e8f1fec54f17a87b7d5e2;674e8d2fec54f17a87b5a38a",
          },
          {
            value: "solid",
            count: 80,
            keywordIds:
              "674e9061ec54f17a87b984b4;674e8d4fec54f17a87b5c22e;674e8ec9ec54f17a87b7648f;674e9099ec54f17a87b9dd3d;674e8fb5ec54f17a87b89d7c;674e90c6ec54f17a87ba1b29;674e8e97ec54f17a87b7259f;674e8d2dec54f17a87b5a0d0;674e8d12ec54f17a87b584e6;674e8f0dec54f17a87b7bdd7;674e8fb8ec54f17a87b8a135;674e8f3cec54f17a87b801a7;674e8f2bec54f17a87b7eb4d;674e91b9ec54f17a87baf9a6;674e9084ec54f17a87b9be9d;674e8e41ec54f17a87b6aaf4;674e90adec54f17a87b9f9b0;674e91beec54f17a87bafde5;674e8e76ec54f17a87b6fbd8;674e8ff1ec54f17a87b8e84d;674e91f9ec54f17a87bb2d0a;674e8f72ec54f17a87b845f4;674e904fec54f17a87b962d3;674e9098ec54f17a87b9db3d;674e8dfcec54f17a87b6672a;674e8fb3ec54f17a87b89b1c;674e8eb8ec54f17a87b75077;674e8daeec54f17a87b61d14;674e8d93ec54f17a87b602a8;674e91c0ec54f17a87bafffe;674e8e1cec54f17a87b687e7;674e8f77ec54f17a87b84cb3;674e9082ec54f17a87b9bc88;674e9077ec54f17a87b9ab0f;674e8efbec54f17a87b7a5d5;674e8f3aec54f17a87b7ff39;674e8d1dec54f17a87b590a2;674e8f91ec54f17a87b87043;674e90b9ec54f17a87ba0abb;674e8df8ec54f17a87b6627e;674e9035ec54f17a87b93c18;674e9125ec54f17a87ba73e3;674e8dc1ec54f17a87b62e70;674e906dec54f17a87b99a19;674e8f2dec54f17a87b7edde;674e8f52ec54f17a87b81e6b;674e8ee4ec54f17a87b78829;674e8f8fec54f17a87b86d1d;674e90a0ec54f17a87b9e824;674e8f46ec54f17a87b80ef2;674e9141ec54f17a87ba8ca9;674e8fc5ec54f17a87b8b269;674e8e5aec54f17a87b6d788;674e8e8aec54f17a87b7166e;674e9167ec54f17a87baae9f;674e90b9ec54f17a87ba0a45;674e9049ec54f17a87b95504;674e91dfec54f17a87bb18cc;674e9021ec54f17a87b9233b;674e906dec54f17a87b999a6;674e8f2eec54f17a87b7ef3e;674e8f9bec54f17a87b87d22;674e9169ec54f17a87bab0b0;674e8dddec54f17a87b64762;674e8d5eec54f17a87b5d027;674e8f4fec54f17a87b81ade;674e91ceec54f17a87bb0acd;674e91dbec54f17a87bb1492;674e8de4ec54f17a87b64d21;674e9106ec54f17a87ba5887",
          },
          {
            value: "state",
            count: 80,
            keywordIds:
              "674e9061ec54f17a87b984f7;674e8d4fec54f17a87b5c254;674e8ec9ec54f17a87b764b9;674e9099ec54f17a87b9dd70;674e8fb5ec54f17a87b89dbd;674e90c7ec54f17a87ba1b47;674e8e97ec54f17a87b725dd;674e8d2dec54f17a87b5a0f2;674e8d12ec54f17a87b58506;674e8f0eec54f17a87b7be14;674e8fb8ec54f17a87b8a17a;674e8f3cec54f17a87b801e9;674e8f2bec54f17a87b7eb86;674e91b9ec54f17a87baf9c3;674e9084ec54f17a87b9bedb;674e8e41ec54f17a87b6ab31;674e90adec54f17a87b9f9e8;674e91beec54f17a87bafe2a;674e8e76ec54f17a87b6fc29;674e8ff1ec54f17a87b8e881;674e91f9ec54f17a87bb2d27;674e8f72ec54f17a87b84624;674e904fec54f17a87b962ff;674e9098ec54f17a87b9db67;674e8dfcec54f17a87b66763;674e8fb3ec54f17a87b89b63;674e8eb9ec54f17a87b750b5;674e8daeec54f17a87b61d5a;674e8d93ec54f17a87b602d4;674e91c1ec54f17a87bb0023;674e8e1cec54f17a87b68873;674e8f77ec54f17a87b84cd5;674e9083ec54f17a87b9bcbf;674e9077ec54f17a87b9ab60;674e8efbec54f17a87b7a610;674e8f3aec54f17a87b7ff6a;674e8d1dec54f17a87b590f4;674e8f92ec54f17a87b8708f;674e90b9ec54f17a87ba0b0b;674e8df8ec54f17a87b662a7;674e9036ec54f17a87b93c32;674e9126ec54f17a87ba7406;674e8dc2ec54f17a87b62eaa;674e906eec54f17a87b99a6d;674e8f2dec54f17a87b7ee0d;674e8f52ec54f17a87b81ece;674e8ee4ec54f17a87b78876;674e8f8fec54f17a87b86d4f;674e90a1ec54f17a87b9e854;674e8f46ec54f17a87b80f2d;674e9142ec54f17a87ba8cc9;674e8fc6ec54f17a87b8b29d;674e8e5aec54f17a87b6d7a7;674e8e8bec54f17a87b716a5;674e9167ec54f17a87baaecb;674e90b9ec54f17a87ba0a67;674e9049ec54f17a87b95523;674e91dfec54f17a87bb18fa;674e9021ec54f17a87b92376;674e906dec54f17a87b99a0c;674e8f2eec54f17a87b7ef8c;674e8f9bec54f17a87b87d6e;674e9169ec54f17a87bab0dd;674e8ddeec54f17a87b64786;674e8d5eec54f17a87b5d048;674e8f4fec54f17a87b81b05;674e91ceec54f17a87bb0ae5;674e91dbec54f17a87bb14c8;674e8de4ec54f17a87b64d4e;674e9106ec54f17a87ba58a3",
          },
          {
            value: "copy",
            count: 79,
            keywordIds:
              "674e9080ec54f17a87b9b92f;674e903cec54f17a87b94503;674e91bcec54f17a87bafc96;674e8fbeec54f17a87b8a8f5;674e8edbec54f17a87b77c2f;674e8feaec54f17a87b8dfde;674e8f40ec54f17a87b80728;674e9030ec54f17a87b9361b;674e8f86ec54f17a87b86074;674e8f2bec54f17a87b7eb25;674e8d8fec54f17a87b5ff09;674e8d29ec54f17a87b59cd3;674e8fcdec54f17a87b8bbd0;674e8e8dec54f17a87b719d2;674e8e40ec54f17a87b6aa4a;674e914dec54f17a87ba96b2;674e8e85ec54f17a87b70f56;674e8e7aec54f17a87b70198;674e8f5eec54f17a87b82ce3;674e8f05ec54f17a87b7b19a;674e8fbfec54f17a87b8aa1c;674e8f06ec54f17a87b7b34b;674e8fd8ec54f17a87b8cac1;674e8dc5ec54f17a87b631b5;674e909eec54f17a87b9e4ec;674e8d55ec54f17a87b5c820;674e8f87ec54f17a87b86272;674e8f77ec54f17a87b84c84;674e915aec54f17a87baa4f7;674e8cfeec54f17a87b570c4;674e9104ec54f17a87ba5710;674e9025ec54f17a87b927e9;674e8f54ec54f17a87b82142;674e8f0bec54f17a87b7bad2;674e8e8cec54f17a87b71889;674e8f75ec54f17a87b84947;674e8ec0ec54f17a87b75a2b;674e8e53ec54f17a87b6bd34;674e8efdec54f17a87b7a7da;674e908aec54f17a87b9c725;674e908eec54f17a87b9cdf1;674e9005ec54f17a87b900bb;674e905eec54f17a87b97f1f;674e8f84ec54f17a87b85eb4;674e8f04ec54f17a87b7b161;674e8f7dec54f17a87b8549c;674e905dec54f17a87b97cf6;674e8f17ec54f17a87b7ca47;674e8e1aec54f17a87b68695;674e919bec54f17a87badfe0;674e8f22ec54f17a87b7da7b;674e8e3dec54f17a87b6a799;674e8fdaec54f17a87b8cc71;674e8deeec54f17a87b655e3;674e8d57ec54f17a87b5c9c3;674e8debec54f17a87b653a5;674e905fec54f17a87b981f8;674e8f8aec54f17a87b86624;674e8e8eec54f17a87b71a1b;674e8f01ec54f17a87b7ad43;674e8eb9ec54f17a87b7515f;674e9037ec54f17a87b93daa;674e8f28ec54f17a87b7e7ce;674e8e61ec54f17a87b6e09b;674e90a3ec54f17a87b9ecc3;674e8efeec54f17a87b7a93b;674e8de3ec54f17a87b64c7d;674e90edec54f17a87ba40bb;674e8fdeec54f17a87b8d1ae",
          },
          {
            value: "virtual",
            count: 79,
            keywordIds:
              "674e9088ec54f17a87b9c4a0;674e8fb5ec54f17a87b89e57;674e8e37ec54f17a87b6a218;674e9183ec54f17a87bacd37;674e9196ec54f17a87badc8c;674e9069ec54f17a87b99254;674e8e5fec54f17a87b6de55;674e8f92ec54f17a87b871f1;674e8f86ec54f17a87b860b8;674e9201ec54f17a87bb33a9;674e8ea0ec54f17a87b73180;674e8e1dec54f17a87b689a3;674e8f3cec54f17a87b801b2;674e8d8eec54f17a87b5fe9d;674e9195ec54f17a87badb2e;674e8ff1ec54f17a87b8e8e2;674e9021ec54f17a87b92356;674e8d23ec54f17a87b5977c;674e9097ec54f17a87b9da6f;674e918aec54f17a87bad20f;674e8fe4ec54f17a87b8d8e7;674e9053ec54f17a87b96993;674e9012ec54f17a87b910ef;674e8f06ec54f17a87b7b379;674e9056ec54f17a87b96f4a;674e8ed1ec54f17a87b76f9b;674e91baec54f17a87bafb19;674e8e88ec54f17a87b7139d;674e9018ec54f17a87b918a5;674e8cfdec54f17a87b57060;674e8fb3ec54f17a87b89c05;674e8d1fec54f17a87b59344;674e9146ec54f17a87ba9062;674e9030ec54f17a87b93527;674e8f76ec54f17a87b84b54;674e8e70ec54f17a87b6f524;674e900cec54f17a87b909f8;674e9091ec54f17a87b9d178;674e9017ec54f17a87b9169f;674e911fec54f17a87ba6e6c;674e8d63ec54f17a87b5d461;674e9130ec54f17a87ba7d50;674e8ebdec54f17a87b756ba;674e8ffcec54f17a87b8f606;674e90e5ec54f17a87ba39ac;674e8ff5ec54f17a87b8ed7d;674e8ee9ec54f17a87b78ee5;674e8f1bec54f17a87b7cf80;674e8da1ec54f17a87b610fa;674e8f90ec54f17a87b86e18;674e9112ec54f17a87ba6354;674e8d40ec54f17a87b5b375;674e9091ec54f17a87b9d2a6;674e8d6dec54f17a87b5ddf1;674e8e81ec54f17a87b7097b;674e8fbdec54f17a87b8a770;674e8fafec54f17a87b8964c;674e8e55ec54f17a87b6bea8;674e8e60ec54f17a87b6e00b;674e9133ec54f17a87ba8026;674e8eb2ec54f17a87b74834",
          },
          {
            value: "auxiliary",
            count: 78,
            keywordIds:
              "674e8d1cec54f17a87b58f63;674e9154ec54f17a87ba9cff;674e8ef1ec54f17a87b7989a;674e8f7fec54f17a87b8585c;674e8f94ec54f17a87b873de;674e8edbec54f17a87b77c8a;674e8eacec54f17a87b740e6;674e8f5fec54f17a87b82e5e;674e8f40ec54f17a87b80762;674e8f57ec54f17a87b82510;674e8e4dec54f17a87b6b6fc;674e8f9dec54f17a87b880b8;674e8f6dec54f17a87b83f53;674e9013ec54f17a87b91253;674e9121ec54f17a87ba702e;674e8fe0ec54f17a87b8d373;674e907aec54f17a87b9b04f;674e918bec54f17a87bad361;674e8f04ec54f17a87b7b133;674e8f9bec54f17a87b87e09;674e8fcbec54f17a87b8ba50;674e909fec54f17a87b9e5cd;674e8fceec54f17a87b8be40;674e8de9ec54f17a87b6519f;674e8f08ec54f17a87b7b698;674e91a5ec54f17a87bae7fa;674e8e17ec54f17a87b6830c;674e8e74ec54f17a87b6f96b;674e900cec54f17a87b909d2;674e91a6ec54f17a87bae92d;674e9028ec54f17a87b92b7f;674e8d54ec54f17a87b5c63e;674e9029ec54f17a87b92d06;674e9083ec54f17a87b9bcd0;674e914cec54f17a87ba95f6;674e90ecec54f17a87ba3ffd;674e8dbfec54f17a87b62cba;674e8f31ec54f17a87b7f3fb;674e8f8dec54f17a87b86a3e;674e8fd4ec54f17a87b8c52e;674e8fd0ec54f17a87b8c023;674e909aec54f17a87b9debe;674e8cf7ec54f17a87b56a39;674e8fadec54f17a87b893e5;674e8ea2ec54f17a87b73369;674e8e65ec54f17a87b6e61e;674e9087ec54f17a87b9c336;674e8ed3ec54f17a87b771df;674e8f22ec54f17a87b7dac1;674e8d98ec54f17a87b60822;674e8f65ec54f17a87b83687;674e916fec54f17a87bab5a8;674e9023ec54f17a87b925a0;674e8f14ec54f17a87b7c656;674e90deec54f17a87ba329c;674e8df0ec54f17a87b65724;674e915fec54f17a87baa8e1;674e8f40ec54f17a87b80797;674e8edfec54f17a87b781cf;674e8ebaec54f17a87b75201;674e8e30ec54f17a87b69aa8;674e9009ec54f17a87b905ab;674e8e49ec54f17a87b6b29c;674e8e70ec54f17a87b6f3db;674e8f03ec54f17a87b7af41",
          },
          {
            value: "haptic",
            count: 78,
            keywordIds:
              "674e8ff7ec54f17a87b8efbb;674e8fe3ec54f17a87b8d6e1;674e8e9eec54f17a87b72f39;674e904aec54f17a87b9566d;674e8ff3ec54f17a87b8ebb8;674e91c6ec54f17a87bb042d;674e8fa3ec54f17a87b88719;674e8f0eec54f17a87b7bf07;674e8eb6ec54f17a87b74cf1;674e8d5dec54f17a87b5ce91;674e9179ec54f17a87babe2a;674e8fd7ec54f17a87b8c8bd;674e8e36ec54f17a87b6a07f;674e8e3fec54f17a87b6a9af;674e8ef7ec54f17a87b7a01c;674e9059ec54f17a87b97521;674e91c9ec54f17a87bb06e0;674e8d10ec54f17a87b5834c;674e8f37ec54f17a87b7fc4d;674e9003ec54f17a87b8ff02;674e90f9ec54f17a87ba4c11;674e8d7fec54f17a87b5f0d5;674e9031ec54f17a87b9374d;674e91e6ec54f17a87bb1e3c;674e8e4cec54f17a87b6b5a8;674e8d6aec54f17a87b5dac3;674e8d08ec54f17a87b57b1d;674e908bec54f17a87b9c8de;674e908dec54f17a87b9cba2;674e8e46ec54f17a87b6b032;674e8ffbec54f17a87b8f499;674e915eec54f17a87baa7c2;674e9198ec54f17a87baddb2;674e8f12ec54f17a87b7c44c;674e8f9cec54f17a87b87ed7;674e8f73ec54f17a87b8476e;674e8e48ec54f17a87b6b153;674e8eeeec54f17a87b7952f;674e9118ec54f17a87ba6818;674e90ccec54f17a87ba20bb;674e8fd0ec54f17a87b8bfe8;674e9147ec54f17a87ba91b9;674e9070ec54f17a87b99edc;674e912fec54f17a87ba7c88;674e9018ec54f17a87b91741;674e8d05ec54f17a87b57844;674e8ea7ec54f17a87b7399a;674e9041ec54f17a87b94a78;674e913aec54f17a87ba85f3;674e8e89ec54f17a87b7146e;674e8d51ec54f17a87b5c3a8;674e8e5aec54f17a87b6d6e2;674e8f6aec54f17a87b83bb3;674e8e9fec54f17a87b72f98;674e9155ec54f17a87ba9eff;674e8fdcec54f17a87b8ce74;674e9193ec54f17a87bad9f3;674e8f9aec54f17a87b87b5a;674e91ffec54f17a87bb3199;674e906fec54f17a87b99cb9;674e9047ec54f17a87b95201;674e8da6ec54f17a87b615a0;674e8ed0ec54f17a87b76e00;674e909fec54f17a87b9e531;674e8e99ec54f17a87b7284e;674e8fddec54f17a87b8d0a9;674e8dc7ec54f17a87b63359;674e8df4ec54f17a87b65abd",
          },
          {
            value: "generate",
            count: 78,
            keywordIds:
              "674e8df4ec54f17a87b65b91;674e8fbaec54f17a87b8a3d0;674e8d27ec54f17a87b59b8e;674e903fec54f17a87b948cc;674e8e6cec54f17a87b6efaf;674e8dbbec54f17a87b628c2;674e90a1ec54f17a87b9e9b4;674e919fec54f17a87bae306;674e8e1dec54f17a87b68909;674e8d59ec54f17a87b5cb91;674e8eecec54f17a87b792ea;674e8d1eec54f17a87b5923e;674e8ebcec54f17a87b7556a;674e8ef2ec54f17a87b79993;674e8eb8ec54f17a87b75023;674e8f1dec54f17a87b7d34b;674e90afec54f17a87b9fc65;674e910dec54f17a87ba5ef6;674e908aec54f17a87b9c714;674e8e2cec54f17a87b69784;674e8e25ec54f17a87b690a3;674e8d94ec54f17a87b6034a;674e8fceec54f17a87b8bdfa;674e8d49ec54f17a87b5bc01;674e8f91ec54f17a87b87009;674e90baec54f17a87ba0ba0;674e8f9cec54f17a87b87eb3;674e8ecbec54f17a87b76827;674e8e47ec54f17a87b6b0c7;674e8f63ec54f17a87b83386;674e8e5aec54f17a87b6d7d3;674e8e95ec54f17a87b72405;674e8ffcec54f17a87b8f598;674e8dd1ec54f17a87b63d18;674e9168ec54f17a87baaf41;674e8e5fec54f17a87b6de7b;674e8ea2ec54f17a87b73334;674e8d03ec54f17a87b57651;674e90bbec54f17a87ba0cde;674e9111ec54f17a87ba6234;674e8f90ec54f17a87b86df9;674e8ddeec54f17a87b647f1;674e8f59ec54f17a87b8273d;674e8ed7ec54f17a87b77673;674e9150ec54f17a87ba9a30;674e8e81ec54f17a87b709a0;674e8f1aec54f17a87b7ce85;674e91ffec54f17a87bb317f;674e906eec54f17a87b99b77;674e9024ec54f17a87b92631;674e8f81ec54f17a87b85ad5;674e8e5cec54f17a87b6d9fb;674e9034ec54f17a87b93ab0;674e8f4fec54f17a87b81a4b;674e8e01ec54f17a87b66cf3;674e8f34ec54f17a87b7f7de;674e8e66ec54f17a87b6e7bd;674e8e99ec54f17a87b727f8;674e8eb7ec54f17a87b74e37;674e8f26ec54f17a87b7e4ab;674e8d2fec54f17a87b5a342",
          },
          {
            value: "override",
            count: 77,
            keywordIds:
              "674e8d6bec54f17a87b5db3d;674e9172ec54f17a87bab887;674e8f0aec54f17a87b7b983;674e90b5ec54f17a87ba043c;674e917cec54f17a87bac60f;674e8de7ec54f17a87b65033;674e9183ec54f17a87bacc66;674e8eacec54f17a87b73f8e;674e8e50ec54f17a87b6ba1b;674e8f6fec54f17a87b841db;674e8eb5ec54f17a87b74c1b;674e8fbfec54f17a87b8aa43;674e8f69ec54f17a87b83ab1;674e8e79ec54f17a87b7004c;674e8d60ec54f17a87b5d16d;674e8ebcec54f17a87b7548a;674e91c9ec54f17a87bb0715;674e907bec54f17a87b9b0bc;674e91d2ec54f17a87bb0db1;674e908fec54f17a87b9cfd4;674e90c8ec54f17a87ba1c87;674e91edec54f17a87bb2384;674e8db2ec54f17a87b6204c;674e8facec54f17a87b892b8;674e908bec54f17a87b9c95f;674e8fb3ec54f17a87b89bc2;674e8e0bec54f17a87b676ca;674e8e71ec54f17a87b6f6ba;674e8d16ec54f17a87b5899c;674e90ceec54f17a87ba2313;674e8ef8ec54f17a87b7a1af;674e9186ec54f17a87bacf39;674e91f0ec54f17a87bb2652;674e9090ec54f17a87b9d087;674e90a8ec54f17a87b9f353;674e8d02ec54f17a87b574be;674e8f51ec54f17a87b81da9;674e8d63ec54f17a87b5d40c;674e8e9fec54f17a87b7305c;674e90e5ec54f17a87ba396f;674e9041ec54f17a87b94b23;674e8e8fec54f17a87b71c30;674e8f01ec54f17a87b7acb8;674e8f46ec54f17a87b80ea5;674e9005ec54f17a87b9018c;674e9063ec54f17a87b987ca;674e8ea2ec54f17a87b732e5;674e9022ec54f17a87b9240f;674e8d98ec54f17a87b607f3;674e8e5cec54f17a87b6da53;674e8f56ec54f17a87b8230f;674e8f65ec54f17a87b83634;674e8e9aec54f17a87b72981;674e8e77ec54f17a87b6fd03;674e8ee1ec54f17a87b783e7;674e8e5dec54f17a87b6dab4;674e8ea5ec54f17a87b7369d;674e8e7eec54f17a87b7058b;674e8fbbec54f17a87b8a59b;674e8f17ec54f17a87b7ca08;674e90b7ec54f17a87ba0789;674e91ceec54f17a87bb0ab2;674e9038ec54f17a87b93f3d;674e8eb2ec54f17a87b748f1;674e8de4ec54f17a87b64cfd;674e8e70ec54f17a87b6f4e5;674e8dcfec54f17a87b63aeb;674e9137ec54f17a87ba83b2;674e8fc8ec54f17a87b8b6b3",
          },
          {
            value: "navigate",
            count: 77,
            keywordIds:
              "674e8e91ec54f17a87b71e19;674e8e92ec54f17a87b71fa4;674e9010ec54f17a87b90e85;674e91c3ec54f17a87bb027b;674e8febec54f17a87b8e09a;674e9064ec54f17a87b989ef;674e8fb0ec54f17a87b897b3;674e8d5dec54f17a87b5ce44;674e8fd4ec54f17a87b8c4f0;674e9044ec54f17a87b94ef0;674e9021ec54f17a87b92288;674e8e43ec54f17a87b6ad5e;674e8ee8ec54f17a87b78dab;674e90e0ec54f17a87ba3495;674e90c9ec54f17a87ba1d47;674e9056ec54f17a87b96eee;674e9054ec54f17a87b96bd9;674e8dadec54f17a87b61c1a;674e91a2ec54f17a87bae568;674e8d09ec54f17a87b57cad;674e8ffbec54f17a87b8f469;674e90bcec54f17a87ba0e77;674e8f39ec54f17a87b7fe40;674e91d9ec54f17a87bb131c;674e90ccec54f17a87ba1ff7;674e8e70ec54f17a87b6f4f0;674e8ebdec54f17a87b7567e;674e9117ec54f17a87ba67e9;674e9045ec54f17a87b95097;674e904eec54f17a87b95b96;674e8ea3ec54f17a87b73524;674e8fabec54f17a87b891c3;674e903dec54f17a87b94624;674e8fe6ec54f17a87b8da35;674e8f4dec54f17a87b8186b;674e912dec54f17a87ba7a5d;674e8d26ec54f17a87b59a36;674e8e9cec54f17a87b72c50;674e8fe5ec54f17a87b8d948;674e8f03ec54f17a87b7afda;674e8f65ec54f17a87b83624;674e9052ec54f17a87b96746;674e91e0ec54f17a87bb195d;674e8d0dec54f17a87b57fb7;674e8fbcec54f17a87b8a672;674e8faeec54f17a87b895a0;674e916bec54f17a87bab2a0;674e90caec54f17a87ba1e5b;674e8f1bec54f17a87b7d048;674e8d2bec54f17a87b59f82;674e8f43ec54f17a87b80b20;674e8ee5ec54f17a87b789d9;674e8ee0ec54f17a87b78247;674e8d45ec54f17a87b5b7bc;674e8f98ec54f17a87b8798b;674e8de1ec54f17a87b64a4c;674e8d57ec54f17a87b5c918;674e8f35ec54f17a87b7f92c;674e8f1fec54f17a87b7d5b8;674e8e58ec54f17a87b6c38c;674e8f02ec54f17a87b7af11;674e8ed5ec54f17a87b7749f",
          },
          {
            value: "wireless",
            count: 76,
            keywordIds:
              "674e90b5ec54f17a87ba0466;674e8f7fec54f17a87b85803;674e8dd7ec54f17a87b641b0;674e8fa5ec54f17a87b8893e;674e904cec54f17a87b95988;674e903fec54f17a87b94815;674e8d07ec54f17a87b579f4;674e8febec54f17a87b8e0ca;674e8e6cec54f17a87b6efe5;674e9067ec54f17a87b98faa;674e8f40ec54f17a87b8065b;674e8eb8ec54f17a87b75056;674e8d6fec54f17a87b5e03f;674e8fcbec54f17a87b8ba8a;674e8e7aec54f17a87b700ea;674e8dd5ec54f17a87b63fd6;674e8db8ec54f17a87b625fe;674e9032ec54f17a87b9381a;674e8f1eec54f17a87b7d401;674e8e6eec54f17a87b6f243;674e8fc1ec54f17a87b8ac53;674e906aec54f17a87b993bb;674e916fec54f17a87bab633;674e8ec3ec54f17a87b75e12;674e8f91ec54f17a87b86ed8;674e8d17ec54f17a87b589d2;674e8e31ec54f17a87b69c85;674e911eec54f17a87ba6d2d;674e907dec54f17a87b9b561;674e9019ec54f17a87b9191c;674e918fec54f17a87bad644;674e8d8dec54f17a87b5fdb4;674e8efcec54f17a87b7a63c;674e8e81ec54f17a87b70a56;674e8dd8ec54f17a87b642f6;674e8d52ec54f17a87b5c4a2;674e9132ec54f17a87ba7fb6;674e8f6cec54f17a87b83ee6;674e8d62ec54f17a87b5d357;674e8f5aec54f17a87b827ce;674e915cec54f17a87baa657;674e9096ec54f17a87b9d853;674e910aec54f17a87ba5c61;674e8f04ec54f17a87b7b0ce;674e8f67ec54f17a87b8385a;674e9092ec54f17a87b9d345;674e8f5aec54f17a87b827e8;674e8fffec54f17a87b8f9b4;674e913fec54f17a87ba8ac1;674e8e81ec54f17a87b709d6;674e8e73ec54f17a87b6f8b8;674e8f56ec54f17a87b823bd;674e8db5ec54f17a87b62375;674e90d7ec54f17a87ba2b51;674e8f8bec54f17a87b86769;674e8e01ec54f17a87b66d28;674e8f38ec54f17a87b7fcb0;674e8ee3ec54f17a87b7864d;674e8dd9ec54f17a87b643b4;674e8edaec54f17a87b77ac0;674e8efeec54f17a87b7a995;674e8e3aec54f17a87b6a4d6;674e90daec54f17a87ba2e7c;674e8fefec54f17a87b8e638",
          },
          {
            value: "quantify",
            count: 75,
            keywordIds:
              "674e9061ec54f17a87b98650;674e8e12ec54f17a87b67e99;674e903dec54f17a87b94619;674e90c0ec54f17a87ba138d;674e90c6ec54f17a87ba1aed;674e8f62ec54f17a87b83299;674e8fa2ec54f17a87b886b0;674e8e5fec54f17a87b6de0c;674e8f80ec54f17a87b858df;674e8fbfec54f17a87b8aaed;674e9044ec54f17a87b94dfb;674e8f30ec54f17a87b7f20b;674e90adec54f17a87b9f96b;674e9002ec54f17a87b8fd8a;674e9128ec54f17a87ba76f9;674e9011ec54f17a87b91042;674e8daaec54f17a87b61950;674e8dfcec54f17a87b666f4;674e8ebeec54f17a87b757e7;674e90a7ec54f17a87b9f1d8;674e8d93ec54f17a87b6027a;674e8f83ec54f17a87b85d68;674e8fc1ec54f17a87b8ace2;674e8e46ec54f17a87b6b00c;674e8d31ec54f17a87b5a4b6;674e91a5ec54f17a87bae7e0;674e9082ec54f17a87b9bc21;674e9069ec54f17a87b992a7;674e8f77ec54f17a87b84c02;674e8d7dec54f17a87b5eee3;674e8f6bec54f17a87b83ccb;674e8efaec54f17a87b7a449;674e8fcdec54f17a87b8bd07;674e9019ec54f17a87b919d6;674e9082ec54f17a87b9bc96;674e91ddec54f17a87bb16a6;674e8f4bec54f17a87b815e0;674e904bec54f17a87b9583c;674e909aec54f17a87b9dddb;674e8ee7ec54f17a87b78bd5;674e8ee9ec54f17a87b78e02;674e8ff6ec54f17a87b8eed6;674e8f1bec54f17a87b7cf3a;674e90a3ec54f17a87b9ec01;674e8f48ec54f17a87b8112d;674e8efcec54f17a87b7a70c;674e8e59ec54f17a87b6d5d5;674e9100ec54f17a87ba5411;674e9005ec54f17a87b90194;674e9166ec54f17a87baae15;674e8f5dec54f17a87b82c2e;674e8e80ec54f17a87b70947;674e8eeeec54f17a87b795a8;674e90b2ec54f17a87ba00ef;674e8d4cec54f17a87b5bef7;674e9034ec54f17a87b93a18;674e8fb4ec54f17a87b89c44;674e8ed0ec54f17a87b76da0;674e8e45ec54f17a87b6aef7;674e91f7ec54f17a87bb2b78;674e8de1ec54f17a87b64ad7;674e8f32ec54f17a87b7f4e5;674e8ed7ec54f17a87b77733;674e8fc9ec54f17a87b8b7ae;674e9161ec54f17a87baa9c9;674e8ff0ec54f17a87b8e69c;674e90c4ec54f17a87ba192c",
          },
          {
            value: "synthesize",
            count: 75,
            keywordIds:
              "674e8ff7ec54f17a87b8ef8f;674e8ec9ec54f17a87b7658d;674e8f25ec54f17a87b7e30f;674e8eefec54f17a87b7965e;674e8edcec54f17a87b77d0e;674e8f77ec54f17a87b84cfa;674e8e6dec54f17a87b6f050;674e8fddec54f17a87b8d00f;674e8f1cec54f17a87b7d0cc;674e8eaaec54f17a87b73df4;674e91eaec54f17a87bb212d;674e8ec7ec54f17a87b76335;674e91f6ec54f17a87bb2abb;674e8f3cec54f17a87b80271;674e8d0eec54f17a87b5814f;674e9083ec54f17a87b9be04;674e91beec54f17a87bafdcc;674e918aec54f17a87bad257;674e8ef8ec54f17a87b7a185;674e9102ec54f17a87ba550b;674e8fbcec54f17a87b8a67d;674e8feeec54f17a87b8e44a;674e8f48ec54f17a87b81102;674e8e9bec54f17a87b72bb7;674e8f29ec54f17a87b7e972;674e8f08ec54f17a87b7b664;674e8d66ec54f17a87b5d732;674e8e7cec54f17a87b703c6;674e8ffeec54f17a87b8f85a;674e91a9ec54f17a87baec0e;674e900cec54f17a87b909c6;674e8d53ec54f17a87b5c599;674e8e31ec54f17a87b69bce;674e91deec54f17a87bb17c6;674e8cfaec54f17a87b56db0;674e90d2ec54f17a87ba26b1;674e911fec54f17a87ba6e4a;674e912fec54f17a87ba7d17;674e8d85ec54f17a87b5f620;674e8cf6ec54f17a87b56961;674e8d82ec54f17a87b5f32b;674e9094ec54f17a87b9d67a;674e9110ec54f17a87ba6126;674e8e61ec54f17a87b6e0d3;674e8f28ec54f17a87b7e726;674e9042ec54f17a87b94c06;674e8e8fec54f17a87b71bc0;674e9022ec54f17a87b92455;674e9024ec54f17a87b92626;674e901dec54f17a87b91e3d;674e8fb9ec54f17a87b8a329;674e8fdbec54f17a87b8cd17;674e8faeec54f17a87b8957f;674e8f53ec54f17a87b82075;674e8f0fec54f17a87b7bf9a;674e90ddec54f17a87ba3211;674e8e1eec54f17a87b68a71;674e913eec54f17a87ba8a04;674e8dd1ec54f17a87b63c4c;674e8f07ec54f17a87b7b42a;674e8e2fec54f17a87b69a5b;674e8edaec54f17a87b77a4d;674e8e57ec54f17a87b6c129;674e901aec54f17a87b91b29;674e912bec54f17a87ba7961",
          },
          {
            value: "cross-platform",
            count: 74,
            keywordIds:
              "674e8f68ec54f17a87b83a52;674e8ec2ec54f17a87b75cb8;674e8fbdec54f17a87b8a810;674e90c0ec54f17a87ba147c;674e8ecdec54f17a87b76999;674e8f6eec54f17a87b84127;674e8fb1ec54f17a87b8986f;674e8fd4ec54f17a87b8c522;674e9031ec54f17a87b936de;674e8eecec54f17a87b7925e;674e9067ec54f17a87b98f18;674e9144ec54f17a87ba8ea4;674e9139ec54f17a87ba854d;674e8e21ec54f17a87b68c9f;674e8e07ec54f17a87b672d1;674e8ef3ec54f17a87b79bac;674e9026ec54f17a87b9291d;674e8e7bec54f17a87b701cd;674e8fc3ec54f17a87b8afb0;674e910eec54f17a87ba5f9d;674e9066ec54f17a87b98d60;674e8f91ec54f17a87b86ead;674e8e6aec54f17a87b6ebe9;674e8e9bec54f17a87b72b1f;674e9053ec54f17a87b968f9;674e9019ec54f17a87b919af;674e8f23ec54f17a87b7e164;674e8f9cec54f17a87b87f06;674e900bec54f17a87b907a3;674e8dd3ec54f17a87b63e7c;674e8f38ec54f17a87b7fd4c;674e8fe1ec54f17a87b8d4b4;674e8d7eec54f17a87b5efb6;674e8cfbec54f17a87b56e30;674e8e8bec54f17a87b71765;674e8dd8ec54f17a87b6426b;674e8e86ec54f17a87b7111e;674e8faeec54f17a87b894ec;674e8f07ec54f17a87b7b546;674e90efec54f17a87ba422b;674e8d3bec54f17a87b5ade6;674e8ea8ec54f17a87b73c1b;674e8ebfec54f17a87b75914;674e8f15ec54f17a87b7c811;674e8f12ec54f17a87b7c43b;674e9082ec54f17a87b9bb1c;674e8d25ec54f17a87b5989a;674e90dcec54f17a87ba30b7;674e8dcbec54f17a87b6372a;674e8f75ec54f17a87b84ab6;674e8e5dec54f17a87b6daf1;674e9034ec54f17a87b93a46;674e8e08ec54f17a87b6748e;674e91e9ec54f17a87bb2051;674e8e7eec54f17a87b705dd;674e8f07ec54f17a87b7b45a;674e8e52ec54f17a87b6bbd8;674e9116ec54f17a87ba666b;674e8fa0ec54f17a87b8839b;674e90b8ec54f17a87ba0888;674e90bdec54f17a87ba0f9a",
          },
          {
            value: "mobile",
            count: 74,
            keywordIds:
              "674e8ddbec54f17a87b644a3;674e8f25ec54f17a87b7e370;674e8eefec54f17a87b796bd;674e9094ec54f17a87b9d694;674e8dbbec54f17a87b628f0;674e8d3eec54f17a87b5b1b2;674e902dec54f17a87b9323f;674e91a0ec54f17a87bae3bb;674e91f6ec54f17a87bb2ad3;674e8e6bec54f17a87b6edf1;674e8f11ec54f17a87b7c220;674e8e3cec54f17a87b6a6cc;674e9120ec54f17a87ba6f96;674e8febec54f17a87b8e143;674e8f83ec54f17a87b85d76;674e9070ec54f17a87b99f09;674e8d70ec54f17a87b5e0e1;674e8d2bec54f17a87b59f02;674e9093ec54f17a87b9d4fb;674e9064ec54f17a87b98a1f;674e9050ec54f17a87b9647d;674e8ebfec54f17a87b758eb;674e9079ec54f17a87b9ae70;674e91a2ec54f17a87bae619;674e91a2ec54f17a87bae580;674e9076ec54f17a87b9a90b;674e8de6ec54f17a87b64f61;674e8d31ec54f17a87b5a4fb;674e8cfeec54f17a87b5710a;674e8e7cec54f17a87b703fc;674e8f39ec54f17a87b7fea3;674e91aaec54f17a87baec58;674e90fcec54f17a87ba4f40;674e8eccec54f17a87b76841;674e8f89ec54f17a87b86518;674e901cec54f17a87b91d77;674e8f81ec54f17a87b859fc;674e8ea3ec54f17a87b7354a;674e8fa9ec54f17a87b88eb0;674e8d85ec54f17a87b5f653;674e9000ec54f17a87b8fb7c;674e8d64ec54f17a87b5d55c;674e8e68ec54f17a87b6ea26;674e90bbec54f17a87ba0d11;674e901aec54f17a87b91b1d;674e91adec54f17a87baef52;674e9006ec54f17a87b9021c;674e902fec54f17a87b934cd;674e8e8fec54f17a87b71c05;674e8d42ec54f17a87b5b53a;674e8edcec54f17a87b77ce9;674e901eec54f17a87b91f4e;674e8e3dec54f17a87b6a7c6;674e8d73ec54f17a87b5e452;674e8eb7ec54f17a87b74ea1;674e8d14ec54f17a87b586e4;674e8d39ec54f17a87b5ac8d;674e8f44ec54f17a87b80c06;674e8e39ec54f17a87b6a34a;674e8fe9ec54f17a87b8de53;674e91ecec54f17a87bb22a4;674e9036ec54f17a87b93ce8;674e90b6ec54f17a87ba0683;674e90edec54f17a87ba40d6;674e90c5ec54f17a87ba194e",
          },
          {
            value: "primary",
            count: 73,
            keywordIds:
              "674e9080ec54f17a87b9b965;674e8f68ec54f17a87b8396a;674e8e0dec54f17a87b6789b;674e907cec54f17a87b9b2d6;674e8f49ec54f17a87b813a4;674e8dc8ec54f17a87b63432;674e9074ec54f17a87b9a614;674e8f1cec54f17a87b7d0fa;674e8ec7ec54f17a87b76369;674e917eec54f17a87bac893;674e8eedec54f17a87b79322;674e8fa8ec54f17a87b88d28;674e903bec54f17a87b942c8;674e8e85ec54f17a87b70fb4;674e9063ec54f17a87b9886b;674e8f61ec54f17a87b83062;674e8f1eec54f17a87b7d38d;674e8f2cec54f17a87b7ed6d;674e9163ec54f17a87baab9e;674e8fddec54f17a87b8cf5c;674e8e2dec54f17a87b697ca;674e8f42ec54f17a87b80922;674e9180ec54f17a87bac9ba;674e8dcaec54f17a87b635fa;674e8f0aec54f17a87b7b943;674e8fc1ec54f17a87b8ac69;674e91b6ec54f17a87baf795;674e9085ec54f17a87b9c082;674e8e18ec54f17a87b684c3;674e8fc8ec54f17a87b8b5b2;674e8e72ec54f17a87b6f6df;674e8e6fec54f17a87b6f33b;674e9026ec54f17a87b92883;674e9137ec54f17a87ba8302;674e8dadec54f17a87b61b9d;674e8f0bec54f17a87b7bb0e;674e8e42ec54f17a87b6abb3;674e8d02ec54f17a87b574eb;674e9047ec54f17a87b95309;674e903bec54f17a87b942bd;674e8d95ec54f17a87b604a9;674e8f6fec54f17a87b842ce;674e8fabec54f17a87b891ee;674e8db0ec54f17a87b61e4a;674e8d4aec54f17a87b5bdc0;674e9122ec54f17a87ba70e5;674e8f62ec54f17a87b8323b;674e8f70ec54f17a87b843d8;674e8fe5ec54f17a87b8d982;674e8e8aec54f17a87b7156a;674e8f4dec54f17a87b81843;674e919bec54f17a87bae07b;674e8eeeec54f17a87b7949e;674e8e5cec54f17a87b6d9e1;674e8fdaec54f17a87b8cccd;674e8d2cec54f17a87b59fc0;674e9047ec54f17a87b952fe;674e9014ec54f17a87b913be;674e8f50ec54f17a87b81bba;674e8efaec54f17a87b7a4be;674e911bec54f17a87ba6a7f;674e8e56ec54f17a87b6bfe1;674e8f08ec54f17a87b7b6a3;674e906fec54f17a87b99d45;674e8fc9ec54f17a87b8b6fa",
          },
          {
            value: "neural",
            count: 69,
            keywordIds:
              "674e8fe3ec54f17a87b8d6ed;674e8d97ec54f17a87b606c1;674e903eec54f17a87b9472e;674e8fe2ec54f17a87b8d603;674e90c6ec54f17a87ba1a6d;674e9040ec54f17a87b94908;674e8f58ec54f17a87b82638;674e8d21ec54f17a87b59570;674e8fb1ec54f17a87b8997d;674e8f2bec54f17a87b7eb1f;674e8e84ec54f17a87b70e9d;674e909aec54f17a87b9df1d;674e903aec54f17a87b941e8;674e905fec54f17a87b982be;674e8d9dec54f17a87b60d00;674e8f5eec54f17a87b82d2a;674e8daaec54f17a87b6197a;674e9089ec54f17a87b9c6a0;674e8fe0ec54f17a87b8d3c7;674e8eddec54f17a87b77f19;674e9000ec54f17a87b8fa63;674e91c0ec54f17a87baff61;674e8e7bec54f17a87b702a9;674e90d5ec54f17a87ba29d1;674e915bec54f17a87baa562;674e8ea1ec54f17a87b73251;674e8f5aec54f17a87b828d8;674e91d7ec54f17a87bb1180;674e90ccec54f17a87ba2022;674e8e87ec54f17a87b71205;674e8ec6ec54f17a87b7611b;674e905eec54f17a87b97f43;674e9085ec54f17a87b9c03b;674e8e5bec54f17a87b6d851;674e8dcdec54f17a87b63997;674e91fbec54f17a87bb2e9e;674e917aec54f17a87babf4b;674e906aec54f17a87b9948e;674e9058ec54f17a87b9732d;674e9041ec54f17a87b94b69;674e8f48ec54f17a87b81226;674e8f00ec54f17a87b7ac32;674e8ed7ec54f17a87b7775e;674e905dec54f17a87b97d45;674e9143ec54f17a87ba8dc5;674e8f95ec54f17a87b874b7;674e91b2ec54f17a87baf34d;674e9192ec54f17a87bad8b8;674e8ee7ec54f17a87b78b98;674e8e63ec54f17a87b6e364;674e8d4cec54f17a87b5bf5a;674e8f0fec54f17a87b7bfd8;674e8fc2ec54f17a87b8ae14;674e8ed4ec54f17a87b7727f;674e8f50ec54f17a87b81c38;674e8e8eec54f17a87b71a7c;674e8f24ec54f17a87b7e2a2;674e8dd0ec54f17a87b63bf1;674e90b4ec54f17a87ba039e;674e8d3cec54f17a87b5aef6;674e8d35ec54f17a87b5a8e2;674e8d19ec54f17a87b58ca5;674e8e4aec54f17a87b6b466",
          },
          {
            value: "optical",
            count: 68,
            keywordIds:
              "674e9072ec54f17a87b9a20f;674e91bdec54f17a87bafd1c;674e907bec54f17a87b9b1bc;674e8eb0ec54f17a87b74656;674e90f6ec54f17a87ba48ed;674e91caec54f17a87bb07dd;674e8d36ec54f17a87b5aa2b;674e8d60ec54f17a87b5d187;674e8d77ec54f17a87b5e8c7;674e9045ec54f17a87b94f20;674e8e7dec54f17a87b7048c;674e916dec54f17a87bab3d3;674e91c4ec54f17a87bb033f;674e905fec54f17a87b98177;674e9002ec54f17a87b8fce9;674e91d2ec54f17a87bb0dcc;674e90c9ec54f17a87ba1d96;674e8fedec54f17a87b8e39d;674e9096ec54f17a87b9d88f;674e8cf9ec54f17a87b56c5b;674e8f85ec54f17a87b85fbb;674e8d66ec54f17a87b5d763;674e8f9dec54f17a87b87ff6;674e900cec54f17a87b908ea;674e91f3ec54f17a87bb2868;674e90baec54f17a87ba0bd5;674e91e2ec54f17a87bb1b3f;674e8fceec54f17a87b8be39;674e9036ec54f17a87b93cf3;674e909cec54f17a87b9e1a6;674e8db9ec54f17a87b62745;674e8ea0ec54f17a87b7309a;674e9056ec54f17a87b96ee2;674e8ec7ec54f17a87b76341;674e8f4dec54f17a87b818a4;674e8d26ec54f17a87b59a6e;674e8e9cec54f17a87b72c77;674e9027ec54f17a87b92a13;674e8eaaec54f17a87b73dac;674e8d92ec54f17a87b601b9;674e903fec54f17a87b948bb;674e900eec54f17a87b90c50;674e8e97ec54f17a87b72576;674e9051ec54f17a87b96665;674e8fb0ec54f17a87b89785;674e8f8cec54f17a87b86950;674e8e64ec54f17a87b6e470;674e8fc7ec54f17a87b8b49a;674e8d79ec54f17a87b5eabc;674e8f34ec54f17a87b7f822;674e8ee0ec54f17a87b78279;674e8f17ec54f17a87b7ca3b;674e91fdec54f17a87bb2fd9;674e90a4ec54f17a87b9ecef;674e9051ec54f17a87b96576;674e8f26ec54f17a87b7e4bc;674e8f18ec54f17a87b7cc37;674e8d35ec54f17a87b5a841;674e8fa6ec54f17a87b88aa9;674e9161ec54f17a87baaa01",
          },
          {
            value: "bluetooth",
            count: 66,
            keywordIds:
              "674e9088ec54f17a87b9c527;674e8eecec54f17a87b791d2;674e8f0bec54f17a87b7ba89;674e9004ec54f17a87b8fff1;674e8de7ec54f17a87b6504f;674e8d28ec54f17a87b59bf7;674e8f63ec54f17a87b832c3;674e901fec54f17a87b92118;674e90bfec54f17a87ba1284;674e9052ec54f17a87b96824;674e8d0bec54f17a87b57ea6;674e9015ec54f17a87b91451;674e8eacec54f17a87b73fb8;674e8eaeec54f17a87b742e1;674e8f05ec54f17a87b7b272;674e8eb5ec54f17a87b74c85;674e8e11ec54f17a87b67d8b;674e8f83ec54f17a87b85c77;674e9159ec54f17a87baa3d6;674e9062ec54f17a87b98749;674e8ed2ec54f17a87b76ff6;674e9128ec54f17a87ba7715;674e91d8ec54f17a87bb1287;674e8d15ec54f17a87b5883a;674e8f33ec54f17a87b7f5a7;674e8f0aec54f17a87b7b889;674e8f48ec54f17a87b81138;674e8e8cec54f17a87b71898;674e8f55ec54f17a87b8221e;674e8ebdec54f17a87b756af;674e90a7ec54f17a87b9f29d;674e9132ec54f17a87ba7efd;674e9149ec54f17a87ba9297;674e90afec54f17a87b9fc91;674e8f2eec54f17a87b7eef5;674e8f0aec54f17a87b7b8b0;674e90a1ec54f17a87b9e9c1;674e8e5fec54f17a87b6deb6;674e9010ec54f17a87b90e94;674e8e83ec54f17a87b70d71;674e9110ec54f17a87ba61a5;674e8e62ec54f17a87b6e1c0;674e8edfec54f17a87b7815f;674e8f2fec54f17a87b7f0ba;674e8fa1ec54f17a87b88480;674e9023ec54f17a87b9250c;674e90b1ec54f17a87b9ff25;674e9024ec54f17a87b92728;674e8f10ec54f17a87b7c0a8;674e8f35ec54f17a87b7f890;674e9022ec54f17a87b92448;674e8eeeec54f17a87b795dd;674e8d9fec54f17a87b60ea3;674e8f1cec54f17a87b7d11c;674e902dec54f17a87b93101;674e90b7ec54f17a87ba07bc;674e8e24ec54f17a87b68f61;674e8f74ec54f17a87b8485d;674e912bec54f17a87ba798e;674e8ed6ec54f17a87b7759e",
          },
          {
            value: "redundant",
            count: 65,
            keywordIds:
              "674e901cec54f17a87b91d38;674e8df4ec54f17a87b65bae;674e8e0dec54f17a87b6798b;674e8fbeec54f17a87b8a949;674e8f4aec54f17a87b813ef;674e8f21ec54f17a87b7d8d7;674e91c4ec54f17a87bb029e;674e8f77ec54f17a87b84d41;674e8ff3ec54f17a87b8eb88;674e9071ec54f17a87b9a141;674e8d29ec54f17a87b59d91;674e8dabec54f17a87b61a4e;674e90acec54f17a87b9f8a4;674e9203ec54f17a87bb3518;674e8cffec54f17a87b57279;674e90e7ec54f17a87ba3b91;674e8e43ec54f17a87b6ad7c;674e8d7bec54f17a87b5ed54;674e8fcbec54f17a87b8b9ae;674e8ed8ec54f17a87b778c1;674e8eb4ec54f17a87b74b8f;674e8e6fec54f17a87b6f308;674e8e95ec54f17a87b7242f;674e8e25ec54f17a87b690d7;674e90e2ec54f17a87ba3668;674e8f4bec54f17a87b8150e;674e8ffdec54f17a87b8f7d2;674e906aec54f17a87b99517;674e8d01ec54f17a87b573bd;674e8ffaec54f17a87b8f3b0;674e9104ec54f17a87ba5748;674e911cec54f17a87ba6bc0;674e8d4aec54f17a87b5bcc7;674e8fe7ec54f17a87b8dca4;674e8d83ec54f17a87b5f4ba;674e8e8cec54f17a87b718bb;674e8f4cec54f17a87b816d7;674e8f61ec54f17a87b83046;674e9007ec54f17a87b90403;674e90a3ec54f17a87b9ec3a;674e8faaec54f17a87b88feb;674e8e6bec54f17a87b6ed7c;674e8d9cec54f17a87b60c4b;674e8df6ec54f17a87b65d5a;674e91e0ec54f17a87bb1974;674e90f0ec54f17a87ba4358;674e8f89ec54f17a87b86502;674e8f2dec54f17a87b7ee5e;674e8eceec54f17a87b76ad5;674e8deeec54f17a87b655c1;674e8fb8ec54f17a87b8a1f1;674e8ec6ec54f17a87b76121;674e8d45ec54f17a87b5b902;674e8fbbec54f17a87b8a5cd;674e8f7dec54f17a87b85576;674e909dec54f17a87b9e255;674e91e4ec54f17a87bb1d0f;674e908dec54f17a87b9ccbd",
          },
          {
            value: "digital",
            count: 64,
            keywordIds:
              "674e8f0eec54f17a87b7be5f;674e917cec54f17a87bac64a;674e8f0dec54f17a87b7bced;674e8f86ec54f17a87b8618c;674e8e75ec54f17a87b6fa8f;674e902aec54f17a87b92dd9;674e8ff4ec54f17a87b8ec96;674e90dbec54f17a87ba2ffe;674e8eafec54f17a87b74419;674e9201ec54f17a87bb3316;674e8e98ec54f17a87b72782;674e8e8eec54f17a87b71a03;674e8f8fec54f17a87b86c91;674e8e75ec54f17a87b6fb66;674e8ff5ec54f17a87b8ed7a;674e9038ec54f17a87b93fa7;674e8ed2ec54f17a87b770c6;674e9107ec54f17a87ba5a1a;674e91abec54f17a87baedd3;674e8fbcec54f17a87b8a6c3;674e902bec54f17a87b92f4f;674e8ef5ec54f17a87b79e65;674e900dec54f17a87b90b3a;674e8fc1ec54f17a87b8ad3d;674e91baec54f17a87bafa87;674e8d7aec54f17a87b5eb9d;674e8d71ec54f17a87b5e236;674e9057ec54f17a87b9721a;674e8f63ec54f17a87b83434;674e9046ec54f17a87b950dc;674e8f6cec54f17a87b83e05;674e90b0ec54f17a87b9fd8f;674e8ed0ec54f17a87b76d88;674e8e79ec54f17a87b6ff85;674e8da2ec54f17a87b6120a;674e8fefec54f17a87b8e59a;674e8e0aec54f17a87b67604;674e8e14ec54f17a87b68082;674e912dec54f17a87ba7a77;674e8e90ec54f17a87b71cbb;674e8f05ec54f17a87b7b18f;674e8f71ec54f17a87b84558;674e902cec54f17a87b930c5;674e8f3eec54f17a87b80460;674e90f8ec54f17a87ba4b1e;674e8fadec54f17a87b89406;674e8eb0ec54f17a87b7462d;674e8ea3ec54f17a87b7340f;674e8fb9ec54f17a87b8a350;674e8f4cec54f17a87b8165b;674e90beec54f17a87ba1192;674e8edeec54f17a87b7808e;674e8d58ec54f17a87b5c9dc;674e8fb4ec54f17a87b89d07;674e8fc7ec54f17a87b8b4d5;674e8ea4ec54f17a87b7358c;674e8dfaec54f17a87b66595;674e8dcfec54f17a87b63a9b;674e9000ec54f17a87b8fb87;674e90a5ec54f17a87b9eece",
          },
          {
            value: "xml",
            count: 52,
            keywordIds:
              "674e8df5ec54f17a87b65bd2;674e8f98ec54f17a87b878aa;674e90b7ec54f17a87ba074e;674e8d28ec54f17a87b59c34;674e8f87ec54f17a87b861be;674e8e75ec54f17a87b6fad6;674e9171ec54f17a87bab7a7;674e8f86ec54f17a87b860e9;674e8e00ec54f17a87b66bfc;674e8eacec54f17a87b74015;674e8d2aec54f17a87b59db1;674e9144ec54f17a87ba8ed2;674e8ef6ec54f17a87b79f62;674e91b0ec54f17a87baf1ba;674e8fcbec54f17a87b8b9df;674e8f7aec54f17a87b8502e;674e91acec54f17a87baedf5;674e8fddec54f17a87b8cf94;674e9032ec54f17a87b93864;674e8e95ec54f17a87b723b0;674e8d92ec54f17a87b60240;674e8d30ec54f17a87b5a430;674e8ea4ec54f17a87b73679;674e8ef4ec54f17a87b79c7c;674e8e47ec54f17a87b6b109;674e9075ec54f17a87b9a8cf;674e8d05ec54f17a87b578d4;674e908eec54f17a87b9ce51;674e8da1ec54f17a87b6111b;674e912dec54f17a87ba7a92;674e8e5aec54f17a87b6d72a;674e8e8eec54f17a87b71b3a;674e8d41ec54f17a87b5b49c;674e8f66ec54f17a87b8378c;674e8e6aec54f17a87b6ec9d;674e8df7ec54f17a87b65d75;674e8fb9ec54f17a87b8a2b2;674e8f1cec54f17a87b7d152;674e902dec54f17a87b9313a;674e8e1fec54f17a87b68a9f;674e8f38ec54f17a87b7fd26;674e8f34ec54f17a87b7f764;674e91f7ec54f17a87bb2bb1;674e8eadec54f17a87b74271;674e8f03ec54f17a87b7af76",
          },
          {
            value: "tls",
            count: 50,
            keywordIds:
              "674e9173ec54f17a87bab987;674e8e13ec54f17a87b67ee2;674e8f0aec54f17a87b7b9c1;674e8df5ec54f17a87b65c70;674e8cfcec54f17a87b56f71;674e91a0ec54f17a87bae3db;674e9013ec54f17a87b91297;674e8e3cec54f17a87b6a6f3;674e9044ec54f17a87b94e75;674e8e06ec54f17a87b67210;674e8d23ec54f17a87b597a1;674e8ff3ec54f17a87b8ea7c;674e918aec54f17a87bad285;674e8e6fec54f17a87b6f339;674e8f1eec54f17a87b7d452;674e8db1ec54f17a87b61f6c;674e8fd2ec54f17a87b8c2c9;674e8e34ec54f17a87b69eca;674e900bec54f17a87b907ae;674e9105ec54f17a87ba578b;674e900bec54f17a87b908ba;674e91a7ec54f17a87bae9e8;674e8da4ec54f17a87b61328;674e907eec54f17a87b9b58a;674e9187ec54f17a87bacfaf;674e8d83ec54f17a87b5f473;674e8d9aec54f17a87b609f2;674e8dc0ec54f17a87b62d01;674e8feeec54f17a87b8e519;674e9110ec54f17a87ba61e6;674e8f47ec54f17a87b81025;674e90f7ec54f17a87ba4a65;674e90b9ec54f17a87ba0ac9;674e8d9dec54f17a87b60c68;674e908cec54f17a87b9caf2;674e90cbec54f17a87ba1ef4;674e9055ec54f17a87b96c9e;674e8f75ec54f17a87b84aee;674e8decec54f17a87b65409;674e8f8aec54f17a87b866a6;674e8f1dec54f17a87b7d2a3;674e8fbcec54f17a87b8a5f6;674e90a4ec54f17a87b9edf6;674e8e56ec54f17a87b6bf62;674e8f08ec54f17a87b7b5df;674e908dec54f17a87b9ccfa",
          },
          {
            value: "thx",
            count: 48,
            keywordIds:
              "674e8fe3ec54f17a87b8d7b4;674e8d6cec54f17a87b5dc0e;674e8ee9ec54f17a87b78ef0;674e8f0cec54f17a87b7bc3c;674e8edcec54f17a87b77d50;674e8e77ec54f17a87b6fe08;674e8e5eec54f17a87b6dd81;674e8f58ec54f17a87b8265e;674e8e1dec54f17a87b689d4;674e8d5aec54f17a87b5cc6a;674e8e3fec54f17a87b6a9cd;674e8e67ec54f17a87b6e90f;674e8e21ec54f17a87b68ce6;674e8ef0ec54f17a87b79818;674e9152ec54f17a87ba9b6a;674e90a3ec54f17a87b9ebde;674e8d0aec54f17a87b57d71;674e91aaec54f17a87baeca3;674e8d8cec54f17a87b5fc97;674e8f54ec54f17a87b821b5;674e91dfec54f17a87bb1860;674e90cdec54f17a87ba2101;674e904eec54f17a87b95c03;674e8d63ec54f17a87b5d399;674e90a1ec54f17a87b9e8d4;674e8ea6ec54f17a87b738d5;674e8eb3ec54f17a87b749b9;674e8f01ec54f17a87b7ad0f;674e8d1aec54f17a87b58e1f;674e8e5aec54f17a87b6d6c1;674e8ebfec54f17a87b75894;674e8faaec54f17a87b89018;674e8ecfec54f17a87b76b9e;674e8d72ec54f17a87b5e36c;674e8eeeec54f17a87b79523;674e8d58ec54f17a87b5ca21;674e8e99ec54f17a87b72899;674e8debec54f17a87b65342;674e91dbec54f17a87bb14e8;674e9137ec54f17a87ba83d2",
          },
          {
            value: "sdd",
            count: 48,
            keywordIds:
              "674e8d97ec54f17a87b60701;674e9065ec54f17a87b98c6a;674e8f9fec54f17a87b8822c;674e907cec54f17a87b9b314;674e8f71ec54f17a87b8444b;674e8ef4ec54f17a87b79ce6;674e9072ec54f17a87b9a21a;674e91c2ec54f17a87bb0157;674e8e11ec54f17a87b67d2b;674e91c9ec54f17a87bb072f;674e9003ec54f17a87b8ff45;674e8ef8ec54f17a87b7a231;674e918dec54f17a87bad4db;674e9108ec54f17a87ba5a33;674e910eec54f17a87ba5f4f;674e8fe9ec54f17a87b8de19;674e8fd9ec54f17a87b8cb1a;674e9065ec54f17a87b98ca1;674e902bec54f17a87b92fd2;674e9077ec54f17a87b9aa4d;674e8e74ec54f17a87b6f999;674e9188ec54f17a87bad106;674e9134ec54f17a87ba8102;674e9125ec54f17a87ba7391;674e8ebcec54f17a87b75460;674e8f6eec54f17a87b84086;674e9008ec54f17a87b90436;674e8efdec54f17a87b7a86e;674e90e6ec54f17a87ba3a23;674e913aec54f17a87ba8622;674e9091ec54f17a87b9d24b;674e900fec54f17a87b90c94;674e8f19ec54f17a87b7cdad;674e8e3bec54f17a87b6a615;674e8e80ec54f17a87b708e5;674e8e5bec54f17a87b6d924;674e8fafec54f17a87b895f3;674e8fb8ec54f17a87b8a127;674e8f99ec54f17a87b87a8f;674e8e79ec54f17a87b6ff71;674e8f50ec54f17a87b81c12;674e8e7eec54f17a87b70615;674e8f18ec54f17a87b7cbc8",
          },
          {
            value: "json",
            count: 47,
            keywordIds:
              "674e9061ec54f17a87b98551;674e8fe1ec54f17a87b8d4ee;674e8f41ec54f17a87b807a3;674e90f6ec54f17a87ba492d;674e8fbfec54f17a87b8aa75;674e8fa8ec54f17a87b88d43;674e8d77ec54f17a87b5e8fd;674e8ff1ec54f17a87b8e894;674e8f8eec54f17a87b86bf3;674e8fe4ec54f17a87b8d837;674e9119ec54f17a87ba68de;674e8ed3ec54f17a87b770ed;674e8f5eec54f17a87b82d5c;674e8daaec54f17a87b618b6;674e8f42ec54f17a87b8094f;674e9096ec54f17a87b9d978;674e8dc6ec54f17a87b6322c;674e91a3ec54f17a87bae63e;674e9018ec54f17a87b918ef;674e8f5bec54f17a87b829c5;674e8fa6ec54f17a87b88a76;674e8f0bec54f17a87b7ba5b;674e914dec54f17a87ba9628;674e909cec54f17a87b9e1f2;674e8ecaec54f17a87b765cb;674e8f45ec54f17a87b80e16;674e8f55ec54f17a87b82277;674e8f61ec54f17a87b83161;674e8fa9ec54f17a87b88ede;674e9058ec54f17a87b97391;674e9158ec54f17a87baa2cd;674e8e05ec54f17a87b670c9;674e903aec54f17a87b94160;674e8edbec54f17a87b77c18;674e8d38ec54f17a87b5ab9b;674e90efec54f17a87ba42da;674e9023ec54f17a87b925e6;674e8d58ec54f17a87b5ca8e;674e8f07ec54f17a87b7b4da;674e90e9ec54f17a87ba3d5e;674e90b6ec54f17a87ba06c9;674e9133ec54f17a87ba8068;674e8eafec54f17a87b744f8;674e8fdeec54f17a87b8d0ff",
          },
          {
            value: "ocr",
            count: 47,
            keywordIds:
              "674e9049ec54f17a87b95551;674e8fb6ec54f17a87b89f3d;674e8d2dec54f17a87b5a119;674e8f8fec54f17a87b86c53;674e8f78ec54f17a87b84e09;674e8ff4ec54f17a87b8ec73;674e8d3fec54f17a87b5b1e1;674e91f6ec54f17a87bb2a87;674e8f2bec54f17a87b7ec14;674e8d22ec54f17a87b59599;674e8d29ec54f17a87b59d53;674e9194ec54f17a87badab5;674e919dec54f17a87bae18e;674e8fdfec54f17a87b8d2ba;674e905fec54f17a87b981d1;674e8f95ec54f17a87b87559;674e8f33ec54f17a87b7f651;674e8fcbec54f17a87b8b9bc;674e8ebfec54f17a87b75925;674e8db2ec54f17a87b6207d;674e8f85ec54f17a87b85f12;674e915bec54f17a87baa596;674e8d1fec54f17a87b59365;674e91f4ec54f17a87bb2909;674e905cec54f17a87b97c6e;674e9083ec54f17a87b9bd04;674e901cec54f17a87b91d09;674e8ec1ec54f17a87b75c17;674e8f28ec54f17a87b7e76f;674e8f00ec54f17a87b7ab5c;674e8f5aec54f17a87b8282a;674e8f4cec54f17a87b81762;674e9127ec54f17a87ba752e;674e8e5dec54f17a87b6daa5;674e8fe6ec54f17a87b8db37;674e8e67ec54f17a87b6e831;674e8eb7ec54f17a87b74eda;674e8eb9ec54f17a87b751a3;674e8ff0ec54f17a87b8e74a;674e8fbeec54f17a87b8a857;674e90d1ec54f17a87ba2626;674e8f26ec54f17a87b7e51b",
          },
          {
            value: "sms",
            count: 46,
            keywordIds:
              "674e919aec54f17a87badf52;674e8fbeec54f17a87b8a832;674e90c2ec54f17a87ba16e5;674e8dc9ec54f17a87b634ef;674e8d0cec54f17a87b57ecc;674e8f10ec54f17a87b7c188;674e8e75ec54f17a87b6fab0;674e8dd6ec54f17a87b640b2;674e9064ec54f17a87b98a73;674e9128ec54f17a87ba7675;674e8dfcec54f17a87b66806;674e91edec54f17a87bb23b3;674e8fc1ec54f17a87b8aca5;674e911cec54f17a87ba6bf1;674e8e10ec54f17a87b67be4;674e9117ec54f17a87ba6792;674e8cfbec54f17a87b56dd3;674e9017ec54f17a87b915e1;674e8dc2ec54f17a87b62ee2;674e8d75ec54f17a87b5e652;674e8f2dec54f17a87b7ee53;674e9168ec54f17a87baaf82;674e8d4bec54f17a87b5be6c;674e8ff4ec54f17a87b8eced;674e8f85ec54f17a87b85fc7;674e8e66ec54f17a87b6e722;674e8f27ec54f17a87b7e5ea;674e9021ec54f17a87b9227d;674e8f70ec54f17a87b84312;674e90f0ec54f17a87ba43d0;674e8f2dec54f17a87b7ee92;674e8fdbec54f17a87b8cd51;674e90beec54f17a87ba120a;674e9054ec54f17a87b96b7f;674e8e15ec54f17a87b68155;674e8f93ec54f17a87b87217;674e8ee5ec54f17a87b78944;674e8efaec54f17a87b7a44e;674e8f36ec54f17a87b7fa47;674e90a4ec54f17a87b9ed22;674e909cec54f17a87b9e1e6;674e8ed5ec54f17a87b774d2",
          },
          {
            value: "http",
            count: 46,
            keywordIds:
              "674e904bec54f17a87b9578e;674e91c4ec54f17a87bb02b6;674e8d06ec54f17a87b579a7;674e9080ec54f17a87b9b82c;674e8fb0ec54f17a87b897da;674e8fd4ec54f17a87b8c59a;674e917fec54f17a87bac8b6;674e90b0ec54f17a87b9fd9a;674e8e4cec54f17a87b6b5d8;674e8f84ec54f17a87b85ddd;674e8ff8ec54f17a87b8f16b;674e8f88ec54f17a87b86363;674e8d20ec54f17a87b593ec;674e915eec54f17a87baa7ef;674e8ee1ec54f17a87b78428;674e8fa6ec54f17a87b88b12;674e91ddec54f17a87bb16ef;674e8ec1ec54f17a87b75b38;674e8fd7ec54f17a87b8c8b1;674e8dcdec54f17a87b639c8;674e8facec54f17a87b8920e;674e9041ec54f17a87b94abb;674e8da1ec54f17a87b610b8;674e8f57ec54f17a87b82475;674e909dec54f17a87b9e30f;674e8f43ec54f17a87b80b4f;674e9101ec54f17a87ba5461;674e8eb4ec54f17a87b74b02;674e8edcec54f17a87b77d71;674e8f1bec54f17a87b7cf6c;674e916cec54f17a87bab344;674e8d76ec54f17a87b5e701;674e8f8dec54f17a87b86a32;674e8f75ec54f17a87b84a3a;674e8decec54f17a87b6546b;674e8edaec54f17a87b77b3d;674e9036ec54f17a87b93d37;674e8e52ec54f17a87b6bc0a;674e9051ec54f17a87b965bc;674e8f74ec54f17a87b848aa;674e8f67ec54f17a87b838c7;674e9106ec54f17a87ba5928;674e913cec54f17a87ba87bc",
          },
          {
            value: "ip",
            count: 44,
            keywordIds:
              "674e8ef0ec54f17a87b7980d;674e8eadec54f17a87b74132;674e8d12ec54f17a87b5852a;674e9129ec54f17a87ba7788;674e8f78ec54f17a87b84d61;674e8f0eec54f17a87b7be52;674e8fbcec54f17a87b8a5f5;674e8f87ec54f17a87b8619e;674e9068ec54f17a87b98ffd;674e9015ec54f17a87b91476;674e9042ec54f17a87b94c8e;674e9121ec54f17a87ba6fb4;674e8e73ec54f17a87b6f7dd;674e8f83ec54f17a87b85cbc;674e916dec54f17a87bab40c;674e91f9ec54f17a87bb2cf3;674e907aec54f17a87b9af4d;674e9026ec54f17a87b92938;674e911aec54f17a87ba69de;674e9054ec54f17a87b96c43;674e8ef5ec54f17a87b79e9c;674e8f9fec54f17a87b88225;674e8cfeec54f17a87b5707f;674e91f3ec54f17a87bb2893;674e8ecbec54f17a87b767b2;674e8eeeec54f17a87b7956d;674e8e64ec54f17a87b6e52a;674e8f8eec54f17a87b86b06;674e8e9aec54f17a87b72a49;674e8e86ec54f17a87b71157;674e917aec54f17a87babf7f;674e8e0aec54f17a87b6762d;674e9114ec54f17a87ba6497;674e8fffec54f17a87b8f9db;674e8f4dec54f17a87b818e0;674e8f1aec54f17a87b7ce0d;674e9124ec54f17a87ba7273;674e8fc2ec54f17a87b8ae49;674e8e4eec54f17a87b6b857;674e8fa6ec54f17a87b88b7f;674e8d30ec54f17a87b5a3a5",
          },
          {
            value: "ib",
            count: 43,
            keywordIds:
              "674e901cec54f17a87b91d64;674e903eec54f17a87b94787;674e9066ec54f17a87b98d33;674e8f5fec54f17a87b82e81;674e8f9dec54f17a87b880f1;674e8e6bec54f17a87b6eeb1;674e8ef2ec54f17a87b79a58;674e8eb9ec54f17a87b7509c;674e918eec54f17a87bad559;674e91abec54f17a87baed78;674e90b3ec54f17a87ba01f8;674e90e1ec54f17a87ba35dc;674e906aec54f17a87b99448;674e9164ec54f17a87baacd6;674e8d1dec54f17a87b59114;674e91a6ec54f17a87bae96f;674e8e31ec54f17a87b69ca9;674e9157ec54f17a87baa223;674e9147ec54f17a87ba913a;674e8e14ec54f17a87b6803b;674e9093ec54f17a87b9d4b0;674e910bec54f17a87ba5d01;674e8eb2ec54f17a87b74922;674e8ea9ec54f17a87b73c51;674e8fa1ec54f17a87b884d4;674e8e6bec54f17a87b6ee21;674e8f96ec54f17a87b876f0;674e8f4cec54f17a87b816b2;674e8f1cec54f17a87b7d0c0;674e8ee8ec54f17a87b78c40;674e8ee1ec54f17a87b7844f;674e8e02ec54f17a87b66d51;674e913eec54f17a87ba89cf;674e8e0fec54f17a87b67ab5;674e8f17ec54f17a87b7ca6e;674e8dd9ec54f17a87b6434e;674e8f09ec54f17a87b7b764;674e8e70ec54f17a87b6f44e",
          },
          {
            value: "hex",
            count: 43,
            keywordIds:
              "674e903cec54f17a87b943d3;674e90c3ec54f17a87ba1767;674e90dfec54f17a87ba339f;674e8f63ec54f17a87b83353;674e8fa3ec54f17a87b88740;674e8ff3ec54f17a87b8ebb6;674e9046ec54f17a87b950bb;674e8e20ec54f17a87b68c52;674e919eec54f17a87bae231;674e8ebcec54f17a87b754d1;674e9203ec54f17a87bb3555;674e91aeec54f17a87baefec;674e8e86ec54f17a87b71049;674e8f1eec54f17a87b7d3ca;674e9056ec54f17a87b9706c;674e8dc3ec54f17a87b6306e;674e8f19ec54f17a87b7cd4c;674e8fc1ec54f17a87b8ac86;674e8f6bec54f17a87b83d69;674e9086ec54f17a87b9c128;674e8ec0ec54f17a87b75a9f;674e8d84ec54f17a87b5f57c;674e914bec54f17a87ba9476;674e9043ec54f17a87b94d14;674e8fe4ec54f17a87b8d8f2;674e905cec54f17a87b97c70;674e9024ec54f17a87b926c1;674e8f23ec54f17a87b7ddfc;674e916fec54f17a87bab5c3;674e8effec54f17a87b7aa20;674e8d79ec54f17a87b5ea68;674e903cec54f17a87b944df;674e8d45ec54f17a87b5b831;674e8f9fec54f17a87b8831e;674e8fc9ec54f17a87b8b830;674e90edec54f17a87ba4074;674e90a5ec54f17a87b9eefc",
          },
          {
            value: "vga",
            count: 42,
            keywordIds:
              "674e903aec54f17a87b9413b;674e8f4aec54f17a87b8142e;674e8f94ec54f17a87b87410;674e8edbec54f17a87b77be3;674e8fcdec54f17a87b8bcb3;674e9021ec54f17a87b922c8;674e9070ec54f17a87b99e88;674e907bec54f17a87b9b124;674e9027ec54f17a87b929f0;674e8fa8ec54f17a87b88de8;674e8f5cec54f17a87b82b4a;674e8ed1ec54f17a87b76fd2;674e8e94ec54f17a87b721fa;674e908bec54f17a87b9c9a9;674e8e7bec54f17a87b702e7;674e908cec54f17a87b9cb30;674e9073ec54f17a87b9a4a7;674e8e74ec54f17a87b6f8fa;674e8ee2ec54f17a87b7854d;674e911eec54f17a87ba6dd2;674e8eefec54f17a87b79669;674e8ec9ec54f17a87b7652e;674e8d95ec54f17a87b6056f;674e8dd2ec54f17a87b63d4d;674e9168ec54f17a87baafe7;674e8f13ec54f17a87b7c59d;674e8ff6ec54f17a87b8ef40;674e909eec54f17a87b9e3c4;674e8f46ec54f17a87b80f61;674e8f17ec54f17a87b7ca7a;674e8e55ec54f17a87b6beda;674e8e09ec54f17a87b674d4;674e8d79ec54f17a87b5eae2;674e8ee6ec54f17a87b78ab0;674e8f37ec54f17a87b7fb93;674e903cec54f17a87b94435;674e901eec54f17a87b91f9b;674e8e30ec54f17a87b69af3;674e8dcfec54f17a87b63b03",
          },
          {
            value: "jbod",
            count: 42,
            keywordIds:
              "674e9089ec54f17a87b9c609;674e904aec54f17a87b9567a;674e8fe2ec54f17a87b8d639;674e9004ec54f17a87b9001d;674e90c0ec54f17a87ba13e4;674e90dbec54f17a87ba2f92;674e8e35ec54f17a87b6a012;674e8f06ec54f17a87b7b340;674e8e07ec54f17a87b67339;674e8d87ec54f17a87b5f858;674e8f1eec54f17a87b7d49c;674e8e4bec54f17a87b6b558;674e9075ec54f17a87b9a81a;674e8d0aec54f17a87b57cfb;674e8f2fec54f17a87b7f14a;674e8d7eec54f17a87b5efe7;674e8d52ec54f17a87b5c4c2;674e8e5bec54f17a87b6d7f0;674e9018ec54f17a87b91772;674e909aec54f17a87b9df08;674e8d64ec54f17a87b5d578;674e8ee9ec54f17a87b78f2c;674e9094ec54f17a87b9d60d;674e8e94ec54f17a87b7221d;674e8e65ec54f17a87b6e66a;674e9030ec54f17a87b934f3;674e8eb4ec54f17a87b74b7d;674e8f94ec54f17a87b87467;674e913fec54f17a87ba8aed;674e8fb0ec54f17a87b89846;674e908bec54f17a87b9c951;674e906fec54f17a87b99d0b;674e8e63ec54f17a87b6e3bd;674e9047ec54f17a87b95226;674e91ecec54f17a87bb2307;674e8ee5ec54f17a87b788d1;674e8efaec54f17a87b7a4e7;674e9115ec54f17a87ba6600;674e9000ec54f17a87b8faeb",
          },
          {
            value: "xss",
            count: 42,
            keywordIds:
              "674e9081ec54f17a87b9b9fe;674e8f0eec54f17a87b7bea7;674e8fb4ec54f17a87b89cae;674e8f22ec54f17a87b7dace;674e8eacec54f17a87b7401a;674e8eaeec54f17a87b74317;674e8f3bec54f17a87b80054;674e90e7ec54f17a87ba3bb7;674e8fc6ec54f17a87b8b384;674e8fc4ec54f17a87b8afe2;674e9182ec54f17a87bacbb1;674e8fedec54f17a87b8e3e1;674e90b2ec54f17a87ba014a;674e900dec54f17a87b90aa3;674e9030ec54f17a87b93576;674e90cbec54f17a87ba1f95;674e8ffeec54f17a87b8f8a2;674e8d8bec54f17a87b5fba1;674e8d17ec54f17a87b58a05;674e8d8dec54f17a87b5fd5b;674e8f81ec54f17a87b85a41;674e903bec54f17a87b94300;674e8f6fec54f17a87b84234;674e90e4ec54f17a87ba386b;674e909aec54f17a87b9de3d;674e8e89ec54f17a87b71511;674e91adec54f17a87baeeea;674e90adec54f17a87b9f9db;674e8d91ec54f17a87b60156;674e8e1bec54f17a87b686b7;674e8eb1ec54f17a87b746de;674e91b2ec54f17a87baf37e;674e91e0ec54f17a87bb1930;674e8fb0ec54f17a87b897b7;674e8d98ec54f17a87b607ae;674e8f9aec54f17a87b87ba5;674e8defec54f17a87b656e9;674e8fb4ec54f17a87b89d3b;674e8f31ec54f17a87b7f3b2",
          },
          {
            value: "sql",
            count: 42,
            keywordIds:
              "674e8f68ec54f17a87b839bb;674e904fec54f17a87b95c75;674e8ff4ec54f17a87b8ebdf;674e8dbcec54f17a87b6290d;674e8f6eec54f17a87b8415c;674e8d61ec54f17a87b5d23e;674e917eec54f17a87bac832;674e8e5eec54f17a87b6dccc;674e90f9ec54f17a87ba4c46;674e9062ec54f17a87b98783;674e914aec54f17a87ba9380;674e8fc8ec54f17a87b8b5e9;674e8e17ec54f17a87b68352;674e90b9ec54f17a87ba0b56;674e8e87ec54f17a87b7118f;674e8d7dec54f17a87b5ef49;674e90ceec54f17a87ba229c;674e8ee0ec54f17a87b78313;674e8e42ec54f17a87b6abd9;674e9157ec54f17a87baa15f;674e8f4cec54f17a87b8164f;674e8d95ec54f17a87b604f3;674e8f6eec54f17a87b84134;674e904bec54f17a87b957bc;674e8f07ec54f17a87b7b4a6;674e8e59ec54f17a87b6d653;674e9006ec54f17a87b90278;674e8dbeec54f17a87b62bbd;674e914fec54f17a87ba99e6;674e8d0dec54f17a87b58064;674e8fbaec54f17a87b8a403;674e8fc4ec54f17a87b8b08f;674e8f01ec54f17a87b7ad80;674e91ceec54f17a87bb0afc;674e9009ec54f17a87b90506;674e8dceec54f17a87b63a45;674e9105ec54f17a87ba5828;674e90bdec54f17a87ba0fbd",
          },
          {
            value: "hdd",
            count: 42,
            keywordIds:
              "674e8e37ec54f17a87b6a23d;674e90b6ec54f17a87ba0692;674e8e97ec54f17a87b7260c;674e9094ec54f17a87b9d6d6;674e8eb0ec54f17a87b7459d;674e8eaeec54f17a87b7436c;674e8f81ec54f17a87b859c7;674e9013ec54f17a87b911e9;674e8d5fec54f17a87b5d0e3;674e8f3fec54f17a87b80609;674e8e44ec54f17a87b6adaf;674e915aec54f17a87baa49b;674e90a9ec54f17a87b9f430;674e9096ec54f17a87b9d8d8;674e8e04ec54f17a87b67001;674e902aec54f17a87b92e9e;674e8d56ec54f17a87b5c868;674e9165ec54f17a87baad35;674e915bec54f17a87baa52d;674e900cec54f17a87b9091b;674e918fec54f17a87bad69e;674e8f89ec54f17a87b86555;674e9090ec54f17a87b9d0c5;674e9018ec54f17a87b91735;674e8e82ec54f17a87b70c28;674e8cf6ec54f17a87b5698d;674e8d03ec54f17a87b575e6;674e90d8ec54f17a87ba2c4b;674e8e1aec54f17a87b68598;674e8f42ec54f17a87b809c2;674e901dec54f17a87b91ec8;674e8fafec54f17a87b896b1;674e8e38ec54f17a87b6a2d3;674e91ecec54f17a87bb22bb;674e8e7fec54f17a87b707de;674e8f26ec54f17a87b7e477;674e8eb1ec54f17a87b7477f;674e8e3aec54f17a87b6a4fe;674e909dec54f17a87b9e284;674e90eeec54f17a87ba4159",
          },
          {
            value: "dram",
            count: 42,
            keywordIds:
              "674e9099ec54f17a87b9dd9f;674e904cec54f17a87b959aa;674e8f57ec54f17a87b82538;674e8d59ec54f17a87b5cbc4;674e8fb2ec54f17a87b89a22;674e8f21ec54f17a87b7d906;674e8e85ec54f17a87b70edb;674e90afec54f17a87b9fcf0;674e8f9bec54f17a87b87d33;674e909fec54f17a87b9e520;674e8d55ec54f17a87b5c75a;674e8e19ec54f17a87b68504;674e8d7aec54f17a87b5ebb9;674e8f13ec54f17a87b7c499;674e8ffcec54f17a87b8f671;674e8fceec54f17a87b8be62;674e8f0cec54f17a87b7bc0f;674e8ef0ec54f17a87b79730;674e90d2ec54f17a87ba26d3;674e8e78ec54f17a87b6fee8;674e8f51ec54f17a87b81db5;674e8ff5ec54f17a87b8ee25;674e8f72ec54f17a87b8458d;674e91b7ec54f17a87baf87a;674e8d92ec54f17a87b601e8;674e8f16ec54f17a87b7c940;674e8f12ec54f17a87b7c351;674e8f9aec54f17a87b87b97;674e8edeec54f17a87b77ff7;674e8fc7ec54f17a87b8b57e;674e8e02ec54f17a87b66e05;674e9060ec54f17a87b9834d;674e8f41ec54f17a87b8083e;674e8e45ec54f17a87b6aeb6;674e8dc7ec54f17a87b633a3;674e8ed8ec54f17a87b777f2;674e8f1fec54f17a87b7d646;674e901bec54f17a87b91b97;674e8ff0ec54f17a87b8e6be",
          },
          {
            value: "utf8",
            count: 41,
            keywordIds:
              "674e901cec54f17a87b91cfb;674e8e13ec54f17a87b67f79;674e8ddbec54f17a87b644d3;674e8fa4ec54f17a87b88899;674e902eec54f17a87b9332f;674e8d5dec54f17a87b5ceb6;674e8d8eec54f17a87b5fe36;674e90aeec54f17a87b9fb92;674e903aec54f17a87b9421e;674e8fc5ec54f17a87b8b1f7;674e8d9eec54f17a87b60d1b;674e8f78ec54f17a87b84d7b;674e8f24ec54f17a87b7e188;674e8d34ec54f17a87b5a77b;674e8e87ec54f17a87b71240;674e8d54ec54f17a87b5c66e;674e8d8aec54f17a87b5fad3;674e8db9ec54f17a87b62771;674e9149ec54f17a87ba92b5;674e8f56ec54f17a87b822fd;674e8dcdec54f17a87b6393b;674e8f4dec54f17a87b817b9;674e8e7eec54f17a87b705d2;674e91cfec54f17a87bb0bc4;674e8ebbec54f17a87b753b6;674e9040ec54f17a87b94972;674e8f03ec54f17a87b7af6a;674e8ea2ec54f17a87b73364;674e9175ec54f17a87baba68;674e90b3ec54f17a87ba0170;674e8f56ec54f17a87b823ec;674e8f65ec54f17a87b836bd;674e9191ec54f17a87bad7b2;674e8d46ec54f17a87b5b923;674e8ebaec54f17a87b75237;674e8ed7ec54f17a87b776be;674e9079ec54f17a87b9ad35",
          },
          {
            value: "cli",
            count: 41,
            keywordIds:
              "674e9080ec54f17a87b9b8b7;674e8fb9ec54f17a87b8a352;674e91b4ec54f17a87baf5af;674e8d07ec54f17a87b57a18;674e8fc2ec54f17a87b8ae4c;674e8fddec54f17a87b8cf89;674e90bfec54f17a87ba12c2;674e9097ec54f17a87b9dab9;674e915aec54f17a87baa41f;674e9038ec54f17a87b93fdc;674e8e7aec54f17a87b70120;674e8f2cec54f17a87b7edae;674e8ffeec54f17a87b8f8c4;674e914aec54f17a87ba93d3;674e8e17ec54f17a87b683d2;674e8e72ec54f17a87b6f6fd;674e8efbec54f17a87b7a53c;674e91e2ec54f17a87bb1ae1;674e9085ec54f17a87b9c083;674e8f4cec54f17a87b81709;674e8f61ec54f17a87b8308f;674e90b2ec54f17a87ba0025;674e8ea0ec54f17a87b730ca;674e8f7bec54f17a87b851d7;674e8d4bec54f17a87b5bddf;674e8e5cec54f17a87b6d951;674e9056ec54f17a87b9705d;674e9084ec54f17a87b9bf25;674e8ddfec54f17a87b6488c;674e906bec54f17a87b9966c;674e9042ec54f17a87b94c83;674e9166ec54f17a87baae2d;674e8fafec54f17a87b896a0;674e8dcbec54f17a87b636b3;674e8f99ec54f17a87b87a48;674e90aaec54f17a87b9f5a4;674e8e24ec54f17a87b68f93",
          },
          {
            value: "adp",
            count: 41,
            keywordIds:
              "674e90c6ec54f17a87ba1aa4;674e913dec54f17a87ba8927;674e8dc8ec54f17a87b63458;674e91caec54f17a87bb07f7;674e91eaec54f17a87bb215b;674e90a6ec54f17a87b9f0df;674e8d6fec54f17a87b5e067;674e8f34ec54f17a87b7f6fd;674e91a8ec54f17a87baead8;674e8ebfec54f17a87b75857;674e9000ec54f17a87b8fa86;674e9079ec54f17a87b9ad80;674e8f91ec54f17a87b87035;674e8e34ec54f17a87b69f4c;674e8de9ec54f17a87b651c0;674e8d66ec54f17a87b5d6e5;674e90bcec54f17a87ba0f04;674e8f5bec54f17a87b82901;674e8f9cec54f17a87b87efa;674e8efaec54f17a87b7a47e;674e9036ec54f17a87b93c5b;674e8f89ec54f17a87b86450;674e90a8ec54f17a87b9f2cb;674e8d02ec54f17a87b57537;674e8dbaec54f17a87b6280c;674e8f32ec54f17a87b7f432;674e9001ec54f17a87b8fc72;674e90bcec54f17a87ba0e0c;674e8e62ec54f17a87b6e216;674e8d4eec54f17a87b5c0b6;674e9051ec54f17a87b966af;674e8fd1ec54f17a87b8c1fd;674e90beec54f17a87ba116c;674e8d39ec54f17a87b5ace0;674e8f43ec54f17a87b80b9c;674e8fdeec54f17a87b8d191;674e8e57ec54f17a87b6c077",
          },
          {
            value: "ram",
            count: 40,
            keywordIds:
              "674e8eecec54f17a87b79204;674e8f7fec54f17a87b85751;674e8eefec54f17a87b796ed;674e90dbec54f17a87ba302d;674e8eb5ec54f17a87b74c44;674e8e91ec54f17a87b71e88;674e8f2cec54f17a87b7ecd0;674e8d0fec54f17a87b58232;674e8e85ec54f17a87b70ed6;674e8d7bec54f17a87b5ecf4;674e8ed1ec54f17a87b76ef5;674e8e6eec54f17a87b6f1a6;674e8e9bec54f17a87b72b50;674e8f39ec54f17a87b7fec6;674e90faec54f17a87ba4d35;674e900dec54f17a87b90a32;674e8dacec54f17a87b61b13;674e8e87ec54f17a87b71295;674e8e8cec54f17a87b718ec;674e8f49ec54f17a87b81295;674e91fcec54f17a87bb2f1a;674e8e68ec54f17a87b6e9a3;674e8ff7ec54f17a87b8efb6;674e90bbec54f17a87ba0d45;674e913bec54f17a87ba86bc;674e8e61ec54f17a87b6e161;674e8f6aec54f17a87b83c00;674e9086ec54f17a87b9c24a;674e906eec54f17a87b99a5f;674e8d13ec54f17a87b58658;674e9049ec54f17a87b95492;674e91ffec54f17a87bb31d9;674e8e77ec54f17a87b6fd63;674e8ddcec54f17a87b64658;674e8edaec54f17a87b77a3e;674e8de1ec54f17a87b64af5;674e90b4ec54f17a87ba0309;674e8e49ec54f17a87b6b239",
          },
          {
            value: "ftp",
            count: 40,
            keywordIds:
              "674e903eec54f17a87b946b6;674e8f58ec54f17a87b825b0;674e8f1cec54f17a87b7d1bc;674e90a6ec54f17a87b9effd;674e90c0ec54f17a87ba1488;674e91c8ec54f17a87bb0684;674e8f60ec54f17a87b82fe7;674e9012ec54f17a87b910ab;674e8daeec54f17a87b61c67;674e9109ec54f17a87ba5b79;674e8e88ec54f17a87b712f5;674e9053ec54f17a87b9695e;674e9083ec54f17a87b9bcf7;674e8ec3ec54f17a87b75e3e;674e8ffdec54f17a87b8f6fd;674e8eccec54f17a87b768f5;674e8fe8ec54f17a87b8dcd6;674e91deec54f17a87bb17f8;674e902aec54f17a87b92e12;674e9046ec54f17a87b95137;674e91cdec54f17a87bb09e5;674e9070ec54f17a87b99f46;674e8efeec54f17a87b7a8e6;674e8ecfec54f17a87b76cd8;674e8f85ec54f17a87b85f20;674e91aeec54f17a87baef78;674e9023ec54f17a87b9254d;674e9022ec54f17a87b923a5;674e8e63ec54f17a87b6e337;674e9186ec54f17a87bacef2;674e90dcec54f17a87ba30ed;674e8f44ec54f17a87b80c45;674e8f14ec54f17a87b7c68b;674e8fd5ec54f17a87b8c74f;674e9116ec54f17a87ba66eb;674e912bec54f17a87ba7907;674e91e5ec54f17a87bb1d94",
          },
          {
            value: "sas",
            count: 40,
            keywordIds:
              "674e8f49ec54f17a87b812fa;674e9009ec54f17a87b9060c;674e8eaaec54f17a87b73e38;674e8f00ec54f17a87b7ac51;674e8d37ec54f17a87b5aa51;674e8e36ec54f17a87b6a113;674e8ff1ec54f17a87b8e915;674e8e76ec54f17a87b6fc6e;674e9189ec54f17a87bad1a0;674e8ef9ec54f17a87b7a2c1;674e8dd5ec54f17a87b63ff9;674e8da8ec54f17a87b616bd;674e9153ec54f17a87ba9c48;674e8e69ec54f17a87b6eb45;674e9170ec54f17a87bab656;674e8f91ec54f17a87b86f6f;674e9058ec54f17a87b97273;674e9018ec54f17a87b9180e;674e91feec54f17a87bb30f1;674e8e65ec54f17a87b6e676;674e904cec54f17a87b958c3;674e8db0ec54f17a87b61e81;674e903eec54f17a87b946c2;674e9004ec54f17a87b90024;674e8f1aec54f17a87b7cece;674e8f4eec54f17a87b8195e;674e8d3bec54f17a87b5ae29;674e8dbeec54f17a87b62b2d;674e9049ec54f17a87b95574;674e8f3dec54f17a87b803cb;674e9034ec54f17a87b93af6;674e8e8eec54f17a87b71b45;674e8fc7ec54f17a87b8b501;674e8f18ec54f17a87b7cb36;674e8eb2ec54f17a87b7492d;674e8fcaec54f17a87b8b91b",
          },
          {
            value: "api",
            count: 39,
            keywordIds:
              "674e8ec2ec54f17a87b75d1c;674e8e9eec54f17a87b72e76;674e905bec54f17a87b9793e;674e9002ec54f17a87b8fdb8;674e9179ec54f17a87babe4a;674e8d21ec54f17a87b59517;674e9044ec54f17a87b94e69;674e9059ec54f17a87b976d7;674e9098ec54f17a87b9dba4;674e8e96ec54f17a87b72483;674e8e03ec54f17a87b66f49;674e8f91ec54f17a87b86f54;674e8d08ec54f17a87b57b49;674e91b6ec54f17a87baf7af;674e9068ec54f17a87b990c5;674e8e70ec54f17a87b6f459;674e8df8ec54f17a87b661ba;674e905eec54f17a87b97fab;674e8dd8ec54f17a87b6429a;674e8f8bec54f17a87b867d9;674e9007ec54f17a87b9035c;674e8dbfec54f17a87b62c54;674e8ec2ec54f17a87b75d0e;674e8ffcec54f17a87b8f64b;674e8e5fec54f17a87b6de01;674e905eec54f17a87b97fd6;674e9143ec54f17a87ba8e29;674e9191ec54f17a87bad864;674e90d4ec54f17a87ba28a0;674e9175ec54f17a87babac5;674e8fbcec54f17a87b8a6bd;674e8f9bec54f17a87b87da7;674e8f4fec54f17a87b81b33;674e8d3cec54f17a87b5afa2;674e905bec54f17a87b97967;674e8f26ec54f17a87b7e52f",
          },
          {
            value: "css",
            count: 39,
            keywordIds:
              "674e8fb5ec54f17a87b89ea9;674e913dec54f17a87ba88ab;674e903fec54f17a87b9485f;674e9052ec54f17a87b9673f;674e8f3cec54f17a87b801f6;674e8fb1ec54f17a87b899a4;674e907fec54f17a87b9b7e1;674e9177ec54f17a87babcf5;674e8d7fec54f17a87b5f05b;674e8f5fec54f17a87b82de3;674e9012ec54f17a87b91128;674e910eec54f17a87ba5fb8;674e8f05ec54f17a87b7b2c0;674e8d6aec54f17a87b5dae2;674e900eec54f17a87b90b98;674e908dec54f17a87b9cbd9;674e8d44ec54f17a87b5b6e1;674e900bec54f17a87b907d6;674e8ef9ec54f17a87b7a309;674e918eec54f17a87bad5d9;674e8e83ec54f17a87b70db7;674e8d6eec54f17a87b5df2d;674e8f04ec54f17a87b7b0fc;674e8e5eec54f17a87b6dc25;674e8e8aec54f17a87b715be;674e9024ec54f17a87b92756;674e8f10ec54f17a87b7c0f8;674e8f13ec54f17a87b7c519;674e9169ec54f17a87bab0fe;674e8dddec54f17a87b6470c;674e8df0ec54f17a87b65745;674e8e8eec54f17a87b71aab;674e901fec54f17a87b9210d;674e91fdec54f17a87bb2ff3;674e8de4ec54f17a87b64c9c;674e905bec54f17a87b97ab3;674e90d0ec54f17a87ba24c8;674e90a4ec54f17a87b9ee26",
          },
          {
            value: "usb",
            count: 38,
            keywordIds:
              "674e8f0dec54f17a87b7bda6;674e8f62ec54f17a87b83209;674e91c6ec54f17a87bb044a;674e90a1ec54f17a87b9e927;674e8e4dec54f17a87b6b73c;674e8e7aec54f17a87b7006e;674e8ff5ec54f17a87b8edb7;674e8d7cec54f17a87b5ed90;674e9032ec54f17a87b93782;674e8d90ec54f17a87b600a2;674e9089ec54f17a87b9c5e1;674e8e2dec54f17a87b69800;674e8f08ec54f17a87b7b5d4;674e8e6fec54f17a87b6f36f;674e8e27ec54f17a87b692a7;674e90fdec54f17a87ba5009;674e8fcaec54f17a87b8b857;674e90cdec54f17a87ba218a;674e90afec54f17a87b9fce0;674e8fd4ec54f17a87b8c5a6;674e8f59ec54f17a87b82725;674e8d04ec54f17a87b577c6;674e91bcec54f17a87bafc26;674e902dec54f17a87b931c4;674e9092ec54f17a87b9d41a;674e8fadec54f17a87b89451;674e90b2ec54f17a87b9ffff;674e8ed4ec54f17a87b77218;674e8e80ec54f17a87b70939;674e919bec54f17a87bae096;674e8f5eec54f17a87b82d1d;674e906dec54f17a87b99927;674e9015ec54f17a87b913e7;674e8d57ec54f17a87b5c964;674e8fefec54f17a87b8e593",
          },
          {
            value: "ssd",
            count: 37,
            keywordIds:
              "674e8fe2ec54f17a87b8d645;674e8d6bec54f17a87b5db9d;674e8f25ec54f17a87b7e426;674e8fe2ec54f17a87b8d597;674e907bec54f17a87b9b1f5;674e90dfec54f17a87ba3420;674e8e51ec54f17a87b6bac1;674e9074ec54f17a87b9a681;674e90bbec54f17a87ba0d38;674e8f68ec54f17a87b8398a;674e8f40ec54f17a87b806a7;674e8f7aec54f17a87b8511c;674e8f5bec54f17a87b82a32;674e8f7bec54f17a87b85228;674e8fb2ec54f17a87b89a3c;674e8f77ec54f17a87b84bf7;674e8e7cec54f17a87b70347;674e8dd4ec54f17a87b63ed5;674e9019ec54f17a87b91a25;674e8d99ec54f17a87b60905;674e9001ec54f17a87b8fbac;674e8f7aec54f17a87b8513f;674e8f95ec54f17a87b874f2;674e8f20ec54f17a87b7d7b1;674e8f35ec54f17a87b7f8b7;674e90f1ec54f17a87ba44d8;674e8dd0ec54f17a87b63b86;674e8ee3ec54f17a87b7867f;674e8efeec54f17a87b7a8da;674e8f66ec54f17a87b837fe;674e8eadec54f17a87b741a8;674e9079ec54f17a87b9ae3b;674e8d18ec54f17a87b58c08;674e9160ec54f17a87baa988",
          },
          {
            value: "exe",
            count: 37,
            keywordIds:
              "674e8d4fec54f17a87b5c15e;674e8f7fec54f17a87b85843;674e9068ec54f17a87b9914f;674e90f7ec54f17a87ba49b6;674e8ef5ec54f17a87b79e57;674e8dbcec54f17a87b629a8;674e9030ec54f17a87b935b5;674e900aec54f17a87b906df;674e8fb8ec54f17a87b8a1bf;674e902eec54f17a87b93265;674e8f6dec54f17a87b83f8e;674e8d1eec54f17a87b591cd;674e8eb5ec54f17a87b74cc7;674e9070ec54f17a87b99f7e;674e91c5ec54f17a87bb0363;674e8f72ec54f17a87b84660;674e8f05ec54f17a87b7b1cd;674e8d94ec54f17a87b60391;674e91baec54f17a87bafaa3;674e9199ec54f17a87bade38;674e8f55ec54f17a87b82266;674e8efbec54f17a87b7a5d0;674e91e3ec54f17a87bb1c79;674e8f46ec54f17a87b80f81;674e911fec54f17a87ba6e90;674e8f51ec54f17a87b81d38;674e8fcfec54f17a87b8bf90;674e9010ec54f17a87b90ed8;674e8e14ec54f17a87b680a7;674e8ec4ec54f17a87b75f49;674e9141ec54f17a87ba8c4b;674e9091ec54f17a87b9d1e8;674e9155ec54f17a87ba9f21;674e8d73ec54f17a87b5e4de;674e8db6ec54f17a87b6239e;674e905fec54f17a87b98107;674e90abec54f17a87b9f7cb",
          },
          {
            value: "tcp",
            count: 37,
            keywordIds:
              "674e9010ec54f17a87b90f03;674e8fb5ec54f17a87b89e35;674e8fd6ec54f17a87b8c848;674e8fd5ec54f17a87b8c6a9;674e8fb3ec54f17a87b89b94;674e9180ec54f17a87bac9e1;674e8f4bec54f17a87b81535;674e8fadec54f17a87b8936f;674e908aec54f17a87b9c803;674e90d5ec54f17a87ba2a01;674e8d01ec54f17a87b573f2;674e8f72ec54f17a87b846b9;674e8cf8ec54f17a87b56b53;674e8ed4ec54f17a87b7734a;674e8f8dec54f17a87b86a88;674e8d86ec54f17a87b5f6d8;674e908bec54f17a87b9c880;674e902dec54f17a87b93118;674e8d48ec54f17a87b5bae9;674e8f2fec54f17a87b7f127;674e8fc6ec54f17a87b8b2ef;674e8f3dec54f17a87b803be;674e8eb0ec54f17a87b74579;674e8ff2ec54f17a87b8e9f5;674e8e50ec54f17a87b6b9b2;674e8e9aec54f17a87b72a36;674e8f3aec54f17a87b7ff58;674e8ddaec54f17a87b6442a;674e90b9ec54f17a87ba09d3;674e90d0ec54f17a87ba253b;674e8d89ec54f17a87b5fa01",
          },
          {
            value: "udp",
            count: 35,
            keywordIds:
              "674e919aec54f17a87badf0a;674e90b5ec54f17a87ba0526;674e8f45ec54f17a87b80d15;674e8d47ec54f17a87b5ba65;674e8f80ec54f17a87b85920;674e9043ec54f17a87b94d20;674e8fe0ec54f17a87b8d30a;674e8f42ec54f17a87b80a0d;674e8ffdec54f17a87b8f709;674e8de6ec54f17a87b64f80;674e90f3ec54f17a87ba463a;674e904dec54f17a87b95b17;674e8fe1ec54f17a87b8d4fc;674e8f53ec54f17a87b81f8f;674e8f7aec54f17a87b85023;674e8e9dec54f17a87b72d5e;674e9027ec54f17a87b92a57;674e9006ec54f17a87b901e9;674e8d6dec54f17a87b5dd58;674e901eec54f17a87b91f8f;674e8fd2ec54f17a87b8c2d9;674e8f15ec54f17a87b7c844;674e8e3eec54f17a87b6a847;674e9194ec54f17a87bada16;674e8dccec54f17a87b637d5;674e8f54ec54f17a87b82136;674e8e16ec54f17a87b6820e;674e8f40ec54f17a87b806e7;674e8d35ec54f17a87b5a862;674e8ebdec54f17a87b755db;674e8f20ec54f17a87b7d6c6",
          },
          {
            value: "scsi",
            count: 35,
            keywordIds:
              "674e8eebec54f17a87b79168;674e9154ec54f17a87ba9d2b;674e90b4ec54f17a87ba03dd;674e8f7fec54f17a87b8575d;674e9197ec54f17a87badcae;674e8fdaec54f17a87b8cc4d;674e8e50ec54f17a87b6ba58;674e8f1bec54f17a87b7d06a;674e91ebec54f17a87bb21ee;674e90adec54f17a87b9f8ec;674e91beec54f17a87bafe69;674e8d9eec54f17a87b60dbb;674e8eb5ec54f17a87b74bc4;674e9163ec54f17a87baabbd;674e9086ec54f17a87b9c1eb;674e8f2aec54f17a87b7e97f;674e8f73ec54f17a87b84826;674e90cfec54f17a87ba23bf;674e8fb6ec54f17a87b8a019;674e9176ec54f17a87babbc9;674e8d5bec54f17a87b5cd14;674e9126ec54f17a87ba7422;674e917dec54f17a87bac70c;674e915dec54f17a87baa68f;674e8ee4ec54f17a87b788a9;674e8ef7ec54f17a87b7a07c;674e912eec54f17a87ba7b50;674e903fec54f17a87b9480d;674e8e97ec54f17a87b725a1;674e906eec54f17a87b99c37;674e9033ec54f17a87b939bd;674e8ee5ec54f17a87b789ff;674e8f7cec54f17a87b85481",
          },
          {
            value: "pci",
            count: 35,
            keywordIds:
              "674e9011ec54f17a87b90fa4;674e8e83ec54f17a87b70d66;674e91b3ec54f17a87baf4fa;674e904aec54f17a87b956bc;674e901fec54f17a87b9214e;674e8e33ec54f17a87b69df0;674e8fecec54f17a87b8e272;674e9064ec54f17a87b98a79;674e8e2bec54f17a87b695d8;674e9179ec54f17a87babec6;674e8e8eec54f17a87b71a2b;674e8dacec54f17a87b61a6d;674e8ef3ec54f17a87b79b17;674e918bec54f17a87bad393;674e908fec54f17a87b9cf68;674e8db8ec54f17a87b6264a;674e8f9cec54f17a87b87f50;674e8ec6ec54f17a87b76150;674e8ebeec54f17a87b756f4;674e8fcfec54f17a87b8bf42;674e8e94ec54f17a87b722d8;674e902fec54f17a87b93439;674e8f90ec54f17a87b86d81;674e90d9ec54f17a87ba2d69;674e90aeec54f17a87b9fb7e;674e8fabec54f17a87b89152;674e8deeec54f17a87b65558;674e90deec54f17a87ba3236;674e8e6aec54f17a87b6ebdc;674e8ea4ec54f17a87b735b9;674e8f27ec54f17a87b7e5f5;674e91b5ec54f17a87baf6a0;674e9161ec54f17a87baaa4a;674e906eec54f17a87b99c46",
          },
          {
            value: "ssl",
            count: 34,
            keywordIds:
              "674e8e93ec54f17a87b7202a;674e90ffec54f17a87ba528c;674e8ff8ec54f17a87b8f158;674e90f5ec54f17a87ba4839;674e9029ec54f17a87b92d72;674e90feec54f17a87ba50ef;674e8e6dec54f17a87b6f088;674e9172ec54f17a87bab82a;674e8e98ec54f17a87b727b0;674e8f30ec54f17a87b7f28d;674e909bec54f17a87b9df83;674e8fc0ec54f17a87b8ab02;674e8f33ec54f17a87b7f64c;674e91c0ec54f17a87baff8e;674e8eedec54f17a87b79402;674e8e0bec54f17a87b67708;674e9078ec54f17a87b9ac25;674e8d49ec54f17a87b5bc2a;674e8dffec54f17a87b66a6e;674e8f8cec54f17a87b86930;674e8d81ec54f17a87b5f2f0;674e908dec54f17a87b9cce4;674e8ea2ec54f17a87b733a5;674e8f71ec54f17a87b84470;674e9092ec54f17a87b9d351;674e9012ec54f17a87b91098;674e907fec54f17a87b9b721;674e8d4cec54f17a87b5bf77;674e8d2eec54f17a87b5a283;674e90aaec54f17a87b9f62b",
          },
          {
            value: "smtp",
            count: 33,
            keywordIds:
              "674e8e0dec54f17a87b678e3;674e917bec54f17a87bac5bf;674e8ec9ec54f17a87b764f3;674e8d2dec54f17a87b5a1c4;674e8eccec54f17a87b768f2;674e9201ec54f17a87bb3351;674e91c1ec54f17a87bb0092;674e90e7ec54f17a87ba3b24;674e8ff1ec54f17a87b8e8b4;674e8f9cec54f17a87b87e44;674e8dc9ec54f17a87b63580;674e9076ec54f17a87b9a99d;674e8ffaec54f17a87b8f3eb;674e8fcdec54f17a87b8bc32;674e8f38ec54f17a87b7fd92;674e8f75ec54f17a87b84a92;674e8e95ec54f17a87b7242c;674e8fadec54f17a87b89445;674e8f14ec54f17a87b7c713;674e9056ec54f17a87b96f2a;674e8e68ec54f17a87b6ea4b;674e8f16ec54f17a87b7c954;674e8f7dec54f17a87b854de;674e90b1ec54f17a87b9fe97;674e8d25ec54f17a87b598d5;674e8db6ec54f17a87b6241d;674e8f0fec54f17a87b7c008;674e8ed0ec54f17a87b76e38;674e909eec54f17a87b9e476;674e8e61ec54f17a87b6e0e0;674e8d3cec54f17a87b5af17",
          },
          {
            value: "rss",
            count: 33,
            keywordIds:
              "674e910cec54f17a87ba5e4e;674e8e2eec54f17a87b69948;674e8f21ec54f17a87b7d81f;674e8febec54f17a87b8e156;674e9031ec54f17a87b93702;674e8e41ec54f17a87b6ab57;674e8ef1ec54f17a87b7992d;674e8ef1ec54f17a87b798a5;674e8ef5ec54f17a87b79df7;674e8f7cec54f17a87b8534d;674e8f2aec54f17a87b7e9ed;674e9073ec54f17a87b9a582;674e8d72ec54f17a87b5e26f;674e91a9ec54f17a87baebba;674e8ffcec54f17a87b8f58c;674e8f0dec54f17a87b7bcc5;674e8efcec54f17a87b7a692;674e8ec1ec54f17a87b75b5d;674e8da3ec54f17a87b61234;674e8ec7ec54f17a87b7628e;674e8e88ec54f17a87b71383;674e90a0ec54f17a87b9e756;674e8f62ec54f17a87b831d6;674e8fa1ec54f17a87b885af;674e8ff3ec54f17a87b8eaa5;674e8e3dec54f17a87b6a758;674e8e5cec54f17a87b6da3b;674e8f25ec54f17a87b7e2cf;674e8ecdec54f17a87b76a7a",
          },
          {
            value: "ascii",
            count: 32,
            keywordIds:
              "674e8d1cec54f17a87b58f8a;674e9173ec54f17a87bab8ec;674e8de7ec54f17a87b6506b;674e8feaec54f17a87b8df6b;674e91d4ec54f17a87bb0f3f;674e8ea8ec54f17a87b73c10;674e919fec54f17a87bae341;674e8d0eec54f17a87b581b5;674e9139ec54f17a87ba84c5;674e8cffec54f17a87b57298;674e8d2aec54f17a87b59e8c;674e8eb9ec54f17a87b75109;674e8f48ec54f17a87b811bf;674e8e64ec54f17a87b6e439;674e9087ec54f17a87b9c2f6;674e8f82ec54f17a87b85bb7;674e917dec54f17a87bac79d;674e8f09ec54f17a87b7b81e;674e8f7cec54f17a87b853df;674e90a3ec54f17a87b9ec69;674e8d26ec54f17a87b599e0;674e8eaaec54f17a87b73de8;674e8d42ec54f17a87b5b594;674e91d6ec54f17a87bb109b;674e8ea3ec54f17a87b73435;674e91efec54f17a87bb2555;674e8f89ec54f17a87b86544;674e90b3ec54f17a87ba0232;674e916bec54f17a87bab2e0;674e8eceec54f17a87b76b0f;674e8de0ec54f17a87b64a06;674e8fa1ec54f17a87b88530",
          },
          {
            value: "ai",
            count: 31,
            keywordIds:
              "674e8eeaec54f17a87b7902f;674e8f6cec54f17a87b83e52;674e8ec8ec54f17a87b76419;674e9071ec54f17a87b9a04b;674e8e98ec54f17a87b7270e;674e8febec54f17a87b8e1a9;674e8f8fec54f17a87b86d42;674e8d10ec54f17a87b5836d;674e9001ec54f17a87b8fc51;674e8ee8ec54f17a87b78d2e;674e8fbdec54f17a87b8a6ef;674e9050ec54f17a87b964db;674e8fd3ec54f17a87b8c3c5;674e90f4ec54f17a87ba4708;674e9069ec54f17a87b992f1;674e8e6fec54f17a87b6f2d2;674e91d9ec54f17a87bb1368;674e8ef8ec54f17a87b7a23e;674e8ed5ec54f17a87b774de;674e8fe6ec54f17a87b8da99;674e8ea3ec54f17a87b73434;674e910aec54f17a87ba5c8f;674e90c2ec54f17a87ba15fd;674e8d5eec54f17a87b5cf7f;674e8f29ec54f17a87b7e809;674e90b8ec54f17a87ba08c9;674e8f1fec54f17a87b7d511",
          },
          {
            value: "dns",
            count: 31,
            keywordIds:
              "674e8e6cec54f17a87b6ef04;674e8db4ec54f17a87b621fe;674e8f37ec54f17a87b7fb70;674e8f72ec54f17a87b8456a;674e8eddec54f17a87b77f46;674e8f32ec54f17a87b7f507;674e8ee3ec54f17a87b78660;674e8e1cec54f17a87b6889d;674e8de6ec54f17a87b64ed2;674e9085ec54f17a87b9c0b0;674e9032ec54f17a87b9389d;674e8f76ec54f17a87b84bae;674e8f64ec54f17a87b8353b;674e8e81ec54f17a87b70a84;674e8e92ec54f17a87b71fe8;674e8fefec54f17a87b8e63b;674e9035ec54f17a87b93b6c;674e8feaec54f17a87b8df2f;674e9025ec54f17a87b927ab;674e91eeec54f17a87bb24df;674e8eb7ec54f17a87b74eee;674e8d39ec54f17a87b5ac4a;674e8ec6ec54f17a87b76151;674e8fd5ec54f17a87b8c67a;674e8e28ec54f17a87b6938a;674e8e60ec54f17a87b6df65;674e8f36ec54f17a87b7fa08;674e8e49ec54f17a87b6b2ef",
          },
          {
            value: "png",
            count: 30,
            keywordIds:
              "674e9071ec54f17a87b9a136;674e903dec54f17a87b94535;674e8dd7ec54f17a87b641d3;674e8ea0ec54f17a87b731aa;674e91b9ec54f17a87baf9ef;674e8e12ec54f17a87b67dc3;674e91bfec54f17a87bafec4;674e8ff6ec54f17a87b8ee5c;674e9053ec54f17a87b969dd;674e8ed9ec54f17a87b778ef;674e91d8ec54f17a87bb129e;674e8d6aec54f17a87b5da63;674e8f18ec54f17a87b7cc7e;674e8fceec54f17a87b8be67;674e91a4ec54f17a87bae778;674e91daec54f17a87bb13d8;674e9026ec54f17a87b928a0;674e8d83ec54f17a87b5f4db;674e9130ec54f17a87ba7ddc;674e8e9cec54f17a87b72c9e;674e8ebfec54f17a87b7595f;674e8f65ec54f17a87b836b1;674e8ee7ec54f17a87b78b20;674e902eec54f17a87b93306;674e8ed4ec54f17a87b772a7;674e8fe7ec54f17a87b8dc99;674e8edfec54f17a87b781f7;674e8deaec54f17a87b65278;674e906cec54f17a87b997f7;674e90d9ec54f17a87ba2e01",
          },
          {
            value: "agp",
            count: 30,
            keywordIds:
              "674e8e90ec54f17a87b71cee;674e912aec54f17a87ba7885;674e8f3cec54f17a87b8022e;674e8eecec54f17a87b79283;674e8fa7ec54f17a87b88cd8;674e91afec54f17a87baf0bd;674e91d2ec54f17a87bb0e10;674e9065ec54f17a87b98b71;674e90ebec54f17a87ba3eb7;674e8dfbec54f17a87b6669b;674e8fb3ec54f17a87b89b58;674e8f3aec54f17a87b7ffaf;674e9198ec54f17a87baddcb;674e8eebec54f17a87b791aa;674e8fceec54f17a87b8bd80;674e8d9bec54f17a87b60b5c;674e8e9bec54f17a87b72b2a;674e9095ec54f17a87b9d770;674e8e90ec54f17a87b71ce3;674e9112ec54f17a87ba6385;674e9016ec54f17a87b915b2;674e8e81ec54f17a87b70a8f;674e91d5ec54f17a87bb101c;674e916aec54f17a87bab1ab;674e8f82ec54f17a87b85bc2;674e8ea5ec54f17a87b736e9;674e911bec54f17a87ba6a9d;674e8ed9ec54f17a87b779dc",
          },
          {
            value: "transmitting",
            count: 29,
            keywordIds:
              "674e8e97ec54f17a87b72572;674e91c3ec54f17a87bb0222;674e8fc2ec54f17a87b8ade9;674e8d3eec54f17a87b5b106;674e8f00ec54f17a87b7ab4e;674e8d36ec54f17a87b5aa13;674e9099ec54f17a87b9dc78;674e8cffec54f17a87b57232;674e9177ec54f17a87babc94;674e9102ec54f17a87ba558b;674e8db8ec54f17a87b625b9;674e9163ec54f17a87baab86;674e91d8ec54f17a87bb126e;674e8e7bec54f17a87b7027c;674e8d16ec54f17a87b58931;674e9057ec54f17a87b970f6;674e91fdec54f17a87bb3074;674e8dc1ec54f17a87b62df0;674e8f31ec54f17a87b7f365;674e8fa8ec54f17a87b88df3;674e8dafec54f17a87b61e1c;674e8ebbec54f17a87b7532b;674e8f2eec54f17a87b7eff7;674e9081ec54f17a87b9bae9;674e8f82ec54f17a87b85b38;674e8fc6ec54f17a87b8b3ef;674e8e23ec54f17a87b68f09;674e9038ec54f17a87b93ea6;674e8e4aec54f17a87b6b445",
          },
          {
            value: "gb",
            count: 28,
            keywordIds:
              "674e8ff6ec54f17a87b8ef3c;674e91bdec54f17a87bafd34;674e8d62ec54f17a87b5d2e7;674e8ef3ec54f17a87b79be3;674e909bec54f17a87b9e029;674e8d88ec54f17a87b5f8df;674e9002ec54f17a87b8fdbb;674e9093ec54f17a87b9d53a;674e8e25ec54f17a87b6905a;674e8e46ec54f17a87b6b05a;674e8ea1ec54f17a87b73278;674e91f0ec54f17a87bb2697;674e8e8bec54f17a87b716b3;674e9206ec54f17a87bb3709;674e90efec54f17a87ba424e;674e8f44ec54f17a87b80bfa;674e8f67ec54f17a87b8388d;674e9082ec54f17a87b9bb66;674e8d9fec54f17a87b60ee9;674e8fdaec54f17a87b8cc14;674e8d2cec54f17a87b5a005;674e9041ec54f17a87b94ae2;674e8fdeec54f17a87b8d0c7;674e8dfaec54f17a87b66523;674e8e57ec54f17a87b6c161;674e90c5ec54f17a87ba1977",
          },
          {
            value: "navigating",
            count: 24,
            keywordIds:
              "674e8e83ec54f17a87b70ceb;674e910cec54f17a87ba5e17;674e8d28ec54f17a87b59bd3;674e8fa3ec54f17a87b886fa;674e9030ec54f17a87b93629;674e8e66ec54f17a87b6e7e0;674e8e7dec54f17a87b70450;674e91b6ec54f17a87baf77c;674e8fc9ec54f17a87b8b7df;674e8e8cec54f17a87b71811;674e8e92ec54f17a87b71f75;674e8e9fec54f17a87b72fdd;674e8ee4ec54f17a87b7873a;674e8e83ec54f17a87b70d39;674e8e8fec54f17a87b71c91;674e9020ec54f17a87b9222f;674e9039ec54f17a87b94072;674e9155ec54f17a87ba9e56;674e9126ec54f17a87ba747c;674e8e4fec54f17a87b6b8ea;674e8f4bec54f17a87b815bb;674e90beec54f17a87ba115b;674e8ee2ec54f17a87b78580;674e8fa0ec54f17a87b88453",
          },
          {
            value: "calculating",
            count: 23,
            keywordIds:
              "674e91bdec54f17a87bafcfa;674e8f9eec54f17a87b88159;674e8f86ec54f17a87b86147;674e8e77ec54f17a87b6fd19;674e8e33ec54f17a87b69d9f;674e8f58ec54f17a87b82577;674e9203ec54f17a87bb34e1;674e8fd8ec54f17a87b8ca6b;674e90b1ec54f17a87b9ff16;674e8ffbec54f17a87b8f53b;674e8f16ec54f17a87b7c8ac;674e9112ec54f17a87ba62d5;674e8ed3ec54f17a87b771a6;674e919bec54f17a87bae03a;674e8d0dec54f17a87b57ffb;674e8f65ec54f17a87b835df;674e8f54ec54f17a87b820e7;674e8e78ec54f17a87b6ff0b;674e8e69ec54f17a87b6eafd;674e90e9ec54f17a87ba3d1e;674e8fbdec54f17a87b8a7a3",
          },
          {
            value: "quantifying",
            count: 23,
            keywordIds:
              "674e9004ec54f17a87b8ffae;674e9099ec54f17a87b9dce8;674e9196ec54f17a87badc01;674e9084ec54f17a87b9be6a;674e8e43ec54f17a87b6ad02;674e90f9ec54f17a87ba4bda;674e91d1ec54f17a87bb0d2d;674e8dc3ec54f17a87b62fca;674e8d15ec54f17a87b587a0;674e8f4aec54f17a87b81460;674e9028ec54f17a87b92b28;674e9025ec54f17a87b9285c;674e8fb6ec54f17a87b89fb5;674e8d9bec54f17a87b60ab1;674e906aec54f17a87b99381;674e91bbec54f17a87bafb9a;674e8ea9ec54f17a87b73d6e;674e8df6ec54f17a87b65d3c;674e8f89ec54f17a87b86416;674e90beec54f17a87ba1105;674e8fb4ec54f17a87b89cbb",
          },
          {
            value: "connecting",
            count: 22,
            keywordIds:
              "674e9063ec54f17a87b98957;674e8ea0ec54f17a87b73158;674e9067ec54f17a87b98f67;674e8e3fec54f17a87b6a977;674e8ff2ec54f17a87b8e965;674e8f1eec54f17a87b7d3bc;674e9109ec54f17a87ba5b42;674e8e1cec54f17a87b687bb;674e8f12ec54f17a87b7c366;674e8ef3ec54f17a87b79b8d;674e8f64ec54f17a87b834e7;674e905eec54f17a87b97ef2;674e8d52ec54f17a87b5c466;674e9148ec54f17a87ba922a;674e9034ec54f17a87b93b0a;674e8f53ec54f17a87b81f69;674e8e96ec54f17a87b724ed;674e8fafec54f17a87b89616;674e8e9aec54f17a87b728f7;674e8f24ec54f17a87b7e274;674e8e2fec54f17a87b699f1",
          },
          {
            value: "programming",
            count: 21,
            keywordIds:
              "674e907cec54f17a87b9b299;674e8f9dec54f17a87b88075;674e8f2aec54f17a87b7eaf2;674e8ff1ec54f17a87b8e80e;674e8e93ec54f17a87b7216f;674e8ea1ec54f17a87b731b6;674e9082ec54f17a87b9bbaa;674e8ec5ec54f17a87b76021;674e914cec54f17a87ba9578;674e8f75ec54f17a87b849d6;674e912eec54f17a87ba7c68;674e905dec54f17a87b97e92;674e902fec54f17a87b9348b;674e8faaec54f17a87b88f9c;674e8e3bec54f17a87b6a5b2;674e8eb6ec54f17a87b74dba;674e91cdec54f17a87bb0a79;674e8d56ec54f17a87b5c8d9;674e8f1fec54f17a87b7d51c;674e908dec54f17a87b9cc85",
          },
          {
            value: "indexing",
            count: 20,
            keywordIds:
              "674e8ec2ec54f17a87b75c81;674e9088ec54f17a87b9c462;674e905aec54f17a87b97839;674e8f93ec54f17a87b8736b;674e8e4cec54f17a87b6b651;674e8d5cec54f17a87b5cde1;674e8e8dec54f17a87b7196b;674e8e40ec54f17a87b6aaa3;674e904fec54f17a87b9628f;674e8fdcec54f17a87b8ceac;674e8f29ec54f17a87b7e8fa;674e8fe1ec54f17a87b8d471;674e8cf8ec54f17a87b56ae0;674e903bec54f17a87b9428a;674e8e9fec54f17a87b72f64;674e8d4cec54f17a87b5bf3a;674e91e8ec54f17a87bb1fe9;674e90aaec54f17a87b9f65e;674e901eec54f17a87b91f17",
          },
          {
            value: "synthesizing",
            count: 20,
            keywordIds:
              "674e8e2eec54f17a87b69892;674e8f92ec54f17a87b87101;674e8fc3ec54f17a87b8af6e;674e90a8ec54f17a87b9f345;674e8facec54f17a87b89319;674e8e8bec54f17a87b717ac;674e8f88ec54f17a87b862e3;674e8fcdec54f17a87b8bbd7;674e8f38ec54f17a87b7fdd0;674e8ee0ec54f17a87b78286;674e9070ec54f17a87b99e1b;674e8f42ec54f17a87b80944;674e9049ec54f17a87b9543b;674e9040ec54f17a87b949ec;674e9014ec54f17a87b91344;674e8e98ec54f17a87b72792;674e8dc7ec54f17a87b63317;674e90b8ec54f17a87ba0874;674e901aec54f17a87b91a87",
          },
          {
            value: "compressing",
            count: 17,
            keywordIds:
              "674e8d1bec54f17a87b58f3b;674e8d12ec54f17a87b5847c;674e8d22ec54f17a87b596ba;674e8f47ec54f17a87b810a1;674e9104ec54f17a87ba56dc;674e8e26ec54f17a87b691e8;674e8e31ec54f17a87b69c32;674e9082ec54f17a87b9bbe4;674e8da2ec54f17a87b611d9;674e8e09ec54f17a87b67564;674e90c1ec54f17a87ba1598;674e8f15ec54f17a87b7c750;674e8ec5ec54f17a87b7605c;674e8e7dec54f17a87b70532;674e901fec54f17a87b92029",
          },
          {
            value: "hacking",
            count: 17,
            keywordIds:
              "674e8e92ec54f17a87b71f26;674e8d0bec54f17a87b57e87;674e8f30ec54f17a87b7f1c4;674e8de2ec54f17a87b64bbc;674e90d5ec54f17a87ba299c;674e8fe7ec54f17a87b8dc54;674e9205ec54f17a87bb36a5;674e8fe5ec54f17a87b8d9d5;674e9122ec54f17a87ba70cc;674e8e5dec54f17a87b6dbd3;674e9006ec54f17a87b901f5;674e8ed7ec54f17a87b77722;674e8d9cec54f17a87b60bee;674e8d37ec54f17a87b5aae1;674e8f14ec54f17a87b7c5fd;674e8ecdec54f17a87b76a20;674e8fa6ec54f17a87b88a54",
          },
          {
            value: "copying",
            count: 17,
            keywordIds:
              "674e907bec54f17a87b9b170;674e900fec54f17a87b90d60;674e909fec54f17a87b9e607;674e918bec54f17a87bad30f;674e8ed1ec54f17a87b76f76;674e9074ec54f17a87b9a68d;674e9146ec54f17a87ba9041;674e8f2fec54f17a87b7f09a;674e8ebbec54f17a87b7535b;674e8d74ec54f17a87b5e590;674e8ee9ec54f17a87b78eb8;674e8fc5ec54f17a87b8b175;674e907eec54f17a87b9b654;674e8e62ec54f17a87b6e2e1;674e8f4fec54f17a87b81ab8;674e8e66ec54f17a87b6e759;674e9059ec54f17a87b97534",
          },
          {
            value: "backing",
            count: 16,
            keywordIds:
              "674e9039ec54f17a87b9404a;674e8e1dec54f17a87b6897f;674e8eb8ec54f17a87b74fb5;674e8fc1ec54f17a87b8ac3c;674e8d43ec54f17a87b5b694;674e915eec54f17a87baa7aa;674e907dec54f17a87b9b45c;674e8e86ec54f17a87b7106b;674e8e5bec54f17a87b6d864;674e8e94ec54f17a87b7218f;674e9057ec54f17a87b97200;674e8f5aec54f17a87b827b7;674e8f9bec54f17a87b87cd0;674e8ecdec54f17a87b76a46;674e8e76ec54f17a87b6fcae;674e8e39ec54f17a87b6a40c",
          },
          {
            value: "overriding",
            count: 16,
            keywordIds:
              "674e90f4ec54f17a87ba47a9;674e8eb8ec54f17a87b74f8f;674e8ff8ec54f17a87b8f0a8;674e8e46ec54f17a87b6afb8;674e9032ec54f17a87b937d9;674e8e71ec54f17a87b6f652;674e91d6ec54f17a87bb10ec;674e8e0fec54f17a87b67b30;674e8f6aec54f17a87b83c77;674e91e3ec54f17a87bb1c2c;674e90eeec54f17a87ba420d;674e8ec3ec54f17a87b75e72;674e8d19ec54f17a87b58d43;674e900eec54f17a87b90c16;674e91f1ec54f17a87bb2788;674e8f36ec54f17a87b7f972",
          },
          {
            value: "parsing",
            count: 16,
            keywordIds:
              "674e904cec54f17a87b9588d;674e8cfcec54f17a87b56f30;674e8fd3ec54f17a87b8c490;674e8ed8ec54f17a87b77891;674e8d08ec54f17a87b57afc;674e8eedec54f17a87b7938f;674e8d00ec54f17a87b57386;674e911bec54f17a87ba6b56;674e8eebec54f17a87b790c8;674e8eedec54f17a87b79446;674e8fabec54f17a87b89129;674e90aeec54f17a87b9fb04;674e8d2fec54f17a87b5a2f4;674e90c4ec54f17a87ba18b5",
          },
          {
            value: "generating",
            count: 15,
            keywordIds:
              "674e8e37ec54f17a87b6a19a;674e8f3bec54f17a87b80113;674e9003ec54f17a87b8fe89;674e9107ec54f17a87ba59e1;674e8fbfec54f17a87b8aa82;674e8eddec54f17a87b77e90;674e917fec54f17a87bac946;674e8f29ec54f17a87b7e8de;674e9029ec54f17a87b92c65;674e9007ec54f17a87b9033e;674e8edeec54f17a87b78080;674e8d40ec54f17a87b5b329;674e8f69ec54f17a87b83b44;674e9022ec54f17a87b924de;674e8f5eec54f17a87b82c97",
          },
          {
            value: "bypassing",
            count: 12,
            keywordIds:
              "674e8e6cec54f17a87b6f00e;674e8d46ec54f17a87b5b9ac;674e8fe8ec54f17a87b8dd67;674e9085ec54f17a87b9bfae;674e8d33ec54f17a87b5a732;674e8f82ec54f17a87b85b2b;674e8d53ec54f17a87b5c60a;674e904dec54f17a87b95a91;674e9026ec54f17a87b92961;674e9193ec54f17a87bad976;674e8f56ec54f17a87b82384;674e916eec54f17a87bab58d",
          },
        ],
        trend: [
          {
            date: "2024-08-05",
            dc: 1,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-08-06",
            dc: 1,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-08-07",
            dc: 0,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-08-08",
            dc: 3,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-08-09",
            dc: 1,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-08-10",
            dc: 2,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-08-11",
            dc: 1,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-08-12",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-08-13",
            dc: 1,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-08-14",
            dc: 1,
            tg: 2,
            keyword: "program",
          },
          {
            date: "2024-08-15",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-08-16",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-08-17",
            dc: 1,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-08-18",
            dc: 0,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-08-19",
            dc: 0,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-08-20",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-08-21",
            dc: 2,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-08-22",
            dc: 1,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-08-23",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-08-24",
            dc: 0,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-08-25",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-08-26",
            dc: 2,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-08-27",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-08-28",
            dc: 0,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-08-29",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-08-30",
            dc: 0,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-08-31",
            dc: 1,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-09-01",
            dc: 0,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-09-02",
            dc: 1,
            tg: 2,
            keyword: "program",
          },
          {
            date: "2024-09-03",
            dc: 0,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-09-04",
            dc: 0,
            tg: 2,
            keyword: "program",
          },
          {
            date: "2024-09-05",
            dc: 1,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-09-06",
            dc: 1,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-09-07",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-09-08",
            dc: 0,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-09-09",
            dc: 1,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-09-10",
            dc: 1,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-09-11",
            dc: 1,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-09-12",
            dc: 0,
            tg: 2,
            keyword: "program",
          },
          {
            date: "2024-09-13",
            dc: 1,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-09-14",
            dc: 0,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-09-15",
            dc: 1,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-09-16",
            dc: 1,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-09-17",
            dc: 1,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-09-18",
            dc: 0,
            tg: 2,
            keyword: "program",
          },
          {
            date: "2024-09-19",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-09-20",
            dc: 1,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-09-21",
            dc: 1,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-09-22",
            dc: 0,
            tg: 2,
            keyword: "program",
          },
          {
            date: "2024-09-23",
            dc: 0,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-09-24",
            dc: 2,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-09-25",
            dc: 0,
            tg: 2,
            keyword: "program",
          },
          {
            date: "2024-09-26",
            dc: 1,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-09-27",
            dc: 1,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-09-28",
            dc: 0,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-09-29",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-09-30",
            dc: 1,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-10-01",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-10-02",
            dc: 1,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-10-03",
            dc: 1,
            tg: 2,
            keyword: "program",
          },
          {
            date: "2024-10-04",
            dc: 0,
            tg: 2,
            keyword: "program",
          },
          {
            date: "2024-10-05",
            dc: 0,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-10-06",
            dc: 2,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-10-07",
            dc: 1,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-10-08",
            dc: 2,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-10-09",
            dc: 3,
            tg: 2,
            keyword: "program",
          },
          {
            date: "2024-10-10",
            dc: 0,
            tg: 2,
            keyword: "program",
          },
          {
            date: "2024-10-11",
            dc: 0,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-10-12",
            dc: 0,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-10-13",
            dc: 1,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-10-14",
            dc: 0,
            tg: 2,
            keyword: "program",
          },
          {
            date: "2024-10-15",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-10-16",
            dc: 1,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-10-17",
            dc: 1,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-10-18",
            dc: 0,
            tg: 2,
            keyword: "program",
          },
          {
            date: "2024-10-19",
            dc: 0,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-10-20",
            dc: 1,
            tg: 3,
            keyword: "program",
          },
          {
            date: "2024-10-21",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-10-22",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-10-23",
            dc: 3,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-10-24",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-10-25",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-10-26",
            dc: 2,
            tg: 2,
            keyword: "program",
          },
          {
            date: "2024-10-27",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-10-28",
            dc: 3,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-10-29",
            dc: 1,
            tg: 2,
            keyword: "program",
          },
          {
            date: "2024-10-30",
            dc: 2,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-10-31",
            dc: 0,
            tg: 3,
            keyword: "program",
          },
          {
            date: "2024-11-01",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-11-02",
            dc: 0,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-11-03",
            dc: 1,
            tg: 2,
            keyword: "program",
          },
          {
            date: "2024-11-04",
            dc: 1,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-11-05",
            dc: 2,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-11-06",
            dc: 0,
            tg: 3,
            keyword: "program",
          },
          {
            date: "2024-11-07",
            dc: 2,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-11-08",
            dc: 1,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-11-09",
            dc: 2,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-11-10",
            dc: 0,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-11-11",
            dc: 1,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-11-12",
            dc: 1,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-11-13",
            dc: 1,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-11-14",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-11-15",
            dc: 1,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-11-16",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-11-17",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-11-18",
            dc: 1,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-11-19",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-11-20",
            dc: 0,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-11-21",
            dc: 1,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-11-22",
            dc: 2,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-11-23",
            dc: 0,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-11-24",
            dc: 1,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-11-25",
            dc: 1,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-11-26",
            dc: 6,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-11-27",
            dc: 2,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-11-28",
            dc: 1,
            tg: 2,
            keyword: "program",
          },
          {
            date: "2024-11-29",
            dc: 1,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-11-30",
            dc: 0,
            tg: 1,
            keyword: "program",
          },
          {
            date: "2024-12-01",
            dc: 1,
            tg: 0,
            keyword: "program",
          },
          {
            date: "2024-12-02",
            dc: 0,
            tg: 1,
            keyword: "program",
          },
        ],
      },
    },
  },
  discord: {
    summary: {
      serverName: "unayung's dc",
      dataInfo: [
        {
          dataTitle: "New Participants",
          number: 4355,
          totalNumber: 5433,
          rate: 12,
          id: "newParticipants",
        },
        {
          dataTitle: "Engagements",
          number: 2160,
          rate: 8,
          id: "engagements",
        },
        {
          dataTitle: "Retention Rate",
          number: 0.22,
          rate: 10,
          id: "retentionRate",
        },
      ],
    },
    cohort: {
      data: {
        days: {
          "26-06-2024": [
            18, 11, 9, 8, 6, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "27-06-2024": [
            30, 19, 16, 13, 10, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "28-06-2024": [
            48, 31, 26, 21, 16, 12, 7, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "29-06-2024": [
            36, 23, 19, 16, 12, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "30-06-2024": [
            23, 14, 12, 10, 8, 5, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "01-07-2024": [
            27, 17, 14, 12, 9, 6, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "02-07-2024": [
            19, 12, 10, 8, 6, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0,
          ],
          "03-07-2024": [
            19, 12, 10, 8, 6, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0,
          ],
          "04-07-2024": [
            23, 14, 12, 10, 8, 5, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0,
          ],
          "05-07-2024": [
            44, 28, 24, 19, 15, 11, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0,
          ],
          "06-07-2024": [
            19, 12, 10, 8, 6, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0,
          ],
          "07-07-2024": [
            11, 7, 6, 4, 3, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0,
          ],
          "08-07-2024": [
            23, 14, 12, 10, 8, 5, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0,
          ],
          "09-07-2024": [
            30, 19, 16, 13, 10, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0,
          ],
          "10-07-2024": [
            47, 30, 25, 21, 16, 11, 7, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "11-07-2024": [
            38, 24, 20, 17, 13, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "12-07-2024": [
            43, 27, 23, 19, 15, 10, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "13-07-2024": [
            35, 22, 19, 15, 12, 8, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "14-07-2024": [
            24, 15, 13, 10, 8, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "15-07-2024": [
            16, 10, 8, 7, 5, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "16-07-2024": [
            47, 30, 25, 21, 16, 11, 7, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "17-07-2024": [
            41, 26, 22, 18, 14, 10, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "18-07-2024": [
            44, 28, 24, 19, 15, 11, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "19-07-2024": [
            11, 7, 6, 4, 3, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "20-07-2024": [
            26, 16, 14, 11, 9, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "21-07-2024": [
            16, 10, 8, 7, 5, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "22-07-2024": [
            36, 23, 19, 16, 12, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "23-07-2024": [
            48, 31, 26, 21, 16, 12, 7, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "24-07-2024": [
            32, 20, 17, 14, 11, 8, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "25-07-2024": [
            44, 28, 24, 19, 15, 11, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "26-07-2024": [
            19, 12, 10, 8, 6, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0,
          ],
          "27-07-2024": [
            36, 23, 19, 16, 12, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0,
          ],
          "28-07-2024": [
            26, 16, 14, 11, 9, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0,
          ],
          "29-07-2024": [
            22, 14, 12, 9, 7, 5, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0,
          ],
          "30-07-2024": [
            44, 28, 24, 19, 15, 11, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0,
          ],
          "31-07-2024": [
            36, 23, 19, 16, 12, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0,
          ],
          "01-08-2024": [
            42, 27, 23, 18, 14, 10, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0,
          ],
          "02-08-2024": [
            15, 9, 8, 6, 5, 3, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "03-08-2024": [
            24, 15, 13, 10, 8, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "04-08-2024": [
            13, 8, 7, 5, 4, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "05-08-2024": [
            31, 20, 17, 13, 10, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "06-08-2024": [
            39, 25, 21, 17, 13, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "07-08-2024": [
            37, 24, 20, 16, 12, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "08-08-2024": [
            40, 26, 22, 18, 14, 10, 6, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "09-08-2024": [
            36, 23, 19, 16, 12, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "10-08-2024": [
            15, 9, 8, 6, 5, 3, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "11-08-2024": [
            35, 22, 19, 15, 12, 8, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "12-08-2024": [
            38, 24, 20, 17, 13, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "13-08-2024": [
            12, 7, 6, 5, 4, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "14-08-2024": [
            20, 13, 11, 9, 7, 5, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "15-08-2024": [
            11, 7, 6, 4, 3, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "16-08-2024": [
            23, 14, 12, 10, 8, 5, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "17-08-2024": [
            34, 22, 18, 15, 11, 8, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "18-08-2024": [
            30, 19, 16, 13, 10, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0,
          ],
          "19-08-2024": [
            41, 26, 22, 18, 14, 10, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0,
          ],
          "20-08-2024": [
            25, 16, 13, 11, 8, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0,
          ],
          "21-08-2024": [
            25, 16, 13, 11, 8, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0,
          ],
          "22-08-2024": [
            45, 29, 24, 20, 15, 11, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0,
          ],
          "23-08-2024": [
            23, 14, 12, 10, 8, 5, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0,
          ],
          "24-08-2024": [
            50, 32, 27, 22, 17, 12, 7, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0,
          ],
          "25-08-2024": [
            27, 17, 14, 12, 9, 6, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "26-08-2024": [
            32, 20, 17, 14, 11, 8, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "27-08-2024": [
            26, 16, 14, 11, 9, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "28-08-2024": [
            12, 7, 6, 5, 4, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "29-08-2024": [
            11, 7, 6, 4, 3, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "30-08-2024": [
            45, 29, 24, 20, 15, 11, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "31-08-2024": [
            19, 12, 10, 8, 6, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "01-09-2024": [
            38, 24, 20, 17, 13, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "02-09-2024": [
            44, 28, 24, 19, 15, 11, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "03-09-2024": [
            21, 13, 11, 9, 7, 5, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "04-09-2024": [
            12, 7, 6, 5, 4, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "05-09-2024": [
            29, 18, 15, 13, 10, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "06-09-2024": [
            13, 8, 7, 5, 4, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "07-09-2024": [
            23, 14, 12, 10, 8, 5, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "08-09-2024": [
            42, 27, 23, 18, 14, 10, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "09-09-2024": [
            11, 7, 6, 4, 3, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0,
          ],
          "10-09-2024": [
            28, 18, 15, 12, 9, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0,
          ],
          "11-09-2024": [
            44, 28, 24, 19, 15, 11, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0,
          ],
          "12-09-2024": [
            45, 29, 24, 20, 15, 11, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0,
          ],
          "13-09-2024": [
            18, 11, 9, 8, 6, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0,
          ],
          "14-09-2024": [
            18, 11, 9, 8, 6, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0,
          ],
          "15-09-2024": [
            14, 9, 7, 6, 4, 3, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0,
          ],
          "16-09-2024": [
            48, 31, 26, 21, 16, 12, 7, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0,
          ],
          "17-09-2024": [
            48, 31, 26, 21, 16, 12, 7, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "18-09-2024": [
            22, 14, 12, 9, 7, 5, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "19-09-2024": [
            14, 9, 7, 6, 4, 3, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "20-09-2024": [
            35, 22, 19, 15, 12, 8, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "21-09-2024": [
            29, 18, 15, 13, 10, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "22-09-2024": [
            47, 30, 25, 21, 16, 11, 7, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "23-09-2024": [
            42, 27, 23, 18, 14, 10, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "24-09-2024": [
            34, 22, 18, 15, 11, 8, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "25-09-2024": [
            14, 9, 7, 6, 4, 3, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "26-09-2024": [
            19, 12, 10, 8, 6, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "27-09-2024": [
            34, 22, 18, 15, 11, 8, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "28-09-2024": [
            40, 26, 22, 18, 14, 10, 6, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "29-09-2024": [
            23, 14, 12, 10, 8, 5, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "30-09-2024": [
            12, 7, 6, 5, 4, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "01-10-2024": [
            38, 24, 20, 17, 13, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "02-10-2024": [
            45, 29, 24, 20, 15, 11, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "03-10-2024": [
            41, 26, 22, 18, 14, 10, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0,
          ],
          "04-10-2024": [
            14, 9, 7, 6, 4, 3, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0,
          ],
          "05-10-2024": [
            17, 11, 9, 7, 5, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0,
          ],
          "06-10-2024": [
            28, 18, 15, 12, 9, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0,
          ],
          "07-10-2024": [
            46, 29, 25, 20, 16, 11, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0,
          ],
          "08-10-2024": [
            41, 26, 22, 18, 14, 10, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0,
          ],
          "09-10-2024": [
            41, 26, 22, 18, 14, 10, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0,
          ],
          "10-10-2024": [
            19, 12, 10, 8, 6, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "11-10-2024": [
            27, 17, 14, 12, 9, 6, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "12-10-2024": [
            10, 6, 5, 4, 3, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "13-10-2024": [
            31, 20, 17, 13, 10, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "14-10-2024": [
            22, 14, 12, 9, 7, 5, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "15-10-2024": [
            22, 14, 12, 9, 7, 5, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "16-10-2024": [
            17, 11, 9, 7, 5, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "17-10-2024": [
            28, 18, 15, 12, 9, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "18-10-2024": [
            24, 15, 13, 10, 8, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "19-10-2024": [
            30, 19, 16, 13, 10, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "20-10-2024": [
            28, 18, 15, 12, 9, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "21-10-2024": [
            37, 24, 20, 16, 12, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "22-10-2024": [
            45, 29, 24, 20, 15, 11, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "23-10-2024": [
            31, 20, 17, 13, 10, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "24-10-2024": [
            41, 26, 22, 18, 14, 10, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "25-10-2024": [
            25, 16, 13, 11, 8, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "26-10-2024": [
            11, 7, 6, 4, 3, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0,
          ],
          "27-10-2024": [
            27, 17, 14, 12, 9, 6, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0,
          ],
          "28-10-2024": [
            20, 13, 11, 9, 7, 5, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0,
          ],
          "29-10-2024": [
            12, 7, 6, 5, 4, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0,
          ],
          "30-10-2024": [
            44, 28, 24, 19, 15, 11, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0,
          ],
          "31-10-2024": [
            26, 16, 14, 11, 9, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0,
          ],
          "01-11-2024": [
            11, 7, 6, 4, 3, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "02-11-2024": [
            26, 16, 14, 11, 9, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "03-11-2024": [
            18, 11, 9, 8, 6, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "04-11-2024": [
            46, 29, 25, 20, 16, 11, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "05-11-2024": [
            17, 11, 9, 7, 5, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "06-11-2024": [
            48, 31, 26, 21, 16, 12, 7, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "07-11-2024": [31, 20, 17, 13, 10, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0],
          "08-11-2024": [25, 16, 13, 11, 8, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0],
          "09-11-2024": [33, 21, 18, 14, 11, 8, 4, 1, 0, 0, 0, 0, 0, 0],
          "10-11-2024": [11, 7, 6, 4, 3, 2, 1, 0, 0, 0, 0, 0, 0],
          "11-11-2024": [45, 29, 24, 20, 15, 11, 6, 2, 0, 0, 0, 0],
          "12-11-2024": [17, 11, 9, 7, 5, 4, 2, 0, 0, 0, 0],
          "13-11-2024": [50, 32, 27, 22, 17, 12, 7, 2, 0, 0],
          "14-11-2024": [29, 18, 15, 13, 10, 7, 4, 1, 0],
          "15-11-2024": [24, 15, 13, 10, 8, 6, 3, 1],
          "16-11-2024": [18, 11, 9, 8, 6, 4, 2],
          "17-11-2024": [17, 11, 9, 7, 5, 4],
          "18-11-2024": [42, 27, 23, 18, 14],
          "19-11-2024": [15, 9, 8, 6],
          "20-11-2024": [36, 23, 19],
          "21-11-2024": [35, 22],
          "22-11-2024": [35],
        },
        weeks: {
          week1: [
            202, 91, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          week2: [
            197, 109, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          week3: [
            244, 128, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          week4: [213, 122, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          week5: [227, 120, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          week6: [201, 112, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          week7: [196, 92, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          week8: [189, 108, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          week9: [215, 97, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          week10: [190, 103, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          week11: [190, 108, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          week12: [213, 116, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          week13: [215, 120, 0, 0, 0, 0, 0, 0, 0, 0],
          week14: [211, 116, 0, 0, 0, 0, 0, 0, 0],
          week15: [228, 143, 0, 0, 0, 0, 0, 0],
          week16: [148, 78, 0, 0, 0, 0, 0],
          week17: [223, 129, 0, 0, 0, 0],
          week18: [180, 90, 0, 0, 0],
          week19: [192, 119, 0, 0],
          week20: [212, 117, 0],
          week21: [181, 84],
          week22: [70],
        },
        months: {
          month1: [946, 120, 0, 0, 0],
          month2: [876, 84, 0, 0],
          month3: [861, 90, 0],
          month4: [888, 92],
          month5: [629],
        },
      },
    },
    reactions: {
      data: [
        {
          date: "2024-07-25",
          count: 7,
        },
        {
          date: "2024-07-26",
          count: 7,
        },
        {
          date: "2024-07-27",
          count: 8,
        },
        {
          date: "2024-07-28",
          count: 11,
        },
        {
          date: "2024-07-29",
          count: 7,
        },
        {
          date: "2024-07-30",
          count: 8,
        },
        {
          date: "2024-07-31",
          count: 14,
        },
        {
          date: "2024-08-01",
          count: 5,
        },
        {
          date: "2024-08-02",
          count: 8,
        },
        {
          date: "2024-08-03",
          count: 8,
        },
        {
          date: "2024-08-04",
          count: 12,
        },
        {
          date: "2024-08-05",
          count: 6,
        },
        {
          date: "2024-08-06",
          count: 8,
        },
        {
          date: "2024-08-07",
          count: 8,
        },
        {
          date: "2024-08-08",
          count: 8,
        },
        {
          date: "2024-08-09",
          count: 14,
        },
        {
          date: "2024-08-10",
          count: 6,
        },
        {
          date: "2024-08-11",
          count: 11,
        },
        {
          date: "2024-08-12",
          count: 4,
        },
        {
          date: "2024-08-13",
          count: 8,
        },
        {
          date: "2024-08-14",
          count: 9,
        },
        {
          date: "2024-08-15",
          count: 5,
        },
        {
          date: "2024-08-16",
          count: 6,
        },
        {
          date: "2024-08-17",
          count: 10,
        },
        {
          date: "2024-08-18",
          count: 7,
        },
        {
          date: "2024-08-19",
          count: 8,
        },
        {
          date: "2024-08-20",
          count: 3,
        },
        {
          date: "2024-08-21",
          count: 5,
        },
        {
          date: "2024-08-22",
          count: 8,
        },
        {
          date: "2024-08-23",
          count: 6,
        },
        {
          date: "2024-08-24",
          count: 7,
        },
        {
          date: "2024-08-25",
          count: 10,
        },
        {
          date: "2024-08-26",
          count: 9,
        },
        {
          date: "2024-08-27",
          count: 8,
        },
        {
          date: "2024-08-28",
          count: 7,
        },
        {
          date: "2024-08-29",
          count: 7,
        },
        {
          date: "2024-08-30",
          count: 7,
        },
        {
          date: "2024-08-31",
          count: 6,
        },
        {
          date: "2024-09-01",
          count: 5,
        },
        {
          date: "2024-09-02",
          count: 9,
        },
        {
          date: "2024-09-03",
          count: 12,
        },
        {
          date: "2024-09-04",
          count: 4,
        },
        {
          date: "2024-09-05",
          count: 10,
        },
        {
          date: "2024-09-06",
          count: 9,
        },
        {
          date: "2024-09-07",
          count: 9,
        },
        {
          date: "2024-09-08",
          count: 5,
        },
        {
          date: "2024-09-09",
          count: 4,
        },
        {
          date: "2024-09-10",
          count: 6,
        },
        {
          date: "2024-09-11",
          count: 9,
        },
        {
          date: "2024-09-12",
          count: 8,
        },
        {
          date: "2024-09-13",
          count: 2,
        },
        {
          date: "2024-09-14",
          count: 7,
        },
        {
          date: "2024-09-15",
          count: 2,
        },
        {
          date: "2024-09-16",
          count: 10,
        },
        {
          date: "2024-09-17",
          count: 8,
        },
        {
          date: "2024-09-18",
          count: 6,
        },
        {
          date: "2024-09-19",
          count: 13,
        },
        {
          date: "2024-09-20",
          count: 11,
        },
        {
          date: "2024-09-21",
          count: 11,
        },
        {
          date: "2024-09-22",
          count: 3,
        },
        {
          date: "2024-09-23",
          count: 10,
        },
        {
          date: "2024-09-24",
          count: 10,
        },
        {
          date: "2024-09-25",
          count: 9,
        },
        {
          date: "2024-09-26",
          count: 7,
        },
        {
          date: "2024-09-27",
          count: 10,
        },
        {
          date: "2024-09-28",
          count: 9,
        },
        {
          date: "2024-09-29",
          count: 10,
        },
        {
          date: "2024-09-30",
          count: 7,
        },
        {
          date: "2024-10-01",
          count: 5,
        },
        {
          date: "2024-10-02",
          count: 11,
        },
        {
          date: "2024-10-03",
          count: 7,
        },
        {
          date: "2024-10-04",
          count: 10,
        },
        {
          date: "2024-10-05",
          count: 5,
        },
        {
          date: "2024-10-06",
          count: 13,
        },
        {
          date: "2024-10-07",
          count: 9,
        },
        {
          date: "2024-10-08",
          count: 5,
        },
        {
          date: "2024-10-09",
          count: 5,
        },
        {
          date: "2024-10-10",
          count: 9,
        },
        {
          date: "2024-10-11",
          count: 7,
        },
        {
          date: "2024-10-12",
          count: 16,
        },
        {
          date: "2024-10-13",
          count: 11,
        },
        {
          date: "2024-10-14",
          count: 10,
        },
        {
          date: "2024-10-15",
          count: 9,
        },
        {
          date: "2024-10-16",
          count: 9,
        },
        {
          date: "2024-10-17",
          count: 9,
        },
        {
          date: "2024-10-18",
          count: 9,
        },
        {
          date: "2024-10-19",
          count: 5,
        },
        {
          date: "2024-10-20",
          count: 12,
        },
        {
          date: "2024-10-21",
          count: 7,
        },
        {
          date: "2024-10-22",
          count: 14,
        },
        {
          date: "2024-10-23",
          count: 4,
        },
        {
          date: "2024-10-24",
          count: 7,
        },
        {
          date: "2024-10-25",
          count: 9,
        },
        {
          date: "2024-10-26",
          count: 9,
        },
        {
          date: "2024-10-27",
          count: 5,
        },
        {
          date: "2024-10-28",
          count: 12,
        },
        {
          date: "2024-10-29",
          count: 6,
        },
        {
          date: "2024-10-30",
          count: 6,
        },
        {
          date: "2024-10-31",
          count: 13,
        },
        {
          date: "2024-11-01",
          count: 4,
        },
        {
          date: "2024-11-02",
          count: 3,
        },
        {
          date: "2024-11-03",
          count: 8,
        },
        {
          date: "2024-11-04",
          count: 9,
        },
        {
          date: "2024-11-05",
          count: 9,
        },
        {
          date: "2024-11-06",
          count: 6,
        },
        {
          date: "2024-11-07",
          count: 8,
        },
        {
          date: "2024-11-08",
          count: 16,
        },
        {
          date: "2024-11-09",
          count: 3,
        },
        {
          date: "2024-11-10",
          count: 8,
        },
        {
          date: "2024-11-11",
          count: 7,
        },
        {
          date: "2024-11-12",
          count: 6,
        },
        {
          date: "2024-11-13",
          count: 9,
        },
        {
          date: "2024-11-14",
          count: 9,
        },
        {
          date: "2024-11-15",
          count: 8,
        },
        {
          date: "2024-11-16",
          count: 9,
        },
        {
          date: "2024-11-17",
          count: 11,
        },
        {
          date: "2024-11-18",
          count: 3,
        },
        {
          date: "2024-11-19",
          count: 8,
        },
        {
          date: "2024-11-20",
          count: 8,
        },
        {
          date: "2024-11-21",
          count: 8,
        },
        {
          date: "2024-11-22",
          count: 1,
        },
      ],
    },
    messages: {
      data: [
        {
          date: "2024-07-25",
          voices: 2,
          messages: 3,
        },
        {
          date: "2024-07-26",
          voices: 7,
          messages: 6,
        },
        {
          date: "2024-07-27",
          voices: 1,
          messages: 4,
        },
        {
          date: "2024-07-28",
          voices: 1,
          messages: 11,
        },
        {
          date: "2024-07-29",
          voices: 0,
          messages: 8,
        },
        {
          date: "2024-07-30",
          voices: 3,
          messages: 4,
        },
        {
          date: "2024-07-31",
          voices: 4,
          messages: 12,
        },
        {
          date: "2024-08-01",
          voices: 3,
          messages: 5,
        },
        {
          date: "2024-08-02",
          voices: 1,
          messages: 5,
        },
        {
          date: "2024-08-03",
          voices: 1,
          messages: 6,
        },
        {
          date: "2024-08-04",
          voices: 4,
          messages: 6,
        },
        {
          date: "2024-08-05",
          voices: 4,
          messages: 9,
        },
        {
          date: "2024-08-06",
          voices: 2,
          messages: 9,
        },
        {
          date: "2024-08-07",
          voices: 2,
          messages: 7,
        },
        {
          date: "2024-08-08",
          voices: 3,
          messages: 7,
        },
        {
          date: "2024-08-09",
          voices: 3,
          messages: 6,
        },
        {
          date: "2024-08-10",
          voices: 5,
          messages: 2,
        },
        {
          date: "2024-08-11",
          voices: 0,
          messages: 8,
        },
        {
          date: "2024-08-12",
          voices: 2,
          messages: 9,
        },
        {
          date: "2024-08-13",
          voices: 4,
          messages: 7,
        },
        {
          date: "2024-08-14",
          voices: 4,
          messages: 9,
        },
        {
          date: "2024-08-15",
          voices: 1,
          messages: 13,
        },
        {
          date: "2024-08-16",
          voices: 4,
          messages: 6,
        },
        {
          date: "2024-08-17",
          voices: 3,
          messages: 12,
        },
        {
          date: "2024-08-18",
          voices: 3,
          messages: 9,
        },
        {
          date: "2024-08-19",
          voices: 3,
          messages: 3,
        },
        {
          date: "2024-08-20",
          voices: 2,
          messages: 11,
        },
        {
          date: "2024-08-21",
          voices: 4,
          messages: 11,
        },
        {
          date: "2024-08-22",
          voices: 2,
          messages: 11,
        },
        {
          date: "2024-08-23",
          voices: 4,
          messages: 4,
        },
        {
          date: "2024-08-24",
          voices: 2,
          messages: 7,
        },
        {
          date: "2024-08-25",
          voices: 4,
          messages: 9,
        },
        {
          date: "2024-08-26",
          voices: 3,
          messages: 10,
        },
        {
          date: "2024-08-27",
          voices: 6,
          messages: 5,
        },
        {
          date: "2024-08-28",
          voices: 2,
          messages: 10,
        },
        {
          date: "2024-08-29",
          voices: 3,
          messages: 10,
        },
        {
          date: "2024-08-30",
          voices: 3,
          messages: 7,
        },
        {
          date: "2024-08-31",
          voices: 3,
          messages: 9,
        },
        {
          date: "2024-09-01",
          voices: 3,
          messages: 9,
        },
        {
          date: "2024-09-02",
          voices: 5,
          messages: 14,
        },
        {
          date: "2024-09-03",
          voices: 2,
          messages: 9,
        },
        {
          date: "2024-09-04",
          voices: 0,
          messages: 6,
        },
        {
          date: "2024-09-05",
          voices: 1,
          messages: 5,
        },
        {
          date: "2024-09-06",
          voices: 1,
          messages: 9,
        },
        {
          date: "2024-09-07",
          voices: 1,
          messages: 8,
        },
        {
          date: "2024-09-08",
          voices: 1,
          messages: 6,
        },
        {
          date: "2024-09-09",
          voices: 3,
          messages: 6,
        },
        {
          date: "2024-09-10",
          voices: 1,
          messages: 6,
        },
        {
          date: "2024-09-11",
          voices: 3,
          messages: 7,
        },
        {
          date: "2024-09-12",
          voices: 1,
          messages: 6,
        },
        {
          date: "2024-09-13",
          voices: 3,
          messages: 7,
        },
        {
          date: "2024-09-14",
          voices: 3,
          messages: 6,
        },
        {
          date: "2024-09-15",
          voices: 4,
          messages: 7,
        },
        {
          date: "2024-09-16",
          voices: 7,
          messages: 12,
        },
        {
          date: "2024-09-17",
          voices: 7,
          messages: 7,
        },
        {
          date: "2024-09-18",
          voices: 4,
          messages: 7,
        },
        {
          date: "2024-09-19",
          voices: 0,
          messages: 2,
        },
        {
          date: "2024-09-20",
          voices: 1,
          messages: 5,
        },
        {
          date: "2024-09-21",
          voices: 3,
          messages: 8,
        },
        {
          date: "2024-09-22",
          voices: 4,
          messages: 8,
        },
        {
          date: "2024-09-23",
          voices: 3,
          messages: 3,
        },
        {
          date: "2024-09-24",
          voices: 0,
          messages: 5,
        },
        {
          date: "2024-09-25",
          voices: 2,
          messages: 12,
        },
        {
          date: "2024-09-26",
          voices: 2,
          messages: 7,
        },
        {
          date: "2024-09-27",
          voices: 2,
          messages: 8,
        },
        {
          date: "2024-09-28",
          voices: 4,
          messages: 3,
        },
        {
          date: "2024-09-29",
          voices: 1,
          messages: 3,
        },
        {
          date: "2024-09-30",
          voices: 2,
          messages: 10,
        },
        {
          date: "2024-10-01",
          voices: 2,
          messages: 6,
        },
        {
          date: "2024-10-02",
          voices: 2,
          messages: 4,
        },
        {
          date: "2024-10-03",
          voices: 1,
          messages: 8,
        },
        {
          date: "2024-10-04",
          voices: 2,
          messages: 9,
        },
        {
          date: "2024-10-05",
          voices: 1,
          messages: 2,
        },
        {
          date: "2024-10-06",
          voices: 3,
          messages: 5,
        },
        {
          date: "2024-10-07",
          voices: 0,
          messages: 7,
        },
        {
          date: "2024-10-08",
          voices: 3,
          messages: 3,
        },
        {
          date: "2024-10-09",
          voices: 1,
          messages: 5,
        },
        {
          date: "2024-10-10",
          voices: 3,
          messages: 9,
        },
        {
          date: "2024-10-11",
          voices: 3,
          messages: 5,
        },
        {
          date: "2024-10-12",
          voices: 6,
          messages: 7,
        },
        {
          date: "2024-10-13",
          voices: 0,
          messages: 9,
        },
        {
          date: "2024-10-14",
          voices: 3,
          messages: 5,
        },
        {
          date: "2024-10-15",
          voices: 3,
          messages: 11,
        },
        {
          date: "2024-10-16",
          voices: 1,
          messages: 8,
        },
        {
          date: "2024-10-17",
          voices: 2,
          messages: 6,
        },
        {
          date: "2024-10-18",
          voices: 1,
          messages: 7,
        },
        {
          date: "2024-10-19",
          voices: 1,
          messages: 9,
        },
        {
          date: "2024-10-20",
          voices: 0,
          messages: 10,
        },
        {
          date: "2024-10-21",
          voices: 2,
          messages: 7,
        },
        {
          date: "2024-10-22",
          voices: 3,
          messages: 5,
        },
        {
          date: "2024-10-23",
          voices: 1,
          messages: 6,
        },
        {
          date: "2024-10-24",
          voices: 2,
          messages: 7,
        },
        {
          date: "2024-10-25",
          voices: 4,
          messages: 6,
        },
        {
          date: "2024-10-26",
          voices: 3,
          messages: 6,
        },
        {
          date: "2024-10-27",
          voices: 2,
          messages: 9,
        },
        {
          date: "2024-10-28",
          voices: 1,
          messages: 7,
        },
        {
          date: "2024-10-29",
          voices: 3,
          messages: 9,
        },
        {
          date: "2024-10-30",
          voices: 7,
          messages: 12,
        },
        {
          date: "2024-10-31",
          voices: 3,
          messages: 8,
        },
        {
          date: "2024-11-01",
          voices: 1,
          messages: 8,
        },
        {
          date: "2024-11-02",
          voices: 2,
          messages: 7,
        },
        {
          date: "2024-11-03",
          voices: 3,
          messages: 9,
        },
        {
          date: "2024-11-04",
          voices: 3,
          messages: 8,
        },
        {
          date: "2024-11-05",
          voices: 3,
          messages: 7,
        },
        {
          date: "2024-11-06",
          voices: 4,
          messages: 5,
        },
        {
          date: "2024-11-07",
          voices: 4,
          messages: 15,
        },
        {
          date: "2024-11-08",
          voices: 0,
          messages: 12,
        },
        {
          date: "2024-11-09",
          voices: 4,
          messages: 13,
        },
        {
          date: "2024-11-10",
          voices: 4,
          messages: 10,
        },
        {
          date: "2024-11-11",
          voices: 1,
          messages: 4,
        },
        {
          date: "2024-11-12",
          voices: 2,
          messages: 4,
        },
        {
          date: "2024-11-13",
          voices: 1,
          messages: 9,
        },
        {
          date: "2024-11-14",
          voices: 5,
          messages: 13,
        },
        {
          date: "2024-11-15",
          voices: 4,
          messages: 2,
        },
        {
          date: "2024-11-16",
          voices: 0,
          messages: 7,
        },
        {
          date: "2024-11-17",
          voices: 1,
          messages: 7,
        },
        {
          date: "2024-11-18",
          voices: 2,
          messages: 10,
        },
        {
          date: "2024-11-19",
          voices: 4,
          messages: 7,
        },
        {
          date: "2024-11-20",
          voices: 1,
          messages: 9,
        },
        {
          date: "2024-11-21",
          voices: 1,
          messages: 12,
        },
        {
          date: "2024-11-22",
          voices: 0,
          messages: 3,
        },
      ],
    },
    keywords: {
      data: {
        rank: [
          {
            keyword: "program",
            count: 93,
            variation: 1,
            keywordIds:
              "674011a740b8c6fe33c3f55b;6740108040b8c6fe33c31183;67400fcb40b8c6fe33c2644b;67400f5440b8c6fe33c20afd;6740101540b8c6fe33c2b54a;6740100640b8c6fe33c2a779;6740128a40b8c6fe33c4a38c;6740118140b8c6fe33c3d8e7;6740121640b8c6fe33c44798;6740114340b8c6fe33c3a978;674011d340b8c6fe33c41545;6740117640b8c6fe33c3d159;67400f7940b8c6fe33c225bc;6740113040b8c6fe33c39ba6;674010b240b8c6fe33c33a7a;6740108940b8c6fe33c3199d;674011db40b8c6fe33c41bce;674011b940b8c6fe33c402f3;674011c740b8c6fe33c40c92;6740101740b8c6fe33c2b671;6740117240b8c6fe33c3ce0e;674010d040b8c6fe33c35244;6740105840b8c6fe33c2efca;6740105940b8c6fe33c2f0c3;6740110740b8c6fe33c37cd8;6740103940b8c6fe33c2d525;6740122440b8c6fe33c451fd;674010bd40b8c6fe33c3432d;67400fa740b8c6fe33c2482b;674011a040b8c6fe33c3f02d;674010a640b8c6fe33c33106;67400f4c40b8c6fe33c2050d;674010ff40b8c6fe33c376bb;6740120f40b8c6fe33c4422f;6740119240b8c6fe33c3e5a3;67400f6640b8c6fe33c2186b;6740108d40b8c6fe33c31d5b;674011b440b8c6fe33c3ff5b;6740106b40b8c6fe33c2ff01;6740109440b8c6fe33c32238;6740103740b8c6fe33c2d31b;674010f140b8c6fe33c36c4c;67400f5240b8c6fe33c208fb;674010c540b8c6fe33c34988;67400fc940b8c6fe33c26253;6740112d40b8c6fe33c39903;6740114d40b8c6fe33c3b120;67400fa840b8c6fe33c248ed;674010de40b8c6fe33c35d89;6740124840b8c6fe33c47149;674010d340b8c6fe33c3546e;67400f5140b8c6fe33c2082c;6740126440b8c6fe33c48715;67400fe940b8c6fe33c28b9e;67400f9d40b8c6fe33c2411e;674011d140b8c6fe33c413e5;67400f5b40b8c6fe33c21084;6740112c40b8c6fe33c3982b;6740107c40b8c6fe33c30ebc;6740111c40b8c6fe33c38c91;6740125640b8c6fe33c47c38;6740104440b8c6fe33c2dd79;6740118640b8c6fe33c3dcd4;674010f040b8c6fe33c36b09;6740124340b8c6fe33c46cf9;674011b340b8c6fe33c3fe1b;67400f7640b8c6fe33c223c7;67400f5240b8c6fe33c20980;6740111440b8c6fe33c38648",
          },
          {
            keyword: "capacitor",
            count: 78,
            variation: -1,
            keywordIds:
              "6740108140b8c6fe33c31241;6740105f40b8c6fe33c2f5a5;6740113640b8c6fe33c3a05b;674011e140b8c6fe33c4208d;674010ba40b8c6fe33c340b9;6740117340b8c6fe33c3cee7;6740102940b8c6fe33c2c71b;6740103240b8c6fe33c2ce5f;6740104d40b8c6fe33c2e5b7;67400f9540b8c6fe33c23b06;674011d440b8c6fe33c41608;67400f4a40b8c6fe33c20348;67400f8740b8c6fe33c23071;6740112a40b8c6fe33c3971e;6740123740b8c6fe33c4623c;6740125b40b8c6fe33c4806d;674010d640b8c6fe33c356c0;6740128440b8c6fe33c49ecb;67400f6a40b8c6fe33c21af0;67400fb240b8c6fe33c250e3;674010ab40b8c6fe33c3350d;6740113740b8c6fe33c3a0d0;6740125a40b8c6fe33c47f00;6740109a40b8c6fe33c3278a;67400f6840b8c6fe33c2197b;67400f9340b8c6fe33c23966;67400fd640b8c6fe33c27195;67400f6940b8c6fe33c21a93;674011cc40b8c6fe33c41036;67400f8c40b8c6fe33c234c7;6740108740b8c6fe33c31837;67400fd740b8c6fe33c272dc;6740103640b8c6fe33c2d297;674010ec40b8c6fe33c367bb;6740116940b8c6fe33c3c7d8;674010c240b8c6fe33c34752;6740109840b8c6fe33c325a8;6740106640b8c6fe33c2fb0d;674010e840b8c6fe33c364a3;67400f3340b8c6fe33c1f17c;674011e440b8c6fe33c422c4;674011e040b8c6fe33c41f40;674010d740b8c6fe33c357ed;6740106840b8c6fe33c2fcac;6740112540b8c6fe33c39333;67400fbc40b8c6fe33c258c4;674011b140b8c6fe33c3fce1;67400f4b40b8c6fe33c203c1;6740104f40b8c6fe33c2e783;6740107240b8c6fe33c30506;6740106240b8c6fe33c2f7f4;674011ca40b8c6fe33c40f6f;6740113940b8c6fe33c3a246;6740111d40b8c6fe33c38cde;6740124540b8c6fe33c46f30;674011df40b8c6fe33c41e7b;674010b540b8c6fe33c33d20;6740101040b8c6fe33c2b066;674010fc40b8c6fe33c37433;67400fc340b8c6fe33c25d7a;6740100340b8c6fe33c2a433;674011bd40b8c6fe33c405b4;67400f5340b8c6fe33c209a0",
          },
          {
            keyword: "panel",
            count: 73,
            variation: 3,
            keywordIds:
              "67400fc640b8c6fe33c26032;6740108140b8c6fe33c311cd;67400ffd40b8c6fe33c29fb4;67400fec40b8c6fe33c28dd2;67400ff940b8c6fe33c29b26;6740102940b8c6fe33c2c6ca;6740123440b8c6fe33c46027;6740111f40b8c6fe33c38ea2;674010f540b8c6fe33c36f6c;6740110240b8c6fe33c37926;67400fca40b8c6fe33c2638b;6740121940b8c6fe33c449d3;674010b240b8c6fe33c33acb;6740113a40b8c6fe33c3a365;674010fb40b8c6fe33c373bc;674010cd40b8c6fe33c34f77;6740127740b8c6fe33c49558;674011da40b8c6fe33c41ae1;6740110640b8c6fe33c37c0e;674010af40b8c6fe33c33835;6740118840b8c6fe33c3ddca;6740118b40b8c6fe33c3e0bf;67400fa440b8c6fe33c2461e;67400fc440b8c6fe33c25e2e;6740125f40b8c6fe33c48337;67400fac40b8c6fe33c24c9c;674010d940b8c6fe33c3591b;67400fc940b8c6fe33c262bf;6740112d40b8c6fe33c398d7;6740118a40b8c6fe33c3dff6;6740103a40b8c6fe33c2d610;67400fa840b8c6fe33c24955;6740114c40b8c6fe33c3b091;674011fc40b8c6fe33c4346e;6740101140b8c6fe33c2b1a4;67400fb940b8c6fe33c256b4;6740103440b8c6fe33c2d12b;6740101a40b8c6fe33c2b9b4;674011ad40b8c6fe33c3f99b;67400fb440b8c6fe33c252b5;6740116640b8c6fe33c3c58e;6740102540b8c6fe33c2c3c7;67400f2840b8c6fe33c1e954;6740110d40b8c6fe33c3814d;674010a040b8c6fe33c32c41;674011b740b8c6fe33c401c9;674010f840b8c6fe33c371a7;674010c140b8c6fe33c346a7;67400f6340b8c6fe33c215e1;67400f6440b8c6fe33c216c0;6740100440b8c6fe33c2a55c;67400f5340b8c6fe33c20a46",
          },
          {
            keyword: "firewall",
            count: 71,
            variation: 4,
            keywordIds:
              "674011f440b8c6fe33c42eab;6740112740b8c6fe33c3945b;6740103e40b8c6fe33c2d8cf;67400f6040b8c6fe33c213fb;6740120340b8c6fe33c439b5;6740114f40b8c6fe33c3b2af;6740102d40b8c6fe33c2ca3d;67400fb140b8c6fe33c24fef;6740120940b8c6fe33c43db6;674011b640b8c6fe33c4013a;6740125c40b8c6fe33c480ec;6740106440b8c6fe33c2f91a;6740122540b8c6fe33c45321;67400f5740b8c6fe33c20cac;67400fdf40b8c6fe33c28015;6740114a40b8c6fe33c3af08;6740112040b8c6fe33c38f88;6740111c40b8c6fe33c38c52;6740105840b8c6fe33c2ef61;6740105a40b8c6fe33c2f113;674011a540b8c6fe33c3f350;6740101940b8c6fe33c2b87b;67400f4540b8c6fe33c1ff17;67400f4c40b8c6fe33c20493;67400f3840b8c6fe33c1f55a;6740115040b8c6fe33c3b392;6740108e40b8c6fe33c31d98;674010e340b8c6fe33c36107;67400fde40b8c6fe33c27d2e;674010d840b8c6fe33c358e9;67400fc740b8c6fe33c2611f;674010f140b8c6fe33c36b96;6740116040b8c6fe33c3c1b3;67400fdb40b8c6fe33c279b9;67400f8040b8c6fe33c22b81;67400fd140b8c6fe33c26987;674011b040b8c6fe33c3fc5d;67400fb840b8c6fe33c25623;674010d240b8c6fe33c35383;6740110e40b8c6fe33c381a8;6740116e40b8c6fe33c3cbb3;67400fbf40b8c6fe33c25b1c;67400fb540b8c6fe33c2535c;67400f6c40b8c6fe33c21ce9;674011b740b8c6fe33c401fb;6740127540b8c6fe33c49374;674010cf40b8c6fe33c35153;67400f9a40b8c6fe33c23e87;674010f940b8c6fe33c37267;674011b240b8c6fe33c3fe02;6740108f40b8c6fe33c31e7b;674011d840b8c6fe33c419ce;674011bb40b8c6fe33c4047d;6740113c40b8c6fe33c3a53c",
          },
          {
            keyword: "sensor",
            count: 65,
            variation: 2,
            keywordIds:
              "6740104240b8c6fe33c2dc01;6740108340b8c6fe33c3141b;6740126540b8c6fe33c487ee;6740121a40b8c6fe33c44a6e;67400faa40b8c6fe33c24ad2;67400ff640b8c6fe33c29907;6740120a40b8c6fe33c43e3b;6740119440b8c6fe33c3e723;674010be40b8c6fe33c34394;67400f8440b8c6fe33c22e08;67400f3140b8c6fe33c1efe3;6740113040b8c6fe33c39bf7;6740108a40b8c6fe33c31a81;6740104b40b8c6fe33c2e40e;6740119a40b8c6fe33c3ec00;6740107540b8c6fe33c307f9;674011c940b8c6fe33c40e20;674010d140b8c6fe33c352a6;674011e940b8c6fe33c426ba;6740105c40b8c6fe33c2f330;6740116a40b8c6fe33c3c88e;674011ee40b8c6fe33c42a9f;67400f4640b8c6fe33c1ffea;6740128d40b8c6fe33c4a74c;6740122f40b8c6fe33c45c5f;6740115440b8c6fe33c3b5c4;6740121f40b8c6fe33c44eba;674011d440b8c6fe33c4167b;67400fdd40b8c6fe33c27ca0;67400fad40b8c6fe33c24d22;6740109440b8c6fe33c322b8;6740103740b8c6fe33c2d383;67400f7b40b8c6fe33c2278d;674010c440b8c6fe33c34887;6740118b40b8c6fe33c3e060;674010df40b8c6fe33c35dba;674010e040b8c6fe33c35e8d;6740122940b8c6fe33c45604;674011f540b8c6fe33c42f8c;67400f9e40b8c6fe33c241a1;6740101440b8c6fe33c2b438;6740118040b8c6fe33c3d88b;6740111c40b8c6fe33c38ca8;67400f6b40b8c6fe33c21c68;674010f740b8c6fe33c370ca;674010c240b8c6fe33c346f0;6740111a40b8c6fe33c38af9;674010a340b8c6fe33c32e01;67400f8940b8c6fe33c231fe;674011d840b8c6fe33c41939;67400fa140b8c6fe33c243ab;6740101340b8c6fe33c2b31d",
          },
          {
            keyword: "alarm",
            count: 62,
            variation: 1,
            keywordIds:
              "6740104240b8c6fe33c2dc71;6740113540b8c6fe33c39f9c;6740111540b8c6fe33c38766;6740104740b8c6fe33c2e03f;67400f3e40b8c6fe33c1f9bc;67400f3140b8c6fe33c1f068;6740109040b8c6fe33c31f53;67400ff140b8c6fe33c293a5;67400fe040b8c6fe33c281e8;67400fa340b8c6fe33c24520;6740105640b8c6fe33c2ed45;67400fb340b8c6fe33c251dc;6740114540b8c6fe33c3ab5e;674010ca40b8c6fe33c34d0a;6740101740b8c6fe33c2b6d7;6740111840b8c6fe33c38925;6740105b40b8c6fe33c2f2a2;67400f3c40b8c6fe33c1f80b;674010da40b8c6fe33c35a0e;6740110040b8c6fe33c377f4;6740117c40b8c6fe33c3d524;674010ec40b8c6fe33c36842;6740108c40b8c6fe33c31c50;674011b540b8c6fe33c3ffb5;6740106b40b8c6fe33c2ffc3;6740109340b8c6fe33c3221d;67400f5240b8c6fe33c208e3;67400fcd40b8c6fe33c26595;6740101e40b8c6fe33c2bcc1;6740121d40b8c6fe33c44cac;6740128740b8c6fe33c4a0c4;67400fd940b8c6fe33c27680;6740124240b8c6fe33c46c19;67400f4e40b8c6fe33c20613;6740117140b8c6fe33c3cd98;67400f4140b8c6fe33c1fc29;6740119c40b8c6fe33c3ed3a;67400fe540b8c6fe33c2873b;6740100940b8c6fe33c2aa3d;674010b340b8c6fe33c33b5d;674010e640b8c6fe33c362ed;674010b540b8c6fe33c33c9d;6740124340b8c6fe33c46d41;67400f2b40b8c6fe33c1ebcf;67400f5940b8c6fe33c20eb4;6740128040b8c6fe33c49bab",
          },
          {
            keyword: "array",
            count: 59,
            variation: -2,
            keywordIds:
              "6740119940b8c6fe33c3eb16;67400ffb40b8c6fe33c29ce5;67400f7c40b8c6fe33c22834;67400ff740b8c6fe33c2995f;6740125540b8c6fe33c47ae5;67400f3540b8c6fe33c1f313;6740107a40b8c6fe33c30bc9;67400f9040b8c6fe33c23765;67400ff240b8c6fe33c294a5;67400f8640b8c6fe33c23031;67400fb140b8c6fe33c2506f;6740113040b8c6fe33c39b7f;6740116340b8c6fe33c3c37f;6740113740b8c6fe33c3a142;67400fdf40b8c6fe33c27f44;674011c940b8c6fe33c40e84;674011eb40b8c6fe33c4287d;674011e740b8c6fe33c42537;67400f3c40b8c6fe33c1f7da;6740103a40b8c6fe33c2d587;6740118840b8c6fe33c3de35;6740116140b8c6fe33c3c252;67400fd640b8c6fe33c27081;6740120540b8c6fe33c43b30;6740103640b8c6fe33c2d2b5;6740104f40b8c6fe33c2e7e3;67400f6240b8c6fe33c214d3;67400fef40b8c6fe33c291da;67400f3440b8c6fe33c1f2b8;67400fc040b8c6fe33c25bc1;6740113b40b8c6fe33c3a420;6740113440b8c6fe33c39f15;67400f4040b8c6fe33c1fbc8;6740108840b8c6fe33c318f8;674011cb40b8c6fe33c40ff4;6740120140b8c6fe33c43819;674010db40b8c6fe33c35b0b;6740104940b8c6fe33c2e1c8;6740117840b8c6fe33c3d2ce;6740123d40b8c6fe33c4673c;674011c340b8c6fe33c409ce;6740106940b8c6fe33c2fdbe;674011c840b8c6fe33c40de1;6740100540b8c6fe33c2a60e;6740111340b8c6fe33c385b2",
          },
          {
            keyword: "interface",
            count: 58,
            variation: -1,
            keywordIds:
              "674011f440b8c6fe33c42f1c;6740112640b8c6fe33c3943e;67400f5440b8c6fe33c20ad0;6740100640b8c6fe33c2a7da;6740125340b8c6fe33c47a0c;67400f3640b8c6fe33c1f40e;6740104840b8c6fe33c2e0c8;6740129240b8c6fe33c4abaf;67400f9140b8c6fe33c23831;6740118340b8c6fe33c3da56;67400f9640b8c6fe33c23bba;6740104c40b8c6fe33c2e4a6;6740122b40b8c6fe33c45802;6740102c40b8c6fe33c2c960;6740109940b8c6fe33c32729;674010d040b8c6fe33c3525d;674011eb40b8c6fe33c427d7;67400f7440b8c6fe33c22268;67400f4440b8c6fe33c1fefe;674010cc40b8c6fe33c34f12;6740114140b8c6fe33c3a891;67400fd540b8c6fe33c26fba;6740121040b8c6fe33c442ed;6740107f40b8c6fe33c3109d;674011d540b8c6fe33c41732;674010c340b8c6fe33c3480d;67400fa540b8c6fe33c246ef;674010d840b8c6fe33c358be;674010b740b8c6fe33c33e26;67400f3340b8c6fe33c1f163;6740104640b8c6fe33c2dfce;6740100040b8c6fe33c2a1c2;67400fd240b8c6fe33c26b75;67400fd040b8c6fe33c26898;674010f340b8c6fe33c36df3;6740117040b8c6fe33c3cd2c;67400f2740b8c6fe33c1e8f0;674010db40b8c6fe33c35ab7;6740129040b8c6fe33c4a9f1;6740124540b8c6fe33c46e7a;6740126040b8c6fe33c4842d;67400f9940b8c6fe33c23e1f;67400f8b40b8c6fe33c2339d;6740120740b8c6fe33c43c93",
          },
          {
            keyword: "monitor",
            count: 57,
            variation: 0,
            keywordIds:
              "6740122040b8c6fe33c44f7f;67400f7140b8c6fe33c2206f;6740121540b8c6fe33c4473e;6740102840b8c6fe33c2c69a;674011ac40b8c6fe33c3f8dd;67400f9540b8c6fe33c23a91;674010f640b8c6fe33c37058;67400f8e40b8c6fe33c235d3;674010e840b8c6fe33c36529;67400fa240b8c6fe33c244c9;67400fb240b8c6fe33c2512b;6740116c40b8c6fe33c3c9dc;674010ca40b8c6fe33c34d95;674011fe40b8c6fe33c43625;6740127c40b8c6fe33c49914;6740111840b8c6fe33c38980;6740117540b8c6fe33c3d0c0;6740105940b8c6fe33c2f0a8;674010cc40b8c6fe33c34eba;674011e240b8c6fe33c42120;6740117040b8c6fe33c3cc89;6740113e40b8c6fe33c3a676;6740120040b8c6fe33c43732;674011ef40b8c6fe33c42b4d;6740124040b8c6fe33c46ae5;6740112940b8c6fe33c39633;674010e740b8c6fe33c36454;67400fdb40b8c6fe33c278b8;6740112f40b8c6fe33c39ad9;6740107040b8c6fe33c303fe;6740113440b8c6fe33c39ec6;6740104e40b8c6fe33c2e6ca;6740128840b8c6fe33c4a1ae;6740102040b8c6fe33c2bfb6;67400fb440b8c6fe33c2524c;6740104040b8c6fe33c2dab4;674010d440b8c6fe33c35507;6740107d40b8c6fe33c30f7f;6740129140b8c6fe33c4aaba;67400f8140b8c6fe33c22c43;67400fbe40b8c6fe33c25a73;6740104340b8c6fe33c2dd14;6740126040b8c6fe33c48394;67400f3f40b8c6fe33c1fabd;6740101140b8c6fe33c2b0d7;6740100340b8c6fe33c2a4bd",
          },
          {
            keyword: "port",
            count: 55,
            variation: 3,
            keywordIds:
              "67400f4740b8c6fe33c20129;67400f6f40b8c6fe33c21ed0;67400ffa40b8c6fe33c29c7e;674010ba40b8c6fe33c34110;67400ffd40b8c6fe33c29f82;67400f7c40b8c6fe33c2284f;6740102f40b8c6fe33c2cbbb;6740112240b8c6fe33c390a2;6740117640b8c6fe33c3d13e;6740129240b8c6fe33c4ab15;6740112940b8c6fe33c3968b;6740113140b8c6fe33c39c47;6740111940b8c6fe33c38a07;6740107b40b8c6fe33c30de3;6740105940b8c6fe33c2f04b;6740111740b8c6fe33c388d7;674010fe40b8c6fe33c37627;6740126240b8c6fe33c48533;674010b940b8c6fe33c33fa5;6740113e40b8c6fe33c3a6ae;6740115c40b8c6fe33c3bbf0;674010fd40b8c6fe33c3753e;674010b640b8c6fe33c33ddc;6740101f40b8c6fe33c2bda9;6740100040b8c6fe33c2a21a;67400faf40b8c6fe33c24eec;674011fc40b8c6fe33c434c2;67400f5d40b8c6fe33c21175;6740102740b8c6fe33c2c5a5;6740107240b8c6fe33c30524;6740116640b8c6fe33c3c52a;6740106a40b8c6fe33c2fe43;6740108540b8c6fe33c315d1;67400f7540b8c6fe33c22353;674010c940b8c6fe33c34c80;6740118640b8c6fe33c3dc66;67400f2b40b8c6fe33c1ec26;67400fd940b8c6fe33c27545;6740102440b8c6fe33c2c23c;67400fb740b8c6fe33c2551c",
          },
          {
            keyword: "bandwidth",
            count: 54,
            variation: -4,
            keywordIds:
              "674010de40b8c6fe33c35cdf;6740115540b8c6fe33c3b659;6740122140b8c6fe33c44fdc;6740119640b8c6fe33c3e89f;67400f7d40b8c6fe33c228f5;6740106540b8c6fe33c2fa0c;6740123540b8c6fe33c46087;6740103140b8c6fe33c2cdf7;6740104d40b8c6fe33c2e619;6740109f40b8c6fe33c32b47;67400f7240b8c6fe33c22185;67400f6b40b8c6fe33c21bf2;67400f9640b8c6fe33c23bd5;6740114040b8c6fe33c3a751;67400fdf40b8c6fe33c27f93;6740107540b8c6fe33c307af;6740115640b8c6fe33c3b793;67400f2c40b8c6fe33c1ecd1;6740101b40b8c6fe33c2ba9c;67400fed40b8c6fe33c28fc1;67400fae40b8c6fe33c24e2a;67400fd740b8c6fe33c27311;6740120540b8c6fe33c43ab5;67400f6640b8c6fe33c217f7;674011ff40b8c6fe33c436b3;67400fab40b8c6fe33c24b6e;67400f6e40b8c6fe33c21e16;6740128b40b8c6fe33c4a416;674011e040b8c6fe33c41f7c;6740106340b8c6fe33c2f8d4;6740121c40b8c6fe33c44c50;67400fda40b8c6fe33c27774;6740110e40b8c6fe33c38228;6740121140b8c6fe33c4447f;67400f4f40b8c6fe33c2073b;6740101d40b8c6fe33c2bc09;6740110f40b8c6fe33c38357;6740108540b8c6fe33c31617;6740123e40b8c6fe33c46826;6740108240b8c6fe33c31330;67400f6440b8c6fe33c21661;674011b340b8c6fe33c3fe56;674011ea40b8c6fe33c426fc;67400fa140b8c6fe33c24427",
          },
          {
            keyword: "system",
            count: 54,
            variation: -2,
            keywordIds:
              "6740119940b8c6fe33c3eb69;67400ff340b8c6fe33c29647;674011d740b8c6fe33c418f4;674011ce40b8c6fe33c41215;6740107640b8c6fe33c30922;6740107440b8c6fe33c30692;6740111340b8c6fe33c38556;6740128a40b8c6fe33c4a374;6740100d40b8c6fe33c2ad55;67400fdd40b8c6fe33c27b84;674011d340b8c6fe33c415a9;674010f640b8c6fe33c36fea;67400fc140b8c6fe33c25c44;674010dc40b8c6fe33c35bf8;6740105d40b8c6fe33c2f448;67400f6a40b8c6fe33c21b37;674010c040b8c6fe33c345a9;6740112140b8c6fe33c39012;6740111b40b8c6fe33c38bcd;67400f8540b8c6fe33c22ec6;674010fe40b8c6fe33c3766f;67400fe840b8c6fe33c28a4f;67400fe640b8c6fe33c28828;674010a740b8c6fe33c3321a;67400f8c40b8c6fe33c234ab;67400f5e40b8c6fe33c2127c;6740103340b8c6fe33c2cfb4;6740116f40b8c6fe33c3cc2b;6740119140b8c6fe33c3e502;6740114840b8c6fe33c3ad6f;6740105040b8c6fe33c2e8c7;6740128b40b8c6fe33c4a4b9;6740106640b8c6fe33c2fb45;6740101e40b8c6fe33c2bd41;67400fd340b8c6fe33c26c26;674011fb40b8c6fe33c43399;6740124740b8c6fe33c4709e;6740123b40b8c6fe33c465d5;67400fbb40b8c6fe33c257dd;6740104140b8c6fe33c2db2f;674010ad40b8c6fe33c336f1;6740118040b8c6fe33c3d833;67400f3b40b8c6fe33c1f734;674010da40b8c6fe33c35a71;67400f7440b8c6fe33c222d7;674010b540b8c6fe33c33cd2;6740123e40b8c6fe33c468c7;6740106d40b8c6fe33c30131;67400fb740b8c6fe33c254be",
          },
          {
            keyword: "matrix",
            count: 54,
            variation: 5,
            keywordIds:
              "6740115540b8c6fe33c3b6d5;6740113640b8c6fe33c39fe4;6740107740b8c6fe33c3099a;6740124040b8c6fe33c46a05;67400f5f40b8c6fe33c21348;674011c640b8c6fe33c40bf0;6740114f40b8c6fe33c3b231;67400fdc40b8c6fe33c27b25;6740110540b8c6fe33c37bcd;67400ff240b8c6fe33c29415;674011d040b8c6fe33c41315;67400fcb40b8c6fe33c263c4;6740125c40b8c6fe33c48142;674010d640b8c6fe33c3571a;6740105640b8c6fe33c2edd1;6740125940b8c6fe33c47e84;674011fe40b8c6fe33c435ae;6740115640b8c6fe33c3b72c;6740115240b8c6fe33c3b4fd;67400fe740b8c6fe33c288a5;6740117c40b8c6fe33c3d577;6740121040b8c6fe33c44276;6740119140b8c6fe33c3e546;6740107e40b8c6fe33c31053;67400fab40b8c6fe33c24bd5;67400f6240b8c6fe33c21562;674011c040b8c6fe33c40849;674010c340b8c6fe33c347a4;6740119540b8c6fe33c3e7fb;6740112e40b8c6fe33c39a05;6740105540b8c6fe33c2ec9b;674010f440b8c6fe33c36e6f;6740124640b8c6fe33c46fe2;674011ad40b8c6fe33c3fa0a;67400f7d40b8c6fe33c2298d;674010e540b8c6fe33c36268;6740120140b8c6fe33c43879;6740118940b8c6fe33c3de8d;674010e640b8c6fe33c36371;6740114440b8c6fe33c3aabb;6740106c40b8c6fe33c30069;6740123c40b8c6fe33c4668e;6740128f40b8c6fe33c4a967;674011bc40b8c6fe33c4050f;6740113d40b8c6fe33c3a576;6740111440b8c6fe33c38617",
          },
          {
            keyword: "copy",
            count: 53,
            variation: 2,
            keywordIds:
              "6740104140b8c6fe33c2dbb4;67400fcb40b8c6fe33c26409;6740107340b8c6fe33c30646;6740106540b8c6fe33c2f9da;67400f5840b8c6fe33c20e03;674010be40b8c6fe33c34358;67400f9c40b8c6fe33c24003;67400f4940b8c6fe33c202cd;6740127b40b8c6fe33c4981a;6740121d40b8c6fe33c44d04;67400fcf40b8c6fe33c266d4;6740128440b8c6fe33c49ee2;67400f6740b8c6fe33c218ff;674011e840b8c6fe33c42617;6740111840b8c6fe33c388ed;67400f3c40b8c6fe33c1f7c1;6740114640b8c6fe33c3aba3;67400f2a40b8c6fe33c1eac1;6740114140b8c6fe33c3a8a9;6740117c40b8c6fe33c3d53b;6740116f40b8c6fe33c3cc43;6740115f40b8c6fe33c3be63;6740113e40b8c6fe33c3a68f;674010eb40b8c6fe33c36752;674011d440b8c6fe33c416ba;6740127a40b8c6fe33c49784;6740119540b8c6fe33c3e795;674011e340b8c6fe33c42169;674011df40b8c6fe33c41ecc;67400faf40b8c6fe33c24e8e;674011fc40b8c6fe33c43442;6740117e40b8c6fe33c3d6ec;67400fb840b8c6fe33c255a9;674010e040b8c6fe33c35eae;6740102040b8c6fe33c2bf6b;67400fbf40b8c6fe33c25aba;67400f3a40b8c6fe33c1f6d5;6740110d40b8c6fe33c38101;674011b740b8c6fe33c4018b;6740118640b8c6fe33c3dc87;67400f3f40b8c6fe33c1fa5a;6740101040b8c6fe33c2b004;6740101840b8c6fe33c2b728;6740128f40b8c6fe33c4a8a2;6740100340b8c6fe33c2a47d",
          },
          {
            keyword: "index",
            count: 53,
            variation: 2,
            keywordIds:
              "6740105240b8c6fe33c2e9e4;6740103d40b8c6fe33c2d84e;6740106d40b8c6fe33c30195;6740109a40b8c6fe33c3281c;67400f3540b8c6fe33c1f331;674010ea40b8c6fe33c366d7;67400fb040b8c6fe33c24fa0;6740125c40b8c6fe33c480b2;6740104b40b8c6fe33c2e3f0;6740110940b8c6fe33c37e21;6740127740b8c6fe33c49514;6740114a40b8c6fe33c3aec4;6740112740b8c6fe33c394fc;6740105840b8c6fe33c2effb;67400f8440b8c6fe33c22ea1;674011c440b8c6fe33c40ae3;67400f4840b8c6fe33c201dd;674011f140b8c6fe33c42c63;6740115e40b8c6fe33c3be01;6740121f40b8c6fe33c44e28;6740125f40b8c6fe33c482cb;67400f6140b8c6fe33c2149b;6740100140b8c6fe33c2a32f;67400fff40b8c6fe33c2a139;67400f9f40b8c6fe33c242a9;6740128640b8c6fe33c49fd7;67400fbc40b8c6fe33c258de;674010f340b8c6fe33c36e13;6740103440b8c6fe33c2d001;6740102740b8c6fe33c2c54f;6740126340b8c6fe33c4864c;674010ee40b8c6fe33c369a4;6740100840b8c6fe33c2a9a1;67400f9940b8c6fe33c23e4b;6740111a40b8c6fe33c38b27;6740115740b8c6fe33c3b85f;67400f2b40b8c6fe33c1ebfb;67400fc340b8c6fe33c25d9f;6740108e40b8c6fe33c31e09;6740102a40b8c6fe33c2c7aa;674011d840b8c6fe33c4196e;674011bc40b8c6fe33c404ef;6740100440b8c6fe33c2a5bc",
          },
          {
            keyword: "application",
            count: 53,
            variation: 3,
            keywordIds:
              "67400f6f40b8c6fe33c21f34;674010c740b8c6fe33c34b5c;6740111240b8c6fe33c384ee;6740103c40b8c6fe33c2d74f;6740103140b8c6fe33c2cddd;674010be40b8c6fe33c34408;67400f8440b8c6fe33c22e76;6740110540b8c6fe33c37b3f;6740102e40b8c6fe33c2cacd;674010ea40b8c6fe33c366bd;67400f8e40b8c6fe33c2364a;67400f8a40b8c6fe33c23314;6740105d40b8c6fe33c2f3b2;67400f5740b8c6fe33c20d1f;6740108a40b8c6fe33c31ad6;6740114a40b8c6fe33c3aea4;6740127040b8c6fe33c49006;6740114640b8c6fe33c3abd9;67400f2a40b8c6fe33c1eb35;674010a440b8c6fe33c32f4c;674010ec40b8c6fe33c367f4;674011f040b8c6fe33c42bb0;674010e440b8c6fe33c36181;67400f3440b8c6fe33c1f257;67400fc640b8c6fe33c2608c;674010f140b8c6fe33c36c21;6740114940b8c6fe33c3ae51;674010d740b8c6fe33c35765;6740117e40b8c6fe33c3d6c9;6740125840b8c6fe33c47dc7;6740100c40b8c6fe33c2acd8;6740126a40b8c6fe33c48bba;67400f5040b8c6fe33c207b9;6740123a40b8c6fe33c46512;67400f9e40b8c6fe33c24182;6740120b40b8c6fe33c43fad;6740110840b8c6fe33c37da7;6740117840b8c6fe33c3d24f;67400f9b40b8c6fe33c23f55;674010c140b8c6fe33c3468b;674010a340b8c6fe33c32e7e;6740110340b8c6fe33c37a4a;6740102440b8c6fe33c2c348;67400fe240b8c6fe33c28423",
          },
          {
            keyword: "bus",
            count: 53,
            variation: 1,
            keywordIds:
              "6740123f40b8c6fe33c4697e;67400fa940b8c6fe33c24a72;674010c640b8c6fe33c34a87;67400ff940b8c6fe33c29bb3;67400f7f40b8c6fe33c22a90;6740127e40b8c6fe33c499f2;674011ab40b8c6fe33c3f87d;67400fff40b8c6fe33c2a106;67400f8d40b8c6fe33c2358c;67400f9140b8c6fe33c23861;67400fca40b8c6fe33c26373;6740109c40b8c6fe33c32972;674011be40b8c6fe33c40621;6740110940b8c6fe33c37e6d;674010a940b8c6fe33c333e8;6740112040b8c6fe33c38f6d;6740107b40b8c6fe33c30d74;67400f9340b8c6fe33c239c5;6740101b40b8c6fe33c2ba7e;6740103940b8c6fe33c2d4bc;674010a440b8c6fe33c32efc;6740115d40b8c6fe33c3bd3f;674011cc40b8c6fe33c410b6;67400f8d40b8c6fe33c23523;67400f4640b8c6fe33c200a8;6740115f40b8c6fe33c3be35;67400f3840b8c6fe33c1f4e4;674011a240b8c6fe33c3f1e4;6740112d40b8c6fe33c39974;6740106740b8c6fe33c2fc2f;67400faf40b8c6fe33c24eab;674011f340b8c6fe33c42e33;67400f4f40b8c6fe33c20678;67400fe340b8c6fe33c28526;67400f4240b8c6fe33c1fd1f;6740105740b8c6fe33c2eea0;6740101c40b8c6fe33c2bb68;6740107c40b8c6fe33c30e9d;674011a440b8c6fe33c3f2ad;6740125640b8c6fe33c47c86;6740113340b8c6fe33c39e27;674010ef40b8c6fe33c36ac0;674010fc40b8c6fe33c374ac;67400fe240b8c6fe33c2837d;6740123a40b8c6fe33c4647f",
          },
          {
            keyword: "microchip",
            count: 52,
            variation: -3,
            keywordIds:
              "67400f4840b8c6fe33c20191;67400ff340b8c6fe33c29570;6740106040b8c6fe33c2f687;67400fec40b8c6fe33c28e12;6740108f40b8c6fe33c31f03;674011cf40b8c6fe33c412b5;67400f9140b8c6fe33c23815;6740118340b8c6fe33c3dac1;6740109c40b8c6fe33c32946;6740108940b8c6fe33c319f0;674010cd40b8c6fe33c34fdd;674010aa40b8c6fe33c3341c;674011a940b8c6fe33c3f67e;6740107b40b8c6fe33c30cfd;6740104540b8c6fe33c2de49;6740102340b8c6fe33c2c165;674010b940b8c6fe33c3403a;674010a540b8c6fe33c32fa1;67400f4840b8c6fe33c20214;6740118c40b8c6fe33c3e155;6740122040b8c6fe33c44f0d;674011ef40b8c6fe33c42ae7;674011d240b8c6fe33c41469;6740108b40b8c6fe33c31bb1;67400f9740b8c6fe33c23c78;6740119540b8c6fe33c3e77d;67400fa040b8c6fe33c24316;674010de40b8c6fe33c35d5c;67400f7f40b8c6fe33c22afc;6740124940b8c6fe33c471ab;6740119040b8c6fe33c3e41e;6740122940b8c6fe33c456cb;67400fbb40b8c6fe33c2584c;6740119e40b8c6fe33c3ee5a;6740103840b8c6fe33c2d479;6740110740b8c6fe33c37d5f;674010e440b8c6fe33c36209;6740115940b8c6fe33c3b925;6740100940b8c6fe33c2a9bc;6740104940b8c6fe33c2e251;6740100740b8c6fe33c2a8aa;674011b340b8c6fe33c3fec6;67400f7640b8c6fe33c2242c;674010b040b8c6fe33c338fc;6740111440b8c6fe33c38694",
          },
          {
            keyword: "back",
            count: 52,
            variation: -2,
            keywordIds:
              "674010dd40b8c6fe33c35cac;6740108340b8c6fe33c31435;6740115540b8c6fe33c3b676;6740126640b8c6fe33c48820;6740117340b8c6fe33c3cf12;6740111240b8c6fe33c384cd;6740102840b8c6fe33c2c630;6740123440b8c6fe33c46046;67400f3e40b8c6fe33c1f9ea;6740102d40b8c6fe33c2ca5b;674010ea40b8c6fe33c36686;67400fa240b8c6fe33c244e7;6740128540b8c6fe33c49f31;674010b740b8c6fe33c33e9d;674011a840b8c6fe33c3f5ca;6740107a40b8c6fe33c30cde;6740111840b8c6fe33c3894f;6740101b40b8c6fe33c2ba14;674010bd40b8c6fe33c342ac;674011e240b8c6fe33c420b5;6740115340b8c6fe33c3b545;67400f3440b8c6fe33c1f280;6740115c40b8c6fe33c3bc3a;6740123240b8c6fe33c45eac;674010c440b8c6fe33c34942;6740118a40b8c6fe33c3e012;67400fdb40b8c6fe33c27871;67400fa840b8c6fe33c2491a;6740105440b8c6fe33c2ebd2;67400fd040b8c6fe33c26863;6740124140b8c6fe33c46b1f;6740105740b8c6fe33c2ee4a;6740103840b8c6fe33c2d3ec;6740126640b8c6fe33c4888c;67400f8240b8c6fe33c22ca3;67400f6b40b8c6fe33c21c4e;6740119840b8c6fe33c3e9c9;6740114440b8c6fe33c3aa69;674010b440b8c6fe33c33c1f;6740102640b8c6fe33c2c4ae;6740101040b8c6fe33c2b0a1;674010f940b8c6fe33c37280;674011fa40b8c6fe33c432ad;67400f6540b8c6fe33c216ef;67400f5940b8c6fe33c20ece;6740121340b8c6fe33c44601;6740127840b8c6fe33c4960a;6740101340b8c6fe33c2b2a6",
          },
          {
            keyword: "card",
            count: 51,
            variation: -1,
            keywordIds:
              "674011a640b8c6fe33c3f4e2;67400f5540b8c6fe33c20b71;6740106e40b8c6fe33c30236;67400f7840b8c6fe33c2252e;6740121440b8c6fe33c446d2;6740118240b8c6fe33c3d9c4;6740127e40b8c6fe33c49a6b;67400f8740b8c6fe33c230c1;67400f7a40b8c6fe33c226b2;674010dc40b8c6fe33c35baf;674010d540b8c6fe33c3565e;6740128540b8c6fe33c49f17;674010e240b8c6fe33c3600a;67400fe740b8c6fe33c2899b;674011a540b8c6fe33c3f3cc;6740122440b8c6fe33c45231;674010a840b8c6fe33c33296;6740108740b8c6fe33c317bf;6740110040b8c6fe33c37751;6740124f40b8c6fe33c4765d;6740115f40b8c6fe33c3beae;67400f6640b8c6fe33c21810;674011d240b8c6fe33c41519;6740111640b8c6fe33c38810;6740104a40b8c6fe33c2e337;6740101f40b8c6fe33c2be3d;6740104640b8c6fe33c2df56;6740114d40b8c6fe33c3b16b;6740118c40b8c6fe33c3e1c4;67400fd540b8c6fe33c26e97;6740125240b8c6fe33c47934;67400ffc40b8c6fe33c29e1c;674010ef40b8c6fe33c36a3a;67400f4140b8c6fe33c1fc82;6740103040b8c6fe33c2ccb1;6740102640b8c6fe33c2c44f;6740106a40b8c6fe33c2fed9;67400fce40b8c6fe33c26691;6740104840b8c6fe33c2e194;6740104340b8c6fe33c2dccc;6740127540b8c6fe33c493ef;6740126a40b8c6fe33c48b2f;674011c240b8c6fe33c40988;6740106840b8c6fe33c2fd08;6740127940b8c6fe33c496b8;6740113c40b8c6fe33c3a511",
          },
          {
            keyword: "hack",
            count: 51,
            variation: 1,
            keywordIds:
              "674011f840b8c6fe33c431a5;6740112640b8c6fe33c393c9;6740118240b8c6fe33c3d977;6740104d40b8c6fe33c2e5d0;674011ab40b8c6fe33c3f832;6740108f40b8c6fe33c31ee6;67400f8d40b8c6fe33c23570;67400f8940b8c6fe33c23265;6740121b40b8c6fe33c44b3e;67400fb240b8c6fe33c250c5;674010ab40b8c6fe33c33539;674010cd40b8c6fe33c34fa1;674011eb40b8c6fe33c42817;6740125b40b8c6fe33c47fae;67400fe740b8c6fe33c2894d;674010ec40b8c6fe33c3687f;6740118b40b8c6fe33c3e0d7;6740103340b8c6fe33c2cef2;6740115340b8c6fe33c3b593;6740115b40b8c6fe33c3bad0;674011ef40b8c6fe33c42b02;674010e440b8c6fe33c36120;67400fdd40b8c6fe33c27c6f;6740112940b8c6fe33c395e8;674010d840b8c6fe33c3583f;67400f7b40b8c6fe33c2272f;67400fcc40b8c6fe33c264e6;67400fa840b8c6fe33c2498c;6740117f40b8c6fe33c3d74a;67400fd940b8c6fe33c276c8;67400fb440b8c6fe33c25265;6740102f40b8c6fe33c2cc02;674010d440b8c6fe33c35525;6740102540b8c6fe33c2c3a9;674010e440b8c6fe33c361cc;6740129040b8c6fe33c4aa1d;674010c840b8c6fe33c34c07;67400fa640b8c6fe33c2479f;67400f3940b8c6fe33c1f615;6740123d40b8c6fe33c467b6;6740123c40b8c6fe33c4666f;67400fbd40b8c6fe33c25977",
          },
          {
            keyword: "drive",
            count: 50,
            variation: 1,
            keywordIds:
              "6740108440b8c6fe33c314f8;67400f7040b8c6fe33c21fde;67400f4340b8c6fe33c1fdd6;674010c740b8c6fe33c34b2b;67400f3640b8c6fe33c1f391;6740112240b8c6fe33c390dd;674011ab40b8c6fe33c3f819;67400f9d40b8c6fe33c2407b;6740109e40b8c6fe33c32ae4;67400f2e40b8c6fe33c1ee33;67400f7940b8c6fe33c22638;674010e940b8c6fe33c365f0;6740113240b8c6fe33c39d04;6740128540b8c6fe33c49f97;6740113940b8c6fe33c3a2dc;674011ca40b8c6fe33c40f23;67400f8540b8c6fe33c22f24;6740104440b8c6fe33c2de01;6740105b40b8c6fe33c2f243;67400f4540b8c6fe33c1ff8d;674010bc40b8c6fe33c3428c;67400f4640b8c6fe33c20046;6740103240b8c6fe33c2ced7;6740122c40b8c6fe33c459a4;67400f9840b8c6fe33c23d95;674010e740b8c6fe33c36410;6740103540b8c6fe33c2d1bc;67400fe440b8c6fe33c2860f;6740119d40b8c6fe33c3edb2;674010ae40b8c6fe33c33782;6740115940b8c6fe33c3b9d1;6740118440b8c6fe33c3db7b;67400f8240b8c6fe33c22cdf;674010b440b8c6fe33c33bc9;6740105440b8c6fe33c2eb96;67400f8840b8c6fe33c2313c;6740122740b8c6fe33c454c9;6740100e40b8c6fe33c2aea4;674010b140b8c6fe33c33991;67400fb740b8c6fe33c25469;674011bd40b8c6fe33c40561",
          },
          {
            keyword: "hard",
            count: 50,
            variation: 2,
            keywordIds:
              "6740108440b8c6fe33c314d5;67400f7040b8c6fe33c21fb2;67400f4340b8c6fe33c1fdbb;674010c740b8c6fe33c34b11;67400f3540b8c6fe33c1f377;6740112240b8c6fe33c390bc;674011aa40b8c6fe33c3f800;67400f9c40b8c6fe33c2404d;6740109e40b8c6fe33c32acb;67400f2e40b8c6fe33c1ee0c;67400f7940b8c6fe33c2261f;674010e940b8c6fe33c365d9;6740113140b8c6fe33c39cd5;6740128540b8c6fe33c49f6b;6740113940b8c6fe33c3a2c6;674011ca40b8c6fe33c40ef4;67400f8540b8c6fe33c22f0a;6740104440b8c6fe33c2ddea;6740105b40b8c6fe33c2f21e;67400f4540b8c6fe33c1ff74;674010bc40b8c6fe33c34271;67400f4640b8c6fe33c20026;6740103240b8c6fe33c2cebe;6740122c40b8c6fe33c4597b;67400f9840b8c6fe33c23d40;674010e740b8c6fe33c363e4;6740103540b8c6fe33c2d1a1;67400fe440b8c6fe33c285ea;6740119c40b8c6fe33c3ed99;674010ae40b8c6fe33c3375d;6740115940b8c6fe33c3b9a3;6740118440b8c6fe33c3db64;67400f8240b8c6fe33c22cbf;674010b440b8c6fe33c33ba8;6740105340b8c6fe33c2eb67;67400f8840b8c6fe33c23126;6740122740b8c6fe33c4549e;6740100e40b8c6fe33c2ae73;674010b140b8c6fe33c33976;67400fb640b8c6fe33c25446;674011bc40b8c6fe33c40544",
          },
          {
            keyword: "transmitter",
            count: 50,
            variation: 2,
            keywordIds:
              "674011f440b8c6fe33c42ed7;6740105f40b8c6fe33c2f5ee;6740103d40b8c6fe33c2d835;67400f6040b8c6fe33c2139d;6740100d40b8c6fe33c2ae25;67400fcf40b8c6fe33c26727;6740123740b8c6fe33c4627d;6740116440b8c6fe33c3c3e2;6740117a40b8c6fe33c3d410;6740113f40b8c6fe33c3a722;6740125e40b8c6fe33c48230;67400f6840b8c6fe33c219c9;6740104540b8c6fe33c2deb2;6740105a40b8c6fe33c2f189;6740101940b8c6fe33c2b7bc;6740106f40b8c6fe33c30369;67400f2940b8c6fe33c1ea9f;6740102240b8c6fe33c2c0d6;6740115340b8c6fe33c3b579;6740115b40b8c6fe33c3bae8;674010fd40b8c6fe33c375ab;6740100140b8c6fe33c2a30e;6740103f40b8c6fe33c2d95e;67400fcd40b8c6fe33c26544;6740106240b8c6fe33c2f83e;67400fd240b8c6fe33c26b9f;67400fa940b8c6fe33c249c4;67400f5640b8c6fe33c20c35;6740105440b8c6fe33c2ec10;674011f240b8c6fe33c42dac;6740124140b8c6fe33c46b94;67400f4b40b8c6fe33c20437;6740121740b8c6fe33c448a9;67400fba40b8c6fe33c2578d;6740103040b8c6fe33c2cc3e;674010ad40b8c6fe33c3370b;6740119840b8c6fe33c3ea2b;67400f3a40b8c6fe33c1f651;6740111b40b8c6fe33c38b59;6740101840b8c6fe33c2b761;67400fc340b8c6fe33c25dd5;67400f5a40b8c6fe33c20f14;6740127940b8c6fe33c4964e",
          },
          {
            keyword: "open-source",
            count: 50,
            variation: 3,
            keywordIds:
              "6740115540b8c6fe33c3b6b6;6740109a40b8c6fe33c327c6;674010c540b8c6fe33c349bf;6740120a40b8c6fe33c43e86;6740114f40b8c6fe33c3b269;67400fdc40b8c6fe33c27ab1;67400f4a40b8c6fe33c202ef;67400f7240b8c6fe33c22157;67400f8740b8c6fe33c2308c;6740128d40b8c6fe33c4a7b7;6740116340b8c6fe33c3c3ac;6740111940b8c6fe33c38a4d;6740119b40b8c6fe33c3ec3e;6740128940b8c6fe33c4a2c2;6740105840b8c6fe33c2efad;674011a540b8c6fe33c3f396;6740101940b8c6fe33c2b81e;6740107840b8c6fe33c30a6c;674010cc40b8c6fe33c34ef9;6740116140b8c6fe33c3c221;674011e240b8c6fe33c420d2;67400f5e40b8c6fe33c21249;6740118b40b8c6fe33c3e108;6740124f40b8c6fe33c476b7;6740107f40b8c6fe33c31082;674011ff40b8c6fe33c43701;674011e540b8c6fe33c423e1;6740120e40b8c6fe33c44160;67400f7b40b8c6fe33c22748;674010d740b8c6fe33c3579f;6740112e40b8c6fe33c399d2;6740121740b8c6fe33c44873;6740128740b8c6fe33c4a104;6740122940b8c6fe33c4565e;6740104040b8c6fe33c2da76;6740120040b8c6fe33c437d8;6740112b40b8c6fe33c397a7;674010b340b8c6fe33c33b43;6740113340b8c6fe33c39df7;67400fa640b8c6fe33c247cc;674010f940b8c6fe33c3724f;67400f6440b8c6fe33c2168e;67400fc340b8c6fe33c25db9;67400fe240b8c6fe33c28302;67400fa140b8c6fe33c24405",
          },
        ],
        cloud: [
          {
            value: "program",
            count: 93,
          },
          {
            value: "capacitor",
            count: 78,
          },
          {
            value: "panel",
            count: 73,
          },
          {
            value: "firewall",
            count: 71,
          },
          {
            value: "sensor",
            count: 65,
          },
          {
            value: "alarm",
            count: 62,
          },
          {
            value: "array",
            count: 59,
          },
          {
            value: "interface",
            count: 58,
          },
          {
            value: "monitor",
            count: 57,
          },
          {
            value: "port",
            count: 55,
          },
          {
            value: "bandwidth",
            count: 54,
          },
          {
            value: "system",
            count: 54,
          },
          {
            value: "matrix",
            count: 54,
          },
          {
            value: "copy",
            count: 53,
          },
          {
            value: "index",
            count: 53,
          },
          {
            value: "application",
            count: 53,
          },
          {
            value: "bus",
            count: 53,
          },
          {
            value: "microchip",
            count: 52,
          },
          {
            value: "back",
            count: 52,
          },
          {
            value: "card",
            count: 51,
          },
          {
            value: "hack",
            count: 51,
          },
          {
            value: "drive",
            count: 50,
          },
          {
            value: "hard",
            count: 50,
          },
          {
            value: "transmitter",
            count: 50,
          },
          {
            value: "open-source",
            count: 50,
          },
        ],
      },
    },
    participants: {
      data: [
        {
          date: "2024-06-26",
          newParticipants: 18,
          participants: 1096,
        },
        {
          date: "2024-06-27",
          newParticipants: 30,
          participants: 1126,
        },
        {
          date: "2024-06-28",
          newParticipants: 48,
          participants: 1174,
        },
        {
          date: "2024-06-29",
          newParticipants: 36,
          participants: 1210,
        },
        {
          date: "2024-06-30",
          newParticipants: 23,
          participants: 1233,
        },
        {
          date: "2024-07-01",
          newParticipants: 27,
          participants: 1260,
        },
        {
          date: "2024-07-02",
          newParticipants: 19,
          participants: 1279,
        },
        {
          date: "2024-07-03",
          newParticipants: 19,
          participants: 1298,
        },
        {
          date: "2024-07-04",
          newParticipants: 23,
          participants: 1321,
        },
        {
          date: "2024-07-05",
          newParticipants: 44,
          participants: 1365,
        },
        {
          date: "2024-07-06",
          newParticipants: 19,
          participants: 1384,
        },
        {
          date: "2024-07-07",
          newParticipants: 11,
          participants: 1395,
        },
        {
          date: "2024-07-08",
          newParticipants: 23,
          participants: 1418,
        },
        {
          date: "2024-07-09",
          newParticipants: 30,
          participants: 1448,
        },
        {
          date: "2024-07-10",
          newParticipants: 47,
          participants: 1495,
        },
        {
          date: "2024-07-11",
          newParticipants: 38,
          participants: 1533,
        },
        {
          date: "2024-07-12",
          newParticipants: 43,
          participants: 1576,
        },
        {
          date: "2024-07-13",
          newParticipants: 35,
          participants: 1611,
        },
        {
          date: "2024-07-14",
          newParticipants: 24,
          participants: 1635,
        },
        {
          date: "2024-07-15",
          newParticipants: 16,
          participants: 1651,
        },
        {
          date: "2024-07-16",
          newParticipants: 47,
          participants: 1698,
        },
        {
          date: "2024-07-17",
          newParticipants: 41,
          participants: 1739,
        },
        {
          date: "2024-07-18",
          newParticipants: 44,
          participants: 1783,
        },
        {
          date: "2024-07-19",
          newParticipants: 11,
          participants: 1794,
        },
        {
          date: "2024-07-20",
          newParticipants: 26,
          participants: 1820,
        },
        {
          date: "2024-07-21",
          newParticipants: 16,
          participants: 1836,
        },
        {
          date: "2024-07-22",
          newParticipants: 36,
          participants: 1872,
        },
        {
          date: "2024-07-23",
          newParticipants: 48,
          participants: 1920,
        },
        {
          date: "2024-07-24",
          newParticipants: 32,
          participants: 1952,
        },
        {
          date: "2024-07-25",
          newParticipants: 44,
          participants: 1996,
        },
        {
          date: "2024-07-26",
          newParticipants: 19,
          participants: 2015,
        },
        {
          date: "2024-07-27",
          newParticipants: 36,
          participants: 2051,
        },
        {
          date: "2024-07-28",
          newParticipants: 26,
          participants: 2077,
        },
        {
          date: "2024-07-29",
          newParticipants: 22,
          participants: 2099,
        },
        {
          date: "2024-07-30",
          newParticipants: 44,
          participants: 2143,
        },
        {
          date: "2024-07-31",
          newParticipants: 36,
          participants: 2179,
        },
        {
          date: "2024-08-01",
          newParticipants: 42,
          participants: 2221,
        },
        {
          date: "2024-08-02",
          newParticipants: 15,
          participants: 2236,
        },
        {
          date: "2024-08-03",
          newParticipants: 24,
          participants: 2260,
        },
        {
          date: "2024-08-04",
          newParticipants: 13,
          participants: 2273,
        },
        {
          date: "2024-08-05",
          newParticipants: 31,
          participants: 2304,
        },
        {
          date: "2024-08-06",
          newParticipants: 39,
          participants: 2343,
        },
        {
          date: "2024-08-07",
          newParticipants: 37,
          participants: 2380,
        },
        {
          date: "2024-08-08",
          newParticipants: 40,
          participants: 2420,
        },
        {
          date: "2024-08-09",
          newParticipants: 36,
          participants: 2456,
        },
        {
          date: "2024-08-10",
          newParticipants: 15,
          participants: 2471,
        },
        {
          date: "2024-08-11",
          newParticipants: 35,
          participants: 2506,
        },
        {
          date: "2024-08-12",
          newParticipants: 38,
          participants: 2544,
        },
        {
          date: "2024-08-13",
          newParticipants: 12,
          participants: 2556,
        },
        {
          date: "2024-08-14",
          newParticipants: 20,
          participants: 2576,
        },
        {
          date: "2024-08-15",
          newParticipants: 11,
          participants: 2587,
        },
        {
          date: "2024-08-16",
          newParticipants: 23,
          participants: 2610,
        },
        {
          date: "2024-08-17",
          newParticipants: 34,
          participants: 2644,
        },
        {
          date: "2024-08-18",
          newParticipants: 30,
          participants: 2674,
        },
        {
          date: "2024-08-19",
          newParticipants: 41,
          participants: 2715,
        },
        {
          date: "2024-08-20",
          newParticipants: 25,
          participants: 2740,
        },
        {
          date: "2024-08-21",
          newParticipants: 25,
          participants: 2765,
        },
        {
          date: "2024-08-22",
          newParticipants: 45,
          participants: 2810,
        },
        {
          date: "2024-08-23",
          newParticipants: 23,
          participants: 2833,
        },
        {
          date: "2024-08-24",
          newParticipants: 50,
          participants: 2883,
        },
        {
          date: "2024-08-25",
          newParticipants: 27,
          participants: 2910,
        },
        {
          date: "2024-08-26",
          newParticipants: 32,
          participants: 2942,
        },
        {
          date: "2024-08-27",
          newParticipants: 26,
          participants: 2968,
        },
        {
          date: "2024-08-28",
          newParticipants: 12,
          participants: 2980,
        },
        {
          date: "2024-08-29",
          newParticipants: 11,
          participants: 2991,
        },
        {
          date: "2024-08-30",
          newParticipants: 45,
          participants: 3036,
        },
        {
          date: "2024-08-31",
          newParticipants: 19,
          participants: 3055,
        },
        {
          date: "2024-09-01",
          newParticipants: 38,
          participants: 3093,
        },
        {
          date: "2024-09-02",
          newParticipants: 44,
          participants: 3137,
        },
        {
          date: "2024-09-03",
          newParticipants: 21,
          participants: 3158,
        },
        {
          date: "2024-09-04",
          newParticipants: 12,
          participants: 3170,
        },
        {
          date: "2024-09-05",
          newParticipants: 29,
          participants: 3199,
        },
        {
          date: "2024-09-06",
          newParticipants: 13,
          participants: 3212,
        },
        {
          date: "2024-09-07",
          newParticipants: 23,
          participants: 3235,
        },
        {
          date: "2024-09-08",
          newParticipants: 42,
          participants: 3277,
        },
        {
          date: "2024-09-09",
          newParticipants: 11,
          participants: 3288,
        },
        {
          date: "2024-09-10",
          newParticipants: 28,
          participants: 3316,
        },
        {
          date: "2024-09-11",
          newParticipants: 44,
          participants: 3360,
        },
        {
          date: "2024-09-12",
          newParticipants: 45,
          participants: 3405,
        },
        {
          date: "2024-09-13",
          newParticipants: 18,
          participants: 3423,
        },
        {
          date: "2024-09-14",
          newParticipants: 18,
          participants: 3441,
        },
        {
          date: "2024-09-15",
          newParticipants: 14,
          participants: 3455,
        },
        {
          date: "2024-09-16",
          newParticipants: 48,
          participants: 3503,
        },
        {
          date: "2024-09-17",
          newParticipants: 48,
          participants: 3551,
        },
        {
          date: "2024-09-18",
          newParticipants: 22,
          participants: 3573,
        },
        {
          date: "2024-09-19",
          newParticipants: 14,
          participants: 3587,
        },
        {
          date: "2024-09-20",
          newParticipants: 35,
          participants: 3622,
        },
        {
          date: "2024-09-21",
          newParticipants: 29,
          participants: 3651,
        },
        {
          date: "2024-09-22",
          newParticipants: 47,
          participants: 3698,
        },
        {
          date: "2024-09-23",
          newParticipants: 42,
          participants: 3740,
        },
        {
          date: "2024-09-24",
          newParticipants: 34,
          participants: 3774,
        },
        {
          date: "2024-09-25",
          newParticipants: 14,
          participants: 3788,
        },
        {
          date: "2024-09-26",
          newParticipants: 19,
          participants: 3807,
        },
        {
          date: "2024-09-27",
          newParticipants: 34,
          participants: 3841,
        },
        {
          date: "2024-09-28",
          newParticipants: 40,
          participants: 3881,
        },
        {
          date: "2024-09-29",
          newParticipants: 23,
          participants: 3904,
        },
        {
          date: "2024-09-30",
          newParticipants: 12,
          participants: 3916,
        },
        {
          date: "2024-10-01",
          newParticipants: 38,
          participants: 3954,
        },
        {
          date: "2024-10-02",
          newParticipants: 45,
          participants: 3999,
        },
        {
          date: "2024-10-03",
          newParticipants: 41,
          participants: 4040,
        },
        {
          date: "2024-10-04",
          newParticipants: 14,
          participants: 4054,
        },
        {
          date: "2024-10-05",
          newParticipants: 17,
          participants: 4071,
        },
        {
          date: "2024-10-06",
          newParticipants: 28,
          participants: 4099,
        },
        {
          date: "2024-10-07",
          newParticipants: 46,
          participants: 4145,
        },
        {
          date: "2024-10-08",
          newParticipants: 41,
          participants: 4186,
        },
        {
          date: "2024-10-09",
          newParticipants: 41,
          participants: 4227,
        },
        {
          date: "2024-10-10",
          newParticipants: 19,
          participants: 4246,
        },
        {
          date: "2024-10-11",
          newParticipants: 27,
          participants: 4273,
        },
        {
          date: "2024-10-12",
          newParticipants: 10,
          participants: 4283,
        },
        {
          date: "2024-10-13",
          newParticipants: 31,
          participants: 4314,
        },
        {
          date: "2024-10-14",
          newParticipants: 22,
          participants: 4336,
        },
        {
          date: "2024-10-15",
          newParticipants: 22,
          participants: 4358,
        },
        {
          date: "2024-10-16",
          newParticipants: 17,
          participants: 4375,
        },
        {
          date: "2024-10-17",
          newParticipants: 28,
          participants: 4403,
        },
        {
          date: "2024-10-18",
          newParticipants: 24,
          participants: 4427,
        },
        {
          date: "2024-10-19",
          newParticipants: 30,
          participants: 4457,
        },
        {
          date: "2024-10-20",
          newParticipants: 28,
          participants: 4485,
        },
        {
          date: "2024-10-21",
          newParticipants: 37,
          participants: 4522,
        },
        {
          date: "2024-10-22",
          newParticipants: 45,
          participants: 4567,
        },
        {
          date: "2024-10-23",
          newParticipants: 31,
          participants: 4598,
        },
        {
          date: "2024-10-24",
          newParticipants: 41,
          participants: 4639,
        },
        {
          date: "2024-10-25",
          newParticipants: 25,
          participants: 4664,
        },
        {
          date: "2024-10-26",
          newParticipants: 11,
          participants: 4675,
        },
        {
          date: "2024-10-27",
          newParticipants: 27,
          participants: 4702,
        },
        {
          date: "2024-10-28",
          newParticipants: 20,
          participants: 4722,
        },
        {
          date: "2024-10-29",
          newParticipants: 12,
          participants: 4734,
        },
        {
          date: "2024-10-30",
          newParticipants: 44,
          participants: 4778,
        },
        {
          date: "2024-10-31",
          newParticipants: 26,
          participants: 4804,
        },
        {
          date: "2024-11-01",
          newParticipants: 11,
          participants: 4815,
        },
        {
          date: "2024-11-02",
          newParticipants: 26,
          participants: 4841,
        },
        {
          date: "2024-11-03",
          newParticipants: 18,
          participants: 4859,
        },
        {
          date: "2024-11-04",
          newParticipants: 46,
          participants: 4905,
        },
        {
          date: "2024-11-05",
          newParticipants: 17,
          participants: 4922,
        },
        {
          date: "2024-11-06",
          newParticipants: 48,
          participants: 4970,
        },
        {
          date: "2024-11-07",
          newParticipants: 31,
          participants: 5001,
        },
        {
          date: "2024-11-08",
          newParticipants: 25,
          participants: 5026,
        },
        {
          date: "2024-11-09",
          newParticipants: 33,
          participants: 5059,
        },
        {
          date: "2024-11-10",
          newParticipants: 11,
          participants: 5070,
        },
        {
          date: "2024-11-11",
          newParticipants: 45,
          participants: 5115,
        },
        {
          date: "2024-11-12",
          newParticipants: 17,
          participants: 5132,
        },
        {
          date: "2024-11-13",
          newParticipants: 50,
          participants: 5182,
        },
        {
          date: "2024-11-14",
          newParticipants: 29,
          participants: 5211,
        },
        {
          date: "2024-11-15",
          newParticipants: 24,
          participants: 5235,
        },
        {
          date: "2024-11-16",
          newParticipants: 18,
          participants: 5253,
        },
        {
          date: "2024-11-17",
          newParticipants: 17,
          participants: 5270,
        },
        {
          date: "2024-11-18",
          newParticipants: 42,
          participants: 5312,
        },
        {
          date: "2024-11-19",
          newParticipants: 15,
          participants: 5327,
        },
        {
          date: "2024-11-20",
          newParticipants: 36,
          participants: 5363,
        },
        {
          date: "2024-11-21",
          newParticipants: 35,
          participants: 5398,
        },
        {
          date: "2024-11-22",
          newParticipants: 35,
          participants: 5433,
        },
      ],
    },
    mentions: {
      data: {
        name: "program",
        times: 90,
        mentions: [
          {
            content:
              "Try to synthesize the HDD bus, maybe it will program the auxiliary feed!",
            date: 1726876800000,
          },
          {
            content:
              "You can't hack the program without indexing the online TCP bus!",
            date: 1727654400000,
          },
          {
            content:
              "You can't program the capacitor without transmitting the redundant ASCII port!",
            date: 1730764800000,
          },
          {
            content:
              "I'll transmit the neural SSL panel, that should sensor the GB program!",
            date: 1730764800000,
          },
          {
            content:
              "Use the haptic AI circuit, then you can program the online card!",
            date: 1730678400000,
          },
          {
            content:
              "Use the optical UDP microchip, then you can program the neural application!",
            date: 1723161600000,
          },
          {
            content:
              "If we reboot the bandwidth, we can get to the DNS program through the mobile ADP firewall!",
            date: 1724630400000,
          },
          {
            content:
              "I'll compress the optical GB circuit, that should program the HTTP program!",
            date: 1724630400000,
          },
          {
            content:
              "I'll compress the neural SMTP transmitter, that should program the API pixel!",
            date: 1723334400000,
          },
          {
            content:
              "bypassing the program won't do anything, we need to bypass the online UDP feed!",
            date: 1732147200000,
          },
          {
            content:
              "Try to parse the EXE card, maybe it will program the solid state system!",
            date: 1732838400000,
          },
          {
            content:
              "You can't synthesize the bandwidth without bypassing the auxiliary UTF8 program!",
            date: 1728345600000,
          },
          {
            content:
              "connecting the hard drive won't do anything, we need to hack the 1080p XML program!",
            date: 1728345600000,
          },
          {
            content: "We need to program the optical JSON interface!",
            date: 1731024000000,
          },
          {
            content:
              "If we quantify the interface, we can get to the SQL program through the cross-platform JBOD system!",
            date: 1728259200000,
          },
          {
            content:
              "Use the 1080p SSL program, then you can synthesize the haptic circuit!",
            date: 1726790400000,
          },
          {
            content:
              "If we hack the hard drive, we can get to the TLS pixel through the redundant PNG program!",
            date: 1727913600000,
          },
          {
            content:
              "The HEX hard drive is down, synthesize the mobile system so we can reboot the TCP program!",
            date: 1727136000000,
          },
          {
            content: "We need to program the auxiliary USB program!",
            date: 1727136000000,
          },
          {
            content: "We need to program the multi-byte TCP port!",
            date: 1722816000000,
          },
          {
            content:
              "The XSS panel is down, index the back-end feed so we can program the THX pixel!",
            date: 1728432000000,
          },
          {
            content: "We need to program the online TLS feed!",
            date: 1728432000000,
          },
          {
            content:
              "If we parse the application, we can get to the SQL card through the neural UTF8 program!",
            date: 1728432000000,
          },
          {
            content:
              "If we program the circuit, we can get to the SSD interface through the open-source TLS application!",
            date: 1727827200000,
          },
          {
            content:
              "I'll compress the neural UTF8 bandwidth, that should program the SCSI card!",
            date: 1730246400000,
          },
          {
            content:
              "If we program the program, we can get to the XML card through the bluetooth SSD transmitter!",
            date: 1730246400000,
          },
          {
            content:
              "If we index the pixel, we can get to the THX alarm through the haptic COM program!",
            date: 1724198400000,
          },
          {
            content:
              "I'll program the neural PNG sensor, that should hard drive the JSON port!",
            date: 1724198400000,
          },
          {
            content:
              "I'll program the haptic SAS card, that should sensor the SQL hard drive!",
            date: 1729641600000,
          },
          {
            content:
              "The SDD system is down, navigate the cross-platform program so we can connect the AI program!",
            date: 1729641600000,
          },
          {
            content:
              "If we copy the program, we can get to the ADP driver through the mobile SDD circuit!",
            date: 1729641600000,
          },
          {
            content:
              "Try to back up the JSON program, maybe it will quantify the neural transmitter!",
            date: 1730073600000,
          },
          {
            content:
              "If we parse the program, we can get to the DRAM hard drive through the auxiliary SMTP microchip!",
            date: 1730073600000,
          },
          {
            content:
              "You can't copy the array without generating the 1080p SSL program!",
            date: 1730073600000,
          },
          {
            content:
              "transmitting the firewall won't do anything, we need to program the solid state SMS pixel!",
            date: 1727308800000,
          },
          {
            content:
              "You can't calculate the program without synthesizing the haptic DRAM circuit!",
            date: 1723507200000,
          },
          {
            content: "We need to program the wireless PNG application!",
            date: 1732665600000,
          },
          {
            content:
              "You can't synthesize the array without quantifying the solid state DRAM program!",
            date: 1732665600000,
          },
          {
            content: "We need to program the online RAM interface!",
            date: 1723852800000,
          },
          {
            content:
              "I'll compress the back-end COM program, that should bandwidth the COM sensor!",
            date: 1732579200000,
          },
          {
            content:
              "The THX circuit is down, synthesize the digital program so we can bypass the USB card!",
            date: 1732579200000,
          },
          {
            content:
              "calculating the microchip won't do anything, we need to generate the online SDD program!",
            date: 1732579200000,
          },
          {
            content:
              "I'll connect the back-end JSON program, that should bus the SSD program!",
            date: 1732579200000,
          },
          {
            content:
              "I'll transmit the 1080p SSL panel, that should program the XML feed!",
            date: 1732579200000,
          },
          {
            content:
              "If we quantify the protocol, we can get to the JBOD program through the cross-platform USB system!",
            date: 1732579200000,
          },
          {
            content:
              "You can't program the card without quantifying the redundant XML firewall!",
            date: 1725235200000,
          },
          {
            content:
              "The AGP bus is down, quantify the solid state bandwidth so we can index the SMS program!",
            date: 1729900800000,
          },
          {
            content:
              "Use the back-end UDP monitor, then you can program the neural circuit!",
            date: 1729900800000,
          },
          {
            content:
              "The TLS sensor is down, index the cross-platform sensor so we can program the JBOD bus!",
            date: 1730937600000,
          },
          {
            content:
              "If we program the application, we can get to the SDD matrix through the bluetooth PNG firewall!",
            date: 1730937600000,
          },
          {
            content:
              "If we quantify the program, we can get to the TLS card through the 1080p UTF8 card!",
            date: 1733011200000,
          },
          {
            content:
              "The JBOD port is down, calculate the haptic card so we can program the SAS microchip!",
            date: 1731283200000,
          },
          {
            content:
              "If we hack the array, we can get to the RAM alarm through the auxiliary DNS program!",
            date: 1723248000000,
          },
          {
            content:
              "Try to program the PNG driver, maybe it will reboot the back-end microchip!",
            date: 1723248000000,
          },
          {
            content:
              "connecting the program won't do anything, we need to calculate the cross-platform HTTP transmitter!",
            date: 1723593600000,
          },
          {
            content:
              "calculating the sensor won't do anything, we need to program the multi-byte THX sensor!",
            date: 1732233600000,
          },
          {
            content: "We need to program the 1080p SCSI pixel!",
            date: 1732233600000,
          },
          {
            content:
              "Try to bypass the UTF8 interface, maybe it will program the multi-byte card!",
            date: 1726358400000,
          },
          {
            content:
              "You can't program the panel without backing up the 1080p JBOD transmitter!",
            date: 1726531200000,
          },
          {
            content:
              "You can't program the transmitter without quantifying the optical ASCII array!",
            date: 1725926400000,
          },
          {
            content: "We need to program the 1080p JSON system!",
            date: 1723075200000,
          },
          {
            content:
              "navigating the program won't do anything, we need to connect the multi-byte ASCII array!",
            date: 1723075200000,
          },
          {
            content:
              "If we generate the program, we can get to the SMS bus through the redundant HDD capacitor!",
            date: 1723075200000,
          },
          {
            content:
              "If we copy the card, we can get to the HEX program through the multi-byte RSS matrix!",
            date: 1727395200000,
          },
          {
            content:
              "Try to program the CLI driver, maybe it will reboot the solid state sensor!",
            date: 1728777600000,
          },
          {
            content:
              "The OCR alarm is down, connect the neural microchip so we can override the THX program!",
            date: 1726012800000,
          },
          {
            content:
              "Try to parse the JSON circuit, maybe it will copy the primary program!",
            date: 1728172800000,
          },
          {
            content:
              "You can't program the bus without hacking the redundant FTP bandwidth!",
            date: 1728172800000,
          },
          {
            content:
              "The DRAM microchip is down, parse the cross-platform sensor so we can reboot the CSS program!",
            date: 1725062400000,
          },
          {
            content:
              "I'll program the open-source HTTP bandwidth, that should panel the GB hard drive!",
            date: 1726185600000,
          },
          {
            content:
              "Try to parse the SAS program, maybe it will back up the primary circuit!",
            date: 1732492800000,
          },
          {
            content:
              "The SSD port is down, copy the solid state pixel so we can compress the UTF8 program!",
            date: 1729123200000,
          },
          {
            content:
              "If we program the capacitor, we can get to the RAM firewall through the wireless EXE matrix!",
            date: 1732752000000,
          },
          {
            content:
              "Use the 1080p OCR circuit, then you can program the optical alarm!",
            date: 1729382400000,
          },
          {
            content:
              "The THX capacitor is down, program the virtual circuit so we can input the COM application!",
            date: 1731628800000,
          },
          {
            content:
              "You can't program the array without programming the redundant THX transmitter!",
            date: 1725580800000,
          },
          {
            content: "We need to bypass the open-source IP program!",
            date: 1731888000000,
          },
          {
            content:
              "If we program the protocol, we can get to the DNS transmitter through the back-end FTP system!",
            date: 1724284800000,
          },
          {
            content:
              "You can't program the system without programming the solid state SMTP transmitter!",
            date: 1730592000000,
          },
          {
            content:
              "You can't quantify the program without hacking the mobile SQL bus!",
            date: 1725840000000,
          },
          {
            content:
              "If we bypass the program, we can get to the HDD port through the auxiliary TLS protocol!",
            date: 1731456000000,
          },
          {
            content:
              "I'll quantify the open-source API program, that should driver the THX system!",
            date: 1731110400000,
          },
          {
            content: "We need to program the 1080p CSS microchip!",
            date: 1731110400000,
          },
          {
            content:
              "You can't compress the program without indexing the solid state COM microchip!",
            date: 1730160000000,
          },
          {
            content:
              "backing up the transmitter won't do anything, we need to parse the neural JSON program!",
            date: 1726444800000,
          },
          {
            content:
              "The AI capacitor is down, program the redundant bus so we can bypass the SDD pixel!",
            date: 1731369600000,
          },
          {
            content:
              "You can't program the matrix without copying the optical SSD card!",
            date: 1732406400000,
          },
          {
            content:
              "bypassing the bandwidth won't do anything, we need to program the primary DNS alarm!",
            date: 1729036800000,
          },
          {
            content:
              "The SMTP system is down, back up the bluetooth bandwidth so we can program the USB port!",
            date: 1725494400000,
          },
          {
            content: "We need to transmit the cross-platform SQL program!",
            date: 1722902400000,
          },
        ],
      },
    },
    topMembers: {
      data: [
        {
          avatar: null,
          userName: "john_doe",
          userId: "johnDoe1234",
          addressCollection: {
            address: "0x909DD7a490612941328728C932B496Eb23344F3a",
            userId: "676ab39743dfa70795c1b52d",
          },
          totalMessages: 100,
          totalReactions: 67,
          userTag: "member",
          lastActive: "2024-11-10T09:20:30.123Z",
        },
        {
          avatar: null,
          userName: "alice_smith",
          userId: "aliceSmith9876",
          addressCollection: null,
          totalMessages: 88,
          totalReactions: 51,
          userTag: "member",
          lastActive: "2024-11-11T09:22:15.456Z",
        },
        {
          avatar: null,
          userName: "bob_jones",
          userId: "bobJones4567",
          addressCollection: null,
          totalMessages: 32,
          totalReactions: 56,
          userTag: "member",
          lastActive: "2024-11-20T09:25:00.789Z",
        },
        {
          avatar: null,
          userName: "charlie_brown",
          userId: "charlieBrown1122",
          addressCollection: {
            address: "0x909DD7a490612941328728C932B496Eb23344F3a",
            userId: "676ab39743dfa70795c1b52d",
          },
          totalMessages: 77,
          totalReactions: 45,
          userTag: "left",
          lastActive: "2024-11-12T20:10:45.555Z",
        },
        {
          avatar: null,
          userName: "diana_lee",
          userId: "dianaLee2323",
          addressCollection: {
            address: "0x909DD7a490612941328728C932B496Eb23344F3a",
            userId: "676ab39743dfa70795c1b52d",
          },
          totalMessages: 45,
          totalReactions: 34,
          userTag: "suspected",
          lastActive: "2024-11-15T09:30:12.345Z",
        },
        {
          avatar: null,
          userName: null,
          userId: "Local Test - MetaCRM Ticket Bot",
          addressCollection: null,
          totalMessages: 89,
          totalReactions: 0,
          userTag: "bot",
          lastActive: "2024-11-17T09:35:29.678Z",
        },
        {
          avatar: null,
          userName: "george_martin",
          userId: "georgeMartin5643",
          addressCollection: {
            address: "0x909DD7a490612941328728C932B496Eb23344F3a",
            userId: "676ab39743dfa70795c1b52d",
          },
          totalMessages: 23,
          totalReactions: 13,
          userTag: "member",
          lastActive: "2024-11-19T09:40:55.123Z",
        },
        {
          avatar: null,
          userName: "hannah_perez",
          userId: "hannahPerez3245",
          addressCollection: {
            address: "0x909DD7a490612941328728C932B496Eb23344F3a",
            userId: "676ab39743dfa70795c1b52d",
          },
          totalMessages: 14,
          totalReactions: 9,
          userTag: "suspected",
          lastActive: "2024-11-01T09:45:34.567Z",
        },
        {
          avatar: null,
          userName: "ian_taylor",
          userId: "ianTaylor1238",
          addressCollection: null,
          totalMessages: 10,
          totalReactions: 1,
          userTag: "left",
          lastActive: "2024-11-10T19:55:01.234Z",
        },
      ],
      total: 50,
    },
  },
  telegram: {
    summary: {
      groupName: "unayung's tg",
      dataInfo: [
        {
          dataTitle: "New Participants",
          number: 4444,
          totalNumber: 6113,
          rate: 21,
          id: "newParticipants",
        },
        {
          dataTitle: "Engagements",
          number: 2160,
          rate: 7,
          id: "engagements",
        },
        {
          dataTitle: "Retention Rate",
          number: 0.12,
          rate: 2.8,
          id: "retentionRate",
        },
      ],
    },
    cohort: {
      data: {
        days: {
          "17-06-2024": [
            19, 12, 10, 8, 6, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0,
          ],
          "18-06-2024": [
            16, 10, 8, 7, 5, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0,
          ],
          "19-06-2024": [
            49, 31, 26, 22, 17, 12, 7, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0,
          ],
          "20-06-2024": [
            49, 31, 26, 22, 17, 12, 7, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0,
          ],
          "21-06-2024": [
            20, 13, 11, 9, 7, 5, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "22-06-2024": [
            37, 24, 20, 16, 12, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "23-06-2024": [
            50, 32, 27, 22, 17, 12, 7, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "24-06-2024": [
            24, 15, 13, 10, 8, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "25-06-2024": [
            36, 23, 19, 16, 12, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "26-06-2024": [
            42, 27, 23, 18, 14, 10, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "27-06-2024": [
            13, 8, 7, 5, 4, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "28-06-2024": [
            25, 16, 13, 11, 8, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "29-06-2024": [
            20, 13, 11, 9, 7, 5, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "30-06-2024": [
            13, 8, 7, 5, 4, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "01-07-2024": [
            17, 11, 9, 7, 5, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "02-07-2024": [
            35, 22, 19, 15, 12, 8, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "03-07-2024": [
            17, 11, 9, 7, 5, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "04-07-2024": [
            47, 30, 25, 21, 16, 11, 7, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "05-07-2024": [
            18, 11, 9, 8, 6, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "06-07-2024": [
            28, 18, 15, 12, 9, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "07-07-2024": [
            22, 14, 12, 9, 7, 5, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0,
          ],
          "08-07-2024": [
            23, 14, 12, 10, 8, 5, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0,
          ],
          "09-07-2024": [
            39, 25, 21, 17, 13, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0,
          ],
          "10-07-2024": [
            14, 9, 7, 6, 4, 3, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0,
          ],
          "11-07-2024": [
            38, 24, 20, 17, 13, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0,
          ],
          "12-07-2024": [
            30, 19, 16, 13, 10, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0,
          ],
          "13-07-2024": [
            30, 19, 16, 13, 10, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0,
          ],
          "14-07-2024": [
            20, 13, 11, 9, 7, 5, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "15-07-2024": [
            44, 28, 24, 19, 15, 11, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "16-07-2024": [
            14, 9, 7, 6, 4, 3, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "17-07-2024": [
            39, 25, 21, 17, 13, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "18-07-2024": [
            33, 21, 18, 14, 11, 8, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "19-07-2024": [
            42, 27, 23, 18, 14, 10, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "20-07-2024": [
            40, 26, 22, 18, 14, 10, 6, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "21-07-2024": [
            20, 13, 11, 9, 7, 5, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "22-07-2024": [
            18, 11, 9, 8, 6, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "23-07-2024": [
            38, 24, 20, 17, 13, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "24-07-2024": [
            14, 9, 7, 6, 4, 3, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "25-07-2024": [
            42, 27, 23, 18, 14, 10, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "26-07-2024": [
            34, 22, 18, 15, 11, 8, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "27-07-2024": [
            41, 26, 22, 18, 14, 10, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "28-07-2024": [
            15, 9, 8, 6, 5, 3, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "29-07-2024": [
            25, 16, 13, 11, 8, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "30-07-2024": [
            28, 18, 15, 12, 9, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "31-07-2024": [
            28, 18, 15, 12, 9, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0,
          ],
          "01-08-2024": [
            33, 21, 18, 14, 11, 8, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0,
          ],
          "02-08-2024": [
            47, 30, 25, 21, 16, 11, 7, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0,
          ],
          "03-08-2024": [
            12, 7, 6, 5, 4, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0,
          ],
          "04-08-2024": [
            41, 26, 22, 18, 14, 10, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0,
          ],
          "05-08-2024": [
            29, 18, 15, 13, 10, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0,
          ],
          "06-08-2024": [
            12, 7, 6, 5, 4, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "07-08-2024": [
            33, 21, 18, 14, 11, 8, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "08-08-2024": [
            43, 27, 23, 19, 15, 10, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "09-08-2024": [
            36, 23, 19, 16, 12, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "10-08-2024": [
            40, 26, 22, 18, 14, 10, 6, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "11-08-2024": [
            16, 10, 8, 7, 5, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "12-08-2024": [
            11, 7, 6, 4, 3, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "13-08-2024": [
            29, 18, 15, 13, 10, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "14-08-2024": [
            43, 27, 23, 19, 15, 10, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "15-08-2024": [
            45, 29, 24, 20, 15, 11, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "16-08-2024": [
            49, 31, 26, 22, 17, 12, 7, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "17-08-2024": [
            29, 18, 15, 13, 10, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "18-08-2024": [
            33, 21, 18, 14, 11, 8, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "19-08-2024": [
            48, 31, 26, 21, 16, 12, 7, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "20-08-2024": [
            14, 9, 7, 6, 4, 3, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "21-08-2024": [
            26, 16, 14, 11, 9, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "22-08-2024": [
            25, 16, 13, 11, 8, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "23-08-2024": [
            47, 30, 25, 21, 16, 11, 7, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0,
          ],
          "24-08-2024": [
            44, 28, 24, 19, 15, 11, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0,
          ],
          "25-08-2024": [
            40, 26, 22, 18, 14, 10, 6, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0,
          ],
          "26-08-2024": [
            22, 14, 12, 9, 7, 5, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0,
          ],
          "27-08-2024": [
            16, 10, 8, 7, 5, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0,
          ],
          "28-08-2024": [
            37, 24, 20, 16, 12, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0,
          ],
          "29-08-2024": [
            17, 11, 9, 7, 5, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "30-08-2024": [
            27, 17, 14, 12, 9, 6, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "31-08-2024": [
            18, 11, 9, 8, 6, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "01-09-2024": [
            16, 10, 8, 7, 5, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "02-09-2024": [
            21, 13, 11, 9, 7, 5, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "03-09-2024": [
            16, 10, 8, 7, 5, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "04-09-2024": [
            10, 6, 5, 4, 3, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "05-09-2024": [
            46, 29, 25, 20, 16, 11, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "06-09-2024": [
            13, 8, 7, 5, 4, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "07-09-2024": [
            14, 9, 7, 6, 4, 3, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "08-09-2024": [
            36, 23, 19, 16, 12, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "09-09-2024": [
            50, 32, 27, 22, 17, 12, 7, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "10-09-2024": [
            21, 13, 11, 9, 7, 5, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "11-09-2024": [
            21, 13, 11, 9, 7, 5, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "12-09-2024": [
            14, 9, 7, 6, 4, 3, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "13-09-2024": [
            39, 25, 21, 17, 13, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "14-09-2024": [
            26, 16, 14, 11, 9, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "15-09-2024": [
            23, 14, 12, 10, 8, 5, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0,
          ],
          "16-09-2024": [
            21, 13, 11, 9, 7, 5, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0,
          ],
          "17-09-2024": [
            11, 7, 6, 4, 3, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0,
          ],
          "18-09-2024": [
            49, 31, 26, 22, 17, 12, 7, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0,
          ],
          "19-09-2024": [
            28, 18, 15, 12, 9, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0,
          ],
          "20-09-2024": [
            26, 16, 14, 11, 9, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0,
          ],
          "21-09-2024": [
            31, 20, 17, 13, 10, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0,
          ],
          "22-09-2024": [
            20, 13, 11, 9, 7, 5, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "23-09-2024": [
            37, 24, 20, 16, 12, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "24-09-2024": [
            30, 19, 16, 13, 10, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "25-09-2024": [
            42, 27, 23, 18, 14, 10, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "26-09-2024": [
            23, 14, 12, 10, 8, 5, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "27-09-2024": [
            22, 14, 12, 9, 7, 5, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "28-09-2024": [
            28, 18, 15, 12, 9, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "29-09-2024": [
            46, 29, 25, 20, 16, 11, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "30-09-2024": [
            27, 17, 14, 12, 9, 6, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "01-10-2024": [
            46, 29, 25, 20, 16, 11, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "02-10-2024": [
            28, 18, 15, 12, 9, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "03-10-2024": [
            41, 26, 22, 18, 14, 10, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "04-10-2024": [
            13, 8, 7, 5, 4, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "05-10-2024": [
            39, 25, 21, 17, 13, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "06-10-2024": [
            18, 11, 9, 8, 6, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "07-10-2024": [
            50, 32, 27, 22, 17, 12, 7, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "08-10-2024": [
            27, 17, 14, 12, 9, 6, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0,
          ],
          "09-10-2024": [
            25, 16, 13, 11, 8, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0,
          ],
          "10-10-2024": [
            12, 7, 6, 5, 4, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0,
          ],
          "11-10-2024": [
            33, 21, 18, 14, 11, 8, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0,
          ],
          "12-10-2024": [
            28, 18, 15, 12, 9, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0,
          ],
          "13-10-2024": [
            35, 22, 19, 15, 12, 8, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0,
          ],
          "14-10-2024": [
            44, 28, 24, 19, 15, 11, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0,
          ],
          "15-10-2024": [
            25, 16, 13, 11, 8, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "16-10-2024": [
            11, 7, 6, 4, 3, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "17-10-2024": [
            17, 11, 9, 7, 5, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "18-10-2024": [
            25, 16, 13, 11, 8, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "19-10-2024": [
            32, 20, 17, 14, 11, 8, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "20-10-2024": [
            27, 17, 14, 12, 9, 6, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "21-10-2024": [
            24, 15, 13, 10, 8, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "22-10-2024": [
            47, 30, 25, 21, 16, 11, 7, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "23-10-2024": [
            39, 25, 21, 17, 13, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "24-10-2024": [
            28, 18, 15, 12, 9, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "25-10-2024": [
            38, 24, 20, 17, 13, 9, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "26-10-2024": [
            34, 22, 18, 15, 11, 8, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "27-10-2024": [
            47, 30, 25, 21, 16, 11, 7, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "28-10-2024": [
            19, 12, 10, 8, 6, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "29-10-2024": [
            19, 12, 10, 8, 6, 4, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "30-10-2024": [
            22, 14, 12, 9, 7, 5, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0,
          ],
          "31-10-2024": [
            29, 18, 15, 13, 10, 7, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0,
          ],
          "01-11-2024": [
            41, 26, 22, 18, 14, 10, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0,
          ],
          "02-11-2024": [
            32, 20, 17, 14, 11, 8, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0,
          ],
          "03-11-2024": [
            25, 16, 13, 11, 8, 6, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0,
          ],
          "04-11-2024": [
            11, 7, 6, 4, 3, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0,
          ],
          "05-11-2024": [
            41, 26, 22, 18, 14, 10, 6, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0,
          ],
          "06-11-2024": [
            48, 31, 26, 21, 16, 12, 7, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0,
          ],
          "07-11-2024": [
            20, 13, 11, 9, 7, 5, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "08-11-2024": [
            36, 23, 19, 16, 12, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "09-11-2024": [
            49, 31, 26, 22, 17, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "10-11-2024": [
            50, 32, 27, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          "11-11-2024": [14, 9, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          "12-11-2024": [46, 29, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          "13-11-2024": [34, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          "14-11-2024": [
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
          ],
          "15-11-2024": [
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
          ],
          "16-11-2024": [
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
          ],
          "17-11-2024": [
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
          ],
          "18-11-2024": [
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
          ],
          "19-11-2024": [
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
          ],
          "20-11-2024": [
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
            "N/A",
          ],
          "21-11-2024": ["N/A", "N/A", "N/A", "N/A", "N/A", "N/A", "N/A"],
          "22-11-2024": ["N/A", "N/A", "N/A", "N/A", "N/A", "N/A"],
          "23-11-2024": ["N/A", "N/A", "N/A", "N/A", "N/A"],
          "24-11-2024": ["N/A", "N/A", "N/A", "N/A"],
          "25-11-2024": ["N/A", "N/A", "N/A"],
          "26-11-2024": ["N/A", "N/A"],
          "27-11-2024": ["N/A"],
        },
        weeks: {
          week1: [
            258, 139, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0,
          ],
          week2: [
            140, 77, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          week3: [
            191, 93, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          week4: [
            215, 110, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          week5: [205, 93, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          week6: [213, 101, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          week7: [207, 104, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          week8: [218, 108, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          week9: [244, 112, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          week10: [231, 118, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          week11: [125, 55, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          week12: [201, 109, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          week13: [183, 106, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          week14: [214, 120, 0, 0, 0, 0, 0, 0, 0, 0],
          week15: [220, 133, 0, 0, 0, 0, 0, 0, 0],
          week16: [213, 114, 0, 0, 0, 0, 0, 0],
          week17: [188, 98, 0, 0, 0, 0, 0],
          week18: [211, 127, 0, 0, 0, 0],
          week19: [207, 100, 0, 0, 0],
          week20: [227, 121, 0, 0],
          week21: [249, 0, 0],
          week22: ["N/A", "N/A"],
          week23: ["N/A"],
        },
        months: {
          month1: [893, 101, 0, 0, 0],
          month2: [962, 88, 0, 0],
          month3: [807, 123, 0],
          month4: [922, 97],
          month5: ["N/A"],
        },
      },
    },
    reactions: {
      data: [
        {
          date: "2024-07-16",
          count: 5,
        },
        {
          date: "2024-07-17",
          count: 8,
        },
        {
          date: "2024-07-18",
          count: 5,
        },
        {
          date: "2024-07-19",
          count: 13,
        },
        {
          date: "2024-07-20",
          count: 11,
        },
        {
          date: "2024-07-21",
          count: 8,
        },
        {
          date: "2024-07-22",
          count: 7,
        },
        {
          date: "2024-07-23",
          count: 7,
        },
        {
          date: "2024-07-24",
          count: 5,
        },
        {
          date: "2024-07-25",
          count: 11,
        },
        {
          date: "2024-07-26",
          count: 5,
        },
        {
          date: "2024-07-27",
          count: 5,
        },
        {
          date: "2024-07-28",
          count: 9,
        },
        {
          date: "2024-07-29",
          count: 5,
        },
        {
          date: "2024-07-30",
          count: 7,
        },
        {
          date: "2024-07-31",
          count: 9,
        },
        {
          date: "2024-08-01",
          count: 3,
        },
        {
          date: "2024-08-02",
          count: 9,
        },
        {
          date: "2024-08-03",
          count: 10,
        },
        {
          date: "2024-08-04",
          count: 7,
        },
        {
          date: "2024-08-05",
          count: 9,
        },
        {
          date: "2024-08-06",
          count: 8,
        },
        {
          date: "2024-08-07",
          count: 9,
        },
        {
          date: "2024-08-08",
          count: 9,
        },
        {
          date: "2024-08-09",
          count: 12,
        },
        {
          date: "2024-08-10",
          count: 6,
        },
        {
          date: "2024-08-11",
          count: 5,
        },
        {
          date: "2024-08-12",
          count: 9,
        },
        {
          date: "2024-08-13",
          count: 6,
        },
        {
          date: "2024-08-14",
          count: 8,
        },
        {
          date: "2024-08-15",
          count: 16,
        },
        {
          date: "2024-08-16",
          count: 6,
        },
        {
          date: "2024-08-17",
          count: 9,
        },
        {
          date: "2024-08-18",
          count: 9,
        },
        {
          date: "2024-08-19",
          count: 4,
        },
        {
          date: "2024-08-20",
          count: 3,
        },
        {
          date: "2024-08-21",
          count: 12,
        },
        {
          date: "2024-08-22",
          count: 8,
        },
        {
          date: "2024-08-23",
          count: 8,
        },
        {
          date: "2024-08-24",
          count: 10,
        },
        {
          date: "2024-08-25",
          count: 8,
        },
        {
          date: "2024-08-26",
          count: 5,
        },
        {
          date: "2024-08-27",
          count: 5,
        },
        {
          date: "2024-08-28",
          count: 6,
        },
        {
          date: "2024-08-29",
          count: 10,
        },
        {
          date: "2024-08-30",
          count: 6,
        },
        {
          date: "2024-08-31",
          count: 4,
        },
        {
          date: "2024-09-01",
          count: 11,
        },
        {
          date: "2024-09-02",
          count: 7,
        },
        {
          date: "2024-09-03",
          count: 8,
        },
        {
          date: "2024-09-04",
          count: 6,
        },
        {
          date: "2024-09-05",
          count: 7,
        },
        {
          date: "2024-09-06",
          count: 8,
        },
        {
          date: "2024-09-07",
          count: 9,
        },
        {
          date: "2024-09-08",
          count: 13,
        },
        {
          date: "2024-09-09",
          count: 6,
        },
        {
          date: "2024-09-10",
          count: 9,
        },
        {
          date: "2024-09-11",
          count: 6,
        },
        {
          date: "2024-09-12",
          count: 12,
        },
        {
          date: "2024-09-13",
          count: 7,
        },
        {
          date: "2024-09-14",
          count: 11,
        },
        {
          date: "2024-09-15",
          count: 7,
        },
        {
          date: "2024-09-16",
          count: 7,
        },
        {
          date: "2024-09-17",
          count: 7,
        },
        {
          date: "2024-09-18",
          count: 4,
        },
        {
          date: "2024-09-19",
          count: 9,
        },
        {
          date: "2024-09-20",
          count: 6,
        },
        {
          date: "2024-09-21",
          count: 11,
        },
        {
          date: "2024-09-22",
          count: 9,
        },
        {
          date: "2024-09-23",
          count: 5,
        },
        {
          date: "2024-09-24",
          count: 8,
        },
        {
          date: "2024-09-25",
          count: 7,
        },
        {
          date: "2024-09-26",
          count: 9,
        },
        {
          date: "2024-09-27",
          count: 9,
        },
        {
          date: "2024-09-28",
          count: 8,
        },
        {
          date: "2024-09-29",
          count: 6,
        },
        {
          date: "2024-09-30",
          count: 8,
        },
        {
          date: "2024-10-01",
          count: 5,
        },
        {
          date: "2024-10-02",
          count: 9,
        },
        {
          date: "2024-10-03",
          count: 14,
        },
        {
          date: "2024-10-04",
          count: 10,
        },
        {
          date: "2024-10-05",
          count: 7,
        },
        {
          date: "2024-10-06",
          count: 5,
        },
        {
          date: "2024-10-07",
          count: 3,
        },
        {
          date: "2024-10-08",
          count: 11,
        },
        {
          date: "2024-10-09",
          count: 7,
        },
        {
          date: "2024-10-10",
          count: 7,
        },
        {
          date: "2024-10-11",
          count: 8,
        },
        {
          date: "2024-10-12",
          count: 13,
        },
        {
          date: "2024-10-13",
          count: 16,
        },
        {
          date: "2024-10-14",
          count: 8,
        },
        {
          date: "2024-10-15",
          count: 13,
        },
        {
          date: "2024-10-16",
          count: 3,
        },
        {
          date: "2024-10-17",
          count: 6,
        },
        {
          date: "2024-10-18",
          count: 7,
        },
        {
          date: "2024-10-19",
          count: 4,
        },
        {
          date: "2024-10-20",
          count: 8,
        },
        {
          date: "2024-10-21",
          count: 12,
        },
        {
          date: "2024-10-22",
          count: 9,
        },
        {
          date: "2024-10-23",
          count: 10,
        },
        {
          date: "2024-10-24",
          count: 10,
        },
        {
          date: "2024-10-25",
          count: 9,
        },
        {
          date: "2024-10-26",
          count: 7,
        },
        {
          date: "2024-10-27",
          count: 10,
        },
        {
          date: "2024-10-28",
          count: 8,
        },
        {
          date: "2024-10-29",
          count: 9,
        },
        {
          date: "2024-10-30",
          count: 9,
        },
        {
          date: "2024-10-31",
          count: 6,
        },
        {
          date: "2024-11-01",
          count: 5,
        },
        {
          date: "2024-11-02",
          count: 5,
        },
        {
          date: "2024-11-03",
          count: 13,
        },
        {
          date: "2024-11-04",
          count: 6,
        },
        {
          date: "2024-11-05",
          count: 9,
        },
        {
          date: "2024-11-06",
          count: 8,
        },
        {
          date: "2024-11-07",
          count: 4,
        },
        {
          date: "2024-11-08",
          count: 7,
        },
        {
          date: "2024-11-09",
          count: 6,
        },
        {
          date: "2024-11-10",
          count: 13,
        },
        {
          date: "2024-11-11",
          count: 10,
        },
        {
          date: "2024-11-12",
          count: 12,
        },
      ],
    },
    messages: {
      data: [
        {
          date: "2024-07-16",
          voices: 1,
          messages: 4,
        },
        {
          date: "2024-07-17",
          voices: 2,
          messages: 12,
        },
        {
          date: "2024-07-18",
          voices: 4,
          messages: 7,
        },
        {
          date: "2024-07-19",
          voices: 3,
          messages: 9,
        },
        {
          date: "2024-07-20",
          voices: 0,
          messages: 11,
        },
        {
          date: "2024-07-21",
          voices: 2,
          messages: 7,
        },
        {
          date: "2024-07-22",
          voices: 4,
          messages: 6,
        },
        {
          date: "2024-07-23",
          voices: 3,
          messages: 11,
        },
        {
          date: "2024-07-24",
          voices: 3,
          messages: 10,
        },
        {
          date: "2024-07-25",
          voices: 3,
          messages: 8,
        },
        {
          date: "2024-07-26",
          voices: 2,
          messages: 6,
        },
        {
          date: "2024-07-27",
          voices: 4,
          messages: 3,
        },
        {
          date: "2024-07-28",
          voices: 4,
          messages: 7,
        },
        {
          date: "2024-07-29",
          voices: 2,
          messages: 6,
        },
        {
          date: "2024-07-30",
          voices: 4,
          messages: 9,
        },
        {
          date: "2024-07-31",
          voices: 3,
          messages: 7,
        },
        {
          date: "2024-08-01",
          voices: 2,
          messages: 4,
        },
        {
          date: "2024-08-02",
          voices: 1,
          messages: 5,
        },
        {
          date: "2024-08-03",
          voices: 3,
          messages: 9,
        },
        {
          date: "2024-08-04",
          voices: 1,
          messages: 2,
        },
        {
          date: "2024-08-05",
          voices: 3,
          messages: 4,
        },
        {
          date: "2024-08-06",
          voices: 2,
          messages: 8,
        },
        {
          date: "2024-08-07",
          voices: 3,
          messages: 11,
        },
        {
          date: "2024-08-08",
          voices: 5,
          messages: 9,
        },
        {
          date: "2024-08-09",
          voices: 2,
          messages: 7,
        },
        {
          date: "2024-08-10",
          voices: 2,
          messages: 9,
        },
        {
          date: "2024-08-11",
          voices: 6,
          messages: 9,
        },
        {
          date: "2024-08-12",
          voices: 5,
          messages: 12,
        },
        {
          date: "2024-08-13",
          voices: 0,
          messages: 2,
        },
        {
          date: "2024-08-14",
          voices: 1,
          messages: 9,
        },
        {
          date: "2024-08-15",
          voices: 1,
          messages: 10,
        },
        {
          date: "2024-08-16",
          voices: 2,
          messages: 9,
        },
        {
          date: "2024-08-17",
          voices: 1,
          messages: 8,
        },
        {
          date: "2024-08-18",
          voices: 2,
          messages: 11,
        },
        {
          date: "2024-08-19",
          voices: 4,
          messages: 6,
        },
        {
          date: "2024-08-20",
          voices: 3,
          messages: 8,
        },
        {
          date: "2024-08-21",
          voices: 2,
          messages: 5,
        },
        {
          date: "2024-08-22",
          voices: 3,
          messages: 5,
        },
        {
          date: "2024-08-23",
          voices: 3,
          messages: 5,
        },
        {
          date: "2024-08-24",
          voices: 1,
          messages: 6,
        },
        {
          date: "2024-08-25",
          voices: 0,
          messages: 3,
        },
        {
          date: "2024-08-26",
          voices: 4,
          messages: 8,
        },
        {
          date: "2024-08-27",
          voices: 1,
          messages: 7,
        },
        {
          date: "2024-08-28",
          voices: 6,
          messages: 6,
        },
        {
          date: "2024-08-29",
          voices: 2,
          messages: 6,
        },
        {
          date: "2024-08-30",
          voices: 6,
          messages: 7,
        },
        {
          date: "2024-08-31",
          voices: 2,
          messages: 8,
        },
        {
          date: "2024-09-01",
          voices: 3,
          messages: 9,
        },
        {
          date: "2024-09-02",
          voices: 3,
          messages: 6,
        },
        {
          date: "2024-09-03",
          voices: 4,
          messages: 5,
        },
        {
          date: "2024-09-04",
          voices: 1,
          messages: 11,
        },
        {
          date: "2024-09-05",
          voices: 0,
          messages: 8,
        },
        {
          date: "2024-09-06",
          voices: 3,
          messages: 5,
        },
        {
          date: "2024-09-07",
          voices: 6,
          messages: 7,
        },
        {
          date: "2024-09-08",
          voices: 4,
          messages: 5,
        },
        {
          date: "2024-09-09",
          voices: 3,
          messages: 9,
        },
        {
          date: "2024-09-10",
          voices: 5,
          messages: 6,
        },
        {
          date: "2024-09-11",
          voices: 2,
          messages: 7,
        },
        {
          date: "2024-09-12",
          voices: 1,
          messages: 6,
        },
        {
          date: "2024-09-13",
          voices: 2,
          messages: 6,
        },
        {
          date: "2024-09-14",
          voices: 2,
          messages: 9,
        },
        {
          date: "2024-09-15",
          voices: 3,
          messages: 12,
        },
        {
          date: "2024-09-16",
          voices: 0,
          messages: 8,
        },
        {
          date: "2024-09-17",
          voices: 2,
          messages: 5,
        },
        {
          date: "2024-09-18",
          voices: 1,
          messages: 3,
        },
        {
          date: "2024-09-19",
          voices: 2,
          messages: 6,
        },
        {
          date: "2024-09-20",
          voices: 2,
          messages: 6,
        },
        {
          date: "2024-09-21",
          voices: 4,
          messages: 13,
        },
        {
          date: "2024-09-22",
          voices: 3,
          messages: 10,
        },
        {
          date: "2024-09-23",
          voices: 0,
          messages: 3,
        },
        {
          date: "2024-09-24",
          voices: 3,
          messages: 9,
        },
        {
          date: "2024-09-25",
          voices: 1,
          messages: 1,
        },
        {
          date: "2024-09-26",
          voices: 5,
          messages: 3,
        },
        {
          date: "2024-09-27",
          voices: 3,
          messages: 5,
        },
        {
          date: "2024-09-28",
          voices: 1,
          messages: 9,
        },
        {
          date: "2024-09-29",
          voices: 4,
          messages: 9,
        },
        {
          date: "2024-09-30",
          voices: 1,
          messages: 10,
        },
        {
          date: "2024-10-01",
          voices: 4,
          messages: 8,
        },
        {
          date: "2024-10-02",
          voices: 4,
          messages: 8,
        },
        {
          date: "2024-10-03",
          voices: 4,
          messages: 6,
        },
        {
          date: "2024-10-04",
          voices: 1,
          messages: 5,
        },
        {
          date: "2024-10-05",
          voices: 2,
          messages: 10,
        },
        {
          date: "2024-10-06",
          voices: 1,
          messages: 13,
        },
        {
          date: "2024-10-07",
          voices: 4,
          messages: 10,
        },
        {
          date: "2024-10-08",
          voices: 1,
          messages: 5,
        },
        {
          date: "2024-10-09",
          voices: 5,
          messages: 11,
        },
        {
          date: "2024-10-10",
          voices: 3,
          messages: 5,
        },
        {
          date: "2024-10-11",
          voices: 3,
          messages: 9,
        },
        {
          date: "2024-10-12",
          voices: 3,
          messages: 5,
        },
        {
          date: "2024-10-13",
          voices: 1,
          messages: 3,
        },
        {
          date: "2024-10-14",
          voices: 2,
          messages: 13,
        },
        {
          date: "2024-10-15",
          voices: 3,
          messages: 11,
        },
        {
          date: "2024-10-16",
          voices: 1,
          messages: 0,
        },
        {
          date: "2024-10-17",
          voices: 4,
          messages: 8,
        },
        {
          date: "2024-10-18",
          voices: 2,
          messages: 7,
        },
        {
          date: "2024-10-19",
          voices: 5,
          messages: 8,
        },
        {
          date: "2024-10-20",
          voices: 2,
          messages: 6,
        },
        {
          date: "2024-10-21",
          voices: 2,
          messages: 8,
        },
        {
          date: "2024-10-22",
          voices: 3,
          messages: 7,
        },
        {
          date: "2024-10-23",
          voices: 5,
          messages: 7,
        },
        {
          date: "2024-10-24",
          voices: 4,
          messages: 10,
        },
        {
          date: "2024-10-25",
          voices: 7,
          messages: 14,
        },
        {
          date: "2024-10-26",
          voices: 2,
          messages: 11,
        },
        {
          date: "2024-10-27",
          voices: 3,
          messages: 12,
        },
        {
          date: "2024-10-28",
          voices: 2,
          messages: 8,
        },
        {
          date: "2024-10-29",
          voices: 2,
          messages: 7,
        },
        {
          date: "2024-10-30",
          voices: 1,
          messages: 4,
        },
        {
          date: "2024-10-31",
          voices: 6,
          messages: 7,
        },
        {
          date: "2024-11-01",
          voices: 5,
          messages: 3,
        },
        {
          date: "2024-11-02",
          voices: 2,
          messages: 9,
        },
        {
          date: "2024-11-03",
          voices: 6,
          messages: 7,
        },
        {
          date: "2024-11-04",
          voices: 4,
          messages: 10,
        },
        {
          date: "2024-11-05",
          voices: 2,
          messages: 4,
        },
        {
          date: "2024-11-06",
          voices: 4,
          messages: 7,
        },
        {
          date: "2024-11-07",
          voices: 1,
          messages: 8,
        },
        {
          date: "2024-11-08",
          voices: 4,
          messages: 5,
        },
        {
          date: "2024-11-09",
          voices: 1,
          messages: 9,
        },
        {
          date: "2024-11-10",
          voices: 1,
          messages: 3,
        },
        {
          date: "2024-11-11",
          voices: 2,
          messages: 5,
        },
        {
          date: "2024-11-12",
          voices: 4,
          messages: 6,
        },
        {
          date: "2024-11-13",
          voices: 0,
          messages: 1,
        },
      ],
    },
    keywords: {
      data: {
        rank: [
          {
            keyword: "program",
            count: 90,
            variation: 2,
            keywordIds:
              "674e9072ec54f17a87b9a25f;674e9153ec54f17a87ba9cde;674e8fb9ec54f17a87b8a321;674e8ef0ec54f17a87b7983d;674e910bec54f17a87ba5d9d;674e8fb4ec54f17a87b89ce0;674e90f5ec54f17a87ba47e8;674e90e0ec54f17a87ba3440;674e90dbec54f17a87ba2f5e;674e8e5fec54f17a87b6ddc3;674e91b8ec54f17a87baf959;674e8fa8ec54f17a87b88d66;674e91c2ec54f17a87bb0126;674e8f2bec54f17a87b7eb7b;674e8e67ec54f17a87b6e87d;674e8ff1ec54f17a87b8e862;674e8f8fec54f17a87b86c60;674e8ef3ec54f17a87b79ac9;674e90e8ec54f17a87ba3bd5;674e8f37ec54f17a87b7fbfd;674e915aec54f17a87baa43d;674e9053ec54f17a87b96934;674e8f5eec54f17a87b82d8d;674e8f5bec54f17a87b8299d;674e8ffdec54f17a87b8f79a;674e908bec54f17a87b9c916;674e8ff9ec54f17a87b8f19a;674e9149ec54f17a87ba9322;674e8ea1ec54f17a87b732b6;674e915eec54f17a87baa771;674e8e7dec54f17a87b70444;674e900bec54f17a87b9084c;674e8f38ec54f17a87b7fd1b;674e90baec54f17a87ba0bae;674e8fa5ec54f17a87b88a04;674e8fc9ec54f17a87b8b7a3;674e8eccec54f17a87b76894;674e905cec54f17a87b97b5a;674e9083ec54f17a87b9bd73;674e8efbec54f17a87b7a5a5;674e909bec54f17a87b9e0a8;674e8f49ec54f17a87b812bd;674e8f31ec54f17a87b7f3be;674e8f8dec54f17a87b86a04;674e91fbec54f17a87bb2e85;674e8fd0ec54f17a87b8c084;674e8f52ec54f17a87b81e29;674e8f79ec54f17a87b84faa;674e8f56ec54f17a87b823fa;674e909eec54f17a87b9e406;674e906bec54f17a87b995f3;674e902dec54f17a87b931ed;674e902fec54f17a87b93412;674e8e6aec54f17a87b6ecde;674e9024ec54f17a87b92705;674e919bec54f17a87badff8;674e90f2ec54f17a87ba459d;674e9193ec54f17a87bad9a5;674e916cec54f17a87bab30d;674e8e9aec54f17a87b72940;674e905fec54f17a87b981b5;674e8f34ec54f17a87b7f7b0;674e8ff0ec54f17a87b8e6d2;674e8e60ec54f17a87b6df9b;674e9009ec54f17a87b9052b;674e9078ec54f17a87b9acba;674e90c5ec54f17a87ba19a0",
          },
          {
            keyword: "microchip",
            count: 70,
            variation: 3,
            keywordIds:
              "674e8fe3ec54f17a87b8d71a;674e8f68ec54f17a87b83a8f;674e910cec54f17a87ba5e88;674e904bec54f17a87b95707;674e90c3ec54f17a87ba1788;674e8f21ec54f17a87b7d930;674e9074ec54f17a87b9a6cc;674e9172ec54f17a87bab841;674e90bbec54f17a87ba0dc5;674e91eaec54f17a87bb2172;674e8eacec54f17a87b74065;674e8e98ec54f17a87b726e5;674e8f06ec54f17a87b7b36e;674e91beec54f17a87bafe88;674e9070ec54f17a87b99e4b;674e9073ec54f17a87b9a471;674e8feeec54f17a87b8e46b;674e910dec54f17a87ba5f27;674e9180ec54f17a87bac97e;674e9152ec54f17a87ba9b82;674e8fadec54f17a87b8939f;674e908dec54f17a87b9cc1f;674e8fb3ec54f17a87b89b88;674e8e71ec54f17a87b6f693;674e9189ec54f17a87bad12b;674e8fa6ec54f17a87b88a49;674e9136ec54f17a87ba8286;674e911eec54f17a87ba6d8f;674e905dec54f17a87b97ce9;674e8f8aec54f17a87b8658a;674e8e8cec54f17a87b71854;674e8ed5ec54f17a87b7738b;674e911fec54f17a87ba6ed7;674e9147ec54f17a87ba915a;674e8f8eec54f17a87b86ae0;674e8fd0ec54f17a87b8c052;674e917aec54f17a87babfb0;674e903eec54f17a87b9470a;674e8ff7ec54f17a87b8ef66;674e90eeec54f17a87ba41d3;674e909dec54f17a87b9e390;674e8e66ec54f17a87b6e69e;674e8f2eec54f17a87b7f02c;674e903fec54f17a87b94854;674e9016ec54f17a87b9156e;674e8f19ec54f17a87b7cd65;674e91d5ec54f17a87bb104c;674e9124ec54f17a87ba7292;674e8fbdec54f17a87b8a797;674e8f65ec54f17a87b83600;674e90d7ec54f17a87ba2b99;674e8fe8ec54f17a87b8dccb;674e8fdeec54f17a87b8d0ec;674e8eceec54f17a87b76ab0;674e91dcec54f17a87bb159a;674e91e5ec54f17a87bb1db4",
          },
          {
            keyword: "application",
            count: 70,
            variation: 5,
            keywordIds:
              "674e9173ec54f17a87bab9a3;674e917bec54f17a87bac5ed;674e8f4bec54f17a87b81503;674e90c6ec54f17a87ba1ac4;674e9002ec54f17a87b8fe27;674e8f41ec54f17a87b807d5;674e8fecec54f17a87b8e2b5;674e8ef5ec54f17a87b79e8e;674e8ff4ec54f17a87b8ebda;674e8f01ec54f17a87b7acac;674e8f9dec54f17a87b88001;674e9098ec54f17a87b9dc47;674e90adec54f17a87b9f920;674e8f8fec54f17a87b86c2c;674e8eb9ec54f17a87b750e4;674e9032ec54f17a87b93896;674e8ebfec54f17a87b758a5;674e91a3ec54f17a87bae657;674e8f84ec54f17a87b85e11;674e8f87ec54f17a87b862a5;674e9019ec54f17a87b919e1;674e91a5ec54f17a87bae7c7;674e9077ec54f17a87b9aa77;674e8e73ec54f17a87b6f8c5;674e8ea5ec54f17a87b73724;674e8f12ec54f17a87b7c3ac;674e91e2ec54f17a87bb1ba5;674e905eec54f17a87b97eae;674e909cec54f17a87b9e0d3;674e8f49ec54f17a87b81383;674e8ea4ec54f17a87b7357e;674e8f6eec54f17a87b840f8;674e8efdec54f17a87b7a88f;674e8e86ec54f17a87b7109e;674e8ff6ec54f17a87b8eefb;674e910fec54f17a87ba6100;674e913bec54f17a87ba867d;674e9114ec54f17a87ba64b8;674e902dec54f17a87b9319b;674e8ecfec54f17a87b76d01;674e9006ec54f17a87b90276;674e9192ec54f17a87bad883;674e90f0ec54f17a87ba437d;674e9054ec54f17a87b96bce;674e8f54ec54f17a87b820a1;674e8e78ec54f17a87b6fedd;674e8f02ec54f17a87b7ae3f;674e8f99ec54f17a87b87a06;674e90aaec54f17a87b9f5cf;674e8f26ec54f17a87b7e44c;674e8f67ec54f17a87b8391f;674e90d0ec54f17a87ba24f9;674e913cec54f17a87ba87ff",
          },
          {
            keyword: "feed",
            count: 66,
            variation: -2,
            keywordIds:
              "674e903aec54f17a87b9416d;674e8e90ec54f17a87b71d19;674e9100ec54f17a87ba536b;674e90dfec54f17a87ba336d;674e9080ec54f17a87b9b856;674e8f93ec54f17a87b87265;674e9015ec54f17a87b914ae;674e9139ec54f17a87ba84fe;674e90adec54f17a87b9fa1c;674e91bfec54f17a87bafeaa;674e91aeec54f17a87baf01b;674e91c5ec54f17a87bb0381;674e9063ec54f17a87b987da;674e8fffec54f17a87b8f991;674e8e6eec54f17a87b6f1f2;674e8e69ec54f17a87b6eb7d;674e91baec54f17a87bafaba;674e9164ec54f17a87baacf1;674e90d5ec54f17a87ba2968;674e915cec54f17a87baa5c8;674e8e72ec54f17a87b6f726;674e8f76ec54f17a87b84bcb;674e8f29ec54f17a87b7e8b3;674e8fe1ec54f17a87b8d443;674e9137ec54f17a87ba8334;674e911eec54f17a87ba6df2;674e907dec54f17a87b9b4aa;674e9187ec54f17a87bacfca;674e8f89ec54f17a87b86421;674e90a8ec54f17a87b9f3c3;674e8f81ec54f17a87b85a5c;674e9176ec54f17a87babbe8;674e8f46ec54f17a87b80efd;674e8f6eec54f17a87b840c8;674e8ea0ec54f17a87b73111;674e917bec54f17a87bac018;674e912dec54f17a87ba7ad2;674e8f04ec54f17a87b7b12d;674e8e5dec54f17a87b6db8d;674e9040ec54f17a87b948fc;674e8fe5ec54f17a87b8d9b2;674e8ed3ec54f17a87b7717c;674e9024ec54f17a87b92653;674e9123ec54f17a87ba7234;674e8fdbec54f17a87b8cd81;674e8ee7ec54f17a87b78bc8;674e8f75ec54f17a87b84a71;674e8effec54f17a87b7aaf6;674e8fe7ec54f17a87b8db72;674e8f35ec54f17a87b7f947;674e8f67ec54f17a87b83833;674e8e70ec54f17a87b6f496;674e9107ec54f17a87ba594f",
          },
          {
            keyword: "bandwidth",
            count: 66,
            variation: -3,
            keywordIds:
              "674e9065ec54f17a87b98c3d;674e8f94ec54f17a87b87473;674e90dfec54f17a87ba33c5;674e8eb0ec54f17a87b745e9;674e91c6ec54f17a87bb0477;674e8ef4ec54f17a87b79d1b;674e9179ec54f17a87babea2;674e8fb2ec54f17a87b899f8;674e90a7ec54f17a87b9f132;674e8f30ec54f17a87b7f1e7;674e8f90ec54f17a87b86d75;674e8ff3ec54f17a87b8eab4;674e8f96ec54f17a87b87665;674e8ebfec54f17a87b75816;674e8f9fec54f17a87b882f4;674e91c1ec54f17a87bb0040;674e8f47ec54f17a87b810cd;674e8f2aec54f17a87b7e9c7;674e8fcfec54f17a87b8be92;674e8efcec54f17a87b7a6bb;674e90cdec54f17a87ba21f4;674e8f8dec54f17a87b8697f;674e9206ec54f17a87bb372b;674e8f32ec54f17a87b7f46e;674e8f8eec54f17a87b86b7d;674e8f70ec54f17a87b84305;674e8f7cec54f17a87b8533c;674e8ee4ec54f17a87b78790;674e8fefec54f17a87b8e5d9;674e8ea3ec54f17a87b73489;674e8f57ec54f17a87b824e5;674e914bec54f17a87ba9533;674e8ea9ec54f17a87b73d5e;674e8fa2ec54f17a87b885e4;674e8f16ec54f17a87b7c98e;674e9017ec54f17a87b91694;674e904aec54f17a87b955a9;674e9156ec54f17a87ba9f3e;674e8e81ec54f17a87b709ab;674e9175ec54f17a87baba8a;674e9194ec54f17a87bada30;674e8fbdec54f17a87b8a6ea;674e8f9aec54f17a87b87bed;674e90ddec54f17a87ba3140;674e8f14ec54f17a87b7c6ca;674e8efbec54f17a87b7a50b;674e901eec54f17a87b91fcb;674e9116ec54f17a87ba6723;674e8eadec54f17a87b7423e;674e8f1fec54f17a87b7d56f;674e90c4ec54f17a87ba1901",
          },
          {
            keyword: "driver",
            count: 65,
            variation: 0,
            keywordIds:
              "674e8ef1ec54f17a87b798dc;674e9020ec54f17a87b92174;674e90f6ec54f17a87ba4994;674e91a0ec54f17a87bae409;674e917fec54f17a87bac8d3;674e90a6ec54f17a87b9f09f;674e8f05ec54f17a87b7b2b5;674e8fd5ec54f17a87b8c6e1;674e9022ec54f17a87b92388;674e91c9ec54f17a87bb0770;674e918dec54f17a87bad4f6;674e8f5eec54f17a87b82dc4;674e90e1ec54f17a87ba3588;674e8f33ec54f17a87b7f69a;674e8f9fec54f17a87b88266;674e8e94ec54f17a87b72269;674e906aec54f17a87b99493;674e9076ec54f17a87b9a9d1;674e90f3ec54f17a87ba46d2;674e9019ec54f17a87b91927;674e91d9ec54f17a87bb13b3;674e90fdec54f17a87ba4fb0;674e9136ec54f17a87ba8239;674e8e8bec54f17a87b716e3;674e9133ec54f17a87ba7fd6;674e90ecec54f17a87ba4030;674e9148ec54f17a87ba9245;674e90b0ec54f17a87b9fe00;674e8e87ec54f17a87b7119a;674e8f53ec54f17a87b81fc2;674e9093ec54f17a87b9d4e4;674e910aec54f17a87ba5ce3;674e9200ec54f17a87bb32ce;674e9022ec54f17a87b9249e;674e91eeec54f17a87bb24b0;674e906dec54f17a87b998d3;674e916cec54f17a87bab329;674e916aec54f17a87bab185;674e91ecec54f17a87bb2347;674e8ee6ec54f17a87b78a39;674e9160ec54f17a87baa91d;674e91ceec54f17a87bb0b43;674e8f36ec54f17a87b7fa3a;674e905cec54f17a87b97af1;674e9079ec54f17a87b9aead;674e90d0ec54f17a87ba2494;674e90a5ec54f17a87b9ee81",
          },
          {
            keyword: "matrix",
            count: 62,
            variation: 1,
            keywordIds:
              "674e8fe2ec54f17a87b8d68f;674e8e91ec54f17a87b71e5e;674e8edcec54f17a87b77dc9;674e913dec54f17a87ba8883;674e9197ec54f17a87badccd;674e91c3ec54f17a87bb0261;674e9075ec54f17a87b9a77d;674e8f1cec54f17a87b7d12b;674e8f58ec54f17a87b825a5;674e8f9eec54f17a87b88118;674e9067ec54f17a87b98ec5;674e9084ec54f17a87b9bf75;674e9044ec54f17a87b94ea3;674e8e7aec54f17a87b70167;674e90ebec54f17a87ba3e9e;674e8e6fec54f17a87b6f371;674e90e0ec54f17a87ba3509;674e8fe8ec54f17a87b8dda3;674e909fec54f17a87b9e613;674e908cec54f17a87b9cb83;674e90d5ec54f17a87ba2a28;674e9170ec54f17a87bab6e1;674e8ffbec54f17a87b8f4bf;674e9199ec54f17a87bade64;674e8f13ec54f17a87b7c4f6;674e8ebeec54f17a87b7574d;674e8eefec54f17a87b796bf;674e90cdec54f17a87ba2122;674e9205ec54f17a87bb368c;674e8ec3ec54f17a87b75de3;674e909bec54f17a87b9df69;674e8ff6ec54f17a87b8ee61;674e8ec7ec54f17a87b762aa;674e8f85ec54f17a87b86029;674e9042ec54f17a87b94c4c;674e8fc6ec54f17a87b8b33a;674e8f3eec54f17a87b804e1;674e8e97ec54f17a87b725de;674e8f23ec54f17a87b7e0f9;674e8f66ec54f17a87b836fe;674e9055ec54f17a87b96ce8;674e906eec54f17a87b99bd5;674e902eec54f17a87b9337b;674e8fe7ec54f17a87b8dc15;674e8f24ec54f17a87b7e229;674e8ebaec54f17a87b75265;674e8ee3ec54f17a87b786b6;674e8e61ec54f17a87b6e135;674e9079ec54f17a87b9adcb",
          },
          {
            keyword: "array",
            count: 61,
            variation: 6,
            keywordIds:
              "674e8f68ec54f17a87b839e9;674e9154ec54f17a87ba9d48;674e8fb9ec54f17a87b8a38b;674e8f7fec54f17a87b85896;674e90f5ec54f17a87ba4857;674e902aec54f17a87b92d8e;674e8f0eec54f17a87b7bf43;674e8f00ec54f17a87b7ab83;674e9179ec54f17a87babe71;674e8f3fec54f17a87b805a5;674e905aec54f17a87b97731;674e8e85ec54f17a87b71005;674e9070ec54f17a87b99eca;674e91d2ec54f17a87bb0d79;674e8eb5ec54f17a87b74be2;674e9089ec54f17a87b9c6e7;674e8f1eec54f17a87b7d490;674e8f91ec54f17a87b86fab;674e9075ec54f17a87b9a884;674e915fec54f17a87baa83b;674e8fcdec54f17a87b8bc79;674e9198ec54f17a87badde6;674e8ecbec54f17a87b767f7;674e8f0cec54f17a87b7bc4b;674e8fb6ec54f17a87b8a03e;674e90cdec54f17a87ba213f;674e8ebbec54f17a87b7539d;674e8fa9ec54f17a87b88e27;674e8efeec54f17a87b7a8b6;674e909aec54f17a87b9de80;674e8f7bec54f17a87b85172;674e9110ec54f17a87ba615e;674e90efec54f17a87ba4276;674e912eec54f17a87ba7b91;674e8ed8ec54f17a87b777bf;674e91a1ec54f17a87bae50c;674e9087ec54f17a87b9c29d;674e9144ec54f17a87ba8e61;674e8f9bec54f17a87b87c93;674e906fec54f17a87b99d75;674e9034ec54f17a87b939eb;674e9051ec54f17a87b96633;674e8f18ec54f17a87b7cc7c;674e901aec54f17a87b91ae1;674e912cec54f17a87ba79b0",
          },
          {
            keyword: "protocol",
            count: 61,
            variation: 3,
            keywordIds:
              "674e90ffec54f17a87ba52cc;674e904fec54f17a87b95d0b;674e90c7ec54f17a87ba1b66;674e902aec54f17a87b92e07;674e90dcec54f17a87ba3062;674e8e6cec54f17a87b6f01d;674e9064ec54f17a87b98991;674e8eaaec54f17a87b73e5e;674e91ebec54f17a87bb2207;674e8fc0ec54f17a87b8ab49;674e917eec54f17a87bac81a;674e90a6ec54f17a87b9f05c;674e8e67ec54f17a87b6e93c;674e919dec54f17a87bae1aa;674e9177ec54f17a87babc79;674e918aec54f17a87bad229;674e9119ec54f17a87ba68fb;674e8f5fec54f17a87b82e0a;674e8e93ec54f17a87b7213b;674e908bec54f17a87b9c86f;674e9078ec54f17a87b9ac6a;674e8f9cec54f17a87b87f44;674e8eebec54f17a87b7910b;674e90ceec54f17a87ba22c0;674e91deec54f17a87bb17e0;674e8e82ec54f17a87b70be0;674e9008ec54f17a87b90445;674e8f31ec54f17a87b7f382;674e8fa9ec54f17a87b88f0f;674e8ff5ec54f17a87b8ed16;674e8ff7ec54f17a87b8f01d;674e8ea2ec54f17a87b733d7;674e8f27ec54f17a87b7e61a;674e8f62ec54f17a87b831fa;674e8f2fec54f17a87b7f15d;674e8e96ec54f17a87b7251c;674e8f4eec54f17a87b81910;674e8f97ec54f17a87b877f3;674e8f54ec54f17a87b8216f;674e8e79ec54f17a87b6ffb2;674e8efaec54f17a87b7a484;674e8f74ec54f17a87b84831;674e8eaeec54f17a87b7429d;674e912bec54f17a87ba7935;674e9138ec54f17a87ba83eb",
          },
          {
            keyword: "alarm",
            count: 60,
            variation: 1,
            keywordIds:
              "674e901cec54f17a87b91cb2;674e8e92ec54f17a87b71f6a;674e8fbaec54f17a87b8a450;674e9066ec54f17a87b98d74;674e9184ec54f17a87bacd5a;674e90feec54f17a87ba5127;674e912aec54f17a87ba78a1;674e8fc2ec54f17a87b8adb2;674e8eabec54f17a87b73ecc;674e9052ec54f17a87b96789;674e9016ec54f17a87b914f9;674e8eecec54f17a87b792af;674e91aeec54f17a87baefd2;674e907bec54f17a87b9b082;674e8ed9ec54f17a87b77946;674e91acec54f17a87baee0e;674e8f91ec54f17a87b87081;674e8ffeec54f17a87b8f803;674e914aec54f17a87ba939b;674e90cbec54f17a87ba1fcf;674e90faec54f17a87ba4dd1;674e90fdec54f17a87ba503c;674e918fec54f17a87bad670;674e8fb6ec54f17a87b89f31;674e8ec2ec54f17a87b75c44;674e8ed6ec54f17a87b77529;674e8e96ec54f17a87b72477;674e8f2dec54f17a87b7ee87;674e8f0aec54f17a87b7b8f0;674e90e6ec54f17a87ba3a04;674e9011ec54f17a87b90fb3;674e913bec54f17a87ba86d7;674e90d8ec54f17a87ba2c6f;674e9142ec54f17a87ba8cfe;674e9167ec54f17a87baaef9;674e8f4dec54f17a87b81794;674e8e80ec54f17a87b70914;674e906eec54f17a87b99ab4;674e8e5cec54f17a87b6da1e;674e916cec54f17a87bab386;674e9185ec54f17a87bacea5;674e8e9aec54f17a87b72a6c;674e8e77ec54f17a87b6fdbf;674e9047ec54f17a87b9526a;674e8ee0ec54f17a87b782dc;674e8ff0ec54f17a87b8e792;674e90a5ec54f17a87b9ef2c",
          },
          {
            keyword: "system",
            count: 59,
            variation: -4,
            keywordIds:
              "674e9071ec54f17a87b9a191;674e903dec54f17a87b94563;674e8fbeec54f17a87b8a98a;674e91b4ec54f17a87baf54d;674e8fb5ec54f17a87b89dee;674e8f78ec54f17a87b84d92;674e8e5fec54f17a87b6de90;674e91eaec54f17a87bb21a1;674e91f6ec54f17a87bb2aa1;674e9195ec54f17a87badb49;674e9204ec54f17a87bb35a0;674e91bfec54f17a87bafee3;674e8ff2ec54f17a87b8e9c2;674e9012ec54f17a87b9114f;674e8f48ec54f17a87b811f3;674e90f4ec54f17a87ba474d;674e8ffbec54f17a87b8f430;674e8e74ec54f17a87b6f92e;674e8f38ec54f17a87b7fdaf;674e8fa6ec54f17a87b88b5b;674e8f0dec54f17a87b7bcfe;674e8efbec54f17a87b7a60d;674e8f8cec54f17a87b868ba;674e9125ec54f17a87ba7362;674e8f6cec54f17a87b83f0f;674e9001ec54f17a87b8fc2e;674e8fcfec54f17a87b8bfc1;674e8ef7ec54f17a87b7a0ba;674e91d0ec54f17a87bb0c5e;674e90a1ec54f17a87b9e881;674e8f7dec54f17a87b8552c;674e9092ec54f17a87b9d2eb;674e8f3dec54f17a87b803f1;674e8faeec54f17a87b89483;674e9006ec54f17a87b9021a;674e9192ec54f17a87bad8d2;674e9029ec54f17a87b92c5a;674e90f1ec54f17a87ba4411;674e8e5cec54f17a87b6d952;674e90beec54f17a87ba10d4;674e8f44ec54f17a87b80bd5;674e91e8ec54f17a87bb2018;674e8fdeec54f17a87b8d1c6;674e8ee2ec54f17a87b785bf;674e8e61ec54f17a87b6e03e;674e9134ec54f17a87ba8088;674e905bec54f17a87b97a0d;674e9106ec54f17a87ba58bf",
          },
          {
            keyword: "monitor",
            count: 55,
            variation: -2,
            keywordIds:
              "674e903cec54f17a87b94429;674e8f0bec54f17a87b7b9f4;674e8e9eec54f17a87b72ec6;674e8f86ec54f17a87b86110;674e90feec54f17a87ba51c8;674e8eafec54f17a87b7449d;674e8fbfec54f17a87b8aac7;674e8eedec54f17a87b79380;674e9084ec54f17a87b9be36;674e9045ec54f17a87b94f53;674e8e75ec54f17a87b6fae8;674e8eb8ec54f17a87b74fc7;674e8ef9ec54f17a87b7a2e5;674e8e7bec54f17a87b701f3;674e9108ec54f17a87ba5a4c;674e8fddec54f17a87b8cfe8;674e8f42ec54f17a87b809d0;674e8f91ec54f17a87b86fe4;674e9164ec54f17a87baac94;674e915eec54f17a87baa789;674e91d6ec54f17a87bb1103;674e8eeeec54f17a87b79476;674e8e88ec54f17a87b712b4;674e8f6eec54f17a87b84167;674e8f7cec54f17a87b85402;674e8feeec54f17a87b8e53d;674e90a3ec54f17a87b9ecb8;674e90d8ec54f17a87ba2d22;674e902dec54f17a87b93159;674e8ed4ec54f17a87b77274;674e8fafec54f17a87b89700;674e8f44ec54f17a87b80c81;674e8ee1ec54f17a87b78486;674e9034ec54f17a87b93a6b;674e8f4fec54f17a87b81a76;674e8e7eec54f17a87b7065c;674e8ebaec54f17a87b751d2;674e90e9ec54f17a87ba3cf2;674e90aaec54f17a87b9f66b;674e8f26ec54f17a87b7e491;674e8eb2ec54f17a87b74971;674e90d1ec54f17a87ba2575",
          },
          {
            keyword: "reboot",
            count: 55,
            variation: -8,
            keywordIds:
              "674e9002ec54f17a87b8fd44;674e8eb0ec54f17a87b74619;674e907fec54f17a87b9b7a6;674e8eaaec54f17a87b73e8c;674e8f00ec54f17a87b7abd0;674e8f10ec54f17a87b7c143;674e8fb1ec54f17a87b89958;674e8f2aec54f17a87b7ea81;674e8ff1ec54f17a87b8e832;674e8e75ec54f17a87b6fb39;674e91f8ec54f17a87bb2c7c;674e9031ec54f17a87b93707;674e8ffeec54f17a87b8f894;674e9181ec54f17a87bacad7;674e8f33ec54f17a87b7f621;674e9109ec54f17a87ba5ad6;674e9164ec54f17a87baac4e;674e9078ec54f17a87b9abfb;674e8e7cec54f17a87b70328;674e91e1ec54f17a87bb1a62;674e8eefec54f17a87b79612;674e8f48ec54f17a87b8125f;674e8e86ec54f17a87b710bd;674e9095ec54f17a87b9d820;674e8ec7ec54f17a87b7630d;674e9122ec54f17a87ba7091;674e91d0ec54f17a87bb0c17;674e8e89ec54f17a87b7140d;674e8f27ec54f17a87b7e654;674e9200ec54f17a87bb3250;674e900eec54f17a87b90b8c;674e90aeec54f17a87b9fa8a;674e9123ec54f17a87ba7193;674e91eeec54f17a87bb2482;674e9193ec54f17a87bad9c5;674e8e5cec54f17a87b6d9b4;674e8f4cec54f17a87b8162d;674e916eec54f17a87bab53e;674e8e78ec54f17a87b6fea7;674e8fddec54f17a87b8d072;674e901dec54f17a87b91e88;674e8f25ec54f17a87b7e41a;674e8ebcec54f17a87b75575;674e90eeec54f17a87ba413c;674e90a4ec54f17a87b9ed99",
          },
          {
            keyword: "interface",
            count: 54,
            variation: 2,
            keywordIds:
              "674e9088ec54f17a87b9c431;674e8f4aec54f17a87b81455;674e8fb5ec54f17a87b89e67;674e8f87ec54f17a87b861f1;674e90f7ec54f17a87ba49e4;674e8fa3ec54f17a87b88785;674e8f92ec54f17a87b87124;674e9121ec54f17a87ba6fcf;674e8eb6ec54f17a87b74cfe;674e8f8fec54f17a87b86cb8;674e91faec54f17a87bb2da7;674e9032ec54f17a87b937b3;674e9000ec54f17a87b8fad5;674e9152ec54f17a87ba9bf7;674e8fc0ec54f17a87b8ac19;674e8f88ec54f17a87b86385;674e8ea1ec54f17a87b731df;674e9077ec54f17a87b9abc0;674e91a9ec54f17a87baebdb;674e8fa6ec54f17a87b88acb;674e8fcaec54f17a87b8b89d;674e8fceec54f17a87b8bd46;674e8ef0ec54f17a87b7976f;674e8e8dec54f17a87b7191a;674e8ed5ec54f17a87b77466;674e8f7bec54f17a87b85219;674e8fefec54f17a87b8e678;674e9122ec54f17a87ba712f;674e910aec54f17a87ba5cc2;674e906cec54f17a87b997a3;674e8e59ec54f17a87b6d689;674e8feaec54f17a87b8df76;674e8e8fec54f17a87b71b7c;674e8f17ec54f17a87b7cadc;674e9025ec54f17a87b92789;674e90b2ec54f17a87ba013a;674e90cbec54f17a87ba1f19;674e90ddec54f17a87ba3162;674e8edeec54f17a87b78027;674e8ee6ec54f17a87b78ad7;674e8f99ec54f17a87b879da;674e90aaec54f17a87b9f5f7;674e8f73ec54f17a87b847bb;674e8f1fec54f17a87b7d638",
          },
          {
            keyword: "card",
            count: 53,
            variation: 3,
            keywordIds:
              "674e9062ec54f17a87b98683;674e8f94ec54f17a87b87397;674e8eb0ec54f17a87b7469c;674e9129ec54f17a87ba77a4;674e8febec54f17a87b8e1b0;674e8e6cec54f17a87b6ef5e;674e8eaeec54f17a87b7439e;674e8fa7ec54f17a87b88c9f;674e9059ec54f17a87b97679;674e8f37ec54f17a87b7fca5;674e918aec54f17a87bad2b4;674e918eec54f17a87bad570;674e91a8ec54f17a87baeb09;674e91c8ec54f17a87bb05f0;674e8f09ec54f17a87b7b6e0;674e915bec54f17a87baa546;674e8f3aec54f17a87b7fff1;674e91f3ec54f17a87bb28da;674e91a7ec54f17a87baea1a;674e9026ec54f17a87b928f8;674e8eccec54f17a87b76924;674e8f89ec54f17a87b864d0;674e909cec54f17a87b9e22c;674e91e3ec54f17a87bb1c0f;674e8fd7ec54f17a87b8c8e1;674e9096ec54f17a87b9d8e5;674e8ec7ec54f17a87b7636f;674e913aec54f17a87ba8654;674e909dec54f17a87b9e361;674e9091ec54f17a87b9d20e;674e9023ec54f17a87b92576;674e9143ec54f17a87ba8df2;674e91b2ec54f17a87baf39b;674e90b3ec54f17a87ba01a3;674e8fdaec54f17a87b8cc42;674e8e76ec54f17a87b6fce1;674e8f82ec54f17a87b85c0d;674e8f4fec54f17a87b81b78;674e9060ec54f17a87b983ac;674e8eb7ec54f17a87b74f16;674e91fcec54f17a87bb2f73;674e90d1ec54f17a87ba2652;674e91dbec54f17a87bb14fe;674e8eadec54f17a87b741f1;674e9105ec54f17a87ba5847",
          },
          {
            keyword: "1080p",
            count: 53,
            variation: 1,
            keywordIds:
              "674e90c3ec54f17a87ba1745;674e907fec54f17a87b9b7f6;674e8eaeec54f17a87b74306;674e9139ec54f17a87ba84a2;674e919eec54f17a87bae1fc;674e8e85ec54f17a87b70fc0;674e91afec54f17a87baf069;674e8ff2ec54f17a87b8ea44;674e908fec54f17a87b9cf29;674e9182ec54f17a87bacb21;674e8f9fec54f17a87b882c7;674e8e94ec54f17a87b721b0;674e9165ec54f17a87baad11;674e914aec54f17a87ba93bc;674e8f77ec54f17a87b84c46;674e91d9ec54f17a87bb134b;674e8ea4ec54f17a87b73648;674e905cec54f17a87b97bc6;674e8e82ec54f17a87b70bb1;674e8f55ec54f17a87b822e0;674e8ec3ec54f17a87b75daf;674e8f7bec54f17a87b852e7;674e8ef7ec54f17a87b7a049;674e9093ec54f17a87b9d563;674e8f85ec54f17a87b85f91;674e90d8ec54f17a87ba2ceb;674e8f7dec54f17a87b855bf;674e8e8eec54f17a87b71b0a;674e8f17ec54f17a87b7c9e0;674e8f19ec54f17a87b7cde4;674e907fec54f17a87b9b6fc;674e9028ec54f17a87b92b46;674e90b3ec54f17a87ba01ec;674e9185ec54f17a87bace77;674e8f54ec54f17a87b8210f;674e8f82ec54f17a87b85b92;674e8f8aec54f17a87b8664e;674e8f02ec54f17a87b7ae18;674e8ff0ec54f17a87b8e726;674e90abec54f17a87b9f799;674e8e70ec54f17a87b6f51f;674e91b5ec54f17a87baf681",
          },
          {
            keyword: "pixel",
            count: 51,
            variation: 2,
            keywordIds:
              "674e903cec54f17a87b944ca;674e8e83ec54f17a87b70dac;674e8fa4ec54f17a87b888db;674e90c3ec54f17a87ba1727;674e8f21ec54f17a87b7d84f;674e9069ec54f17a87b991a3;674e91cbec54f17a87bb08a5;674e8fb1ec54f17a87b898b0;674e8f3bec54f17a87b80156;674e91f6ec54f17a87bb2b14;674e8e67ec54f17a87b6e825;674e903aec54f17a87b94264;674e91abec54f17a87baeda5;674e908cec54f17a87b9cae4;674e9170ec54f17a87bab66e;674e8e7cec54f17a87b70370;674e8e74ec54f17a87b6f9cd;674e9057ec54f17a87b9715d;674e8e81ec54f17a87b70ac8;674e8ec2ec54f17a87b75d40;674e917dec54f17a87bac7c9;674e904eec54f17a87b95bce;674e8ea3ec54f17a87b7340e;674e8f85ec54f17a87b85f5a;674e8f5aec54f17a87b82868;674e8fc5ec54f17a87b8b1eb;674e9166ec54f17a87baae5c;674e8e6bec54f17a87b6ee72;674e9049ec54f17a87b95476;674e9155ec54f17a87ba9e9b;674e8f4bec54f17a87b815eb;674e8f75ec54f17a87b849b4;674e902eec54f17a87b933a8;674e8efaec54f17a87b7a40b;674e901dec54f17a87b91ed5;674e8ecdec54f17a87b769f4;674e8eb2ec54f17a87b7486b;674e8f03ec54f17a87b7afa9",
          },
          {
            keyword: "firewall",
            count: 50,
            variation: 0,
            keywordIds:
              "674e9173ec54f17a87bab8d1;674e90b5ec54f17a87ba04ce;674e91b4ec54f17a87baf5ec;674e90b7ec54f17a87ba0703;674e907cec54f17a87b9b338;674e904dec54f17a87b959d7;674e8f0eec54f17a87b7be9b;674e9202ec54f17a87bb33dc;674e917eec54f17a87bac84e;674e8f06ec54f17a87b7b2e8;674e8ef4ec54f17a87b79c13;674e916dec54f17a87bab42b;674e914eec54f17a87ba988d;674e8f72ec54f17a87b84686;674e9012ec54f17a87b91073;674e8fcbec54f17a87b8b9eb;674e902bec54f17a87b92ed0;674e90e2ec54f17a87ba36bd;674e9146ec54f17a87ba90b5;674e9025ec54f17a87b9281a;674e91deec54f17a87bb177f;674e8ec1ec54f17a87b75aef;674e8f47ec54f17a87b80fb8;674e8f6cec54f17a87b83e5d;674e912eec54f17a87ba7c26;674e917dec54f17a87bac732;674e909aec54f17a87b9de15;674e910bec54f17a87ba5d22;674e8e89ec54f17a87b7152f;674e8f59ec54f17a87b82781;674e90c1ec54f17a87ba157a;674e8f17ec54f17a87b7ca13;674e91efec54f17a87bb2509;674e8e62ec54f17a87b6e2b6;674e90beec54f17a87ba11c9;674e91ffec54f17a87bb320d;674e8ec5ec54f17a87b760a6;674e8f25ec54f17a87b7e316;674e90eaec54f17a87ba3d89;674e900aec54f17a87b90706",
          },
          {
            keyword: "circuit",
            count: 50,
            variation: 3,
            keywordIds:
              "674e90b6ec54f17a87ba0559;674e8e9fec54f17a87b72f70;674e907cec54f17a87b9b27a;674e8f1bec54f17a87b7d09f;674e8f59ec54f17a87b8267f;674e919fec54f17a87bae373;674e8fd3ec54f17a87b8c4bf;674e9099ec54f17a87b9dd4b;674e8f2aec54f17a87b7eabc;674e91c8ec54f17a87bb06a3;674e903bec54f17a87b9430b;674e8f60ec54f17a87b8301a;674e8fc4ec54f17a87b8b016;674e8ffeec54f17a87b8f8ec;674e8fd8ec54f17a87b8caa8;674e8facec54f17a87b892e8;674e8fc8ec54f17a87b8b629;674e8ea5ec54f17a87b736d7;674e90baec54f17a87ba0b7b;674e91deec54f17a87bb1813;674e8fd7ec54f17a87b8c97c;674e9018ec54f17a87b917ad;674e8f7aec54f17a87b84fd4;674e9095ec54f17a87b9d7b0;674e9111ec54f17a87ba6206;674e8ec4ec54f17a87b75f73;674e9159ec54f17a87baa374;674e91adec54f17a87baeebc;674e9017ec54f17a87b915d6;674e91b2ec54f17a87baf3cb;674e90d4ec54f17a87ba28bd;674e906dec54f17a87b99973;674e8fafec54f17a87b89623;674e91f2ec54f17a87bb27f5;674e8f43ec54f17a87b80b62;674e8ec6ec54f17a87b761c0;674e913fec54f17a87ba8a55;674e8f35ec54f17a87b7f85b;674e8edaec54f17a87b77a1c;674e905bec54f17a87b97926;674e90a4ec54f17a87b9edd3",
          },
          {
            keyword: "port",
            count: 50,
            variation: 0,
            keywordIds:
              "674e9088ec54f17a87b9c503;674e8ee9ec54f17a87b78f3b;674e8edbec54f17a87b77cc0;674e913dec54f17a87ba88cf;674e8f1cec54f17a87b7d1ed;674e8f3cec54f17a87b80266;674e8f10ec54f17a87b7c1aa;674e8ef3ec54f17a87b79b60;674e8f37ec54f17a87b7fbcb;674e90f9ec54f17a87ba4c89;674e9053ec54f17a87b96a23;674e91d8ec54f17a87bb12e0;674e8f5bec54f17a87b829d7;674e8f42ec54f17a87b80982;674e90f3ec54f17a87ba4667;674e915bec54f17a87baa512;674e8fccec54f17a87b8bb9f;674e91f3ec54f17a87bb28c0;674e9058ec54f17a87b972ce;674e9117ec54f17a87ba67c1;674e9132ec54f17a87ba7f6f;674e8e5bec54f17a87b6d890;674e8e95ec54f17a87b723ca;674e8f2eec54f17a87b7ef33;674e8e89ec54f17a87b7149c;674e9112ec54f17a87ba62f1;674e8e5eec54f17a87b6dc83;674e8f7dec54f17a87b855fa;674e900fec54f17a87b90cd2;674e90aeec54f17a87b9facc;674e8f22ec54f17a87b7daf6;674e90f0ec54f17a87ba4313;674e90b3ec54f17a87ba0271;674e90caec54f17a87ba1e3d;674e91ceec54f17a87bb0a9a;674e8f74ec54f17a87b848d4;674e8eb1ec54f17a87b747cf;674e8f20ec54f17a87b7d6ea",
          },
          {
            keyword: "panel",
            count: 49,
            variation: 1,
            keywordIds:
              "674e8fe3ec54f17a87b8d7d6;674e8f0bec54f17a87b7babc;674e8fbeec54f17a87b8a855;674e90b6ec54f17a87ba06d4;674e91d4ec54f17a87bb0f59;674e8f78ec54f17a87b84dea;674e9031ec54f17a87b93682;674e8f3fec54f17a87b80631;674e9102ec54f17a87ba55e0;674e9164ec54f17a87baac0a;674e8fe9ec54f17a87b8de48;674e9109ec54f17a87ba5bb2;674e8e9bec54f17a87b72b8b;674e900bec54f17a87b9086e;674e8ea5ec54f17a87b7375a;674e91aaec54f17a87baece2;674e8eecec54f17a87b791df;674e8eccec54f17a87b76863;674e9082ec54f17a87b9bc41;674e8eefec54f17a87b796e8;674e8e8bec54f17a87b71787;674e9007ec54f17a87b90382;674e8e5bec54f17a87b6d816;674e8e95ec54f17a87b722f6;674e8efeec54f17a87b7a912;674e9093ec54f17a87b9d598;674e9041ec54f17a87b94aee;674e90d9ec54f17a87ba2d8f;674e8e8fec54f17a87b71c3c;674e8f6aec54f17a87b83c19;674e8f16ec54f17a87b7c887;674e8fdaec54f17a87b8ccf0;674e8ee7ec54f17a87b78b44;674e8f82ec54f17a87b85b06;674e8e7eec54f17a87b70558;674e8f26ec54f17a87b7e545;674e90edec54f17a87ba4099",
          },
          {
            keyword: "transmitter",
            count: 49,
            variation: 3,
            keywordIds:
              "674e901cec54f17a87b91d92;674e90b5ec54f17a87ba0419;674e8eeaec54f17a87b78fb4;674e8f7fec54f17a87b857a4;674e8edbec54f17a87b77c08;674e912aec54f17a87ba782a;674e9074ec54f17a87b9a706;674e90a1ec54f17a87b9e976;674e90bbec54f17a87ba0e01;674e9179ec54f17a87babf09;674e8fb2ec54f17a87b899cd;674e919eec54f17a87bae25f;674e8e85ec54f17a87b70f05;674e8e75ec54f17a87b6fb91;674e914dec54f17a87ba96fd;674e9119ec54f17a87ba699d;674e9107ec54f17a87ba59c5;674e8fdcec54f17a87b8cedd;674e9033ec54f17a87b93949;674e9182ec54f17a87bacbca;674e8f33ec54f17a87b7f5f3;674e8e6eec54f17a87b6f25e;674e91c0ec54f17a87baffbe;674e906bec54f17a87b9955a;674e8f3bec54f17a87b80096;674e91d9ec54f17a87bb1384;674e91e4ec54f17a87bb1c9e;674e915dec54f17a87baa6ab;674e8ee5ec54f17a87b788dd;674e9056ec54f17a87b96fb5;674e8f1bec54f17a87b7cfd3;674e8ec4ec54f17a87b75ea2;674e8f05ec54f17a87b7b1c2;674e8f28ec54f17a87b7e79e;674e8ea9ec54f17a87b73c88;674e8fa1ec54f17a87b88579;674e8f4dec54f17a87b81878;674e8f15ec54f17a87b7c7a3;674e8fc7ec54f17a87b8b53c;674e91f8ec54f17a87bb2be2;674e90acec54f17a87b9f7f8;674e9039ec54f17a87b93fe7;674e8f18ec54f17a87b7cbfd;674e901bec54f17a87b91bce;674e9079ec54f17a87b9ad6b;674e9138ec54f17a87ba843a",
          },
          {
            keyword: "back-end",
            count: 49,
            variation: 2,
            keywordIds:
              "674e903cec54f17a87b94486;674e8fbaec54f17a87b8a3fe;674e9066ec54f17a87b98cf3;674e904fec54f17a87b96284;674e8f70ec54f17a87b84415;674e8eb0ec54f17a87b7456c;674e912aec54f17a87ba7812;674e8fb8ec54f17a87b8a279;674e8f00ec54f17a87b7ac1b;674e90a6ec54f17a87b9efd1;674e8ef9ec54f17a87b7a29a;674e9102ec54f17a87ba55a7;674e8fe8ec54f17a87b8ddf0;674e8fd9ec54f17a87b8caee;674e8e6dec54f17a87b6f16b;674e8ffdec54f17a87b8f6d4;674e8e63ec54f17a87b6e3f7;674e8fcdec54f17a87b8bc07;674e8f29ec54f17a87b7e94b;674e8eebec54f17a87b79176;674e9157ec54f17a87baa12a;674e9205ec54f17a87bb36d1;674e8efdec54f17a87b7a82b;674e908eec54f17a87b9cd89;674e8f57ec54f17a87b8243c;674e8f27ec54f17a87b7e67f;674e9043ec54f17a87b94ce5;674e8ecfec54f17a87b76ccb;674e9191ec54f17a87bad847;674e90d4ec54f17a87ba2873;674e90beec54f17a87ba1139;674e9054ec54f17a87b96b2c;674e8e78ec54f17a87b6ff3d;674e9190ec54f17a87bad769;674e9038ec54f17a87b93f85;674e8eadec54f17a87b7414b;674e90d0ec54f17a87ba251c",
          },
          {
            keyword: "drive",
            count: 48,
            variation: -3,
            keywordIds:
              "674e9061ec54f17a87b98600;674e8ec9ec54f17a87b76550;674e9183ec54f17a87baccda;674e9069ec54f17a87b992dc;674e8f78ec54f17a87b84e5c;674e91cbec54f17a87bb0846;674e9067ec54f17a87b98f9b;674e8e99ec54f17a87b7283b;674e9178ec54f17a87babd6b;674e91f9ec54f17a87bb2cd6;674e907aec54f17a87b9afbe;674e918cec54f17a87bad3fa;674e8f95ec54f17a87b875c4;674e9102ec54f17a87ba556e;674e910eec54f17a87ba6002;674e8f5cec54f17a87b82ab5;674e8fc1ec54f17a87b8ad24;674e91d7ec54f17a87bb11f5;674e91daec54f17a87bb1422;674e91e2ec54f17a87bb1a9d;674e8fceec54f17a87b8bdee;674e8f0cec54f17a87b7bbcc;674e90d3ec54f17a87ba27d7;674e91ccec54f17a87bb0953;674e8f52ec54f17a87b81f2a;674e8f7aec54f17a87b850d3;674e912dec54f17a87ba7b2f;674e8f28ec54f17a87b7e6de;674e9027ec54f17a87b92acb;674e8ed7ec54f17a87b776f2;674e8fa1ec54f17a87b88532;674e8ffaec54f17a87b8f2de;674e8ecfec54f17a87b76c3a;674e9006ec54f17a87b902ea;674e91b3ec54f17a87baf45c;674e8f22ec54f17a87b7da42;674e8fc7ec54f17a87b8b44b;674e911bec54f17a87ba6b02;674e9009ec54f17a87b90649;674e8f67ec54f17a87b83898;674e8e71ec54f17a87b6f59c",
          },
          {
            keyword: "hard",
            count: 48,
            variation: -3,
            keywordIds:
              "674e9061ec54f17a87b985ae;674e8ec9ec54f17a87b7652d;674e9183ec54f17a87bacc9a;674e9069ec54f17a87b99293;674e8f78ec54f17a87b84e3a;674e91caec54f17a87bb0812;674e9067ec54f17a87b98f59;674e8e99ec54f17a87b727eb;674e9178ec54f17a87babd47;674e91f9ec54f17a87bb2cad;674e907aec54f17a87b9af93;674e918cec54f17a87bad3de;674e8f95ec54f17a87b87590;674e9102ec54f17a87ba553d;674e910eec54f17a87ba5fd2;674e8f5cec54f17a87b82a6a;674e8fc1ec54f17a87b8acd5;674e91d7ec54f17a87bb11c9;674e91daec54f17a87bb13f4;674e91e1ec54f17a87bb1a79;674e8fceec54f17a87b8bdc0;674e8f0cec54f17a87b7bb7b;674e90d3ec54f17a87ba27a2;674e91ccec54f17a87bb093c;674e8f52ec54f17a87b81ef9;674e8f7aec54f17a87b85066;674e912dec54f17a87ba7b13;674e8f28ec54f17a87b7e6ab;674e9027ec54f17a87b92a88;674e8ed7ec54f17a87b776b1;674e8fa1ec54f17a87b88509;674e8ff9ec54f17a87b8f2ae;674e8ecfec54f17a87b76bf6;674e9006ec54f17a87b902bb;674e91b3ec54f17a87baf42a;674e8f22ec54f17a87b7da0e;674e8fc6ec54f17a87b8b41c;674e911bec54f17a87ba6ad2;674e9009ec54f17a87b905ff;674e8f67ec54f17a87b83865;674e8e71ec54f17a87b6f56d",
          },
        ],
        cloud: [
          {
            value: "program",
            count: 90,
          },
          {
            value: "microchip",
            count: 70,
          },
          {
            value: "application",
            count: 70,
          },
          {
            value: "feed",
            count: 66,
          },
          {
            value: "bandwidth",
            count: 66,
          },
          {
            value: "driver",
            count: 65,
          },
          {
            value: "matrix",
            count: 62,
          },
          {
            value: "array",
            count: 61,
          },
          {
            value: "protocol",
            count: 61,
          },
          {
            value: "alarm",
            count: 60,
          },
          {
            value: "system",
            count: 59,
          },
          {
            value: "monitor",
            count: 55,
          },
          {
            value: "reboot",
            count: 55,
          },
          {
            value: "interface",
            count: 54,
          },
          {
            value: "card",
            count: 53,
          },
          {
            value: "1080p",
            count: 53,
          },
          {
            value: "pixel",
            count: 51,
          },
          {
            value: "firewall",
            count: 50,
          },
          {
            value: "circuit",
            count: 50,
          },
          {
            value: "port",
            count: 50,
          },
          {
            value: "panel",
            count: 49,
          },
          {
            value: "transmitter",
            count: 49,
          },
          {
            value: "back-end",
            count: 49,
          },
          {
            value: "drive",
            count: 48,
          },
          {
            value: "hard",
            count: 48,
          },
        ],
      },
    },
    participants: {
      data: [
        {
          date: "2024-06-26",
          newParticipants: 18,
          participants: 1096,
        },
        {
          date: "2024-06-27",
          newParticipants: 30,
          participants: 1126,
        },
        {
          date: "2024-06-28",
          newParticipants: 48,
          participants: 1174,
        },
        {
          date: "2024-06-29",
          newParticipants: 36,
          participants: 1210,
        },
        {
          date: "2024-06-30",
          newParticipants: 23,
          participants: 1233,
        },
        {
          date: "2024-07-01",
          newParticipants: 27,
          participants: 1260,
        },
        {
          date: "2024-07-02",
          newParticipants: 19,
          participants: 1279,
        },
        {
          date: "2024-07-03",
          newParticipants: 19,
          participants: 1298,
        },
        {
          date: "2024-07-04",
          newParticipants: 23,
          participants: 1321,
        },
        {
          date: "2024-07-05",
          newParticipants: 44,
          participants: 1365,
        },
        {
          date: "2024-07-06",
          newParticipants: 19,
          participants: 1384,
        },
        {
          date: "2024-07-07",
          newParticipants: 11,
          participants: 1395,
        },
        {
          date: "2024-07-08",
          newParticipants: 23,
          participants: 1418,
        },
        {
          date: "2024-07-09",
          newParticipants: 30,
          participants: 1448,
        },
        {
          date: "2024-07-10",
          newParticipants: 47,
          participants: 1495,
        },
        {
          date: "2024-07-11",
          newParticipants: 38,
          participants: 1533,
        },
        {
          date: "2024-07-12",
          newParticipants: 43,
          participants: 1576,
        },
        {
          date: "2024-07-13",
          newParticipants: 35,
          participants: 1611,
        },
        {
          date: "2024-07-14",
          newParticipants: 24,
          participants: 1635,
        },
        {
          date: "2024-07-15",
          newParticipants: 16,
          participants: 1651,
        },
        {
          date: "2024-07-16",
          newParticipants: 47,
          participants: 1698,
        },
        {
          date: "2024-07-17",
          newParticipants: 41,
          participants: 1739,
        },
        {
          date: "2024-07-18",
          newParticipants: 44,
          participants: 1783,
        },
        {
          date: "2024-07-19",
          newParticipants: 11,
          participants: 1794,
        },
        {
          date: "2024-07-20",
          newParticipants: 26,
          participants: 1820,
        },
        {
          date: "2024-07-21",
          newParticipants: 16,
          participants: 1836,
        },
        {
          date: "2024-07-22",
          newParticipants: 36,
          participants: 1872,
        },
        {
          date: "2024-07-23",
          newParticipants: 48,
          participants: 1920,
        },
        {
          date: "2024-07-24",
          newParticipants: 32,
          participants: 1952,
        },
        {
          date: "2024-07-25",
          newParticipants: 44,
          participants: 1996,
        },
        {
          date: "2024-07-26",
          newParticipants: 19,
          participants: 2015,
        },
        {
          date: "2024-07-27",
          newParticipants: 36,
          participants: 2051,
        },
        {
          date: "2024-07-28",
          newParticipants: 26,
          participants: 2077,
        },
        {
          date: "2024-07-29",
          newParticipants: 22,
          participants: 2099,
        },
        {
          date: "2024-07-30",
          newParticipants: 44,
          participants: 2143,
        },
        {
          date: "2024-07-31",
          newParticipants: 36,
          participants: 2179,
        },
        {
          date: "2024-08-01",
          newParticipants: 42,
          participants: 2221,
        },
        {
          date: "2024-08-02",
          newParticipants: 15,
          participants: 2236,
        },
        {
          date: "2024-08-03",
          newParticipants: 24,
          participants: 2260,
        },
        {
          date: "2024-08-04",
          newParticipants: 13,
          participants: 2273,
        },
        {
          date: "2024-08-05",
          newParticipants: 31,
          participants: 2304,
        },
        {
          date: "2024-08-06",
          newParticipants: 39,
          participants: 2343,
        },
        {
          date: "2024-08-07",
          newParticipants: 37,
          participants: 2380,
        },
        {
          date: "2024-08-08",
          newParticipants: 40,
          participants: 2420,
        },
        {
          date: "2024-08-09",
          newParticipants: 36,
          participants: 2456,
        },
        {
          date: "2024-08-10",
          newParticipants: 15,
          participants: 2471,
        },
        {
          date: "2024-08-11",
          newParticipants: 35,
          participants: 2506,
        },
        {
          date: "2024-08-12",
          newParticipants: 38,
          participants: 2544,
        },
        {
          date: "2024-08-13",
          newParticipants: 12,
          participants: 2556,
        },
        {
          date: "2024-08-14",
          newParticipants: 20,
          participants: 2576,
        },
        {
          date: "2024-08-15",
          newParticipants: 11,
          participants: 2587,
        },
        {
          date: "2024-08-16",
          newParticipants: 23,
          participants: 2610,
        },
        {
          date: "2024-08-17",
          newParticipants: 34,
          participants: 2644,
        },
        {
          date: "2024-08-18",
          newParticipants: 30,
          participants: 2674,
        },
        {
          date: "2024-08-19",
          newParticipants: 41,
          participants: 2715,
        },
        {
          date: "2024-08-20",
          newParticipants: 25,
          participants: 2740,
        },
        {
          date: "2024-08-21",
          newParticipants: 25,
          participants: 2765,
        },
        {
          date: "2024-08-22",
          newParticipants: 45,
          participants: 2810,
        },
        {
          date: "2024-08-23",
          newParticipants: 23,
          participants: 2833,
        },
        {
          date: "2024-08-24",
          newParticipants: 50,
          participants: 2883,
        },
        {
          date: "2024-08-25",
          newParticipants: 27,
          participants: 2910,
        },
        {
          date: "2024-08-26",
          newParticipants: 32,
          participants: 2942,
        },
        {
          date: "2024-08-27",
          newParticipants: 26,
          participants: 2968,
        },
        {
          date: "2024-08-28",
          newParticipants: 12,
          participants: 2980,
        },
        {
          date: "2024-08-29",
          newParticipants: 11,
          participants: 2991,
        },
        {
          date: "2024-08-30",
          newParticipants: 45,
          participants: 3036,
        },
        {
          date: "2024-08-31",
          newParticipants: 19,
          participants: 3055,
        },
        {
          date: "2024-09-01",
          newParticipants: 38,
          participants: 3093,
        },
        {
          date: "2024-09-02",
          newParticipants: 44,
          participants: 3137,
        },
        {
          date: "2024-09-03",
          newParticipants: 21,
          participants: 3158,
        },
        {
          date: "2024-09-04",
          newParticipants: 12,
          participants: 3170,
        },
        {
          date: "2024-09-05",
          newParticipants: 29,
          participants: 3199,
        },
        {
          date: "2024-09-06",
          newParticipants: 13,
          participants: 3212,
        },
        {
          date: "2024-09-07",
          newParticipants: 23,
          participants: 3235,
        },
        {
          date: "2024-09-08",
          newParticipants: 42,
          participants: 3277,
        },
        {
          date: "2024-09-09",
          newParticipants: 11,
          participants: 3288,
        },
        {
          date: "2024-09-10",
          newParticipants: 28,
          participants: 3316,
        },
        {
          date: "2024-09-11",
          newParticipants: 44,
          participants: 3360,
        },
        {
          date: "2024-09-12",
          newParticipants: 45,
          participants: 3405,
        },
        {
          date: "2024-09-13",
          newParticipants: 18,
          participants: 3423,
        },
        {
          date: "2024-09-14",
          newParticipants: 18,
          participants: 3441,
        },
        {
          date: "2024-09-15",
          newParticipants: 14,
          participants: 3455,
        },
        {
          date: "2024-09-16",
          newParticipants: 48,
          participants: 3503,
        },
        {
          date: "2024-09-17",
          newParticipants: 48,
          participants: 3551,
        },
        {
          date: "2024-09-18",
          newParticipants: 22,
          participants: 3573,
        },
        {
          date: "2024-09-19",
          newParticipants: 14,
          participants: 3587,
        },
        {
          date: "2024-09-20",
          newParticipants: 35,
          participants: 3622,
        },
        {
          date: "2024-09-21",
          newParticipants: 29,
          participants: 3651,
        },
        {
          date: "2024-09-22",
          newParticipants: 47,
          participants: 3698,
        },
        {
          date: "2024-09-23",
          newParticipants: 42,
          participants: 3740,
        },
        {
          date: "2024-09-24",
          newParticipants: 34,
          participants: 3774,
        },
        {
          date: "2024-09-25",
          newParticipants: 14,
          participants: 3788,
        },
        {
          date: "2024-09-26",
          newParticipants: 19,
          participants: 3807,
        },
        {
          date: "2024-09-27",
          newParticipants: 34,
          participants: 3841,
        },
        {
          date: "2024-09-28",
          newParticipants: 40,
          participants: 3881,
        },
        {
          date: "2024-09-29",
          newParticipants: 23,
          participants: 3904,
        },
        {
          date: "2024-09-30",
          newParticipants: 12,
          participants: 3916,
        },
        {
          date: "2024-10-01",
          newParticipants: 38,
          participants: 3954,
        },
        {
          date: "2024-10-02",
          newParticipants: 45,
          participants: 3999,
        },
        {
          date: "2024-10-03",
          newParticipants: 41,
          participants: 4040,
        },
        {
          date: "2024-10-04",
          newParticipants: 14,
          participants: 4054,
        },
        {
          date: "2024-10-05",
          newParticipants: 17,
          participants: 4071,
        },
        {
          date: "2024-10-06",
          newParticipants: 28,
          participants: 4099,
        },
        {
          date: "2024-10-07",
          newParticipants: 46,
          participants: 4145,
        },
        {
          date: "2024-10-08",
          newParticipants: 41,
          participants: 4186,
        },
        {
          date: "2024-10-09",
          newParticipants: 41,
          participants: 4227,
        },
        {
          date: "2024-10-10",
          newParticipants: 19,
          participants: 4246,
        },
        {
          date: "2024-10-11",
          newParticipants: 27,
          participants: 4273,
        },
        {
          date: "2024-10-12",
          newParticipants: 10,
          participants: 4283,
        },
        {
          date: "2024-10-13",
          newParticipants: 31,
          participants: 4314,
        },
        {
          date: "2024-10-14",
          newParticipants: 22,
          participants: 4336,
        },
        {
          date: "2024-10-15",
          newParticipants: 22,
          participants: 4358,
        },
        {
          date: "2024-10-16",
          newParticipants: 17,
          participants: 4375,
        },
        {
          date: "2024-10-17",
          newParticipants: 28,
          participants: 4403,
        },
        {
          date: "2024-10-18",
          newParticipants: 24,
          participants: 4427,
        },
        {
          date: "2024-10-19",
          newParticipants: 30,
          participants: 4457,
        },
        {
          date: "2024-10-20",
          newParticipants: 28,
          participants: 4485,
        },
        {
          date: "2024-10-21",
          newParticipants: 37,
          participants: 4522,
        },
        {
          date: "2024-10-22",
          newParticipants: 45,
          participants: 4567,
        },
        {
          date: "2024-10-23",
          newParticipants: 31,
          participants: 4598,
        },
        {
          date: "2024-10-24",
          newParticipants: 41,
          participants: 4639,
        },
        {
          date: "2024-10-25",
          newParticipants: 25,
          participants: 4664,
        },
        {
          date: "2024-10-26",
          newParticipants: 11,
          participants: 4675,
        },
        {
          date: "2024-10-27",
          newParticipants: 27,
          participants: 4702,
        },
        {
          date: "2024-10-28",
          newParticipants: 20,
          participants: 4722,
        },
        {
          date: "2024-10-29",
          newParticipants: 12,
          participants: 4734,
        },
        {
          date: "2024-10-30",
          newParticipants: 44,
          participants: 4778,
        },
        {
          date: "2024-10-31",
          newParticipants: 26,
          participants: 4804,
        },
        {
          date: "2024-11-01",
          newParticipants: 11,
          participants: 4815,
        },
        {
          date: "2024-11-02",
          newParticipants: 26,
          participants: 4841,
        },
        {
          date: "2024-11-03",
          newParticipants: 18,
          participants: 4859,
        },
        {
          date: "2024-11-04",
          newParticipants: 46,
          participants: 4905,
        },
        {
          date: "2024-11-05",
          newParticipants: 17,
          participants: 4922,
        },
        {
          date: "2024-11-06",
          newParticipants: 48,
          participants: 4970,
        },
        {
          date: "2024-11-07",
          newParticipants: 31,
          participants: 5001,
        },
        {
          date: "2024-11-08",
          newParticipants: 25,
          participants: 5026,
        },
        {
          date: "2024-11-09",
          newParticipants: 33,
          participants: 5059,
        },
        {
          date: "2024-11-10",
          newParticipants: 11,
          participants: 5070,
        },
        {
          date: "2024-11-11",
          newParticipants: 45,
          participants: 5115,
        },
        {
          date: "2024-11-12",
          newParticipants: 17,
          participants: 5132,
        },
        {
          date: "2024-11-13",
          newParticipants: 50,
          participants: 5182,
        },
        {
          date: "2024-11-14",
          newParticipants: 29,
          participants: 5211,
        },
        {
          date: "2024-11-15",
          newParticipants: 24,
          participants: 5235,
        },
        {
          date: "2024-11-16",
          newParticipants: 18,
          participants: 5253,
        },
        {
          date: "2024-11-17",
          newParticipants: 17,
          participants: 5270,
        },
        {
          date: "2024-11-18",
          newParticipants: 42,
          participants: 5312,
        },
        {
          date: "2024-11-19",
          newParticipants: 15,
          participants: 5327,
        },
        {
          date: "2024-11-20",
          newParticipants: 36,
          participants: 5363,
        },
        {
          date: "2024-11-21",
          newParticipants: 35,
          participants: 5398,
        },
        {
          date: "2024-11-22",
          newParticipants: 35,
          participants: 5433,
        },
      ],
    },

    mentions: {
      data: {
        name: "program",
        times: 90,
        mentions: [
          {
            content:
              "Try to synthesize the HDD bus, maybe it will program the auxiliary feed!",
            date: 1726876800000,
          },
          {
            content:
              "You can't hack the program without indexing the online TCP bus!",
            date: 1727654400000,
          },
          {
            content:
              "You can't program the capacitor without transmitting the redundant ASCII port!",
            date: 1730764800000,
          },
          {
            content:
              "I'll transmit the neural SSL panel, that should sensor the GB program!",
            date: 1730764800000,
          },
          {
            content:
              "Use the haptic AI circuit, then you can program the online card!",
            date: 1730678400000,
          },
          {
            content:
              "Use the optical UDP microchip, then you can program the neural application!",
            date: 1723161600000,
          },
          {
            content:
              "If we reboot the bandwidth, we can get to the DNS program through the mobile ADP firewall!",
            date: 1724630400000,
          },
          {
            content:
              "I'll compress the optical GB circuit, that should program the HTTP program!",
            date: 1724630400000,
          },
          {
            content:
              "I'll compress the neural SMTP transmitter, that should program the API pixel!",
            date: 1723334400000,
          },
          {
            content:
              "bypassing the program won't do anything, we need to bypass the online UDP feed!",
            date: 1732147200000,
          },
          {
            content:
              "Try to parse the EXE card, maybe it will program the solid state system!",
            date: 1732838400000,
          },
          {
            content:
              "You can't synthesize the bandwidth without bypassing the auxiliary UTF8 program!",
            date: 1728345600000,
          },
          {
            content:
              "connecting the hard drive won't do anything, we need to hack the 1080p XML program!",
            date: 1728345600000,
          },
          {
            content: "We need to program the optical JSON interface!",
            date: 1731024000000,
          },
          {
            content:
              "If we quantify the interface, we can get to the SQL program through the cross-platform JBOD system!",
            date: 1728259200000,
          },
          {
            content:
              "Use the 1080p SSL program, then you can synthesize the haptic circuit!",
            date: 1726790400000,
          },
          {
            content:
              "If we hack the hard drive, we can get to the TLS pixel through the redundant PNG program!",
            date: 1727913600000,
          },
          {
            content:
              "The HEX hard drive is down, synthesize the mobile system so we can reboot the TCP program!",
            date: 1727136000000,
          },
          {
            content: "We need to program the auxiliary USB program!",
            date: 1727136000000,
          },
          {
            content: "We need to program the multi-byte TCP port!",
            date: 1722816000000,
          },
          {
            content:
              "The XSS panel is down, index the back-end feed so we can program the THX pixel!",
            date: 1728432000000,
          },
          {
            content: "We need to program the online TLS feed!",
            date: 1728432000000,
          },
          {
            content:
              "If we parse the application, we can get to the SQL card through the neural UTF8 program!",
            date: 1728432000000,
          },
          {
            content:
              "If we program the circuit, we can get to the SSD interface through the open-source TLS application!",
            date: 1727827200000,
          },
          {
            content:
              "I'll compress the neural UTF8 bandwidth, that should program the SCSI card!",
            date: 1730246400000,
          },
          {
            content:
              "If we program the program, we can get to the XML card through the bluetooth SSD transmitter!",
            date: 1730246400000,
          },
          {
            content:
              "If we index the pixel, we can get to the THX alarm through the haptic COM program!",
            date: 1724198400000,
          },
          {
            content:
              "I'll program the neural PNG sensor, that should hard drive the JSON port!",
            date: 1724198400000,
          },
          {
            content:
              "I'll program the haptic SAS card, that should sensor the SQL hard drive!",
            date: 1729641600000,
          },
          {
            content:
              "The SDD system is down, navigate the cross-platform program so we can connect the AI program!",
            date: 1729641600000,
          },
          {
            content:
              "If we copy the program, we can get to the ADP driver through the mobile SDD circuit!",
            date: 1729641600000,
          },
          {
            content:
              "Try to back up the JSON program, maybe it will quantify the neural transmitter!",
            date: 1730073600000,
          },
          {
            content:
              "If we parse the program, we can get to the DRAM hard drive through the auxiliary SMTP microchip!",
            date: 1730073600000,
          },
          {
            content:
              "You can't copy the array without generating the 1080p SSL program!",
            date: 1730073600000,
          },
          {
            content:
              "transmitting the firewall won't do anything, we need to program the solid state SMS pixel!",
            date: 1727308800000,
          },
          {
            content:
              "You can't calculate the program without synthesizing the haptic DRAM circuit!",
            date: 1723507200000,
          },
          {
            content: "We need to program the wireless PNG application!",
            date: 1732665600000,
          },
          {
            content:
              "You can't synthesize the array without quantifying the solid state DRAM program!",
            date: 1732665600000,
          },
          {
            content: "We need to program the online RAM interface!",
            date: 1723852800000,
          },
          {
            content:
              "I'll compress the back-end COM program, that should bandwidth the COM sensor!",
            date: 1732579200000,
          },
          {
            content:
              "The THX circuit is down, synthesize the digital program so we can bypass the USB card!",
            date: 1732579200000,
          },
          {
            content:
              "calculating the microchip won't do anything, we need to generate the online SDD program!",
            date: 1732579200000,
          },
          {
            content:
              "I'll connect the back-end JSON program, that should bus the SSD program!",
            date: 1732579200000,
          },
          {
            content:
              "I'll transmit the 1080p SSL panel, that should program the XML feed!",
            date: 1732579200000,
          },
          {
            content:
              "If we quantify the protocol, we can get to the JBOD program through the cross-platform USB system!",
            date: 1732579200000,
          },
          {
            content:
              "You can't program the card without quantifying the redundant XML firewall!",
            date: 1725235200000,
          },
          {
            content:
              "The AGP bus is down, quantify the solid state bandwidth so we can index the SMS program!",
            date: 1729900800000,
          },
          {
            content:
              "Use the back-end UDP monitor, then you can program the neural circuit!",
            date: 1729900800000,
          },
          {
            content:
              "The TLS sensor is down, index the cross-platform sensor so we can program the JBOD bus!",
            date: 1730937600000,
          },
          {
            content:
              "If we program the application, we can get to the SDD matrix through the bluetooth PNG firewall!",
            date: 1730937600000,
          },
          {
            content:
              "If we quantify the program, we can get to the TLS card through the 1080p UTF8 card!",
            date: 1733011200000,
          },
          {
            content:
              "The JBOD port is down, calculate the haptic card so we can program the SAS microchip!",
            date: 1731283200000,
          },
          {
            content:
              "If we hack the array, we can get to the RAM alarm through the auxiliary DNS program!",
            date: 1723248000000,
          },
          {
            content:
              "Try to program the PNG driver, maybe it will reboot the back-end microchip!",
            date: 1723248000000,
          },
          {
            content:
              "connecting the program won't do anything, we need to calculate the cross-platform HTTP transmitter!",
            date: 1723593600000,
          },
          {
            content:
              "calculating the sensor won't do anything, we need to program the multi-byte THX sensor!",
            date: 1732233600000,
          },
          {
            content: "We need to program the 1080p SCSI pixel!",
            date: 1732233600000,
          },
          {
            content:
              "Try to bypass the UTF8 interface, maybe it will program the multi-byte card!",
            date: 1726358400000,
          },
          {
            content:
              "You can't program the panel without backing up the 1080p JBOD transmitter!",
            date: 1726531200000,
          },
          {
            content:
              "You can't program the transmitter without quantifying the optical ASCII array!",
            date: 1725926400000,
          },
          {
            content: "We need to program the 1080p JSON system!",
            date: 1723075200000,
          },
          {
            content:
              "navigating the program won't do anything, we need to connect the multi-byte ASCII array!",
            date: 1723075200000,
          },
          {
            content:
              "If we generate the program, we can get to the SMS bus through the redundant HDD capacitor!",
            date: 1723075200000,
          },
          {
            content:
              "If we copy the card, we can get to the HEX program through the multi-byte RSS matrix!",
            date: 1727395200000,
          },
          {
            content:
              "Try to program the CLI driver, maybe it will reboot the solid state sensor!",
            date: 1728777600000,
          },
          {
            content:
              "The OCR alarm is down, connect the neural microchip so we can override the THX program!",
            date: 1726012800000,
          },
          {
            content:
              "Try to parse the JSON circuit, maybe it will copy the primary program!",
            date: 1728172800000,
          },
          {
            content:
              "You can't program the bus without hacking the redundant FTP bandwidth!",
            date: 1728172800000,
          },
          {
            content:
              "The DRAM microchip is down, parse the cross-platform sensor so we can reboot the CSS program!",
            date: 1725062400000,
          },
          {
            content:
              "I'll program the open-source HTTP bandwidth, that should panel the GB hard drive!",
            date: 1726185600000,
          },
          {
            content:
              "Try to parse the SAS program, maybe it will back up the primary circuit!",
            date: 1732492800000,
          },
          {
            content:
              "The SSD port is down, copy the solid state pixel so we can compress the UTF8 program!",
            date: 1729123200000,
          },
          {
            content:
              "If we program the capacitor, we can get to the RAM firewall through the wireless EXE matrix!",
            date: 1732752000000,
          },
          {
            content:
              "Use the 1080p OCR circuit, then you can program the optical alarm!",
            date: 1729382400000,
          },
          {
            content:
              "The THX capacitor is down, program the virtual circuit so we can input the COM application!",
            date: 1731628800000,
          },
          {
            content:
              "You can't program the array without programming the redundant THX transmitter!",
            date: 1725580800000,
          },
          {
            content: "We need to bypass the open-source IP program!",
            date: 1731888000000,
          },
          {
            content:
              "If we program the protocol, we can get to the DNS transmitter through the back-end FTP system!",
            date: 1724284800000,
          },
          {
            content:
              "You can't program the system without programming the solid state SMTP transmitter!",
            date: 1730592000000,
          },
          {
            content:
              "You can't quantify the program without hacking the mobile SQL bus!",
            date: 1725840000000,
          },
          {
            content:
              "If we bypass the program, we can get to the HDD port through the auxiliary TLS protocol!",
            date: 1731456000000,
          },
          {
            content:
              "I'll quantify the open-source API program, that should driver the THX system!",
            date: 1731110400000,
          },
          {
            content: "We need to program the 1080p CSS microchip!",
            date: 1731110400000,
          },
          {
            content:
              "You can't compress the program without indexing the solid state COM microchip!",
            date: 1730160000000,
          },
          {
            content:
              "backing up the transmitter won't do anything, we need to parse the neural JSON program!",
            date: 1726444800000,
          },
          {
            content:
              "The AI capacitor is down, program the redundant bus so we can bypass the SDD pixel!",
            date: 1731369600000,
          },
          {
            content:
              "You can't program the matrix without copying the optical SSD card!",
            date: 1732406400000,
          },
          {
            content:
              "bypassing the bandwidth won't do anything, we need to program the primary DNS alarm!",
            date: 1729036800000,
          },
          {
            content:
              "The SMTP system is down, back up the bluetooth bandwidth so we can program the USB port!",
            date: 1725494400000,
          },
          {
            content: "We need to transmit the cross-platform SQL program!",
            date: 1722902400000,
          },
        ],
      },
    },
  },
};
